var _get = require("/Users/cex/Desktop/burnsignal/burnsignal-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _assertThisInitialized = require("/Users/cex/Desktop/burnsignal/burnsignal-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _regeneratorRuntime = require("/Users/cex/Desktop/burnsignal/burnsignal-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Users/cex/Desktop/burnsignal/burnsignal-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/Users/cex/Desktop/burnsignal/burnsignal-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/cex/Desktop/burnsignal/burnsignal-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/cex/Desktop/burnsignal/burnsignal-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/cex/Desktop/burnsignal/burnsignal-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/cex/Desktop/burnsignal/burnsignal-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

!function (t, e) {
  "object" == typeof exports && "object" == typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define("WalletConnectProvider", [], e) : "object" == typeof exports ? exports.WalletConnectProvider = e() : t.WalletConnectProvider = e();
}(this, function () {
  return function (t) {
    var e = {};

    function r(n) {
      if (e[n]) return e[n].exports;
      var i = e[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return t[n].call(i.exports, i, i.exports, r), i.l = !0, i.exports;
    }

    return r.m = t, r.c = e, r.d = function (t, e, n) {
      r.o(t, e) || Object.defineProperty(t, e, {
        enumerable: !0,
        get: n
      });
    }, r.r = function (t) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    }, r.t = function (t, e) {
      if (1 & e && (t = r(t)), 8 & e) return t;
      if (4 & e && "object" == typeof t && t && t.__esModule) return t;
      var n = Object.create(null);
      if (r.r(n), Object.defineProperty(n, "default", {
        enumerable: !0,
        value: t
      }), 2 & e && "string" != typeof t) for (var i in t) {
        r.d(n, i, function (e) {
          return t[e];
        }.bind(null, i));
      }
      return n;
    }, r.n = function (t) {
      var e = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };
      return r.d(e, "a", e), e;
    }, r.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, r.p = "", r(r.s = 244);
  }([function (t, e) {
    "function" == typeof Object.create ? t.exports = function (t, e) {
      t.super_ = e, t.prototype = Object.create(e.prototype, {
        constructor: {
          value: t,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      });
    } : t.exports = function (t, e) {
      t.super_ = e;

      var r = function r() {};

      r.prototype = e.prototype, t.prototype = new r(), t.prototype.constructor = t;
    };
  }, function (t, e, r) {
    var n = r(2),
        i = n.Buffer;

    function o(t, e) {
      for (var r in t) {
        e[r] = t[r];
      }
    }

    function s(t, e, r) {
      return i(t, e, r);
    }

    i.from && i.alloc && i.allocUnsafe && i.allocUnsafeSlow ? t.exports = n : (o(n, e), e.Buffer = s), o(i, s), s.from = function (t, e, r) {
      if ("number" == typeof t) throw new TypeError("Argument must not be a number");
      return i(t, e, r);
    }, s.alloc = function (t, e, r) {
      if ("number" != typeof t) throw new TypeError("Argument must be a number");
      var n = i(t);
      return void 0 !== e ? "string" == typeof r ? n.fill(e, r) : n.fill(e) : n.fill(0), n;
    }, s.allocUnsafe = function (t) {
      if ("number" != typeof t) throw new TypeError("Argument must be a number");
      return i(t);
    }, s.allocUnsafeSlow = function (t) {
      if ("number" != typeof t) throw new TypeError("Argument must be a number");
      return n.SlowBuffer(t);
    };
  }, function (t, e, r) {
    "use strict";

    (function (t) {
      /*!
       * The buffer module from node.js, for the browser.
       *
       * @author   Feross Aboukhadijeh <http://feross.org>
       * @license  MIT
       */
      var n = r(104),
          i = r(105),
          o = r(54);

      function s() {
        return u.TYPED_ARRAY_SUPPORT ? 2147483647 : 1073741823;
      }

      function a(t, e) {
        if (s() < e) throw new RangeError("Invalid typed array length");
        return u.TYPED_ARRAY_SUPPORT ? (t = new Uint8Array(e)).__proto__ = u.prototype : (null === t && (t = new u(e)), t.length = e), t;
      }

      function u(t, e, r) {
        if (!(u.TYPED_ARRAY_SUPPORT || this instanceof u)) return new u(t, e, r);

        if ("number" == typeof t) {
          if ("string" == typeof e) throw new Error("If encoding is specified then the first argument must be a string");
          return h(this, t);
        }

        return f(this, t, e, r);
      }

      function f(t, e, r, n) {
        if ("number" == typeof e) throw new TypeError('"value" argument must not be a number');
        return "undefined" != typeof ArrayBuffer && e instanceof ArrayBuffer ? function (t, e, r, n) {
          if (e.byteLength, r < 0 || e.byteLength < r) throw new RangeError("'offset' is out of bounds");
          if (e.byteLength < r + (n || 0)) throw new RangeError("'length' is out of bounds");
          e = void 0 === r && void 0 === n ? new Uint8Array(e) : void 0 === n ? new Uint8Array(e, r) : new Uint8Array(e, r, n);
          u.TYPED_ARRAY_SUPPORT ? (t = e).__proto__ = u.prototype : t = l(t, e);
          return t;
        }(t, e, r, n) : "string" == typeof e ? function (t, e, r) {
          "string" == typeof r && "" !== r || (r = "utf8");
          if (!u.isEncoding(r)) throw new TypeError('"encoding" must be a valid string encoding');
          var n = 0 | p(e, r),
              i = (t = a(t, n)).write(e, r);
          i !== n && (t = t.slice(0, i));
          return t;
        }(t, e, r) : function (t, e) {
          if (u.isBuffer(e)) {
            var r = 0 | d(e.length);
            return 0 === (t = a(t, r)).length ? t : (e.copy(t, 0, 0, r), t);
          }

          if (e) {
            if ("undefined" != typeof ArrayBuffer && e.buffer instanceof ArrayBuffer || "length" in e) return "number" != typeof e.length || (n = e.length) != n ? a(t, 0) : l(t, e);
            if ("Buffer" === e.type && o(e.data)) return l(t, e.data);
          }

          var n;
          throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
        }(t, e);
      }

      function c(t) {
        if ("number" != typeof t) throw new TypeError('"size" argument must be a number');
        if (t < 0) throw new RangeError('"size" argument must not be negative');
      }

      function h(t, e) {
        if (c(e), t = a(t, e < 0 ? 0 : 0 | d(e)), !u.TYPED_ARRAY_SUPPORT) for (var r = 0; r < e; ++r) {
          t[r] = 0;
        }
        return t;
      }

      function l(t, e) {
        var r = e.length < 0 ? 0 : 0 | d(e.length);
        t = a(t, r);

        for (var n = 0; n < r; n += 1) {
          t[n] = 255 & e[n];
        }

        return t;
      }

      function d(t) {
        if (t >= s()) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + s().toString(16) + " bytes");
        return 0 | t;
      }

      function p(t, e) {
        if (u.isBuffer(t)) return t.length;
        if ("undefined" != typeof ArrayBuffer && "function" == typeof ArrayBuffer.isView && (ArrayBuffer.isView(t) || t instanceof ArrayBuffer)) return t.byteLength;
        "string" != typeof t && (t = "" + t);
        var r = t.length;
        if (0 === r) return 0;

        for (var n = !1;;) {
          switch (e) {
            case "ascii":
            case "latin1":
            case "binary":
              return r;

            case "utf8":
            case "utf-8":
            case void 0:
              return F(t).length;

            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              return 2 * r;

            case "hex":
              return r >>> 1;

            case "base64":
              return z(t).length;

            default:
              if (n) return F(t).length;
              e = ("" + e).toLowerCase(), n = !0;
          }
        }
      }

      function g(t, e, r) {
        var n = !1;
        if ((void 0 === e || e < 0) && (e = 0), e > this.length) return "";
        if ((void 0 === r || r > this.length) && (r = this.length), r <= 0) return "";
        if ((r >>>= 0) <= (e >>>= 0)) return "";

        for (t || (t = "utf8");;) {
          switch (t) {
            case "hex":
              return k(this, e, r);

            case "utf8":
            case "utf-8":
              return x(this, e, r);

            case "ascii":
              return R(this, e, r);

            case "latin1":
            case "binary":
              return T(this, e, r);

            case "base64":
              return A(this, e, r);

            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              return I(this, e, r);

            default:
              if (n) throw new TypeError("Unknown encoding: " + t);
              t = (t + "").toLowerCase(), n = !0;
          }
        }
      }

      function m(t, e, r) {
        var n = t[e];
        t[e] = t[r], t[r] = n;
      }

      function b(t, e, r, n, i) {
        if (0 === t.length) return -1;

        if ("string" == typeof r ? (n = r, r = 0) : r > 2147483647 ? r = 2147483647 : r < -2147483648 && (r = -2147483648), r = +r, isNaN(r) && (r = i ? 0 : t.length - 1), r < 0 && (r = t.length + r), r >= t.length) {
          if (i) return -1;
          r = t.length - 1;
        } else if (r < 0) {
          if (!i) return -1;
          r = 0;
        }

        if ("string" == typeof e && (e = u.from(e, n)), u.isBuffer(e)) return 0 === e.length ? -1 : v(t, e, r, n, i);
        if ("number" == typeof e) return e &= 255, u.TYPED_ARRAY_SUPPORT && "function" == typeof Uint8Array.prototype.indexOf ? i ? Uint8Array.prototype.indexOf.call(t, e, r) : Uint8Array.prototype.lastIndexOf.call(t, e, r) : v(t, [e], r, n, i);
        throw new TypeError("val must be string, number or Buffer");
      }

      function v(t, e, r, n, i) {
        var o,
            s = 1,
            a = t.length,
            u = e.length;

        if (void 0 !== n && ("ucs2" === (n = String(n).toLowerCase()) || "ucs-2" === n || "utf16le" === n || "utf-16le" === n)) {
          if (t.length < 2 || e.length < 2) return -1;
          s = 2, a /= 2, u /= 2, r /= 2;
        }

        function f(t, e) {
          return 1 === s ? t[e] : t.readUInt16BE(e * s);
        }

        if (i) {
          var c = -1;

          for (o = r; o < a; o++) {
            if (f(t, o) === f(e, -1 === c ? 0 : o - c)) {
              if (-1 === c && (c = o), o - c + 1 === u) return c * s;
            } else -1 !== c && (o -= o - c), c = -1;
          }
        } else for (r + u > a && (r = a - u), o = r; o >= 0; o--) {
          for (var h = !0, l = 0; l < u; l++) {
            if (f(t, o + l) !== f(e, l)) {
              h = !1;
              break;
            }
          }

          if (h) return o;
        }

        return -1;
      }

      function y(t, e, r, n) {
        r = Number(r) || 0;
        var i = t.length - r;
        n ? (n = Number(n)) > i && (n = i) : n = i;
        var o = e.length;
        if (o % 2 != 0) throw new TypeError("Invalid hex string");
        n > o / 2 && (n = o / 2);

        for (var s = 0; s < n; ++s) {
          var a = parseInt(e.substr(2 * s, 2), 16);
          if (isNaN(a)) return s;
          t[r + s] = a;
        }

        return s;
      }

      function _(t, e, r, n) {
        return q(F(e, t.length - r), t, r, n);
      }

      function w(t, e, r, n) {
        return q(function (t) {
          for (var e = [], r = 0; r < t.length; ++r) {
            e.push(255 & t.charCodeAt(r));
          }

          return e;
        }(e), t, r, n);
      }

      function E(t, e, r, n) {
        return w(t, e, r, n);
      }

      function M(t, e, r, n) {
        return q(z(e), t, r, n);
      }

      function S(t, e, r, n) {
        return q(function (t, e) {
          for (var r, n, i, o = [], s = 0; s < t.length && !((e -= 2) < 0); ++s) {
            r = t.charCodeAt(s), n = r >> 8, i = r % 256, o.push(i), o.push(n);
          }

          return o;
        }(e, t.length - r), t, r, n);
      }

      function A(t, e, r) {
        return 0 === e && r === t.length ? n.fromByteArray(t) : n.fromByteArray(t.slice(e, r));
      }

      function x(t, e, r) {
        r = Math.min(t.length, r);

        for (var n = [], i = e; i < r;) {
          var o,
              s,
              a,
              u,
              f = t[i],
              c = null,
              h = f > 239 ? 4 : f > 223 ? 3 : f > 191 ? 2 : 1;
          if (i + h <= r) switch (h) {
            case 1:
              f < 128 && (c = f);
              break;

            case 2:
              128 == (192 & (o = t[i + 1])) && (u = (31 & f) << 6 | 63 & o) > 127 && (c = u);
              break;

            case 3:
              o = t[i + 1], s = t[i + 2], 128 == (192 & o) && 128 == (192 & s) && (u = (15 & f) << 12 | (63 & o) << 6 | 63 & s) > 2047 && (u < 55296 || u > 57343) && (c = u);
              break;

            case 4:
              o = t[i + 1], s = t[i + 2], a = t[i + 3], 128 == (192 & o) && 128 == (192 & s) && 128 == (192 & a) && (u = (15 & f) << 18 | (63 & o) << 12 | (63 & s) << 6 | 63 & a) > 65535 && u < 1114112 && (c = u);
          }
          null === c ? (c = 65533, h = 1) : c > 65535 && (c -= 65536, n.push(c >>> 10 & 1023 | 55296), c = 56320 | 1023 & c), n.push(c), i += h;
        }

        return function (t) {
          var e = t.length;
          if (e <= 4096) return String.fromCharCode.apply(String, t);
          var r = "",
              n = 0;

          for (; n < e;) {
            r += String.fromCharCode.apply(String, t.slice(n, n += 4096));
          }

          return r;
        }(n);
      }

      e.Buffer = u, e.SlowBuffer = function (t) {
        +t != t && (t = 0);
        return u.alloc(+t);
      }, e.INSPECT_MAX_BYTES = 50, u.TYPED_ARRAY_SUPPORT = void 0 !== t.TYPED_ARRAY_SUPPORT ? t.TYPED_ARRAY_SUPPORT : function () {
        try {
          var t = new Uint8Array(1);
          return t.__proto__ = {
            __proto__: Uint8Array.prototype,
            foo: function foo() {
              return 42;
            }
          }, 42 === t.foo() && "function" == typeof t.subarray && 0 === t.subarray(1, 1).byteLength;
        } catch (t) {
          return !1;
        }
      }(), e.kMaxLength = s(), u.poolSize = 8192, u._augment = function (t) {
        return t.__proto__ = u.prototype, t;
      }, u.from = function (t, e, r) {
        return f(null, t, e, r);
      }, u.TYPED_ARRAY_SUPPORT && (u.prototype.__proto__ = Uint8Array.prototype, u.__proto__ = Uint8Array, "undefined" != typeof Symbol && Symbol.species && u[Symbol.species] === u && Object.defineProperty(u, Symbol.species, {
        value: null,
        configurable: !0
      })), u.alloc = function (t, e, r) {
        return function (t, e, r, n) {
          return c(e), e <= 0 ? a(t, e) : void 0 !== r ? "string" == typeof n ? a(t, e).fill(r, n) : a(t, e).fill(r) : a(t, e);
        }(null, t, e, r);
      }, u.allocUnsafe = function (t) {
        return h(null, t);
      }, u.allocUnsafeSlow = function (t) {
        return h(null, t);
      }, u.isBuffer = function (t) {
        return !(null == t || !t._isBuffer);
      }, u.compare = function (t, e) {
        if (!u.isBuffer(t) || !u.isBuffer(e)) throw new TypeError("Arguments must be Buffers");
        if (t === e) return 0;

        for (var r = t.length, n = e.length, i = 0, o = Math.min(r, n); i < o; ++i) {
          if (t[i] !== e[i]) {
            r = t[i], n = e[i];
            break;
          }
        }

        return r < n ? -1 : n < r ? 1 : 0;
      }, u.isEncoding = function (t) {
        switch (String(t).toLowerCase()) {
          case "hex":
          case "utf8":
          case "utf-8":
          case "ascii":
          case "latin1":
          case "binary":
          case "base64":
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return !0;

          default:
            return !1;
        }
      }, u.concat = function (t, e) {
        if (!o(t)) throw new TypeError('"list" argument must be an Array of Buffers');
        if (0 === t.length) return u.alloc(0);
        var r;
        if (void 0 === e) for (e = 0, r = 0; r < t.length; ++r) {
          e += t[r].length;
        }
        var n = u.allocUnsafe(e),
            i = 0;

        for (r = 0; r < t.length; ++r) {
          var s = t[r];
          if (!u.isBuffer(s)) throw new TypeError('"list" argument must be an Array of Buffers');
          s.copy(n, i), i += s.length;
        }

        return n;
      }, u.byteLength = p, u.prototype._isBuffer = !0, u.prototype.swap16 = function () {
        var t = this.length;
        if (t % 2 != 0) throw new RangeError("Buffer size must be a multiple of 16-bits");

        for (var e = 0; e < t; e += 2) {
          m(this, e, e + 1);
        }

        return this;
      }, u.prototype.swap32 = function () {
        var t = this.length;
        if (t % 4 != 0) throw new RangeError("Buffer size must be a multiple of 32-bits");

        for (var e = 0; e < t; e += 4) {
          m(this, e, e + 3), m(this, e + 1, e + 2);
        }

        return this;
      }, u.prototype.swap64 = function () {
        var t = this.length;
        if (t % 8 != 0) throw new RangeError("Buffer size must be a multiple of 64-bits");

        for (var e = 0; e < t; e += 8) {
          m(this, e, e + 7), m(this, e + 1, e + 6), m(this, e + 2, e + 5), m(this, e + 3, e + 4);
        }

        return this;
      }, u.prototype.toString = function () {
        var t = 0 | this.length;
        return 0 === t ? "" : 0 === arguments.length ? x(this, 0, t) : g.apply(this, arguments);
      }, u.prototype.equals = function (t) {
        if (!u.isBuffer(t)) throw new TypeError("Argument must be a Buffer");
        return this === t || 0 === u.compare(this, t);
      }, u.prototype.inspect = function () {
        var t = "",
            r = e.INSPECT_MAX_BYTES;
        return this.length > 0 && (t = this.toString("hex", 0, r).match(/.{2}/g).join(" "), this.length > r && (t += " ... ")), "<Buffer " + t + ">";
      }, u.prototype.compare = function (t, e, r, n, i) {
        if (!u.isBuffer(t)) throw new TypeError("Argument must be a Buffer");
        if (void 0 === e && (e = 0), void 0 === r && (r = t ? t.length : 0), void 0 === n && (n = 0), void 0 === i && (i = this.length), e < 0 || r > t.length || n < 0 || i > this.length) throw new RangeError("out of range index");
        if (n >= i && e >= r) return 0;
        if (n >= i) return -1;
        if (e >= r) return 1;
        if (this === t) return 0;

        for (var o = (i >>>= 0) - (n >>>= 0), s = (r >>>= 0) - (e >>>= 0), a = Math.min(o, s), f = this.slice(n, i), c = t.slice(e, r), h = 0; h < a; ++h) {
          if (f[h] !== c[h]) {
            o = f[h], s = c[h];
            break;
          }
        }

        return o < s ? -1 : s < o ? 1 : 0;
      }, u.prototype.includes = function (t, e, r) {
        return -1 !== this.indexOf(t, e, r);
      }, u.prototype.indexOf = function (t, e, r) {
        return b(this, t, e, r, !0);
      }, u.prototype.lastIndexOf = function (t, e, r) {
        return b(this, t, e, r, !1);
      }, u.prototype.write = function (t, e, r, n) {
        if (void 0 === e) n = "utf8", r = this.length, e = 0;else if (void 0 === r && "string" == typeof e) n = e, r = this.length, e = 0;else {
          if (!isFinite(e)) throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
          e |= 0, isFinite(r) ? (r |= 0, void 0 === n && (n = "utf8")) : (n = r, r = void 0);
        }
        var i = this.length - e;
        if ((void 0 === r || r > i) && (r = i), t.length > 0 && (r < 0 || e < 0) || e > this.length) throw new RangeError("Attempt to write outside buffer bounds");
        n || (n = "utf8");

        for (var o = !1;;) {
          switch (n) {
            case "hex":
              return y(this, t, e, r);

            case "utf8":
            case "utf-8":
              return _(this, t, e, r);

            case "ascii":
              return w(this, t, e, r);

            case "latin1":
            case "binary":
              return E(this, t, e, r);

            case "base64":
              return M(this, t, e, r);

            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              return S(this, t, e, r);

            default:
              if (o) throw new TypeError("Unknown encoding: " + n);
              n = ("" + n).toLowerCase(), o = !0;
          }
        }
      }, u.prototype.toJSON = function () {
        return {
          type: "Buffer",
          data: Array.prototype.slice.call(this._arr || this, 0)
        };
      };

      function R(t, e, r) {
        var n = "";
        r = Math.min(t.length, r);

        for (var i = e; i < r; ++i) {
          n += String.fromCharCode(127 & t[i]);
        }

        return n;
      }

      function T(t, e, r) {
        var n = "";
        r = Math.min(t.length, r);

        for (var i = e; i < r; ++i) {
          n += String.fromCharCode(t[i]);
        }

        return n;
      }

      function k(t, e, r) {
        var n = t.length;
        (!e || e < 0) && (e = 0), (!r || r < 0 || r > n) && (r = n);

        for (var i = "", o = e; o < r; ++o) {
          i += D(t[o]);
        }

        return i;
      }

      function I(t, e, r) {
        for (var n = t.slice(e, r), i = "", o = 0; o < n.length; o += 2) {
          i += String.fromCharCode(n[o] + 256 * n[o + 1]);
        }

        return i;
      }

      function B(t, e, r) {
        if (t % 1 != 0 || t < 0) throw new RangeError("offset is not uint");
        if (t + e > r) throw new RangeError("Trying to access beyond buffer length");
      }

      function O(t, e, r, n, i, o) {
        if (!u.isBuffer(t)) throw new TypeError('"buffer" argument must be a Buffer instance');
        if (e > i || e < o) throw new RangeError('"value" argument is out of bounds');
        if (r + n > t.length) throw new RangeError("Index out of range");
      }

      function P(t, e, r, n) {
        e < 0 && (e = 65535 + e + 1);

        for (var i = 0, o = Math.min(t.length - r, 2); i < o; ++i) {
          t[r + i] = (e & 255 << 8 * (n ? i : 1 - i)) >>> 8 * (n ? i : 1 - i);
        }
      }

      function N(t, e, r, n) {
        e < 0 && (e = 4294967295 + e + 1);

        for (var i = 0, o = Math.min(t.length - r, 4); i < o; ++i) {
          t[r + i] = e >>> 8 * (n ? i : 3 - i) & 255;
        }
      }

      function C(t, e, r, n, i, o) {
        if (r + n > t.length) throw new RangeError("Index out of range");
        if (r < 0) throw new RangeError("Index out of range");
      }

      function L(t, e, r, n, o) {
        return o || C(t, 0, r, 4), i.write(t, e, r, n, 23, 4), r + 4;
      }

      function j(t, e, r, n, o) {
        return o || C(t, 0, r, 8), i.write(t, e, r, n, 52, 8), r + 8;
      }

      u.prototype.slice = function (t, e) {
        var r,
            n = this.length;
        if ((t = ~~t) < 0 ? (t += n) < 0 && (t = 0) : t > n && (t = n), (e = void 0 === e ? n : ~~e) < 0 ? (e += n) < 0 && (e = 0) : e > n && (e = n), e < t && (e = t), u.TYPED_ARRAY_SUPPORT) (r = this.subarray(t, e)).__proto__ = u.prototype;else {
          var i = e - t;
          r = new u(i, void 0);

          for (var o = 0; o < i; ++o) {
            r[o] = this[o + t];
          }
        }
        return r;
      }, u.prototype.readUIntLE = function (t, e, r) {
        t |= 0, e |= 0, r || B(t, e, this.length);

        for (var n = this[t], i = 1, o = 0; ++o < e && (i *= 256);) {
          n += this[t + o] * i;
        }

        return n;
      }, u.prototype.readUIntBE = function (t, e, r) {
        t |= 0, e |= 0, r || B(t, e, this.length);

        for (var n = this[t + --e], i = 1; e > 0 && (i *= 256);) {
          n += this[t + --e] * i;
        }

        return n;
      }, u.prototype.readUInt8 = function (t, e) {
        return e || B(t, 1, this.length), this[t];
      }, u.prototype.readUInt16LE = function (t, e) {
        return e || B(t, 2, this.length), this[t] | this[t + 1] << 8;
      }, u.prototype.readUInt16BE = function (t, e) {
        return e || B(t, 2, this.length), this[t] << 8 | this[t + 1];
      }, u.prototype.readUInt32LE = function (t, e) {
        return e || B(t, 4, this.length), (this[t] | this[t + 1] << 8 | this[t + 2] << 16) + 16777216 * this[t + 3];
      }, u.prototype.readUInt32BE = function (t, e) {
        return e || B(t, 4, this.length), 16777216 * this[t] + (this[t + 1] << 16 | this[t + 2] << 8 | this[t + 3]);
      }, u.prototype.readIntLE = function (t, e, r) {
        t |= 0, e |= 0, r || B(t, e, this.length);

        for (var n = this[t], i = 1, o = 0; ++o < e && (i *= 256);) {
          n += this[t + o] * i;
        }

        return n >= (i *= 128) && (n -= Math.pow(2, 8 * e)), n;
      }, u.prototype.readIntBE = function (t, e, r) {
        t |= 0, e |= 0, r || B(t, e, this.length);

        for (var n = e, i = 1, o = this[t + --n]; n > 0 && (i *= 256);) {
          o += this[t + --n] * i;
        }

        return o >= (i *= 128) && (o -= Math.pow(2, 8 * e)), o;
      }, u.prototype.readInt8 = function (t, e) {
        return e || B(t, 1, this.length), 128 & this[t] ? -1 * (255 - this[t] + 1) : this[t];
      }, u.prototype.readInt16LE = function (t, e) {
        e || B(t, 2, this.length);
        var r = this[t] | this[t + 1] << 8;
        return 32768 & r ? 4294901760 | r : r;
      }, u.prototype.readInt16BE = function (t, e) {
        e || B(t, 2, this.length);
        var r = this[t + 1] | this[t] << 8;
        return 32768 & r ? 4294901760 | r : r;
      }, u.prototype.readInt32LE = function (t, e) {
        return e || B(t, 4, this.length), this[t] | this[t + 1] << 8 | this[t + 2] << 16 | this[t + 3] << 24;
      }, u.prototype.readInt32BE = function (t, e) {
        return e || B(t, 4, this.length), this[t] << 24 | this[t + 1] << 16 | this[t + 2] << 8 | this[t + 3];
      }, u.prototype.readFloatLE = function (t, e) {
        return e || B(t, 4, this.length), i.read(this, t, !0, 23, 4);
      }, u.prototype.readFloatBE = function (t, e) {
        return e || B(t, 4, this.length), i.read(this, t, !1, 23, 4);
      }, u.prototype.readDoubleLE = function (t, e) {
        return e || B(t, 8, this.length), i.read(this, t, !0, 52, 8);
      }, u.prototype.readDoubleBE = function (t, e) {
        return e || B(t, 8, this.length), i.read(this, t, !1, 52, 8);
      }, u.prototype.writeUIntLE = function (t, e, r, n) {
        (t = +t, e |= 0, r |= 0, n) || O(this, t, e, r, Math.pow(2, 8 * r) - 1, 0);
        var i = 1,
            o = 0;

        for (this[e] = 255 & t; ++o < r && (i *= 256);) {
          this[e + o] = t / i & 255;
        }

        return e + r;
      }, u.prototype.writeUIntBE = function (t, e, r, n) {
        (t = +t, e |= 0, r |= 0, n) || O(this, t, e, r, Math.pow(2, 8 * r) - 1, 0);
        var i = r - 1,
            o = 1;

        for (this[e + i] = 255 & t; --i >= 0 && (o *= 256);) {
          this[e + i] = t / o & 255;
        }

        return e + r;
      }, u.prototype.writeUInt8 = function (t, e, r) {
        return t = +t, e |= 0, r || O(this, t, e, 1, 255, 0), u.TYPED_ARRAY_SUPPORT || (t = Math.floor(t)), this[e] = 255 & t, e + 1;
      }, u.prototype.writeUInt16LE = function (t, e, r) {
        return t = +t, e |= 0, r || O(this, t, e, 2, 65535, 0), u.TYPED_ARRAY_SUPPORT ? (this[e] = 255 & t, this[e + 1] = t >>> 8) : P(this, t, e, !0), e + 2;
      }, u.prototype.writeUInt16BE = function (t, e, r) {
        return t = +t, e |= 0, r || O(this, t, e, 2, 65535, 0), u.TYPED_ARRAY_SUPPORT ? (this[e] = t >>> 8, this[e + 1] = 255 & t) : P(this, t, e, !1), e + 2;
      }, u.prototype.writeUInt32LE = function (t, e, r) {
        return t = +t, e |= 0, r || O(this, t, e, 4, 4294967295, 0), u.TYPED_ARRAY_SUPPORT ? (this[e + 3] = t >>> 24, this[e + 2] = t >>> 16, this[e + 1] = t >>> 8, this[e] = 255 & t) : N(this, t, e, !0), e + 4;
      }, u.prototype.writeUInt32BE = function (t, e, r) {
        return t = +t, e |= 0, r || O(this, t, e, 4, 4294967295, 0), u.TYPED_ARRAY_SUPPORT ? (this[e] = t >>> 24, this[e + 1] = t >>> 16, this[e + 2] = t >>> 8, this[e + 3] = 255 & t) : N(this, t, e, !1), e + 4;
      }, u.prototype.writeIntLE = function (t, e, r, n) {
        if (t = +t, e |= 0, !n) {
          var i = Math.pow(2, 8 * r - 1);
          O(this, t, e, r, i - 1, -i);
        }

        var o = 0,
            s = 1,
            a = 0;

        for (this[e] = 255 & t; ++o < r && (s *= 256);) {
          t < 0 && 0 === a && 0 !== this[e + o - 1] && (a = 1), this[e + o] = (t / s >> 0) - a & 255;
        }

        return e + r;
      }, u.prototype.writeIntBE = function (t, e, r, n) {
        if (t = +t, e |= 0, !n) {
          var i = Math.pow(2, 8 * r - 1);
          O(this, t, e, r, i - 1, -i);
        }

        var o = r - 1,
            s = 1,
            a = 0;

        for (this[e + o] = 255 & t; --o >= 0 && (s *= 256);) {
          t < 0 && 0 === a && 0 !== this[e + o + 1] && (a = 1), this[e + o] = (t / s >> 0) - a & 255;
        }

        return e + r;
      }, u.prototype.writeInt8 = function (t, e, r) {
        return t = +t, e |= 0, r || O(this, t, e, 1, 127, -128), u.TYPED_ARRAY_SUPPORT || (t = Math.floor(t)), t < 0 && (t = 255 + t + 1), this[e] = 255 & t, e + 1;
      }, u.prototype.writeInt16LE = function (t, e, r) {
        return t = +t, e |= 0, r || O(this, t, e, 2, 32767, -32768), u.TYPED_ARRAY_SUPPORT ? (this[e] = 255 & t, this[e + 1] = t >>> 8) : P(this, t, e, !0), e + 2;
      }, u.prototype.writeInt16BE = function (t, e, r) {
        return t = +t, e |= 0, r || O(this, t, e, 2, 32767, -32768), u.TYPED_ARRAY_SUPPORT ? (this[e] = t >>> 8, this[e + 1] = 255 & t) : P(this, t, e, !1), e + 2;
      }, u.prototype.writeInt32LE = function (t, e, r) {
        return t = +t, e |= 0, r || O(this, t, e, 4, 2147483647, -2147483648), u.TYPED_ARRAY_SUPPORT ? (this[e] = 255 & t, this[e + 1] = t >>> 8, this[e + 2] = t >>> 16, this[e + 3] = t >>> 24) : N(this, t, e, !0), e + 4;
      }, u.prototype.writeInt32BE = function (t, e, r) {
        return t = +t, e |= 0, r || O(this, t, e, 4, 2147483647, -2147483648), t < 0 && (t = 4294967295 + t + 1), u.TYPED_ARRAY_SUPPORT ? (this[e] = t >>> 24, this[e + 1] = t >>> 16, this[e + 2] = t >>> 8, this[e + 3] = 255 & t) : N(this, t, e, !1), e + 4;
      }, u.prototype.writeFloatLE = function (t, e, r) {
        return L(this, t, e, !0, r);
      }, u.prototype.writeFloatBE = function (t, e, r) {
        return L(this, t, e, !1, r);
      }, u.prototype.writeDoubleLE = function (t, e, r) {
        return j(this, t, e, !0, r);
      }, u.prototype.writeDoubleBE = function (t, e, r) {
        return j(this, t, e, !1, r);
      }, u.prototype.copy = function (t, e, r, n) {
        if (r || (r = 0), n || 0 === n || (n = this.length), e >= t.length && (e = t.length), e || (e = 0), n > 0 && n < r && (n = r), n === r) return 0;
        if (0 === t.length || 0 === this.length) return 0;
        if (e < 0) throw new RangeError("targetStart out of bounds");
        if (r < 0 || r >= this.length) throw new RangeError("sourceStart out of bounds");
        if (n < 0) throw new RangeError("sourceEnd out of bounds");
        n > this.length && (n = this.length), t.length - e < n - r && (n = t.length - e + r);
        var i,
            o = n - r;
        if (this === t && r < e && e < n) for (i = o - 1; i >= 0; --i) {
          t[i + e] = this[i + r];
        } else if (o < 1e3 || !u.TYPED_ARRAY_SUPPORT) for (i = 0; i < o; ++i) {
          t[i + e] = this[i + r];
        } else Uint8Array.prototype.set.call(t, this.subarray(r, r + o), e);
        return o;
      }, u.prototype.fill = function (t, e, r, n) {
        if ("string" == typeof t) {
          if ("string" == typeof e ? (n = e, e = 0, r = this.length) : "string" == typeof r && (n = r, r = this.length), 1 === t.length) {
            var i = t.charCodeAt(0);
            i < 256 && (t = i);
          }

          if (void 0 !== n && "string" != typeof n) throw new TypeError("encoding must be a string");
          if ("string" == typeof n && !u.isEncoding(n)) throw new TypeError("Unknown encoding: " + n);
        } else "number" == typeof t && (t &= 255);

        if (e < 0 || this.length < e || this.length < r) throw new RangeError("Out of range index");
        if (r <= e) return this;
        var o;
        if (e >>>= 0, r = void 0 === r ? this.length : r >>> 0, t || (t = 0), "number" == typeof t) for (o = e; o < r; ++o) {
          this[o] = t;
        } else {
          var s = u.isBuffer(t) ? t : F(new u(t, n).toString()),
              a = s.length;

          for (o = 0; o < r - e; ++o) {
            this[o + e] = s[o % a];
          }
        }
        return this;
      };
      var U = /[^+\/0-9A-Za-z-_]/g;

      function D(t) {
        return t < 16 ? "0" + t.toString(16) : t.toString(16);
      }

      function F(t, e) {
        var r;
        e = e || 1 / 0;

        for (var n = t.length, i = null, o = [], s = 0; s < n; ++s) {
          if ((r = t.charCodeAt(s)) > 55295 && r < 57344) {
            if (!i) {
              if (r > 56319) {
                (e -= 3) > -1 && o.push(239, 191, 189);
                continue;
              }

              if (s + 1 === n) {
                (e -= 3) > -1 && o.push(239, 191, 189);
                continue;
              }

              i = r;
              continue;
            }

            if (r < 56320) {
              (e -= 3) > -1 && o.push(239, 191, 189), i = r;
              continue;
            }

            r = 65536 + (i - 55296 << 10 | r - 56320);
          } else i && (e -= 3) > -1 && o.push(239, 191, 189);

          if (i = null, r < 128) {
            if ((e -= 1) < 0) break;
            o.push(r);
          } else if (r < 2048) {
            if ((e -= 2) < 0) break;
            o.push(r >> 6 | 192, 63 & r | 128);
          } else if (r < 65536) {
            if ((e -= 3) < 0) break;
            o.push(r >> 12 | 224, r >> 6 & 63 | 128, 63 & r | 128);
          } else {
            if (!(r < 1114112)) throw new Error("Invalid code point");
            if ((e -= 4) < 0) break;
            o.push(r >> 18 | 240, r >> 12 & 63 | 128, r >> 6 & 63 | 128, 63 & r | 128);
          }
        }

        return o;
      }

      function z(t) {
        return n.toByteArray(function (t) {
          if ((t = function (t) {
            return t.trim ? t.trim() : t.replace(/^\s+|\s+$/g, "");
          }(t).replace(U, "")).length < 2) return "";

          for (; t.length % 4 != 0;) {
            t += "=";
          }

          return t;
        }(t));
      }

      function q(t, e, r, n) {
        for (var i = 0; i < n && !(i + r >= e.length || i >= t.length); ++i) {
          e[i + r] = t[i];
        }

        return i;
      }
    }).call(this, r(4));
  }, function (t, e, r) {
    (function (t) {
      !function (t, e) {
        "use strict";

        function n(t, e) {
          if (!t) throw new Error(e || "Assertion failed");
        }

        function i(t, e) {
          t.super_ = e;

          var r = function r() {};

          r.prototype = e.prototype, t.prototype = new r(), t.prototype.constructor = t;
        }

        function o(t, e, r) {
          if (o.isBN(t)) return t;
          this.negative = 0, this.words = null, this.length = 0, this.red = null, null !== t && ("le" !== e && "be" !== e || (r = e, e = 10), this._init(t || 0, e || 10, r || "be"));
        }

        var s;
        "object" == typeof t ? t.exports = o : e.BN = o, o.BN = o, o.wordSize = 26;

        try {
          s = r(132).Buffer;
        } catch (t) {}

        function a(t, e, r) {
          for (var n = 0, i = Math.min(t.length, r), o = e; o < i; o++) {
            var s = t.charCodeAt(o) - 48;
            n <<= 4, n |= s >= 49 && s <= 54 ? s - 49 + 10 : s >= 17 && s <= 22 ? s - 17 + 10 : 15 & s;
          }

          return n;
        }

        function u(t, e, r, n) {
          for (var i = 0, o = Math.min(t.length, r), s = e; s < o; s++) {
            var a = t.charCodeAt(s) - 48;
            i *= n, i += a >= 49 ? a - 49 + 10 : a >= 17 ? a - 17 + 10 : a;
          }

          return i;
        }

        o.isBN = function (t) {
          return t instanceof o || null !== t && "object" == typeof t && t.constructor.wordSize === o.wordSize && Array.isArray(t.words);
        }, o.max = function (t, e) {
          return t.cmp(e) > 0 ? t : e;
        }, o.min = function (t, e) {
          return t.cmp(e) < 0 ? t : e;
        }, o.prototype._init = function (t, e, r) {
          if ("number" == typeof t) return this._initNumber(t, e, r);
          if ("object" == typeof t) return this._initArray(t, e, r);
          "hex" === e && (e = 16), n(e === (0 | e) && e >= 2 && e <= 36);
          var i = 0;
          "-" === (t = t.toString().replace(/\s+/g, ""))[0] && i++, 16 === e ? this._parseHex(t, i) : this._parseBase(t, e, i), "-" === t[0] && (this.negative = 1), this.strip(), "le" === r && this._initArray(this.toArray(), e, r);
        }, o.prototype._initNumber = function (t, e, r) {
          t < 0 && (this.negative = 1, t = -t), t < 67108864 ? (this.words = [67108863 & t], this.length = 1) : t < 4503599627370496 ? (this.words = [67108863 & t, t / 67108864 & 67108863], this.length = 2) : (n(t < 9007199254740992), this.words = [67108863 & t, t / 67108864 & 67108863, 1], this.length = 3), "le" === r && this._initArray(this.toArray(), e, r);
        }, o.prototype._initArray = function (t, e, r) {
          if (n("number" == typeof t.length), t.length <= 0) return this.words = [0], this.length = 1, this;
          this.length = Math.ceil(t.length / 3), this.words = new Array(this.length);

          for (var i = 0; i < this.length; i++) {
            this.words[i] = 0;
          }

          var o,
              s,
              a = 0;
          if ("be" === r) for (i = t.length - 1, o = 0; i >= 0; i -= 3) {
            s = t[i] | t[i - 1] << 8 | t[i - 2] << 16, this.words[o] |= s << a & 67108863, this.words[o + 1] = s >>> 26 - a & 67108863, (a += 24) >= 26 && (a -= 26, o++);
          } else if ("le" === r) for (i = 0, o = 0; i < t.length; i += 3) {
            s = t[i] | t[i + 1] << 8 | t[i + 2] << 16, this.words[o] |= s << a & 67108863, this.words[o + 1] = s >>> 26 - a & 67108863, (a += 24) >= 26 && (a -= 26, o++);
          }
          return this.strip();
        }, o.prototype._parseHex = function (t, e) {
          this.length = Math.ceil((t.length - e) / 6), this.words = new Array(this.length);

          for (var r = 0; r < this.length; r++) {
            this.words[r] = 0;
          }

          var n,
              i,
              o = 0;

          for (r = t.length - 6, n = 0; r >= e; r -= 6) {
            i = a(t, r, r + 6), this.words[n] |= i << o & 67108863, this.words[n + 1] |= i >>> 26 - o & 4194303, (o += 24) >= 26 && (o -= 26, n++);
          }

          r + 6 !== e && (i = a(t, e, r + 6), this.words[n] |= i << o & 67108863, this.words[n + 1] |= i >>> 26 - o & 4194303), this.strip();
        }, o.prototype._parseBase = function (t, e, r) {
          this.words = [0], this.length = 1;

          for (var n = 0, i = 1; i <= 67108863; i *= e) {
            n++;
          }

          n--, i = i / e | 0;

          for (var o = t.length - r, s = o % n, a = Math.min(o, o - s) + r, f = 0, c = r; c < a; c += n) {
            f = u(t, c, c + n, e), this.imuln(i), this.words[0] + f < 67108864 ? this.words[0] += f : this._iaddn(f);
          }

          if (0 !== s) {
            var h = 1;

            for (f = u(t, c, t.length, e), c = 0; c < s; c++) {
              h *= e;
            }

            this.imuln(h), this.words[0] + f < 67108864 ? this.words[0] += f : this._iaddn(f);
          }
        }, o.prototype.copy = function (t) {
          t.words = new Array(this.length);

          for (var e = 0; e < this.length; e++) {
            t.words[e] = this.words[e];
          }

          t.length = this.length, t.negative = this.negative, t.red = this.red;
        }, o.prototype.clone = function () {
          var t = new o(null);
          return this.copy(t), t;
        }, o.prototype._expand = function (t) {
          for (; this.length < t;) {
            this.words[this.length++] = 0;
          }

          return this;
        }, o.prototype.strip = function () {
          for (; this.length > 1 && 0 === this.words[this.length - 1];) {
            this.length--;
          }

          return this._normSign();
        }, o.prototype._normSign = function () {
          return 1 === this.length && 0 === this.words[0] && (this.negative = 0), this;
        }, o.prototype.inspect = function () {
          return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
        };
        var f = ["", "0", "00", "000", "0000", "00000", "000000", "0000000", "00000000", "000000000", "0000000000", "00000000000", "000000000000", "0000000000000", "00000000000000", "000000000000000", "0000000000000000", "00000000000000000", "000000000000000000", "0000000000000000000", "00000000000000000000", "000000000000000000000", "0000000000000000000000", "00000000000000000000000", "000000000000000000000000", "0000000000000000000000000"],
            c = [0, 0, 25, 16, 12, 11, 10, 9, 8, 8, 7, 7, 7, 7, 6, 6, 6, 6, 6, 6, 6, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5],
            h = [0, 0, 33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216, 43046721, 1e7, 19487171, 35831808, 62748517, 7529536, 11390625, 16777216, 24137569, 34012224, 47045881, 64e6, 4084101, 5153632, 6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149, 243e5, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176];

        function l(t, e, r) {
          r.negative = e.negative ^ t.negative;
          var n = t.length + e.length | 0;
          r.length = n, n = n - 1 | 0;
          var i = 0 | t.words[0],
              o = 0 | e.words[0],
              s = i * o,
              a = 67108863 & s,
              u = s / 67108864 | 0;
          r.words[0] = a;

          for (var f = 1; f < n; f++) {
            for (var c = u >>> 26, h = 67108863 & u, l = Math.min(f, e.length - 1), d = Math.max(0, f - t.length + 1); d <= l; d++) {
              var p = f - d | 0;
              c += (s = (i = 0 | t.words[p]) * (o = 0 | e.words[d]) + h) / 67108864 | 0, h = 67108863 & s;
            }

            r.words[f] = 0 | h, u = 0 | c;
          }

          return 0 !== u ? r.words[f] = 0 | u : r.length--, r.strip();
        }

        o.prototype.toString = function (t, e) {
          var r;

          if (e = 0 | e || 1, 16 === (t = t || 10) || "hex" === t) {
            r = "";

            for (var i = 0, o = 0, s = 0; s < this.length; s++) {
              var a = this.words[s],
                  u = (16777215 & (a << i | o)).toString(16);
              r = 0 !== (o = a >>> 24 - i & 16777215) || s !== this.length - 1 ? f[6 - u.length] + u + r : u + r, (i += 2) >= 26 && (i -= 26, s--);
            }

            for (0 !== o && (r = o.toString(16) + r); r.length % e != 0;) {
              r = "0" + r;
            }

            return 0 !== this.negative && (r = "-" + r), r;
          }

          if (t === (0 | t) && t >= 2 && t <= 36) {
            var l = c[t],
                d = h[t];
            r = "";
            var p = this.clone();

            for (p.negative = 0; !p.isZero();) {
              var g = p.modn(d).toString(t);
              r = (p = p.idivn(d)).isZero() ? g + r : f[l - g.length] + g + r;
            }

            for (this.isZero() && (r = "0" + r); r.length % e != 0;) {
              r = "0" + r;
            }

            return 0 !== this.negative && (r = "-" + r), r;
          }

          n(!1, "Base should be between 2 and 36");
        }, o.prototype.toNumber = function () {
          var t = this.words[0];
          return 2 === this.length ? t += 67108864 * this.words[1] : 3 === this.length && 1 === this.words[2] ? t += 4503599627370496 + 67108864 * this.words[1] : this.length > 2 && n(!1, "Number can only safely store up to 53 bits"), 0 !== this.negative ? -t : t;
        }, o.prototype.toJSON = function () {
          return this.toString(16);
        }, o.prototype.toBuffer = function (t, e) {
          return n(void 0 !== s), this.toArrayLike(s, t, e);
        }, o.prototype.toArray = function (t, e) {
          return this.toArrayLike(Array, t, e);
        }, o.prototype.toArrayLike = function (t, e, r) {
          var i = this.byteLength(),
              o = r || Math.max(1, i);
          n(i <= o, "byte array longer than desired length"), n(o > 0, "Requested array length <= 0"), this.strip();
          var s,
              a,
              u = "le" === e,
              f = new t(o),
              c = this.clone();

          if (u) {
            for (a = 0; !c.isZero(); a++) {
              s = c.andln(255), c.iushrn(8), f[a] = s;
            }

            for (; a < o; a++) {
              f[a] = 0;
            }
          } else {
            for (a = 0; a < o - i; a++) {
              f[a] = 0;
            }

            for (a = 0; !c.isZero(); a++) {
              s = c.andln(255), c.iushrn(8), f[o - a - 1] = s;
            }
          }

          return f;
        }, Math.clz32 ? o.prototype._countBits = function (t) {
          return 32 - Math.clz32(t);
        } : o.prototype._countBits = function (t) {
          var e = t,
              r = 0;
          return e >= 4096 && (r += 13, e >>>= 13), e >= 64 && (r += 7, e >>>= 7), e >= 8 && (r += 4, e >>>= 4), e >= 2 && (r += 2, e >>>= 2), r + e;
        }, o.prototype._zeroBits = function (t) {
          if (0 === t) return 26;
          var e = t,
              r = 0;
          return 0 == (8191 & e) && (r += 13, e >>>= 13), 0 == (127 & e) && (r += 7, e >>>= 7), 0 == (15 & e) && (r += 4, e >>>= 4), 0 == (3 & e) && (r += 2, e >>>= 2), 0 == (1 & e) && r++, r;
        }, o.prototype.bitLength = function () {
          var t = this.words[this.length - 1],
              e = this._countBits(t);

          return 26 * (this.length - 1) + e;
        }, o.prototype.zeroBits = function () {
          if (this.isZero()) return 0;

          for (var t = 0, e = 0; e < this.length; e++) {
            var r = this._zeroBits(this.words[e]);

            if (t += r, 26 !== r) break;
          }

          return t;
        }, o.prototype.byteLength = function () {
          return Math.ceil(this.bitLength() / 8);
        }, o.prototype.toTwos = function (t) {
          return 0 !== this.negative ? this.abs().inotn(t).iaddn(1) : this.clone();
        }, o.prototype.fromTwos = function (t) {
          return this.testn(t - 1) ? this.notn(t).iaddn(1).ineg() : this.clone();
        }, o.prototype.isNeg = function () {
          return 0 !== this.negative;
        }, o.prototype.neg = function () {
          return this.clone().ineg();
        }, o.prototype.ineg = function () {
          return this.isZero() || (this.negative ^= 1), this;
        }, o.prototype.iuor = function (t) {
          for (; this.length < t.length;) {
            this.words[this.length++] = 0;
          }

          for (var e = 0; e < t.length; e++) {
            this.words[e] = this.words[e] | t.words[e];
          }

          return this.strip();
        }, o.prototype.ior = function (t) {
          return n(0 == (this.negative | t.negative)), this.iuor(t);
        }, o.prototype.or = function (t) {
          return this.length > t.length ? this.clone().ior(t) : t.clone().ior(this);
        }, o.prototype.uor = function (t) {
          return this.length > t.length ? this.clone().iuor(t) : t.clone().iuor(this);
        }, o.prototype.iuand = function (t) {
          var e;
          e = this.length > t.length ? t : this;

          for (var r = 0; r < e.length; r++) {
            this.words[r] = this.words[r] & t.words[r];
          }

          return this.length = e.length, this.strip();
        }, o.prototype.iand = function (t) {
          return n(0 == (this.negative | t.negative)), this.iuand(t);
        }, o.prototype.and = function (t) {
          return this.length > t.length ? this.clone().iand(t) : t.clone().iand(this);
        }, o.prototype.uand = function (t) {
          return this.length > t.length ? this.clone().iuand(t) : t.clone().iuand(this);
        }, o.prototype.iuxor = function (t) {
          var e, r;
          this.length > t.length ? (e = this, r = t) : (e = t, r = this);

          for (var n = 0; n < r.length; n++) {
            this.words[n] = e.words[n] ^ r.words[n];
          }

          if (this !== e) for (; n < e.length; n++) {
            this.words[n] = e.words[n];
          }
          return this.length = e.length, this.strip();
        }, o.prototype.ixor = function (t) {
          return n(0 == (this.negative | t.negative)), this.iuxor(t);
        }, o.prototype.xor = function (t) {
          return this.length > t.length ? this.clone().ixor(t) : t.clone().ixor(this);
        }, o.prototype.uxor = function (t) {
          return this.length > t.length ? this.clone().iuxor(t) : t.clone().iuxor(this);
        }, o.prototype.inotn = function (t) {
          n("number" == typeof t && t >= 0);
          var e = 0 | Math.ceil(t / 26),
              r = t % 26;
          this._expand(e), r > 0 && e--;

          for (var i = 0; i < e; i++) {
            this.words[i] = 67108863 & ~this.words[i];
          }

          return r > 0 && (this.words[i] = ~this.words[i] & 67108863 >> 26 - r), this.strip();
        }, o.prototype.notn = function (t) {
          return this.clone().inotn(t);
        }, o.prototype.setn = function (t, e) {
          n("number" == typeof t && t >= 0);
          var r = t / 26 | 0,
              i = t % 26;
          return this._expand(r + 1), this.words[r] = e ? this.words[r] | 1 << i : this.words[r] & ~(1 << i), this.strip();
        }, o.prototype.iadd = function (t) {
          var e, r, n;
          if (0 !== this.negative && 0 === t.negative) return this.negative = 0, e = this.isub(t), this.negative ^= 1, this._normSign();
          if (0 === this.negative && 0 !== t.negative) return t.negative = 0, e = this.isub(t), t.negative = 1, e._normSign();
          this.length > t.length ? (r = this, n = t) : (r = t, n = this);

          for (var i = 0, o = 0; o < n.length; o++) {
            e = (0 | r.words[o]) + (0 | n.words[o]) + i, this.words[o] = 67108863 & e, i = e >>> 26;
          }

          for (; 0 !== i && o < r.length; o++) {
            e = (0 | r.words[o]) + i, this.words[o] = 67108863 & e, i = e >>> 26;
          }

          if (this.length = r.length, 0 !== i) this.words[this.length] = i, this.length++;else if (r !== this) for (; o < r.length; o++) {
            this.words[o] = r.words[o];
          }
          return this;
        }, o.prototype.add = function (t) {
          var e;
          return 0 !== t.negative && 0 === this.negative ? (t.negative = 0, e = this.sub(t), t.negative ^= 1, e) : 0 === t.negative && 0 !== this.negative ? (this.negative = 0, e = t.sub(this), this.negative = 1, e) : this.length > t.length ? this.clone().iadd(t) : t.clone().iadd(this);
        }, o.prototype.isub = function (t) {
          if (0 !== t.negative) {
            t.negative = 0;
            var e = this.iadd(t);
            return t.negative = 1, e._normSign();
          }

          if (0 !== this.negative) return this.negative = 0, this.iadd(t), this.negative = 1, this._normSign();
          var r,
              n,
              i = this.cmp(t);
          if (0 === i) return this.negative = 0, this.length = 1, this.words[0] = 0, this;
          i > 0 ? (r = this, n = t) : (r = t, n = this);

          for (var o = 0, s = 0; s < n.length; s++) {
            o = (e = (0 | r.words[s]) - (0 | n.words[s]) + o) >> 26, this.words[s] = 67108863 & e;
          }

          for (; 0 !== o && s < r.length; s++) {
            o = (e = (0 | r.words[s]) + o) >> 26, this.words[s] = 67108863 & e;
          }

          if (0 === o && s < r.length && r !== this) for (; s < r.length; s++) {
            this.words[s] = r.words[s];
          }
          return this.length = Math.max(this.length, s), r !== this && (this.negative = 1), this.strip();
        }, o.prototype.sub = function (t) {
          return this.clone().isub(t);
        };

        var d = function d(t, e, r) {
          var n,
              i,
              o,
              s = t.words,
              a = e.words,
              u = r.words,
              f = 0,
              c = 0 | s[0],
              h = 8191 & c,
              l = c >>> 13,
              d = 0 | s[1],
              p = 8191 & d,
              g = d >>> 13,
              m = 0 | s[2],
              b = 8191 & m,
              v = m >>> 13,
              y = 0 | s[3],
              _ = 8191 & y,
              w = y >>> 13,
              E = 0 | s[4],
              M = 8191 & E,
              S = E >>> 13,
              A = 0 | s[5],
              x = 8191 & A,
              R = A >>> 13,
              T = 0 | s[6],
              k = 8191 & T,
              I = T >>> 13,
              B = 0 | s[7],
              O = 8191 & B,
              P = B >>> 13,
              N = 0 | s[8],
              C = 8191 & N,
              L = N >>> 13,
              j = 0 | s[9],
              U = 8191 & j,
              D = j >>> 13,
              F = 0 | a[0],
              z = 8191 & F,
              q = F >>> 13,
              H = 0 | a[1],
              Y = 8191 & H,
              G = H >>> 13,
              K = 0 | a[2],
              Z = 8191 & K,
              V = K >>> 13,
              W = 0 | a[3],
              J = 8191 & W,
              X = W >>> 13,
              $ = 0 | a[4],
              Q = 8191 & $,
              tt = $ >>> 13,
              et = 0 | a[5],
              rt = 8191 & et,
              nt = et >>> 13,
              it = 0 | a[6],
              ot = 8191 & it,
              st = it >>> 13,
              at = 0 | a[7],
              ut = 8191 & at,
              ft = at >>> 13,
              ct = 0 | a[8],
              ht = 8191 & ct,
              lt = ct >>> 13,
              dt = 0 | a[9],
              pt = 8191 & dt,
              gt = dt >>> 13;

          r.negative = t.negative ^ e.negative, r.length = 19;
          var mt = (f + (n = Math.imul(h, z)) | 0) + ((8191 & (i = (i = Math.imul(h, q)) + Math.imul(l, z) | 0)) << 13) | 0;
          f = ((o = Math.imul(l, q)) + (i >>> 13) | 0) + (mt >>> 26) | 0, mt &= 67108863, n = Math.imul(p, z), i = (i = Math.imul(p, q)) + Math.imul(g, z) | 0, o = Math.imul(g, q);
          var bt = (f + (n = n + Math.imul(h, Y) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, G) | 0) + Math.imul(l, Y) | 0)) << 13) | 0;
          f = ((o = o + Math.imul(l, G) | 0) + (i >>> 13) | 0) + (bt >>> 26) | 0, bt &= 67108863, n = Math.imul(b, z), i = (i = Math.imul(b, q)) + Math.imul(v, z) | 0, o = Math.imul(v, q), n = n + Math.imul(p, Y) | 0, i = (i = i + Math.imul(p, G) | 0) + Math.imul(g, Y) | 0, o = o + Math.imul(g, G) | 0;
          var vt = (f + (n = n + Math.imul(h, Z) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, V) | 0) + Math.imul(l, Z) | 0)) << 13) | 0;
          f = ((o = o + Math.imul(l, V) | 0) + (i >>> 13) | 0) + (vt >>> 26) | 0, vt &= 67108863, n = Math.imul(_, z), i = (i = Math.imul(_, q)) + Math.imul(w, z) | 0, o = Math.imul(w, q), n = n + Math.imul(b, Y) | 0, i = (i = i + Math.imul(b, G) | 0) + Math.imul(v, Y) | 0, o = o + Math.imul(v, G) | 0, n = n + Math.imul(p, Z) | 0, i = (i = i + Math.imul(p, V) | 0) + Math.imul(g, Z) | 0, o = o + Math.imul(g, V) | 0;
          var yt = (f + (n = n + Math.imul(h, J) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, X) | 0) + Math.imul(l, J) | 0)) << 13) | 0;
          f = ((o = o + Math.imul(l, X) | 0) + (i >>> 13) | 0) + (yt >>> 26) | 0, yt &= 67108863, n = Math.imul(M, z), i = (i = Math.imul(M, q)) + Math.imul(S, z) | 0, o = Math.imul(S, q), n = n + Math.imul(_, Y) | 0, i = (i = i + Math.imul(_, G) | 0) + Math.imul(w, Y) | 0, o = o + Math.imul(w, G) | 0, n = n + Math.imul(b, Z) | 0, i = (i = i + Math.imul(b, V) | 0) + Math.imul(v, Z) | 0, o = o + Math.imul(v, V) | 0, n = n + Math.imul(p, J) | 0, i = (i = i + Math.imul(p, X) | 0) + Math.imul(g, J) | 0, o = o + Math.imul(g, X) | 0;

          var _t = (f + (n = n + Math.imul(h, Q) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, tt) | 0) + Math.imul(l, Q) | 0)) << 13) | 0;

          f = ((o = o + Math.imul(l, tt) | 0) + (i >>> 13) | 0) + (_t >>> 26) | 0, _t &= 67108863, n = Math.imul(x, z), i = (i = Math.imul(x, q)) + Math.imul(R, z) | 0, o = Math.imul(R, q), n = n + Math.imul(M, Y) | 0, i = (i = i + Math.imul(M, G) | 0) + Math.imul(S, Y) | 0, o = o + Math.imul(S, G) | 0, n = n + Math.imul(_, Z) | 0, i = (i = i + Math.imul(_, V) | 0) + Math.imul(w, Z) | 0, o = o + Math.imul(w, V) | 0, n = n + Math.imul(b, J) | 0, i = (i = i + Math.imul(b, X) | 0) + Math.imul(v, J) | 0, o = o + Math.imul(v, X) | 0, n = n + Math.imul(p, Q) | 0, i = (i = i + Math.imul(p, tt) | 0) + Math.imul(g, Q) | 0, o = o + Math.imul(g, tt) | 0;
          var wt = (f + (n = n + Math.imul(h, rt) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, nt) | 0) + Math.imul(l, rt) | 0)) << 13) | 0;
          f = ((o = o + Math.imul(l, nt) | 0) + (i >>> 13) | 0) + (wt >>> 26) | 0, wt &= 67108863, n = Math.imul(k, z), i = (i = Math.imul(k, q)) + Math.imul(I, z) | 0, o = Math.imul(I, q), n = n + Math.imul(x, Y) | 0, i = (i = i + Math.imul(x, G) | 0) + Math.imul(R, Y) | 0, o = o + Math.imul(R, G) | 0, n = n + Math.imul(M, Z) | 0, i = (i = i + Math.imul(M, V) | 0) + Math.imul(S, Z) | 0, o = o + Math.imul(S, V) | 0, n = n + Math.imul(_, J) | 0, i = (i = i + Math.imul(_, X) | 0) + Math.imul(w, J) | 0, o = o + Math.imul(w, X) | 0, n = n + Math.imul(b, Q) | 0, i = (i = i + Math.imul(b, tt) | 0) + Math.imul(v, Q) | 0, o = o + Math.imul(v, tt) | 0, n = n + Math.imul(p, rt) | 0, i = (i = i + Math.imul(p, nt) | 0) + Math.imul(g, rt) | 0, o = o + Math.imul(g, nt) | 0;
          var Et = (f + (n = n + Math.imul(h, ot) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, st) | 0) + Math.imul(l, ot) | 0)) << 13) | 0;
          f = ((o = o + Math.imul(l, st) | 0) + (i >>> 13) | 0) + (Et >>> 26) | 0, Et &= 67108863, n = Math.imul(O, z), i = (i = Math.imul(O, q)) + Math.imul(P, z) | 0, o = Math.imul(P, q), n = n + Math.imul(k, Y) | 0, i = (i = i + Math.imul(k, G) | 0) + Math.imul(I, Y) | 0, o = o + Math.imul(I, G) | 0, n = n + Math.imul(x, Z) | 0, i = (i = i + Math.imul(x, V) | 0) + Math.imul(R, Z) | 0, o = o + Math.imul(R, V) | 0, n = n + Math.imul(M, J) | 0, i = (i = i + Math.imul(M, X) | 0) + Math.imul(S, J) | 0, o = o + Math.imul(S, X) | 0, n = n + Math.imul(_, Q) | 0, i = (i = i + Math.imul(_, tt) | 0) + Math.imul(w, Q) | 0, o = o + Math.imul(w, tt) | 0, n = n + Math.imul(b, rt) | 0, i = (i = i + Math.imul(b, nt) | 0) + Math.imul(v, rt) | 0, o = o + Math.imul(v, nt) | 0, n = n + Math.imul(p, ot) | 0, i = (i = i + Math.imul(p, st) | 0) + Math.imul(g, ot) | 0, o = o + Math.imul(g, st) | 0;
          var Mt = (f + (n = n + Math.imul(h, ut) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, ft) | 0) + Math.imul(l, ut) | 0)) << 13) | 0;
          f = ((o = o + Math.imul(l, ft) | 0) + (i >>> 13) | 0) + (Mt >>> 26) | 0, Mt &= 67108863, n = Math.imul(C, z), i = (i = Math.imul(C, q)) + Math.imul(L, z) | 0, o = Math.imul(L, q), n = n + Math.imul(O, Y) | 0, i = (i = i + Math.imul(O, G) | 0) + Math.imul(P, Y) | 0, o = o + Math.imul(P, G) | 0, n = n + Math.imul(k, Z) | 0, i = (i = i + Math.imul(k, V) | 0) + Math.imul(I, Z) | 0, o = o + Math.imul(I, V) | 0, n = n + Math.imul(x, J) | 0, i = (i = i + Math.imul(x, X) | 0) + Math.imul(R, J) | 0, o = o + Math.imul(R, X) | 0, n = n + Math.imul(M, Q) | 0, i = (i = i + Math.imul(M, tt) | 0) + Math.imul(S, Q) | 0, o = o + Math.imul(S, tt) | 0, n = n + Math.imul(_, rt) | 0, i = (i = i + Math.imul(_, nt) | 0) + Math.imul(w, rt) | 0, o = o + Math.imul(w, nt) | 0, n = n + Math.imul(b, ot) | 0, i = (i = i + Math.imul(b, st) | 0) + Math.imul(v, ot) | 0, o = o + Math.imul(v, st) | 0, n = n + Math.imul(p, ut) | 0, i = (i = i + Math.imul(p, ft) | 0) + Math.imul(g, ut) | 0, o = o + Math.imul(g, ft) | 0;
          var St = (f + (n = n + Math.imul(h, ht) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, lt) | 0) + Math.imul(l, ht) | 0)) << 13) | 0;
          f = ((o = o + Math.imul(l, lt) | 0) + (i >>> 13) | 0) + (St >>> 26) | 0, St &= 67108863, n = Math.imul(U, z), i = (i = Math.imul(U, q)) + Math.imul(D, z) | 0, o = Math.imul(D, q), n = n + Math.imul(C, Y) | 0, i = (i = i + Math.imul(C, G) | 0) + Math.imul(L, Y) | 0, o = o + Math.imul(L, G) | 0, n = n + Math.imul(O, Z) | 0, i = (i = i + Math.imul(O, V) | 0) + Math.imul(P, Z) | 0, o = o + Math.imul(P, V) | 0, n = n + Math.imul(k, J) | 0, i = (i = i + Math.imul(k, X) | 0) + Math.imul(I, J) | 0, o = o + Math.imul(I, X) | 0, n = n + Math.imul(x, Q) | 0, i = (i = i + Math.imul(x, tt) | 0) + Math.imul(R, Q) | 0, o = o + Math.imul(R, tt) | 0, n = n + Math.imul(M, rt) | 0, i = (i = i + Math.imul(M, nt) | 0) + Math.imul(S, rt) | 0, o = o + Math.imul(S, nt) | 0, n = n + Math.imul(_, ot) | 0, i = (i = i + Math.imul(_, st) | 0) + Math.imul(w, ot) | 0, o = o + Math.imul(w, st) | 0, n = n + Math.imul(b, ut) | 0, i = (i = i + Math.imul(b, ft) | 0) + Math.imul(v, ut) | 0, o = o + Math.imul(v, ft) | 0, n = n + Math.imul(p, ht) | 0, i = (i = i + Math.imul(p, lt) | 0) + Math.imul(g, ht) | 0, o = o + Math.imul(g, lt) | 0;
          var At = (f + (n = n + Math.imul(h, pt) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, gt) | 0) + Math.imul(l, pt) | 0)) << 13) | 0;
          f = ((o = o + Math.imul(l, gt) | 0) + (i >>> 13) | 0) + (At >>> 26) | 0, At &= 67108863, n = Math.imul(U, Y), i = (i = Math.imul(U, G)) + Math.imul(D, Y) | 0, o = Math.imul(D, G), n = n + Math.imul(C, Z) | 0, i = (i = i + Math.imul(C, V) | 0) + Math.imul(L, Z) | 0, o = o + Math.imul(L, V) | 0, n = n + Math.imul(O, J) | 0, i = (i = i + Math.imul(O, X) | 0) + Math.imul(P, J) | 0, o = o + Math.imul(P, X) | 0, n = n + Math.imul(k, Q) | 0, i = (i = i + Math.imul(k, tt) | 0) + Math.imul(I, Q) | 0, o = o + Math.imul(I, tt) | 0, n = n + Math.imul(x, rt) | 0, i = (i = i + Math.imul(x, nt) | 0) + Math.imul(R, rt) | 0, o = o + Math.imul(R, nt) | 0, n = n + Math.imul(M, ot) | 0, i = (i = i + Math.imul(M, st) | 0) + Math.imul(S, ot) | 0, o = o + Math.imul(S, st) | 0, n = n + Math.imul(_, ut) | 0, i = (i = i + Math.imul(_, ft) | 0) + Math.imul(w, ut) | 0, o = o + Math.imul(w, ft) | 0, n = n + Math.imul(b, ht) | 0, i = (i = i + Math.imul(b, lt) | 0) + Math.imul(v, ht) | 0, o = o + Math.imul(v, lt) | 0;
          var xt = (f + (n = n + Math.imul(p, pt) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(p, gt) | 0) + Math.imul(g, pt) | 0)) << 13) | 0;
          f = ((o = o + Math.imul(g, gt) | 0) + (i >>> 13) | 0) + (xt >>> 26) | 0, xt &= 67108863, n = Math.imul(U, Z), i = (i = Math.imul(U, V)) + Math.imul(D, Z) | 0, o = Math.imul(D, V), n = n + Math.imul(C, J) | 0, i = (i = i + Math.imul(C, X) | 0) + Math.imul(L, J) | 0, o = o + Math.imul(L, X) | 0, n = n + Math.imul(O, Q) | 0, i = (i = i + Math.imul(O, tt) | 0) + Math.imul(P, Q) | 0, o = o + Math.imul(P, tt) | 0, n = n + Math.imul(k, rt) | 0, i = (i = i + Math.imul(k, nt) | 0) + Math.imul(I, rt) | 0, o = o + Math.imul(I, nt) | 0, n = n + Math.imul(x, ot) | 0, i = (i = i + Math.imul(x, st) | 0) + Math.imul(R, ot) | 0, o = o + Math.imul(R, st) | 0, n = n + Math.imul(M, ut) | 0, i = (i = i + Math.imul(M, ft) | 0) + Math.imul(S, ut) | 0, o = o + Math.imul(S, ft) | 0, n = n + Math.imul(_, ht) | 0, i = (i = i + Math.imul(_, lt) | 0) + Math.imul(w, ht) | 0, o = o + Math.imul(w, lt) | 0;
          var Rt = (f + (n = n + Math.imul(b, pt) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(b, gt) | 0) + Math.imul(v, pt) | 0)) << 13) | 0;
          f = ((o = o + Math.imul(v, gt) | 0) + (i >>> 13) | 0) + (Rt >>> 26) | 0, Rt &= 67108863, n = Math.imul(U, J), i = (i = Math.imul(U, X)) + Math.imul(D, J) | 0, o = Math.imul(D, X), n = n + Math.imul(C, Q) | 0, i = (i = i + Math.imul(C, tt) | 0) + Math.imul(L, Q) | 0, o = o + Math.imul(L, tt) | 0, n = n + Math.imul(O, rt) | 0, i = (i = i + Math.imul(O, nt) | 0) + Math.imul(P, rt) | 0, o = o + Math.imul(P, nt) | 0, n = n + Math.imul(k, ot) | 0, i = (i = i + Math.imul(k, st) | 0) + Math.imul(I, ot) | 0, o = o + Math.imul(I, st) | 0, n = n + Math.imul(x, ut) | 0, i = (i = i + Math.imul(x, ft) | 0) + Math.imul(R, ut) | 0, o = o + Math.imul(R, ft) | 0, n = n + Math.imul(M, ht) | 0, i = (i = i + Math.imul(M, lt) | 0) + Math.imul(S, ht) | 0, o = o + Math.imul(S, lt) | 0;
          var Tt = (f + (n = n + Math.imul(_, pt) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(_, gt) | 0) + Math.imul(w, pt) | 0)) << 13) | 0;
          f = ((o = o + Math.imul(w, gt) | 0) + (i >>> 13) | 0) + (Tt >>> 26) | 0, Tt &= 67108863, n = Math.imul(U, Q), i = (i = Math.imul(U, tt)) + Math.imul(D, Q) | 0, o = Math.imul(D, tt), n = n + Math.imul(C, rt) | 0, i = (i = i + Math.imul(C, nt) | 0) + Math.imul(L, rt) | 0, o = o + Math.imul(L, nt) | 0, n = n + Math.imul(O, ot) | 0, i = (i = i + Math.imul(O, st) | 0) + Math.imul(P, ot) | 0, o = o + Math.imul(P, st) | 0, n = n + Math.imul(k, ut) | 0, i = (i = i + Math.imul(k, ft) | 0) + Math.imul(I, ut) | 0, o = o + Math.imul(I, ft) | 0, n = n + Math.imul(x, ht) | 0, i = (i = i + Math.imul(x, lt) | 0) + Math.imul(R, ht) | 0, o = o + Math.imul(R, lt) | 0;
          var kt = (f + (n = n + Math.imul(M, pt) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(M, gt) | 0) + Math.imul(S, pt) | 0)) << 13) | 0;
          f = ((o = o + Math.imul(S, gt) | 0) + (i >>> 13) | 0) + (kt >>> 26) | 0, kt &= 67108863, n = Math.imul(U, rt), i = (i = Math.imul(U, nt)) + Math.imul(D, rt) | 0, o = Math.imul(D, nt), n = n + Math.imul(C, ot) | 0, i = (i = i + Math.imul(C, st) | 0) + Math.imul(L, ot) | 0, o = o + Math.imul(L, st) | 0, n = n + Math.imul(O, ut) | 0, i = (i = i + Math.imul(O, ft) | 0) + Math.imul(P, ut) | 0, o = o + Math.imul(P, ft) | 0, n = n + Math.imul(k, ht) | 0, i = (i = i + Math.imul(k, lt) | 0) + Math.imul(I, ht) | 0, o = o + Math.imul(I, lt) | 0;
          var It = (f + (n = n + Math.imul(x, pt) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(x, gt) | 0) + Math.imul(R, pt) | 0)) << 13) | 0;
          f = ((o = o + Math.imul(R, gt) | 0) + (i >>> 13) | 0) + (It >>> 26) | 0, It &= 67108863, n = Math.imul(U, ot), i = (i = Math.imul(U, st)) + Math.imul(D, ot) | 0, o = Math.imul(D, st), n = n + Math.imul(C, ut) | 0, i = (i = i + Math.imul(C, ft) | 0) + Math.imul(L, ut) | 0, o = o + Math.imul(L, ft) | 0, n = n + Math.imul(O, ht) | 0, i = (i = i + Math.imul(O, lt) | 0) + Math.imul(P, ht) | 0, o = o + Math.imul(P, lt) | 0;
          var Bt = (f + (n = n + Math.imul(k, pt) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(k, gt) | 0) + Math.imul(I, pt) | 0)) << 13) | 0;
          f = ((o = o + Math.imul(I, gt) | 0) + (i >>> 13) | 0) + (Bt >>> 26) | 0, Bt &= 67108863, n = Math.imul(U, ut), i = (i = Math.imul(U, ft)) + Math.imul(D, ut) | 0, o = Math.imul(D, ft), n = n + Math.imul(C, ht) | 0, i = (i = i + Math.imul(C, lt) | 0) + Math.imul(L, ht) | 0, o = o + Math.imul(L, lt) | 0;
          var Ot = (f + (n = n + Math.imul(O, pt) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(O, gt) | 0) + Math.imul(P, pt) | 0)) << 13) | 0;
          f = ((o = o + Math.imul(P, gt) | 0) + (i >>> 13) | 0) + (Ot >>> 26) | 0, Ot &= 67108863, n = Math.imul(U, ht), i = (i = Math.imul(U, lt)) + Math.imul(D, ht) | 0, o = Math.imul(D, lt);
          var Pt = (f + (n = n + Math.imul(C, pt) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(C, gt) | 0) + Math.imul(L, pt) | 0)) << 13) | 0;
          f = ((o = o + Math.imul(L, gt) | 0) + (i >>> 13) | 0) + (Pt >>> 26) | 0, Pt &= 67108863;
          var Nt = (f + (n = Math.imul(U, pt)) | 0) + ((8191 & (i = (i = Math.imul(U, gt)) + Math.imul(D, pt) | 0)) << 13) | 0;
          return f = ((o = Math.imul(D, gt)) + (i >>> 13) | 0) + (Nt >>> 26) | 0, Nt &= 67108863, u[0] = mt, u[1] = bt, u[2] = vt, u[3] = yt, u[4] = _t, u[5] = wt, u[6] = Et, u[7] = Mt, u[8] = St, u[9] = At, u[10] = xt, u[11] = Rt, u[12] = Tt, u[13] = kt, u[14] = It, u[15] = Bt, u[16] = Ot, u[17] = Pt, u[18] = Nt, 0 !== f && (u[19] = f, r.length++), r;
        };

        function p(t, e, r) {
          return new g().mulp(t, e, r);
        }

        function g(t, e) {
          this.x = t, this.y = e;
        }

        Math.imul || (d = l), o.prototype.mulTo = function (t, e) {
          var r = this.length + t.length;
          return 10 === this.length && 10 === t.length ? d(this, t, e) : r < 63 ? l(this, t, e) : r < 1024 ? function (t, e, r) {
            r.negative = e.negative ^ t.negative, r.length = t.length + e.length;

            for (var n = 0, i = 0, o = 0; o < r.length - 1; o++) {
              var s = i;
              i = 0;

              for (var a = 67108863 & n, u = Math.min(o, e.length - 1), f = Math.max(0, o - t.length + 1); f <= u; f++) {
                var c = o - f,
                    h = (0 | t.words[c]) * (0 | e.words[f]),
                    l = 67108863 & h;
                a = 67108863 & (l = l + a | 0), i += (s = (s = s + (h / 67108864 | 0) | 0) + (l >>> 26) | 0) >>> 26, s &= 67108863;
              }

              r.words[o] = a, n = s, s = i;
            }

            return 0 !== n ? r.words[o] = n : r.length--, r.strip();
          }(this, t, e) : p(this, t, e);
        }, g.prototype.makeRBT = function (t) {
          for (var e = new Array(t), r = o.prototype._countBits(t) - 1, n = 0; n < t; n++) {
            e[n] = this.revBin(n, r, t);
          }

          return e;
        }, g.prototype.revBin = function (t, e, r) {
          if (0 === t || t === r - 1) return t;

          for (var n = 0, i = 0; i < e; i++) {
            n |= (1 & t) << e - i - 1, t >>= 1;
          }

          return n;
        }, g.prototype.permute = function (t, e, r, n, i, o) {
          for (var s = 0; s < o; s++) {
            n[s] = e[t[s]], i[s] = r[t[s]];
          }
        }, g.prototype.transform = function (t, e, r, n, i, o) {
          this.permute(o, t, e, r, n, i);

          for (var s = 1; s < i; s <<= 1) {
            for (var a = s << 1, u = Math.cos(2 * Math.PI / a), f = Math.sin(2 * Math.PI / a), c = 0; c < i; c += a) {
              for (var h = u, l = f, d = 0; d < s; d++) {
                var p = r[c + d],
                    g = n[c + d],
                    m = r[c + d + s],
                    b = n[c + d + s],
                    v = h * m - l * b;
                b = h * b + l * m, m = v, r[c + d] = p + m, n[c + d] = g + b, r[c + d + s] = p - m, n[c + d + s] = g - b, d !== a && (v = u * h - f * l, l = u * l + f * h, h = v);
              }
            }
          }
        }, g.prototype.guessLen13b = function (t, e) {
          var r = 1 | Math.max(e, t),
              n = 1 & r,
              i = 0;

          for (r = r / 2 | 0; r; r >>>= 1) {
            i++;
          }

          return 1 << i + 1 + n;
        }, g.prototype.conjugate = function (t, e, r) {
          if (!(r <= 1)) for (var n = 0; n < r / 2; n++) {
            var i = t[n];
            t[n] = t[r - n - 1], t[r - n - 1] = i, i = e[n], e[n] = -e[r - n - 1], e[r - n - 1] = -i;
          }
        }, g.prototype.normalize13b = function (t, e) {
          for (var r = 0, n = 0; n < e / 2; n++) {
            var i = 8192 * Math.round(t[2 * n + 1] / e) + Math.round(t[2 * n] / e) + r;
            t[n] = 67108863 & i, r = i < 67108864 ? 0 : i / 67108864 | 0;
          }

          return t;
        }, g.prototype.convert13b = function (t, e, r, i) {
          for (var o = 0, s = 0; s < e; s++) {
            o += 0 | t[s], r[2 * s] = 8191 & o, o >>>= 13, r[2 * s + 1] = 8191 & o, o >>>= 13;
          }

          for (s = 2 * e; s < i; ++s) {
            r[s] = 0;
          }

          n(0 === o), n(0 == (-8192 & o));
        }, g.prototype.stub = function (t) {
          for (var e = new Array(t), r = 0; r < t; r++) {
            e[r] = 0;
          }

          return e;
        }, g.prototype.mulp = function (t, e, r) {
          var n = 2 * this.guessLen13b(t.length, e.length),
              i = this.makeRBT(n),
              o = this.stub(n),
              s = new Array(n),
              a = new Array(n),
              u = new Array(n),
              f = new Array(n),
              c = new Array(n),
              h = new Array(n),
              l = r.words;
          l.length = n, this.convert13b(t.words, t.length, s, n), this.convert13b(e.words, e.length, f, n), this.transform(s, o, a, u, n, i), this.transform(f, o, c, h, n, i);

          for (var d = 0; d < n; d++) {
            var p = a[d] * c[d] - u[d] * h[d];
            u[d] = a[d] * h[d] + u[d] * c[d], a[d] = p;
          }

          return this.conjugate(a, u, n), this.transform(a, u, l, o, n, i), this.conjugate(l, o, n), this.normalize13b(l, n), r.negative = t.negative ^ e.negative, r.length = t.length + e.length, r.strip();
        }, o.prototype.mul = function (t) {
          var e = new o(null);
          return e.words = new Array(this.length + t.length), this.mulTo(t, e);
        }, o.prototype.mulf = function (t) {
          var e = new o(null);
          return e.words = new Array(this.length + t.length), p(this, t, e);
        }, o.prototype.imul = function (t) {
          return this.clone().mulTo(t, this);
        }, o.prototype.imuln = function (t) {
          n("number" == typeof t), n(t < 67108864);

          for (var e = 0, r = 0; r < this.length; r++) {
            var i = (0 | this.words[r]) * t,
                o = (67108863 & i) + (67108863 & e);
            e >>= 26, e += i / 67108864 | 0, e += o >>> 26, this.words[r] = 67108863 & o;
          }

          return 0 !== e && (this.words[r] = e, this.length++), this;
        }, o.prototype.muln = function (t) {
          return this.clone().imuln(t);
        }, o.prototype.sqr = function () {
          return this.mul(this);
        }, o.prototype.isqr = function () {
          return this.imul(this.clone());
        }, o.prototype.pow = function (t) {
          var e = function (t) {
            for (var e = new Array(t.bitLength()), r = 0; r < e.length; r++) {
              var n = r / 26 | 0,
                  i = r % 26;
              e[r] = (t.words[n] & 1 << i) >>> i;
            }

            return e;
          }(t);

          if (0 === e.length) return new o(1);

          for (var r = this, n = 0; n < e.length && 0 === e[n]; n++, r = r.sqr()) {
            ;
          }

          if (++n < e.length) for (var i = r.sqr(); n < e.length; n++, i = i.sqr()) {
            0 !== e[n] && (r = r.mul(i));
          }
          return r;
        }, o.prototype.iushln = function (t) {
          n("number" == typeof t && t >= 0);
          var e,
              r = t % 26,
              i = (t - r) / 26,
              o = 67108863 >>> 26 - r << 26 - r;

          if (0 !== r) {
            var s = 0;

            for (e = 0; e < this.length; e++) {
              var a = this.words[e] & o,
                  u = (0 | this.words[e]) - a << r;
              this.words[e] = u | s, s = a >>> 26 - r;
            }

            s && (this.words[e] = s, this.length++);
          }

          if (0 !== i) {
            for (e = this.length - 1; e >= 0; e--) {
              this.words[e + i] = this.words[e];
            }

            for (e = 0; e < i; e++) {
              this.words[e] = 0;
            }

            this.length += i;
          }

          return this.strip();
        }, o.prototype.ishln = function (t) {
          return n(0 === this.negative), this.iushln(t);
        }, o.prototype.iushrn = function (t, e, r) {
          var i;
          n("number" == typeof t && t >= 0), i = e ? (e - e % 26) / 26 : 0;
          var o = t % 26,
              s = Math.min((t - o) / 26, this.length),
              a = 67108863 ^ 67108863 >>> o << o,
              u = r;

          if (i -= s, i = Math.max(0, i), u) {
            for (var f = 0; f < s; f++) {
              u.words[f] = this.words[f];
            }

            u.length = s;
          }

          if (0 === s) ;else if (this.length > s) for (this.length -= s, f = 0; f < this.length; f++) {
            this.words[f] = this.words[f + s];
          } else this.words[0] = 0, this.length = 1;
          var c = 0;

          for (f = this.length - 1; f >= 0 && (0 !== c || f >= i); f--) {
            var h = 0 | this.words[f];
            this.words[f] = c << 26 - o | h >>> o, c = h & a;
          }

          return u && 0 !== c && (u.words[u.length++] = c), 0 === this.length && (this.words[0] = 0, this.length = 1), this.strip();
        }, o.prototype.ishrn = function (t, e, r) {
          return n(0 === this.negative), this.iushrn(t, e, r);
        }, o.prototype.shln = function (t) {
          return this.clone().ishln(t);
        }, o.prototype.ushln = function (t) {
          return this.clone().iushln(t);
        }, o.prototype.shrn = function (t) {
          return this.clone().ishrn(t);
        }, o.prototype.ushrn = function (t) {
          return this.clone().iushrn(t);
        }, o.prototype.testn = function (t) {
          n("number" == typeof t && t >= 0);
          var e = t % 26,
              r = (t - e) / 26,
              i = 1 << e;
          return !(this.length <= r) && !!(this.words[r] & i);
        }, o.prototype.imaskn = function (t) {
          n("number" == typeof t && t >= 0);
          var e = t % 26,
              r = (t - e) / 26;
          if (n(0 === this.negative, "imaskn works only with positive numbers"), this.length <= r) return this;

          if (0 !== e && r++, this.length = Math.min(r, this.length), 0 !== e) {
            var i = 67108863 ^ 67108863 >>> e << e;
            this.words[this.length - 1] &= i;
          }

          return this.strip();
        }, o.prototype.maskn = function (t) {
          return this.clone().imaskn(t);
        }, o.prototype.iaddn = function (t) {
          return n("number" == typeof t), n(t < 67108864), t < 0 ? this.isubn(-t) : 0 !== this.negative ? 1 === this.length && (0 | this.words[0]) < t ? (this.words[0] = t - (0 | this.words[0]), this.negative = 0, this) : (this.negative = 0, this.isubn(t), this.negative = 1, this) : this._iaddn(t);
        }, o.prototype._iaddn = function (t) {
          this.words[0] += t;

          for (var e = 0; e < this.length && this.words[e] >= 67108864; e++) {
            this.words[e] -= 67108864, e === this.length - 1 ? this.words[e + 1] = 1 : this.words[e + 1]++;
          }

          return this.length = Math.max(this.length, e + 1), this;
        }, o.prototype.isubn = function (t) {
          if (n("number" == typeof t), n(t < 67108864), t < 0) return this.iaddn(-t);
          if (0 !== this.negative) return this.negative = 0, this.iaddn(t), this.negative = 1, this;
          if (this.words[0] -= t, 1 === this.length && this.words[0] < 0) this.words[0] = -this.words[0], this.negative = 1;else for (var e = 0; e < this.length && this.words[e] < 0; e++) {
            this.words[e] += 67108864, this.words[e + 1] -= 1;
          }
          return this.strip();
        }, o.prototype.addn = function (t) {
          return this.clone().iaddn(t);
        }, o.prototype.subn = function (t) {
          return this.clone().isubn(t);
        }, o.prototype.iabs = function () {
          return this.negative = 0, this;
        }, o.prototype.abs = function () {
          return this.clone().iabs();
        }, o.prototype._ishlnsubmul = function (t, e, r) {
          var i,
              o,
              s = t.length + r;

          this._expand(s);

          var a = 0;

          for (i = 0; i < t.length; i++) {
            o = (0 | this.words[i + r]) + a;
            var u = (0 | t.words[i]) * e;
            a = ((o -= 67108863 & u) >> 26) - (u / 67108864 | 0), this.words[i + r] = 67108863 & o;
          }

          for (; i < this.length - r; i++) {
            a = (o = (0 | this.words[i + r]) + a) >> 26, this.words[i + r] = 67108863 & o;
          }

          if (0 === a) return this.strip();

          for (n(-1 === a), a = 0, i = 0; i < this.length; i++) {
            a = (o = -(0 | this.words[i]) + a) >> 26, this.words[i] = 67108863 & o;
          }

          return this.negative = 1, this.strip();
        }, o.prototype._wordDiv = function (t, e) {
          var r = (this.length, t.length),
              n = this.clone(),
              i = t,
              s = 0 | i.words[i.length - 1];
          0 !== (r = 26 - this._countBits(s)) && (i = i.ushln(r), n.iushln(r), s = 0 | i.words[i.length - 1]);
          var a,
              u = n.length - i.length;

          if ("mod" !== e) {
            (a = new o(null)).length = u + 1, a.words = new Array(a.length);

            for (var f = 0; f < a.length; f++) {
              a.words[f] = 0;
            }
          }

          var c = n.clone()._ishlnsubmul(i, 1, u);

          0 === c.negative && (n = c, a && (a.words[u] = 1));

          for (var h = u - 1; h >= 0; h--) {
            var l = 67108864 * (0 | n.words[i.length + h]) + (0 | n.words[i.length + h - 1]);

            for (l = Math.min(l / s | 0, 67108863), n._ishlnsubmul(i, l, h); 0 !== n.negative;) {
              l--, n.negative = 0, n._ishlnsubmul(i, 1, h), n.isZero() || (n.negative ^= 1);
            }

            a && (a.words[h] = l);
          }

          return a && a.strip(), n.strip(), "div" !== e && 0 !== r && n.iushrn(r), {
            div: a || null,
            mod: n
          };
        }, o.prototype.divmod = function (t, e, r) {
          return n(!t.isZero()), this.isZero() ? {
            div: new o(0),
            mod: new o(0)
          } : 0 !== this.negative && 0 === t.negative ? (a = this.neg().divmod(t, e), "mod" !== e && (i = a.div.neg()), "div" !== e && (s = a.mod.neg(), r && 0 !== s.negative && s.iadd(t)), {
            div: i,
            mod: s
          }) : 0 === this.negative && 0 !== t.negative ? (a = this.divmod(t.neg(), e), "mod" !== e && (i = a.div.neg()), {
            div: i,
            mod: a.mod
          }) : 0 != (this.negative & t.negative) ? (a = this.neg().divmod(t.neg(), e), "div" !== e && (s = a.mod.neg(), r && 0 !== s.negative && s.isub(t)), {
            div: a.div,
            mod: s
          }) : t.length > this.length || this.cmp(t) < 0 ? {
            div: new o(0),
            mod: this
          } : 1 === t.length ? "div" === e ? {
            div: this.divn(t.words[0]),
            mod: null
          } : "mod" === e ? {
            div: null,
            mod: new o(this.modn(t.words[0]))
          } : {
            div: this.divn(t.words[0]),
            mod: new o(this.modn(t.words[0]))
          } : this._wordDiv(t, e);
          var i, s, a;
        }, o.prototype.div = function (t) {
          return this.divmod(t, "div", !1).div;
        }, o.prototype.mod = function (t) {
          return this.divmod(t, "mod", !1).mod;
        }, o.prototype.umod = function (t) {
          return this.divmod(t, "mod", !0).mod;
        }, o.prototype.divRound = function (t) {
          var e = this.divmod(t);
          if (e.mod.isZero()) return e.div;
          var r = 0 !== e.div.negative ? e.mod.isub(t) : e.mod,
              n = t.ushrn(1),
              i = t.andln(1),
              o = r.cmp(n);
          return o < 0 || 1 === i && 0 === o ? e.div : 0 !== e.div.negative ? e.div.isubn(1) : e.div.iaddn(1);
        }, o.prototype.modn = function (t) {
          n(t <= 67108863);

          for (var e = (1 << 26) % t, r = 0, i = this.length - 1; i >= 0; i--) {
            r = (e * r + (0 | this.words[i])) % t;
          }

          return r;
        }, o.prototype.idivn = function (t) {
          n(t <= 67108863);

          for (var e = 0, r = this.length - 1; r >= 0; r--) {
            var i = (0 | this.words[r]) + 67108864 * e;
            this.words[r] = i / t | 0, e = i % t;
          }

          return this.strip();
        }, o.prototype.divn = function (t) {
          return this.clone().idivn(t);
        }, o.prototype.egcd = function (t) {
          n(0 === t.negative), n(!t.isZero());
          var e = this,
              r = t.clone();
          e = 0 !== e.negative ? e.umod(t) : e.clone();

          for (var i = new o(1), s = new o(0), a = new o(0), u = new o(1), f = 0; e.isEven() && r.isEven();) {
            e.iushrn(1), r.iushrn(1), ++f;
          }

          for (var c = r.clone(), h = e.clone(); !e.isZero();) {
            for (var l = 0, d = 1; 0 == (e.words[0] & d) && l < 26; ++l, d <<= 1) {
              ;
            }

            if (l > 0) for (e.iushrn(l); l-- > 0;) {
              (i.isOdd() || s.isOdd()) && (i.iadd(c), s.isub(h)), i.iushrn(1), s.iushrn(1);
            }

            for (var p = 0, g = 1; 0 == (r.words[0] & g) && p < 26; ++p, g <<= 1) {
              ;
            }

            if (p > 0) for (r.iushrn(p); p-- > 0;) {
              (a.isOdd() || u.isOdd()) && (a.iadd(c), u.isub(h)), a.iushrn(1), u.iushrn(1);
            }
            e.cmp(r) >= 0 ? (e.isub(r), i.isub(a), s.isub(u)) : (r.isub(e), a.isub(i), u.isub(s));
          }

          return {
            a: a,
            b: u,
            gcd: r.iushln(f)
          };
        }, o.prototype._invmp = function (t) {
          n(0 === t.negative), n(!t.isZero());
          var e = this,
              r = t.clone();
          e = 0 !== e.negative ? e.umod(t) : e.clone();

          for (var i, s = new o(1), a = new o(0), u = r.clone(); e.cmpn(1) > 0 && r.cmpn(1) > 0;) {
            for (var f = 0, c = 1; 0 == (e.words[0] & c) && f < 26; ++f, c <<= 1) {
              ;
            }

            if (f > 0) for (e.iushrn(f); f-- > 0;) {
              s.isOdd() && s.iadd(u), s.iushrn(1);
            }

            for (var h = 0, l = 1; 0 == (r.words[0] & l) && h < 26; ++h, l <<= 1) {
              ;
            }

            if (h > 0) for (r.iushrn(h); h-- > 0;) {
              a.isOdd() && a.iadd(u), a.iushrn(1);
            }
            e.cmp(r) >= 0 ? (e.isub(r), s.isub(a)) : (r.isub(e), a.isub(s));
          }

          return (i = 0 === e.cmpn(1) ? s : a).cmpn(0) < 0 && i.iadd(t), i;
        }, o.prototype.gcd = function (t) {
          if (this.isZero()) return t.abs();
          if (t.isZero()) return this.abs();
          var e = this.clone(),
              r = t.clone();
          e.negative = 0, r.negative = 0;

          for (var n = 0; e.isEven() && r.isEven(); n++) {
            e.iushrn(1), r.iushrn(1);
          }

          for (;;) {
            for (; e.isEven();) {
              e.iushrn(1);
            }

            for (; r.isEven();) {
              r.iushrn(1);
            }

            var i = e.cmp(r);

            if (i < 0) {
              var o = e;
              e = r, r = o;
            } else if (0 === i || 0 === r.cmpn(1)) break;

            e.isub(r);
          }

          return r.iushln(n);
        }, o.prototype.invm = function (t) {
          return this.egcd(t).a.umod(t);
        }, o.prototype.isEven = function () {
          return 0 == (1 & this.words[0]);
        }, o.prototype.isOdd = function () {
          return 1 == (1 & this.words[0]);
        }, o.prototype.andln = function (t) {
          return this.words[0] & t;
        }, o.prototype.bincn = function (t) {
          n("number" == typeof t);
          var e = t % 26,
              r = (t - e) / 26,
              i = 1 << e;
          if (this.length <= r) return this._expand(r + 1), this.words[r] |= i, this;

          for (var o = i, s = r; 0 !== o && s < this.length; s++) {
            var a = 0 | this.words[s];
            o = (a += o) >>> 26, a &= 67108863, this.words[s] = a;
          }

          return 0 !== o && (this.words[s] = o, this.length++), this;
        }, o.prototype.isZero = function () {
          return 1 === this.length && 0 === this.words[0];
        }, o.prototype.cmpn = function (t) {
          var e,
              r = t < 0;
          if (0 !== this.negative && !r) return -1;
          if (0 === this.negative && r) return 1;
          if (this.strip(), this.length > 1) e = 1;else {
            r && (t = -t), n(t <= 67108863, "Number is too big");
            var i = 0 | this.words[0];
            e = i === t ? 0 : i < t ? -1 : 1;
          }
          return 0 !== this.negative ? 0 | -e : e;
        }, o.prototype.cmp = function (t) {
          if (0 !== this.negative && 0 === t.negative) return -1;
          if (0 === this.negative && 0 !== t.negative) return 1;
          var e = this.ucmp(t);
          return 0 !== this.negative ? 0 | -e : e;
        }, o.prototype.ucmp = function (t) {
          if (this.length > t.length) return 1;
          if (this.length < t.length) return -1;

          for (var e = 0, r = this.length - 1; r >= 0; r--) {
            var n = 0 | this.words[r],
                i = 0 | t.words[r];

            if (n !== i) {
              n < i ? e = -1 : n > i && (e = 1);
              break;
            }
          }

          return e;
        }, o.prototype.gtn = function (t) {
          return 1 === this.cmpn(t);
        }, o.prototype.gt = function (t) {
          return 1 === this.cmp(t);
        }, o.prototype.gten = function (t) {
          return this.cmpn(t) >= 0;
        }, o.prototype.gte = function (t) {
          return this.cmp(t) >= 0;
        }, o.prototype.ltn = function (t) {
          return -1 === this.cmpn(t);
        }, o.prototype.lt = function (t) {
          return -1 === this.cmp(t);
        }, o.prototype.lten = function (t) {
          return this.cmpn(t) <= 0;
        }, o.prototype.lte = function (t) {
          return this.cmp(t) <= 0;
        }, o.prototype.eqn = function (t) {
          return 0 === this.cmpn(t);
        }, o.prototype.eq = function (t) {
          return 0 === this.cmp(t);
        }, o.red = function (t) {
          return new E(t);
        }, o.prototype.toRed = function (t) {
          return n(!this.red, "Already a number in reduction context"), n(0 === this.negative, "red works only with positives"), t.convertTo(this)._forceRed(t);
        }, o.prototype.fromRed = function () {
          return n(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
        }, o.prototype._forceRed = function (t) {
          return this.red = t, this;
        }, o.prototype.forceRed = function (t) {
          return n(!this.red, "Already a number in reduction context"), this._forceRed(t);
        }, o.prototype.redAdd = function (t) {
          return n(this.red, "redAdd works only with red numbers"), this.red.add(this, t);
        }, o.prototype.redIAdd = function (t) {
          return n(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, t);
        }, o.prototype.redSub = function (t) {
          return n(this.red, "redSub works only with red numbers"), this.red.sub(this, t);
        }, o.prototype.redISub = function (t) {
          return n(this.red, "redISub works only with red numbers"), this.red.isub(this, t);
        }, o.prototype.redShl = function (t) {
          return n(this.red, "redShl works only with red numbers"), this.red.shl(this, t);
        }, o.prototype.redMul = function (t) {
          return n(this.red, "redMul works only with red numbers"), this.red._verify2(this, t), this.red.mul(this, t);
        }, o.prototype.redIMul = function (t) {
          return n(this.red, "redMul works only with red numbers"), this.red._verify2(this, t), this.red.imul(this, t);
        }, o.prototype.redSqr = function () {
          return n(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
        }, o.prototype.redISqr = function () {
          return n(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
        }, o.prototype.redSqrt = function () {
          return n(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
        }, o.prototype.redInvm = function () {
          return n(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
        }, o.prototype.redNeg = function () {
          return n(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
        }, o.prototype.redPow = function (t) {
          return n(this.red && !t.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, t);
        };
        var m = {
          k256: null,
          p224: null,
          p192: null,
          p25519: null
        };

        function b(t, e) {
          this.name = t, this.p = new o(e, 16), this.n = this.p.bitLength(), this.k = new o(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
        }

        function v() {
          b.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
        }

        function y() {
          b.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
        }

        function _() {
          b.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
        }

        function w() {
          b.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
        }

        function E(t) {
          if ("string" == typeof t) {
            var e = o._prime(t);

            this.m = e.p, this.prime = e;
          } else n(t.gtn(1), "modulus must be greater than 1"), this.m = t, this.prime = null;
        }

        function M(t) {
          E.call(this, t), this.shift = this.m.bitLength(), this.shift % 26 != 0 && (this.shift += 26 - this.shift % 26), this.r = new o(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
        }

        b.prototype._tmp = function () {
          var t = new o(null);
          return t.words = new Array(Math.ceil(this.n / 13)), t;
        }, b.prototype.ireduce = function (t) {
          var e,
              r = t;

          do {
            this.split(r, this.tmp), e = (r = (r = this.imulK(r)).iadd(this.tmp)).bitLength();
          } while (e > this.n);

          var n = e < this.n ? -1 : r.ucmp(this.p);
          return 0 === n ? (r.words[0] = 0, r.length = 1) : n > 0 ? r.isub(this.p) : r.strip(), r;
        }, b.prototype.split = function (t, e) {
          t.iushrn(this.n, 0, e);
        }, b.prototype.imulK = function (t) {
          return t.imul(this.k);
        }, i(v, b), v.prototype.split = function (t, e) {
          for (var r = Math.min(t.length, 9), n = 0; n < r; n++) {
            e.words[n] = t.words[n];
          }

          if (e.length = r, t.length <= 9) return t.words[0] = 0, void (t.length = 1);
          var i = t.words[9];

          for (e.words[e.length++] = 4194303 & i, n = 10; n < t.length; n++) {
            var o = 0 | t.words[n];
            t.words[n - 10] = (4194303 & o) << 4 | i >>> 22, i = o;
          }

          i >>>= 22, t.words[n - 10] = i, 0 === i && t.length > 10 ? t.length -= 10 : t.length -= 9;
        }, v.prototype.imulK = function (t) {
          t.words[t.length] = 0, t.words[t.length + 1] = 0, t.length += 2;

          for (var e = 0, r = 0; r < t.length; r++) {
            var n = 0 | t.words[r];
            e += 977 * n, t.words[r] = 67108863 & e, e = 64 * n + (e / 67108864 | 0);
          }

          return 0 === t.words[t.length - 1] && (t.length--, 0 === t.words[t.length - 1] && t.length--), t;
        }, i(y, b), i(_, b), i(w, b), w.prototype.imulK = function (t) {
          for (var e = 0, r = 0; r < t.length; r++) {
            var n = 19 * (0 | t.words[r]) + e,
                i = 67108863 & n;
            n >>>= 26, t.words[r] = i, e = n;
          }

          return 0 !== e && (t.words[t.length++] = e), t;
        }, o._prime = function (t) {
          if (m[t]) return m[t];
          var e;
          if ("k256" === t) e = new v();else if ("p224" === t) e = new y();else if ("p192" === t) e = new _();else {
            if ("p25519" !== t) throw new Error("Unknown prime " + t);
            e = new w();
          }
          return m[t] = e, e;
        }, E.prototype._verify1 = function (t) {
          n(0 === t.negative, "red works only with positives"), n(t.red, "red works only with red numbers");
        }, E.prototype._verify2 = function (t, e) {
          n(0 == (t.negative | e.negative), "red works only with positives"), n(t.red && t.red === e.red, "red works only with red numbers");
        }, E.prototype.imod = function (t) {
          return this.prime ? this.prime.ireduce(t)._forceRed(this) : t.umod(this.m)._forceRed(this);
        }, E.prototype.neg = function (t) {
          return t.isZero() ? t.clone() : this.m.sub(t)._forceRed(this);
        }, E.prototype.add = function (t, e) {
          this._verify2(t, e);

          var r = t.add(e);
          return r.cmp(this.m) >= 0 && r.isub(this.m), r._forceRed(this);
        }, E.prototype.iadd = function (t, e) {
          this._verify2(t, e);

          var r = t.iadd(e);
          return r.cmp(this.m) >= 0 && r.isub(this.m), r;
        }, E.prototype.sub = function (t, e) {
          this._verify2(t, e);

          var r = t.sub(e);
          return r.cmpn(0) < 0 && r.iadd(this.m), r._forceRed(this);
        }, E.prototype.isub = function (t, e) {
          this._verify2(t, e);

          var r = t.isub(e);
          return r.cmpn(0) < 0 && r.iadd(this.m), r;
        }, E.prototype.shl = function (t, e) {
          return this._verify1(t), this.imod(t.ushln(e));
        }, E.prototype.imul = function (t, e) {
          return this._verify2(t, e), this.imod(t.imul(e));
        }, E.prototype.mul = function (t, e) {
          return this._verify2(t, e), this.imod(t.mul(e));
        }, E.prototype.isqr = function (t) {
          return this.imul(t, t.clone());
        }, E.prototype.sqr = function (t) {
          return this.mul(t, t);
        }, E.prototype.sqrt = function (t) {
          if (t.isZero()) return t.clone();
          var e = this.m.andln(3);

          if (n(e % 2 == 1), 3 === e) {
            var r = this.m.add(new o(1)).iushrn(2);
            return this.pow(t, r);
          }

          for (var i = this.m.subn(1), s = 0; !i.isZero() && 0 === i.andln(1);) {
            s++, i.iushrn(1);
          }

          n(!i.isZero());
          var a = new o(1).toRed(this),
              u = a.redNeg(),
              f = this.m.subn(1).iushrn(1),
              c = this.m.bitLength();

          for (c = new o(2 * c * c).toRed(this); 0 !== this.pow(c, f).cmp(u);) {
            c.redIAdd(u);
          }

          for (var h = this.pow(c, i), l = this.pow(t, i.addn(1).iushrn(1)), d = this.pow(t, i), p = s; 0 !== d.cmp(a);) {
            for (var g = d, m = 0; 0 !== g.cmp(a); m++) {
              g = g.redSqr();
            }

            n(m < p);
            var b = this.pow(h, new o(1).iushln(p - m - 1));
            l = l.redMul(b), h = b.redSqr(), d = d.redMul(h), p = m;
          }

          return l;
        }, E.prototype.invm = function (t) {
          var e = t._invmp(this.m);

          return 0 !== e.negative ? (e.negative = 0, this.imod(e).redNeg()) : this.imod(e);
        }, E.prototype.pow = function (t, e) {
          if (e.isZero()) return new o(1).toRed(this);
          if (0 === e.cmpn(1)) return t.clone();
          var r = new Array(16);
          r[0] = new o(1).toRed(this), r[1] = t;

          for (var n = 2; n < r.length; n++) {
            r[n] = this.mul(r[n - 1], t);
          }

          var i = r[0],
              s = 0,
              a = 0,
              u = e.bitLength() % 26;

          for (0 === u && (u = 26), n = e.length - 1; n >= 0; n--) {
            for (var f = e.words[n], c = u - 1; c >= 0; c--) {
              var h = f >> c & 1;
              i !== r[0] && (i = this.sqr(i)), 0 !== h || 0 !== s ? (s <<= 1, s |= h, (4 === ++a || 0 === n && 0 === c) && (i = this.mul(i, r[s]), a = 0, s = 0)) : a = 0;
            }

            u = 26;
          }

          return i;
        }, E.prototype.convertTo = function (t) {
          var e = t.umod(this.m);
          return e === t ? e.clone() : e;
        }, E.prototype.convertFrom = function (t) {
          var e = t.clone();
          return e.red = null, e;
        }, o.mont = function (t) {
          return new M(t);
        }, i(M, E), M.prototype.convertTo = function (t) {
          return this.imod(t.ushln(this.shift));
        }, M.prototype.convertFrom = function (t) {
          var e = this.imod(t.mul(this.rinv));
          return e.red = null, e;
        }, M.prototype.imul = function (t, e) {
          if (t.isZero() || e.isZero()) return t.words[0] = 0, t.length = 1, t;
          var r = t.imul(e),
              n = r.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m),
              i = r.isub(n).iushrn(this.shift),
              o = i;
          return i.cmp(this.m) >= 0 ? o = i.isub(this.m) : i.cmpn(0) < 0 && (o = i.iadd(this.m)), o._forceRed(this);
        }, M.prototype.mul = function (t, e) {
          if (t.isZero() || e.isZero()) return new o(0)._forceRed(this);
          var r = t.mul(e),
              n = r.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m),
              i = r.isub(n).iushrn(this.shift),
              s = i;
          return i.cmp(this.m) >= 0 ? s = i.isub(this.m) : i.cmpn(0) < 0 && (s = i.iadd(this.m)), s._forceRed(this);
        }, M.prototype.invm = function (t) {
          return this.imod(t._invmp(this.m).mul(this.r2))._forceRed(this);
        };
      }(t, this);
    }).call(this, r(19)(t));
  }, function (t, e) {
    var r;

    r = function () {
      return this;
    }();

    try {
      r = r || new Function("return this")();
    } catch (t) {
      "object" == typeof window && (r = window);
    }

    t.exports = r;
  }, function (t, e, r) {
    "use strict";

    var n = e,
        i = r(3),
        o = r(11),
        s = r(63);
    n.assert = o, n.toArray = s.toArray, n.zero2 = s.zero2, n.toHex = s.toHex, n.encode = s.encode, n.getNAF = function (t, e, r) {
      var n = new Array(Math.max(t.bitLength(), r) + 1);
      n.fill(0);

      for (var i = 1 << e + 1, o = t.clone(), s = 0; s < n.length; s++) {
        var a,
            u = o.andln(i - 1);
        o.isOdd() ? (a = u > (i >> 1) - 1 ? (i >> 1) - u : u, o.isubn(a)) : a = 0, n[s] = a, o.iushrn(1);
      }

      return n;
    }, n.getJSF = function (t, e) {
      var r = [[], []];
      t = t.clone(), e = e.clone();

      for (var n = 0, i = 0; t.cmpn(-n) > 0 || e.cmpn(-i) > 0;) {
        var o,
            s,
            a,
            u = t.andln(3) + n & 3,
            f = e.andln(3) + i & 3;
        if (3 === u && (u = -1), 3 === f && (f = -1), 0 == (1 & u)) o = 0;else o = 3 !== (a = t.andln(7) + n & 7) && 5 !== a || 2 !== f ? u : -u;
        if (r[0].push(o), 0 == (1 & f)) s = 0;else s = 3 !== (a = e.andln(7) + i & 7) && 5 !== a || 2 !== u ? f : -f;
        r[1].push(s), 2 * n === o + 1 && (n = 1 - n), 2 * i === s + 1 && (i = 1 - i), t.iushrn(1), e.iushrn(1);
      }

      return r;
    }, n.cachedProperty = function (t, e, r) {
      var n = "_" + e;

      t.prototype[e] = function () {
        return void 0 !== this[n] ? this[n] : this[n] = r.call(this);
      };
    }, n.parseBytes = function (t) {
      return "string" == typeof t ? n.toArray(t, "hex") : t;
    }, n.intFromLE = function (t) {
      return new i(t, "hex", "le");
    };
  }, function (t, e) {
    var r,
        n,
        i = t.exports = {};

    function o() {
      throw new Error("setTimeout has not been defined");
    }

    function s() {
      throw new Error("clearTimeout has not been defined");
    }

    function a(t) {
      if (r === setTimeout) return setTimeout(t, 0);
      if ((r === o || !r) && setTimeout) return r = setTimeout, setTimeout(t, 0);

      try {
        return r(t, 0);
      } catch (e) {
        try {
          return r.call(null, t, 0);
        } catch (e) {
          return r.call(this, t, 0);
        }
      }
    }

    !function () {
      try {
        r = "function" == typeof setTimeout ? setTimeout : o;
      } catch (t) {
        r = o;
      }

      try {
        n = "function" == typeof clearTimeout ? clearTimeout : s;
      } catch (t) {
        n = s;
      }
    }();
    var u,
        f = [],
        c = !1,
        h = -1;

    function l() {
      c && u && (c = !1, u.length ? f = u.concat(f) : h = -1, f.length && d());
    }

    function d() {
      if (!c) {
        var t = a(l);
        c = !0;

        for (var e = f.length; e;) {
          for (u = f, f = []; ++h < e;) {
            u && u[h].run();
          }

          h = -1, e = f.length;
        }

        u = null, c = !1, function (t) {
          if (n === clearTimeout) return clearTimeout(t);
          if ((n === s || !n) && clearTimeout) return n = clearTimeout, clearTimeout(t);

          try {
            n(t);
          } catch (e) {
            try {
              return n.call(null, t);
            } catch (e) {
              return n.call(this, t);
            }
          }
        }(t);
      }
    }

    function p(t, e) {
      this.fun = t, this.array = e;
    }

    function g() {}

    i.nextTick = function (t) {
      var e = new Array(arguments.length - 1);
      if (arguments.length > 1) for (var r = 1; r < arguments.length; r++) {
        e[r - 1] = arguments[r];
      }
      f.push(new p(t, e)), 1 !== f.length || c || a(d);
    }, p.prototype.run = function () {
      this.fun.apply(null, this.array);
    }, i.title = "browser", i.browser = !0, i.env = {}, i.argv = [], i.version = "", i.versions = {}, i.on = g, i.addListener = g, i.once = g, i.off = g, i.removeListener = g, i.removeAllListeners = g, i.emit = g, i.prependListener = g, i.prependOnceListener = g, i.listeners = function (t) {
      return [];
    }, i.binding = function (t) {
      throw new Error("process.binding is not supported");
    }, i.cwd = function () {
      return "/";
    }, i.chdir = function (t) {
      throw new Error("process.chdir is not supported");
    }, i.umask = function () {
      return 0;
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(11),
        i = r(0);

    function o(t) {
      return (t >>> 24 | t >>> 8 & 65280 | t << 8 & 16711680 | (255 & t) << 24) >>> 0;
    }

    function s(t) {
      return 1 === t.length ? "0" + t : t;
    }

    function a(t) {
      return 7 === t.length ? "0" + t : 6 === t.length ? "00" + t : 5 === t.length ? "000" + t : 4 === t.length ? "0000" + t : 3 === t.length ? "00000" + t : 2 === t.length ? "000000" + t : 1 === t.length ? "0000000" + t : t;
    }

    e.inherits = i, e.toArray = function (t, e) {
      if (Array.isArray(t)) return t.slice();
      if (!t) return [];
      var r = [];
      if ("string" == typeof t) {
        if (e) {
          if ("hex" === e) for ((t = t.replace(/[^a-z0-9]+/gi, "")).length % 2 != 0 && (t = "0" + t), n = 0; n < t.length; n += 2) {
            r.push(parseInt(t[n] + t[n + 1], 16));
          }
        } else for (var n = 0; n < t.length; n++) {
          var i = t.charCodeAt(n),
              o = i >> 8,
              s = 255 & i;
          o ? r.push(o, s) : r.push(s);
        }
      } else for (n = 0; n < t.length; n++) {
        r[n] = 0 | t[n];
      }
      return r;
    }, e.toHex = function (t) {
      for (var e = "", r = 0; r < t.length; r++) {
        e += s(t[r].toString(16));
      }

      return e;
    }, e.htonl = o, e.toHex32 = function (t, e) {
      for (var r = "", n = 0; n < t.length; n++) {
        var i = t[n];
        "little" === e && (i = o(i)), r += a(i.toString(16));
      }

      return r;
    }, e.zero2 = s, e.zero8 = a, e.join32 = function (t, e, r, i) {
      var o = r - e;
      n(o % 4 == 0);

      for (var s = new Array(o / 4), a = 0, u = e; a < s.length; a++, u += 4) {
        var f;
        f = "big" === i ? t[u] << 24 | t[u + 1] << 16 | t[u + 2] << 8 | t[u + 3] : t[u + 3] << 24 | t[u + 2] << 16 | t[u + 1] << 8 | t[u], s[a] = f >>> 0;
      }

      return s;
    }, e.split32 = function (t, e) {
      for (var r = new Array(4 * t.length), n = 0, i = 0; n < t.length; n++, i += 4) {
        var o = t[n];
        "big" === e ? (r[i] = o >>> 24, r[i + 1] = o >>> 16 & 255, r[i + 2] = o >>> 8 & 255, r[i + 3] = 255 & o) : (r[i + 3] = o >>> 24, r[i + 2] = o >>> 16 & 255, r[i + 1] = o >>> 8 & 255, r[i] = 255 & o);
      }

      return r;
    }, e.rotr32 = function (t, e) {
      return t >>> e | t << 32 - e;
    }, e.rotl32 = function (t, e) {
      return t << e | t >>> 32 - e;
    }, e.sum32 = function (t, e) {
      return t + e >>> 0;
    }, e.sum32_3 = function (t, e, r) {
      return t + e + r >>> 0;
    }, e.sum32_4 = function (t, e, r, n) {
      return t + e + r + n >>> 0;
    }, e.sum32_5 = function (t, e, r, n, i) {
      return t + e + r + n + i >>> 0;
    }, e.sum64 = function (t, e, r, n) {
      var i = t[e],
          o = n + t[e + 1] >>> 0,
          s = (o < n ? 1 : 0) + r + i;
      t[e] = s >>> 0, t[e + 1] = o;
    }, e.sum64_hi = function (t, e, r, n) {
      return (e + n >>> 0 < e ? 1 : 0) + t + r >>> 0;
    }, e.sum64_lo = function (t, e, r, n) {
      return e + n >>> 0;
    }, e.sum64_4_hi = function (t, e, r, n, i, o, s, a) {
      var u = 0,
          f = e;
      return u += (f = f + n >>> 0) < e ? 1 : 0, u += (f = f + o >>> 0) < o ? 1 : 0, t + r + i + s + (u += (f = f + a >>> 0) < a ? 1 : 0) >>> 0;
    }, e.sum64_4_lo = function (t, e, r, n, i, o, s, a) {
      return e + n + o + a >>> 0;
    }, e.sum64_5_hi = function (t, e, r, n, i, o, s, a, u, f) {
      var c = 0,
          h = e;
      return c += (h = h + n >>> 0) < e ? 1 : 0, c += (h = h + o >>> 0) < o ? 1 : 0, c += (h = h + a >>> 0) < a ? 1 : 0, t + r + i + s + u + (c += (h = h + f >>> 0) < f ? 1 : 0) >>> 0;
    }, e.sum64_5_lo = function (t, e, r, n, i, o, s, a, u, f) {
      return e + n + o + a + f >>> 0;
    }, e.rotr64_hi = function (t, e, r) {
      return (e << 32 - r | t >>> r) >>> 0;
    }, e.rotr64_lo = function (t, e, r) {
      return (t << 32 - r | e >>> r) >>> 0;
    }, e.shr64_hi = function (t, e, r) {
      return t >>> r;
    }, e.shr64_lo = function (t, e, r) {
      return (t << 32 - r | e >>> r) >>> 0;
    };
  }, function (t, e, r) {
    "use strict";

    var n,
        i = "object" == typeof Reflect ? Reflect : null,
        o = i && "function" == typeof i.apply ? i.apply : function (t, e, r) {
      return Function.prototype.apply.call(t, e, r);
    };
    n = i && "function" == typeof i.ownKeys ? i.ownKeys : Object.getOwnPropertySymbols ? function (t) {
      return Object.getOwnPropertyNames(t).concat(Object.getOwnPropertySymbols(t));
    } : function (t) {
      return Object.getOwnPropertyNames(t);
    };

    var s = Number.isNaN || function (t) {
      return t != t;
    };

    function a() {
      a.init.call(this);
    }

    t.exports = a, a.EventEmitter = a, a.prototype._events = void 0, a.prototype._eventsCount = 0, a.prototype._maxListeners = void 0;
    var u = 10;

    function f(t) {
      if ("function" != typeof t) throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof t);
    }

    function c(t) {
      return void 0 === t._maxListeners ? a.defaultMaxListeners : t._maxListeners;
    }

    function h(t, e, r, n) {
      var i, o, s, a;
      if (f(r), void 0 === (o = t._events) ? (o = t._events = Object.create(null), t._eventsCount = 0) : (void 0 !== o.newListener && (t.emit("newListener", e, r.listener ? r.listener : r), o = t._events), s = o[e]), void 0 === s) s = o[e] = r, ++t._eventsCount;else if ("function" == typeof s ? s = o[e] = n ? [r, s] : [s, r] : n ? s.unshift(r) : s.push(r), (i = c(t)) > 0 && s.length > i && !s.warned) {
        s.warned = !0;
        var u = new Error("Possible EventEmitter memory leak detected. " + s.length + " " + String(e) + " listeners added. Use emitter.setMaxListeners() to increase limit");
        u.name = "MaxListenersExceededWarning", u.emitter = t, u.type = e, u.count = s.length, a = u, console && console.warn && console.warn(a);
      }
      return t;
    }

    function l() {
      if (!this.fired) return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, 0 === arguments.length ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
    }

    function d(t, e, r) {
      var n = {
        fired: !1,
        wrapFn: void 0,
        target: t,
        type: e,
        listener: r
      },
          i = l.bind(n);
      return i.listener = r, n.wrapFn = i, i;
    }

    function p(t, e, r) {
      var n = t._events;
      if (void 0 === n) return [];
      var i = n[e];
      return void 0 === i ? [] : "function" == typeof i ? r ? [i.listener || i] : [i] : r ? function (t) {
        for (var e = new Array(t.length), r = 0; r < e.length; ++r) {
          e[r] = t[r].listener || t[r];
        }

        return e;
      }(i) : m(i, i.length);
    }

    function g(t) {
      var e = this._events;

      if (void 0 !== e) {
        var r = e[t];
        if ("function" == typeof r) return 1;
        if (void 0 !== r) return r.length;
      }

      return 0;
    }

    function m(t, e) {
      for (var r = new Array(e), n = 0; n < e; ++n) {
        r[n] = t[n];
      }

      return r;
    }

    Object.defineProperty(a, "defaultMaxListeners", {
      enumerable: !0,
      get: function get() {
        return u;
      },
      set: function set(t) {
        if ("number" != typeof t || t < 0 || s(t)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + t + ".");
        u = t;
      }
    }), a.init = function () {
      void 0 !== this._events && this._events !== Object.getPrototypeOf(this)._events || (this._events = Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
    }, a.prototype.setMaxListeners = function (t) {
      if ("number" != typeof t || t < 0 || s(t)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + t + ".");
      return this._maxListeners = t, this;
    }, a.prototype.getMaxListeners = function () {
      return c(this);
    }, a.prototype.emit = function (t) {
      for (var e = [], r = 1; r < arguments.length; r++) {
        e.push(arguments[r]);
      }

      var n = "error" === t,
          i = this._events;
      if (void 0 !== i) n = n && void 0 === i.error;else if (!n) return !1;

      if (n) {
        var s;
        if (e.length > 0 && (s = e[0]), s instanceof Error) throw s;
        var a = new Error("Unhandled error." + (s ? " (" + s.message + ")" : ""));
        throw a.context = s, a;
      }

      var u = i[t];
      if (void 0 === u) return !1;
      if ("function" == typeof u) o(u, this, e);else {
        var f = u.length,
            c = m(u, f);

        for (r = 0; r < f; ++r) {
          o(c[r], this, e);
        }
      }
      return !0;
    }, a.prototype.addListener = function (t, e) {
      return h(this, t, e, !1);
    }, a.prototype.on = a.prototype.addListener, a.prototype.prependListener = function (t, e) {
      return h(this, t, e, !0);
    }, a.prototype.once = function (t, e) {
      return f(e), this.on(t, d(this, t, e)), this;
    }, a.prototype.prependOnceListener = function (t, e) {
      return f(e), this.prependListener(t, d(this, t, e)), this;
    }, a.prototype.removeListener = function (t, e) {
      var r, n, i, o, s;
      if (f(e), void 0 === (n = this._events)) return this;
      if (void 0 === (r = n[t])) return this;
      if (r === e || r.listener === e) 0 == --this._eventsCount ? this._events = Object.create(null) : (delete n[t], n.removeListener && this.emit("removeListener", t, r.listener || e));else if ("function" != typeof r) {
        for (i = -1, o = r.length - 1; o >= 0; o--) {
          if (r[o] === e || r[o].listener === e) {
            s = r[o].listener, i = o;
            break;
          }
        }

        if (i < 0) return this;
        0 === i ? r.shift() : function (t, e) {
          for (; e + 1 < t.length; e++) {
            t[e] = t[e + 1];
          }

          t.pop();
        }(r, i), 1 === r.length && (n[t] = r[0]), void 0 !== n.removeListener && this.emit("removeListener", t, s || e);
      }
      return this;
    }, a.prototype.off = a.prototype.removeListener, a.prototype.removeAllListeners = function (t) {
      var e, r, n;
      if (void 0 === (r = this._events)) return this;
      if (void 0 === r.removeListener) return 0 === arguments.length ? (this._events = Object.create(null), this._eventsCount = 0) : void 0 !== r[t] && (0 == --this._eventsCount ? this._events = Object.create(null) : delete r[t]), this;

      if (0 === arguments.length) {
        var i,
            o = Object.keys(r);

        for (n = 0; n < o.length; ++n) {
          "removeListener" !== (i = o[n]) && this.removeAllListeners(i);
        }

        return this.removeAllListeners("removeListener"), this._events = Object.create(null), this._eventsCount = 0, this;
      }

      if ("function" == typeof (e = r[t])) this.removeListener(t, e);else if (void 0 !== e) for (n = e.length - 1; n >= 0; n--) {
        this.removeListener(t, e[n]);
      }
      return this;
    }, a.prototype.listeners = function (t) {
      return p(this, t, !0);
    }, a.prototype.rawListeners = function (t) {
      return p(this, t, !1);
    }, a.listenerCount = function (t, e) {
      return "function" == typeof t.listenerCount ? t.listenerCount(e) : g.call(t, e);
    }, a.prototype.listenerCount = g, a.prototype.eventNames = function () {
      return this._eventsCount > 0 ? n(this._events) : [];
    };
  }, function (t, e, r) {
    (function (t) {
      var n = Object.getOwnPropertyDescriptors || function (t) {
        for (var e = Object.keys(t), r = {}, n = 0; n < e.length; n++) {
          r[e[n]] = Object.getOwnPropertyDescriptor(t, e[n]);
        }

        return r;
      },
          i = /%[sdj%]/g;

      e.format = function (t) {
        if (!b(t)) {
          for (var e = [], r = 0; r < arguments.length; r++) {
            e.push(a(arguments[r]));
          }

          return e.join(" ");
        }

        r = 1;

        for (var n = arguments, o = n.length, s = String(t).replace(i, function (t) {
          if ("%%" === t) return "%";
          if (r >= o) return t;

          switch (t) {
            case "%s":
              return String(n[r++]);

            case "%d":
              return Number(n[r++]);

            case "%j":
              try {
                return JSON.stringify(n[r++]);
              } catch (t) {
                return "[Circular]";
              }

            default:
              return t;
          }
        }), u = n[r]; r < o; u = n[++r]) {
          g(u) || !_(u) ? s += " " + u : s += " " + a(u);
        }

        return s;
      }, e.deprecate = function (r, n) {
        if (void 0 !== t && !0 === t.noDeprecation) return r;
        if (void 0 === t) return function () {
          return e.deprecate(r, n).apply(this, arguments);
        };
        var i = !1;
        return function () {
          if (!i) {
            if (t.throwDeprecation) throw new Error(n);
            t.traceDeprecation ? console.trace(n) : console.error(n), i = !0;
          }

          return r.apply(this, arguments);
        };
      };
      var o,
          s = {};

      function a(t, r) {
        var n = {
          seen: [],
          stylize: f
        };
        return arguments.length >= 3 && (n.depth = arguments[2]), arguments.length >= 4 && (n.colors = arguments[3]), p(r) ? n.showHidden = r : r && e._extend(n, r), v(n.showHidden) && (n.showHidden = !1), v(n.depth) && (n.depth = 2), v(n.colors) && (n.colors = !1), v(n.customInspect) && (n.customInspect = !0), n.colors && (n.stylize = u), c(n, t, n.depth);
      }

      function u(t, e) {
        var r = a.styles[e];
        return r ? "[" + a.colors[r][0] + "m" + t + "[" + a.colors[r][1] + "m" : t;
      }

      function f(t, e) {
        return t;
      }

      function c(t, r, n) {
        if (t.customInspect && r && M(r.inspect) && r.inspect !== e.inspect && (!r.constructor || r.constructor.prototype !== r)) {
          var i = r.inspect(n, t);
          return b(i) || (i = c(t, i, n)), i;
        }

        var o = function (t, e) {
          if (v(e)) return t.stylize("undefined", "undefined");

          if (b(e)) {
            var r = "'" + JSON.stringify(e).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
            return t.stylize(r, "string");
          }

          if (m(e)) return t.stylize("" + e, "number");
          if (p(e)) return t.stylize("" + e, "boolean");
          if (g(e)) return t.stylize("null", "null");
        }(t, r);

        if (o) return o;

        var s = Object.keys(r),
            a = function (t) {
          var e = {};
          return t.forEach(function (t, r) {
            e[t] = !0;
          }), e;
        }(s);

        if (t.showHidden && (s = Object.getOwnPropertyNames(r)), E(r) && (s.indexOf("message") >= 0 || s.indexOf("description") >= 0)) return h(r);

        if (0 === s.length) {
          if (M(r)) {
            var u = r.name ? ": " + r.name : "";
            return t.stylize("[Function" + u + "]", "special");
          }

          if (y(r)) return t.stylize(RegExp.prototype.toString.call(r), "regexp");
          if (w(r)) return t.stylize(Date.prototype.toString.call(r), "date");
          if (E(r)) return h(r);
        }

        var f,
            _ = "",
            S = !1,
            A = ["{", "}"];
        (d(r) && (S = !0, A = ["[", "]"]), M(r)) && (_ = " [Function" + (r.name ? ": " + r.name : "") + "]");
        return y(r) && (_ = " " + RegExp.prototype.toString.call(r)), w(r) && (_ = " " + Date.prototype.toUTCString.call(r)), E(r) && (_ = " " + h(r)), 0 !== s.length || S && 0 != r.length ? n < 0 ? y(r) ? t.stylize(RegExp.prototype.toString.call(r), "regexp") : t.stylize("[Object]", "special") : (t.seen.push(r), f = S ? function (t, e, r, n, i) {
          for (var o = [], s = 0, a = e.length; s < a; ++s) {
            T(e, String(s)) ? o.push(l(t, e, r, n, String(s), !0)) : o.push("");
          }

          return i.forEach(function (i) {
            i.match(/^\d+$/) || o.push(l(t, e, r, n, i, !0));
          }), o;
        }(t, r, n, a, s) : s.map(function (e) {
          return l(t, r, n, a, e, S);
        }), t.seen.pop(), function (t, e, r) {
          if (t.reduce(function (t, e) {
            return e.indexOf("\n") >= 0 && 0, t + e.replace(/\u001b\[\d\d?m/g, "").length + 1;
          }, 0) > 60) return r[0] + ("" === e ? "" : e + "\n ") + " " + t.join(",\n  ") + " " + r[1];
          return r[0] + e + " " + t.join(", ") + " " + r[1];
        }(f, _, A)) : A[0] + _ + A[1];
      }

      function h(t) {
        return "[" + Error.prototype.toString.call(t) + "]";
      }

      function l(t, e, r, n, i, o) {
        var s, a, u;

        if ((u = Object.getOwnPropertyDescriptor(e, i) || {
          value: e[i]
        }).get ? a = u.set ? t.stylize("[Getter/Setter]", "special") : t.stylize("[Getter]", "special") : u.set && (a = t.stylize("[Setter]", "special")), T(n, i) || (s = "[" + i + "]"), a || (t.seen.indexOf(u.value) < 0 ? (a = g(r) ? c(t, u.value, null) : c(t, u.value, r - 1)).indexOf("\n") > -1 && (a = o ? a.split("\n").map(function (t) {
          return "  " + t;
        }).join("\n").substr(2) : "\n" + a.split("\n").map(function (t) {
          return "   " + t;
        }).join("\n")) : a = t.stylize("[Circular]", "special")), v(s)) {
          if (o && i.match(/^\d+$/)) return a;
          (s = JSON.stringify("" + i)).match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/) ? (s = s.substr(1, s.length - 2), s = t.stylize(s, "name")) : (s = s.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'"), s = t.stylize(s, "string"));
        }

        return s + ": " + a;
      }

      function d(t) {
        return Array.isArray(t);
      }

      function p(t) {
        return "boolean" == typeof t;
      }

      function g(t) {
        return null === t;
      }

      function m(t) {
        return "number" == typeof t;
      }

      function b(t) {
        return "string" == typeof t;
      }

      function v(t) {
        return void 0 === t;
      }

      function y(t) {
        return _(t) && "[object RegExp]" === S(t);
      }

      function _(t) {
        return "object" == typeof t && null !== t;
      }

      function w(t) {
        return _(t) && "[object Date]" === S(t);
      }

      function E(t) {
        return _(t) && ("[object Error]" === S(t) || t instanceof Error);
      }

      function M(t) {
        return "function" == typeof t;
      }

      function S(t) {
        return Object.prototype.toString.call(t);
      }

      function A(t) {
        return t < 10 ? "0" + t.toString(10) : t.toString(10);
      }

      e.debuglog = function (r) {
        if (v(o) && (o = t.env.NODE_DEBUG || ""), r = r.toUpperCase(), !s[r]) if (new RegExp("\\b" + r + "\\b", "i").test(o)) {
          var n = t.pid;

          s[r] = function () {
            var t = e.format.apply(e, arguments);
            console.error("%s %d: %s", r, n, t);
          };
        } else s[r] = function () {};
        return s[r];
      }, e.inspect = a, a.colors = {
        bold: [1, 22],
        italic: [3, 23],
        underline: [4, 24],
        inverse: [7, 27],
        white: [37, 39],
        grey: [90, 39],
        black: [30, 39],
        blue: [34, 39],
        cyan: [36, 39],
        green: [32, 39],
        magenta: [35, 39],
        red: [31, 39],
        yellow: [33, 39]
      }, a.styles = {
        special: "cyan",
        number: "yellow",
        boolean: "yellow",
        undefined: "grey",
        null: "bold",
        string: "green",
        date: "magenta",
        regexp: "red"
      }, e.isArray = d, e.isBoolean = p, e.isNull = g, e.isNullOrUndefined = function (t) {
        return null == t;
      }, e.isNumber = m, e.isString = b, e.isSymbol = function (t) {
        return "symbol" == typeof t;
      }, e.isUndefined = v, e.isRegExp = y, e.isObject = _, e.isDate = w, e.isError = E, e.isFunction = M, e.isPrimitive = function (t) {
        return null === t || "boolean" == typeof t || "number" == typeof t || "string" == typeof t || "symbol" == typeof t || void 0 === t;
      }, e.isBuffer = r(100);
      var x = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

      function R() {
        var t = new Date(),
            e = [A(t.getHours()), A(t.getMinutes()), A(t.getSeconds())].join(":");
        return [t.getDate(), x[t.getMonth()], e].join(" ");
      }

      function T(t, e) {
        return Object.prototype.hasOwnProperty.call(t, e);
      }

      e.log = function () {
        console.log("%s - %s", R(), e.format.apply(e, arguments));
      }, e.inherits = r(0), e._extend = function (t, e) {
        if (!e || !_(e)) return t;

        for (var r = Object.keys(e), n = r.length; n--;) {
          t[r[n]] = e[r[n]];
        }

        return t;
      };
      var k = "undefined" != typeof Symbol ? Symbol("util.promisify.custom") : void 0;

      function I(t, e) {
        if (!t) {
          var r = new Error("Promise was rejected with a falsy value");
          r.reason = t, t = r;
        }

        return e(t);
      }

      e.promisify = function (t) {
        if ("function" != typeof t) throw new TypeError('The "original" argument must be of type Function');

        if (k && t[k]) {
          var e;
          if ("function" != typeof (e = t[k])) throw new TypeError('The "util.promisify.custom" argument must be of type Function');
          return Object.defineProperty(e, k, {
            value: e,
            enumerable: !1,
            writable: !1,
            configurable: !0
          }), e;
        }

        function e() {
          for (var e, r, n = new Promise(function (t, n) {
            e = t, r = n;
          }), i = [], o = 0; o < arguments.length; o++) {
            i.push(arguments[o]);
          }

          i.push(function (t, n) {
            t ? r(t) : e(n);
          });

          try {
            t.apply(this, i);
          } catch (t) {
            r(t);
          }

          return n;
        }

        return Object.setPrototypeOf(e, Object.getPrototypeOf(t)), k && Object.defineProperty(e, k, {
          value: e,
          enumerable: !1,
          writable: !1,
          configurable: !0
        }), Object.defineProperties(e, n(t));
      }, e.promisify.custom = k, e.callbackify = function (e) {
        if ("function" != typeof e) throw new TypeError('The "original" argument must be of type Function');

        function r() {
          for (var r = [], n = 0; n < arguments.length; n++) {
            r.push(arguments[n]);
          }

          var i = r.pop();
          if ("function" != typeof i) throw new TypeError("The last argument must be of type Function");

          var o = this,
              s = function s() {
            return i.apply(o, arguments);
          };

          e.apply(this, r).then(function (e) {
            t.nextTick(s, null, e);
          }, function (e) {
            t.nextTick(I, e, s);
          });
        }

        return Object.setPrototypeOf(r, Object.getPrototypeOf(e)), Object.defineProperties(r, n(e)), r;
      };
    }).call(this, r(6));
  }, function (t, e, r) {
    "use strict";

    var n = r(24),
        i = Object.keys || function (t) {
      var e = [];

      for (var r in t) {
        e.push(r);
      }

      return e;
    };

    t.exports = h;
    var o = r(18);
    o.inherits = r(0);
    var s = r(55),
        a = r(33);
    o.inherits(h, s);

    for (var u = i(a.prototype), f = 0; f < u.length; f++) {
      var c = u[f];
      h.prototype[c] || (h.prototype[c] = a.prototype[c]);
    }

    function h(t) {
      if (!(this instanceof h)) return new h(t);
      s.call(this, t), a.call(this, t), t && !1 === t.readable && (this.readable = !1), t && !1 === t.writable && (this.writable = !1), this.allowHalfOpen = !0, t && !1 === t.allowHalfOpen && (this.allowHalfOpen = !1), this.once("end", l);
    }

    function l() {
      this.allowHalfOpen || this._writableState.ended || n.nextTick(d, this);
    }

    function d(t) {
      t.end();
    }

    Object.defineProperty(h.prototype, "writableHighWaterMark", {
      enumerable: !1,
      get: function get() {
        return this._writableState.highWaterMark;
      }
    }), Object.defineProperty(h.prototype, "destroyed", {
      get: function get() {
        return void 0 !== this._readableState && void 0 !== this._writableState && this._readableState.destroyed && this._writableState.destroyed;
      },
      set: function set(t) {
        void 0 !== this._readableState && void 0 !== this._writableState && (this._readableState.destroyed = t, this._writableState.destroyed = t);
      }
    }), h.prototype._destroy = function (t, e) {
      this.push(null), this.end(), n.nextTick(e, t);
    };
  }, function (t, e) {
    function r(t, e) {
      if (!t) throw new Error(e || "Assertion failed");
    }

    t.exports = r, r.equal = function (t, e, r) {
      if (t != e) throw new Error(r || "Assertion failed: " + t + " != " + e);
    };
  }, function (t, e, r) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.isAsync = void 0;
    var n,
        i = r(182),
        o = (n = i) && n.__esModule ? n : {
      default: n
    };
    var s = "function" == typeof Symbol;

    function a(t) {
      return s && "AsyncFunction" === t[Symbol.toStringTag];
    }

    e.default = function (t) {
      return a(t) ? (0, o.default)(t) : t;
    }, e.isAsync = a;
  }, function (t, e, r) {
    t.exports = i;
    var n = r(8).EventEmitter;

    function i() {
      n.call(this);
    }

    r(0)(i, n), i.Readable = r(17), i.Writable = r(112), i.Duplex = r(113), i.Transform = r(114), i.PassThrough = r(115), i.Stream = i, i.prototype.pipe = function (t, e) {
      var r = this;

      function i(e) {
        t.writable && !1 === t.write(e) && r.pause && r.pause();
      }

      function o() {
        r.readable && r.resume && r.resume();
      }

      r.on("data", i), t.on("drain", o), t._isStdio || e && !1 === e.end || (r.on("end", a), r.on("close", u));
      var s = !1;

      function a() {
        s || (s = !0, t.end());
      }

      function u() {
        s || (s = !0, "function" == typeof t.destroy && t.destroy());
      }

      function f(t) {
        if (c(), 0 === n.listenerCount(this, "error")) throw t;
      }

      function c() {
        r.removeListener("data", i), t.removeListener("drain", o), r.removeListener("end", a), r.removeListener("close", u), r.removeListener("error", f), t.removeListener("error", f), r.removeListener("end", c), r.removeListener("close", c), t.removeListener("close", c);
      }

      return r.on("error", f), t.on("error", f), r.on("end", c), r.on("close", c), t.on("close", c), t.emit("pipe", r), t;
    };
  }, function (t, e, r) {
    var n = r(1).Buffer;

    function i(t, e) {
      this._block = n.alloc(t), this._finalSize = e, this._blockSize = t, this._len = 0;
    }

    i.prototype.update = function (t, e) {
      "string" == typeof t && (e = e || "utf8", t = n.from(t, e));

      for (var r = this._block, i = this._blockSize, o = t.length, s = this._len, a = 0; a < o;) {
        for (var u = s % i, f = Math.min(o - a, i - u), c = 0; c < f; c++) {
          r[u + c] = t[a + c];
        }

        a += f, (s += f) % i == 0 && this._update(r);
      }

      return this._len += o, this;
    }, i.prototype.digest = function (t) {
      var e = this._len % this._blockSize;
      this._block[e] = 128, this._block.fill(0, e + 1), e >= this._finalSize && (this._update(this._block), this._block.fill(0));
      var r = 8 * this._len;
      if (r <= 4294967295) this._block.writeUInt32BE(r, this._blockSize - 4);else {
        var n = (4294967295 & r) >>> 0,
            i = (r - n) / 4294967296;
        this._block.writeUInt32BE(i, this._blockSize - 8), this._block.writeUInt32BE(n, this._blockSize - 4);
      }

      this._update(this._block);

      var o = this._hash();

      return t ? o.toString(t) : o;
    }, i.prototype._update = function () {
      throw new Error("_update must be implemented by subclass");
    }, t.exports = i;
  }, function (t, e, r) {
    "use strict";

    (function (e) {
      var n = r(69),
          i = r(154);

      function o(t) {
        var e = t;
        if ("string" != typeof e) throw new Error("[ethjs-util] while padding to even, value must be string, is currently " + typeof e + ", while padToEven.");
        return e.length % 2 && (e = "0" + e), e;
      }

      function s(t) {
        return "0x" + t.toString(16);
      }

      t.exports = {
        arrayContainsArray: function arrayContainsArray(t, e, r) {
          if (!0 !== Array.isArray(t)) throw new Error("[ethjs-util] method arrayContainsArray requires input 'superset' to be an array got type '" + typeof t + "'");
          if (!0 !== Array.isArray(e)) throw new Error("[ethjs-util] method arrayContainsArray requires input 'subset' to be an array got type '" + typeof e + "'");
          return e[Boolean(r) ? "some" : "every"](function (e) {
            return t.indexOf(e) >= 0;
          });
        },
        intToBuffer: function intToBuffer(t) {
          var r = s(t);
          return new e(o(r.slice(2)), "hex");
        },
        getBinarySize: function getBinarySize(t) {
          if ("string" != typeof t) throw new Error("[ethjs-util] while getting binary size, method getBinarySize requires input 'str' to be type String, got '" + typeof t + "'.");
          return e.byteLength(t, "utf8");
        },
        isHexPrefixed: n,
        stripHexPrefix: i,
        padToEven: o,
        intToHex: s,
        fromAscii: function fromAscii(t) {
          for (var e = "", r = 0; r < t.length; r++) {
            var n = t.charCodeAt(r).toString(16);
            e += n.length < 2 ? "0" + n : n;
          }

          return "0x" + e;
        },
        fromUtf8: function fromUtf8(t) {
          return "0x" + o(new e(t, "utf8").toString("hex")).replace(/^0+|0+$/g, "");
        },
        toAscii: function toAscii(t) {
          var e = "",
              r = 0,
              n = t.length;

          for ("0x" === t.substring(0, 2) && (r = 2); r < n; r += 2) {
            var i = parseInt(t.substr(r, 2), 16);
            e += String.fromCharCode(i);
          }

          return e;
        },
        toUtf8: function toUtf8(t) {
          return new e(o(i(t).replace(/^0+|0+$/g, "")), "hex").toString("utf8");
        },
        getKeys: function getKeys(t, e, r) {
          if (!Array.isArray(t)) throw new Error("[ethjs-util] method getKeys expecting type Array as 'params' input, got '" + typeof t + "'");
          if ("string" != typeof e) throw new Error("[ethjs-util] method getKeys expecting type String for input 'key' got '" + typeof e + "'.");

          for (var n = [], i = 0; i < t.length; i++) {
            var o = t[i][e];
            if (r && !o) o = "";else if ("string" != typeof o) throw new Error("invalid abi");
            n.push(o);
          }

          return n;
        },
        isHexString: function isHexString(t, e) {
          return !("string" != typeof t || !t.match(/^0x[0-9A-Fa-f]*$/)) && (!e || t.length === 2 + 2 * e);
        }
      };
    }).call(this, r(2).Buffer);
  }, function (t, e, r) {
    "use strict";

    var n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
      return typeof t;
    } : function (t) {
      return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    },
        i = r(101),
        o = r(26),
        s = r(38),
        a = r(28),
        u = r(3),
        f = r(35),
        c = r(1).Buffer;
    Object.assign(e, r(15)), e.MAX_INTEGER = new u("ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff", 16), e.TWO_POW256 = new u("10000000000000000000000000000000000000000000000000000000000000000", 16), e.KECCAK256_NULL_S = "c5d2460186f7233c927e7db2dcc703c0e500b653ca82273b7bfad8045d85a470", e.SHA3_NULL_S = e.KECCAK256_NULL_S, e.KECCAK256_NULL = c.from(e.KECCAK256_NULL_S, "hex"), e.SHA3_NULL = e.KECCAK256_NULL, e.KECCAK256_RLP_ARRAY_S = "1dcc4de8dec75d7aab85b567b6ccd41ad312451b948a7413f0a142fd40d49347", e.SHA3_RLP_ARRAY_S = e.KECCAK256_RLP_ARRAY_S, e.KECCAK256_RLP_ARRAY = c.from(e.KECCAK256_RLP_ARRAY_S, "hex"), e.SHA3_RLP_ARRAY = e.KECCAK256_RLP_ARRAY, e.KECCAK256_RLP_S = "56e81f171bcc55a6ff8345e692c0f86e5b48e01b996cadc001622fb5e363b421", e.SHA3_RLP_S = e.KECCAK256_RLP_S, e.KECCAK256_RLP = c.from(e.KECCAK256_RLP_S, "hex"), e.SHA3_RLP = e.KECCAK256_RLP, e.BN = u, e.rlp = a, e.secp256k1 = o, e.zeros = function (t) {
      return c.allocUnsafe(t).fill(0);
    }, e.zeroAddress = function () {
      var t = e.zeros(20);
      return e.bufferToHex(t);
    }, e.setLengthLeft = e.setLength = function (t, r, n) {
      var i = e.zeros(r);
      return t = e.toBuffer(t), n ? t.length < r ? (t.copy(i), i) : t.slice(0, r) : t.length < r ? (t.copy(i, r - t.length), i) : t.slice(-r);
    }, e.setLengthRight = function (t, r) {
      return e.setLength(t, r, !0);
    }, e.unpad = e.stripZeros = function (t) {
      for (var r = (t = e.stripHexPrefix(t))[0]; t.length > 0 && "0" === r.toString();) {
        r = (t = t.slice(1))[0];
      }

      return t;
    }, e.toBuffer = function (t) {
      if (!c.isBuffer(t)) if (Array.isArray(t)) t = c.from(t);else if ("string" == typeof t) t = e.isHexString(t) ? c.from(e.padToEven(e.stripHexPrefix(t)), "hex") : c.from(t);else if ("number" == typeof t) t = e.intToBuffer(t);else if (null == t) t = c.allocUnsafe(0);else if (u.isBN(t)) t = t.toArrayLike(c);else {
        if (!t.toArray) throw new Error("invalid type");
        t = c.from(t.toArray());
      }
      return t;
    }, e.bufferToInt = function (t) {
      return new u(e.toBuffer(t)).toNumber();
    }, e.bufferToHex = function (t) {
      return "0x" + (t = e.toBuffer(t)).toString("hex");
    }, e.fromSigned = function (t) {
      return new u(t).fromTwos(256);
    }, e.toUnsigned = function (t) {
      return c.from(t.toTwos(256).toArray());
    }, e.keccak = function (t, r) {
      return t = e.toBuffer(t), r || (r = 256), i("keccak" + r).update(t).digest();
    }, e.keccak256 = function (t) {
      return e.keccak(t);
    }, e.sha3 = e.keccak, e.sha256 = function (t) {
      return t = e.toBuffer(t), f("sha256").update(t).digest();
    }, e.ripemd160 = function (t, r) {
      t = e.toBuffer(t);
      var n = f("rmd160").update(t).digest();
      return !0 === r ? e.setLength(n, 32) : n;
    }, e.rlphash = function (t) {
      return e.keccak(a.encode(t));
    }, e.isValidPrivate = function (t) {
      return o.privateKeyVerify(t);
    }, e.isValidPublic = function (t, e) {
      return 64 === t.length ? o.publicKeyVerify(c.concat([c.from([4]), t])) : !!e && o.publicKeyVerify(t);
    }, e.pubToAddress = e.publicToAddress = function (t, r) {
      return t = e.toBuffer(t), r && 64 !== t.length && (t = o.publicKeyConvert(t, !1).slice(1)), s(64 === t.length), e.keccak(t).slice(-20);
    };

    var h = e.privateToPublic = function (t) {
      return t = e.toBuffer(t), o.publicKeyCreate(t, !1).slice(1);
    };

    e.importPublic = function (t) {
      return 64 !== (t = e.toBuffer(t)).length && (t = o.publicKeyConvert(t, !1).slice(1)), t;
    }, e.ecsign = function (t, e) {
      var r = o.sign(t, e),
          n = {};
      return n.r = r.signature.slice(0, 32), n.s = r.signature.slice(32, 64), n.v = r.recovery + 27, n;
    }, e.hashPersonalMessage = function (t) {
      var r = e.toBuffer("Ethereum Signed Message:\n" + t.length.toString());
      return e.keccak(c.concat([r, t]));
    }, e.ecrecover = function (t, r, n, i) {
      var s = c.concat([e.setLength(n, 32), e.setLength(i, 32)], 64),
          a = r - 27;
      if (0 !== a && 1 !== a) throw new Error("Invalid signature v value");
      var u = o.recover(t, s, a);
      return o.publicKeyConvert(u, !1).slice(1);
    }, e.toRpcSig = function (t, r, n) {
      if (27 !== t && 28 !== t) throw new Error("Invalid recovery id");
      return e.bufferToHex(c.concat([e.setLengthLeft(r, 32), e.setLengthLeft(n, 32), e.toBuffer(t - 27)]));
    }, e.fromRpcSig = function (t) {
      if (65 !== (t = e.toBuffer(t)).length) throw new Error("Invalid signature length");
      var r = t[64];
      return r < 27 && (r += 27), {
        v: r,
        r: t.slice(0, 32),
        s: t.slice(32, 64)
      };
    }, e.privateToAddress = function (t) {
      return e.publicToAddress(h(t));
    }, e.isValidAddress = function (t) {
      return /^0x[0-9a-fA-F]{40}$/.test(t);
    }, e.isZeroAddress = function (t) {
      return e.zeroAddress() === e.addHexPrefix(t);
    }, e.toChecksumAddress = function (t) {
      t = e.stripHexPrefix(t).toLowerCase();

      for (var r = e.keccak(t).toString("hex"), n = "0x", i = 0; i < t.length; i++) {
        parseInt(r[i], 16) >= 8 ? n += t[i].toUpperCase() : n += t[i];
      }

      return n;
    }, e.isValidChecksumAddress = function (t) {
      return e.isValidAddress(t) && e.toChecksumAddress(t) === t;
    }, e.generateAddress = function (t, r) {
      return t = e.toBuffer(t), r = (r = new u(r)).isZero() ? null : c.from(r.toArray()), e.rlphash([t, r]).slice(-20);
    }, e.isPrecompiled = function (t) {
      var r = e.unpad(t);
      return 1 === r.length && r[0] >= 1 && r[0] <= 8;
    }, e.addHexPrefix = function (t) {
      return "string" != typeof t ? t : e.isHexPrefixed(t) ? t : "0x" + t;
    }, e.isValidSignature = function (t, e, r, n) {
      var i = new u("7fffffffffffffffffffffffffffffff5d576e7357a4501ddfe92f46681b20a0", 16),
          o = new u("fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141", 16);
      return 32 === e.length && 32 === r.length && (27 === t || 28 === t) && (e = new u(e), r = new u(r), !(e.isZero() || e.gt(o) || r.isZero() || r.gt(o)) && (!1 !== n || 1 !== new u(r).cmp(i)));
    }, e.baToJSON = function (t) {
      if (c.isBuffer(t)) return "0x" + t.toString("hex");

      if (t instanceof Array) {
        for (var r = [], n = 0; n < t.length; n++) {
          r.push(e.baToJSON(t[n]));
        }

        return r;
      }
    }, e.defineProperties = function (t, r, i) {
      if (t.raw = [], t._fields = [], t.toJSON = function (r) {
        if (r) {
          var n = {};
          return t._fields.forEach(function (e) {
            n[e] = "0x" + t[e].toString("hex");
          }), n;
        }

        return e.baToJSON(this.raw);
      }, t.serialize = function () {
        return a.encode(t.raw);
      }, r.forEach(function (r, n) {
        function i() {
          return t.raw[n];
        }

        function o(i) {
          "00" !== (i = e.toBuffer(i)).toString("hex") || r.allowZero || (i = c.allocUnsafe(0)), r.allowLess && r.length ? (i = e.stripZeros(i), s(r.length >= i.length, "The field " + r.name + " must not have more " + r.length + " bytes")) : r.allowZero && 0 === i.length || !r.length || s(r.length === i.length, "The field " + r.name + " must have byte length of " + r.length), t.raw[n] = i;
        }

        t._fields.push(r.name), Object.defineProperty(t, r.name, {
          enumerable: !0,
          configurable: !0,
          get: i,
          set: o
        }), r.default && (t[r.name] = r.default), r.alias && Object.defineProperty(t, r.alias, {
          enumerable: !1,
          configurable: !0,
          set: o,
          get: i
        });
      }), i) if ("string" == typeof i && (i = c.from(e.stripHexPrefix(i), "hex")), c.isBuffer(i) && (i = a.decode(i)), Array.isArray(i)) {
        if (i.length > t._fields.length) throw new Error("wrong number of fields in data");
        i.forEach(function (r, n) {
          t[t._fields[n]] = e.toBuffer(r);
        });
      } else {
        if ("object" !== (void 0 === i ? "undefined" : n(i))) throw new Error("invalid data");
        var o = Object.keys(i);
        r.forEach(function (e) {
          -1 !== o.indexOf(e.name) && (t[e.name] = i[e.name]), -1 !== o.indexOf(e.alias) && (t[e.alias] = i[e.alias]);
        });
      }
    };
  }, function (t, e, r) {
    (e = t.exports = r(55)).Stream = e, e.Readable = e, e.Writable = r(33), e.Duplex = r(10), e.Transform = r(58), e.PassThrough = r(111);
  }, function (t, e, r) {
    (function (t) {
      function r(t) {
        return Object.prototype.toString.call(t);
      }

      e.isArray = function (t) {
        return Array.isArray ? Array.isArray(t) : "[object Array]" === r(t);
      }, e.isBoolean = function (t) {
        return "boolean" == typeof t;
      }, e.isNull = function (t) {
        return null === t;
      }, e.isNullOrUndefined = function (t) {
        return null == t;
      }, e.isNumber = function (t) {
        return "number" == typeof t;
      }, e.isString = function (t) {
        return "string" == typeof t;
      }, e.isSymbol = function (t) {
        return "symbol" == typeof t;
      }, e.isUndefined = function (t) {
        return void 0 === t;
      }, e.isRegExp = function (t) {
        return "[object RegExp]" === r(t);
      }, e.isObject = function (t) {
        return "object" == typeof t && null !== t;
      }, e.isDate = function (t) {
        return "[object Date]" === r(t);
      }, e.isError = function (t) {
        return "[object Error]" === r(t) || t instanceof Error;
      }, e.isFunction = function (t) {
        return "function" == typeof t;
      }, e.isPrimitive = function (t) {
        return null === t || "boolean" == typeof t || "number" == typeof t || "string" == typeof t || "symbol" == typeof t || void 0 === t;
      }, e.isBuffer = t.isBuffer;
    }).call(this, r(2).Buffer);
  }, function (t, e) {
    t.exports = function (t) {
      return t.webpackPolyfill || (t.deprecate = function () {}, t.paths = [], t.children || (t.children = []), Object.defineProperty(t, "loaded", {
        enumerable: !0,
        get: function get() {
          return t.l;
        }
      }), Object.defineProperty(t, "id", {
        enumerable: !0,
        get: function get() {
          return t.i;
        }
      }), t.webpackPolyfill = 1), t;
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(7),
        i = r(11);

    function o() {
      this.pending = null, this.pendingTotal = 0, this.blockSize = this.constructor.blockSize, this.outSize = this.constructor.outSize, this.hmacStrength = this.constructor.hmacStrength, this.padLength = this.constructor.padLength / 8, this.endian = "big", this._delta8 = this.blockSize / 8, this._delta32 = this.blockSize / 32;
    }

    e.BlockHash = o, o.prototype.update = function (t, e) {
      if (t = n.toArray(t, e), this.pending ? this.pending = this.pending.concat(t) : this.pending = t, this.pendingTotal += t.length, this.pending.length >= this._delta8) {
        var r = (t = this.pending).length % this._delta8;
        this.pending = t.slice(t.length - r, t.length), 0 === this.pending.length && (this.pending = null), t = n.join32(t, 0, t.length - r, this.endian);

        for (var i = 0; i < t.length; i += this._delta32) {
          this._update(t, i, i + this._delta32);
        }
      }

      return this;
    }, o.prototype.digest = function (t) {
      return this.update(this._pad()), i(null === this.pending), this._digest(t);
    }, o.prototype._pad = function () {
      var t = this.pendingTotal,
          e = this._delta8,
          r = e - (t + this.padLength) % e,
          n = new Array(r + this.padLength);
      n[0] = 128;

      for (var i = 1; i < r; i++) {
        n[i] = 0;
      }

      if (t <<= 3, "big" === this.endian) {
        for (var o = 8; o < this.padLength; o++) {
          n[i++] = 0;
        }

        n[i++] = 0, n[i++] = 0, n[i++] = 0, n[i++] = 0, n[i++] = t >>> 24 & 255, n[i++] = t >>> 16 & 255, n[i++] = t >>> 8 & 255, n[i++] = 255 & t;
      } else for (n[i++] = 255 & t, n[i++] = t >>> 8 & 255, n[i++] = t >>> 16 & 255, n[i++] = t >>> 24 & 255, n[i++] = 0, n[i++] = 0, n[i++] = 0, n[i++] = 0, o = 8; o < this.padLength; o++) {
        n[i++] = 0;
      }

      return n;
    };
  }, function (t, e) {
    t.exports = function () {};
  }, function (t, e) {
    function r(t) {
      return t.sort(function (t, e) {
        return "latest" === t || "earliest" === e ? 1 : "latest" === e || "earliest" === t ? -1 : n(t) - n(e);
      });
    }

    function n(t) {
      return null == t ? t : Number.parseInt(t, 16);
    }

    function i(t) {
      if (null == t) return t;
      var e = t.toString(16);
      return e.length % 2 && (e = "0" + e), "0x" + e;
    }

    function o() {
      return Math.floor(16 * Math.random()).toString(16);
    }

    t.exports = {
      minBlockRef: function minBlockRef() {
        for (var _len = arguments.length, t = new Array(_len), _key = 0; _key < _len; _key++) {
          t[_key] = arguments[_key];
        }

        return r(t)[0];
      },
      maxBlockRef: function maxBlockRef() {
        for (var _len2 = arguments.length, t = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          t[_key2] = arguments[_key2];
        }

        var e = r(t);
        return e[e.length - 1];
      },
      sortBlockRefs: r,
      bnToHex: function bnToHex(t) {
        return "0x" + t.toString(16);
      },
      blockRefIsNumber: function blockRefIsNumber(t) {
        return t && !["earliest", "latest", "pending"].includes(t);
      },
      hexToInt: n,
      incrementHexInt: function incrementHexInt(t) {
        if (null == t) return t;
        return i(n(t) + 1);
      },
      intToHex: i,
      unsafeRandomBytes: function unsafeRandomBytes(t) {
        var e = "0x";

        for (var _r = 0; _r < t; _r++) {
          e += o(), e += o();
        }

        return e;
      }
    };
  }, function (t, e, r) {
    "use strict";

    (function (t) {
      Object.defineProperty(e, "__esModule", {
        value: !0
      });
      var n = r(15),
          i = r(3);
      e.zeros = function (e) {
        return t.allocUnsafe(e).fill(0);
      }, e.setLengthLeft = function (t, r, n) {
        void 0 === n && (n = !1);
        var i = e.zeros(r);
        return t = e.toBuffer(t), n ? t.length < r ? (t.copy(i), i) : t.slice(0, r) : t.length < r ? (t.copy(i, r - t.length), i) : t.slice(-r);
      }, e.setLength = e.setLengthLeft, e.setLengthRight = function (t, r) {
        return e.setLength(t, r, !0);
      }, e.unpad = function (t) {
        for (var e = (t = n.stripHexPrefix(t))[0]; t.length > 0 && "0" === e.toString();) {
          e = (t = t.slice(1))[0];
        }

        return t;
      }, e.stripZeros = e.unpad, e.toBuffer = function (e) {
        if (!t.isBuffer(e)) if (Array.isArray(e)) e = t.from(e);else if ("string" == typeof e) {
          if (!n.isHexString(e)) throw new Error("Cannot convert string to buffer. toBuffer only supports 0x-prefixed hex strings and this string was given: " + e);
          e = t.from(n.padToEven(n.stripHexPrefix(e)), "hex");
        } else if ("number" == typeof e) e = n.intToBuffer(e);else if (null == e) e = t.allocUnsafe(0);else if (i.isBN(e)) e = e.toArrayLike(t);else {
          if (!e.toArray) throw new Error("invalid type");
          e = t.from(e.toArray());
        }
        return e;
      }, e.bufferToInt = function (t) {
        return new i(e.toBuffer(t)).toNumber();
      }, e.bufferToHex = function (t) {
        return "0x" + (t = e.toBuffer(t)).toString("hex");
      }, e.fromSigned = function (t) {
        return new i(t).fromTwos(256);
      }, e.toUnsigned = function (e) {
        return t.from(e.toTwos(256).toArray());
      }, e.addHexPrefix = function (t) {
        return "string" != typeof t ? t : n.isHexPrefixed(t) ? t : "0x" + t;
      }, e.baToJSON = function (r) {
        if (t.isBuffer(r)) return "0x" + r.toString("hex");

        if (r instanceof Array) {
          for (var n = [], i = 0; i < r.length; i++) {
            n.push(e.baToJSON(r[i]));
          }

          return n;
        }
      };
    }).call(this, r(2).Buffer);
  }, function (t, e, r) {
    "use strict";

    (function (e) {
      !e.version || 0 === e.version.indexOf("v0.") || 0 === e.version.indexOf("v1.") && 0 !== e.version.indexOf("v1.8.") ? t.exports = {
        nextTick: function nextTick(t, r, n, i) {
          if ("function" != typeof t) throw new TypeError('"callback" argument must be a function');
          var o,
              s,
              a = arguments.length;

          switch (a) {
            case 0:
            case 1:
              return e.nextTick(t);

            case 2:
              return e.nextTick(function () {
                t.call(null, r);
              });

            case 3:
              return e.nextTick(function () {
                t.call(null, r, n);
              });

            case 4:
              return e.nextTick(function () {
                t.call(null, r, n, i);
              });

            default:
              for (o = new Array(a - 1), s = 0; s < o.length;) {
                o[s++] = arguments[s];
              }

              return e.nextTick(function () {
                t.apply(null, o);
              });
          }
        }
      } : t.exports = e;
    }).call(this, r(6));
  }, function (t, e, r) {
    (function (t) {
      var n = void 0 !== t && t || "undefined" != typeof self && self || window,
          i = Function.prototype.apply;

      function o(t, e) {
        this._id = t, this._clearFn = e;
      }

      e.setTimeout = function () {
        return new o(i.call(setTimeout, n, arguments), clearTimeout);
      }, e.setInterval = function () {
        return new o(i.call(setInterval, n, arguments), clearInterval);
      }, e.clearTimeout = e.clearInterval = function (t) {
        t && t.close();
      }, o.prototype.unref = o.prototype.ref = function () {}, o.prototype.close = function () {
        this._clearFn.call(n, this._id);
      }, e.enroll = function (t, e) {
        clearTimeout(t._idleTimeoutId), t._idleTimeout = e;
      }, e.unenroll = function (t) {
        clearTimeout(t._idleTimeoutId), t._idleTimeout = -1;
      }, e._unrefActive = e.active = function (t) {
        clearTimeout(t._idleTimeoutId);
        var e = t._idleTimeout;
        e >= 0 && (t._idleTimeoutId = setTimeout(function () {
          t._onTimeout && t._onTimeout();
        }, e));
      }, r(109), e.setImmediate = "undefined" != typeof self && self.setImmediate || void 0 !== t && t.setImmediate || this && this.setImmediate, e.clearImmediate = "undefined" != typeof self && self.clearImmediate || void 0 !== t && t.clearImmediate || this && this.clearImmediate;
    }).call(this, r(4));
  }, function (t, e, r) {
    "use strict";

    t.exports = r(119)(r(123));
  }, function (t, e, r) {
    "use strict";

    var n = r(3),
        i = r(5),
        o = i.getNAF,
        s = i.getJSF,
        a = i.assert;

    function u(t, e) {
      this.type = t, this.p = new n(e.p, 16), this.red = e.prime ? n.red(e.prime) : n.mont(this.p), this.zero = new n(0).toRed(this.red), this.one = new n(1).toRed(this.red), this.two = new n(2).toRed(this.red), this.n = e.n && new n(e.n, 16), this.g = e.g && this.pointFromJSON(e.g, e.gRed), this._wnafT1 = new Array(4), this._wnafT2 = new Array(4), this._wnafT3 = new Array(4), this._wnafT4 = new Array(4), this._bitLength = this.n ? this.n.bitLength() : 0;
      var r = this.n && this.p.div(this.n);
      !r || r.cmpn(100) > 0 ? this.redN = null : (this._maxwellTrick = !0, this.redN = this.n.toRed(this.red));
    }

    function f(t, e) {
      this.curve = t, this.type = e, this.precomputed = null;
    }

    t.exports = u, u.prototype.point = function () {
      throw new Error("Not implemented");
    }, u.prototype.validate = function () {
      throw new Error("Not implemented");
    }, u.prototype._fixedNafMul = function (t, e) {
      a(t.precomputed);

      var r = t._getDoubles(),
          n = o(e, 1, this._bitLength),
          i = (1 << r.step + 1) - (r.step % 2 == 0 ? 2 : 1);

      i /= 3;

      for (var s = [], u = 0; u < n.length; u += r.step) {
        var f = 0;

        for (e = u + r.step - 1; e >= u; e--) {
          f = (f << 1) + n[e];
        }

        s.push(f);
      }

      for (var c = this.jpoint(null, null, null), h = this.jpoint(null, null, null), l = i; l > 0; l--) {
        for (u = 0; u < s.length; u++) {
          (f = s[u]) === l ? h = h.mixedAdd(r.points[u]) : f === -l && (h = h.mixedAdd(r.points[u].neg()));
        }

        c = c.add(h);
      }

      return c.toP();
    }, u.prototype._wnafMul = function (t, e) {
      var r = 4,
          n = t._getNAFPoints(r);

      r = n.wnd;

      for (var i = n.points, s = o(e, r, this._bitLength), u = this.jpoint(null, null, null), f = s.length - 1; f >= 0; f--) {
        for (e = 0; f >= 0 && 0 === s[f]; f--) {
          e++;
        }

        if (f >= 0 && e++, u = u.dblp(e), f < 0) break;
        var c = s[f];
        a(0 !== c), u = "affine" === t.type ? c > 0 ? u.mixedAdd(i[c - 1 >> 1]) : u.mixedAdd(i[-c - 1 >> 1].neg()) : c > 0 ? u.add(i[c - 1 >> 1]) : u.add(i[-c - 1 >> 1].neg());
      }

      return "affine" === t.type ? u.toP() : u;
    }, u.prototype._wnafMulAdd = function (t, e, r, n, i) {
      for (var a = this._wnafT1, u = this._wnafT2, f = this._wnafT3, c = 0, h = 0; h < n; h++) {
        var l = (A = e[h])._getNAFPoints(t);

        a[h] = l.wnd, u[h] = l.points;
      }

      for (h = n - 1; h >= 1; h -= 2) {
        var d = h - 1,
            p = h;

        if (1 === a[d] && 1 === a[p]) {
          var g = [e[d], null, null, e[p]];
          0 === e[d].y.cmp(e[p].y) ? (g[1] = e[d].add(e[p]), g[2] = e[d].toJ().mixedAdd(e[p].neg())) : 0 === e[d].y.cmp(e[p].y.redNeg()) ? (g[1] = e[d].toJ().mixedAdd(e[p]), g[2] = e[d].add(e[p].neg())) : (g[1] = e[d].toJ().mixedAdd(e[p]), g[2] = e[d].toJ().mixedAdd(e[p].neg()));
          var m = [-3, -1, -5, -7, 0, 7, 5, 1, 3],
              b = s(r[d], r[p]);
          c = Math.max(b[0].length, c), f[d] = new Array(c), f[p] = new Array(c);

          for (var v = 0; v < c; v++) {
            var y = 0 | b[0][v],
                _ = 0 | b[1][v];

            f[d][v] = m[3 * (y + 1) + (_ + 1)], f[p][v] = 0, u[d] = g;
          }
        } else f[d] = o(r[d], a[d], this._bitLength), f[p] = o(r[p], a[p], this._bitLength), c = Math.max(f[d].length, c), c = Math.max(f[p].length, c);
      }

      var w = this.jpoint(null, null, null),
          E = this._wnafT4;

      for (h = c; h >= 0; h--) {
        for (var M = 0; h >= 0;) {
          var S = !0;

          for (v = 0; v < n; v++) {
            E[v] = 0 | f[v][h], 0 !== E[v] && (S = !1);
          }

          if (!S) break;
          M++, h--;
        }

        if (h >= 0 && M++, w = w.dblp(M), h < 0) break;

        for (v = 0; v < n; v++) {
          var A,
              x = E[v];
          0 !== x && (x > 0 ? A = u[v][x - 1 >> 1] : x < 0 && (A = u[v][-x - 1 >> 1].neg()), w = "affine" === A.type ? w.mixedAdd(A) : w.add(A));
        }
      }

      for (h = 0; h < n; h++) {
        u[h] = null;
      }

      return i ? w : w.toP();
    }, u.BasePoint = f, f.prototype.eq = function () {
      throw new Error("Not implemented");
    }, f.prototype.validate = function () {
      return this.curve.validate(this);
    }, u.prototype.decodePoint = function (t, e) {
      t = i.toArray(t, e);
      var r = this.p.byteLength();
      if ((4 === t[0] || 6 === t[0] || 7 === t[0]) && t.length - 1 == 2 * r) return 6 === t[0] ? a(t[t.length - 1] % 2 == 0) : 7 === t[0] && a(t[t.length - 1] % 2 == 1), this.point(t.slice(1, 1 + r), t.slice(1 + r, 1 + 2 * r));
      if ((2 === t[0] || 3 === t[0]) && t.length - 1 === r) return this.pointFromX(t.slice(1, 1 + r), 3 === t[0]);
      throw new Error("Unknown point format");
    }, f.prototype.encodeCompressed = function (t) {
      return this.encode(t, !0);
    }, f.prototype._encode = function (t) {
      var e = this.curve.p.byteLength(),
          r = this.getX().toArray("be", e);
      return t ? [this.getY().isEven() ? 2 : 3].concat(r) : [4].concat(r, this.getY().toArray("be", e));
    }, f.prototype.encode = function (t, e) {
      return i.encode(this._encode(e), t);
    }, f.prototype.precompute = function (t) {
      if (this.precomputed) return this;
      var e = {
        doubles: null,
        naf: null,
        beta: null
      };
      return e.naf = this._getNAFPoints(8), e.doubles = this._getDoubles(4, t), e.beta = this._getBeta(), this.precomputed = e, this;
    }, f.prototype._hasDoubles = function (t) {
      if (!this.precomputed) return !1;
      var e = this.precomputed.doubles;
      return !!e && e.points.length >= Math.ceil((t.bitLength() + 1) / e.step);
    }, f.prototype._getDoubles = function (t, e) {
      if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;

      for (var r = [this], n = this, i = 0; i < e; i += t) {
        for (var o = 0; o < t; o++) {
          n = n.dbl();
        }

        r.push(n);
      }

      return {
        step: t,
        points: r
      };
    }, f.prototype._getNAFPoints = function (t) {
      if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;

      for (var e = [this], r = (1 << t) - 1, n = 1 === r ? null : this.dbl(), i = 1; i < r; i++) {
        e[i] = e[i - 1].add(n);
      }

      return {
        wnd: t,
        points: e
      };
    }, f.prototype._getBeta = function () {
      return null;
    }, f.prototype.dblp = function (t) {
      for (var e = this, r = 0; r < t; r++) {
        e = e.dbl();
      }

      return e;
    };
  }, function (t, e, r) {
    "use strict";

    (function (t) {
      Object.defineProperty(e, "__esModule", {
        value: !0
      });
      var n = r(3);

      function i(t, e) {
        if ("00" === t.slice(0, 2)) throw new Error("invalid RLP: extra zeros");
        return parseInt(t, e);
      }

      function o(e, r) {
        if (e < 56) return t.from([e + r]);
        var n = a(e),
            i = a(r + 55 + n.length / 2);
        return t.from(i + n, "hex");
      }

      function s(t) {
        return "0x" === t.slice(0, 2);
      }

      function a(t) {
        if (t < 0) throw new Error("Invalid integer as argument, must be unsigned!");
        var e = t.toString(16);
        return e.length % 2 ? "0" + e : e;
      }

      function u(e) {
        if (!t.isBuffer(e)) {
          if ("string" == typeof e) return s(e) ? t.from((i = "string" != typeof (o = e) ? o : s(o) ? o.slice(2) : o).length % 2 ? "0" + i : i, "hex") : t.from(e);
          if ("number" == typeof e) return e ? (r = a(e), t.from(r, "hex")) : t.from([]);
          if (null == e) return t.from([]);
          if (e instanceof Uint8Array) return t.from(e);
          if (n.isBN(e)) return t.from(e.toArray());
          throw new Error("invalid type");
        }

        var r, i, o;
        return e;
      }

      e.encode = function e(r) {
        if (Array.isArray(r)) {
          for (var n = [], i = 0; i < r.length; i++) {
            n.push(e(r[i]));
          }

          var s = t.concat(n);
          return t.concat([o(s.length, 192), s]);
        }

        var a = u(r);
        return 1 === a.length && a[0] < 128 ? a : t.concat([o(a.length, 128), a]);
      }, e.decode = function (e, r) {
        if (void 0 === r && (r = !1), !e || 0 === e.length) return t.from([]);

        var n = function e(r) {
          var n,
              o,
              s,
              a,
              u,
              f = [],
              c = r[0];
          if (c <= 127) return {
            data: r.slice(0, 1),
            remainder: r.slice(1)
          };

          if (c <= 183) {
            if (n = c - 127, s = 128 === c ? t.from([]) : r.slice(1, n), 2 === n && s[0] < 128) throw new Error("invalid rlp encoding: byte must be less 0x80");
            return {
              data: s,
              remainder: r.slice(n)
            };
          }

          if (c <= 191) {
            if (o = c - 182, n = i(r.slice(1, o).toString("hex"), 16), (s = r.slice(o, n + o)).length < n) throw new Error("invalid RLP");
            return {
              data: s,
              remainder: r.slice(n + o)
            };
          }

          if (c <= 247) {
            for (n = c - 191, a = r.slice(1, n); a.length;) {
              u = e(a), f.push(u.data), a = u.remainder;
            }

            return {
              data: f,
              remainder: r.slice(n)
            };
          }

          o = c - 246, n = i(r.slice(1, o).toString("hex"), 16);
          var h = o + n;
          if (h > r.length) throw new Error("invalid rlp: total length is larger than the data");
          if (0 === (a = r.slice(o, h)).length) throw new Error("invalid rlp, List has a invalid length");

          for (; a.length;) {
            u = e(a), f.push(u.data), a = u.remainder;
          }

          return {
            data: f,
            remainder: r.slice(h)
          };
        }(u(e));

        if (r) return n;
        if (0 !== n.remainder.length) throw new Error("invalid remainder");
        return n.data;
      }, e.getLength = function (e) {
        if (!e || 0 === e.length) return t.from([]);
        var r = u(e),
            n = r[0];
        if (n <= 127) return r.length;
        if (n <= 183) return n - 127;
        if (n <= 191) return n - 182;
        if (n <= 247) return n - 191;
        var o = n - 246;
        return o + i(r.slice(1, o).toString("hex"), 16);
      };
    }).call(this, r(2).Buffer);
  }, function (t, e) {
    t.exports = function () {
      for (var t = {}, e = 0; e < arguments.length; e++) {
        var n = arguments[e];

        for (var i in n) {
          r.call(n, i) && (t[i] = n[i]);
        }
      }

      return t;
    };

    var r = Object.prototype.hasOwnProperty;
  }, function (t, e, r) {
    var n = r(160),
        i = r(77);

    t.exports = function (t) {
      return null != t && i(t.length) && !n(t);
    };
  }, function (t, e, r) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = function (t, e) {
      e |= 0;

      for (var r = Math.max(t.length - e, 0), n = Array(r), i = 0; i < r; i++) {
        n[i] = t[e + i];
      }

      return n;
    }, t.exports = e.default;
  }, function (t, e, r) {
    var n = r(44);

    function i() {}

    t.exports = i, i.prototype.setEngine = function (t) {
      var e = this;
      e.engine || (e.engine = t, t.on("block", function (t) {
        e.currentBlock = t;
      }), t.on("start", function () {
        e.start();
      }), t.on("stop", function () {
        e.stop();
      }));
    }, i.prototype.handleRequest = function (t, e, r) {
      throw new Error("Subproviders should override `handleRequest`.");
    }, i.prototype.emitPayload = function (t, e) {
      this.engine.sendAsync(n(t), e);
    }, i.prototype.stop = function () {}, i.prototype.start = function () {};
  }, function (t, e, r) {
    "use strict";

    (function (e, n, i) {
      var o = r(24);

      function s(t) {
        var e = this;
        this.next = null, this.entry = null, this.finish = function () {
          !function (t, e, r) {
            var n = t.entry;
            t.entry = null;

            for (; n;) {
              var i = n.callback;
              e.pendingcb--, i(r), n = n.next;
            }

            e.corkedRequestsFree ? e.corkedRequestsFree.next = t : e.corkedRequestsFree = t;
          }(e, t);
        };
      }

      t.exports = v;
      var a,
          u = !e.browser && ["v0.10", "v0.9."].indexOf(e.version.slice(0, 5)) > -1 ? n : o.nextTick;
      v.WritableState = b;
      var f = r(18);
      f.inherits = r(0);

      var c = {
        deprecate: r(110)
      },
          h = r(56),
          l = r(1).Buffer,
          d = i.Uint8Array || function () {};

      var p,
          g = r(57);

      function m() {}

      function b(t, e) {
        a = a || r(10), t = t || {};
        var n = e instanceof a;
        this.objectMode = !!t.objectMode, n && (this.objectMode = this.objectMode || !!t.writableObjectMode);
        var i = t.highWaterMark,
            f = t.writableHighWaterMark,
            c = this.objectMode ? 16 : 16384;
        this.highWaterMark = i || 0 === i ? i : n && (f || 0 === f) ? f : c, this.highWaterMark = Math.floor(this.highWaterMark), this.finalCalled = !1, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1, this.destroyed = !1;
        var h = !1 === t.decodeStrings;
        this.decodeStrings = !h, this.defaultEncoding = t.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function (t) {
          !function (t, e) {
            var r = t._writableState,
                n = r.sync,
                i = r.writecb;
            if (function (t) {
              t.writing = !1, t.writecb = null, t.length -= t.writelen, t.writelen = 0;
            }(r), e) !function (t, e, r, n, i) {
              --e.pendingcb, r ? (o.nextTick(i, n), o.nextTick(S, t, e), t._writableState.errorEmitted = !0, t.emit("error", n)) : (i(n), t._writableState.errorEmitted = !0, t.emit("error", n), S(t, e));
            }(t, r, n, e, i);else {
              var s = E(r);
              s || r.corked || r.bufferProcessing || !r.bufferedRequest || w(t, r), n ? u(_, t, r, s, i) : _(t, r, s, i);
            }
          }(e, t);
        }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.bufferedRequestCount = 0, this.corkedRequestsFree = new s(this);
      }

      function v(t) {
        if (a = a || r(10), !(p.call(v, this) || this instanceof a)) return new v(t);
        this._writableState = new b(t, this), this.writable = !0, t && ("function" == typeof t.write && (this._write = t.write), "function" == typeof t.writev && (this._writev = t.writev), "function" == typeof t.destroy && (this._destroy = t.destroy), "function" == typeof t.final && (this._final = t.final)), h.call(this);
      }

      function y(t, e, r, n, i, o, s) {
        e.writelen = n, e.writecb = s, e.writing = !0, e.sync = !0, r ? t._writev(i, e.onwrite) : t._write(i, o, e.onwrite), e.sync = !1;
      }

      function _(t, e, r, n) {
        r || function (t, e) {
          0 === e.length && e.needDrain && (e.needDrain = !1, t.emit("drain"));
        }(t, e), e.pendingcb--, n(), S(t, e);
      }

      function w(t, e) {
        e.bufferProcessing = !0;
        var r = e.bufferedRequest;

        if (t._writev && r && r.next) {
          var n = e.bufferedRequestCount,
              i = new Array(n),
              o = e.corkedRequestsFree;
          o.entry = r;

          for (var a = 0, u = !0; r;) {
            i[a] = r, r.isBuf || (u = !1), r = r.next, a += 1;
          }

          i.allBuffers = u, y(t, e, !0, e.length, i, "", o.finish), e.pendingcb++, e.lastBufferedRequest = null, o.next ? (e.corkedRequestsFree = o.next, o.next = null) : e.corkedRequestsFree = new s(e), e.bufferedRequestCount = 0;
        } else {
          for (; r;) {
            var f = r.chunk,
                c = r.encoding,
                h = r.callback;
            if (y(t, e, !1, e.objectMode ? 1 : f.length, f, c, h), r = r.next, e.bufferedRequestCount--, e.writing) break;
          }

          null === r && (e.lastBufferedRequest = null);
        }

        e.bufferedRequest = r, e.bufferProcessing = !1;
      }

      function E(t) {
        return t.ending && 0 === t.length && null === t.bufferedRequest && !t.finished && !t.writing;
      }

      function M(t, e) {
        t._final(function (r) {
          e.pendingcb--, r && t.emit("error", r), e.prefinished = !0, t.emit("prefinish"), S(t, e);
        });
      }

      function S(t, e) {
        var r = E(e);
        return r && (!function (t, e) {
          e.prefinished || e.finalCalled || ("function" == typeof t._final ? (e.pendingcb++, e.finalCalled = !0, o.nextTick(M, t, e)) : (e.prefinished = !0, t.emit("prefinish")));
        }(t, e), 0 === e.pendingcb && (e.finished = !0, t.emit("finish"))), r;
      }

      f.inherits(v, h), b.prototype.getBuffer = function () {
        for (var t = this.bufferedRequest, e = []; t;) {
          e.push(t), t = t.next;
        }

        return e;
      }, function () {
        try {
          Object.defineProperty(b.prototype, "buffer", {
            get: c.deprecate(function () {
              return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
          });
        } catch (t) {}
      }(), "function" == typeof Symbol && Symbol.hasInstance && "function" == typeof Function.prototype[Symbol.hasInstance] ? (p = Function.prototype[Symbol.hasInstance], Object.defineProperty(v, Symbol.hasInstance, {
        value: function value(t) {
          return !!p.call(this, t) || this === v && t && t._writableState instanceof b;
        }
      })) : p = function p(t) {
        return t instanceof this;
      }, v.prototype.pipe = function () {
        this.emit("error", new Error("Cannot pipe, not readable"));
      }, v.prototype.write = function (t, e, r) {
        var n,
            i = this._writableState,
            s = !1,
            a = !i.objectMode && (n = t, l.isBuffer(n) || n instanceof d);
        return a && !l.isBuffer(t) && (t = function (t) {
          return l.from(t);
        }(t)), "function" == typeof e && (r = e, e = null), a ? e = "buffer" : e || (e = i.defaultEncoding), "function" != typeof r && (r = m), i.ended ? function (t, e) {
          var r = new Error("write after end");
          t.emit("error", r), o.nextTick(e, r);
        }(this, r) : (a || function (t, e, r, n) {
          var i = !0,
              s = !1;
          return null === r ? s = new TypeError("May not write null values to stream") : "string" == typeof r || void 0 === r || e.objectMode || (s = new TypeError("Invalid non-string/buffer chunk")), s && (t.emit("error", s), o.nextTick(n, s), i = !1), i;
        }(this, i, t, r)) && (i.pendingcb++, s = function (t, e, r, n, i, o) {
          if (!r) {
            var s = function (t, e, r) {
              t.objectMode || !1 === t.decodeStrings || "string" != typeof e || (e = l.from(e, r));
              return e;
            }(e, n, i);

            n !== s && (r = !0, i = "buffer", n = s);
          }

          var a = e.objectMode ? 1 : n.length;
          e.length += a;
          var u = e.length < e.highWaterMark;
          u || (e.needDrain = !0);

          if (e.writing || e.corked) {
            var f = e.lastBufferedRequest;
            e.lastBufferedRequest = {
              chunk: n,
              encoding: i,
              isBuf: r,
              callback: o,
              next: null
            }, f ? f.next = e.lastBufferedRequest : e.bufferedRequest = e.lastBufferedRequest, e.bufferedRequestCount += 1;
          } else y(t, e, !1, a, n, i, o);

          return u;
        }(this, i, a, t, e, r)), s;
      }, v.prototype.cork = function () {
        this._writableState.corked++;
      }, v.prototype.uncork = function () {
        var t = this._writableState;
        t.corked && (t.corked--, t.writing || t.corked || t.finished || t.bufferProcessing || !t.bufferedRequest || w(this, t));
      }, v.prototype.setDefaultEncoding = function (t) {
        if ("string" == typeof t && (t = t.toLowerCase()), !(["hex", "utf8", "utf-8", "ascii", "binary", "base64", "ucs2", "ucs-2", "utf16le", "utf-16le", "raw"].indexOf((t + "").toLowerCase()) > -1)) throw new TypeError("Unknown encoding: " + t);
        return this._writableState.defaultEncoding = t, this;
      }, Object.defineProperty(v.prototype, "writableHighWaterMark", {
        enumerable: !1,
        get: function get() {
          return this._writableState.highWaterMark;
        }
      }), v.prototype._write = function (t, e, r) {
        r(new Error("_write() is not implemented"));
      }, v.prototype._writev = null, v.prototype.end = function (t, e, r) {
        var n = this._writableState;
        "function" == typeof t ? (r = t, t = null, e = null) : "function" == typeof e && (r = e, e = null), null != t && this.write(t, e), n.corked && (n.corked = 1, this.uncork()), n.ending || n.finished || function (t, e, r) {
          e.ending = !0, S(t, e), r && (e.finished ? o.nextTick(r) : t.once("finish", r));
          e.ended = !0, t.writable = !1;
        }(this, n, r);
      }, Object.defineProperty(v.prototype, "destroyed", {
        get: function get() {
          return void 0 !== this._writableState && this._writableState.destroyed;
        },
        set: function set(t) {
          this._writableState && (this._writableState.destroyed = t);
        }
      }), v.prototype.destroy = g.destroy, v.prototype._undestroy = g.undestroy, v.prototype._destroy = function (t, e) {
        this.end(), e(t);
      };
    }).call(this, r(6), r(25).setImmediate, r(4));
  }, function (t, e, r) {
    "use strict";

    var n = r(1).Buffer,
        i = n.isEncoding || function (t) {
      switch ((t = "" + t) && t.toLowerCase()) {
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
        case "raw":
          return !0;

        default:
          return !1;
      }
    };

    function o(t) {
      var e;

      switch (this.encoding = function (t) {
        var e = function (t) {
          if (!t) return "utf8";

          for (var e;;) {
            switch (t) {
              case "utf8":
              case "utf-8":
                return "utf8";

              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                return "utf16le";

              case "latin1":
              case "binary":
                return "latin1";

              case "base64":
              case "ascii":
              case "hex":
                return t;

              default:
                if (e) return;
                t = ("" + t).toLowerCase(), e = !0;
            }
          }
        }(t);

        if ("string" != typeof e && (n.isEncoding === i || !i(t))) throw new Error("Unknown encoding: " + t);
        return e || t;
      }(t), this.encoding) {
        case "utf16le":
          this.text = u, this.end = f, e = 4;
          break;

        case "utf8":
          this.fillLast = a, e = 4;
          break;

        case "base64":
          this.text = c, this.end = h, e = 3;
          break;

        default:
          return this.write = l, void (this.end = d);
      }

      this.lastNeed = 0, this.lastTotal = 0, this.lastChar = n.allocUnsafe(e);
    }

    function s(t) {
      return t <= 127 ? 0 : t >> 5 == 6 ? 2 : t >> 4 == 14 ? 3 : t >> 3 == 30 ? 4 : t >> 6 == 2 ? -1 : -2;
    }

    function a(t) {
      var e = this.lastTotal - this.lastNeed,
          r = function (t, e, r) {
        if (128 != (192 & e[0])) return t.lastNeed = 0, "�";

        if (t.lastNeed > 1 && e.length > 1) {
          if (128 != (192 & e[1])) return t.lastNeed = 1, "�";
          if (t.lastNeed > 2 && e.length > 2 && 128 != (192 & e[2])) return t.lastNeed = 2, "�";
        }
      }(this, t);

      return void 0 !== r ? r : this.lastNeed <= t.length ? (t.copy(this.lastChar, e, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal)) : (t.copy(this.lastChar, e, 0, t.length), void (this.lastNeed -= t.length));
    }

    function u(t, e) {
      if ((t.length - e) % 2 == 0) {
        var r = t.toString("utf16le", e);

        if (r) {
          var n = r.charCodeAt(r.length - 1);
          if (n >= 55296 && n <= 56319) return this.lastNeed = 2, this.lastTotal = 4, this.lastChar[0] = t[t.length - 2], this.lastChar[1] = t[t.length - 1], r.slice(0, -1);
        }

        return r;
      }

      return this.lastNeed = 1, this.lastTotal = 2, this.lastChar[0] = t[t.length - 1], t.toString("utf16le", e, t.length - 1);
    }

    function f(t) {
      var e = t && t.length ? this.write(t) : "";

      if (this.lastNeed) {
        var r = this.lastTotal - this.lastNeed;
        return e + this.lastChar.toString("utf16le", 0, r);
      }

      return e;
    }

    function c(t, e) {
      var r = (t.length - e) % 3;
      return 0 === r ? t.toString("base64", e) : (this.lastNeed = 3 - r, this.lastTotal = 3, 1 === r ? this.lastChar[0] = t[t.length - 1] : (this.lastChar[0] = t[t.length - 2], this.lastChar[1] = t[t.length - 1]), t.toString("base64", e, t.length - r));
    }

    function h(t) {
      var e = t && t.length ? this.write(t) : "";
      return this.lastNeed ? e + this.lastChar.toString("base64", 0, 3 - this.lastNeed) : e;
    }

    function l(t) {
      return t.toString(this.encoding);
    }

    function d(t) {
      return t && t.length ? this.write(t) : "";
    }

    e.StringDecoder = o, o.prototype.write = function (t) {
      if (0 === t.length) return "";
      var e, r;

      if (this.lastNeed) {
        if (void 0 === (e = this.fillLast(t))) return "";
        r = this.lastNeed, this.lastNeed = 0;
      } else r = 0;

      return r < t.length ? e ? e + this.text(t, r) : this.text(t, r) : e || "";
    }, o.prototype.end = function (t) {
      var e = t && t.length ? this.write(t) : "";
      return this.lastNeed ? e + "�" : e;
    }, o.prototype.text = function (t, e) {
      var r = function (t, e, r) {
        var n = e.length - 1;
        if (n < r) return 0;
        var i = s(e[n]);
        if (i >= 0) return i > 0 && (t.lastNeed = i - 1), i;
        if (--n < r || -2 === i) return 0;
        if ((i = s(e[n])) >= 0) return i > 0 && (t.lastNeed = i - 2), i;
        if (--n < r || -2 === i) return 0;
        if ((i = s(e[n])) >= 0) return i > 0 && (2 === i ? i = 0 : t.lastNeed = i - 3), i;
        return 0;
      }(this, t, e);

      if (!this.lastNeed) return t.toString("utf8", e);
      this.lastTotal = r;
      var n = t.length - (r - this.lastNeed);
      return t.copy(this.lastChar, 0, n), t.toString("utf8", e, n);
    }, o.prototype.fillLast = function (t) {
      if (this.lastNeed <= t.length) return t.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
      t.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, t.length), this.lastNeed -= t.length;
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(0),
        i = r(124),
        o = r(125),
        s = r(126),
        a = r(131);

    function u(t) {
      a.call(this, "digest"), this._hash = t;
    }

    n(u, a), u.prototype._update = function (t) {
      this._hash.update(t);
    }, u.prototype._final = function () {
      return this._hash.digest();
    }, t.exports = function (t) {
      return "md5" === (t = t.toLowerCase()) ? new i() : "rmd160" === t || "ripemd160" === t ? new o() : new u(s(t));
    };
  }, function (t, e, r) {
    "use strict";

    var n,
        i = e,
        o = r(37),
        s = r(65),
        a = r(5).assert;

    function u(t) {
      "short" === t.type ? this.curve = new s.short(t) : "edwards" === t.type ? this.curve = new s.edwards(t) : this.curve = new s.mont(t), this.g = this.curve.g, this.n = this.curve.n, this.hash = t.hash, a(this.g.validate(), "Invalid curve"), a(this.g.mul(this.n).isInfinity(), "Invalid curve, G*N != O");
    }

    function f(t, e) {
      Object.defineProperty(i, t, {
        configurable: !0,
        enumerable: !0,
        get: function get() {
          var r = new u(e);
          return Object.defineProperty(i, t, {
            configurable: !0,
            enumerable: !0,
            value: r
          }), r;
        }
      });
    }

    i.PresetCurve = u, f("p192", {
      type: "short",
      prime: "p192",
      p: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",
      a: "ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",
      b: "64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",
      n: "ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",
      hash: o.sha256,
      gRed: !1,
      g: ["188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012", "07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"]
    }), f("p224", {
      type: "short",
      prime: "p224",
      p: "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",
      a: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",
      b: "b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",
      n: "ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",
      hash: o.sha256,
      gRed: !1,
      g: ["b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21", "bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"]
    }), f("p256", {
      type: "short",
      prime: null,
      p: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",
      a: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",
      b: "5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",
      n: "ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",
      hash: o.sha256,
      gRed: !1,
      g: ["6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296", "4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"]
    }), f("p384", {
      type: "short",
      prime: null,
      p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
      a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
      b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
      n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
      hash: o.sha384,
      gRed: !1,
      g: ["aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7", "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"]
    }), f("p521", {
      type: "short",
      prime: null,
      p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
      a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
      b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
      n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
      hash: o.sha512,
      gRed: !1,
      g: ["000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66", "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"]
    }), f("curve25519", {
      type: "mont",
      prime: "p25519",
      p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
      a: "76d06",
      b: "1",
      n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
      hash: o.sha256,
      gRed: !1,
      g: ["9"]
    }), f("ed25519", {
      type: "edwards",
      prime: "p25519",
      p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
      a: "-1",
      c: "1",
      d: "52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",
      n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
      hash: o.sha256,
      gRed: !1,
      g: ["216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a", "6666666666666666666666666666666666666666666666666666666666666658"]
    });

    try {
      n = r(145);
    } catch (t) {
      n = void 0;
    }

    f("secp256k1", {
      type: "short",
      prime: "k256",
      p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",
      a: "0",
      b: "7",
      n: "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",
      h: "1",
      hash: o.sha256,
      beta: "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",
      lambda: "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",
      basis: [{
        a: "3086d221a7d46bcde86c90e49284eb15",
        b: "-e4437ed6010e88286f547fa90abfe4c3"
      }, {
        a: "114ca50f7a8e2f3f657c1108d9d44cfd8",
        b: "3086d221a7d46bcde86c90e49284eb15"
      }],
      gRed: !1,
      g: ["79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798", "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8", n]
    });
  }, function (t, e, r) {
    var n = e;
    n.utils = r(7), n.common = r(20), n.sha = r(139), n.ripemd = r(143), n.hmac = r(144), n.sha1 = n.sha.sha1, n.sha256 = n.sha.sha256, n.sha224 = n.sha.sha224, n.sha384 = n.sha.sha384, n.sha512 = n.sha.sha512, n.ripemd160 = n.ripemd.ripemd160;
  }, function (t, e, r) {
    "use strict";

    (function (e) {
      var n = r(153);
      /*!
       * The buffer module from node.js, for the browser.
       *
       * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
       * @license  MIT
       */

      function i(t, e) {
        if (t === e) return 0;

        for (var r = t.length, n = e.length, i = 0, o = Math.min(r, n); i < o; ++i) {
          if (t[i] !== e[i]) {
            r = t[i], n = e[i];
            break;
          }
        }

        return r < n ? -1 : n < r ? 1 : 0;
      }

      function o(t) {
        return e.Buffer && "function" == typeof e.Buffer.isBuffer ? e.Buffer.isBuffer(t) : !(null == t || !t._isBuffer);
      }

      var s = r(9),
          a = Object.prototype.hasOwnProperty,
          u = Array.prototype.slice,
          f = "foo" === function () {}.name;

      function c(t) {
        return Object.prototype.toString.call(t);
      }

      function h(t) {
        return !o(t) && "function" == typeof e.ArrayBuffer && ("function" == typeof ArrayBuffer.isView ? ArrayBuffer.isView(t) : !!t && (t instanceof DataView || !!(t.buffer && t.buffer instanceof ArrayBuffer)));
      }

      var l = t.exports = v,
          d = /\s*function\s+([^\(\s]*)\s*/;

      function p(t) {
        if (s.isFunction(t)) {
          if (f) return t.name;
          var e = t.toString().match(d);
          return e && e[1];
        }
      }

      function g(t, e) {
        return "string" == typeof t ? t.length < e ? t : t.slice(0, e) : t;
      }

      function m(t) {
        if (f || !s.isFunction(t)) return s.inspect(t);
        var e = p(t);
        return "[Function" + (e ? ": " + e : "") + "]";
      }

      function b(t, e, r, n, i) {
        throw new l.AssertionError({
          message: r,
          actual: t,
          expected: e,
          operator: n,
          stackStartFunction: i
        });
      }

      function v(t, e) {
        t || b(t, !0, e, "==", l.ok);
      }

      function y(t, e, r, n) {
        if (t === e) return !0;
        if (o(t) && o(e)) return 0 === i(t, e);
        if (s.isDate(t) && s.isDate(e)) return t.getTime() === e.getTime();
        if (s.isRegExp(t) && s.isRegExp(e)) return t.source === e.source && t.global === e.global && t.multiline === e.multiline && t.lastIndex === e.lastIndex && t.ignoreCase === e.ignoreCase;

        if (null !== t && "object" == typeof t || null !== e && "object" == typeof e) {
          if (h(t) && h(e) && c(t) === c(e) && !(t instanceof Float32Array || t instanceof Float64Array)) return 0 === i(new Uint8Array(t.buffer), new Uint8Array(e.buffer));
          if (o(t) !== o(e)) return !1;
          var a = (n = n || {
            actual: [],
            expected: []
          }).actual.indexOf(t);
          return -1 !== a && a === n.expected.indexOf(e) || (n.actual.push(t), n.expected.push(e), function (t, e, r, n) {
            if (null == t || null == e) return !1;
            if (s.isPrimitive(t) || s.isPrimitive(e)) return t === e;
            if (r && Object.getPrototypeOf(t) !== Object.getPrototypeOf(e)) return !1;

            var i = _(t),
                o = _(e);

            if (i && !o || !i && o) return !1;
            if (i) return t = u.call(t), e = u.call(e), y(t, e, r);
            var a,
                f,
                c = M(t),
                h = M(e);
            if (c.length !== h.length) return !1;

            for (c.sort(), h.sort(), f = c.length - 1; f >= 0; f--) {
              if (c[f] !== h[f]) return !1;
            }

            for (f = c.length - 1; f >= 0; f--) {
              if (a = c[f], !y(t[a], e[a], r, n)) return !1;
            }

            return !0;
          }(t, e, r, n));
        }

        return r ? t === e : t == e;
      }

      function _(t) {
        return "[object Arguments]" == Object.prototype.toString.call(t);
      }

      function w(t, e) {
        if (!t || !e) return !1;
        if ("[object RegExp]" == Object.prototype.toString.call(e)) return e.test(t);

        try {
          if (t instanceof e) return !0;
        } catch (t) {}

        return !Error.isPrototypeOf(e) && !0 === e.call({}, t);
      }

      function E(t, e, r, n) {
        var i;
        if ("function" != typeof e) throw new TypeError('"block" argument must be a function');
        "string" == typeof r && (n = r, r = null), i = function (t) {
          var e;

          try {
            t();
          } catch (t) {
            e = t;
          }

          return e;
        }(e), n = (r && r.name ? " (" + r.name + ")." : ".") + (n ? " " + n : "."), t && !i && b(i, r, "Missing expected exception" + n);
        var o = "string" == typeof n,
            a = !t && i && !r;
        if ((!t && s.isError(i) && o && w(i, r) || a) && b(i, r, "Got unwanted exception" + n), t && i && r && !w(i, r) || !t && i) throw i;
      }

      l.AssertionError = function (t) {
        this.name = "AssertionError", this.actual = t.actual, this.expected = t.expected, this.operator = t.operator, t.message ? (this.message = t.message, this.generatedMessage = !1) : (this.message = function (t) {
          return g(m(t.actual), 128) + " " + t.operator + " " + g(m(t.expected), 128);
        }(this), this.generatedMessage = !0);
        var e = t.stackStartFunction || b;
        if (Error.captureStackTrace) Error.captureStackTrace(this, e);else {
          var r = new Error();

          if (r.stack) {
            var n = r.stack,
                i = p(e),
                o = n.indexOf("\n" + i);

            if (o >= 0) {
              var s = n.indexOf("\n", o + 1);
              n = n.substring(s + 1);
            }

            this.stack = n;
          }
        }
      }, s.inherits(l.AssertionError, Error), l.fail = b, l.ok = v, l.equal = function (t, e, r) {
        t != e && b(t, e, r, "==", l.equal);
      }, l.notEqual = function (t, e, r) {
        t == e && b(t, e, r, "!=", l.notEqual);
      }, l.deepEqual = function (t, e, r) {
        y(t, e, !1) || b(t, e, r, "deepEqual", l.deepEqual);
      }, l.deepStrictEqual = function (t, e, r) {
        y(t, e, !0) || b(t, e, r, "deepStrictEqual", l.deepStrictEqual);
      }, l.notDeepEqual = function (t, e, r) {
        y(t, e, !1) && b(t, e, r, "notDeepEqual", l.notDeepEqual);
      }, l.notDeepStrictEqual = function t(e, r, n) {
        y(e, r, !0) && b(e, r, n, "notDeepStrictEqual", t);
      }, l.strictEqual = function (t, e, r) {
        t !== e && b(t, e, r, "===", l.strictEqual);
      }, l.notStrictEqual = function (t, e, r) {
        t === e && b(t, e, r, "!==", l.notStrictEqual);
      }, l.throws = function (t, e, r) {
        E(!0, t, e, r);
      }, l.doesNotThrow = function (t, e, r) {
        E(!1, t, e, r);
      }, l.ifError = function (t) {
        if (t) throw t;
      }, l.strict = n(function t(e, r) {
        e || b(e, !0, r, "==", t);
      }, l, {
        equal: l.strictEqual,
        deepEqual: l.deepStrictEqual,
        notEqual: l.notStrictEqual,
        notDeepEqual: l.notDeepStrictEqual
      }), l.strict.strict = l.strict;

      var M = Object.keys || function (t) {
        var e = [];

        for (var r in t) {
          a.call(t, r) && e.push(r);
        }

        return e;
      };
    }).call(this, r(4));
  }, function (t, e, r) {
    var n = r(9),
        i = r(8);
    var o = "object" == typeof Reflect ? Reflect : null,
        s = o && "function" == typeof o.apply ? o.apply : function (t, e, r) {
      return Function.prototype.apply.call(t, e, r);
    };

    function a() {
      i.call(this);
    }

    function u(t, e, r) {
      try {
        s(t, e, r);
      } catch (t) {
        setTimeout(function () {
          throw t;
        });
      }
    }

    function f(t, e) {
      for (var r = new Array(e), n = 0; n < e; ++n) {
        r[n] = t[n];
      }

      return r;
    }

    t.exports = a, n.inherits(a, i), a.prototype.emit = function (t) {
      for (var e = [], r = 1; r < arguments.length; r++) {
        e.push(arguments[r]);
      }

      var n = "error" === t,
          i = this._events;
      if (void 0 !== i) n = n && void 0 === i.error;else if (!n) return !1;

      if (n) {
        var o;
        if (e.length > 0 && (o = e[0]), o instanceof Error) throw o;
        var s = new Error("Unhandled error." + (o ? " (" + o.message + ")" : ""));
        throw s.context = o, s;
      }

      var a = i[t];
      if (void 0 === a) return !1;
      if ("function" == typeof a) u(a, this, e);else {
        var c = a.length,
            h = f(a, c);

        for (r = 0; r < c; ++r) {
          u(h[r], this, e);
        }
      }
      return !0;
    };
  }, function (t, e, r) {
    var n = r(73),
        i = r(161),
        o = r(162),
        s = n ? n.toStringTag : void 0;

    t.exports = function (t) {
      return null == t ? void 0 === t ? "[object Undefined]" : "[object Null]" : s && s in Object(t) ? i(t) : o(t);
    };
  }, function (t, e, r) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = function (t) {
      return function () {
        if (null !== t) {
          var e = t;
          t = null, e.apply(this, arguments);
        }
      };
    }, t.exports = e.default;
  }, function (t, e) {
    t.exports = function (t) {
      return null != t && "object" == typeof t;
    };
  }, function (t, e, r) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = function (t) {
      return function () {
        if (null === t) throw new Error("Callback was already called.");
        var e = t;
        t = null, e.apply(this, arguments);
      };
    }, t.exports = e.default;
  }, function (t, e, r) {
    var n = r(193),
        i = r(29);

    t.exports = function (t) {
      return i({
        id: n(),
        jsonrpc: "2.0",
        params: []
      }, t);
    };
  }, function (t, e, r) {
    var n = r(32);

    t.exports =
    /*#__PURE__*/
    function (_n) {
      "use strict";

      _inherits(_class, _n);

      function _class(t) {
        var _this;

        _classCallCheck(this, _class);

        if (_this = _possibleConstructorReturn(this, _getPrototypeOf(_class).call(this)), !t) throw new Error("JsonRpcEngineMiddlewareSubprovider - no constructorFn specified");
        _this._constructorFn = t;
        return _possibleConstructorReturn(_this);
      }

      _createClass(_class, [{
        key: "setEngine",
        value: function setEngine(t) {
          if (this.middleware) throw new Error("JsonRpcEngineMiddlewareSubprovider - subprovider added to engine twice");

          var e = t._blockTracker,
              r = this._constructorFn({
            engine: t,
            provider: t,
            blockTracker: e
          });

          if (!r) throw new Error("JsonRpcEngineMiddlewareSubprovider - _constructorFn did not return middleware");
          if ("function" != typeof r) throw new Error("JsonRpcEngineMiddlewareSubprovider - specified middleware is not a function");
          this.middleware = r;
        }
      }, {
        key: "handleRequest",
        value: function handleRequest(t, e, r) {
          var n = {
            id: t.id
          };
          this.middleware(t, n, function (t) {
            e(function (e, r, i) {
              e ? (delete n.result, n.error = {
                message: e.message || e
              }) : n.result = r, t ? t(i) : i();
            });
          }, function (t) {
            if (t) return r(t);
            r(null, n.result);
          });
        }
      }]);

      return _class;
    }(n);
  }, function (t, e, r) {
    var n = r(196);

    t.exports = function (t) {
      return function (e, r, i, o) {
        var s = null;
        var a = t(e, r,
        /*#__PURE__*/
        _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee() {
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  s = function () {
                    return new Promise(function (t) {
                      i(function (e) {
                        return t(e);
                      });
                    });
                  }();

                  _context.next = 3;
                  return s;

                case 3:
                  return _context.abrupt("return", void _context.sent);

                case 4:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        })));
        n(a)(function (t) {
          s ? n(s)(function (e, r) {
            if (e) return console.error(e), o(e);
            r(t);
          }) : o(t);
        });
      };
    };
  }, function (t, e, r) {
    var n = r(39);

    t.exports =
    /*#__PURE__*/
    function (_n2) {
      "use strict";

      _inherits(_class2, _n2);

      function _class2() {
        var _this2;

        _classCallCheck(this, _class2);

        _this2 = _possibleConstructorReturn(this, _getPrototypeOf(_class2).call(this)), _this2.updates = [];
        return _this2;
      }

      _createClass(_class2, [{
        key: "initialize",
        value: function () {
          var _initialize = _asyncToGenerator(
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee2() {
            return _regeneratorRuntime.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2);
          }));

          function initialize() {
            return _initialize.apply(this, arguments);
          }

          return initialize;
        }()
      }, {
        key: "update",
        value: function () {
          var _update = _asyncToGenerator(
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee3() {
            return _regeneratorRuntime.wrap(function _callee3$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    throw new Error("BaseFilter - no update method specified");

                  case 1:
                  case "end":
                    return _context3.stop();
                }
              }
            }, _callee3);
          }));

          function update() {
            return _update.apply(this, arguments);
          }

          return update;
        }()
      }, {
        key: "addResults",
        value: function addResults(t) {
          var _this3 = this;

          this.updates = this.updates.concat(t), t.forEach(function (t) {
            return _this3.emit("update", t);
          });
        }
      }, {
        key: "addInitialResults",
        value: function addInitialResults(t) {}
      }, {
        key: "getChangesAndClear",
        value: function getChangesAndClear() {
          var t = this.updates;
          return this.updates = [], t;
        }
      }]);

      return _class2;
    }(n);
  }, function (t, e) {
    function r(t) {
      return null == t ? t : Number.parseInt(t, 16);
    }

    function n(t) {
      if (null == t) return t;
      return "0x" + t.toString(16);
    }

    t.exports =
    /*#__PURE__*/
    function () {
      var _ref3 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4(_ref2) {
        var t, e, i, o, s, a;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                t = _ref2.provider, e = _ref2.fromBlock, i = _ref2.toBlock;
                e || (e = i);
                o = r(e), s = r(i), a = Array(s - o + 1).fill().map(function (t, e) {
                  return o + e;
                }).map(n);
                _context4.next = 5;
                return Promise.all(a.map(function (e) {
                  return function (t, e, r) {
                    return new Promise(function (n, i) {
                      t.sendAsync({
                        id: 1,
                        jsonrpc: "2.0",
                        method: e,
                        params: r
                      }, function (t, e) {
                        if (t) return i(t);
                        n(e.result);
                      });
                    });
                  }(t, "eth_getBlockByNumber", [e, !1]);
                }));

              case 5:
                return _context4.abrupt("return", _context4.sent);

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      return function (_x) {
        return _ref3.apply(this, arguments);
      };
    }();
  }, function (t, e, r) {
    "use strict";

    (function (t) {
      Object.defineProperty(e, "__esModule", {
        value: !0
      });
      var n = r(216),
          i = r(35),
          o = r(15),
          s = r(28),
          a = r(23);
      e.keccak = function (e, r) {
        return void 0 === r && (r = 256), e = "string" != typeof e || o.isHexString(e) ? a.toBuffer(e) : t.from(e, "utf8"), r || (r = 256), n("keccak" + r).update(e).digest();
      }, e.keccak256 = function (t) {
        return e.keccak(t);
      }, e.sha256 = function (t) {
        return t = a.toBuffer(t), i("sha256").update(t).digest();
      }, e.ripemd160 = function (t, e) {
        t = a.toBuffer(t);
        var r = i("rmd160").update(t).digest();
        return !0 === e ? a.setLength(r, 32) : r;
      }, e.rlphash = function (t) {
        return e.keccak(s.encode(t));
      };
    }).call(this, r(2).Buffer);
  }, function (t, e, r) {
    var n = r(2),
        i = n.Buffer;

    function o(t, e) {
      for (var r in t) {
        e[r] = t[r];
      }
    }

    function s(t, e, r) {
      return i(t, e, r);
    }

    i.from && i.alloc && i.allocUnsafe && i.allocUnsafeSlow ? t.exports = n : (o(n, e), e.Buffer = s), s.prototype = Object.create(i.prototype), o(i, s), s.from = function (t, e, r) {
      if ("number" == typeof t) throw new TypeError("Argument must not be a number");
      return i(t, e, r);
    }, s.alloc = function (t, e, r) {
      if ("number" != typeof t) throw new TypeError("Argument must be a number");
      var n = i(t);
      return void 0 !== e ? "string" == typeof r ? n.fill(e, r) : n.fill(e) : n.fill(0), n;
    }, s.allocUnsafe = function (t) {
      if ("number" != typeof t) throw new TypeError("Argument must be a number");
      return i(t);
    }, s.allocUnsafeSlow = function (t) {
      if ("number" != typeof t) throw new TypeError("Argument must be a number");
      return n.SlowBuffer(t);
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(233),
        i = r(234);

    function o() {
      this.protocol = null, this.slashes = null, this.auth = null, this.host = null, this.port = null, this.hostname = null, this.hash = null, this.search = null, this.query = null, this.pathname = null, this.path = null, this.href = null;
    }

    e.parse = y, e.resolve = function (t, e) {
      return y(t, !1, !0).resolve(e);
    }, e.resolveObject = function (t, e) {
      return t ? y(t, !1, !0).resolveObject(e) : e;
    }, e.format = function (t) {
      i.isString(t) && (t = y(t));
      return t instanceof o ? t.format() : o.prototype.format.call(t);
    }, e.Url = o;
    var s = /^([a-z0-9.+-]+:)/i,
        a = /:[0-9]*$/,
        u = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,
        f = ["{", "}", "|", "\\", "^", "`"].concat(["<", ">", '"', "`", " ", "\r", "\n", "\t"]),
        c = ["'"].concat(f),
        h = ["%", "/", "?", ";", "#"].concat(c),
        l = ["/", "?", "#"],
        d = /^[+a-z0-9A-Z_-]{0,63}$/,
        p = /^([+a-z0-9A-Z_-]{0,63})(.*)$/,
        g = {
      javascript: !0,
      "javascript:": !0
    },
        m = {
      javascript: !0,
      "javascript:": !0
    },
        b = {
      http: !0,
      https: !0,
      ftp: !0,
      gopher: !0,
      file: !0,
      "http:": !0,
      "https:": !0,
      "ftp:": !0,
      "gopher:": !0,
      "file:": !0
    },
        v = r(235);

    function y(t, e, r) {
      if (t && i.isObject(t) && t instanceof o) return t;
      var n = new o();
      return n.parse(t, e, r), n;
    }

    o.prototype.parse = function (t, e, r) {
      if (!i.isString(t)) throw new TypeError("Parameter 'url' must be a string, not " + typeof t);
      var o = t.indexOf("?"),
          a = -1 !== o && o < t.indexOf("#") ? "?" : "#",
          f = t.split(a);
      f[0] = f[0].replace(/\\/g, "/");
      var y = t = f.join(a);

      if (y = y.trim(), !r && 1 === t.split("#").length) {
        var _ = u.exec(y);

        if (_) return this.path = y, this.href = y, this.pathname = _[1], _[2] ? (this.search = _[2], this.query = e ? v.parse(this.search.substr(1)) : this.search.substr(1)) : e && (this.search = "", this.query = {}), this;
      }

      var w = s.exec(y);

      if (w) {
        var E = (w = w[0]).toLowerCase();
        this.protocol = E, y = y.substr(w.length);
      }

      if (r || w || y.match(/^\/\/[^@\/]+@[^@\/]+/)) {
        var M = "//" === y.substr(0, 2);
        !M || w && m[w] || (y = y.substr(2), this.slashes = !0);
      }

      if (!m[w] && (M || w && !b[w])) {
        for (var S, A, x = -1, R = 0; R < l.length; R++) {
          -1 !== (T = y.indexOf(l[R])) && (-1 === x || T < x) && (x = T);
        }

        -1 !== (A = -1 === x ? y.lastIndexOf("@") : y.lastIndexOf("@", x)) && (S = y.slice(0, A), y = y.slice(A + 1), this.auth = decodeURIComponent(S)), x = -1;

        for (R = 0; R < h.length; R++) {
          var T;
          -1 !== (T = y.indexOf(h[R])) && (-1 === x || T < x) && (x = T);
        }

        -1 === x && (x = y.length), this.host = y.slice(0, x), y = y.slice(x), this.parseHost(), this.hostname = this.hostname || "";
        var k = "[" === this.hostname[0] && "]" === this.hostname[this.hostname.length - 1];
        if (!k) for (var I = this.hostname.split(/\./), B = (R = 0, I.length); R < B; R++) {
          var O = I[R];

          if (O && !O.match(d)) {
            for (var P = "", N = 0, C = O.length; N < C; N++) {
              O.charCodeAt(N) > 127 ? P += "x" : P += O[N];
            }

            if (!P.match(d)) {
              var L = I.slice(0, R),
                  j = I.slice(R + 1),
                  U = O.match(p);
              U && (L.push(U[1]), j.unshift(U[2])), j.length && (y = "/" + j.join(".") + y), this.hostname = L.join(".");
              break;
            }
          }
        }
        this.hostname.length > 255 ? this.hostname = "" : this.hostname = this.hostname.toLowerCase(), k || (this.hostname = n.toASCII(this.hostname));
        var D = this.port ? ":" + this.port : "",
            F = this.hostname || "";
        this.host = F + D, this.href += this.host, k && (this.hostname = this.hostname.substr(1, this.hostname.length - 2), "/" !== y[0] && (y = "/" + y));
      }

      if (!g[E]) for (R = 0, B = c.length; R < B; R++) {
        var z = c[R];

        if (-1 !== y.indexOf(z)) {
          var q = encodeURIComponent(z);
          q === z && (q = escape(z)), y = y.split(z).join(q);
        }
      }
      var H = y.indexOf("#");
      -1 !== H && (this.hash = y.substr(H), y = y.slice(0, H));
      var Y = y.indexOf("?");

      if (-1 !== Y ? (this.search = y.substr(Y), this.query = y.substr(Y + 1), e && (this.query = v.parse(this.query)), y = y.slice(0, Y)) : e && (this.search = "", this.query = {}), y && (this.pathname = y), b[E] && this.hostname && !this.pathname && (this.pathname = "/"), this.pathname || this.search) {
        D = this.pathname || "";
        var G = this.search || "";
        this.path = D + G;
      }

      return this.href = this.format(), this;
    }, o.prototype.format = function () {
      var t = this.auth || "";
      t && (t = (t = encodeURIComponent(t)).replace(/%3A/i, ":"), t += "@");
      var e = this.protocol || "",
          r = this.pathname || "",
          n = this.hash || "",
          o = !1,
          s = "";
      this.host ? o = t + this.host : this.hostname && (o = t + (-1 === this.hostname.indexOf(":") ? this.hostname : "[" + this.hostname + "]"), this.port && (o += ":" + this.port)), this.query && i.isObject(this.query) && Object.keys(this.query).length && (s = v.stringify(this.query));
      var a = this.search || s && "?" + s || "";
      return e && ":" !== e.substr(-1) && (e += ":"), this.slashes || (!e || b[e]) && !1 !== o ? (o = "//" + (o || ""), r && "/" !== r.charAt(0) && (r = "/" + r)) : o || (o = ""), n && "#" !== n.charAt(0) && (n = "#" + n), a && "?" !== a.charAt(0) && (a = "?" + a), e + o + (r = r.replace(/[?#]/g, function (t) {
        return encodeURIComponent(t);
      })) + (a = a.replace("#", "%23")) + n;
    }, o.prototype.resolve = function (t) {
      return this.resolveObject(y(t, !1, !0)).format();
    }, o.prototype.resolveObject = function (t) {
      if (i.isString(t)) {
        var e = new o();
        e.parse(t, !1, !0), t = e;
      }

      for (var r = new o(), n = Object.keys(this), s = 0; s < n.length; s++) {
        var a = n[s];
        r[a] = this[a];
      }

      if (r.hash = t.hash, "" === t.href) return r.href = r.format(), r;

      if (t.slashes && !t.protocol) {
        for (var u = Object.keys(t), f = 0; f < u.length; f++) {
          var c = u[f];
          "protocol" !== c && (r[c] = t[c]);
        }

        return b[r.protocol] && r.hostname && !r.pathname && (r.path = r.pathname = "/"), r.href = r.format(), r;
      }

      if (t.protocol && t.protocol !== r.protocol) {
        if (!b[t.protocol]) {
          for (var h = Object.keys(t), l = 0; l < h.length; l++) {
            var d = h[l];
            r[d] = t[d];
          }

          return r.href = r.format(), r;
        }

        if (r.protocol = t.protocol, t.host || m[t.protocol]) r.pathname = t.pathname;else {
          for (var p = (t.pathname || "").split("/"); p.length && !(t.host = p.shift());) {
            ;
          }

          t.host || (t.host = ""), t.hostname || (t.hostname = ""), "" !== p[0] && p.unshift(""), p.length < 2 && p.unshift(""), r.pathname = p.join("/");
        }

        if (r.search = t.search, r.query = t.query, r.host = t.host || "", r.auth = t.auth, r.hostname = t.hostname || t.host, r.port = t.port, r.pathname || r.search) {
          var g = r.pathname || "",
              v = r.search || "";
          r.path = g + v;
        }

        return r.slashes = r.slashes || t.slashes, r.href = r.format(), r;
      }

      var y = r.pathname && "/" === r.pathname.charAt(0),
          _ = t.host || t.pathname && "/" === t.pathname.charAt(0),
          w = _ || y || r.host && t.pathname,
          E = w,
          M = r.pathname && r.pathname.split("/") || [],
          S = (p = t.pathname && t.pathname.split("/") || [], r.protocol && !b[r.protocol]);

      if (S && (r.hostname = "", r.port = null, r.host && ("" === M[0] ? M[0] = r.host : M.unshift(r.host)), r.host = "", t.protocol && (t.hostname = null, t.port = null, t.host && ("" === p[0] ? p[0] = t.host : p.unshift(t.host)), t.host = null), w = w && ("" === p[0] || "" === M[0])), _) r.host = t.host || "" === t.host ? t.host : r.host, r.hostname = t.hostname || "" === t.hostname ? t.hostname : r.hostname, r.search = t.search, r.query = t.query, M = p;else if (p.length) M || (M = []), M.pop(), M = M.concat(p), r.search = t.search, r.query = t.query;else if (!i.isNullOrUndefined(t.search)) {
        if (S) r.hostname = r.host = M.shift(), (k = !!(r.host && r.host.indexOf("@") > 0) && r.host.split("@")) && (r.auth = k.shift(), r.host = r.hostname = k.shift());
        return r.search = t.search, r.query = t.query, i.isNull(r.pathname) && i.isNull(r.search) || (r.path = (r.pathname ? r.pathname : "") + (r.search ? r.search : "")), r.href = r.format(), r;
      }
      if (!M.length) return r.pathname = null, r.search ? r.path = "/" + r.search : r.path = null, r.href = r.format(), r;

      for (var A = M.slice(-1)[0], x = (r.host || t.host || M.length > 1) && ("." === A || ".." === A) || "" === A, R = 0, T = M.length; T >= 0; T--) {
        "." === (A = M[T]) ? M.splice(T, 1) : ".." === A ? (M.splice(T, 1), R++) : R && (M.splice(T, 1), R--);
      }

      if (!w && !E) for (; R--; R) {
        M.unshift("..");
      }
      !w || "" === M[0] || M[0] && "/" === M[0].charAt(0) || M.unshift(""), x && "/" !== M.join("/").substr(-1) && M.push("");
      var k,
          I = "" === M[0] || M[0] && "/" === M[0].charAt(0);
      S && (r.hostname = r.host = I ? "" : M.length ? M.shift() : "", (k = !!(r.host && r.host.indexOf("@") > 0) && r.host.split("@")) && (r.auth = k.shift(), r.host = r.hostname = k.shift()));
      return (w = w || r.host && M.length) && !I && M.unshift(""), M.length ? r.pathname = M.join("/") : (r.pathname = null, r.path = null), i.isNull(r.pathname) && i.isNull(r.search) || (r.path = (r.pathname ? r.pathname : "") + (r.search ? r.search : "")), r.auth = t.auth || r.auth, r.slashes = r.slashes || t.slashes, r.href = r.format(), r;
    }, o.prototype.parseHost = function () {
      var t = this.host,
          e = a.exec(t);
      e && (":" !== (e = e[0]) && (this.port = e.substr(1)), t = t.substr(0, t.length - e.length)), t && (this.hostname = t);
    };
  }, function (t, e, r) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });

    var n = function () {
      function t() {
        this.listeners = {};
      }

      return t.prototype.addEventListener = function (t, e) {
        t = t.toLowerCase(), this.listeners[t] = this.listeners[t] || [], this.listeners[t].push(e.handleEvent || e);
      }, t.prototype.removeEventListener = function (t, e) {
        if (t = t.toLowerCase(), this.listeners[t]) {
          var r = this.listeners[t].indexOf(e.handleEvent || e);
          r < 0 || this.listeners[t].splice(r, 1);
        }
      }, t.prototype.dispatchEvent = function (t) {
        var e = t.type.toLowerCase();
        if (t.target = this, this.listeners[e]) for (var r = 0, n = this.listeners[e]; r < n.length; r++) {
          n[r].call(this, t);
        }
        var i = this["on" + e];
        return i && i.call(this, t), !0;
      }, t;
    }();

    e.XMLHttpRequestEventTarget = n;
  }, function (t, e, r) {
    t.exports = function (t) {
      var e = {};

      function r(n) {
        if (e[n]) return e[n].exports;
        var i = e[n] = {
          i: n,
          l: !1,
          exports: {}
        };
        return t[n].call(i.exports, i, i.exports, r), i.l = !0, i.exports;
      }

      return r.m = t, r.c = e, r.d = function (t, e, n) {
        r.o(t, e) || Object.defineProperty(t, e, {
          enumerable: !0,
          get: n
        });
      }, r.r = function (t) {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
          value: "Module"
        }), Object.defineProperty(t, "__esModule", {
          value: !0
        });
      }, r.t = function (t, e) {
        if (1 & e && (t = r(t)), 8 & e) return t;
        if (4 & e && "object" == typeof t && t && t.__esModule) return t;
        var n = Object.create(null);
        if (r.r(n), Object.defineProperty(n, "default", {
          enumerable: !0,
          value: t
        }), 2 & e && "string" != typeof t) for (var i in t) {
          r.d(n, i, function (e) {
            return t[e];
          }.bind(null, i));
        }
        return n;
      }, r.n = function (t) {
        var e = t && t.__esModule ? function () {
          return t.default;
        } : function () {
          return t;
        };
        return r.d(e, "a", e), e;
      }, r.o = function (t, e) {
        return Object.prototype.hasOwnProperty.call(t, e);
      }, r.p = "", r(r.s = 28);
    }([function (t, e, r) {
      "use strict";

      (function (t) {
        /*!
         * The buffer module from node.js, for the browser.
         *
         * @author   Feross Aboukhadijeh <http://feross.org>
         * @license  MIT
         */
        var n = r(31),
            i = r(32),
            o = r(13);

        function s() {
          return u.TYPED_ARRAY_SUPPORT ? 2147483647 : 1073741823;
        }

        function a(t, e) {
          if (s() < e) throw new RangeError("Invalid typed array length");
          return u.TYPED_ARRAY_SUPPORT ? (t = new Uint8Array(e)).__proto__ = u.prototype : (null === t && (t = new u(e)), t.length = e), t;
        }

        function u(t, e, r) {
          if (!(u.TYPED_ARRAY_SUPPORT || this instanceof u)) return new u(t, e, r);

          if ("number" == typeof t) {
            if ("string" == typeof e) throw new Error("If encoding is specified then the first argument must be a string");
            return h(this, t);
          }

          return f(this, t, e, r);
        }

        function f(t, e, r, n) {
          if ("number" == typeof e) throw new TypeError('"value" argument must not be a number');
          return "undefined" != typeof ArrayBuffer && e instanceof ArrayBuffer ? function (t, e, r, n) {
            if (e.byteLength, r < 0 || e.byteLength < r) throw new RangeError("'offset' is out of bounds");
            if (e.byteLength < r + (n || 0)) throw new RangeError("'length' is out of bounds");
            return e = void 0 === r && void 0 === n ? new Uint8Array(e) : void 0 === n ? new Uint8Array(e, r) : new Uint8Array(e, r, n), u.TYPED_ARRAY_SUPPORT ? (t = e).__proto__ = u.prototype : t = l(t, e), t;
          }(t, e, r, n) : "string" == typeof e ? function (t, e, r) {
            if ("string" == typeof r && "" !== r || (r = "utf8"), !u.isEncoding(r)) throw new TypeError('"encoding" must be a valid string encoding');
            var n = 0 | p(e, r),
                i = (t = a(t, n)).write(e, r);
            return i !== n && (t = t.slice(0, i)), t;
          }(t, e, r) : function (t, e) {
            if (u.isBuffer(e)) {
              var r = 0 | d(e.length);
              return 0 === (t = a(t, r)).length ? t : (e.copy(t, 0, 0, r), t);
            }

            if (e) {
              if ("undefined" != typeof ArrayBuffer && e.buffer instanceof ArrayBuffer || "length" in e) return "number" != typeof e.length || (n = e.length) != n ? a(t, 0) : l(t, e);
              if ("Buffer" === e.type && o(e.data)) return l(t, e.data);
            }

            var n;
            throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
          }(t, e);
        }

        function c(t) {
          if ("number" != typeof t) throw new TypeError('"size" argument must be a number');
          if (t < 0) throw new RangeError('"size" argument must not be negative');
        }

        function h(t, e) {
          if (c(e), t = a(t, e < 0 ? 0 : 0 | d(e)), !u.TYPED_ARRAY_SUPPORT) for (var r = 0; r < e; ++r) {
            t[r] = 0;
          }
          return t;
        }

        function l(t, e) {
          var r = e.length < 0 ? 0 : 0 | d(e.length);
          t = a(t, r);

          for (var n = 0; n < r; n += 1) {
            t[n] = 255 & e[n];
          }

          return t;
        }

        function d(t) {
          if (t >= s()) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + s().toString(16) + " bytes");
          return 0 | t;
        }

        function p(t, e) {
          if (u.isBuffer(t)) return t.length;
          if ("undefined" != typeof ArrayBuffer && "function" == typeof ArrayBuffer.isView && (ArrayBuffer.isView(t) || t instanceof ArrayBuffer)) return t.byteLength;
          "string" != typeof t && (t = "" + t);
          var r = t.length;
          if (0 === r) return 0;

          for (var n = !1;;) {
            switch (e) {
              case "ascii":
              case "latin1":
              case "binary":
                return r;

              case "utf8":
              case "utf-8":
              case void 0:
                return F(t).length;

              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                return 2 * r;

              case "hex":
                return r >>> 1;

              case "base64":
                return z(t).length;

              default:
                if (n) return F(t).length;
                e = ("" + e).toLowerCase(), n = !0;
            }
          }
        }

        function g(t, e, r) {
          var n = !1;
          if ((void 0 === e || e < 0) && (e = 0), e > this.length) return "";
          if ((void 0 === r || r > this.length) && (r = this.length), r <= 0) return "";
          if ((r >>>= 0) <= (e >>>= 0)) return "";

          for (t || (t = "utf8");;) {
            switch (t) {
              case "hex":
                return k(this, e, r);

              case "utf8":
              case "utf-8":
                return x(this, e, r);

              case "ascii":
                return R(this, e, r);

              case "latin1":
              case "binary":
                return T(this, e, r);

              case "base64":
                return A(this, e, r);

              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                return I(this, e, r);

              default:
                if (n) throw new TypeError("Unknown encoding: " + t);
                t = (t + "").toLowerCase(), n = !0;
            }
          }
        }

        function m(t, e, r) {
          var n = t[e];
          t[e] = t[r], t[r] = n;
        }

        function b(t, e, r, n, i) {
          if (0 === t.length) return -1;

          if ("string" == typeof r ? (n = r, r = 0) : r > 2147483647 ? r = 2147483647 : r < -2147483648 && (r = -2147483648), r = +r, isNaN(r) && (r = i ? 0 : t.length - 1), r < 0 && (r = t.length + r), r >= t.length) {
            if (i) return -1;
            r = t.length - 1;
          } else if (r < 0) {
            if (!i) return -1;
            r = 0;
          }

          if ("string" == typeof e && (e = u.from(e, n)), u.isBuffer(e)) return 0 === e.length ? -1 : v(t, e, r, n, i);
          if ("number" == typeof e) return e &= 255, u.TYPED_ARRAY_SUPPORT && "function" == typeof Uint8Array.prototype.indexOf ? i ? Uint8Array.prototype.indexOf.call(t, e, r) : Uint8Array.prototype.lastIndexOf.call(t, e, r) : v(t, [e], r, n, i);
          throw new TypeError("val must be string, number or Buffer");
        }

        function v(t, e, r, n, i) {
          var o,
              s = 1,
              a = t.length,
              u = e.length;

          if (void 0 !== n && ("ucs2" === (n = String(n).toLowerCase()) || "ucs-2" === n || "utf16le" === n || "utf-16le" === n)) {
            if (t.length < 2 || e.length < 2) return -1;
            s = 2, a /= 2, u /= 2, r /= 2;
          }

          function f(t, e) {
            return 1 === s ? t[e] : t.readUInt16BE(e * s);
          }

          if (i) {
            var c = -1;

            for (o = r; o < a; o++) {
              if (f(t, o) === f(e, -1 === c ? 0 : o - c)) {
                if (-1 === c && (c = o), o - c + 1 === u) return c * s;
              } else -1 !== c && (o -= o - c), c = -1;
            }
          } else for (r + u > a && (r = a - u), o = r; o >= 0; o--) {
            for (var h = !0, l = 0; l < u; l++) {
              if (f(t, o + l) !== f(e, l)) {
                h = !1;
                break;
              }
            }

            if (h) return o;
          }

          return -1;
        }

        function y(t, e, r, n) {
          r = Number(r) || 0;
          var i = t.length - r;
          n ? (n = Number(n)) > i && (n = i) : n = i;
          var o = e.length;
          if (o % 2 != 0) throw new TypeError("Invalid hex string");
          n > o / 2 && (n = o / 2);

          for (var s = 0; s < n; ++s) {
            var a = parseInt(e.substr(2 * s, 2), 16);
            if (isNaN(a)) return s;
            t[r + s] = a;
          }

          return s;
        }

        function _(t, e, r, n) {
          return q(F(e, t.length - r), t, r, n);
        }

        function w(t, e, r, n) {
          return q(function (t) {
            for (var e = [], r = 0; r < t.length; ++r) {
              e.push(255 & t.charCodeAt(r));
            }

            return e;
          }(e), t, r, n);
        }

        function E(t, e, r, n) {
          return w(t, e, r, n);
        }

        function M(t, e, r, n) {
          return q(z(e), t, r, n);
        }

        function S(t, e, r, n) {
          return q(function (t, e) {
            for (var r, n, i, o = [], s = 0; s < t.length && !((e -= 2) < 0); ++s) {
              n = (r = t.charCodeAt(s)) >> 8, i = r % 256, o.push(i), o.push(n);
            }

            return o;
          }(e, t.length - r), t, r, n);
        }

        function A(t, e, r) {
          return 0 === e && r === t.length ? n.fromByteArray(t) : n.fromByteArray(t.slice(e, r));
        }

        function x(t, e, r) {
          r = Math.min(t.length, r);

          for (var n = [], i = e; i < r;) {
            var o,
                s,
                a,
                u,
                f = t[i],
                c = null,
                h = f > 239 ? 4 : f > 223 ? 3 : f > 191 ? 2 : 1;
            if (i + h <= r) switch (h) {
              case 1:
                f < 128 && (c = f);
                break;

              case 2:
                128 == (192 & (o = t[i + 1])) && (u = (31 & f) << 6 | 63 & o) > 127 && (c = u);
                break;

              case 3:
                o = t[i + 1], s = t[i + 2], 128 == (192 & o) && 128 == (192 & s) && (u = (15 & f) << 12 | (63 & o) << 6 | 63 & s) > 2047 && (u < 55296 || u > 57343) && (c = u);
                break;

              case 4:
                o = t[i + 1], s = t[i + 2], a = t[i + 3], 128 == (192 & o) && 128 == (192 & s) && 128 == (192 & a) && (u = (15 & f) << 18 | (63 & o) << 12 | (63 & s) << 6 | 63 & a) > 65535 && u < 1114112 && (c = u);
            }
            null === c ? (c = 65533, h = 1) : c > 65535 && (c -= 65536, n.push(c >>> 10 & 1023 | 55296), c = 56320 | 1023 & c), n.push(c), i += h;
          }

          return function (t) {
            var e = t.length;
            if (e <= 4096) return String.fromCharCode.apply(String, t);

            for (var r = "", n = 0; n < e;) {
              r += String.fromCharCode.apply(String, t.slice(n, n += 4096));
            }

            return r;
          }(n);
        }

        function R(t, e, r) {
          var n = "";
          r = Math.min(t.length, r);

          for (var i = e; i < r; ++i) {
            n += String.fromCharCode(127 & t[i]);
          }

          return n;
        }

        function T(t, e, r) {
          var n = "";
          r = Math.min(t.length, r);

          for (var i = e; i < r; ++i) {
            n += String.fromCharCode(t[i]);
          }

          return n;
        }

        function k(t, e, r) {
          var n = t.length;
          (!e || e < 0) && (e = 0), (!r || r < 0 || r > n) && (r = n);

          for (var i = "", o = e; o < r; ++o) {
            i += D(t[o]);
          }

          return i;
        }

        function I(t, e, r) {
          for (var n = t.slice(e, r), i = "", o = 0; o < n.length; o += 2) {
            i += String.fromCharCode(n[o] + 256 * n[o + 1]);
          }

          return i;
        }

        function B(t, e, r) {
          if (t % 1 != 0 || t < 0) throw new RangeError("offset is not uint");
          if (t + e > r) throw new RangeError("Trying to access beyond buffer length");
        }

        function O(t, e, r, n, i, o) {
          if (!u.isBuffer(t)) throw new TypeError('"buffer" argument must be a Buffer instance');
          if (e > i || e < o) throw new RangeError('"value" argument is out of bounds');
          if (r + n > t.length) throw new RangeError("Index out of range");
        }

        function P(t, e, r, n) {
          e < 0 && (e = 65535 + e + 1);

          for (var i = 0, o = Math.min(t.length - r, 2); i < o; ++i) {
            t[r + i] = (e & 255 << 8 * (n ? i : 1 - i)) >>> 8 * (n ? i : 1 - i);
          }
        }

        function N(t, e, r, n) {
          e < 0 && (e = 4294967295 + e + 1);

          for (var i = 0, o = Math.min(t.length - r, 4); i < o; ++i) {
            t[r + i] = e >>> 8 * (n ? i : 3 - i) & 255;
          }
        }

        function C(t, e, r, n, i, o) {
          if (r + n > t.length) throw new RangeError("Index out of range");
          if (r < 0) throw new RangeError("Index out of range");
        }

        function L(t, e, r, n, o) {
          return o || C(t, 0, r, 4), i.write(t, e, r, n, 23, 4), r + 4;
        }

        function j(t, e, r, n, o) {
          return o || C(t, 0, r, 8), i.write(t, e, r, n, 52, 8), r + 8;
        }

        e.Buffer = u, e.SlowBuffer = function (t) {
          return +t != t && (t = 0), u.alloc(+t);
        }, e.INSPECT_MAX_BYTES = 50, u.TYPED_ARRAY_SUPPORT = void 0 !== t.TYPED_ARRAY_SUPPORT ? t.TYPED_ARRAY_SUPPORT : function () {
          try {
            var t = new Uint8Array(1);
            return t.__proto__ = {
              __proto__: Uint8Array.prototype,
              foo: function foo() {
                return 42;
              }
            }, 42 === t.foo() && "function" == typeof t.subarray && 0 === t.subarray(1, 1).byteLength;
          } catch (t) {
            return !1;
          }
        }(), e.kMaxLength = s(), u.poolSize = 8192, u._augment = function (t) {
          return t.__proto__ = u.prototype, t;
        }, u.from = function (t, e, r) {
          return f(null, t, e, r);
        }, u.TYPED_ARRAY_SUPPORT && (u.prototype.__proto__ = Uint8Array.prototype, u.__proto__ = Uint8Array, "undefined" != typeof Symbol && Symbol.species && u[Symbol.species] === u && Object.defineProperty(u, Symbol.species, {
          value: null,
          configurable: !0
        })), u.alloc = function (t, e, r) {
          return function (t, e, r, n) {
            return c(e), e <= 0 ? a(t, e) : void 0 !== r ? "string" == typeof n ? a(t, e).fill(r, n) : a(t, e).fill(r) : a(t, e);
          }(null, t, e, r);
        }, u.allocUnsafe = function (t) {
          return h(null, t);
        }, u.allocUnsafeSlow = function (t) {
          return h(null, t);
        }, u.isBuffer = function (t) {
          return !(null == t || !t._isBuffer);
        }, u.compare = function (t, e) {
          if (!u.isBuffer(t) || !u.isBuffer(e)) throw new TypeError("Arguments must be Buffers");
          if (t === e) return 0;

          for (var r = t.length, n = e.length, i = 0, o = Math.min(r, n); i < o; ++i) {
            if (t[i] !== e[i]) {
              r = t[i], n = e[i];
              break;
            }
          }

          return r < n ? -1 : n < r ? 1 : 0;
        }, u.isEncoding = function (t) {
          switch (String(t).toLowerCase()) {
            case "hex":
            case "utf8":
            case "utf-8":
            case "ascii":
            case "latin1":
            case "binary":
            case "base64":
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              return !0;

            default:
              return !1;
          }
        }, u.concat = function (t, e) {
          if (!o(t)) throw new TypeError('"list" argument must be an Array of Buffers');
          if (0 === t.length) return u.alloc(0);
          var r;
          if (void 0 === e) for (e = 0, r = 0; r < t.length; ++r) {
            e += t[r].length;
          }
          var n = u.allocUnsafe(e),
              i = 0;

          for (r = 0; r < t.length; ++r) {
            var s = t[r];
            if (!u.isBuffer(s)) throw new TypeError('"list" argument must be an Array of Buffers');
            s.copy(n, i), i += s.length;
          }

          return n;
        }, u.byteLength = p, u.prototype._isBuffer = !0, u.prototype.swap16 = function () {
          var t = this.length;
          if (t % 2 != 0) throw new RangeError("Buffer size must be a multiple of 16-bits");

          for (var e = 0; e < t; e += 2) {
            m(this, e, e + 1);
          }

          return this;
        }, u.prototype.swap32 = function () {
          var t = this.length;
          if (t % 4 != 0) throw new RangeError("Buffer size must be a multiple of 32-bits");

          for (var e = 0; e < t; e += 4) {
            m(this, e, e + 3), m(this, e + 1, e + 2);
          }

          return this;
        }, u.prototype.swap64 = function () {
          var t = this.length;
          if (t % 8 != 0) throw new RangeError("Buffer size must be a multiple of 64-bits");

          for (var e = 0; e < t; e += 8) {
            m(this, e, e + 7), m(this, e + 1, e + 6), m(this, e + 2, e + 5), m(this, e + 3, e + 4);
          }

          return this;
        }, u.prototype.toString = function () {
          var t = 0 | this.length;
          return 0 === t ? "" : 0 === arguments.length ? x(this, 0, t) : g.apply(this, arguments);
        }, u.prototype.equals = function (t) {
          if (!u.isBuffer(t)) throw new TypeError("Argument must be a Buffer");
          return this === t || 0 === u.compare(this, t);
        }, u.prototype.inspect = function () {
          var t = "",
              r = e.INSPECT_MAX_BYTES;
          return this.length > 0 && (t = this.toString("hex", 0, r).match(/.{2}/g).join(" "), this.length > r && (t += " ... ")), "<Buffer " + t + ">";
        }, u.prototype.compare = function (t, e, r, n, i) {
          if (!u.isBuffer(t)) throw new TypeError("Argument must be a Buffer");
          if (void 0 === e && (e = 0), void 0 === r && (r = t ? t.length : 0), void 0 === n && (n = 0), void 0 === i && (i = this.length), e < 0 || r > t.length || n < 0 || i > this.length) throw new RangeError("out of range index");
          if (n >= i && e >= r) return 0;
          if (n >= i) return -1;
          if (e >= r) return 1;
          if (this === t) return 0;

          for (var o = (i >>>= 0) - (n >>>= 0), s = (r >>>= 0) - (e >>>= 0), a = Math.min(o, s), f = this.slice(n, i), c = t.slice(e, r), h = 0; h < a; ++h) {
            if (f[h] !== c[h]) {
              o = f[h], s = c[h];
              break;
            }
          }

          return o < s ? -1 : s < o ? 1 : 0;
        }, u.prototype.includes = function (t, e, r) {
          return -1 !== this.indexOf(t, e, r);
        }, u.prototype.indexOf = function (t, e, r) {
          return b(this, t, e, r, !0);
        }, u.prototype.lastIndexOf = function (t, e, r) {
          return b(this, t, e, r, !1);
        }, u.prototype.write = function (t, e, r, n) {
          if (void 0 === e) n = "utf8", r = this.length, e = 0;else if (void 0 === r && "string" == typeof e) n = e, r = this.length, e = 0;else {
            if (!isFinite(e)) throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
            e |= 0, isFinite(r) ? (r |= 0, void 0 === n && (n = "utf8")) : (n = r, r = void 0);
          }
          var i = this.length - e;
          if ((void 0 === r || r > i) && (r = i), t.length > 0 && (r < 0 || e < 0) || e > this.length) throw new RangeError("Attempt to write outside buffer bounds");
          n || (n = "utf8");

          for (var o = !1;;) {
            switch (n) {
              case "hex":
                return y(this, t, e, r);

              case "utf8":
              case "utf-8":
                return _(this, t, e, r);

              case "ascii":
                return w(this, t, e, r);

              case "latin1":
              case "binary":
                return E(this, t, e, r);

              case "base64":
                return M(this, t, e, r);

              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                return S(this, t, e, r);

              default:
                if (o) throw new TypeError("Unknown encoding: " + n);
                n = ("" + n).toLowerCase(), o = !0;
            }
          }
        }, u.prototype.toJSON = function () {
          return {
            type: "Buffer",
            data: Array.prototype.slice.call(this._arr || this, 0)
          };
        }, u.prototype.slice = function (t, e) {
          var r,
              n = this.length;
          if ((t = ~~t) < 0 ? (t += n) < 0 && (t = 0) : t > n && (t = n), (e = void 0 === e ? n : ~~e) < 0 ? (e += n) < 0 && (e = 0) : e > n && (e = n), e < t && (e = t), u.TYPED_ARRAY_SUPPORT) (r = this.subarray(t, e)).__proto__ = u.prototype;else {
            var i = e - t;
            r = new u(i, void 0);

            for (var o = 0; o < i; ++o) {
              r[o] = this[o + t];
            }
          }
          return r;
        }, u.prototype.readUIntLE = function (t, e, r) {
          t |= 0, e |= 0, r || B(t, e, this.length);

          for (var n = this[t], i = 1, o = 0; ++o < e && (i *= 256);) {
            n += this[t + o] * i;
          }

          return n;
        }, u.prototype.readUIntBE = function (t, e, r) {
          t |= 0, e |= 0, r || B(t, e, this.length);

          for (var n = this[t + --e], i = 1; e > 0 && (i *= 256);) {
            n += this[t + --e] * i;
          }

          return n;
        }, u.prototype.readUInt8 = function (t, e) {
          return e || B(t, 1, this.length), this[t];
        }, u.prototype.readUInt16LE = function (t, e) {
          return e || B(t, 2, this.length), this[t] | this[t + 1] << 8;
        }, u.prototype.readUInt16BE = function (t, e) {
          return e || B(t, 2, this.length), this[t] << 8 | this[t + 1];
        }, u.prototype.readUInt32LE = function (t, e) {
          return e || B(t, 4, this.length), (this[t] | this[t + 1] << 8 | this[t + 2] << 16) + 16777216 * this[t + 3];
        }, u.prototype.readUInt32BE = function (t, e) {
          return e || B(t, 4, this.length), 16777216 * this[t] + (this[t + 1] << 16 | this[t + 2] << 8 | this[t + 3]);
        }, u.prototype.readIntLE = function (t, e, r) {
          t |= 0, e |= 0, r || B(t, e, this.length);

          for (var n = this[t], i = 1, o = 0; ++o < e && (i *= 256);) {
            n += this[t + o] * i;
          }

          return n >= (i *= 128) && (n -= Math.pow(2, 8 * e)), n;
        }, u.prototype.readIntBE = function (t, e, r) {
          t |= 0, e |= 0, r || B(t, e, this.length);

          for (var n = e, i = 1, o = this[t + --n]; n > 0 && (i *= 256);) {
            o += this[t + --n] * i;
          }

          return o >= (i *= 128) && (o -= Math.pow(2, 8 * e)), o;
        }, u.prototype.readInt8 = function (t, e) {
          return e || B(t, 1, this.length), 128 & this[t] ? -1 * (255 - this[t] + 1) : this[t];
        }, u.prototype.readInt16LE = function (t, e) {
          e || B(t, 2, this.length);
          var r = this[t] | this[t + 1] << 8;
          return 32768 & r ? 4294901760 | r : r;
        }, u.prototype.readInt16BE = function (t, e) {
          e || B(t, 2, this.length);
          var r = this[t + 1] | this[t] << 8;
          return 32768 & r ? 4294901760 | r : r;
        }, u.prototype.readInt32LE = function (t, e) {
          return e || B(t, 4, this.length), this[t] | this[t + 1] << 8 | this[t + 2] << 16 | this[t + 3] << 24;
        }, u.prototype.readInt32BE = function (t, e) {
          return e || B(t, 4, this.length), this[t] << 24 | this[t + 1] << 16 | this[t + 2] << 8 | this[t + 3];
        }, u.prototype.readFloatLE = function (t, e) {
          return e || B(t, 4, this.length), i.read(this, t, !0, 23, 4);
        }, u.prototype.readFloatBE = function (t, e) {
          return e || B(t, 4, this.length), i.read(this, t, !1, 23, 4);
        }, u.prototype.readDoubleLE = function (t, e) {
          return e || B(t, 8, this.length), i.read(this, t, !0, 52, 8);
        }, u.prototype.readDoubleBE = function (t, e) {
          return e || B(t, 8, this.length), i.read(this, t, !1, 52, 8);
        }, u.prototype.writeUIntLE = function (t, e, r, n) {
          t = +t, e |= 0, r |= 0, n || O(this, t, e, r, Math.pow(2, 8 * r) - 1, 0);
          var i = 1,
              o = 0;

          for (this[e] = 255 & t; ++o < r && (i *= 256);) {
            this[e + o] = t / i & 255;
          }

          return e + r;
        }, u.prototype.writeUIntBE = function (t, e, r, n) {
          t = +t, e |= 0, r |= 0, n || O(this, t, e, r, Math.pow(2, 8 * r) - 1, 0);
          var i = r - 1,
              o = 1;

          for (this[e + i] = 255 & t; --i >= 0 && (o *= 256);) {
            this[e + i] = t / o & 255;
          }

          return e + r;
        }, u.prototype.writeUInt8 = function (t, e, r) {
          return t = +t, e |= 0, r || O(this, t, e, 1, 255, 0), u.TYPED_ARRAY_SUPPORT || (t = Math.floor(t)), this[e] = 255 & t, e + 1;
        }, u.prototype.writeUInt16LE = function (t, e, r) {
          return t = +t, e |= 0, r || O(this, t, e, 2, 65535, 0), u.TYPED_ARRAY_SUPPORT ? (this[e] = 255 & t, this[e + 1] = t >>> 8) : P(this, t, e, !0), e + 2;
        }, u.prototype.writeUInt16BE = function (t, e, r) {
          return t = +t, e |= 0, r || O(this, t, e, 2, 65535, 0), u.TYPED_ARRAY_SUPPORT ? (this[e] = t >>> 8, this[e + 1] = 255 & t) : P(this, t, e, !1), e + 2;
        }, u.prototype.writeUInt32LE = function (t, e, r) {
          return t = +t, e |= 0, r || O(this, t, e, 4, 4294967295, 0), u.TYPED_ARRAY_SUPPORT ? (this[e + 3] = t >>> 24, this[e + 2] = t >>> 16, this[e + 1] = t >>> 8, this[e] = 255 & t) : N(this, t, e, !0), e + 4;
        }, u.prototype.writeUInt32BE = function (t, e, r) {
          return t = +t, e |= 0, r || O(this, t, e, 4, 4294967295, 0), u.TYPED_ARRAY_SUPPORT ? (this[e] = t >>> 24, this[e + 1] = t >>> 16, this[e + 2] = t >>> 8, this[e + 3] = 255 & t) : N(this, t, e, !1), e + 4;
        }, u.prototype.writeIntLE = function (t, e, r, n) {
          if (t = +t, e |= 0, !n) {
            var i = Math.pow(2, 8 * r - 1);
            O(this, t, e, r, i - 1, -i);
          }

          var o = 0,
              s = 1,
              a = 0;

          for (this[e] = 255 & t; ++o < r && (s *= 256);) {
            t < 0 && 0 === a && 0 !== this[e + o - 1] && (a = 1), this[e + o] = (t / s >> 0) - a & 255;
          }

          return e + r;
        }, u.prototype.writeIntBE = function (t, e, r, n) {
          if (t = +t, e |= 0, !n) {
            var i = Math.pow(2, 8 * r - 1);
            O(this, t, e, r, i - 1, -i);
          }

          var o = r - 1,
              s = 1,
              a = 0;

          for (this[e + o] = 255 & t; --o >= 0 && (s *= 256);) {
            t < 0 && 0 === a && 0 !== this[e + o + 1] && (a = 1), this[e + o] = (t / s >> 0) - a & 255;
          }

          return e + r;
        }, u.prototype.writeInt8 = function (t, e, r) {
          return t = +t, e |= 0, r || O(this, t, e, 1, 127, -128), u.TYPED_ARRAY_SUPPORT || (t = Math.floor(t)), t < 0 && (t = 255 + t + 1), this[e] = 255 & t, e + 1;
        }, u.prototype.writeInt16LE = function (t, e, r) {
          return t = +t, e |= 0, r || O(this, t, e, 2, 32767, -32768), u.TYPED_ARRAY_SUPPORT ? (this[e] = 255 & t, this[e + 1] = t >>> 8) : P(this, t, e, !0), e + 2;
        }, u.prototype.writeInt16BE = function (t, e, r) {
          return t = +t, e |= 0, r || O(this, t, e, 2, 32767, -32768), u.TYPED_ARRAY_SUPPORT ? (this[e] = t >>> 8, this[e + 1] = 255 & t) : P(this, t, e, !1), e + 2;
        }, u.prototype.writeInt32LE = function (t, e, r) {
          return t = +t, e |= 0, r || O(this, t, e, 4, 2147483647, -2147483648), u.TYPED_ARRAY_SUPPORT ? (this[e] = 255 & t, this[e + 1] = t >>> 8, this[e + 2] = t >>> 16, this[e + 3] = t >>> 24) : N(this, t, e, !0), e + 4;
        }, u.prototype.writeInt32BE = function (t, e, r) {
          return t = +t, e |= 0, r || O(this, t, e, 4, 2147483647, -2147483648), t < 0 && (t = 4294967295 + t + 1), u.TYPED_ARRAY_SUPPORT ? (this[e] = t >>> 24, this[e + 1] = t >>> 16, this[e + 2] = t >>> 8, this[e + 3] = 255 & t) : N(this, t, e, !1), e + 4;
        }, u.prototype.writeFloatLE = function (t, e, r) {
          return L(this, t, e, !0, r);
        }, u.prototype.writeFloatBE = function (t, e, r) {
          return L(this, t, e, !1, r);
        }, u.prototype.writeDoubleLE = function (t, e, r) {
          return j(this, t, e, !0, r);
        }, u.prototype.writeDoubleBE = function (t, e, r) {
          return j(this, t, e, !1, r);
        }, u.prototype.copy = function (t, e, r, n) {
          if (r || (r = 0), n || 0 === n || (n = this.length), e >= t.length && (e = t.length), e || (e = 0), n > 0 && n < r && (n = r), n === r) return 0;
          if (0 === t.length || 0 === this.length) return 0;
          if (e < 0) throw new RangeError("targetStart out of bounds");
          if (r < 0 || r >= this.length) throw new RangeError("sourceStart out of bounds");
          if (n < 0) throw new RangeError("sourceEnd out of bounds");
          n > this.length && (n = this.length), t.length - e < n - r && (n = t.length - e + r);
          var i,
              o = n - r;
          if (this === t && r < e && e < n) for (i = o - 1; i >= 0; --i) {
            t[i + e] = this[i + r];
          } else if (o < 1e3 || !u.TYPED_ARRAY_SUPPORT) for (i = 0; i < o; ++i) {
            t[i + e] = this[i + r];
          } else Uint8Array.prototype.set.call(t, this.subarray(r, r + o), e);
          return o;
        }, u.prototype.fill = function (t, e, r, n) {
          if ("string" == typeof t) {
            if ("string" == typeof e ? (n = e, e = 0, r = this.length) : "string" == typeof r && (n = r, r = this.length), 1 === t.length) {
              var i = t.charCodeAt(0);
              i < 256 && (t = i);
            }

            if (void 0 !== n && "string" != typeof n) throw new TypeError("encoding must be a string");
            if ("string" == typeof n && !u.isEncoding(n)) throw new TypeError("Unknown encoding: " + n);
          } else "number" == typeof t && (t &= 255);

          if (e < 0 || this.length < e || this.length < r) throw new RangeError("Out of range index");
          if (r <= e) return this;
          var o;
          if (e >>>= 0, r = void 0 === r ? this.length : r >>> 0, t || (t = 0), "number" == typeof t) for (o = e; o < r; ++o) {
            this[o] = t;
          } else {
            var s = u.isBuffer(t) ? t : F(new u(t, n).toString()),
                a = s.length;

            for (o = 0; o < r - e; ++o) {
              this[o + e] = s[o % a];
            }
          }
          return this;
        };
        var U = /[^+\/0-9A-Za-z-_]/g;

        function D(t) {
          return t < 16 ? "0" + t.toString(16) : t.toString(16);
        }

        function F(t, e) {
          var r;
          e = e || 1 / 0;

          for (var n = t.length, i = null, o = [], s = 0; s < n; ++s) {
            if ((r = t.charCodeAt(s)) > 55295 && r < 57344) {
              if (!i) {
                if (r > 56319) {
                  (e -= 3) > -1 && o.push(239, 191, 189);
                  continue;
                }

                if (s + 1 === n) {
                  (e -= 3) > -1 && o.push(239, 191, 189);
                  continue;
                }

                i = r;
                continue;
              }

              if (r < 56320) {
                (e -= 3) > -1 && o.push(239, 191, 189), i = r;
                continue;
              }

              r = 65536 + (i - 55296 << 10 | r - 56320);
            } else i && (e -= 3) > -1 && o.push(239, 191, 189);

            if (i = null, r < 128) {
              if ((e -= 1) < 0) break;
              o.push(r);
            } else if (r < 2048) {
              if ((e -= 2) < 0) break;
              o.push(r >> 6 | 192, 63 & r | 128);
            } else if (r < 65536) {
              if ((e -= 3) < 0) break;
              o.push(r >> 12 | 224, r >> 6 & 63 | 128, 63 & r | 128);
            } else {
              if (!(r < 1114112)) throw new Error("Invalid code point");
              if ((e -= 4) < 0) break;
              o.push(r >> 18 | 240, r >> 12 & 63 | 128, r >> 6 & 63 | 128, 63 & r | 128);
            }
          }

          return o;
        }

        function z(t) {
          return n.toByteArray(function (t) {
            if ((t = function (t) {
              return t.trim ? t.trim() : t.replace(/^\s+|\s+$/g, "");
            }(t).replace(U, "")).length < 2) return "";

            for (; t.length % 4 != 0;) {
              t += "=";
            }

            return t;
          }(t));
        }

        function q(t, e, r, n) {
          for (var i = 0; i < n && !(i + r >= e.length || i >= t.length); ++i) {
            e[i + r] = t[i];
          }

          return i;
        }
      }).call(this, r(2));
    }, function (t, e) {
      var r,
          n,
          i = t.exports = {};

      function o() {
        throw new Error("setTimeout has not been defined");
      }

      function s() {
        throw new Error("clearTimeout has not been defined");
      }

      function a(t) {
        if (r === setTimeout) return setTimeout(t, 0);
        if ((r === o || !r) && setTimeout) return r = setTimeout, setTimeout(t, 0);

        try {
          return r(t, 0);
        } catch (e) {
          try {
            return r.call(null, t, 0);
          } catch (e) {
            return r.call(this, t, 0);
          }
        }
      }

      !function () {
        try {
          r = "function" == typeof setTimeout ? setTimeout : o;
        } catch (t) {
          r = o;
        }

        try {
          n = "function" == typeof clearTimeout ? clearTimeout : s;
        } catch (t) {
          n = s;
        }
      }();
      var u,
          f = [],
          c = !1,
          h = -1;

      function l() {
        c && u && (c = !1, u.length ? f = u.concat(f) : h = -1, f.length && d());
      }

      function d() {
        if (!c) {
          var t = a(l);
          c = !0;

          for (var e = f.length; e;) {
            for (u = f, f = []; ++h < e;) {
              u && u[h].run();
            }

            h = -1, e = f.length;
          }

          u = null, c = !1, function (t) {
            if (n === clearTimeout) return clearTimeout(t);
            if ((n === s || !n) && clearTimeout) return n = clearTimeout, clearTimeout(t);

            try {
              n(t);
            } catch (e) {
              try {
                return n.call(null, t);
              } catch (e) {
                return n.call(this, t);
              }
            }
          }(t);
        }
      }

      function p(t, e) {
        this.fun = t, this.array = e;
      }

      function g() {}

      i.nextTick = function (t) {
        var e = new Array(arguments.length - 1);
        if (arguments.length > 1) for (var r = 1; r < arguments.length; r++) {
          e[r - 1] = arguments[r];
        }
        f.push(new p(t, e)), 1 !== f.length || c || a(d);
      }, p.prototype.run = function () {
        this.fun.apply(null, this.array);
      }, i.title = "browser", i.browser = !0, i.env = {}, i.argv = [], i.version = "", i.versions = {}, i.on = g, i.addListener = g, i.once = g, i.off = g, i.removeListener = g, i.removeAllListeners = g, i.emit = g, i.prependListener = g, i.prependOnceListener = g, i.listeners = function (t) {
        return [];
      }, i.binding = function (t) {
        throw new Error("process.binding is not supported");
      }, i.cwd = function () {
        return "/";
      }, i.chdir = function (t) {
        throw new Error("process.chdir is not supported");
      }, i.umask = function () {
        return 0;
      };
    }, function (t, e) {
      var r;

      r = function () {
        return this;
      }();

      try {
        r = r || new Function("return this")();
      } catch (t) {
        "object" == typeof window && (r = window);
      }

      t.exports = r;
    }, function (t, e) {
      "function" == typeof Object.create ? t.exports = function (t, e) {
        t.super_ = e, t.prototype = Object.create(e.prototype, {
          constructor: {
            value: t,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        });
      } : t.exports = function (t, e) {
        t.super_ = e;

        var r = function r() {};

        r.prototype = e.prototype, t.prototype = new r(), t.prototype.constructor = t;
      };
    }, function (t, e, r) {
      "use strict";

      var n = r(6),
          i = Object.keys || function (t) {
        var e = [];

        for (var r in t) {
          e.push(r);
        }

        return e;
      };

      t.exports = h;
      var o = r(5);
      o.inherits = r(3);
      var s = r(15),
          a = r(11);
      o.inherits(h, s);

      for (var u = i(a.prototype), f = 0; f < u.length; f++) {
        var c = u[f];
        h.prototype[c] || (h.prototype[c] = a.prototype[c]);
      }

      function h(t) {
        if (!(this instanceof h)) return new h(t);
        s.call(this, t), a.call(this, t), t && !1 === t.readable && (this.readable = !1), t && !1 === t.writable && (this.writable = !1), this.allowHalfOpen = !0, t && !1 === t.allowHalfOpen && (this.allowHalfOpen = !1), this.once("end", l);
      }

      function l() {
        this.allowHalfOpen || this._writableState.ended || n.nextTick(d, this);
      }

      function d(t) {
        t.end();
      }

      Object.defineProperty(h.prototype, "writableHighWaterMark", {
        enumerable: !1,
        get: function get() {
          return this._writableState.highWaterMark;
        }
      }), Object.defineProperty(h.prototype, "destroyed", {
        get: function get() {
          return void 0 !== this._readableState && void 0 !== this._writableState && this._readableState.destroyed && this._writableState.destroyed;
        },
        set: function set(t) {
          void 0 !== this._readableState && void 0 !== this._writableState && (this._readableState.destroyed = t, this._writableState.destroyed = t);
        }
      }), h.prototype._destroy = function (t, e) {
        this.push(null), this.end(), n.nextTick(e, t);
      };
    }, function (t, e, r) {
      (function (t) {
        function r(t) {
          return Object.prototype.toString.call(t);
        }

        e.isArray = function (t) {
          return Array.isArray ? Array.isArray(t) : "[object Array]" === r(t);
        }, e.isBoolean = function (t) {
          return "boolean" == typeof t;
        }, e.isNull = function (t) {
          return null === t;
        }, e.isNullOrUndefined = function (t) {
          return null == t;
        }, e.isNumber = function (t) {
          return "number" == typeof t;
        }, e.isString = function (t) {
          return "string" == typeof t;
        }, e.isSymbol = function (t) {
          return "symbol" == typeof t;
        }, e.isUndefined = function (t) {
          return void 0 === t;
        }, e.isRegExp = function (t) {
          return "[object RegExp]" === r(t);
        }, e.isObject = function (t) {
          return "object" == typeof t && null !== t;
        }, e.isDate = function (t) {
          return "[object Date]" === r(t);
        }, e.isError = function (t) {
          return "[object Error]" === r(t) || t instanceof Error;
        }, e.isFunction = function (t) {
          return "function" == typeof t;
        }, e.isPrimitive = function (t) {
          return null === t || "boolean" == typeof t || "number" == typeof t || "string" == typeof t || "symbol" == typeof t || void 0 === t;
        }, e.isBuffer = t.isBuffer;
      }).call(this, r(0).Buffer);
    }, function (t, e, r) {
      "use strict";

      (function (e) {
        !e.version || 0 === e.version.indexOf("v0.") || 0 === e.version.indexOf("v1.") && 0 !== e.version.indexOf("v1.8.") ? t.exports = {
          nextTick: function nextTick(t, r, n, i) {
            if ("function" != typeof t) throw new TypeError('"callback" argument must be a function');
            var o,
                s,
                a = arguments.length;

            switch (a) {
              case 0:
              case 1:
                return e.nextTick(t);

              case 2:
                return e.nextTick(function () {
                  t.call(null, r);
                });

              case 3:
                return e.nextTick(function () {
                  t.call(null, r, n);
                });

              case 4:
                return e.nextTick(function () {
                  t.call(null, r, n, i);
                });

              default:
                for (o = new Array(a - 1), s = 0; s < o.length;) {
                  o[s++] = arguments[s];
                }

                return e.nextTick(function () {
                  t.apply(null, o);
                });
            }
          }
        } : t.exports = e;
      }).call(this, r(1));
    }, function (t, e, r) {
      var n = r(0),
          i = n.Buffer;

      function o(t, e) {
        for (var r in t) {
          e[r] = t[r];
        }
      }

      function s(t, e, r) {
        return i(t, e, r);
      }

      i.from && i.alloc && i.allocUnsafe && i.allocUnsafeSlow ? t.exports = n : (o(n, e), e.Buffer = s), o(i, s), s.from = function (t, e, r) {
        if ("number" == typeof t) throw new TypeError("Argument must not be a number");
        return i(t, e, r);
      }, s.alloc = function (t, e, r) {
        if ("number" != typeof t) throw new TypeError("Argument must be a number");
        var n = i(t);
        return void 0 !== e ? "string" == typeof r ? n.fill(e, r) : n.fill(e) : n.fill(0), n;
      }, s.allocUnsafe = function (t) {
        if ("number" != typeof t) throw new TypeError("Argument must be a number");
        return i(t);
      }, s.allocUnsafeSlow = function (t) {
        if ("number" != typeof t) throw new TypeError("Argument must be a number");
        return n.SlowBuffer(t);
      };
    }, function (t, e, r) {
      "use strict";

      var n = "undefined" != typeof Uint8Array && "undefined" != typeof Uint16Array && "undefined" != typeof Int32Array;

      function i(t, e) {
        return Object.prototype.hasOwnProperty.call(t, e);
      }

      e.assign = function (t) {
        for (var e = Array.prototype.slice.call(arguments, 1); e.length;) {
          var r = e.shift();

          if (r) {
            if ("object" != typeof r) throw new TypeError(r + "must be non-object");

            for (var n in r) {
              i(r, n) && (t[n] = r[n]);
            }
          }
        }

        return t;
      }, e.shrinkBuf = function (t, e) {
        return t.length === e ? t : t.subarray ? t.subarray(0, e) : (t.length = e, t);
      };
      var o = {
        arraySet: function arraySet(t, e, r, n, i) {
          if (e.subarray && t.subarray) t.set(e.subarray(r, r + n), i);else for (var o = 0; o < n; o++) {
            t[i + o] = e[r + o];
          }
        },
        flattenChunks: function flattenChunks(t) {
          var e, r, n, i, o, s;

          for (n = 0, e = 0, r = t.length; e < r; e++) {
            n += t[e].length;
          }

          for (s = new Uint8Array(n), i = 0, e = 0, r = t.length; e < r; e++) {
            o = t[e], s.set(o, i), i += o.length;
          }

          return s;
        }
      },
          s = {
        arraySet: function arraySet(t, e, r, n, i) {
          for (var o = 0; o < n; o++) {
            t[i + o] = e[r + o];
          }
        },
        flattenChunks: function flattenChunks(t) {
          return [].concat.apply([], t);
        }
      };
      e.setTyped = function (t) {
        t ? (e.Buf8 = Uint8Array, e.Buf16 = Uint16Array, e.Buf32 = Int32Array, e.assign(e, o)) : (e.Buf8 = Array, e.Buf16 = Array, e.Buf32 = Array, e.assign(e, s));
      }, e.setTyped(n);
    }, function (t, e, r) {
      "use strict";

      var n,
          i = "object" == typeof Reflect ? Reflect : null,
          o = i && "function" == typeof i.apply ? i.apply : function (t, e, r) {
        return Function.prototype.apply.call(t, e, r);
      };
      n = i && "function" == typeof i.ownKeys ? i.ownKeys : Object.getOwnPropertySymbols ? function (t) {
        return Object.getOwnPropertyNames(t).concat(Object.getOwnPropertySymbols(t));
      } : function (t) {
        return Object.getOwnPropertyNames(t);
      };

      var s = Number.isNaN || function (t) {
        return t != t;
      };

      function a() {
        a.init.call(this);
      }

      t.exports = a, a.EventEmitter = a, a.prototype._events = void 0, a.prototype._eventsCount = 0, a.prototype._maxListeners = void 0;
      var u = 10;

      function f(t) {
        if ("function" != typeof t) throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof t);
      }

      function c(t) {
        return void 0 === t._maxListeners ? a.defaultMaxListeners : t._maxListeners;
      }

      function h(t, e, r, n) {
        var i, o, s, a;
        if (f(r), void 0 === (o = t._events) ? (o = t._events = Object.create(null), t._eventsCount = 0) : (void 0 !== o.newListener && (t.emit("newListener", e, r.listener ? r.listener : r), o = t._events), s = o[e]), void 0 === s) s = o[e] = r, ++t._eventsCount;else if ("function" == typeof s ? s = o[e] = n ? [r, s] : [s, r] : n ? s.unshift(r) : s.push(r), (i = c(t)) > 0 && s.length > i && !s.warned) {
          s.warned = !0;
          var u = new Error("Possible EventEmitter memory leak detected. " + s.length + " " + String(e) + " listeners added. Use emitter.setMaxListeners() to increase limit");
          u.name = "MaxListenersExceededWarning", u.emitter = t, u.type = e, u.count = s.length, a = u, console && console.warn && console.warn(a);
        }
        return t;
      }

      function l() {
        if (!this.fired) return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, 0 === arguments.length ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
      }

      function d(t, e, r) {
        var n = {
          fired: !1,
          wrapFn: void 0,
          target: t,
          type: e,
          listener: r
        },
            i = l.bind(n);
        return i.listener = r, n.wrapFn = i, i;
      }

      function p(t, e, r) {
        var n = t._events;
        if (void 0 === n) return [];
        var i = n[e];
        return void 0 === i ? [] : "function" == typeof i ? r ? [i.listener || i] : [i] : r ? function (t) {
          for (var e = new Array(t.length), r = 0; r < e.length; ++r) {
            e[r] = t[r].listener || t[r];
          }

          return e;
        }(i) : m(i, i.length);
      }

      function g(t) {
        var e = this._events;

        if (void 0 !== e) {
          var r = e[t];
          if ("function" == typeof r) return 1;
          if (void 0 !== r) return r.length;
        }

        return 0;
      }

      function m(t, e) {
        for (var r = new Array(e), n = 0; n < e; ++n) {
          r[n] = t[n];
        }

        return r;
      }

      Object.defineProperty(a, "defaultMaxListeners", {
        enumerable: !0,
        get: function get() {
          return u;
        },
        set: function set(t) {
          if ("number" != typeof t || t < 0 || s(t)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + t + ".");
          u = t;
        }
      }), a.init = function () {
        void 0 !== this._events && this._events !== Object.getPrototypeOf(this)._events || (this._events = Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
      }, a.prototype.setMaxListeners = function (t) {
        if ("number" != typeof t || t < 0 || s(t)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + t + ".");
        return this._maxListeners = t, this;
      }, a.prototype.getMaxListeners = function () {
        return c(this);
      }, a.prototype.emit = function (t) {
        for (var e = [], r = 1; r < arguments.length; r++) {
          e.push(arguments[r]);
        }

        var n = "error" === t,
            i = this._events;
        if (void 0 !== i) n = n && void 0 === i.error;else if (!n) return !1;

        if (n) {
          var s;
          if (e.length > 0 && (s = e[0]), s instanceof Error) throw s;
          var a = new Error("Unhandled error." + (s ? " (" + s.message + ")" : ""));
          throw a.context = s, a;
        }

        var u = i[t];
        if (void 0 === u) return !1;
        if ("function" == typeof u) o(u, this, e);else {
          var f = u.length,
              c = m(u, f);

          for (r = 0; r < f; ++r) {
            o(c[r], this, e);
          }
        }
        return !0;
      }, a.prototype.addListener = function (t, e) {
        return h(this, t, e, !1);
      }, a.prototype.on = a.prototype.addListener, a.prototype.prependListener = function (t, e) {
        return h(this, t, e, !0);
      }, a.prototype.once = function (t, e) {
        return f(e), this.on(t, d(this, t, e)), this;
      }, a.prototype.prependOnceListener = function (t, e) {
        return f(e), this.prependListener(t, d(this, t, e)), this;
      }, a.prototype.removeListener = function (t, e) {
        var r, n, i, o, s;
        if (f(e), void 0 === (n = this._events)) return this;
        if (void 0 === (r = n[t])) return this;
        if (r === e || r.listener === e) 0 == --this._eventsCount ? this._events = Object.create(null) : (delete n[t], n.removeListener && this.emit("removeListener", t, r.listener || e));else if ("function" != typeof r) {
          for (i = -1, o = r.length - 1; o >= 0; o--) {
            if (r[o] === e || r[o].listener === e) {
              s = r[o].listener, i = o;
              break;
            }
          }

          if (i < 0) return this;
          0 === i ? r.shift() : function (t, e) {
            for (; e + 1 < t.length; e++) {
              t[e] = t[e + 1];
            }

            t.pop();
          }(r, i), 1 === r.length && (n[t] = r[0]), void 0 !== n.removeListener && this.emit("removeListener", t, s || e);
        }
        return this;
      }, a.prototype.off = a.prototype.removeListener, a.prototype.removeAllListeners = function (t) {
        var e, r, n;
        if (void 0 === (r = this._events)) return this;
        if (void 0 === r.removeListener) return 0 === arguments.length ? (this._events = Object.create(null), this._eventsCount = 0) : void 0 !== r[t] && (0 == --this._eventsCount ? this._events = Object.create(null) : delete r[t]), this;

        if (0 === arguments.length) {
          var i,
              o = Object.keys(r);

          for (n = 0; n < o.length; ++n) {
            "removeListener" !== (i = o[n]) && this.removeAllListeners(i);
          }

          return this.removeAllListeners("removeListener"), this._events = Object.create(null), this._eventsCount = 0, this;
        }

        if ("function" == typeof (e = r[t])) this.removeListener(t, e);else if (void 0 !== e) for (n = e.length - 1; n >= 0; n--) {
          this.removeListener(t, e[n]);
        }
        return this;
      }, a.prototype.listeners = function (t) {
        return p(this, t, !0);
      }, a.prototype.rawListeners = function (t) {
        return p(this, t, !1);
      }, a.listenerCount = function (t, e) {
        return "function" == typeof t.listenerCount ? t.listenerCount(e) : g.call(t, e);
      }, a.prototype.listenerCount = g, a.prototype.eventNames = function () {
        return this._eventsCount > 0 ? n(this._events) : [];
      };
    }, function (t, e, r) {
      (e = t.exports = r(15)).Stream = e, e.Readable = e, e.Writable = r(11), e.Duplex = r(4), e.Transform = r(19), e.PassThrough = r(39);
    }, function (t, e, r) {
      "use strict";

      (function (e, n, i) {
        var o = r(6);

        function s(t) {
          var e = this;
          this.next = null, this.entry = null, this.finish = function () {
            !function (t, e, r) {
              var n = t.entry;

              for (t.entry = null; n;) {
                var i = n.callback;
                e.pendingcb--, i(void 0), n = n.next;
              }

              e.corkedRequestsFree ? e.corkedRequestsFree.next = t : e.corkedRequestsFree = t;
            }(e, t);
          };
        }

        t.exports = v;
        var a,
            u = !e.browser && ["v0.10", "v0.9."].indexOf(e.version.slice(0, 5)) > -1 ? n : o.nextTick;
        v.WritableState = b;
        var f = r(5);
        f.inherits = r(3);

        var c,
            h = {
          deprecate: r(38)
        },
            l = r(16),
            d = r(7).Buffer,
            p = i.Uint8Array || function () {},
            g = r(17);

        function m() {}

        function b(t, e) {
          a = a || r(4), t = t || {};
          var n = e instanceof a;
          this.objectMode = !!t.objectMode, n && (this.objectMode = this.objectMode || !!t.writableObjectMode);
          var i = t.highWaterMark,
              f = t.writableHighWaterMark,
              c = this.objectMode ? 16 : 16384;
          this.highWaterMark = i || 0 === i ? i : n && (f || 0 === f) ? f : c, this.highWaterMark = Math.floor(this.highWaterMark), this.finalCalled = !1, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1, this.destroyed = !1;
          var h = !1 === t.decodeStrings;
          this.decodeStrings = !h, this.defaultEncoding = t.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function (t) {
            !function (t, e) {
              var r = t._writableState,
                  n = r.sync,
                  i = r.writecb;
              if (function (t) {
                t.writing = !1, t.writecb = null, t.length -= t.writelen, t.writelen = 0;
              }(r), e) !function (t, e, r, n, i) {
                --e.pendingcb, r ? (o.nextTick(i, n), o.nextTick(S, t, e), t._writableState.errorEmitted = !0, t.emit("error", n)) : (i(n), t._writableState.errorEmitted = !0, t.emit("error", n), S(t, e));
              }(t, r, n, e, i);else {
                var s = E(r);
                s || r.corked || r.bufferProcessing || !r.bufferedRequest || w(t, r), n ? u(_, t, r, s, i) : _(t, r, s, i);
              }
            }(e, t);
          }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.bufferedRequestCount = 0, this.corkedRequestsFree = new s(this);
        }

        function v(t) {
          if (a = a || r(4), !(c.call(v, this) || this instanceof a)) return new v(t);
          this._writableState = new b(t, this), this.writable = !0, t && ("function" == typeof t.write && (this._write = t.write), "function" == typeof t.writev && (this._writev = t.writev), "function" == typeof t.destroy && (this._destroy = t.destroy), "function" == typeof t.final && (this._final = t.final)), l.call(this);
        }

        function y(t, e, r, n, i, o, s) {
          e.writelen = n, e.writecb = s, e.writing = !0, e.sync = !0, r ? t._writev(i, e.onwrite) : t._write(i, o, e.onwrite), e.sync = !1;
        }

        function _(t, e, r, n) {
          r || function (t, e) {
            0 === e.length && e.needDrain && (e.needDrain = !1, t.emit("drain"));
          }(t, e), e.pendingcb--, n(), S(t, e);
        }

        function w(t, e) {
          e.bufferProcessing = !0;
          var r = e.bufferedRequest;

          if (t._writev && r && r.next) {
            var n = e.bufferedRequestCount,
                i = new Array(n),
                o = e.corkedRequestsFree;
            o.entry = r;

            for (var a = 0, u = !0; r;) {
              i[a] = r, r.isBuf || (u = !1), r = r.next, a += 1;
            }

            i.allBuffers = u, y(t, e, !0, e.length, i, "", o.finish), e.pendingcb++, e.lastBufferedRequest = null, o.next ? (e.corkedRequestsFree = o.next, o.next = null) : e.corkedRequestsFree = new s(e), e.bufferedRequestCount = 0;
          } else {
            for (; r;) {
              var f = r.chunk,
                  c = r.encoding,
                  h = r.callback;
              if (y(t, e, !1, e.objectMode ? 1 : f.length, f, c, h), r = r.next, e.bufferedRequestCount--, e.writing) break;
            }

            null === r && (e.lastBufferedRequest = null);
          }

          e.bufferedRequest = r, e.bufferProcessing = !1;
        }

        function E(t) {
          return t.ending && 0 === t.length && null === t.bufferedRequest && !t.finished && !t.writing;
        }

        function M(t, e) {
          t._final(function (r) {
            e.pendingcb--, r && t.emit("error", r), e.prefinished = !0, t.emit("prefinish"), S(t, e);
          });
        }

        function S(t, e) {
          var r = E(e);
          return r && (function (t, e) {
            e.prefinished || e.finalCalled || ("function" == typeof t._final ? (e.pendingcb++, e.finalCalled = !0, o.nextTick(M, t, e)) : (e.prefinished = !0, t.emit("prefinish")));
          }(t, e), 0 === e.pendingcb && (e.finished = !0, t.emit("finish"))), r;
        }

        f.inherits(v, l), b.prototype.getBuffer = function () {
          for (var t = this.bufferedRequest, e = []; t;) {
            e.push(t), t = t.next;
          }

          return e;
        }, function () {
          try {
            Object.defineProperty(b.prototype, "buffer", {
              get: h.deprecate(function () {
                return this.getBuffer();
              }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
            });
          } catch (t) {}
        }(), "function" == typeof Symbol && Symbol.hasInstance && "function" == typeof Function.prototype[Symbol.hasInstance] ? (c = Function.prototype[Symbol.hasInstance], Object.defineProperty(v, Symbol.hasInstance, {
          value: function value(t) {
            return !!c.call(this, t) || this === v && t && t._writableState instanceof b;
          }
        })) : c = function c(t) {
          return t instanceof this;
        }, v.prototype.pipe = function () {
          this.emit("error", new Error("Cannot pipe, not readable"));
        }, v.prototype.write = function (t, e, r) {
          var n,
              i = this._writableState,
              s = !1,
              a = !i.objectMode && (n = t, d.isBuffer(n) || n instanceof p);
          return a && !d.isBuffer(t) && (t = function (t) {
            return d.from(t);
          }(t)), "function" == typeof e && (r = e, e = null), a ? e = "buffer" : e || (e = i.defaultEncoding), "function" != typeof r && (r = m), i.ended ? function (t, e) {
            var r = new Error("write after end");
            t.emit("error", r), o.nextTick(e, r);
          }(this, r) : (a || function (t, e, r, n) {
            var i = !0,
                s = !1;
            return null === r ? s = new TypeError("May not write null values to stream") : "string" == typeof r || void 0 === r || e.objectMode || (s = new TypeError("Invalid non-string/buffer chunk")), s && (t.emit("error", s), o.nextTick(n, s), i = !1), i;
          }(this, i, t, r)) && (i.pendingcb++, s = function (t, e, r, n, i, o) {
            if (!r) {
              var s = function (t, e, r) {
                return t.objectMode || !1 === t.decodeStrings || "string" != typeof e || (e = d.from(e, r)), e;
              }(e, n, i);

              n !== s && (r = !0, i = "buffer", n = s);
            }

            var a = e.objectMode ? 1 : n.length;
            e.length += a;
            var u = e.length < e.highWaterMark;

            if (u || (e.needDrain = !0), e.writing || e.corked) {
              var f = e.lastBufferedRequest;
              e.lastBufferedRequest = {
                chunk: n,
                encoding: i,
                isBuf: r,
                callback: o,
                next: null
              }, f ? f.next = e.lastBufferedRequest : e.bufferedRequest = e.lastBufferedRequest, e.bufferedRequestCount += 1;
            } else y(t, e, !1, a, n, i, o);

            return u;
          }(this, i, a, t, e, r)), s;
        }, v.prototype.cork = function () {
          this._writableState.corked++;
        }, v.prototype.uncork = function () {
          var t = this._writableState;
          t.corked && (t.corked--, t.writing || t.corked || t.finished || t.bufferProcessing || !t.bufferedRequest || w(this, t));
        }, v.prototype.setDefaultEncoding = function (t) {
          if ("string" == typeof t && (t = t.toLowerCase()), !(["hex", "utf8", "utf-8", "ascii", "binary", "base64", "ucs2", "ucs-2", "utf16le", "utf-16le", "raw"].indexOf((t + "").toLowerCase()) > -1)) throw new TypeError("Unknown encoding: " + t);
          return this._writableState.defaultEncoding = t, this;
        }, Object.defineProperty(v.prototype, "writableHighWaterMark", {
          enumerable: !1,
          get: function get() {
            return this._writableState.highWaterMark;
          }
        }), v.prototype._write = function (t, e, r) {
          r(new Error("_write() is not implemented"));
        }, v.prototype._writev = null, v.prototype.end = function (t, e, r) {
          var n = this._writableState;
          "function" == typeof t ? (r = t, t = null, e = null) : "function" == typeof e && (r = e, e = null), null != t && this.write(t, e), n.corked && (n.corked = 1, this.uncork()), n.ending || n.finished || function (t, e, r) {
            e.ending = !0, S(t, e), r && (e.finished ? o.nextTick(r) : t.once("finish", r)), e.ended = !0, t.writable = !1;
          }(this, n, r);
        }, Object.defineProperty(v.prototype, "destroyed", {
          get: function get() {
            return void 0 !== this._writableState && this._writableState.destroyed;
          },
          set: function set(t) {
            this._writableState && (this._writableState.destroyed = t);
          }
        }), v.prototype.destroy = g.destroy, v.prototype._undestroy = g.undestroy, v.prototype._destroy = function (t, e) {
          this.end(), e(t);
        };
      }).call(this, r(1), r(36).setImmediate, r(2));
    }, function (t, e, r) {
      "use strict";

      r.r(e), r.d(e, "__extends", function () {
        return i;
      }), r.d(e, "__assign", function () {
        return _o;
      }), r.d(e, "__rest", function () {
        return s;
      }), r.d(e, "__decorate", function () {
        return a;
      }), r.d(e, "__param", function () {
        return u;
      }), r.d(e, "__metadata", function () {
        return f;
      }), r.d(e, "__awaiter", function () {
        return c;
      }), r.d(e, "__generator", function () {
        return h;
      }), r.d(e, "__exportStar", function () {
        return l;
      }), r.d(e, "__values", function () {
        return d;
      }), r.d(e, "__read", function () {
        return p;
      }), r.d(e, "__spread", function () {
        return g;
      }), r.d(e, "__await", function () {
        return m;
      }), r.d(e, "__asyncGenerator", function () {
        return b;
      }), r.d(e, "__asyncDelegator", function () {
        return v;
      }), r.d(e, "__asyncValues", function () {
        return y;
      }), r.d(e, "__makeTemplateObject", function () {
        return _;
      }), r.d(e, "__importStar", function () {
        return w;
      }), r.d(e, "__importDefault", function () {
        return E;
      });
      /*! *****************************************************************************
      Copyright (c) Microsoft Corporation. All rights reserved.
      Licensed under the Apache License, Version 2.0 (the "License"); you may not use
      this file except in compliance with the License. You may obtain a copy of the
      License at http://www.apache.org/licenses/LICENSE-2.0
      
      THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
      KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
      WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
      MERCHANTABLITY OR NON-INFRINGEMENT.
      
      See the Apache Version 2.0 License for specific language governing permissions
      and limitations under the License.
      ***************************************************************************** */

      var _n3 = function n(t, e) {
        return (_n3 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (t, e) {
          t.__proto__ = e;
        } || function (t, e) {
          for (var r in e) {
            e.hasOwnProperty(r) && (t[r] = e[r]);
          }
        })(t, e);
      };

      function i(t, e) {
        function r() {
          this.constructor = t;
        }

        _n3(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
      }

      var _o = function o() {
        return (_o = Object.assign || function (t) {
          for (var e, r = 1, n = arguments.length; r < n; r++) {
            for (var i in e = arguments[r]) {
              Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
            }
          }

          return t;
        }).apply(this, arguments);
      };

      function s(t, e) {
        var r = {};

        for (var n in t) {
          Object.prototype.hasOwnProperty.call(t, n) && e.indexOf(n) < 0 && (r[n] = t[n]);
        }

        if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
          var i = 0;

          for (n = Object.getOwnPropertySymbols(t); i < n.length; i++) {
            e.indexOf(n[i]) < 0 && (r[n[i]] = t[n[i]]);
          }
        }

        return r;
      }

      function a(t, e, r, n) {
        var i,
            o = arguments.length,
            s = o < 3 ? e : null === n ? n = Object.getOwnPropertyDescriptor(e, r) : n;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) s = Reflect.decorate(t, e, r, n);else for (var a = t.length - 1; a >= 0; a--) {
          (i = t[a]) && (s = (o < 3 ? i(s) : o > 3 ? i(e, r, s) : i(e, r)) || s);
        }
        return o > 3 && s && Object.defineProperty(e, r, s), s;
      }

      function u(t, e) {
        return function (r, n) {
          e(r, n, t);
        };
      }

      function f(t, e) {
        if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(t, e);
      }

      function c(t, e, r, n) {
        return new (r || (r = Promise))(function (i, o) {
          function s(t) {
            try {
              u(n.next(t));
            } catch (t) {
              o(t);
            }
          }

          function a(t) {
            try {
              u(n.throw(t));
            } catch (t) {
              o(t);
            }
          }

          function u(t) {
            t.done ? i(t.value) : new r(function (e) {
              e(t.value);
            }).then(s, a);
          }

          u((n = n.apply(t, e || [])).next());
        });
      }

      function h(t, e) {
        var r,
            n,
            i,
            o,
            s = {
          label: 0,
          sent: function sent() {
            if (1 & i[0]) throw i[1];
            return i[1];
          },
          trys: [],
          ops: []
        };
        return o = {
          next: a(0),
          throw: a(1),
          return: a(2)
        }, "function" == typeof Symbol && (o[Symbol.iterator] = function () {
          return this;
        }), o;

        function a(o) {
          return function (a) {
            return function (o) {
              if (r) throw new TypeError("Generator is already executing.");

              for (; s;) {
                try {
                  if (r = 1, n && (i = 2 & o[0] ? n.return : o[0] ? n.throw || ((i = n.return) && i.call(n), 0) : n.next) && !(i = i.call(n, o[1])).done) return i;

                  switch (n = 0, i && (o = [2 & o[0], i.value]), o[0]) {
                    case 0:
                    case 1:
                      i = o;
                      break;

                    case 4:
                      return s.label++, {
                        value: o[1],
                        done: !1
                      };

                    case 5:
                      s.label++, n = o[1], o = [0];
                      continue;

                    case 7:
                      o = s.ops.pop(), s.trys.pop();
                      continue;

                    default:
                      if (!(i = (i = s.trys).length > 0 && i[i.length - 1]) && (6 === o[0] || 2 === o[0])) {
                        s = 0;
                        continue;
                      }

                      if (3 === o[0] && (!i || o[1] > i[0] && o[1] < i[3])) {
                        s.label = o[1];
                        break;
                      }

                      if (6 === o[0] && s.label < i[1]) {
                        s.label = i[1], i = o;
                        break;
                      }

                      if (i && s.label < i[2]) {
                        s.label = i[2], s.ops.push(o);
                        break;
                      }

                      i[2] && s.ops.pop(), s.trys.pop();
                      continue;
                  }

                  o = e.call(t, s);
                } catch (t) {
                  o = [6, t], n = 0;
                } finally {
                  r = i = 0;
                }
              }

              if (5 & o[0]) throw o[1];
              return {
                value: o[0] ? o[1] : void 0,
                done: !0
              };
            }([o, a]);
          };
        }
      }

      function l(t, e) {
        for (var r in t) {
          e.hasOwnProperty(r) || (e[r] = t[r]);
        }
      }

      function d(t) {
        var e = "function" == typeof Symbol && t[Symbol.iterator],
            r = 0;
        return e ? e.call(t) : {
          next: function next() {
            return t && r >= t.length && (t = void 0), {
              value: t && t[r++],
              done: !t
            };
          }
        };
      }

      function p(t, e) {
        var r = "function" == typeof Symbol && t[Symbol.iterator];
        if (!r) return t;
        var n,
            i,
            o = r.call(t),
            s = [];

        try {
          for (; (void 0 === e || e-- > 0) && !(n = o.next()).done;) {
            s.push(n.value);
          }
        } catch (t) {
          i = {
            error: t
          };
        } finally {
          try {
            n && !n.done && (r = o.return) && r.call(o);
          } finally {
            if (i) throw i.error;
          }
        }

        return s;
      }

      function g() {
        for (var t = [], e = 0; e < arguments.length; e++) {
          t = t.concat(p(arguments[e]));
        }

        return t;
      }

      function m(t) {
        return this instanceof m ? (this.v = t, this) : new m(t);
      }

      function b(t, e, r) {
        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
        var n,
            i = r.apply(t, e || []),
            o = [];
        return n = {}, s("next"), s("throw"), s("return"), n[Symbol.asyncIterator] = function () {
          return this;
        }, n;

        function s(t) {
          i[t] && (n[t] = function (e) {
            return new Promise(function (r, n) {
              o.push([t, e, r, n]) > 1 || a(t, e);
            });
          });
        }

        function a(t, e) {
          try {
            (r = i[t](e)).value instanceof m ? Promise.resolve(r.value.v).then(u, f) : c(o[0][2], r);
          } catch (t) {
            c(o[0][3], t);
          }

          var r;
        }

        function u(t) {
          a("next", t);
        }

        function f(t) {
          a("throw", t);
        }

        function c(t, e) {
          t(e), o.shift(), o.length && a(o[0][0], o[0][1]);
        }
      }

      function v(t) {
        var e, r;
        return e = {}, n("next"), n("throw", function (t) {
          throw t;
        }), n("return"), e[Symbol.iterator] = function () {
          return this;
        }, e;

        function n(n, i) {
          e[n] = t[n] ? function (e) {
            return (r = !r) ? {
              value: m(t[n](e)),
              done: "return" === n
            } : i ? i(e) : e;
          } : i;
        }
      }

      function y(t) {
        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
        var e,
            r = t[Symbol.asyncIterator];
        return r ? r.call(t) : (t = d(t), e = {}, n("next"), n("throw"), n("return"), e[Symbol.asyncIterator] = function () {
          return this;
        }, e);

        function n(r) {
          e[r] = t[r] && function (e) {
            return new Promise(function (n, i) {
              !function (t, e, r, n) {
                Promise.resolve(n).then(function (e) {
                  t({
                    value: e,
                    done: r
                  });
                }, e);
              }(n, i, (e = t[r](e)).done, e.value);
            });
          };
        }
      }

      function _(t, e) {
        return Object.defineProperty ? Object.defineProperty(t, "raw", {
          value: e
        }) : t.raw = e, t;
      }

      function w(t) {
        if (t && t.__esModule) return t;
        var e = {};
        if (null != t) for (var r in t) {
          Object.hasOwnProperty.call(t, r) && (e[r] = t[r]);
        }
        return e.default = t, e;
      }

      function E(t) {
        return t && t.__esModule ? t : {
          default: t
        };
      }
    }, function (t, e) {
      var r = {}.toString;

      t.exports = Array.isArray || function (t) {
        return "[object Array]" == r.call(t);
      };
    }, function (t, e, r) {
      t.exports = i;
      var n = r(9).EventEmitter;

      function i() {
        n.call(this);
      }

      r(3)(i, n), i.Readable = r(10), i.Writable = r(40), i.Duplex = r(41), i.Transform = r(42), i.PassThrough = r(43), i.Stream = i, i.prototype.pipe = function (t, e) {
        var r = this;

        function i(e) {
          t.writable && !1 === t.write(e) && r.pause && r.pause();
        }

        function o() {
          r.readable && r.resume && r.resume();
        }

        r.on("data", i), t.on("drain", o), t._isStdio || e && !1 === e.end || (r.on("end", a), r.on("close", u));
        var s = !1;

        function a() {
          s || (s = !0, t.end());
        }

        function u() {
          s || (s = !0, "function" == typeof t.destroy && t.destroy());
        }

        function f(t) {
          if (c(), 0 === n.listenerCount(this, "error")) throw t;
        }

        function c() {
          r.removeListener("data", i), t.removeListener("drain", o), r.removeListener("end", a), r.removeListener("close", u), r.removeListener("error", f), t.removeListener("error", f), r.removeListener("end", c), r.removeListener("close", c), t.removeListener("close", c);
        }

        return r.on("error", f), t.on("error", f), r.on("end", c), r.on("close", c), t.on("close", c), t.emit("pipe", r), t;
      };
    }, function (t, e, r) {
      "use strict";

      (function (e, n) {
        var i = r(6);
        t.exports = y;
        var o,
            s = r(13);
        y.ReadableState = v, r(9).EventEmitter;

        var a = function a(t, e) {
          return t.listeners(e).length;
        },
            u = r(16),
            f = r(7).Buffer,
            c = e.Uint8Array || function () {},
            h = r(5);

        h.inherits = r(3);
        var l = r(33),
            d = void 0;
        d = l && l.debuglog ? l.debuglog("stream") : function () {};
        var p,
            g = r(34),
            m = r(17);
        h.inherits(y, u);
        var b = ["error", "close", "destroy", "pause", "resume"];

        function v(t, e) {
          t = t || {};
          var n = e instanceof (o = o || r(4));
          this.objectMode = !!t.objectMode, n && (this.objectMode = this.objectMode || !!t.readableObjectMode);
          var i = t.highWaterMark,
              s = t.readableHighWaterMark,
              a = this.objectMode ? 16 : 16384;
          this.highWaterMark = i || 0 === i ? i : n && (s || 0 === s) ? s : a, this.highWaterMark = Math.floor(this.highWaterMark), this.buffer = new g(), this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.destroyed = !1, this.defaultEncoding = t.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, t.encoding && (p || (p = r(18).StringDecoder), this.decoder = new p(t.encoding), this.encoding = t.encoding);
        }

        function y(t) {
          if (o = o || r(4), !(this instanceof y)) return new y(t);
          this._readableState = new v(t, this), this.readable = !0, t && ("function" == typeof t.read && (this._read = t.read), "function" == typeof t.destroy && (this._destroy = t.destroy)), u.call(this);
        }

        function _(t, e, r, n, i) {
          var o,
              s = t._readableState;
          return null === e ? (s.reading = !1, function (t, e) {
            if (!e.ended) {
              if (e.decoder) {
                var r = e.decoder.end();
                r && r.length && (e.buffer.push(r), e.length += e.objectMode ? 1 : r.length);
              }

              e.ended = !0, M(t);
            }
          }(t, s)) : (i || (o = function (t, e) {
            var r, n;
            return n = e, f.isBuffer(n) || n instanceof c || "string" == typeof e || void 0 === e || t.objectMode || (r = new TypeError("Invalid non-string/buffer chunk")), r;
          }(s, e)), o ? t.emit("error", o) : s.objectMode || e && e.length > 0 ? ("string" == typeof e || s.objectMode || Object.getPrototypeOf(e) === f.prototype || (e = function (t) {
            return f.from(t);
          }(e)), n ? s.endEmitted ? t.emit("error", new Error("stream.unshift() after end event")) : w(t, s, e, !0) : s.ended ? t.emit("error", new Error("stream.push() after EOF")) : (s.reading = !1, s.decoder && !r ? (e = s.decoder.write(e), s.objectMode || 0 !== e.length ? w(t, s, e, !1) : A(t, s)) : w(t, s, e, !1))) : n || (s.reading = !1)), function (t) {
            return !t.ended && (t.needReadable || t.length < t.highWaterMark || 0 === t.length);
          }(s);
        }

        function w(t, e, r, n) {
          e.flowing && 0 === e.length && !e.sync ? (t.emit("data", r), t.read(0)) : (e.length += e.objectMode ? 1 : r.length, n ? e.buffer.unshift(r) : e.buffer.push(r), e.needReadable && M(t)), A(t, e);
        }

        function E(t, e) {
          return t <= 0 || 0 === e.length && e.ended ? 0 : e.objectMode ? 1 : t != t ? e.flowing && e.length ? e.buffer.head.data.length : e.length : (t > e.highWaterMark && (e.highWaterMark = function (t) {
            return t >= 8388608 ? t = 8388608 : (t--, t |= t >>> 1, t |= t >>> 2, t |= t >>> 4, t |= t >>> 8, t |= t >>> 16, t++), t;
          }(t)), t <= e.length ? t : e.ended ? e.length : (e.needReadable = !0, 0));
        }

        function M(t) {
          var e = t._readableState;
          e.needReadable = !1, e.emittedReadable || (d("emitReadable", e.flowing), e.emittedReadable = !0, e.sync ? i.nextTick(S, t) : S(t));
        }

        function S(t) {
          d("emit readable"), t.emit("readable"), k(t);
        }

        function A(t, e) {
          e.readingMore || (e.readingMore = !0, i.nextTick(x, t, e));
        }

        function x(t, e) {
          for (var r = e.length; !e.reading && !e.flowing && !e.ended && e.length < e.highWaterMark && (d("maybeReadMore read 0"), t.read(0), r !== e.length);) {
            r = e.length;
          }

          e.readingMore = !1;
        }

        function R(t) {
          d("readable nexttick read 0"), t.read(0);
        }

        function T(t, e) {
          e.reading || (d("resume read 0"), t.read(0)), e.resumeScheduled = !1, e.awaitDrain = 0, t.emit("resume"), k(t), e.flowing && !e.reading && t.read(0);
        }

        function k(t) {
          var e = t._readableState;

          for (d("flow", e.flowing); e.flowing && null !== t.read();) {
            ;
          }
        }

        function I(t, e) {
          return 0 === e.length ? null : (e.objectMode ? r = e.buffer.shift() : !t || t >= e.length ? (r = e.decoder ? e.buffer.join("") : 1 === e.buffer.length ? e.buffer.head.data : e.buffer.concat(e.length), e.buffer.clear()) : r = function (t, e, r) {
            var n;
            return t < e.head.data.length ? (n = e.head.data.slice(0, t), e.head.data = e.head.data.slice(t)) : n = t === e.head.data.length ? e.shift() : r ? function (t, e) {
              var r = e.head,
                  n = 1,
                  i = r.data;

              for (t -= i.length; r = r.next;) {
                var o = r.data,
                    s = t > o.length ? o.length : t;

                if (s === o.length ? i += o : i += o.slice(0, t), 0 == (t -= s)) {
                  s === o.length ? (++n, r.next ? e.head = r.next : e.head = e.tail = null) : (e.head = r, r.data = o.slice(s));
                  break;
                }

                ++n;
              }

              return e.length -= n, i;
            }(t, e) : function (t, e) {
              var r = f.allocUnsafe(t),
                  n = e.head,
                  i = 1;

              for (n.data.copy(r), t -= n.data.length; n = n.next;) {
                var o = n.data,
                    s = t > o.length ? o.length : t;

                if (o.copy(r, r.length - t, 0, s), 0 == (t -= s)) {
                  s === o.length ? (++i, n.next ? e.head = n.next : e.head = e.tail = null) : (e.head = n, n.data = o.slice(s));
                  break;
                }

                ++i;
              }

              return e.length -= i, r;
            }(t, e), n;
          }(t, e.buffer, e.decoder), r);
          var r;
        }

        function B(t) {
          var e = t._readableState;
          if (e.length > 0) throw new Error('"endReadable()" called on non-empty stream');
          e.endEmitted || (e.ended = !0, i.nextTick(O, e, t));
        }

        function O(t, e) {
          t.endEmitted || 0 !== t.length || (t.endEmitted = !0, e.readable = !1, e.emit("end"));
        }

        function P(t, e) {
          for (var r = 0, n = t.length; r < n; r++) {
            if (t[r] === e) return r;
          }

          return -1;
        }

        Object.defineProperty(y.prototype, "destroyed", {
          get: function get() {
            return void 0 !== this._readableState && this._readableState.destroyed;
          },
          set: function set(t) {
            this._readableState && (this._readableState.destroyed = t);
          }
        }), y.prototype.destroy = m.destroy, y.prototype._undestroy = m.undestroy, y.prototype._destroy = function (t, e) {
          this.push(null), e(t);
        }, y.prototype.push = function (t, e) {
          var r,
              n = this._readableState;
          return n.objectMode ? r = !0 : "string" == typeof t && ((e = e || n.defaultEncoding) !== n.encoding && (t = f.from(t, e), e = ""), r = !0), _(this, t, e, !1, r);
        }, y.prototype.unshift = function (t) {
          return _(this, t, null, !0, !1);
        }, y.prototype.isPaused = function () {
          return !1 === this._readableState.flowing;
        }, y.prototype.setEncoding = function (t) {
          return p || (p = r(18).StringDecoder), this._readableState.decoder = new p(t), this._readableState.encoding = t, this;
        }, y.prototype.read = function (t) {
          d("read", t), t = parseInt(t, 10);
          var e = this._readableState,
              r = t;
          if (0 !== t && (e.emittedReadable = !1), 0 === t && e.needReadable && (e.length >= e.highWaterMark || e.ended)) return d("read: emitReadable", e.length, e.ended), 0 === e.length && e.ended ? B(this) : M(this), null;
          if (0 === (t = E(t, e)) && e.ended) return 0 === e.length && B(this), null;
          var n,
              i = e.needReadable;
          return d("need readable", i), (0 === e.length || e.length - t < e.highWaterMark) && d("length less than watermark", i = !0), e.ended || e.reading ? d("reading or ended", i = !1) : i && (d("do read"), e.reading = !0, e.sync = !0, 0 === e.length && (e.needReadable = !0), this._read(e.highWaterMark), e.sync = !1, e.reading || (t = E(r, e))), null === (n = t > 0 ? I(t, e) : null) ? (e.needReadable = !0, t = 0) : e.length -= t, 0 === e.length && (e.ended || (e.needReadable = !0), r !== t && e.ended && B(this)), null !== n && this.emit("data", n), n;
        }, y.prototype._read = function (t) {
          this.emit("error", new Error("_read() is not implemented"));
        }, y.prototype.pipe = function (t, e) {
          var r = this,
              o = this._readableState;

          switch (o.pipesCount) {
            case 0:
              o.pipes = t;
              break;

            case 1:
              o.pipes = [o.pipes, t];
              break;

            default:
              o.pipes.push(t);
          }

          o.pipesCount += 1, d("pipe count=%d opts=%j", o.pipesCount, e);
          var u = e && !1 === e.end || t === n.stdout || t === n.stderr ? v : f;

          function f() {
            d("onend"), t.end();
          }

          o.endEmitted ? i.nextTick(u) : r.once("end", u), t.on("unpipe", function e(n, i) {
            d("onunpipe"), n === r && i && !1 === i.hasUnpiped && (i.hasUnpiped = !0, d("cleanup"), t.removeListener("close", m), t.removeListener("finish", b), t.removeListener("drain", c), t.removeListener("error", g), t.removeListener("unpipe", e), r.removeListener("end", f), r.removeListener("end", v), r.removeListener("data", p), h = !0, !o.awaitDrain || t._writableState && !t._writableState.needDrain || c());
          });

          var c = function (t) {
            return function () {
              var e = t._readableState;
              d("pipeOnDrain", e.awaitDrain), e.awaitDrain && e.awaitDrain--, 0 === e.awaitDrain && a(t, "data") && (e.flowing = !0, k(t));
            };
          }(r);

          t.on("drain", c);
          var h = !1,
              l = !1;

          function p(e) {
            d("ondata"), l = !1, !1 !== t.write(e) || l || ((1 === o.pipesCount && o.pipes === t || o.pipesCount > 1 && -1 !== P(o.pipes, t)) && !h && (d("false write response, pause", r._readableState.awaitDrain), r._readableState.awaitDrain++, l = !0), r.pause());
          }

          function g(e) {
            d("onerror", e), v(), t.removeListener("error", g), 0 === a(t, "error") && t.emit("error", e);
          }

          function m() {
            t.removeListener("finish", b), v();
          }

          function b() {
            d("onfinish"), t.removeListener("close", m), v();
          }

          function v() {
            d("unpipe"), r.unpipe(t);
          }

          return r.on("data", p), function (t, e, r) {
            if ("function" == typeof t.prependListener) return t.prependListener(e, r);
            t._events && t._events[e] ? s(t._events[e]) ? t._events[e].unshift(r) : t._events[e] = [r, t._events[e]] : t.on(e, r);
          }(t, "error", g), t.once("close", m), t.once("finish", b), t.emit("pipe", r), o.flowing || (d("pipe resume"), r.resume()), t;
        }, y.prototype.unpipe = function (t) {
          var e = this._readableState,
              r = {
            hasUnpiped: !1
          };
          if (0 === e.pipesCount) return this;
          if (1 === e.pipesCount) return t && t !== e.pipes ? this : (t || (t = e.pipes), e.pipes = null, e.pipesCount = 0, e.flowing = !1, t && t.emit("unpipe", this, r), this);

          if (!t) {
            var n = e.pipes,
                i = e.pipesCount;
            e.pipes = null, e.pipesCount = 0, e.flowing = !1;

            for (var o = 0; o < i; o++) {
              n[o].emit("unpipe", this, r);
            }

            return this;
          }

          var s = P(e.pipes, t);
          return -1 === s ? this : (e.pipes.splice(s, 1), e.pipesCount -= 1, 1 === e.pipesCount && (e.pipes = e.pipes[0]), t.emit("unpipe", this, r), this);
        }, y.prototype.on = function (t, e) {
          var r = u.prototype.on.call(this, t, e);
          if ("data" === t) !1 !== this._readableState.flowing && this.resume();else if ("readable" === t) {
            var n = this._readableState;
            n.endEmitted || n.readableListening || (n.readableListening = n.needReadable = !0, n.emittedReadable = !1, n.reading ? n.length && M(this) : i.nextTick(R, this));
          }
          return r;
        }, y.prototype.addListener = y.prototype.on, y.prototype.resume = function () {
          var t = this._readableState;
          return t.flowing || (d("resume"), t.flowing = !0, function (t, e) {
            e.resumeScheduled || (e.resumeScheduled = !0, i.nextTick(T, t, e));
          }(this, t)), this;
        }, y.prototype.pause = function () {
          return d("call pause flowing=%j", this._readableState.flowing), !1 !== this._readableState.flowing && (d("pause"), this._readableState.flowing = !1, this.emit("pause")), this;
        }, y.prototype.wrap = function (t) {
          var e = this,
              r = this._readableState,
              n = !1;

          for (var i in t.on("end", function () {
            if (d("wrapped end"), r.decoder && !r.ended) {
              var t = r.decoder.end();
              t && t.length && e.push(t);
            }

            e.push(null);
          }), t.on("data", function (i) {
            d("wrapped data"), r.decoder && (i = r.decoder.write(i)), r.objectMode && null == i || (r.objectMode || i && i.length) && (e.push(i) || (n = !0, t.pause()));
          }), t) {
            void 0 === this[i] && "function" == typeof t[i] && (this[i] = function (e) {
              return function () {
                return t[e].apply(t, arguments);
              };
            }(i));
          }

          for (var o = 0; o < b.length; o++) {
            t.on(b[o], this.emit.bind(this, b[o]));
          }

          return this._read = function (e) {
            d("wrapped _read", e), n && (n = !1, t.resume());
          }, this;
        }, Object.defineProperty(y.prototype, "readableHighWaterMark", {
          enumerable: !1,
          get: function get() {
            return this._readableState.highWaterMark;
          }
        }), y._fromList = I;
      }).call(this, r(2), r(1));
    }, function (t, e, r) {
      t.exports = r(9).EventEmitter;
    }, function (t, e, r) {
      "use strict";

      var n = r(6);

      function i(t, e) {
        t.emit("error", e);
      }

      t.exports = {
        destroy: function destroy(t, e) {
          var r = this,
              o = this._readableState && this._readableState.destroyed,
              s = this._writableState && this._writableState.destroyed;
          return o || s ? (e ? e(t) : !t || this._writableState && this._writableState.errorEmitted || n.nextTick(i, this, t), this) : (this._readableState && (this._readableState.destroyed = !0), this._writableState && (this._writableState.destroyed = !0), this._destroy(t || null, function (t) {
            !e && t ? (n.nextTick(i, r, t), r._writableState && (r._writableState.errorEmitted = !0)) : e && e(t);
          }), this);
        },
        undestroy: function undestroy() {
          this._readableState && (this._readableState.destroyed = !1, this._readableState.reading = !1, this._readableState.ended = !1, this._readableState.endEmitted = !1), this._writableState && (this._writableState.destroyed = !1, this._writableState.ended = !1, this._writableState.ending = !1, this._writableState.finished = !1, this._writableState.errorEmitted = !1);
        }
      };
    }, function (t, e, r) {
      "use strict";

      var n = r(7).Buffer,
          i = n.isEncoding || function (t) {
        switch ((t = "" + t) && t.toLowerCase()) {
          case "hex":
          case "utf8":
          case "utf-8":
          case "ascii":
          case "binary":
          case "base64":
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
          case "raw":
            return !0;

          default:
            return !1;
        }
      };

      function o(t) {
        var e;

        switch (this.encoding = function (t) {
          var e = function (t) {
            if (!t) return "utf8";

            for (var e;;) {
              switch (t) {
                case "utf8":
                case "utf-8":
                  return "utf8";

                case "ucs2":
                case "ucs-2":
                case "utf16le":
                case "utf-16le":
                  return "utf16le";

                case "latin1":
                case "binary":
                  return "latin1";

                case "base64":
                case "ascii":
                case "hex":
                  return t;

                default:
                  if (e) return;
                  t = ("" + t).toLowerCase(), e = !0;
              }
            }
          }(t);

          if ("string" != typeof e && (n.isEncoding === i || !i(t))) throw new Error("Unknown encoding: " + t);
          return e || t;
        }(t), this.encoding) {
          case "utf16le":
            this.text = u, this.end = f, e = 4;
            break;

          case "utf8":
            this.fillLast = a, e = 4;
            break;

          case "base64":
            this.text = c, this.end = h, e = 3;
            break;

          default:
            return this.write = l, void (this.end = d);
        }

        this.lastNeed = 0, this.lastTotal = 0, this.lastChar = n.allocUnsafe(e);
      }

      function s(t) {
        return t <= 127 ? 0 : t >> 5 == 6 ? 2 : t >> 4 == 14 ? 3 : t >> 3 == 30 ? 4 : t >> 6 == 2 ? -1 : -2;
      }

      function a(t) {
        var e = this.lastTotal - this.lastNeed,
            r = function (t, e, r) {
          if (128 != (192 & e[0])) return t.lastNeed = 0, "�";

          if (t.lastNeed > 1 && e.length > 1) {
            if (128 != (192 & e[1])) return t.lastNeed = 1, "�";
            if (t.lastNeed > 2 && e.length > 2 && 128 != (192 & e[2])) return t.lastNeed = 2, "�";
          }
        }(this, t);

        return void 0 !== r ? r : this.lastNeed <= t.length ? (t.copy(this.lastChar, e, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal)) : (t.copy(this.lastChar, e, 0, t.length), void (this.lastNeed -= t.length));
      }

      function u(t, e) {
        if ((t.length - e) % 2 == 0) {
          var r = t.toString("utf16le", e);

          if (r) {
            var n = r.charCodeAt(r.length - 1);
            if (n >= 55296 && n <= 56319) return this.lastNeed = 2, this.lastTotal = 4, this.lastChar[0] = t[t.length - 2], this.lastChar[1] = t[t.length - 1], r.slice(0, -1);
          }

          return r;
        }

        return this.lastNeed = 1, this.lastTotal = 2, this.lastChar[0] = t[t.length - 1], t.toString("utf16le", e, t.length - 1);
      }

      function f(t) {
        var e = t && t.length ? this.write(t) : "";

        if (this.lastNeed) {
          var r = this.lastTotal - this.lastNeed;
          return e + this.lastChar.toString("utf16le", 0, r);
        }

        return e;
      }

      function c(t, e) {
        var r = (t.length - e) % 3;
        return 0 === r ? t.toString("base64", e) : (this.lastNeed = 3 - r, this.lastTotal = 3, 1 === r ? this.lastChar[0] = t[t.length - 1] : (this.lastChar[0] = t[t.length - 2], this.lastChar[1] = t[t.length - 1]), t.toString("base64", e, t.length - r));
      }

      function h(t) {
        var e = t && t.length ? this.write(t) : "";
        return this.lastNeed ? e + this.lastChar.toString("base64", 0, 3 - this.lastNeed) : e;
      }

      function l(t) {
        return t.toString(this.encoding);
      }

      function d(t) {
        return t && t.length ? this.write(t) : "";
      }

      e.StringDecoder = o, o.prototype.write = function (t) {
        if (0 === t.length) return "";
        var e, r;

        if (this.lastNeed) {
          if (void 0 === (e = this.fillLast(t))) return "";
          r = this.lastNeed, this.lastNeed = 0;
        } else r = 0;

        return r < t.length ? e ? e + this.text(t, r) : this.text(t, r) : e || "";
      }, o.prototype.end = function (t) {
        var e = t && t.length ? this.write(t) : "";
        return this.lastNeed ? e + "�" : e;
      }, o.prototype.text = function (t, e) {
        var r = function (t, e, r) {
          var n = e.length - 1;
          if (n < r) return 0;
          var i = s(e[n]);
          return i >= 0 ? (i > 0 && (t.lastNeed = i - 1), i) : --n < r || -2 === i ? 0 : (i = s(e[n])) >= 0 ? (i > 0 && (t.lastNeed = i - 2), i) : --n < r || -2 === i ? 0 : (i = s(e[n])) >= 0 ? (i > 0 && (2 === i ? i = 0 : t.lastNeed = i - 3), i) : 0;
        }(this, t, e);

        if (!this.lastNeed) return t.toString("utf8", e);
        this.lastTotal = r;
        var n = t.length - (r - this.lastNeed);
        return t.copy(this.lastChar, 0, n), t.toString("utf8", e, n);
      }, o.prototype.fillLast = function (t) {
        if (this.lastNeed <= t.length) return t.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
        t.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, t.length), this.lastNeed -= t.length;
      };
    }, function (t, e, r) {
      "use strict";

      t.exports = s;
      var n = r(4),
          i = r(5);

      function o(t, e) {
        var r = this._transformState;
        r.transforming = !1;
        var n = r.writecb;
        if (!n) return this.emit("error", new Error("write callback called multiple times"));
        r.writechunk = null, r.writecb = null, null != e && this.push(e), n(t);
        var i = this._readableState;
        i.reading = !1, (i.needReadable || i.length < i.highWaterMark) && this._read(i.highWaterMark);
      }

      function s(t) {
        if (!(this instanceof s)) return new s(t);
        n.call(this, t), this._transformState = {
          afterTransform: o.bind(this),
          needTransform: !1,
          transforming: !1,
          writecb: null,
          writechunk: null,
          writeencoding: null
        }, this._readableState.needReadable = !0, this._readableState.sync = !1, t && ("function" == typeof t.transform && (this._transform = t.transform), "function" == typeof t.flush && (this._flush = t.flush)), this.on("prefinish", a);
      }

      function a() {
        var t = this;
        "function" == typeof this._flush ? this._flush(function (e, r) {
          u(t, e, r);
        }) : u(this, null, null);
      }

      function u(t, e, r) {
        if (e) return t.emit("error", e);
        if (null != r && t.push(r), t._writableState.length) throw new Error("Calling transform done when ws.length != 0");
        if (t._transformState.transforming) throw new Error("Calling transform done when still transforming");
        return t.push(null);
      }

      i.inherits = r(3), i.inherits(s, n), s.prototype.push = function (t, e) {
        return this._transformState.needTransform = !1, n.prototype.push.call(this, t, e);
      }, s.prototype._transform = function (t, e, r) {
        throw new Error("_transform() is not implemented");
      }, s.prototype._write = function (t, e, r) {
        var n = this._transformState;

        if (n.writecb = r, n.writechunk = t, n.writeencoding = e, !n.transforming) {
          var i = this._readableState;
          (n.needTransform || i.needReadable || i.length < i.highWaterMark) && this._read(i.highWaterMark);
        }
      }, s.prototype._read = function (t) {
        var e = this._transformState;
        null !== e.writechunk && e.writecb && !e.transforming ? (e.transforming = !0, this._transform(e.writechunk, e.writeencoding, e.afterTransform)) : e.needTransform = !0;
      }, s.prototype._destroy = function (t, e) {
        var r = this;

        n.prototype._destroy.call(this, t, function (t) {
          e(t), r.emit("close");
        });
      };
    }, function (t, e, r) {
      "use strict";

      (function (e) {
        var n = r(51);
        /*!
         * The buffer module from node.js, for the browser.
         *
         * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
         * @license  MIT
         */

        function i(t, e) {
          if (t === e) return 0;

          for (var r = t.length, n = e.length, i = 0, o = Math.min(r, n); i < o; ++i) {
            if (t[i] !== e[i]) {
              r = t[i], n = e[i];
              break;
            }
          }

          return r < n ? -1 : n < r ? 1 : 0;
        }

        function o(t) {
          return e.Buffer && "function" == typeof e.Buffer.isBuffer ? e.Buffer.isBuffer(t) : !(null == t || !t._isBuffer);
        }

        var s = r(21),
            a = Object.prototype.hasOwnProperty,
            u = Array.prototype.slice,
            f = "foo" === function () {}.name;

        function c(t) {
          return Object.prototype.toString.call(t);
        }

        function h(t) {
          return !o(t) && "function" == typeof e.ArrayBuffer && ("function" == typeof ArrayBuffer.isView ? ArrayBuffer.isView(t) : !!t && (t instanceof DataView || !!(t.buffer && t.buffer instanceof ArrayBuffer)));
        }

        var l = t.exports = v,
            d = /\s*function\s+([^\(\s]*)\s*/;

        function p(t) {
          if (s.isFunction(t)) {
            if (f) return t.name;
            var e = t.toString().match(d);
            return e && e[1];
          }
        }

        function g(t, e) {
          return "string" == typeof t ? t.length < e ? t : t.slice(0, e) : t;
        }

        function m(t) {
          if (f || !s.isFunction(t)) return s.inspect(t);
          var e = p(t);
          return "[Function" + (e ? ": " + e : "") + "]";
        }

        function b(t, e, r, n, i) {
          throw new l.AssertionError({
            message: r,
            actual: t,
            expected: e,
            operator: n,
            stackStartFunction: i
          });
        }

        function v(t, e) {
          t || b(t, !0, e, "==", l.ok);
        }

        function y(t, e, r, n) {
          if (t === e) return !0;
          if (o(t) && o(e)) return 0 === i(t, e);
          if (s.isDate(t) && s.isDate(e)) return t.getTime() === e.getTime();
          if (s.isRegExp(t) && s.isRegExp(e)) return t.source === e.source && t.global === e.global && t.multiline === e.multiline && t.lastIndex === e.lastIndex && t.ignoreCase === e.ignoreCase;

          if (null !== t && "object" == typeof t || null !== e && "object" == typeof e) {
            if (h(t) && h(e) && c(t) === c(e) && !(t instanceof Float32Array || t instanceof Float64Array)) return 0 === i(new Uint8Array(t.buffer), new Uint8Array(e.buffer));
            if (o(t) !== o(e)) return !1;
            var a = (n = n || {
              actual: [],
              expected: []
            }).actual.indexOf(t);
            return -1 !== a && a === n.expected.indexOf(e) || (n.actual.push(t), n.expected.push(e), function (t, e, r, n) {
              if (null == t || null == e) return !1;
              if (s.isPrimitive(t) || s.isPrimitive(e)) return t === e;
              if (r && Object.getPrototypeOf(t) !== Object.getPrototypeOf(e)) return !1;

              var i = _(t),
                  o = _(e);

              if (i && !o || !i && o) return !1;
              if (i) return y(t = u.call(t), e = u.call(e), r);
              var a,
                  f,
                  c = M(t),
                  h = M(e);
              if (c.length !== h.length) return !1;

              for (c.sort(), h.sort(), f = c.length - 1; f >= 0; f--) {
                if (c[f] !== h[f]) return !1;
              }

              for (f = c.length - 1; f >= 0; f--) {
                if (!y(t[a = c[f]], e[a], r, n)) return !1;
              }

              return !0;
            }(t, e, r, n));
          }

          return r ? t === e : t == e;
        }

        function _(t) {
          return "[object Arguments]" == Object.prototype.toString.call(t);
        }

        function w(t, e) {
          if (!t || !e) return !1;
          if ("[object RegExp]" == Object.prototype.toString.call(e)) return e.test(t);

          try {
            if (t instanceof e) return !0;
          } catch (t) {}

          return !Error.isPrototypeOf(e) && !0 === e.call({}, t);
        }

        function E(t, e, r, n) {
          var i;
          if ("function" != typeof e) throw new TypeError('"block" argument must be a function');
          "string" == typeof r && (n = r, r = null), i = function (t) {
            var e;

            try {
              t();
            } catch (t) {
              e = t;
            }

            return e;
          }(e), n = (r && r.name ? " (" + r.name + ")." : ".") + (n ? " " + n : "."), t && !i && b(i, r, "Missing expected exception" + n);
          var o = "string" == typeof n,
              a = !t && i && !r;
          if ((!t && s.isError(i) && o && w(i, r) || a) && b(i, r, "Got unwanted exception" + n), t && i && r && !w(i, r) || !t && i) throw i;
        }

        l.AssertionError = function (t) {
          this.name = "AssertionError", this.actual = t.actual, this.expected = t.expected, this.operator = t.operator, t.message ? (this.message = t.message, this.generatedMessage = !1) : (this.message = function (t) {
            return g(m(t.actual), 128) + " " + t.operator + " " + g(m(t.expected), 128);
          }(this), this.generatedMessage = !0);
          var e = t.stackStartFunction || b;
          if (Error.captureStackTrace) Error.captureStackTrace(this, e);else {
            var r = new Error();

            if (r.stack) {
              var n = r.stack,
                  i = p(e),
                  o = n.indexOf("\n" + i);

              if (o >= 0) {
                var s = n.indexOf("\n", o + 1);
                n = n.substring(s + 1);
              }

              this.stack = n;
            }
          }
        }, s.inherits(l.AssertionError, Error), l.fail = b, l.ok = v, l.equal = function (t, e, r) {
          t != e && b(t, e, r, "==", l.equal);
        }, l.notEqual = function (t, e, r) {
          t == e && b(t, e, r, "!=", l.notEqual);
        }, l.deepEqual = function (t, e, r) {
          y(t, e, !1) || b(t, e, r, "deepEqual", l.deepEqual);
        }, l.deepStrictEqual = function (t, e, r) {
          y(t, e, !0) || b(t, e, r, "deepStrictEqual", l.deepStrictEqual);
        }, l.notDeepEqual = function (t, e, r) {
          y(t, e, !1) && b(t, e, r, "notDeepEqual", l.notDeepEqual);
        }, l.notDeepStrictEqual = function t(e, r, n) {
          y(e, r, !0) && b(e, r, n, "notDeepStrictEqual", t);
        }, l.strictEqual = function (t, e, r) {
          t !== e && b(t, e, r, "===", l.strictEqual);
        }, l.notStrictEqual = function (t, e, r) {
          t === e && b(t, e, r, "!==", l.notStrictEqual);
        }, l.throws = function (t, e, r) {
          E(!0, t, e, r);
        }, l.doesNotThrow = function (t, e, r) {
          E(!1, t, e, r);
        }, l.ifError = function (t) {
          if (t) throw t;
        }, l.strict = n(function t(e, r) {
          e || b(e, !0, r, "==", t);
        }, l, {
          equal: l.strictEqual,
          deepEqual: l.deepStrictEqual,
          notEqual: l.notStrictEqual,
          notDeepEqual: l.notDeepStrictEqual
        }), l.strict.strict = l.strict;

        var M = Object.keys || function (t) {
          var e = [];

          for (var r in t) {
            a.call(t, r) && e.push(r);
          }

          return e;
        };
      }).call(this, r(2));
    }, function (t, e, r) {
      (function (t) {
        var n = Object.getOwnPropertyDescriptors || function (t) {
          for (var e = Object.keys(t), r = {}, n = 0; n < e.length; n++) {
            r[e[n]] = Object.getOwnPropertyDescriptor(t, e[n]);
          }

          return r;
        },
            i = /%[sdj%]/g;

        e.format = function (t) {
          if (!b(t)) {
            for (var e = [], r = 0; r < arguments.length; r++) {
              e.push(a(arguments[r]));
            }

            return e.join(" ");
          }

          r = 1;

          for (var n = arguments, o = n.length, s = String(t).replace(i, function (t) {
            if ("%%" === t) return "%";
            if (r >= o) return t;

            switch (t) {
              case "%s":
                return String(n[r++]);

              case "%d":
                return Number(n[r++]);

              case "%j":
                try {
                  return JSON.stringify(n[r++]);
                } catch (t) {
                  return "[Circular]";
                }

              default:
                return t;
            }
          }), u = n[r]; r < o; u = n[++r]) {
            g(u) || !_(u) ? s += " " + u : s += " " + a(u);
          }

          return s;
        }, e.deprecate = function (r, n) {
          if (void 0 !== t && !0 === t.noDeprecation) return r;
          if (void 0 === t) return function () {
            return e.deprecate(r, n).apply(this, arguments);
          };
          var i = !1;
          return function () {
            if (!i) {
              if (t.throwDeprecation) throw new Error(n);
              t.traceDeprecation ? console.trace(n) : console.error(n), i = !0;
            }

            return r.apply(this, arguments);
          };
        };
        var o,
            s = {};

        function a(t, r) {
          var n = {
            seen: [],
            stylize: f
          };
          return arguments.length >= 3 && (n.depth = arguments[2]), arguments.length >= 4 && (n.colors = arguments[3]), p(r) ? n.showHidden = r : r && e._extend(n, r), v(n.showHidden) && (n.showHidden = !1), v(n.depth) && (n.depth = 2), v(n.colors) && (n.colors = !1), v(n.customInspect) && (n.customInspect = !0), n.colors && (n.stylize = u), c(n, t, n.depth);
        }

        function u(t, e) {
          var r = a.styles[e];
          return r ? "[" + a.colors[r][0] + "m" + t + "[" + a.colors[r][1] + "m" : t;
        }

        function f(t, e) {
          return t;
        }

        function c(t, r, n) {
          if (t.customInspect && r && M(r.inspect) && r.inspect !== e.inspect && (!r.constructor || r.constructor.prototype !== r)) {
            var i = r.inspect(n, t);
            return b(i) || (i = c(t, i, n)), i;
          }

          var o = function (t, e) {
            if (v(e)) return t.stylize("undefined", "undefined");

            if (b(e)) {
              var r = "'" + JSON.stringify(e).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
              return t.stylize(r, "string");
            }

            return m(e) ? t.stylize("" + e, "number") : p(e) ? t.stylize("" + e, "boolean") : g(e) ? t.stylize("null", "null") : void 0;
          }(t, r);

          if (o) return o;

          var s = Object.keys(r),
              a = function (t) {
            var e = {};
            return t.forEach(function (t, r) {
              e[t] = !0;
            }), e;
          }(s);

          if (t.showHidden && (s = Object.getOwnPropertyNames(r)), E(r) && (s.indexOf("message") >= 0 || s.indexOf("description") >= 0)) return h(r);

          if (0 === s.length) {
            if (M(r)) {
              var u = r.name ? ": " + r.name : "";
              return t.stylize("[Function" + u + "]", "special");
            }

            if (y(r)) return t.stylize(RegExp.prototype.toString.call(r), "regexp");
            if (w(r)) return t.stylize(Date.prototype.toString.call(r), "date");
            if (E(r)) return h(r);
          }

          var f,
              _ = "",
              S = !1,
              A = ["{", "}"];
          return d(r) && (S = !0, A = ["[", "]"]), M(r) && (_ = " [Function" + (r.name ? ": " + r.name : "") + "]"), y(r) && (_ = " " + RegExp.prototype.toString.call(r)), w(r) && (_ = " " + Date.prototype.toUTCString.call(r)), E(r) && (_ = " " + h(r)), 0 !== s.length || S && 0 != r.length ? n < 0 ? y(r) ? t.stylize(RegExp.prototype.toString.call(r), "regexp") : t.stylize("[Object]", "special") : (t.seen.push(r), f = S ? function (t, e, r, n, i) {
            for (var o = [], s = 0, a = e.length; s < a; ++s) {
              T(e, String(s)) ? o.push(l(t, e, r, n, String(s), !0)) : o.push("");
            }

            return i.forEach(function (i) {
              i.match(/^\d+$/) || o.push(l(t, e, r, n, i, !0));
            }), o;
          }(t, r, n, a, s) : s.map(function (e) {
            return l(t, r, n, a, e, S);
          }), t.seen.pop(), function (t, e, r) {
            return t.reduce(function (t, e) {
              return e.indexOf("\n"), t + e.replace(/\u001b\[\d\d?m/g, "").length + 1;
            }, 0) > 60 ? r[0] + ("" === e ? "" : e + "\n ") + " " + t.join(",\n  ") + " " + r[1] : r[0] + e + " " + t.join(", ") + " " + r[1];
          }(f, _, A)) : A[0] + _ + A[1];
        }

        function h(t) {
          return "[" + Error.prototype.toString.call(t) + "]";
        }

        function l(t, e, r, n, i, o) {
          var s, a, u;

          if ((u = Object.getOwnPropertyDescriptor(e, i) || {
            value: e[i]
          }).get ? a = u.set ? t.stylize("[Getter/Setter]", "special") : t.stylize("[Getter]", "special") : u.set && (a = t.stylize("[Setter]", "special")), T(n, i) || (s = "[" + i + "]"), a || (t.seen.indexOf(u.value) < 0 ? (a = g(r) ? c(t, u.value, null) : c(t, u.value, r - 1)).indexOf("\n") > -1 && (a = o ? a.split("\n").map(function (t) {
            return "  " + t;
          }).join("\n").substr(2) : "\n" + a.split("\n").map(function (t) {
            return "   " + t;
          }).join("\n")) : a = t.stylize("[Circular]", "special")), v(s)) {
            if (o && i.match(/^\d+$/)) return a;
            (s = JSON.stringify("" + i)).match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/) ? (s = s.substr(1, s.length - 2), s = t.stylize(s, "name")) : (s = s.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'"), s = t.stylize(s, "string"));
          }

          return s + ": " + a;
        }

        function d(t) {
          return Array.isArray(t);
        }

        function p(t) {
          return "boolean" == typeof t;
        }

        function g(t) {
          return null === t;
        }

        function m(t) {
          return "number" == typeof t;
        }

        function b(t) {
          return "string" == typeof t;
        }

        function v(t) {
          return void 0 === t;
        }

        function y(t) {
          return _(t) && "[object RegExp]" === S(t);
        }

        function _(t) {
          return "object" == typeof t && null !== t;
        }

        function w(t) {
          return _(t) && "[object Date]" === S(t);
        }

        function E(t) {
          return _(t) && ("[object Error]" === S(t) || t instanceof Error);
        }

        function M(t) {
          return "function" == typeof t;
        }

        function S(t) {
          return Object.prototype.toString.call(t);
        }

        function A(t) {
          return t < 10 ? "0" + t.toString(10) : t.toString(10);
        }

        e.debuglog = function (r) {
          if (v(o) && (o = t.env.NODE_DEBUG || ""), r = r.toUpperCase(), !s[r]) if (new RegExp("\\b" + r + "\\b", "i").test(o)) {
            var n = t.pid;

            s[r] = function () {
              var t = e.format.apply(e, arguments);
              console.error("%s %d: %s", r, n, t);
            };
          } else s[r] = function () {};
          return s[r];
        }, e.inspect = a, a.colors = {
          bold: [1, 22],
          italic: [3, 23],
          underline: [4, 24],
          inverse: [7, 27],
          white: [37, 39],
          grey: [90, 39],
          black: [30, 39],
          blue: [34, 39],
          cyan: [36, 39],
          green: [32, 39],
          magenta: [35, 39],
          red: [31, 39],
          yellow: [33, 39]
        }, a.styles = {
          special: "cyan",
          number: "yellow",
          boolean: "yellow",
          undefined: "grey",
          null: "bold",
          string: "green",
          date: "magenta",
          regexp: "red"
        }, e.isArray = d, e.isBoolean = p, e.isNull = g, e.isNullOrUndefined = function (t) {
          return null == t;
        }, e.isNumber = m, e.isString = b, e.isSymbol = function (t) {
          return "symbol" == typeof t;
        }, e.isUndefined = v, e.isRegExp = y, e.isObject = _, e.isDate = w, e.isError = E, e.isFunction = M, e.isPrimitive = function (t) {
          return null === t || "boolean" == typeof t || "number" == typeof t || "string" == typeof t || "symbol" == typeof t || void 0 === t;
        }, e.isBuffer = r(52);
        var x = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

        function R() {
          var t = new Date(),
              e = [A(t.getHours()), A(t.getMinutes()), A(t.getSeconds())].join(":");
          return [t.getDate(), x[t.getMonth()], e].join(" ");
        }

        function T(t, e) {
          return Object.prototype.hasOwnProperty.call(t, e);
        }

        e.log = function () {
          console.log("%s - %s", R(), e.format.apply(e, arguments));
        }, e.inherits = r(3), e._extend = function (t, e) {
          if (!e || !_(e)) return t;

          for (var r = Object.keys(e), n = r.length; n--;) {
            t[r[n]] = e[r[n]];
          }

          return t;
        };
        var k = "undefined" != typeof Symbol ? Symbol("util.promisify.custom") : void 0;

        function I(t, e) {
          if (!t) {
            var r = new Error("Promise was rejected with a falsy value");
            r.reason = t, t = r;
          }

          return e(t);
        }

        e.promisify = function (t) {
          if ("function" != typeof t) throw new TypeError('The "original" argument must be of type Function');

          if (k && t[k]) {
            var e;
            if ("function" != typeof (e = t[k])) throw new TypeError('The "util.promisify.custom" argument must be of type Function');
            return Object.defineProperty(e, k, {
              value: e,
              enumerable: !1,
              writable: !1,
              configurable: !0
            }), e;
          }

          function e() {
            for (var e, r, n = new Promise(function (t, n) {
              e = t, r = n;
            }), i = [], o = 0; o < arguments.length; o++) {
              i.push(arguments[o]);
            }

            i.push(function (t, n) {
              t ? r(t) : e(n);
            });

            try {
              t.apply(this, i);
            } catch (t) {
              r(t);
            }

            return n;
          }

          return Object.setPrototypeOf(e, Object.getPrototypeOf(t)), k && Object.defineProperty(e, k, {
            value: e,
            enumerable: !1,
            writable: !1,
            configurable: !0
          }), Object.defineProperties(e, n(t));
        }, e.promisify.custom = k, e.callbackify = function (e) {
          if ("function" != typeof e) throw new TypeError('The "original" argument must be of type Function');

          function r() {
            for (var r = [], n = 0; n < arguments.length; n++) {
              r.push(arguments[n]);
            }

            var i = r.pop();
            if ("function" != typeof i) throw new TypeError("The last argument must be of type Function");

            var o = this,
                s = function s() {
              return i.apply(o, arguments);
            };

            e.apply(this, r).then(function (e) {
              t.nextTick(s, null, e);
            }, function (e) {
              t.nextTick(I, e, s);
            });
          }

          return Object.setPrototypeOf(r, Object.getPrototypeOf(e)), Object.defineProperties(r, n(e)), r;
        };
      }).call(this, r(1));
    }, function (t, e, r) {
      "use strict";

      t.exports = function (t, e, r, n) {
        for (var i = 65535 & t | 0, o = t >>> 16 & 65535 | 0, s = 0; 0 !== r;) {
          r -= s = r > 2e3 ? 2e3 : r;

          do {
            o = o + (i = i + e[n++] | 0) | 0;
          } while (--s);

          i %= 65521, o %= 65521;
        }

        return i | o << 16 | 0;
      };
    }, function (t, e, r) {
      "use strict";

      var n = function () {
        for (var t, e = [], r = 0; r < 256; r++) {
          t = r;

          for (var n = 0; n < 8; n++) {
            t = 1 & t ? 3988292384 ^ t >>> 1 : t >>> 1;
          }

          e[r] = t;
        }

        return e;
      }();

      t.exports = function (t, e, r, i) {
        var o = n,
            s = i + r;
        t ^= -1;

        for (var a = i; a < s; a++) {
          t = t >>> 8 ^ o[255 & (t ^ e[a])];
        }

        return -1 ^ t;
      };
    }, function (t, e) {
      t.exports = {
        MODE_NUMBER: 1,
        MODE_ALPHA_NUM: 2,
        MODE_8BIT_BYTE: 4,
        MODE_KANJI: 8
      };
    }, function (t, e, r) {
      var n = r(26);

      function i(t, e) {
        if (void 0 === t.length) throw new Error(t.length + "/" + e);

        for (var r = 0; r < t.length && 0 === t[r];) {
          r++;
        }

        this.num = new Array(t.length - r + e);

        for (var n = 0; n < t.length - r; n++) {
          this.num[n] = t[n + r];
        }
      }

      i.prototype = {
        get: function get(t) {
          return this.num[t];
        },
        getLength: function getLength() {
          return this.num.length;
        },
        multiply: function multiply(t) {
          for (var e = new Array(this.getLength() + t.getLength() - 1), r = 0; r < this.getLength(); r++) {
            for (var o = 0; o < t.getLength(); o++) {
              e[r + o] ^= n.gexp(n.glog(this.get(r)) + n.glog(t.get(o)));
            }
          }

          return new i(e, 0);
        },
        mod: function mod(t) {
          if (this.getLength() - t.getLength() < 0) return this;

          for (var e = n.glog(this.get(0)) - n.glog(t.get(0)), r = new Array(this.getLength()), o = 0; o < this.getLength(); o++) {
            r[o] = this.get(o);
          }

          for (var s = 0; s < t.getLength(); s++) {
            r[s] ^= n.gexp(n.glog(t.get(s)) + e);
          }

          return new i(r, 0).mod(t);
        }
      }, t.exports = i;
    }, function (t, e) {
      for (var r = {
        glog: function glog(t) {
          if (t < 1) throw new Error("glog(" + t + ")");
          return r.LOG_TABLE[t];
        },
        gexp: function gexp(t) {
          for (; t < 0;) {
            t += 255;
          }

          for (; t >= 256;) {
            t -= 255;
          }

          return r.EXP_TABLE[t];
        },
        EXP_TABLE: new Array(256),
        LOG_TABLE: new Array(256)
      }, n = 0; n < 8; n++) {
        r.EXP_TABLE[n] = 1 << n;
      }

      for (n = 8; n < 256; n++) {
        r.EXP_TABLE[n] = r.EXP_TABLE[n - 4] ^ r.EXP_TABLE[n - 5] ^ r.EXP_TABLE[n - 6] ^ r.EXP_TABLE[n - 8];
      }

      for (n = 0; n < 255; n++) {
        r.LOG_TABLE[r.EXP_TABLE[n]] = n;
      }

      t.exports = r;
    }, function (t, e) {
      t.exports = {
        L: 1,
        M: 0,
        Q: 3,
        H: 2
      };
    }, function (t, e, r) {
      "use strict";

      Object.defineProperty(e, "__esModule", {
        value: !0
      });

      var n = r(12),
          i = n.__importDefault(r(29)),
          o = n.__importDefault(r(70));

      e.default = {
        open: function open(t, e, r) {
          r ? o.default.open(t, e) : i.default.open(t, e);
        },
        close: function close(t) {
          t ? o.default.close() : i.default.close();
        }
      };
    }, function (t, e, r) {
      "use strict";

      Object.defineProperty(e, "__esModule", {
        value: !0
      });

      var n,
          i = r(12),
          o = i.__importStar(r(30)),
          s = i.__importDefault(r(64)),
          a = i.__importDefault(r(65));

      function u() {
        var t = n.getElementById("walletconnect-qrcode-modal");
        t && (t.className = t.className.replace("fadeIn", "fadeOut"), setTimeout(function () {
          var t = n.getElementById("walletconnect-wrapper");
          t && n.body.removeChild(t);
        }, a.default.animationDuration));
      }

      r(66), "undefined" != typeof window && void 0 !== window.document && (n = window.document), e.default = {
        close: u,
        open: function open(t, e) {
          var r = n.createElement("div");
          r.setAttribute("id", "walletconnect-wrapper");
          var i,
              a,
              f,
              c = (i = t, a = "", "string" == typeof (f = o.imageSync(i, {
            type: "svg"
          })) && (a = f.replace("<svg", '<svg class="walletconnect-qrcode__image"')), a);
          r.innerHTML = function (t) {
            return '\n    <div\n      id="walletconnect-qrcode-modal"\n      class="walletconnect-qrcode__base animated fadeIn"\n    >\n      <div class="walletconnect-modal__base">\n        <div class="walletconnect-modal__header">\n          <img src="' + s.default + '" class="walletconnect-modal__headerLogo" />\n          <div class="walletconnect-modal__close__wrapper">\n            <div\n              id="walletconnect-qrcode-close"\n              class="walletconnect-modal__close__icon"\n            >\n              <div class="walletconnect-modal__close__line1""></div>\n              <div class="walletconnect-modal__close__line2"></div>\n            </div>\n          </div>\n        </div>\n        <div>\n          <div>\n            <p id="walletconnect-qrcode-text" class="walletconnect-qrcode__text">\n              Scan QR code with a WalletConnect-compatible wallet\n            </p>\n            ' + t + "\n          </div>\n        </div>\n      </div>\n    </div>\n";
          }(c), n.body.appendChild(r);
          var h = n.getElementById("walletconnect-qrcode-close");
          h && h.addEventListener("click", function () {
            u(), e && e();
          });
        }
      };
    }, function (t, e, r) {
      "use strict";

      (function (e, n) {
        var i = r(14).Readable,
            o = r(44).QR,
            s = r(48),
            a = r(63),
            u = function u() {},
            f = {
          parse_url: !1,
          ec_level: "M",
          size: 5,
          margin: 4,
          customize: null
        },
            c = {
          parse_url: !1,
          ec_level: "M",
          margin: 1,
          size: 0
        };

        function h(t, e) {
          t = "string" == typeof t ? {
            ec_level: t
          } : t || {};
          var r = {
            type: String(e || t.type || "png").toLowerCase()
          },
              n = "png" == r.type ? f : c;

          for (var i in n) {
            r[i] = i in t ? t[i] : n[i];
          }

          return r;
        }

        t.exports = {
          matrix: o,
          image: function image(t, r) {
            r = h(r);
            var n = o(t, r.ec_level, r.parse_url),
                f = new i();

            switch (f._read = u, r.type) {
              case "svg":
              case "pdf":
              case "eps":
                e.nextTick(function () {
                  a[r.type](n, f, r.margin, r.size);
                });
                break;

              case "svgpath":
                e.nextTick(function () {
                  var t = a.svg_object(n, r.margin, r.size);
                  f.push(t.path), f.push(null);
                });
                break;

              case "png":
              default:
                e.nextTick(function () {
                  var t = s.bitmap(n, r.size, r.margin);
                  r.customize && r.customize(t), s.png(t, f);
                });
            }

            return f;
          },
          imageSync: function imageSync(t, e) {
            e = h(e);
            var r,
                i = o(t, e.ec_level, e.parse_url),
                u = [];

            switch (e.type) {
              case "svg":
              case "pdf":
              case "eps":
                a[e.type](i, u, e.margin, e.size), r = u.filter(Boolean).join("");
                break;

              case "png":
              default:
                var f = s.bitmap(i, e.size, e.margin);
                e.customize && e.customize(f), s.png(f, u), r = n.concat(u.filter(Boolean));
            }

            return r;
          },
          svgObject: function svgObject(t, e) {
            e = h(e, "svg");
            var r = o(t, e.ec_level);
            return a.svg_object(r, e.margin);
          }
        };
      }).call(this, r(1), r(0).Buffer);
    }, function (t, e, r) {
      "use strict";

      e.byteLength = function (t) {
        var e = f(t),
            r = e[0],
            n = e[1];
        return 3 * (r + n) / 4 - n;
      }, e.toByteArray = function (t) {
        var e,
            r,
            n = f(t),
            s = n[0],
            a = n[1],
            u = new o(function (t, e, r) {
          return 3 * (e + r) / 4 - r;
        }(0, s, a)),
            c = 0,
            h = a > 0 ? s - 4 : s;

        for (r = 0; r < h; r += 4) {
          e = i[t.charCodeAt(r)] << 18 | i[t.charCodeAt(r + 1)] << 12 | i[t.charCodeAt(r + 2)] << 6 | i[t.charCodeAt(r + 3)], u[c++] = e >> 16 & 255, u[c++] = e >> 8 & 255, u[c++] = 255 & e;
        }

        return 2 === a && (e = i[t.charCodeAt(r)] << 2 | i[t.charCodeAt(r + 1)] >> 4, u[c++] = 255 & e), 1 === a && (e = i[t.charCodeAt(r)] << 10 | i[t.charCodeAt(r + 1)] << 4 | i[t.charCodeAt(r + 2)] >> 2, u[c++] = e >> 8 & 255, u[c++] = 255 & e), u;
      }, e.fromByteArray = function (t) {
        for (var e, r = t.length, i = r % 3, o = [], s = 0, a = r - i; s < a; s += 16383) {
          o.push(c(t, s, s + 16383 > a ? a : s + 16383));
        }

        return 1 === i ? (e = t[r - 1], o.push(n[e >> 2] + n[e << 4 & 63] + "==")) : 2 === i && (e = (t[r - 2] << 8) + t[r - 1], o.push(n[e >> 10] + n[e >> 4 & 63] + n[e << 2 & 63] + "=")), o.join("");
      };

      for (var n = [], i = [], o = "undefined" != typeof Uint8Array ? Uint8Array : Array, s = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", a = 0, u = s.length; a < u; ++a) {
        n[a] = s[a], i[s.charCodeAt(a)] = a;
      }

      function f(t) {
        var e = t.length;
        if (e % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
        var r = t.indexOf("=");
        return -1 === r && (r = e), [r, r === e ? 0 : 4 - r % 4];
      }

      function c(t, e, r) {
        for (var i, o, s = [], a = e; a < r; a += 3) {
          i = (t[a] << 16 & 16711680) + (t[a + 1] << 8 & 65280) + (255 & t[a + 2]), s.push(n[(o = i) >> 18 & 63] + n[o >> 12 & 63] + n[o >> 6 & 63] + n[63 & o]);
        }

        return s.join("");
      }

      i["-".charCodeAt(0)] = 62, i["_".charCodeAt(0)] = 63;
    }, function (t, e) {
      e.read = function (t, e, r, n, i) {
        var o,
            s,
            a = 8 * i - n - 1,
            u = (1 << a) - 1,
            f = u >> 1,
            c = -7,
            h = r ? i - 1 : 0,
            l = r ? -1 : 1,
            d = t[e + h];

        for (h += l, o = d & (1 << -c) - 1, d >>= -c, c += a; c > 0; o = 256 * o + t[e + h], h += l, c -= 8) {
          ;
        }

        for (s = o & (1 << -c) - 1, o >>= -c, c += n; c > 0; s = 256 * s + t[e + h], h += l, c -= 8) {
          ;
        }

        if (0 === o) o = 1 - f;else {
          if (o === u) return s ? NaN : 1 / 0 * (d ? -1 : 1);
          s += Math.pow(2, n), o -= f;
        }
        return (d ? -1 : 1) * s * Math.pow(2, o - n);
      }, e.write = function (t, e, r, n, i, o) {
        var s,
            a,
            u,
            f = 8 * o - i - 1,
            c = (1 << f) - 1,
            h = c >> 1,
            l = 23 === i ? Math.pow(2, -24) - Math.pow(2, -77) : 0,
            d = n ? 0 : o - 1,
            p = n ? 1 : -1,
            g = e < 0 || 0 === e && 1 / e < 0 ? 1 : 0;

        for (e = Math.abs(e), isNaN(e) || e === 1 / 0 ? (a = isNaN(e) ? 1 : 0, s = c) : (s = Math.floor(Math.log(e) / Math.LN2), e * (u = Math.pow(2, -s)) < 1 && (s--, u *= 2), (e += s + h >= 1 ? l / u : l * Math.pow(2, 1 - h)) * u >= 2 && (s++, u /= 2), s + h >= c ? (a = 0, s = c) : s + h >= 1 ? (a = (e * u - 1) * Math.pow(2, i), s += h) : (a = e * Math.pow(2, h - 1) * Math.pow(2, i), s = 0)); i >= 8; t[r + d] = 255 & a, d += p, a /= 256, i -= 8) {
          ;
        }

        for (s = s << i | a, f += i; f > 0; t[r + d] = 255 & s, d += p, s /= 256, f -= 8) {
          ;
        }

        t[r + d - p] |= 128 * g;
      };
    }, function (t, e) {}, function (t, e, r) {
      "use strict";

      var n = r(7).Buffer,
          i = r(35);
      t.exports = function () {
        function t() {
          !function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, t), this.head = null, this.tail = null, this.length = 0;
        }

        return t.prototype.push = function (t) {
          var e = {
            data: t,
            next: null
          };
          this.length > 0 ? this.tail.next = e : this.head = e, this.tail = e, ++this.length;
        }, t.prototype.unshift = function (t) {
          var e = {
            data: t,
            next: this.head
          };
          0 === this.length && (this.tail = e), this.head = e, ++this.length;
        }, t.prototype.shift = function () {
          if (0 !== this.length) {
            var t = this.head.data;
            return 1 === this.length ? this.head = this.tail = null : this.head = this.head.next, --this.length, t;
          }
        }, t.prototype.clear = function () {
          this.head = this.tail = null, this.length = 0;
        }, t.prototype.join = function (t) {
          if (0 === this.length) return "";

          for (var e = this.head, r = "" + e.data; e = e.next;) {
            r += t + e.data;
          }

          return r;
        }, t.prototype.concat = function (t) {
          if (0 === this.length) return n.alloc(0);
          if (1 === this.length) return this.head.data;

          for (var e, r, i = n.allocUnsafe(t >>> 0), o = this.head, s = 0; o;) {
            e = i, r = s, o.data.copy(e, r), s += o.data.length, o = o.next;
          }

          return i;
        }, t;
      }(), i && i.inspect && i.inspect.custom && (t.exports.prototype[i.inspect.custom] = function () {
        var t = i.inspect({
          length: this.length
        });
        return this.constructor.name + " " + t;
      });
    }, function (t, e) {}, function (t, e, r) {
      (function (t) {
        var n = void 0 !== t && t || "undefined" != typeof self && self || window,
            i = Function.prototype.apply;

        function o(t, e) {
          this._id = t, this._clearFn = e;
        }

        e.setTimeout = function () {
          return new o(i.call(setTimeout, n, arguments), clearTimeout);
        }, e.setInterval = function () {
          return new o(i.call(setInterval, n, arguments), clearInterval);
        }, e.clearTimeout = e.clearInterval = function (t) {
          t && t.close();
        }, o.prototype.unref = o.prototype.ref = function () {}, o.prototype.close = function () {
          this._clearFn.call(n, this._id);
        }, e.enroll = function (t, e) {
          clearTimeout(t._idleTimeoutId), t._idleTimeout = e;
        }, e.unenroll = function (t) {
          clearTimeout(t._idleTimeoutId), t._idleTimeout = -1;
        }, e._unrefActive = e.active = function (t) {
          clearTimeout(t._idleTimeoutId);
          var e = t._idleTimeout;
          e >= 0 && (t._idleTimeoutId = setTimeout(function () {
            t._onTimeout && t._onTimeout();
          }, e));
        }, r(37), e.setImmediate = "undefined" != typeof self && self.setImmediate || void 0 !== t && t.setImmediate || this && this.setImmediate, e.clearImmediate = "undefined" != typeof self && self.clearImmediate || void 0 !== t && t.clearImmediate || this && this.clearImmediate;
      }).call(this, r(2));
    }, function (t, e, r) {
      (function (t, e) {
        !function (t, r) {
          "use strict";

          if (!t.setImmediate) {
            var n,
                i,
                o,
                s,
                a,
                u = 1,
                f = {},
                c = !1,
                h = t.document,
                l = Object.getPrototypeOf && Object.getPrototypeOf(t);
            l = l && l.setTimeout ? l : t, "[object process]" === {}.toString.call(t.process) ? n = function n() {
              var t = d(arguments);
              return e.nextTick(p(g, t)), t;
            } : function () {
              if (t.postMessage && !t.importScripts) {
                var e = !0,
                    r = t.onmessage;
                return t.onmessage = function () {
                  e = !1;
                }, t.postMessage("", "*"), t.onmessage = r, e;
              }
            }() ? (s = "setImmediate$" + Math.random() + "$", a = function a(e) {
              e.source === t && "string" == typeof e.data && 0 === e.data.indexOf(s) && g(+e.data.slice(s.length));
            }, t.addEventListener ? t.addEventListener("message", a, !1) : t.attachEvent("onmessage", a), n = function n() {
              var e = d(arguments);
              return t.postMessage(s + e, "*"), e;
            }) : t.MessageChannel ? ((o = new MessageChannel()).port1.onmessage = function (t) {
              g(t.data);
            }, n = function n() {
              var t = d(arguments);
              return o.port2.postMessage(t), t;
            }) : h && "onreadystatechange" in h.createElement("script") ? (i = h.documentElement, n = function n() {
              var t = d(arguments),
                  e = h.createElement("script");
              return e.onreadystatechange = function () {
                g(t), e.onreadystatechange = null, i.removeChild(e), e = null;
              }, i.appendChild(e), t;
            }) : n = function n() {
              var t = d(arguments);
              return setTimeout(p(g, t), 0), t;
            }, l.setImmediate = n, l.clearImmediate = m;
          }

          function d(t) {
            return f[u] = p.apply(void 0, t), u++;
          }

          function p(t) {
            var e = [].slice.call(arguments, 1);
            return function () {
              "function" == typeof t ? t.apply(void 0, e) : new Function("" + t)();
            };
          }

          function g(t) {
            if (c) setTimeout(p(g, t), 0);else {
              var e = f[t];

              if (e) {
                c = !0;

                try {
                  e();
                } finally {
                  m(t), c = !1;
                }
              }
            }
          }

          function m(t) {
            delete f[t];
          }
        }("undefined" == typeof self ? void 0 === t ? this : t : self);
      }).call(this, r(2), r(1));
    }, function (t, e, r) {
      (function (e) {
        function r(t) {
          try {
            if (!e.localStorage) return !1;
          } catch (t) {
            return !1;
          }

          var r = e.localStorage[t];
          return null != r && "true" === String(r).toLowerCase();
        }

        t.exports = function (t, e) {
          if (r("noDeprecation")) return t;
          var n = !1;
          return function () {
            if (!n) {
              if (r("throwDeprecation")) throw new Error(e);
              r("traceDeprecation") ? console.trace(e) : console.warn(e), n = !0;
            }

            return t.apply(this, arguments);
          };
        };
      }).call(this, r(2));
    }, function (t, e, r) {
      "use strict";

      t.exports = o;
      var n = r(19),
          i = r(5);

      function o(t) {
        if (!(this instanceof o)) return new o(t);
        n.call(this, t);
      }

      i.inherits = r(3), i.inherits(o, n), o.prototype._transform = function (t, e, r) {
        r(null, t);
      };
    }, function (t, e, r) {
      t.exports = r(11);
    }, function (t, e, r) {
      t.exports = r(4);
    }, function (t, e, r) {
      t.exports = r(10).Transform;
    }, function (t, e, r) {
      t.exports = r(10).PassThrough;
    }, function (t, e, r) {
      "use strict";

      (function (e) {
        var n = r(45),
            i = r(46),
            o = r(47);

        function s(t) {
          return JSON.parse(JSON.stringify(t));
        }

        var a = ["L", "M", "Q", "H"],
            u = [[], [26, 7, 1, 10, 1, 13, 1, 17, 1], [44, 10, 1, 16, 1, 22, 1, 28, 1], [70, 15, 1, 26, 1, 36, 2, 44, 2], [100, 20, 1, 36, 2, 52, 2, 64, 4], [134, 26, 1, 48, 2, 72, 4, 88, 4], [172, 36, 2, 64, 4, 96, 4, 112, 4], [196, 40, 2, 72, 4, 108, 6, 130, 5], [242, 48, 2, 88, 4, 132, 6, 156, 6], [292, 60, 2, 110, 5, 160, 8, 192, 8], [346, 72, 4, 130, 5, 192, 8, 224, 8], [404, 80, 4, 150, 5, 224, 8, 264, 11], [466, 96, 4, 176, 8, 260, 10, 308, 11], [532, 104, 4, 198, 9, 288, 12, 352, 16], [581, 120, 4, 216, 9, 320, 16, 384, 16], [655, 132, 6, 240, 10, 360, 12, 432, 18], [733, 144, 6, 280, 10, 408, 17, 480, 16], [815, 168, 6, 308, 11, 448, 16, 532, 19], [901, 180, 6, 338, 13, 504, 18, 588, 21], [991, 196, 7, 364, 14, 546, 21, 650, 25], [1085, 224, 8, 416, 16, 600, 20, 700, 25], [1156, 224, 8, 442, 17, 644, 23, 750, 25], [1258, 252, 9, 476, 17, 690, 23, 816, 34], [1364, 270, 9, 504, 18, 750, 25, 900, 30], [1474, 300, 10, 560, 20, 810, 27, 960, 32], [1588, 312, 12, 588, 21, 870, 29, 1050, 35], [1706, 336, 12, 644, 23, 952, 34, 1110, 37], [1828, 360, 12, 700, 25, 1020, 34, 1200, 40], [1921, 390, 13, 728, 26, 1050, 35, 1260, 42], [2051, 420, 14, 784, 28, 1140, 38, 1350, 45], [2185, 450, 15, 812, 29, 1200, 40, 1440, 48], [2323, 480, 16, 868, 31, 1290, 43, 1530, 51], [2465, 510, 17, 924, 33, 1350, 45, 1620, 54], [2611, 540, 18, 980, 35, 1440, 48, 1710, 57], [2761, 570, 19, 1036, 37, 1530, 51, 1800, 60], [2876, 570, 19, 1064, 38, 1590, 53, 1890, 63], [3034, 600, 20, 1120, 40, 1680, 56, 1980, 66], [3196, 630, 21, 1204, 43, 1770, 59, 2100, 70], [3362, 660, 22, 1260, 45, 1860, 62, 2220, 74], [3532, 720, 24, 1316, 47, 1950, 65, 2310, 77], [3706, 750, 25, 1372, 49, 2040, 68, 2430, 81]];

        function f(t, e) {
          var r,
              n = 1;

          for (t.data1 ? r = Math.ceil(t.data1.length / 8) : n = 10; n < 10; n++) {
            if ((i = u[n][e]).data_len >= r) return s(i);
          }

          for (t.data10 ? r = Math.ceil(t.data10.length / 8) : n = 27; n < 27; n++) {
            if ((i = u[n][e]).data_len >= r) return s(i);
          }

          for (r = Math.ceil(t.data27.length / 8); n < 41; n++) {
            var i;
            if ((i = u[n][e]).data_len >= r) return s(i);
          }

          throw new Error("Too much data");
        }

        function c(t, r) {
          var n = new e(r.data_len);
          n.fill(0);

          for (var o = (t = r.version < 10 ? t.data1 : r.version < 27 ? t.data10 : t.data27).length, s = 0; s < o; s += 8) {
            for (var a = 0, u = 0; u < 8; u++) {
              a = a << 1 | (t[s + u] ? 1 : 0);
            }

            n[s / 8] = a;
          }

          var f = 236;

          for (s = Math.ceil((o + 4) / 8); s < n.length; s++) {
            n[s] = f, f = 236 == f ? 17 : 236;
          }

          var c = 0;
          return r.blocks = r.blocks.map(function (t) {
            var e = n.slice(c, c + t);
            return c += t, r.ec.push(i(e, r.ec_len)), e;
          }), r;
        }

        u = u.map(function (t, e) {
          if (!e) return {};

          for (var r = {}, n = 1; n < 8; n += 2) {
            for (var i = t[0] - t[n], o = t[n + 1], s = a[n / 2 | 0], u = {
              version: e,
              ec_level: s,
              data_len: i,
              ec_len: t[n] / o,
              blocks: [],
              ec: []
            }, f = o, c = i; f > 0; f--) {
              var h = c / f | 0;
              u.blocks.push(h), c -= h;
            }

            r[s] = u;
          }

          return r;
        }), t.exports = {
          QR: function QR(t, e, r) {
            e = a.indexOf(e) > -1 ? e : "M";
            var i = n(t, r),
                s = c(i, f(i, e));
            return o.getMatrix(s);
          },
          getTemplate: f,
          fillTemplate: c
        };
      }).call(this, r(0).Buffer);
    }, function (t, e, r) {
      "use strict";

      (function (e) {
        function r(t, e, r) {
          for (var n = 1 << e - 1; n; n >>>= 1) {
            t.push(n & r ? 1 : 0);
          }
        }

        var n = function (t) {
          for (var e = {}, r = 0; r < t.length; r++) {
            e[t[r]] = r;
          }

          return e;
        }("0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ $%*+-./:");

        t.exports = function t(i, o) {
          var s,
              a = typeof i;
          if ("string" == a || "number" == a) i = new e(s = "" + i);else if (e.isBuffer(i)) s = i.toString();else {
            if (!Array.isArray(i)) throw new Error("Bad data");
            s = (i = new e(i)).toString();
          }

          if (/^[0-9]+$/.test(s)) {
            if (i.length > 7089) throw new Error("Too much data");
            return function (t) {
              for (var e = t.length, n = [], i = 0; i < e; i += 3) {
                var o = t.substr(i, 3);
                r(n, Math.ceil(10 * o.length / 3), parseInt(o, 10));
              }

              var s,
                  a = {};
              return r(s = [0, 0, 0, 1], 14, e), a.data27 = s.concat(n), e < 4096 && (r(s = [0, 0, 0, 1], 12, e), a.data10 = s.concat(n)), e < 1024 && (r(s = [0, 0, 0, 1], 10, e), a.data1 = s.concat(n)), a;
            }(s);
          }

          if (/^[0-9A-Z \$%\*\+\.\/\:\-]+$/.test(s)) {
            if (i.length > 4296) throw new Error("Too much data");
            return function (t) {
              for (var e = t.length, i = [], o = 0; o < e; o += 2) {
                var s = 6,
                    a = n[t[o]];
                t[o + 1] && (s = 11, a = 45 * a + n[t[o + 1]]), r(i, s, a);
              }

              var u,
                  f = {};
              return r(u = [0, 0, 1, 0], 13, e), f.data27 = u.concat(i), e < 2048 && (r(u = [0, 0, 1, 0], 11, e), f.data10 = u.concat(i)), e < 512 && (r(u = [0, 0, 1, 0], 9, e), f.data1 = u.concat(i)), f;
            }(s);
          }

          if (o && /^https?:/i.test(s)) return function (e) {
            var r = e.indexOf("/", 8) + 1 || e.length,
                n = t(e.slice(0, r).toUpperCase(), !1);
            if (r >= e.length) return n;
            var i = t(e.slice(r), !1);
            return n.data27 = n.data27.concat(i.data27), n.data10 && i.data10 && (n.data10 = n.data10.concat(i.data10)), n.data1 && i.data1 && (n.data1 = n.data1.concat(i.data1)), n;
          }(s);
          if (i.length > 2953) throw new Error("Too much data");
          return function (t) {
            for (var e = t.length, n = [], i = 0; i < e; i++) {
              r(n, 8, t[i]);
            }

            var o,
                s = {};
            return r(o = [0, 1, 0, 0], 16, e), s.data10 = s.data27 = o.concat(n), e < 256 && (r(o = [0, 1, 0, 0], 8, e), s.data1 = o.concat(n)), s;
          }(i);
        };
      }).call(this, r(0).Buffer);
    }, function (t, e, r) {
      "use strict";

      (function (e) {
        for (var r = [1], n = [], i = 1; i < 256; i++) {
          var o = r[i - 1] << 1;
          o > 255 && (o ^= 285), r[i] = o;
        }

        for (i = 0; i < 255; i++) {
          n[r[i]] = i;
        }

        function s(t) {
          for (; t < 0;) {
            t += 255;
          }

          for (; t > 255;) {
            t -= 255;
          }

          return r[t];
        }

        function a(t) {
          if (t < 1 || t > 255) throw Error("Bad log(" + t + ")");
          return n[t];
        }

        var u = [[0], [0, 0], [0, 25, 1]];

        t.exports = function (t, r) {
          t = [].slice.call(t);

          for (var n = function t(e) {
            if (u[e]) return u[e];
            var r = t(e - 1),
                n = [];
            n[0] = r[0];

            for (var i = 1; i <= e; i++) {
              n[i] = a(s(r[i]) ^ s(r[i - 1] + e - 1));
            }

            return u[e] = n, n;
          }(r), i = 0; i < r; i++) {
            t.push(0);
          }

          for (; t.length > r;) {
            if (t[0]) {
              var o = a(t[0]);

              for (i = 0; i <= r; i++) {
                t[i] = t[i] ^ s(n[i] + o);
              }

              t.shift();
            } else t.shift();
          }

          return new e(t);
        };
      }).call(this, r(0).Buffer);
    }, function (t, e, r) {
      "use strict";

      (function (e) {
        function r(t) {
          var r = 4 * t + 17,
              n = [],
              i = new e(r);
          i.fill(0), i = [].slice.call(i);

          for (var o = 0; o < r; o++) {
            n[o] = i.slice();
          }

          return n;
        }

        function n(t) {
          for (var e = t.length, r = -3; r <= 3; r++) {
            for (var n = -3; n <= 3; n++) {
              var i = Math.max(r, n),
                  o = Math.min(r, n),
                  s = 2 == i && o >= -2 || -2 == o && i <= 2 ? 128 : 129;
              t[3 + r][3 + n] = s, t[3 + r][e - 4 + n] = s, t[e - 4 + r][3 + n] = s;
            }
          }

          for (r = 0; r < 8; r++) {
            t[7][r] = t[r][7] = t[7][e - r - 1] = t[r][e - 8] = t[e - 8][r] = t[e - 1 - r][7] = 128;
          }
        }

        function i(t) {
          var e = t.length;

          if (e > 21) {
            var r = e - 13,
                n = Math.round(r / Math.ceil(r / 28));
            n % 2 && n++;

            for (var i = [], o = r + 6; o > 10; o -= n) {
              i.unshift(o);
            }

            i.unshift(6);

            for (var s = 0; s < i.length; s++) {
              for (var a = 0; a < i.length; a++) {
                var u = i[s],
                    f = i[a];
                if (!t[u][f]) for (var c = -2; c <= 2; c++) {
                  for (var h = -2; h <= 2; h++) {
                    var l = Math.max(c, h),
                        d = Math.min(c, h),
                        p = 1 == l && d >= -1 || -1 == d && l <= 1 ? 128 : 129;
                    t[u + c][f + h] = p;
                  }
                }
              }
            }
          }

          for (s = 8; s < e - 8; s++) {
            t[6][s] = t[s][6] = s % 2 ? 128 : 129;
          }
        }

        function o(t) {
          for (var e = t.length, r = 0; r < 8; r++) {
            6 != r && (t[8][r] = t[r][8] = 128), t[8][e - 1 - r] = 128, t[e - 1 - r][8] = 128;
          }

          if (t[8][8] = 128, t[e - 8][8] = 129, !(e < 45)) for (r = e - 11; r < e - 8; r++) {
            for (var n = 0; n < 6; n++) {
              t[r][n] = t[n][r] = 128;
            }
          }
        }

        var s,
            a = function () {
          for (var t = Array(32), e = Array(40), r = 0; r < 32; r++) {
            for (var n = r << 10, i = 5; i > 0; i--) {
              n >>> 9 + i && (n ^= 1335 << i - 1);
            }

            t[r] = 21522 ^ (n | r << 10);
          }

          for (var o = 7; o <= 40; o++) {
            for (n = o << 12, i = 6; i > 0; i--) {
              n >>> 11 + i && (n ^= 7973 << i - 1);
            }

            e[o] = n | o << 12;
          }

          var s = {
            L: 1,
            M: 0,
            Q: 3,
            H: 2
          };
          return function (r, n, i) {
            var o = r.length,
                a = t[s[n] << 3 | i];

            function u(t) {
              return a >> t & 1 ? 129 : 128;
            }

            for (var f = 0; f < 8; f++) {
              r[8][o - 1 - f] = u(f), f < 6 && (r[f][8] = u(f));
            }

            for (f = 8; f < 15; f++) {
              r[o - 15 + f][8] = u(f), f > 8 && (r[8][14 - f] = u(f));
            }

            r[7][8] = u(6), r[8][8] = u(7), r[8][7] = u(8);
            var c = e[(o - 17) / 4];
            if (c) for (f = 0; f < 6; f++) {
              for (var h = 0; h < 3; h++) {
                r[o - 11 + h][f] = r[f][o - 11 + h] = c >> 3 * f + h & 1 ? 129 : 128;
              }
            }
          };
        }(),
            u = (s = [function (t, e) {
          return (t + e) % 2 == 0;
        }, function (t, e) {
          return t % 2 == 0;
        }, function (t, e) {
          return e % 3 == 0;
        }, function (t, e) {
          return (t + e) % 3 == 0;
        }, function (t, e) {
          return (Math.floor(t / 2) + Math.floor(e / 3)) % 2 == 0;
        }, function (t, e) {
          return t * e % 2 + t * e % 3 == 0;
        }, function (t, e) {
          return (t * e % 2 + t * e % 3) % 2 == 0;
        }, function (t, e) {
          return (t * e % 3 + (t + e) % 2) % 2 == 0;
        }], function (t, e, r) {
          var n,
              i,
              o = t.length,
              a = -1;
          n = i = o - 1;

          for (var u = s[r], f = e.blocks[e.blocks.length - 1].length, c = 0; c < f; c++) {
            for (var h = 0; h < e.blocks.length; h++) {
              e.blocks[h].length <= c || l(e.blocks[h][c]);
            }
          }

          for (f = e.ec_len, c = 0; c < f; c++) {
            for (h = 0; h < e.ec.length; h++) {
              l(e.ec[h][c]);
            }
          }

          if (i > -1) do {
            t[n][i] = u(n, i) ? 1 : 0;
          } while (d());

          function l(e) {
            for (var r = 128; r; r >>= 1) {
              var o = !!(r & e);
              u(n, i) && (o = !o), t[n][i] = o ? 1 : 0, d();
            }
          }

          function d() {
            do {
              if (i % 2 ^ i < 6 ? a < 0 && 0 == n || a > 0 && n == o - 1 ? (i--, a = -a) : (i++, n += a) : i--, 6 == i && i--, i < 0) return !1;
            } while (240 & t[n][i]);

            return !0;
          }
        });

        function f(t) {
          for (var e = t.length, r = 0, n = 0; n < e; n++) {
            for (var i = 1 & t[n][0], o = 1, s = 1; s < e; s++) {
              (a = 1 & t[n][s]) != i ? (o >= 5 && (r += o - 2), i = a, o = 1) : o++;
            }

            o >= 5 && (r += o - 2);
          }

          for (s = 0; s < e; s++) {
            for (i = 1 & t[0][s], o = 1, n = 1; n < e; n++) {
              var a;
              (a = 1 & t[n][s]) != i ? (o >= 5 && (r += o - 2), i = a, o = 1) : o++;
            }

            o >= 5 && (r += o - 2);
          }

          for (n = 0; n < e - 1; n++) {
            for (s = 0; s < e - 1; s++) {
              var u = t[n][s] + t[n][s + 1] + t[n + 1][s] + t[n + 1][s + 1] & 7;
              0 != u && 4 != u || (r += 3);
            }
          }

          function f(e) {
            return 1 & t[n][s + e];
          }

          function c(e) {
            return 1 & t[n + e][s];
          }

          for (n = 0; n < e; n++) {
            for (s = 0; s < e; s++) {
              s < e - 6 && f(0) && !f(1) && f(2) && f(3) && f(4) && !f(5) && f(6) && (s >= 4 && !(f(-4) || f(-3) || f(-2) || f(-1)) && (r += 40), s < e - 10 && !(f(7) || f(8) || f(9) || f(10)) && (r += 40)), n < e - 6 && c(0) && !c(1) && c(2) && c(3) && c(4) && !c(5) && c(6) && (n >= 4 && !(c(-4) || c(-3) || c(-2) || c(-1)) && (r += 40), n < e - 10 && !(c(7) || c(8) || c(9) || c(10)) && (r += 40));
            }
          }

          var h = 0;

          for (n = 0; n < e; n++) {
            for (s = 0; s < e; s++) {
              1 & t[n][s] && h++;
            }
          }

          return r + 10 * Math.floor(Math.abs(10 - 20 * h / (e * e)));
        }

        t.exports = {
          getMatrix: function getMatrix(t) {
            var e = r(t.version);
            n(e), i(e), o(e);

            for (var s = 1 / 0, c = 0, h = 0; h < 8; h++) {
              u(e, t, h), a(e, t.ec_level, h);
              var l = f(e);
              l < s && (s = l, c = h);
            }

            return u(e, t, c), a(e, t.ec_level, c), e.map(function (t) {
              return t.map(function (t) {
                return 1 & t;
              });
            });
          },
          init: r,
          fillFinders: n,
          fillAlignAndTiming: i,
          fillStub: o,
          fillReserved: a,
          fillData: u,
          calculatePenalty: f
        };
      }).call(this, r(0).Buffer);
    }, function (t, e, r) {
      "use strict";

      (function (e) {
        var n = r(49),
            i = r(61),
            o = new e([137, 80, 78, 71, 13, 10, 26, 10]),
            s = new e([0, 0, 0, 13, 73, 72, 68, 82, 0, 0, 0, 0, 0, 0, 0, 0, 8, 0, 0, 0, 0, 0, 0, 0, 0]),
            a = new e([0, 0, 0, 0, 73, 68, 65, 84]),
            u = new e([0, 0, 0, 0, 73, 69, 78, 68, 174, 66, 96, 130]);
        t.exports = {
          bitmap: function bitmap(t, r, n) {
            var i = t.length,
                o = (i + 2 * n) * r,
                s = new e((o + 1) * o);
            s.fill(255);

            for (var a = 0; a < o; a++) {
              s[a * (o + 1)] = 0;
            }

            for (a = 0; a < i; a++) {
              for (var u = 0; u < i; u++) {
                if (t[a][u]) {
                  var f = ((n + a) * (o + 1) + (n + u)) * r + 1;
                  s.fill(0, f, f + r);

                  for (var c = 1; c < r; c++) {
                    s.copy(s, f + c * (o + 1), f, f + r);
                  }
                }
              }
            }

            return {
              data: s,
              size: o
            };
          },
          png: function png(t, r) {
            r.push(o);
            var f = e.concat([s]);
            f.writeUInt32BE(t.size, 8), f.writeUInt32BE(t.size, 12), f.writeUInt32BE(i(f.slice(4, -4)), 21), r.push(f);
            var c = e.concat([a, n.deflateSync(t.data, {
              level: 9
            }), new e(4)]);
            c.writeUInt32BE(c.length - 12, 0), c.writeUInt32BE(i(c.slice(4, -4)), c.length - 4), r.push(c), r.push(u), r.push(null);
          }
        };
      }).call(this, r(0).Buffer);
    }, function (t, e, r) {
      "use strict";

      (function (t) {
        var n = r(0).Buffer,
            i = r(14).Transform,
            o = r(50),
            s = r(21),
            a = r(20).ok,
            u = r(0).kMaxLength,
            f = "Cannot create final Buffer. It would be larger than 0x" + u.toString(16) + " bytes";
        o.Z_MIN_WINDOWBITS = 8, o.Z_MAX_WINDOWBITS = 15, o.Z_DEFAULT_WINDOWBITS = 15, o.Z_MIN_CHUNK = 64, o.Z_MAX_CHUNK = 1 / 0, o.Z_DEFAULT_CHUNK = 16384, o.Z_MIN_MEMLEVEL = 1, o.Z_MAX_MEMLEVEL = 9, o.Z_DEFAULT_MEMLEVEL = 8, o.Z_MIN_LEVEL = -1, o.Z_MAX_LEVEL = 9, o.Z_DEFAULT_LEVEL = o.Z_DEFAULT_COMPRESSION;

        for (var c = Object.keys(o), h = 0; h < c.length; h++) {
          var l = c[h];
          l.match(/^Z/) && Object.defineProperty(e, l, {
            enumerable: !0,
            value: o[l],
            writable: !1
          });
        }

        for (var d = {
          Z_OK: o.Z_OK,
          Z_STREAM_END: o.Z_STREAM_END,
          Z_NEED_DICT: o.Z_NEED_DICT,
          Z_ERRNO: o.Z_ERRNO,
          Z_STREAM_ERROR: o.Z_STREAM_ERROR,
          Z_DATA_ERROR: o.Z_DATA_ERROR,
          Z_MEM_ERROR: o.Z_MEM_ERROR,
          Z_BUF_ERROR: o.Z_BUF_ERROR,
          Z_VERSION_ERROR: o.Z_VERSION_ERROR
        }, p = Object.keys(d), g = 0; g < p.length; g++) {
          var m = p[g];
          d[d[m]] = m;
        }

        function b(t, e, r) {
          var i = [],
              o = 0;

          function s() {
            for (var e; null !== (e = t.read());) {
              i.push(e), o += e.length;
            }

            t.once("readable", s);
          }

          function a() {
            var e,
                s = null;
            o >= u ? s = new RangeError(f) : e = n.concat(i, o), i = [], t.close(), r(s, e);
          }

          t.on("error", function (e) {
            t.removeListener("end", a), t.removeListener("readable", s), r(e);
          }), t.on("end", a), t.end(e), s();
        }

        function v(t, e) {
          if ("string" == typeof e && (e = n.from(e)), !n.isBuffer(e)) throw new TypeError("Not a string or buffer");
          var r = t._finishFlushFlag;
          return t._processChunk(e, r);
        }

        function y(t) {
          if (!(this instanceof y)) return new y(t);
          R.call(this, t, o.DEFLATE);
        }

        function _(t) {
          if (!(this instanceof _)) return new _(t);
          R.call(this, t, o.INFLATE);
        }

        function w(t) {
          if (!(this instanceof w)) return new w(t);
          R.call(this, t, o.GZIP);
        }

        function E(t) {
          if (!(this instanceof E)) return new E(t);
          R.call(this, t, o.GUNZIP);
        }

        function M(t) {
          if (!(this instanceof M)) return new M(t);
          R.call(this, t, o.DEFLATERAW);
        }

        function S(t) {
          if (!(this instanceof S)) return new S(t);
          R.call(this, t, o.INFLATERAW);
        }

        function A(t) {
          if (!(this instanceof A)) return new A(t);
          R.call(this, t, o.UNZIP);
        }

        function x(t) {
          return t === o.Z_NO_FLUSH || t === o.Z_PARTIAL_FLUSH || t === o.Z_SYNC_FLUSH || t === o.Z_FULL_FLUSH || t === o.Z_FINISH || t === o.Z_BLOCK;
        }

        function R(t, r) {
          var s = this;
          if (this._opts = t = t || {}, this._chunkSize = t.chunkSize || e.Z_DEFAULT_CHUNK, i.call(this, t), t.flush && !x(t.flush)) throw new Error("Invalid flush flag: " + t.flush);
          if (t.finishFlush && !x(t.finishFlush)) throw new Error("Invalid flush flag: " + t.finishFlush);
          if (this._flushFlag = t.flush || o.Z_NO_FLUSH, this._finishFlushFlag = void 0 !== t.finishFlush ? t.finishFlush : o.Z_FINISH, t.chunkSize && (t.chunkSize < e.Z_MIN_CHUNK || t.chunkSize > e.Z_MAX_CHUNK)) throw new Error("Invalid chunk size: " + t.chunkSize);
          if (t.windowBits && (t.windowBits < e.Z_MIN_WINDOWBITS || t.windowBits > e.Z_MAX_WINDOWBITS)) throw new Error("Invalid windowBits: " + t.windowBits);
          if (t.level && (t.level < e.Z_MIN_LEVEL || t.level > e.Z_MAX_LEVEL)) throw new Error("Invalid compression level: " + t.level);
          if (t.memLevel && (t.memLevel < e.Z_MIN_MEMLEVEL || t.memLevel > e.Z_MAX_MEMLEVEL)) throw new Error("Invalid memLevel: " + t.memLevel);
          if (t.strategy && t.strategy != e.Z_FILTERED && t.strategy != e.Z_HUFFMAN_ONLY && t.strategy != e.Z_RLE && t.strategy != e.Z_FIXED && t.strategy != e.Z_DEFAULT_STRATEGY) throw new Error("Invalid strategy: " + t.strategy);
          if (t.dictionary && !n.isBuffer(t.dictionary)) throw new Error("Invalid dictionary: it should be a Buffer instance");
          this._handle = new o.Zlib(r);
          var a = this;
          this._hadError = !1, this._handle.onerror = function (t, r) {
            T(a), a._hadError = !0;
            var n = new Error(t);
            n.errno = r, n.code = e.codes[r], a.emit("error", n);
          };
          var u = e.Z_DEFAULT_COMPRESSION;
          "number" == typeof t.level && (u = t.level);
          var f = e.Z_DEFAULT_STRATEGY;
          "number" == typeof t.strategy && (f = t.strategy), this._handle.init(t.windowBits || e.Z_DEFAULT_WINDOWBITS, u, t.memLevel || e.Z_DEFAULT_MEMLEVEL, f, t.dictionary), this._buffer = n.allocUnsafe(this._chunkSize), this._offset = 0, this._level = u, this._strategy = f, this.once("end", this.close), Object.defineProperty(this, "_closed", {
            get: function get() {
              return !s._handle;
            },
            configurable: !0,
            enumerable: !0
          });
        }

        function T(e, r) {
          r && t.nextTick(r), e._handle && (e._handle.close(), e._handle = null);
        }

        function k(t) {
          t.emit("close");
        }

        Object.defineProperty(e, "codes", {
          enumerable: !0,
          value: Object.freeze(d),
          writable: !1
        }), e.Deflate = y, e.Inflate = _, e.Gzip = w, e.Gunzip = E, e.DeflateRaw = M, e.InflateRaw = S, e.Unzip = A, e.createDeflate = function (t) {
          return new y(t);
        }, e.createInflate = function (t) {
          return new _(t);
        }, e.createDeflateRaw = function (t) {
          return new M(t);
        }, e.createInflateRaw = function (t) {
          return new S(t);
        }, e.createGzip = function (t) {
          return new w(t);
        }, e.createGunzip = function (t) {
          return new E(t);
        }, e.createUnzip = function (t) {
          return new A(t);
        }, e.deflate = function (t, e, r) {
          return "function" == typeof e && (r = e, e = {}), b(new y(e), t, r);
        }, e.deflateSync = function (t, e) {
          return v(new y(e), t);
        }, e.gzip = function (t, e, r) {
          return "function" == typeof e && (r = e, e = {}), b(new w(e), t, r);
        }, e.gzipSync = function (t, e) {
          return v(new w(e), t);
        }, e.deflateRaw = function (t, e, r) {
          return "function" == typeof e && (r = e, e = {}), b(new M(e), t, r);
        }, e.deflateRawSync = function (t, e) {
          return v(new M(e), t);
        }, e.unzip = function (t, e, r) {
          return "function" == typeof e && (r = e, e = {}), b(new A(e), t, r);
        }, e.unzipSync = function (t, e) {
          return v(new A(e), t);
        }, e.inflate = function (t, e, r) {
          return "function" == typeof e && (r = e, e = {}), b(new _(e), t, r);
        }, e.inflateSync = function (t, e) {
          return v(new _(e), t);
        }, e.gunzip = function (t, e, r) {
          return "function" == typeof e && (r = e, e = {}), b(new E(e), t, r);
        }, e.gunzipSync = function (t, e) {
          return v(new E(e), t);
        }, e.inflateRaw = function (t, e, r) {
          return "function" == typeof e && (r = e, e = {}), b(new S(e), t, r);
        }, e.inflateRawSync = function (t, e) {
          return v(new S(e), t);
        }, s.inherits(R, i), R.prototype.params = function (r, n, i) {
          if (r < e.Z_MIN_LEVEL || r > e.Z_MAX_LEVEL) throw new RangeError("Invalid compression level: " + r);
          if (n != e.Z_FILTERED && n != e.Z_HUFFMAN_ONLY && n != e.Z_RLE && n != e.Z_FIXED && n != e.Z_DEFAULT_STRATEGY) throw new TypeError("Invalid strategy: " + n);

          if (this._level !== r || this._strategy !== n) {
            var s = this;
            this.flush(o.Z_SYNC_FLUSH, function () {
              a(s._handle, "zlib binding closed"), s._handle.params(r, n), s._hadError || (s._level = r, s._strategy = n, i && i());
            });
          } else t.nextTick(i);
        }, R.prototype.reset = function () {
          return a(this._handle, "zlib binding closed"), this._handle.reset();
        }, R.prototype._flush = function (t) {
          this._transform(n.alloc(0), "", t);
        }, R.prototype.flush = function (e, r) {
          var i = this,
              s = this._writableState;
          ("function" == typeof e || void 0 === e && !r) && (r = e, e = o.Z_FULL_FLUSH), s.ended ? r && t.nextTick(r) : s.ending ? r && this.once("end", r) : s.needDrain ? r && this.once("drain", function () {
            return i.flush(e, r);
          }) : (this._flushFlag = e, this.write(n.alloc(0), "", r));
        }, R.prototype.close = function (e) {
          T(this, e), t.nextTick(k, this);
        }, R.prototype._transform = function (t, e, r) {
          var i,
              s = this._writableState,
              a = (s.ending || s.ended) && (!t || s.length === t.length);
          return null === t || n.isBuffer(t) ? this._handle ? (a ? i = this._finishFlushFlag : (i = this._flushFlag, t.length >= s.length && (this._flushFlag = this._opts.flush || o.Z_NO_FLUSH)), void this._processChunk(t, i, r)) : r(new Error("zlib binding closed")) : r(new Error("invalid input"));
        }, R.prototype._processChunk = function (t, e, r) {
          var i = t && t.length,
              o = this._chunkSize - this._offset,
              s = 0,
              c = this,
              h = "function" == typeof r;

          if (!h) {
            var l,
                d = [],
                p = 0;
            this.on("error", function (t) {
              l = t;
            }), a(this._handle, "zlib binding closed");

            do {
              var g = this._handle.writeSync(e, t, s, i, this._buffer, this._offset, o);
            } while (!this._hadError && v(g[0], g[1]));

            if (this._hadError) throw l;
            if (p >= u) throw T(this), new RangeError(f);
            var m = n.concat(d, p);
            return T(this), m;
          }

          a(this._handle, "zlib binding closed");

          var b = this._handle.write(e, t, s, i, this._buffer, this._offset, o);

          function v(u, f) {
            if (this && (this.buffer = null, this.callback = null), !c._hadError) {
              var l = o - f;

              if (a(l >= 0, "have should not go down"), l > 0) {
                var g = c._buffer.slice(c._offset, c._offset + l);

                c._offset += l, h ? c.push(g) : (d.push(g), p += g.length);
              }

              if ((0 === f || c._offset >= c._chunkSize) && (o = c._chunkSize, c._offset = 0, c._buffer = n.allocUnsafe(c._chunkSize)), 0 === f) {
                if (s += i - u, i = u, !h) return !0;

                var m = c._handle.write(e, t, s, i, c._buffer, c._offset, c._chunkSize);

                return m.callback = v, void (m.buffer = t);
              }

              if (!h) return !1;
              r();
            }
          }

          b.buffer = t, b.callback = v;
        }, s.inherits(y, R), s.inherits(_, R), s.inherits(w, R), s.inherits(E, R), s.inherits(M, R), s.inherits(S, R), s.inherits(A, R);
      }).call(this, r(1));
    }, function (t, e, r) {
      "use strict";

      (function (t, n) {
        var i = r(20),
            o = r(53),
            s = r(54),
            a = r(57),
            u = r(60);

        for (var f in u) {
          e[f] = u[f];
        }

        function c(t) {
          if ("number" != typeof t || t < e.DEFLATE || t > e.UNZIP) throw new TypeError("Bad argument");
          this.dictionary = null, this.err = 0, this.flush = 0, this.init_done = !1, this.level = 0, this.memLevel = 0, this.mode = t, this.strategy = 0, this.windowBits = 0, this.write_in_progress = !1, this.pending_close = !1, this.gzip_id_bytes_read = 0;
        }

        e.NONE = 0, e.DEFLATE = 1, e.INFLATE = 2, e.GZIP = 3, e.GUNZIP = 4, e.DEFLATERAW = 5, e.INFLATERAW = 6, e.UNZIP = 7, c.prototype.close = function () {
          this.write_in_progress ? this.pending_close = !0 : (this.pending_close = !1, i(this.init_done, "close before init"), i(this.mode <= e.UNZIP), this.mode === e.DEFLATE || this.mode === e.GZIP || this.mode === e.DEFLATERAW ? s.deflateEnd(this.strm) : this.mode !== e.INFLATE && this.mode !== e.GUNZIP && this.mode !== e.INFLATERAW && this.mode !== e.UNZIP || a.inflateEnd(this.strm), this.mode = e.NONE, this.dictionary = null);
        }, c.prototype.write = function (t, e, r, n, i, o, s) {
          return this._write(!0, t, e, r, n, i, o, s);
        }, c.prototype.writeSync = function (t, e, r, n, i, o, s) {
          return this._write(!1, t, e, r, n, i, o, s);
        }, c.prototype._write = function (r, o, s, a, u, f, c, h) {
          if (i.equal(arguments.length, 8), i(this.init_done, "write before init"), i(this.mode !== e.NONE, "already finalized"), i.equal(!1, this.write_in_progress, "write already in progress"), i.equal(!1, this.pending_close, "close is pending"), this.write_in_progress = !0, i.equal(!1, void 0 === o, "must provide flush value"), this.write_in_progress = !0, o !== e.Z_NO_FLUSH && o !== e.Z_PARTIAL_FLUSH && o !== e.Z_SYNC_FLUSH && o !== e.Z_FULL_FLUSH && o !== e.Z_FINISH && o !== e.Z_BLOCK) throw new Error("Invalid flush value");
          if (null == s && (s = t.alloc(0), u = 0, a = 0), this.strm.avail_in = u, this.strm.input = s, this.strm.next_in = a, this.strm.avail_out = h, this.strm.output = f, this.strm.next_out = c, this.flush = o, !r) return this._process(), this._checkError() ? this._afterSync() : void 0;
          var l = this;
          return n.nextTick(function () {
            l._process(), l._after();
          }), this;
        }, c.prototype._afterSync = function () {
          var t = this.strm.avail_out,
              e = this.strm.avail_in;
          return this.write_in_progress = !1, [e, t];
        }, c.prototype._process = function () {
          var t = null;

          switch (this.mode) {
            case e.DEFLATE:
            case e.GZIP:
            case e.DEFLATERAW:
              this.err = s.deflate(this.strm, this.flush);
              break;

            case e.UNZIP:
              switch (this.strm.avail_in > 0 && (t = this.strm.next_in), this.gzip_id_bytes_read) {
                case 0:
                  if (null === t) break;

                  if (31 !== this.strm.input[t]) {
                    this.mode = e.INFLATE;
                    break;
                  }

                  if (this.gzip_id_bytes_read = 1, t++, 1 === this.strm.avail_in) break;

                case 1:
                  if (null === t) break;
                  139 === this.strm.input[t] ? (this.gzip_id_bytes_read = 2, this.mode = e.GUNZIP) : this.mode = e.INFLATE;
                  break;

                default:
                  throw new Error("invalid number of gzip magic number bytes read");
              }

            case e.INFLATE:
            case e.GUNZIP:
            case e.INFLATERAW:
              for (this.err = a.inflate(this.strm, this.flush), this.err === e.Z_NEED_DICT && this.dictionary && (this.err = a.inflateSetDictionary(this.strm, this.dictionary), this.err === e.Z_OK ? this.err = a.inflate(this.strm, this.flush) : this.err === e.Z_DATA_ERROR && (this.err = e.Z_NEED_DICT)); this.strm.avail_in > 0 && this.mode === e.GUNZIP && this.err === e.Z_STREAM_END && 0 !== this.strm.next_in[0];) {
                this.reset(), this.err = a.inflate(this.strm, this.flush);
              }

              break;

            default:
              throw new Error("Unknown mode " + this.mode);
          }
        }, c.prototype._checkError = function () {
          switch (this.err) {
            case e.Z_OK:
            case e.Z_BUF_ERROR:
              if (0 !== this.strm.avail_out && this.flush === e.Z_FINISH) return this._error("unexpected end of file"), !1;
              break;

            case e.Z_STREAM_END:
              break;

            case e.Z_NEED_DICT:
              return null == this.dictionary ? this._error("Missing dictionary") : this._error("Bad dictionary"), !1;

            default:
              return this._error("Zlib error"), !1;
          }

          return !0;
        }, c.prototype._after = function () {
          if (this._checkError()) {
            var t = this.strm.avail_out,
                e = this.strm.avail_in;
            this.write_in_progress = !1, this.callback(e, t), this.pending_close && this.close();
          }
        }, c.prototype._error = function (t) {
          this.strm.msg && (t = this.strm.msg), this.onerror(t, this.err), this.write_in_progress = !1, this.pending_close && this.close();
        }, c.prototype.init = function (t, r, n, o, s) {
          i(4 === arguments.length || 5 === arguments.length, "init(windowBits, level, memLevel, strategy, [dictionary])"), i(t >= 8 && t <= 15, "invalid windowBits"), i(r >= -1 && r <= 9, "invalid compression level"), i(n >= 1 && n <= 9, "invalid memlevel"), i(o === e.Z_FILTERED || o === e.Z_HUFFMAN_ONLY || o === e.Z_RLE || o === e.Z_FIXED || o === e.Z_DEFAULT_STRATEGY, "invalid strategy"), this._init(r, t, n, o, s), this._setDictionary();
        }, c.prototype.params = function () {
          throw new Error("deflateParams Not supported");
        }, c.prototype.reset = function () {
          this._reset(), this._setDictionary();
        }, c.prototype._init = function (t, r, n, i, u) {
          switch (this.level = t, this.windowBits = r, this.memLevel = n, this.strategy = i, this.flush = e.Z_NO_FLUSH, this.err = e.Z_OK, this.mode !== e.GZIP && this.mode !== e.GUNZIP || (this.windowBits += 16), this.mode === e.UNZIP && (this.windowBits += 32), this.mode !== e.DEFLATERAW && this.mode !== e.INFLATERAW || (this.windowBits = -1 * this.windowBits), this.strm = new o(), this.mode) {
            case e.DEFLATE:
            case e.GZIP:
            case e.DEFLATERAW:
              this.err = s.deflateInit2(this.strm, this.level, e.Z_DEFLATED, this.windowBits, this.memLevel, this.strategy);
              break;

            case e.INFLATE:
            case e.GUNZIP:
            case e.INFLATERAW:
            case e.UNZIP:
              this.err = a.inflateInit2(this.strm, this.windowBits);
              break;

            default:
              throw new Error("Unknown mode " + this.mode);
          }

          this.err !== e.Z_OK && this._error("Init error"), this.dictionary = u, this.write_in_progress = !1, this.init_done = !0;
        }, c.prototype._setDictionary = function () {
          if (null != this.dictionary) {
            switch (this.err = e.Z_OK, this.mode) {
              case e.DEFLATE:
              case e.DEFLATERAW:
                this.err = s.deflateSetDictionary(this.strm, this.dictionary);
            }

            this.err !== e.Z_OK && this._error("Failed to set dictionary");
          }
        }, c.prototype._reset = function () {
          switch (this.err = e.Z_OK, this.mode) {
            case e.DEFLATE:
            case e.DEFLATERAW:
            case e.GZIP:
              this.err = s.deflateReset(this.strm);
              break;

            case e.INFLATE:
            case e.INFLATERAW:
            case e.GUNZIP:
              this.err = a.inflateReset(this.strm);
          }

          this.err !== e.Z_OK && this._error("Failed to reset stream");
        }, e.Zlib = c;
      }).call(this, r(0).Buffer, r(1));
    }, function (t, e, r) {
      "use strict";
      /*
      object-assign
      (c) Sindre Sorhus
      @license MIT
      */

      var n = Object.getOwnPropertySymbols,
          i = Object.prototype.hasOwnProperty,
          o = Object.prototype.propertyIsEnumerable;

      function s(t) {
        if (null == t) throw new TypeError("Object.assign cannot be called with null or undefined");
        return Object(t);
      }

      t.exports = function () {
        try {
          if (!Object.assign) return !1;
          var t = new String("abc");
          if (t[5] = "de", "5" === Object.getOwnPropertyNames(t)[0]) return !1;

          for (var e = {}, r = 0; r < 10; r++) {
            e["_" + String.fromCharCode(r)] = r;
          }

          if ("0123456789" !== Object.getOwnPropertyNames(e).map(function (t) {
            return e[t];
          }).join("")) return !1;
          var n = {};
          return "abcdefghijklmnopqrst".split("").forEach(function (t) {
            n[t] = t;
          }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, n)).join("");
        } catch (t) {
          return !1;
        }
      }() ? Object.assign : function (t, e) {
        for (var r, a, u = s(t), f = 1; f < arguments.length; f++) {
          for (var c in r = Object(arguments[f])) {
            i.call(r, c) && (u[c] = r[c]);
          }

          if (n) {
            a = n(r);

            for (var h = 0; h < a.length; h++) {
              o.call(r, a[h]) && (u[a[h]] = r[a[h]]);
            }
          }
        }

        return u;
      };
    }, function (t, e) {
      t.exports = function (t) {
        return t && "object" == typeof t && "function" == typeof t.copy && "function" == typeof t.fill && "function" == typeof t.readUInt8;
      };
    }, function (t, e, r) {
      "use strict";

      t.exports = function () {
        this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
      };
    }, function (t, e, r) {
      "use strict";

      var n,
          i = r(8),
          o = r(55),
          s = r(22),
          a = r(23),
          u = r(56);

      function f(t, e) {
        return t.msg = u[e], e;
      }

      function c(t) {
        return (t << 1) - (t > 4 ? 9 : 0);
      }

      function h(t) {
        for (var e = t.length; --e >= 0;) {
          t[e] = 0;
        }
      }

      function l(t) {
        var e = t.state,
            r = e.pending;
        r > t.avail_out && (r = t.avail_out), 0 !== r && (i.arraySet(t.output, e.pending_buf, e.pending_out, r, t.next_out), t.next_out += r, e.pending_out += r, t.total_out += r, t.avail_out -= r, e.pending -= r, 0 === e.pending && (e.pending_out = 0));
      }

      function d(t, e) {
        o._tr_flush_block(t, t.block_start >= 0 ? t.block_start : -1, t.strstart - t.block_start, e), t.block_start = t.strstart, l(t.strm);
      }

      function p(t, e) {
        t.pending_buf[t.pending++] = e;
      }

      function g(t, e) {
        t.pending_buf[t.pending++] = e >>> 8 & 255, t.pending_buf[t.pending++] = 255 & e;
      }

      function m(t, e) {
        var r,
            n,
            i = t.max_chain_length,
            o = t.strstart,
            s = t.prev_length,
            a = t.nice_match,
            u = t.strstart > t.w_size - 262 ? t.strstart - (t.w_size - 262) : 0,
            f = t.window,
            c = t.w_mask,
            h = t.prev,
            l = t.strstart + 258,
            d = f[o + s - 1],
            p = f[o + s];
        t.prev_length >= t.good_match && (i >>= 2), a > t.lookahead && (a = t.lookahead);

        do {
          if (f[(r = e) + s] === p && f[r + s - 1] === d && f[r] === f[o] && f[++r] === f[o + 1]) {
            o += 2, r++;

            do {} while (f[++o] === f[++r] && f[++o] === f[++r] && f[++o] === f[++r] && f[++o] === f[++r] && f[++o] === f[++r] && f[++o] === f[++r] && f[++o] === f[++r] && f[++o] === f[++r] && o < l);

            if (n = 258 - (l - o), o = l - 258, n > s) {
              if (t.match_start = e, s = n, n >= a) break;
              d = f[o + s - 1], p = f[o + s];
            }
          }
        } while ((e = h[e & c]) > u && 0 != --i);

        return s <= t.lookahead ? s : t.lookahead;
      }

      function b(t) {
        var e,
            r,
            n,
            o,
            u,
            f,
            c,
            h,
            l,
            d,
            p = t.w_size;

        do {
          if (o = t.window_size - t.lookahead - t.strstart, t.strstart >= p + (p - 262)) {
            i.arraySet(t.window, t.window, p, p, 0), t.match_start -= p, t.strstart -= p, t.block_start -= p, e = r = t.hash_size;

            do {
              n = t.head[--e], t.head[e] = n >= p ? n - p : 0;
            } while (--r);

            e = r = p;

            do {
              n = t.prev[--e], t.prev[e] = n >= p ? n - p : 0;
            } while (--r);

            o += p;
          }

          if (0 === t.strm.avail_in) break;
          if (f = t.strm, c = t.window, h = t.strstart + t.lookahead, l = o, d = void 0, (d = f.avail_in) > l && (d = l), r = 0 === d ? 0 : (f.avail_in -= d, i.arraySet(c, f.input, f.next_in, d, h), 1 === f.state.wrap ? f.adler = s(f.adler, c, d, h) : 2 === f.state.wrap && (f.adler = a(f.adler, c, d, h)), f.next_in += d, f.total_in += d, d), t.lookahead += r, t.lookahead + t.insert >= 3) for (u = t.strstart - t.insert, t.ins_h = t.window[u], t.ins_h = (t.ins_h << t.hash_shift ^ t.window[u + 1]) & t.hash_mask; t.insert && (t.ins_h = (t.ins_h << t.hash_shift ^ t.window[u + 3 - 1]) & t.hash_mask, t.prev[u & t.w_mask] = t.head[t.ins_h], t.head[t.ins_h] = u, u++, t.insert--, !(t.lookahead + t.insert < 3));) {
            ;
          }
        } while (t.lookahead < 262 && 0 !== t.strm.avail_in);
      }

      function v(t, e) {
        for (var r, n;;) {
          if (t.lookahead < 262) {
            if (b(t), t.lookahead < 262 && 0 === e) return 1;
            if (0 === t.lookahead) break;
          }

          if (r = 0, t.lookahead >= 3 && (t.ins_h = (t.ins_h << t.hash_shift ^ t.window[t.strstart + 3 - 1]) & t.hash_mask, r = t.prev[t.strstart & t.w_mask] = t.head[t.ins_h], t.head[t.ins_h] = t.strstart), 0 !== r && t.strstart - r <= t.w_size - 262 && (t.match_length = m(t, r)), t.match_length >= 3) {
            if (n = o._tr_tally(t, t.strstart - t.match_start, t.match_length - 3), t.lookahead -= t.match_length, t.match_length <= t.max_lazy_match && t.lookahead >= 3) {
              t.match_length--;

              do {
                t.strstart++, t.ins_h = (t.ins_h << t.hash_shift ^ t.window[t.strstart + 3 - 1]) & t.hash_mask, r = t.prev[t.strstart & t.w_mask] = t.head[t.ins_h], t.head[t.ins_h] = t.strstart;
              } while (0 != --t.match_length);

              t.strstart++;
            } else t.strstart += t.match_length, t.match_length = 0, t.ins_h = t.window[t.strstart], t.ins_h = (t.ins_h << t.hash_shift ^ t.window[t.strstart + 1]) & t.hash_mask;
          } else n = o._tr_tally(t, 0, t.window[t.strstart]), t.lookahead--, t.strstart++;
          if (n && (d(t, !1), 0 === t.strm.avail_out)) return 1;
        }

        return t.insert = t.strstart < 2 ? t.strstart : 2, 4 === e ? (d(t, !0), 0 === t.strm.avail_out ? 3 : 4) : t.last_lit && (d(t, !1), 0 === t.strm.avail_out) ? 1 : 2;
      }

      function y(t, e) {
        for (var r, n, i;;) {
          if (t.lookahead < 262) {
            if (b(t), t.lookahead < 262 && 0 === e) return 1;
            if (0 === t.lookahead) break;
          }

          if (r = 0, t.lookahead >= 3 && (t.ins_h = (t.ins_h << t.hash_shift ^ t.window[t.strstart + 3 - 1]) & t.hash_mask, r = t.prev[t.strstart & t.w_mask] = t.head[t.ins_h], t.head[t.ins_h] = t.strstart), t.prev_length = t.match_length, t.prev_match = t.match_start, t.match_length = 2, 0 !== r && t.prev_length < t.max_lazy_match && t.strstart - r <= t.w_size - 262 && (t.match_length = m(t, r), t.match_length <= 5 && (1 === t.strategy || 3 === t.match_length && t.strstart - t.match_start > 4096) && (t.match_length = 2)), t.prev_length >= 3 && t.match_length <= t.prev_length) {
            i = t.strstart + t.lookahead - 3, n = o._tr_tally(t, t.strstart - 1 - t.prev_match, t.prev_length - 3), t.lookahead -= t.prev_length - 1, t.prev_length -= 2;

            do {
              ++t.strstart <= i && (t.ins_h = (t.ins_h << t.hash_shift ^ t.window[t.strstart + 3 - 1]) & t.hash_mask, r = t.prev[t.strstart & t.w_mask] = t.head[t.ins_h], t.head[t.ins_h] = t.strstart);
            } while (0 != --t.prev_length);

            if (t.match_available = 0, t.match_length = 2, t.strstart++, n && (d(t, !1), 0 === t.strm.avail_out)) return 1;
          } else if (t.match_available) {
            if ((n = o._tr_tally(t, 0, t.window[t.strstart - 1])) && d(t, !1), t.strstart++, t.lookahead--, 0 === t.strm.avail_out) return 1;
          } else t.match_available = 1, t.strstart++, t.lookahead--;
        }

        return t.match_available && (n = o._tr_tally(t, 0, t.window[t.strstart - 1]), t.match_available = 0), t.insert = t.strstart < 2 ? t.strstart : 2, 4 === e ? (d(t, !0), 0 === t.strm.avail_out ? 3 : 4) : t.last_lit && (d(t, !1), 0 === t.strm.avail_out) ? 1 : 2;
      }

      function _(t, e, r, n, i) {
        this.good_length = t, this.max_lazy = e, this.nice_length = r, this.max_chain = n, this.func = i;
      }

      function w() {
        this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = 8, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new i.Buf16(1146), this.dyn_dtree = new i.Buf16(122), this.bl_tree = new i.Buf16(78), h(this.dyn_ltree), h(this.dyn_dtree), h(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new i.Buf16(16), this.heap = new i.Buf16(573), h(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new i.Buf16(573), h(this.depth), this.l_buf = 0, this.lit_bufsize = 0, this.last_lit = 0, this.d_buf = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
      }

      function E(t) {
        var e;
        return t && t.state ? (t.total_in = t.total_out = 0, t.data_type = 2, (e = t.state).pending = 0, e.pending_out = 0, e.wrap < 0 && (e.wrap = -e.wrap), e.status = e.wrap ? 42 : 113, t.adler = 2 === e.wrap ? 0 : 1, e.last_flush = 0, o._tr_init(e), 0) : f(t, -2);
      }

      function M(t) {
        var e,
            r = E(t);
        return 0 === r && ((e = t.state).window_size = 2 * e.w_size, h(e.head), e.max_lazy_match = n[e.level].max_lazy, e.good_match = n[e.level].good_length, e.nice_match = n[e.level].nice_length, e.max_chain_length = n[e.level].max_chain, e.strstart = 0, e.block_start = 0, e.lookahead = 0, e.insert = 0, e.match_length = e.prev_length = 2, e.match_available = 0, e.ins_h = 0), r;
      }

      function S(t, e, r, n, o, s) {
        if (!t) return -2;
        var a = 1;
        if (-1 === e && (e = 6), n < 0 ? (a = 0, n = -n) : n > 15 && (a = 2, n -= 16), o < 1 || o > 9 || 8 !== r || n < 8 || n > 15 || e < 0 || e > 9 || s < 0 || s > 4) return f(t, -2);
        8 === n && (n = 9);
        var u = new w();
        return t.state = u, u.strm = t, u.wrap = a, u.gzhead = null, u.w_bits = n, u.w_size = 1 << u.w_bits, u.w_mask = u.w_size - 1, u.hash_bits = o + 7, u.hash_size = 1 << u.hash_bits, u.hash_mask = u.hash_size - 1, u.hash_shift = ~~((u.hash_bits + 3 - 1) / 3), u.window = new i.Buf8(2 * u.w_size), u.head = new i.Buf16(u.hash_size), u.prev = new i.Buf16(u.w_size), u.lit_bufsize = 1 << o + 6, u.pending_buf_size = 4 * u.lit_bufsize, u.pending_buf = new i.Buf8(u.pending_buf_size), u.d_buf = 1 * u.lit_bufsize, u.l_buf = 3 * u.lit_bufsize, u.level = e, u.strategy = s, u.method = r, M(t);
      }

      n = [new _(0, 0, 0, 0, function (t, e) {
        var r = 65535;

        for (r > t.pending_buf_size - 5 && (r = t.pending_buf_size - 5);;) {
          if (t.lookahead <= 1) {
            if (b(t), 0 === t.lookahead && 0 === e) return 1;
            if (0 === t.lookahead) break;
          }

          t.strstart += t.lookahead, t.lookahead = 0;
          var n = t.block_start + r;
          if ((0 === t.strstart || t.strstart >= n) && (t.lookahead = t.strstart - n, t.strstart = n, d(t, !1), 0 === t.strm.avail_out)) return 1;
          if (t.strstart - t.block_start >= t.w_size - 262 && (d(t, !1), 0 === t.strm.avail_out)) return 1;
        }

        return t.insert = 0, 4 === e ? (d(t, !0), 0 === t.strm.avail_out ? 3 : 4) : (t.strstart > t.block_start && (d(t, !1), t.strm.avail_out), 1);
      }), new _(4, 4, 8, 4, v), new _(4, 5, 16, 8, v), new _(4, 6, 32, 32, v), new _(4, 4, 16, 16, y), new _(8, 16, 32, 32, y), new _(8, 16, 128, 128, y), new _(8, 32, 128, 256, y), new _(32, 128, 258, 1024, y), new _(32, 258, 258, 4096, y)], e.deflateInit = function (t, e) {
        return S(t, e, 8, 15, 8, 0);
      }, e.deflateInit2 = S, e.deflateReset = M, e.deflateResetKeep = E, e.deflateSetHeader = function (t, e) {
        return t && t.state ? 2 !== t.state.wrap ? -2 : (t.state.gzhead = e, 0) : -2;
      }, e.deflate = function (t, e) {
        var r, i, s, u;
        if (!t || !t.state || e > 5 || e < 0) return t ? f(t, -2) : -2;
        if (i = t.state, !t.output || !t.input && 0 !== t.avail_in || 666 === i.status && 4 !== e) return f(t, 0 === t.avail_out ? -5 : -2);
        if (i.strm = t, r = i.last_flush, i.last_flush = e, 42 === i.status) if (2 === i.wrap) t.adler = 0, p(i, 31), p(i, 139), p(i, 8), i.gzhead ? (p(i, (i.gzhead.text ? 1 : 0) + (i.gzhead.hcrc ? 2 : 0) + (i.gzhead.extra ? 4 : 0) + (i.gzhead.name ? 8 : 0) + (i.gzhead.comment ? 16 : 0)), p(i, 255 & i.gzhead.time), p(i, i.gzhead.time >> 8 & 255), p(i, i.gzhead.time >> 16 & 255), p(i, i.gzhead.time >> 24 & 255), p(i, 9 === i.level ? 2 : i.strategy >= 2 || i.level < 2 ? 4 : 0), p(i, 255 & i.gzhead.os), i.gzhead.extra && i.gzhead.extra.length && (p(i, 255 & i.gzhead.extra.length), p(i, i.gzhead.extra.length >> 8 & 255)), i.gzhead.hcrc && (t.adler = a(t.adler, i.pending_buf, i.pending, 0)), i.gzindex = 0, i.status = 69) : (p(i, 0), p(i, 0), p(i, 0), p(i, 0), p(i, 0), p(i, 9 === i.level ? 2 : i.strategy >= 2 || i.level < 2 ? 4 : 0), p(i, 3), i.status = 113);else {
          var m = 8 + (i.w_bits - 8 << 4) << 8;
          m |= (i.strategy >= 2 || i.level < 2 ? 0 : i.level < 6 ? 1 : 6 === i.level ? 2 : 3) << 6, 0 !== i.strstart && (m |= 32), m += 31 - m % 31, i.status = 113, g(i, m), 0 !== i.strstart && (g(i, t.adler >>> 16), g(i, 65535 & t.adler)), t.adler = 1;
        }
        if (69 === i.status) if (i.gzhead.extra) {
          for (s = i.pending; i.gzindex < (65535 & i.gzhead.extra.length) && (i.pending !== i.pending_buf_size || (i.gzhead.hcrc && i.pending > s && (t.adler = a(t.adler, i.pending_buf, i.pending - s, s)), l(t), s = i.pending, i.pending !== i.pending_buf_size));) {
            p(i, 255 & i.gzhead.extra[i.gzindex]), i.gzindex++;
          }

          i.gzhead.hcrc && i.pending > s && (t.adler = a(t.adler, i.pending_buf, i.pending - s, s)), i.gzindex === i.gzhead.extra.length && (i.gzindex = 0, i.status = 73);
        } else i.status = 73;
        if (73 === i.status) if (i.gzhead.name) {
          s = i.pending;

          do {
            if (i.pending === i.pending_buf_size && (i.gzhead.hcrc && i.pending > s && (t.adler = a(t.adler, i.pending_buf, i.pending - s, s)), l(t), s = i.pending, i.pending === i.pending_buf_size)) {
              u = 1;
              break;
            }

            u = i.gzindex < i.gzhead.name.length ? 255 & i.gzhead.name.charCodeAt(i.gzindex++) : 0, p(i, u);
          } while (0 !== u);

          i.gzhead.hcrc && i.pending > s && (t.adler = a(t.adler, i.pending_buf, i.pending - s, s)), 0 === u && (i.gzindex = 0, i.status = 91);
        } else i.status = 91;
        if (91 === i.status) if (i.gzhead.comment) {
          s = i.pending;

          do {
            if (i.pending === i.pending_buf_size && (i.gzhead.hcrc && i.pending > s && (t.adler = a(t.adler, i.pending_buf, i.pending - s, s)), l(t), s = i.pending, i.pending === i.pending_buf_size)) {
              u = 1;
              break;
            }

            u = i.gzindex < i.gzhead.comment.length ? 255 & i.gzhead.comment.charCodeAt(i.gzindex++) : 0, p(i, u);
          } while (0 !== u);

          i.gzhead.hcrc && i.pending > s && (t.adler = a(t.adler, i.pending_buf, i.pending - s, s)), 0 === u && (i.status = 103);
        } else i.status = 103;

        if (103 === i.status && (i.gzhead.hcrc ? (i.pending + 2 > i.pending_buf_size && l(t), i.pending + 2 <= i.pending_buf_size && (p(i, 255 & t.adler), p(i, t.adler >> 8 & 255), t.adler = 0, i.status = 113)) : i.status = 113), 0 !== i.pending) {
          if (l(t), 0 === t.avail_out) return i.last_flush = -1, 0;
        } else if (0 === t.avail_in && c(e) <= c(r) && 4 !== e) return f(t, -5);

        if (666 === i.status && 0 !== t.avail_in) return f(t, -5);

        if (0 !== t.avail_in || 0 !== i.lookahead || 0 !== e && 666 !== i.status) {
          var v = 2 === i.strategy ? function (t, e) {
            for (var r;;) {
              if (0 === t.lookahead && (b(t), 0 === t.lookahead)) {
                if (0 === e) return 1;
                break;
              }

              if (t.match_length = 0, r = o._tr_tally(t, 0, t.window[t.strstart]), t.lookahead--, t.strstart++, r && (d(t, !1), 0 === t.strm.avail_out)) return 1;
            }

            return t.insert = 0, 4 === e ? (d(t, !0), 0 === t.strm.avail_out ? 3 : 4) : t.last_lit && (d(t, !1), 0 === t.strm.avail_out) ? 1 : 2;
          }(i, e) : 3 === i.strategy ? function (t, e) {
            for (var r, n, i, s, a = t.window;;) {
              if (t.lookahead <= 258) {
                if (b(t), t.lookahead <= 258 && 0 === e) return 1;
                if (0 === t.lookahead) break;
              }

              if (t.match_length = 0, t.lookahead >= 3 && t.strstart > 0 && (n = a[i = t.strstart - 1]) === a[++i] && n === a[++i] && n === a[++i]) {
                s = t.strstart + 258;

                do {} while (n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && i < s);

                t.match_length = 258 - (s - i), t.match_length > t.lookahead && (t.match_length = t.lookahead);
              }

              if (t.match_length >= 3 ? (r = o._tr_tally(t, 1, t.match_length - 3), t.lookahead -= t.match_length, t.strstart += t.match_length, t.match_length = 0) : (r = o._tr_tally(t, 0, t.window[t.strstart]), t.lookahead--, t.strstart++), r && (d(t, !1), 0 === t.strm.avail_out)) return 1;
            }

            return t.insert = 0, 4 === e ? (d(t, !0), 0 === t.strm.avail_out ? 3 : 4) : t.last_lit && (d(t, !1), 0 === t.strm.avail_out) ? 1 : 2;
          }(i, e) : n[i.level].func(i, e);
          if (3 !== v && 4 !== v || (i.status = 666), 1 === v || 3 === v) return 0 === t.avail_out && (i.last_flush = -1), 0;
          if (2 === v && (1 === e ? o._tr_align(i) : 5 !== e && (o._tr_stored_block(i, 0, 0, !1), 3 === e && (h(i.head), 0 === i.lookahead && (i.strstart = 0, i.block_start = 0, i.insert = 0))), l(t), 0 === t.avail_out)) return i.last_flush = -1, 0;
        }

        return 4 !== e ? 0 : i.wrap <= 0 ? 1 : (2 === i.wrap ? (p(i, 255 & t.adler), p(i, t.adler >> 8 & 255), p(i, t.adler >> 16 & 255), p(i, t.adler >> 24 & 255), p(i, 255 & t.total_in), p(i, t.total_in >> 8 & 255), p(i, t.total_in >> 16 & 255), p(i, t.total_in >> 24 & 255)) : (g(i, t.adler >>> 16), g(i, 65535 & t.adler)), l(t), i.wrap > 0 && (i.wrap = -i.wrap), 0 !== i.pending ? 0 : 1);
      }, e.deflateEnd = function (t) {
        var e;
        return t && t.state ? 42 !== (e = t.state.status) && 69 !== e && 73 !== e && 91 !== e && 103 !== e && 113 !== e && 666 !== e ? f(t, -2) : (t.state = null, 113 === e ? f(t, -3) : 0) : -2;
      }, e.deflateSetDictionary = function (t, e) {
        var r,
            n,
            o,
            a,
            u,
            f,
            c,
            l,
            d = e.length;
        if (!t || !t.state) return -2;
        if (2 === (a = (r = t.state).wrap) || 1 === a && 42 !== r.status || r.lookahead) return -2;

        for (1 === a && (t.adler = s(t.adler, e, d, 0)), r.wrap = 0, d >= r.w_size && (0 === a && (h(r.head), r.strstart = 0, r.block_start = 0, r.insert = 0), l = new i.Buf8(r.w_size), i.arraySet(l, e, d - r.w_size, r.w_size, 0), e = l, d = r.w_size), u = t.avail_in, f = t.next_in, c = t.input, t.avail_in = d, t.next_in = 0, t.input = e, b(r); r.lookahead >= 3;) {
          n = r.strstart, o = r.lookahead - 2;

          do {
            r.ins_h = (r.ins_h << r.hash_shift ^ r.window[n + 3 - 1]) & r.hash_mask, r.prev[n & r.w_mask] = r.head[r.ins_h], r.head[r.ins_h] = n, n++;
          } while (--o);

          r.strstart = n, r.lookahead = 2, b(r);
        }

        return r.strstart += r.lookahead, r.block_start = r.strstart, r.insert = r.lookahead, r.lookahead = 0, r.match_length = r.prev_length = 2, r.match_available = 0, t.next_in = f, t.input = c, t.avail_in = u, r.wrap = a, 0;
      }, e.deflateInfo = "pako deflate (from Nodeca project)";
    }, function (t, e, r) {
      "use strict";

      var n = r(8);

      function i(t) {
        for (var e = t.length; --e >= 0;) {
          t[e] = 0;
        }
      }

      var o = [0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0],
          s = [0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13],
          a = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 3, 7],
          u = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15],
          f = new Array(576);
      i(f);
      var c = new Array(60);
      i(c);
      var h = new Array(512);
      i(h);
      var l = new Array(256);
      i(l);
      var d = new Array(29);
      i(d);
      var p,
          g,
          m,
          b = new Array(30);

      function v(t, e, r, n, i) {
        this.static_tree = t, this.extra_bits = e, this.extra_base = r, this.elems = n, this.max_length = i, this.has_stree = t && t.length;
      }

      function y(t, e) {
        this.dyn_tree = t, this.max_code = 0, this.stat_desc = e;
      }

      function _(t) {
        return t < 256 ? h[t] : h[256 + (t >>> 7)];
      }

      function w(t, e) {
        t.pending_buf[t.pending++] = 255 & e, t.pending_buf[t.pending++] = e >>> 8 & 255;
      }

      function E(t, e, r) {
        t.bi_valid > 16 - r ? (t.bi_buf |= e << t.bi_valid & 65535, w(t, t.bi_buf), t.bi_buf = e >> 16 - t.bi_valid, t.bi_valid += r - 16) : (t.bi_buf |= e << t.bi_valid & 65535, t.bi_valid += r);
      }

      function M(t, e, r) {
        E(t, r[2 * e], r[2 * e + 1]);
      }

      function S(t, e) {
        var r = 0;

        do {
          r |= 1 & t, t >>>= 1, r <<= 1;
        } while (--e > 0);

        return r >>> 1;
      }

      function A(t, e, r) {
        var n,
            i,
            o = new Array(16),
            s = 0;

        for (n = 1; n <= 15; n++) {
          o[n] = s = s + r[n - 1] << 1;
        }

        for (i = 0; i <= e; i++) {
          var a = t[2 * i + 1];
          0 !== a && (t[2 * i] = S(o[a]++, a));
        }
      }

      function x(t) {
        var e;

        for (e = 0; e < 286; e++) {
          t.dyn_ltree[2 * e] = 0;
        }

        for (e = 0; e < 30; e++) {
          t.dyn_dtree[2 * e] = 0;
        }

        for (e = 0; e < 19; e++) {
          t.bl_tree[2 * e] = 0;
        }

        t.dyn_ltree[512] = 1, t.opt_len = t.static_len = 0, t.last_lit = t.matches = 0;
      }

      function R(t) {
        t.bi_valid > 8 ? w(t, t.bi_buf) : t.bi_valid > 0 && (t.pending_buf[t.pending++] = t.bi_buf), t.bi_buf = 0, t.bi_valid = 0;
      }

      function T(t, e, r, n) {
        var i = 2 * e,
            o = 2 * r;
        return t[i] < t[o] || t[i] === t[o] && n[e] <= n[r];
      }

      function k(t, e, r) {
        for (var n = t.heap[r], i = r << 1; i <= t.heap_len && (i < t.heap_len && T(e, t.heap[i + 1], t.heap[i], t.depth) && i++, !T(e, n, t.heap[i], t.depth));) {
          t.heap[r] = t.heap[i], r = i, i <<= 1;
        }

        t.heap[r] = n;
      }

      function I(t, e, r) {
        var n,
            i,
            a,
            u,
            f = 0;
        if (0 !== t.last_lit) do {
          n = t.pending_buf[t.d_buf + 2 * f] << 8 | t.pending_buf[t.d_buf + 2 * f + 1], i = t.pending_buf[t.l_buf + f], f++, 0 === n ? M(t, i, e) : (M(t, (a = l[i]) + 256 + 1, e), 0 !== (u = o[a]) && E(t, i -= d[a], u), M(t, a = _(--n), r), 0 !== (u = s[a]) && E(t, n -= b[a], u));
        } while (f < t.last_lit);
        M(t, 256, e);
      }

      function B(t, e) {
        var r,
            n,
            i,
            o = e.dyn_tree,
            s = e.stat_desc.static_tree,
            a = e.stat_desc.has_stree,
            u = e.stat_desc.elems,
            f = -1;

        for (t.heap_len = 0, t.heap_max = 573, r = 0; r < u; r++) {
          0 !== o[2 * r] ? (t.heap[++t.heap_len] = f = r, t.depth[r] = 0) : o[2 * r + 1] = 0;
        }

        for (; t.heap_len < 2;) {
          o[2 * (i = t.heap[++t.heap_len] = f < 2 ? ++f : 0)] = 1, t.depth[i] = 0, t.opt_len--, a && (t.static_len -= s[2 * i + 1]);
        }

        for (e.max_code = f, r = t.heap_len >> 1; r >= 1; r--) {
          k(t, o, r);
        }

        i = u;

        do {
          r = t.heap[1], t.heap[1] = t.heap[t.heap_len--], k(t, o, 1), n = t.heap[1], t.heap[--t.heap_max] = r, t.heap[--t.heap_max] = n, o[2 * i] = o[2 * r] + o[2 * n], t.depth[i] = (t.depth[r] >= t.depth[n] ? t.depth[r] : t.depth[n]) + 1, o[2 * r + 1] = o[2 * n + 1] = i, t.heap[1] = i++, k(t, o, 1);
        } while (t.heap_len >= 2);

        t.heap[--t.heap_max] = t.heap[1], function (t, e) {
          var r,
              n,
              i,
              o,
              s,
              a,
              u = e.dyn_tree,
              f = e.max_code,
              c = e.stat_desc.static_tree,
              h = e.stat_desc.has_stree,
              l = e.stat_desc.extra_bits,
              d = e.stat_desc.extra_base,
              p = e.stat_desc.max_length,
              g = 0;

          for (o = 0; o <= 15; o++) {
            t.bl_count[o] = 0;
          }

          for (u[2 * t.heap[t.heap_max] + 1] = 0, r = t.heap_max + 1; r < 573; r++) {
            (o = u[2 * u[2 * (n = t.heap[r]) + 1] + 1] + 1) > p && (o = p, g++), u[2 * n + 1] = o, n > f || (t.bl_count[o]++, s = 0, n >= d && (s = l[n - d]), a = u[2 * n], t.opt_len += a * (o + s), h && (t.static_len += a * (c[2 * n + 1] + s)));
          }

          if (0 !== g) {
            do {
              for (o = p - 1; 0 === t.bl_count[o];) {
                o--;
              }

              t.bl_count[o]--, t.bl_count[o + 1] += 2, t.bl_count[p]--, g -= 2;
            } while (g > 0);

            for (o = p; 0 !== o; o--) {
              for (n = t.bl_count[o]; 0 !== n;) {
                (i = t.heap[--r]) > f || (u[2 * i + 1] !== o && (t.opt_len += (o - u[2 * i + 1]) * u[2 * i], u[2 * i + 1] = o), n--);
              }
            }
          }
        }(t, e), A(o, f, t.bl_count);
      }

      function O(t, e, r) {
        var n,
            i,
            o = -1,
            s = e[1],
            a = 0,
            u = 7,
            f = 4;

        for (0 === s && (u = 138, f = 3), e[2 * (r + 1) + 1] = 65535, n = 0; n <= r; n++) {
          i = s, s = e[2 * (n + 1) + 1], ++a < u && i === s || (a < f ? t.bl_tree[2 * i] += a : 0 !== i ? (i !== o && t.bl_tree[2 * i]++, t.bl_tree[32]++) : a <= 10 ? t.bl_tree[34]++ : t.bl_tree[36]++, a = 0, o = i, 0 === s ? (u = 138, f = 3) : i === s ? (u = 6, f = 3) : (u = 7, f = 4));
        }
      }

      function P(t, e, r) {
        var n,
            i,
            o = -1,
            s = e[1],
            a = 0,
            u = 7,
            f = 4;

        for (0 === s && (u = 138, f = 3), n = 0; n <= r; n++) {
          if (i = s, s = e[2 * (n + 1) + 1], !(++a < u && i === s)) {
            if (a < f) do {
              M(t, i, t.bl_tree);
            } while (0 != --a);else 0 !== i ? (i !== o && (M(t, i, t.bl_tree), a--), M(t, 16, t.bl_tree), E(t, a - 3, 2)) : a <= 10 ? (M(t, 17, t.bl_tree), E(t, a - 3, 3)) : (M(t, 18, t.bl_tree), E(t, a - 11, 7));
            a = 0, o = i, 0 === s ? (u = 138, f = 3) : i === s ? (u = 6, f = 3) : (u = 7, f = 4);
          }
        }
      }

      i(b);
      var N = !1;

      function C(t, e, r, i) {
        E(t, 0 + (i ? 1 : 0), 3), function (t, e, r, i) {
          R(t), w(t, r), w(t, ~r), n.arraySet(t.pending_buf, t.window, e, r, t.pending), t.pending += r;
        }(t, e, r);
      }

      e._tr_init = function (t) {
        N || (function () {
          var t,
              e,
              r,
              n,
              i,
              u = new Array(16);

          for (r = 0, n = 0; n < 28; n++) {
            for (d[n] = r, t = 0; t < 1 << o[n]; t++) {
              l[r++] = n;
            }
          }

          for (l[r - 1] = n, i = 0, n = 0; n < 16; n++) {
            for (b[n] = i, t = 0; t < 1 << s[n]; t++) {
              h[i++] = n;
            }
          }

          for (i >>= 7; n < 30; n++) {
            for (b[n] = i << 7, t = 0; t < 1 << s[n] - 7; t++) {
              h[256 + i++] = n;
            }
          }

          for (e = 0; e <= 15; e++) {
            u[e] = 0;
          }

          for (t = 0; t <= 143;) {
            f[2 * t + 1] = 8, t++, u[8]++;
          }

          for (; t <= 255;) {
            f[2 * t + 1] = 9, t++, u[9]++;
          }

          for (; t <= 279;) {
            f[2 * t + 1] = 7, t++, u[7]++;
          }

          for (; t <= 287;) {
            f[2 * t + 1] = 8, t++, u[8]++;
          }

          for (A(f, 287, u), t = 0; t < 30; t++) {
            c[2 * t + 1] = 5, c[2 * t] = S(t, 5);
          }

          p = new v(f, o, 257, 286, 15), g = new v(c, s, 0, 30, 15), m = new v(new Array(0), a, 0, 19, 7);
        }(), N = !0), t.l_desc = new y(t.dyn_ltree, p), t.d_desc = new y(t.dyn_dtree, g), t.bl_desc = new y(t.bl_tree, m), t.bi_buf = 0, t.bi_valid = 0, x(t);
      }, e._tr_stored_block = C, e._tr_flush_block = function (t, e, r, n) {
        var i,
            o,
            s = 0;
        t.level > 0 ? (2 === t.strm.data_type && (t.strm.data_type = function (t) {
          var e,
              r = 4093624447;

          for (e = 0; e <= 31; e++, r >>>= 1) {
            if (1 & r && 0 !== t.dyn_ltree[2 * e]) return 0;
          }

          if (0 !== t.dyn_ltree[18] || 0 !== t.dyn_ltree[20] || 0 !== t.dyn_ltree[26]) return 1;

          for (e = 32; e < 256; e++) {
            if (0 !== t.dyn_ltree[2 * e]) return 1;
          }

          return 0;
        }(t)), B(t, t.l_desc), B(t, t.d_desc), s = function (t) {
          var e;

          for (O(t, t.dyn_ltree, t.l_desc.max_code), O(t, t.dyn_dtree, t.d_desc.max_code), B(t, t.bl_desc), e = 18; e >= 3 && 0 === t.bl_tree[2 * u[e] + 1]; e--) {
            ;
          }

          return t.opt_len += 3 * (e + 1) + 5 + 5 + 4, e;
        }(t), i = t.opt_len + 3 + 7 >>> 3, (o = t.static_len + 3 + 7 >>> 3) <= i && (i = o)) : i = o = r + 5, r + 4 <= i && -1 !== e ? C(t, e, r, n) : 4 === t.strategy || o === i ? (E(t, 2 + (n ? 1 : 0), 3), I(t, f, c)) : (E(t, 4 + (n ? 1 : 0), 3), function (t, e, r, n) {
          var i;

          for (E(t, e - 257, 5), E(t, r - 1, 5), E(t, n - 4, 4), i = 0; i < n; i++) {
            E(t, t.bl_tree[2 * u[i] + 1], 3);
          }

          P(t, t.dyn_ltree, e - 1), P(t, t.dyn_dtree, r - 1);
        }(t, t.l_desc.max_code + 1, t.d_desc.max_code + 1, s + 1), I(t, t.dyn_ltree, t.dyn_dtree)), x(t), n && R(t);
      }, e._tr_tally = function (t, e, r) {
        return t.pending_buf[t.d_buf + 2 * t.last_lit] = e >>> 8 & 255, t.pending_buf[t.d_buf + 2 * t.last_lit + 1] = 255 & e, t.pending_buf[t.l_buf + t.last_lit] = 255 & r, t.last_lit++, 0 === e ? t.dyn_ltree[2 * r]++ : (t.matches++, e--, t.dyn_ltree[2 * (l[r] + 256 + 1)]++, t.dyn_dtree[2 * _(e)]++), t.last_lit === t.lit_bufsize - 1;
      }, e._tr_align = function (t) {
        E(t, 2, 3), M(t, 256, f), function (t) {
          16 === t.bi_valid ? (w(t, t.bi_buf), t.bi_buf = 0, t.bi_valid = 0) : t.bi_valid >= 8 && (t.pending_buf[t.pending++] = 255 & t.bi_buf, t.bi_buf >>= 8, t.bi_valid -= 8);
        }(t);
      };
    }, function (t, e, r) {
      "use strict";

      t.exports = {
        2: "need dictionary",
        1: "stream end",
        0: "",
        "-1": "file error",
        "-2": "stream error",
        "-3": "data error",
        "-4": "insufficient memory",
        "-5": "buffer error",
        "-6": "incompatible version"
      };
    }, function (t, e, r) {
      "use strict";

      var n = r(8),
          i = r(22),
          o = r(23),
          s = r(58),
          a = r(59);

      function u(t) {
        return (t >>> 24 & 255) + (t >>> 8 & 65280) + ((65280 & t) << 8) + ((255 & t) << 24);
      }

      function f() {
        this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new n.Buf16(320), this.work = new n.Buf16(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
      }

      function c(t) {
        var e;
        return t && t.state ? (e = t.state, t.total_in = t.total_out = e.total = 0, t.msg = "", e.wrap && (t.adler = 1 & e.wrap), e.mode = 1, e.last = 0, e.havedict = 0, e.dmax = 32768, e.head = null, e.hold = 0, e.bits = 0, e.lencode = e.lendyn = new n.Buf32(852), e.distcode = e.distdyn = new n.Buf32(592), e.sane = 1, e.back = -1, 0) : -2;
      }

      function h(t) {
        var e;
        return t && t.state ? ((e = t.state).wsize = 0, e.whave = 0, e.wnext = 0, c(t)) : -2;
      }

      function l(t, e) {
        var r, n;
        return t && t.state ? (n = t.state, e < 0 ? (r = 0, e = -e) : (r = 1 + (e >> 4), e < 48 && (e &= 15)), e && (e < 8 || e > 15) ? -2 : (null !== n.window && n.wbits !== e && (n.window = null), n.wrap = r, n.wbits = e, h(t))) : -2;
      }

      function d(t, e) {
        var r, n;
        return t ? (n = new f(), t.state = n, n.window = null, 0 !== (r = l(t, e)) && (t.state = null), r) : -2;
      }

      var p,
          g,
          m = !0;

      function b(t) {
        if (m) {
          var e;

          for (p = new n.Buf32(512), g = new n.Buf32(32), e = 0; e < 144;) {
            t.lens[e++] = 8;
          }

          for (; e < 256;) {
            t.lens[e++] = 9;
          }

          for (; e < 280;) {
            t.lens[e++] = 7;
          }

          for (; e < 288;) {
            t.lens[e++] = 8;
          }

          for (a(1, t.lens, 0, 288, p, 0, t.work, {
            bits: 9
          }), e = 0; e < 32;) {
            t.lens[e++] = 5;
          }

          a(2, t.lens, 0, 32, g, 0, t.work, {
            bits: 5
          }), m = !1;
        }

        t.lencode = p, t.lenbits = 9, t.distcode = g, t.distbits = 5;
      }

      function v(t, e, r, i) {
        var o,
            s = t.state;
        return null === s.window && (s.wsize = 1 << s.wbits, s.wnext = 0, s.whave = 0, s.window = new n.Buf8(s.wsize)), i >= s.wsize ? (n.arraySet(s.window, e, r - s.wsize, s.wsize, 0), s.wnext = 0, s.whave = s.wsize) : ((o = s.wsize - s.wnext) > i && (o = i), n.arraySet(s.window, e, r - i, o, s.wnext), (i -= o) ? (n.arraySet(s.window, e, r - i, i, 0), s.wnext = i, s.whave = s.wsize) : (s.wnext += o, s.wnext === s.wsize && (s.wnext = 0), s.whave < s.wsize && (s.whave += o))), 0;
      }

      e.inflateReset = h, e.inflateReset2 = l, e.inflateResetKeep = c, e.inflateInit = function (t) {
        return d(t, 15);
      }, e.inflateInit2 = d, e.inflate = function (t, e) {
        var r,
            f,
            c,
            h,
            l,
            d,
            p,
            g,
            m,
            y,
            _,
            w,
            E,
            M,
            S,
            A,
            x,
            R,
            T,
            k,
            I,
            B,
            O,
            P,
            N = 0,
            C = new n.Buf8(4),
            L = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15];

        if (!t || !t.state || !t.output || !t.input && 0 !== t.avail_in) return -2;
        12 === (r = t.state).mode && (r.mode = 13), l = t.next_out, c = t.output, p = t.avail_out, h = t.next_in, f = t.input, d = t.avail_in, g = r.hold, m = r.bits, y = d, _ = p, B = 0;

        t: for (;;) {
          switch (r.mode) {
            case 1:
              if (0 === r.wrap) {
                r.mode = 13;
                break;
              }

              for (; m < 16;) {
                if (0 === d) break t;
                d--, g += f[h++] << m, m += 8;
              }

              if (2 & r.wrap && 35615 === g) {
                r.check = 0, C[0] = 255 & g, C[1] = g >>> 8 & 255, r.check = o(r.check, C, 2, 0), g = 0, m = 0, r.mode = 2;
                break;
              }

              if (r.flags = 0, r.head && (r.head.done = !1), !(1 & r.wrap) || (((255 & g) << 8) + (g >> 8)) % 31) {
                t.msg = "incorrect header check", r.mode = 30;
                break;
              }

              if (8 != (15 & g)) {
                t.msg = "unknown compression method", r.mode = 30;
                break;
              }

              if (m -= 4, I = 8 + (15 & (g >>>= 4)), 0 === r.wbits) r.wbits = I;else if (I > r.wbits) {
                t.msg = "invalid window size", r.mode = 30;
                break;
              }
              r.dmax = 1 << I, t.adler = r.check = 1, r.mode = 512 & g ? 10 : 12, g = 0, m = 0;
              break;

            case 2:
              for (; m < 16;) {
                if (0 === d) break t;
                d--, g += f[h++] << m, m += 8;
              }

              if (r.flags = g, 8 != (255 & r.flags)) {
                t.msg = "unknown compression method", r.mode = 30;
                break;
              }

              if (57344 & r.flags) {
                t.msg = "unknown header flags set", r.mode = 30;
                break;
              }

              r.head && (r.head.text = g >> 8 & 1), 512 & r.flags && (C[0] = 255 & g, C[1] = g >>> 8 & 255, r.check = o(r.check, C, 2, 0)), g = 0, m = 0, r.mode = 3;

            case 3:
              for (; m < 32;) {
                if (0 === d) break t;
                d--, g += f[h++] << m, m += 8;
              }

              r.head && (r.head.time = g), 512 & r.flags && (C[0] = 255 & g, C[1] = g >>> 8 & 255, C[2] = g >>> 16 & 255, C[3] = g >>> 24 & 255, r.check = o(r.check, C, 4, 0)), g = 0, m = 0, r.mode = 4;

            case 4:
              for (; m < 16;) {
                if (0 === d) break t;
                d--, g += f[h++] << m, m += 8;
              }

              r.head && (r.head.xflags = 255 & g, r.head.os = g >> 8), 512 & r.flags && (C[0] = 255 & g, C[1] = g >>> 8 & 255, r.check = o(r.check, C, 2, 0)), g = 0, m = 0, r.mode = 5;

            case 5:
              if (1024 & r.flags) {
                for (; m < 16;) {
                  if (0 === d) break t;
                  d--, g += f[h++] << m, m += 8;
                }

                r.length = g, r.head && (r.head.extra_len = g), 512 & r.flags && (C[0] = 255 & g, C[1] = g >>> 8 & 255, r.check = o(r.check, C, 2, 0)), g = 0, m = 0;
              } else r.head && (r.head.extra = null);

              r.mode = 6;

            case 6:
              if (1024 & r.flags && ((w = r.length) > d && (w = d), w && (r.head && (I = r.head.extra_len - r.length, r.head.extra || (r.head.extra = new Array(r.head.extra_len)), n.arraySet(r.head.extra, f, h, w, I)), 512 & r.flags && (r.check = o(r.check, f, w, h)), d -= w, h += w, r.length -= w), r.length)) break t;
              r.length = 0, r.mode = 7;

            case 7:
              if (2048 & r.flags) {
                if (0 === d) break t;
                w = 0;

                do {
                  I = f[h + w++], r.head && I && r.length < 65536 && (r.head.name += String.fromCharCode(I));
                } while (I && w < d);

                if (512 & r.flags && (r.check = o(r.check, f, w, h)), d -= w, h += w, I) break t;
              } else r.head && (r.head.name = null);

              r.length = 0, r.mode = 8;

            case 8:
              if (4096 & r.flags) {
                if (0 === d) break t;
                w = 0;

                do {
                  I = f[h + w++], r.head && I && r.length < 65536 && (r.head.comment += String.fromCharCode(I));
                } while (I && w < d);

                if (512 & r.flags && (r.check = o(r.check, f, w, h)), d -= w, h += w, I) break t;
              } else r.head && (r.head.comment = null);

              r.mode = 9;

            case 9:
              if (512 & r.flags) {
                for (; m < 16;) {
                  if (0 === d) break t;
                  d--, g += f[h++] << m, m += 8;
                }

                if (g !== (65535 & r.check)) {
                  t.msg = "header crc mismatch", r.mode = 30;
                  break;
                }

                g = 0, m = 0;
              }

              r.head && (r.head.hcrc = r.flags >> 9 & 1, r.head.done = !0), t.adler = r.check = 0, r.mode = 12;
              break;

            case 10:
              for (; m < 32;) {
                if (0 === d) break t;
                d--, g += f[h++] << m, m += 8;
              }

              t.adler = r.check = u(g), g = 0, m = 0, r.mode = 11;

            case 11:
              if (0 === r.havedict) return t.next_out = l, t.avail_out = p, t.next_in = h, t.avail_in = d, r.hold = g, r.bits = m, 2;
              t.adler = r.check = 1, r.mode = 12;

            case 12:
              if (5 === e || 6 === e) break t;

            case 13:
              if (r.last) {
                g >>>= 7 & m, m -= 7 & m, r.mode = 27;
                break;
              }

              for (; m < 3;) {
                if (0 === d) break t;
                d--, g += f[h++] << m, m += 8;
              }

              switch (r.last = 1 & g, m -= 1, 3 & (g >>>= 1)) {
                case 0:
                  r.mode = 14;
                  break;

                case 1:
                  if (b(r), r.mode = 20, 6 === e) {
                    g >>>= 2, m -= 2;
                    break t;
                  }

                  break;

                case 2:
                  r.mode = 17;
                  break;

                case 3:
                  t.msg = "invalid block type", r.mode = 30;
              }

              g >>>= 2, m -= 2;
              break;

            case 14:
              for (g >>>= 7 & m, m -= 7 & m; m < 32;) {
                if (0 === d) break t;
                d--, g += f[h++] << m, m += 8;
              }

              if ((65535 & g) != (g >>> 16 ^ 65535)) {
                t.msg = "invalid stored block lengths", r.mode = 30;
                break;
              }

              if (r.length = 65535 & g, g = 0, m = 0, r.mode = 15, 6 === e) break t;

            case 15:
              r.mode = 16;

            case 16:
              if (w = r.length) {
                if (w > d && (w = d), w > p && (w = p), 0 === w) break t;
                n.arraySet(c, f, h, w, l), d -= w, h += w, p -= w, l += w, r.length -= w;
                break;
              }

              r.mode = 12;
              break;

            case 17:
              for (; m < 14;) {
                if (0 === d) break t;
                d--, g += f[h++] << m, m += 8;
              }

              if (r.nlen = 257 + (31 & g), g >>>= 5, m -= 5, r.ndist = 1 + (31 & g), g >>>= 5, m -= 5, r.ncode = 4 + (15 & g), g >>>= 4, m -= 4, r.nlen > 286 || r.ndist > 30) {
                t.msg = "too many length or distance symbols", r.mode = 30;
                break;
              }

              r.have = 0, r.mode = 18;

            case 18:
              for (; r.have < r.ncode;) {
                for (; m < 3;) {
                  if (0 === d) break t;
                  d--, g += f[h++] << m, m += 8;
                }

                r.lens[L[r.have++]] = 7 & g, g >>>= 3, m -= 3;
              }

              for (; r.have < 19;) {
                r.lens[L[r.have++]] = 0;
              }

              if (r.lencode = r.lendyn, r.lenbits = 7, O = {
                bits: r.lenbits
              }, B = a(0, r.lens, 0, 19, r.lencode, 0, r.work, O), r.lenbits = O.bits, B) {
                t.msg = "invalid code lengths set", r.mode = 30;
                break;
              }

              r.have = 0, r.mode = 19;

            case 19:
              for (; r.have < r.nlen + r.ndist;) {
                for (; A = (N = r.lencode[g & (1 << r.lenbits) - 1]) >>> 16 & 255, x = 65535 & N, !((S = N >>> 24) <= m);) {
                  if (0 === d) break t;
                  d--, g += f[h++] << m, m += 8;
                }

                if (x < 16) g >>>= S, m -= S, r.lens[r.have++] = x;else {
                  if (16 === x) {
                    for (P = S + 2; m < P;) {
                      if (0 === d) break t;
                      d--, g += f[h++] << m, m += 8;
                    }

                    if (g >>>= S, m -= S, 0 === r.have) {
                      t.msg = "invalid bit length repeat", r.mode = 30;
                      break;
                    }

                    I = r.lens[r.have - 1], w = 3 + (3 & g), g >>>= 2, m -= 2;
                  } else if (17 === x) {
                    for (P = S + 3; m < P;) {
                      if (0 === d) break t;
                      d--, g += f[h++] << m, m += 8;
                    }

                    m -= S, I = 0, w = 3 + (7 & (g >>>= S)), g >>>= 3, m -= 3;
                  } else {
                    for (P = S + 7; m < P;) {
                      if (0 === d) break t;
                      d--, g += f[h++] << m, m += 8;
                    }

                    m -= S, I = 0, w = 11 + (127 & (g >>>= S)), g >>>= 7, m -= 7;
                  }

                  if (r.have + w > r.nlen + r.ndist) {
                    t.msg = "invalid bit length repeat", r.mode = 30;
                    break;
                  }

                  for (; w--;) {
                    r.lens[r.have++] = I;
                  }
                }
              }

              if (30 === r.mode) break;

              if (0 === r.lens[256]) {
                t.msg = "invalid code -- missing end-of-block", r.mode = 30;
                break;
              }

              if (r.lenbits = 9, O = {
                bits: r.lenbits
              }, B = a(1, r.lens, 0, r.nlen, r.lencode, 0, r.work, O), r.lenbits = O.bits, B) {
                t.msg = "invalid literal/lengths set", r.mode = 30;
                break;
              }

              if (r.distbits = 6, r.distcode = r.distdyn, O = {
                bits: r.distbits
              }, B = a(2, r.lens, r.nlen, r.ndist, r.distcode, 0, r.work, O), r.distbits = O.bits, B) {
                t.msg = "invalid distances set", r.mode = 30;
                break;
              }

              if (r.mode = 20, 6 === e) break t;

            case 20:
              r.mode = 21;

            case 21:
              if (d >= 6 && p >= 258) {
                t.next_out = l, t.avail_out = p, t.next_in = h, t.avail_in = d, r.hold = g, r.bits = m, s(t, _), l = t.next_out, c = t.output, p = t.avail_out, h = t.next_in, f = t.input, d = t.avail_in, g = r.hold, m = r.bits, 12 === r.mode && (r.back = -1);
                break;
              }

              for (r.back = 0; A = (N = r.lencode[g & (1 << r.lenbits) - 1]) >>> 16 & 255, x = 65535 & N, !((S = N >>> 24) <= m);) {
                if (0 === d) break t;
                d--, g += f[h++] << m, m += 8;
              }

              if (A && 0 == (240 & A)) {
                for (R = S, T = A, k = x; A = (N = r.lencode[k + ((g & (1 << R + T) - 1) >> R)]) >>> 16 & 255, x = 65535 & N, !(R + (S = N >>> 24) <= m);) {
                  if (0 === d) break t;
                  d--, g += f[h++] << m, m += 8;
                }

                g >>>= R, m -= R, r.back += R;
              }

              if (g >>>= S, m -= S, r.back += S, r.length = x, 0 === A) {
                r.mode = 26;
                break;
              }

              if (32 & A) {
                r.back = -1, r.mode = 12;
                break;
              }

              if (64 & A) {
                t.msg = "invalid literal/length code", r.mode = 30;
                break;
              }

              r.extra = 15 & A, r.mode = 22;

            case 22:
              if (r.extra) {
                for (P = r.extra; m < P;) {
                  if (0 === d) break t;
                  d--, g += f[h++] << m, m += 8;
                }

                r.length += g & (1 << r.extra) - 1, g >>>= r.extra, m -= r.extra, r.back += r.extra;
              }

              r.was = r.length, r.mode = 23;

            case 23:
              for (; A = (N = r.distcode[g & (1 << r.distbits) - 1]) >>> 16 & 255, x = 65535 & N, !((S = N >>> 24) <= m);) {
                if (0 === d) break t;
                d--, g += f[h++] << m, m += 8;
              }

              if (0 == (240 & A)) {
                for (R = S, T = A, k = x; A = (N = r.distcode[k + ((g & (1 << R + T) - 1) >> R)]) >>> 16 & 255, x = 65535 & N, !(R + (S = N >>> 24) <= m);) {
                  if (0 === d) break t;
                  d--, g += f[h++] << m, m += 8;
                }

                g >>>= R, m -= R, r.back += R;
              }

              if (g >>>= S, m -= S, r.back += S, 64 & A) {
                t.msg = "invalid distance code", r.mode = 30;
                break;
              }

              r.offset = x, r.extra = 15 & A, r.mode = 24;

            case 24:
              if (r.extra) {
                for (P = r.extra; m < P;) {
                  if (0 === d) break t;
                  d--, g += f[h++] << m, m += 8;
                }

                r.offset += g & (1 << r.extra) - 1, g >>>= r.extra, m -= r.extra, r.back += r.extra;
              }

              if (r.offset > r.dmax) {
                t.msg = "invalid distance too far back", r.mode = 30;
                break;
              }

              r.mode = 25;

            case 25:
              if (0 === p) break t;

              if (w = _ - p, r.offset > w) {
                if ((w = r.offset - w) > r.whave && r.sane) {
                  t.msg = "invalid distance too far back", r.mode = 30;
                  break;
                }

                w > r.wnext ? (w -= r.wnext, E = r.wsize - w) : E = r.wnext - w, w > r.length && (w = r.length), M = r.window;
              } else M = c, E = l - r.offset, w = r.length;

              w > p && (w = p), p -= w, r.length -= w;

              do {
                c[l++] = M[E++];
              } while (--w);

              0 === r.length && (r.mode = 21);
              break;

            case 26:
              if (0 === p) break t;
              c[l++] = r.length, p--, r.mode = 21;
              break;

            case 27:
              if (r.wrap) {
                for (; m < 32;) {
                  if (0 === d) break t;
                  d--, g |= f[h++] << m, m += 8;
                }

                if (_ -= p, t.total_out += _, r.total += _, _ && (t.adler = r.check = r.flags ? o(r.check, c, _, l - _) : i(r.check, c, _, l - _)), _ = p, (r.flags ? g : u(g)) !== r.check) {
                  t.msg = "incorrect data check", r.mode = 30;
                  break;
                }

                g = 0, m = 0;
              }

              r.mode = 28;

            case 28:
              if (r.wrap && r.flags) {
                for (; m < 32;) {
                  if (0 === d) break t;
                  d--, g += f[h++] << m, m += 8;
                }

                if (g !== (4294967295 & r.total)) {
                  t.msg = "incorrect length check", r.mode = 30;
                  break;
                }

                g = 0, m = 0;
              }

              r.mode = 29;

            case 29:
              B = 1;
              break t;

            case 30:
              B = -3;
              break t;

            case 31:
              return -4;

            case 32:
            default:
              return -2;
          }
        }

        return t.next_out = l, t.avail_out = p, t.next_in = h, t.avail_in = d, r.hold = g, r.bits = m, (r.wsize || _ !== t.avail_out && r.mode < 30 && (r.mode < 27 || 4 !== e)) && v(t, t.output, t.next_out, _ - t.avail_out) ? (r.mode = 31, -4) : (y -= t.avail_in, _ -= t.avail_out, t.total_in += y, t.total_out += _, r.total += _, r.wrap && _ && (t.adler = r.check = r.flags ? o(r.check, c, _, t.next_out - _) : i(r.check, c, _, t.next_out - _)), t.data_type = r.bits + (r.last ? 64 : 0) + (12 === r.mode ? 128 : 0) + (20 === r.mode || 15 === r.mode ? 256 : 0), (0 === y && 0 === _ || 4 === e) && 0 === B && (B = -5), B);
      }, e.inflateEnd = function (t) {
        if (!t || !t.state) return -2;
        var e = t.state;
        return e.window && (e.window = null), t.state = null, 0;
      }, e.inflateGetHeader = function (t, e) {
        var r;
        return t && t.state ? 0 == (2 & (r = t.state).wrap) ? -2 : (r.head = e, e.done = !1, 0) : -2;
      }, e.inflateSetDictionary = function (t, e) {
        var r,
            n = e.length;
        return t && t.state ? 0 !== (r = t.state).wrap && 11 !== r.mode ? -2 : 11 === r.mode && i(1, e, n, 0) !== r.check ? -3 : v(t, e, n, n) ? (r.mode = 31, -4) : (r.havedict = 1, 0) : -2;
      }, e.inflateInfo = "pako inflate (from Nodeca project)";
    }, function (t, e, r) {
      "use strict";

      t.exports = function (t, e) {
        var r, n, i, o, s, a, u, f, c, h, l, d, p, g, m, b, v, y, _, w, E, M, S, A, x;

        r = t.state, n = t.next_in, A = t.input, i = n + (t.avail_in - 5), o = t.next_out, x = t.output, s = o - (e - t.avail_out), a = o + (t.avail_out - 257), u = r.dmax, f = r.wsize, c = r.whave, h = r.wnext, l = r.window, d = r.hold, p = r.bits, g = r.lencode, m = r.distcode, b = (1 << r.lenbits) - 1, v = (1 << r.distbits) - 1;

        t: do {
          p < 15 && (d += A[n++] << p, p += 8, d += A[n++] << p, p += 8), y = g[d & b];

          e: for (;;) {
            if (d >>>= _ = y >>> 24, p -= _, 0 == (_ = y >>> 16 & 255)) x[o++] = 65535 & y;else {
              if (!(16 & _)) {
                if (0 == (64 & _)) {
                  y = g[(65535 & y) + (d & (1 << _) - 1)];
                  continue e;
                }

                if (32 & _) {
                  r.mode = 12;
                  break t;
                }

                t.msg = "invalid literal/length code", r.mode = 30;
                break t;
              }

              w = 65535 & y, (_ &= 15) && (p < _ && (d += A[n++] << p, p += 8), w += d & (1 << _) - 1, d >>>= _, p -= _), p < 15 && (d += A[n++] << p, p += 8, d += A[n++] << p, p += 8), y = m[d & v];

              r: for (;;) {
                if (d >>>= _ = y >>> 24, p -= _, !(16 & (_ = y >>> 16 & 255))) {
                  if (0 == (64 & _)) {
                    y = m[(65535 & y) + (d & (1 << _) - 1)];
                    continue r;
                  }

                  t.msg = "invalid distance code", r.mode = 30;
                  break t;
                }

                if (E = 65535 & y, p < (_ &= 15) && (d += A[n++] << p, (p += 8) < _ && (d += A[n++] << p, p += 8)), (E += d & (1 << _) - 1) > u) {
                  t.msg = "invalid distance too far back", r.mode = 30;
                  break t;
                }

                if (d >>>= _, p -= _, E > (_ = o - s)) {
                  if ((_ = E - _) > c && r.sane) {
                    t.msg = "invalid distance too far back", r.mode = 30;
                    break t;
                  }

                  if (M = 0, S = l, 0 === h) {
                    if (M += f - _, _ < w) {
                      w -= _;

                      do {
                        x[o++] = l[M++];
                      } while (--_);

                      M = o - E, S = x;
                    }
                  } else if (h < _) {
                    if (M += f + h - _, (_ -= h) < w) {
                      w -= _;

                      do {
                        x[o++] = l[M++];
                      } while (--_);

                      if (M = 0, h < w) {
                        w -= _ = h;

                        do {
                          x[o++] = l[M++];
                        } while (--_);

                        M = o - E, S = x;
                      }
                    }
                  } else if (M += h - _, _ < w) {
                    w -= _;

                    do {
                      x[o++] = l[M++];
                    } while (--_);

                    M = o - E, S = x;
                  }

                  for (; w > 2;) {
                    x[o++] = S[M++], x[o++] = S[M++], x[o++] = S[M++], w -= 3;
                  }

                  w && (x[o++] = S[M++], w > 1 && (x[o++] = S[M++]));
                } else {
                  M = o - E;

                  do {
                    x[o++] = x[M++], x[o++] = x[M++], x[o++] = x[M++], w -= 3;
                  } while (w > 2);

                  w && (x[o++] = x[M++], w > 1 && (x[o++] = x[M++]));
                }

                break;
              }
            }
            break;
          }
        } while (n < i && o < a);

        n -= w = p >> 3, d &= (1 << (p -= w << 3)) - 1, t.next_in = n, t.next_out = o, t.avail_in = n < i ? i - n + 5 : 5 - (n - i), t.avail_out = o < a ? a - o + 257 : 257 - (o - a), r.hold = d, r.bits = p;
      };
    }, function (t, e, r) {
      "use strict";

      var n = r(8),
          i = [3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31, 35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0],
          o = [16, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 18, 18, 19, 19, 19, 19, 20, 20, 20, 20, 21, 21, 21, 21, 16, 72, 78],
          s = [1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193, 257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145, 8193, 12289, 16385, 24577, 0, 0],
          a = [16, 16, 16, 16, 17, 17, 18, 18, 19, 19, 20, 20, 21, 21, 22, 22, 23, 23, 24, 24, 25, 25, 26, 26, 27, 27, 28, 28, 29, 29, 64, 64];

      t.exports = function (t, e, r, u, f, c, h, l) {
        var d,
            p,
            g,
            m,
            b,
            v,
            y,
            _,
            w,
            E = l.bits,
            M = 0,
            S = 0,
            A = 0,
            x = 0,
            R = 0,
            T = 0,
            k = 0,
            I = 0,
            B = 0,
            O = 0,
            P = null,
            N = 0,
            C = new n.Buf16(16),
            L = new n.Buf16(16),
            j = null,
            U = 0;

        for (M = 0; M <= 15; M++) {
          C[M] = 0;
        }

        for (S = 0; S < u; S++) {
          C[e[r + S]]++;
        }

        for (R = E, x = 15; x >= 1 && 0 === C[x]; x--) {
          ;
        }

        if (R > x && (R = x), 0 === x) return f[c++] = 20971520, f[c++] = 20971520, l.bits = 1, 0;

        for (A = 1; A < x && 0 === C[A]; A++) {
          ;
        }

        for (R < A && (R = A), I = 1, M = 1; M <= 15; M++) {
          if (I <<= 1, (I -= C[M]) < 0) return -1;
        }

        if (I > 0 && (0 === t || 1 !== x)) return -1;

        for (L[1] = 0, M = 1; M < 15; M++) {
          L[M + 1] = L[M] + C[M];
        }

        for (S = 0; S < u; S++) {
          0 !== e[r + S] && (h[L[e[r + S]]++] = S);
        }

        if (0 === t ? (P = j = h, v = 19) : 1 === t ? (P = i, N -= 257, j = o, U -= 257, v = 256) : (P = s, j = a, v = -1), O = 0, S = 0, M = A, b = c, T = R, k = 0, g = -1, m = (B = 1 << R) - 1, 1 === t && B > 852 || 2 === t && B > 592) return 1;

        for (;;) {
          y = M - k, h[S] < v ? (_ = 0, w = h[S]) : h[S] > v ? (_ = j[U + h[S]], w = P[N + h[S]]) : (_ = 96, w = 0), d = 1 << M - k, A = p = 1 << T;

          do {
            f[b + (O >> k) + (p -= d)] = y << 24 | _ << 16 | w | 0;
          } while (0 !== p);

          for (d = 1 << M - 1; O & d;) {
            d >>= 1;
          }

          if (0 !== d ? (O &= d - 1, O += d) : O = 0, S++, 0 == --C[M]) {
            if (M === x) break;
            M = e[r + h[S]];
          }

          if (M > R && (O & m) !== g) {
            for (0 === k && (k = R), b += A, I = 1 << (T = M - k); T + k < x && !((I -= C[T + k]) <= 0);) {
              T++, I <<= 1;
            }

            if (B += 1 << T, 1 === t && B > 852 || 2 === t && B > 592) return 1;
            f[g = O & m] = R << 24 | T << 16 | b - c | 0;
          }
        }

        return 0 !== O && (f[b + O] = M - k << 24 | 64 << 16 | 0), l.bits = R, 0;
      };
    }, function (t, e, r) {
      "use strict";

      t.exports = {
        Z_NO_FLUSH: 0,
        Z_PARTIAL_FLUSH: 1,
        Z_SYNC_FLUSH: 2,
        Z_FULL_FLUSH: 3,
        Z_FINISH: 4,
        Z_BLOCK: 5,
        Z_TREES: 6,
        Z_OK: 0,
        Z_STREAM_END: 1,
        Z_NEED_DICT: 2,
        Z_ERRNO: -1,
        Z_STREAM_ERROR: -2,
        Z_DATA_ERROR: -3,
        Z_BUF_ERROR: -5,
        Z_NO_COMPRESSION: 0,
        Z_BEST_SPEED: 1,
        Z_BEST_COMPRESSION: 9,
        Z_DEFAULT_COMPRESSION: -1,
        Z_FILTERED: 1,
        Z_HUFFMAN_ONLY: 2,
        Z_RLE: 3,
        Z_FIXED: 4,
        Z_DEFAULT_STRATEGY: 0,
        Z_BINARY: 0,
        Z_TEXT: 1,
        Z_UNKNOWN: 2,
        Z_DEFLATED: 8
      };
    }, function (t, e, r) {
      "use strict";

      (function (e, n) {
        !function () {
          if ("arm" !== e.arch) {
            var i = [];
            !function () {
              for (var t = 0; t < 256; t++) {
                for (var e = t, r = 0; r < 8; r++) {
                  1 & e ? e = 3988292384 ^ e >>> 1 : e >>>= 1;
                }

                i[t] = e >>> 0;
              }
            }(), t.exports = function () {
              for (var t = arguments.length, e = -1, r = 0; r < t; r++) {
                e = o(e, new n(arguments[r]));
              }

              return (-1 ^ e) >>> 0;
            };
          } else t.exports = r(62);

          function o(t, e) {
            for (var r = e.length, n = 0; n < r; n++) {
              t = i[255 & (t ^ e[n])] ^ t >>> 8;
            }

            return t;
          }
        }();
      }).call(this, r(1), r(0).Buffer);
    }, function (t, e, r) {
      "use strict";

      (function (e) {
        for (var r = [], n = 0; n < 256; n++) {
          var i = r[n] = new e(4);
          i.writeUInt32BE(n, 0);

          for (var o = 0; o < 8; o++) {
            var s = 1 & i[0],
                a = 1 & i[1],
                u = 1 & i[2],
                f = 1 & i[3];
            i[0] = i[0] >> 1 ^ (f ? 237 : 0), i[1] = i[1] >> 1 ^ (f ? 184 : 0) ^ (s ? 128 : 0), i[2] = i[2] >> 1 ^ (f ? 131 : 0) ^ (a ? 128 : 0), i[3] = i[3] >> 1 ^ (f ? 32 : 0) ^ (u ? 128 : 0);
          }
        }

        function c(t, e) {
          for (var n = e.length, i = 0; i < n; i++) {
            var o = r[t[3] ^ e[i]];
            t[3] = o[3] ^ t[2], t[2] = o[2] ^ t[1], t[1] = o[1] ^ t[0], t[0] = o[0];
          }
        }

        t.exports = function () {
          var t = arguments.length,
              r = new e(4);
          r.fill(255);

          for (var n = 0; n < t; n++) {
            c(r, new e(arguments[n]));
          }

          return r[0] = 255 ^ r[0], r[1] = 255 ^ r[1], r[2] = 255 ^ r[2], r[3] = 255 ^ r[3], r.readUInt32BE(0);
        };
      }).call(this, r(0).Buffer);
    }, function (t, e, r) {
      "use strict";

      function n(t) {
        for (var e = t.length, r = [], n = -1; n <= e; n++) {
          r[n] = [];
        }

        var i = [];

        for (n = 0; n < e; n++) {
          for (var o = 0; o < e; o++) {
            r[n][o] || (r[n][o] = 1, s(n, o) ? s(n - 1, o) || i.push(a(n, o, "right")) : s(n, o - 1) && i.push(a(n, o, "down")));
          }
        }

        return i;

        function s(r, n) {
          return !(r < 0 || n < 0 || r >= e || n >= e || !t[r][n]);
        }

        function a(t, e, n) {
          r[t][e] = 1;
          var i = [];
          i.push(["M", e, t]);
          var o = t,
              a = e,
              u = 0;

          do {
            switch (n) {
              case "right":
                r[o][a] = 1, s(o, a) ? (r[o - 1][a] = 1, s(o - 1, a) ? (i.push(["h", u]), u = 0, n = "up") : (u++, a++)) : (i.push(["h", u]), u = 0, n = "down");
                break;

              case "left":
                r[o - 1][a - 1] = 1, s(o - 1, a - 1) ? (r[o][a - 1] = 1, s(o, a - 1) ? (i.push(["h", -u]), u = 0, n = "down") : (u++, a--)) : (i.push(["h", -u]), u = 0, n = "up");
                break;

              case "down":
                r[o][a - 1] = 1, s(o, a - 1) ? (r[o][a] = 1, s(o, a) ? (i.push(["v", u]), u = 0, n = "right") : (u++, o++)) : (i.push(["v", u]), u = 0, n = "left");
                break;

              case "up":
                r[o - 1][a] = 1, s(o - 1, a) ? (r[o - 1][a - 1] = 1, s(o - 1, a - 1) ? (i.push(["v", -u]), u = 0, n = "left") : (u++, o--)) : (i.push(["v", -u]), u = 0, n = "right");
            }
          } while (o != t || a != e);

          return i;
        }
      }

      function i(t, e, r) {
        n(t).forEach(function (t) {
          for (var n = "", i = 0; i < t.length; i++) {
            var o = t[i];

            switch (o[0]) {
              case "M":
                n += "M" + (o[1] + r) + " " + (o[2] + r);
                break;

              default:
                n += o.join("");
            }
          }

          n += "z", e.push(n);
        });
      }

      t.exports = {
        svg: function svg(t, e, r, n) {
          var o = t.length + 2 * r;

          if (e.push('<svg xmlns="http://www.w3.org/2000/svg" '), n > 0) {
            var s = o * n;
            e.push('width="' + s + '" height="' + s + '" ');
          }

          e.push('viewBox="0 0 ' + o + " " + o + '">'), e.push('<path d="'), i(t, e, r), e.push('"/></svg>'), e.push(null);
        },
        eps: function eps(t, e, r) {
          var i = t.length,
              o = 9 * (i + 2 * r);
          e.push(["%!PS-Adobe-3.0 EPSF-3.0", "%%BoundingBox: 0 0 " + o + " " + o, "/h { 0 rlineto } bind def", "/v { 0 exch neg rlineto } bind def", "/M { neg " + (i + r) + " add moveto } bind def", "/z { closepath } bind def", "9 9 scale", ""].join("\n")), n(t).forEach(function (t) {
            for (var n = "", i = 0; i < t.length; i++) {
              var o = t[i];

              switch (o[0]) {
                case "M":
                  n += o[1] + r + " " + o[2] + " M ";
                  break;

                default:
                  n += o[1] + " " + o[0] + " ";
              }
            }

            n += "z\n", e.push(n);
          }), e.push("fill\n%%EOF\n"), e.push(null);
        },
        pdf: function pdf(t, e, r) {
          var i = t.length,
              o = 9 * (i + 2 * r),
              s = ["%PDF-1.0\n\n", "1 0 obj << /Type /Catalog /Pages 2 0 R >> endobj\n", "2 0 obj << /Type /Pages /Count 1 /Kids [ 3 0 R ] >> endobj\n"];
          s.push("3 0 obj << /Type /Page /Parent 2 0 R /Resources <<>> /Contents 4 0 R /MediaBox [ 0 0 " + o + " " + o + " ] >> endobj\n");
          var a = "9 0 0 9 0 0 cm\n";
          a += n(t).map(function (t) {
            for (var e, n, o = "", s = 0; s < t.length; s++) {
              var a = t[s];

              switch (a[0]) {
                case "M":
                  o += (e = a[1] + r) + " " + (n = i - a[2] + r) + " m ";
                  break;

                case "h":
                  o += (e += a[1]) + " " + n + " l ";
                  break;

                case "v":
                  o += e + " " + (n -= a[1]) + " l ";
              }
            }

            return o + "h";
          }).join("\n"), a += "\nf\n", s.push("4 0 obj << /Length " + a.length + " >> stream\n" + a + "endstream\nendobj\n");

          for (var u = "xref\n0 5\n0000000000 65535 f \n", f = 1, c = s[0].length; f < 5; f++) {
            u += ("0000000000" + c).substr(-10) + " 00000 n \n", c += s[f].length;
          }

          s.push(u, "trailer << /Root 1 0 R /Size 5 >>\n", "startxref\n" + c + "\n%%EOF\n"), e.push(s.join("")), e.push(null);
        },
        svg_object: function svg_object(t, e) {
          var r = [];
          return i(t, r, e), {
            size: t.length + 2 * e,
            path: r.filter(Boolean).join("")
          };
        }
      };
    }, function (t, e) {
      t.exports = "data:image/svg+xml,%3Csvg width='1459' height='238' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M526.767 130.224l-20.024 72.055h-20.827L458 96.827h22.874l16.588 76.367h.585l19.731-76.367h18.635l19.731 76.367h.585l16.662-76.367h22.873l-27.989 105.452h-20.827l-20.023-72.055h-.658zm99.898 57.878c9.281 0 16.954-6.066 16.954-14.543v-5.7l-16.515 1.023c-7.966.585-12.497 4.166-12.497 9.72 0 5.846 4.823 9.5 12.058 9.5zm-7.015 15.42c-14.908 0-26.236-9.647-26.236-23.751 0-14.25 10.962-22.508 30.474-23.677l19.731-1.17v-5.188c0-7.308-5.115-11.547-13.154-11.547-7.965 0-13.008 3.947-14.03 9.72h-19.513c.804-15.2 13.739-25.65 34.493-25.65 20.097 0 33.178 10.376 33.178 26.161v53.86h-20.608v-11.986h-.439c-4.384 8.331-14.104 13.228-23.896 13.228zm59.193-1.243V96.827h21.339v105.452h-21.339zm36.247 0V96.827h21.339v105.452H715.09zm70.886-64.236c-9.354 0-16.077 7.089-16.808 16.881h33.25c-.438-10.011-6.942-16.88-16.442-16.88zm16.735 40.266h19.585c-2.338 15.347-16.37 25.651-35.735 25.651-24.116 0-38.586-15.42-38.586-40.485 0-24.993 14.616-41.217 37.782-41.217 22.8 0 37.197 15.42 37.197 39.243v6.504h-54.005v1.316c0 11.18 7.088 18.854 17.977 18.854 7.82 0 13.812-3.873 15.785-9.866zm36.905-72.42h21.339v18.05h14.47v16.077h-14.47v37.49c0 5.992 2.923 8.842 9.208 8.842 1.9 0 3.873-.146 5.188-.365v15.712c-2.192.511-5.846.877-10.158.877-18.416 0-25.577-6.14-25.577-21.412v-41.144H828.58V123.94h11.035v-18.05zm95.952 98.217c-30.693 0-49.913-20.535-49.913-54.59 0-33.98 19.366-54.516 49.913-54.516 25.358 0 44.65 16.077 46.332 39.682h-21.486c-2.046-12.935-11.984-21.412-24.846-21.412-16.662 0-27.405 13.958-27.405 36.173 0 22.509 10.597 36.394 27.478 36.394 13.08 0 22.508-7.674 24.847-20.17h21.485c-2.485 23.531-20.535 38.44-46.405 38.44zm94.125-.146c-23.678 0-38.805-15.2-38.805-40.924 0-25.358 15.347-40.778 38.805-40.778s38.805 15.347 38.805 40.778c0 25.797-15.128 40.924-38.805 40.924zm0-16.297c10.45 0 17.1-8.842 17.1-24.554 0-15.566-6.723-24.554-17.1-24.554-10.377 0-17.174 8.988-17.174 24.554 0 15.712 6.65 24.554 17.174 24.554zm49.766 14.616v-78.34h20.608v13.958h.439c4.165-9.72 12.423-15.42 24.481-15.42 17.393 0 27.185 10.962 27.185 29.305v50.497h-21.339v-46.04c0-10.23-4.823-16.077-14.396-16.077s-15.639 7.016-15.639 17.174v44.943h-21.339zm86.233 0v-78.34h20.608v13.958h.438c4.166-9.72 12.424-15.42 24.482-15.42 17.392 0 27.185 10.962 27.185 29.305v50.497h-21.339v-46.04c0-10.23-4.823-16.077-14.396-16.077-9.574 0-15.64 7.016-15.64 17.174v44.943h-21.338zm121.383-64.236c-9.354 0-16.077 7.089-16.808 16.881h33.25c-.438-10.011-6.942-16.88-16.442-16.88zm16.735 40.266h19.585c-2.338 15.347-16.37 25.651-35.735 25.651-24.116 0-38.586-15.42-38.586-40.485 0-24.993 14.616-41.217 37.782-41.217 22.8 0 37.197 15.42 37.197 39.243v6.504h-54.005v1.316c0 11.18 7.089 18.854 17.977 18.854 7.82 0 13.812-3.873 15.785-9.866zm102.383-25.212h-19.804c-1.242-8.257-6.723-14.104-15.493-14.104-10.523 0-17.1 8.916-17.1 24.043 0 15.42 6.577 24.189 17.173 24.189 8.55 0 14.104-5.115 15.42-13.666h19.877c-1.096 18.49-14.908 30.401-35.516 30.401-23.604 0-38.585-15.346-38.585-40.924 0-25.139 14.98-40.778 38.439-40.778 21.193 0 34.64 13.081 35.59 30.84zm16.077-47.208h21.34v18.05h14.469v16.077h-14.47v37.49c0 5.992 2.923 8.842 9.208 8.842 1.9 0 3.873-.146 5.189-.365v15.712c-2.193.511-5.847.877-10.158.877-18.416 0-25.578-6.14-25.578-21.412v-41.144h-11.034V123.94h11.034v-18.05z' fill='%233999FB'/%3E%3Cpath d='M79.5 46.539c63.216-61.894 165.71-61.894 228.926 0l7.608 7.449a7.808 7.808 0 0 1 0 11.207l-26.026 25.482a4.108 4.108 0 0 1-5.723 0l-10.47-10.251c-44.101-43.179-115.604-43.179-159.705 0l-11.212 10.978a4.108 4.108 0 0 1-5.723 0L71.149 65.922a7.808 7.808 0 0 1 0-11.207l8.35-8.176zm282.75 52.699l23.163 22.679a7.808 7.808 0 0 1 0 11.206L280.97 235.385c-3.161 3.095-8.286 3.095-11.447 0l-74.128-72.578a2.054 2.054 0 0 0-2.862 0l-74.127 72.578c-3.16 3.095-8.285 3.095-11.446 0L2.51 133.122a7.808 7.808 0 0 1 0-11.207l23.164-22.679c3.16-3.094 8.285-3.094 11.446 0l74.13 72.58c.79.773 2.07.773 2.861 0l74.126-72.58c3.16-3.094 8.285-3.094 11.446 0l74.13 72.58c.79.773 2.071.773 2.861 0l74.129-72.578c3.16-3.095 8.285-3.095 11.446 0z' fill='%233B99FC' fill-rule='nonzero'/%3E%3C/g%3E%3C/svg%3E";
    }, function (t, e, r) {
      "use strict";

      Object.defineProperty(e, "__esModule", {
        value: !0
      }), e.default = {
        animationDuration: 300
      };
    }, function (t, e, r) {
      var n = r(67),
          i = r(68);
      "string" == typeof (i = i.__esModule ? i.default : i) && (i = [[t.i, i, ""]]);
      var o = (n(i, {
        insert: "head",
        singleton: !1
      }), i.locals ? i.locals : {});
      t.exports = o;
    }, function (t, e, r) {
      "use strict";

      var n,
          i = function () {
        var t = {};
        return function (e) {
          if (void 0 === t[e]) {
            var r = document.querySelector(e);
            if (window.HTMLIFrameElement && r instanceof window.HTMLIFrameElement) try {
              r = r.contentDocument.head;
            } catch (t) {
              r = null;
            }
            t[e] = r;
          }

          return t[e];
        };
      }(),
          o = [];

      function s(t) {
        for (var e = -1, r = 0; r < o.length; r++) {
          if (o[r].identifier === t) {
            e = r;
            break;
          }
        }

        return e;
      }

      function a(t, e) {
        for (var r = {}, n = [], i = 0; i < t.length; i++) {
          var a = t[i],
              u = e.base ? a[0] + e.base : a[0],
              f = r[u] || 0,
              c = "".concat(u, " ").concat(f);
          r[u] = f + 1;
          var h = s(c),
              l = {
            css: a[1],
            media: a[2],
            sourceMap: a[3]
          };
          -1 !== h ? (o[h].references++, o[h].updater(l)) : o.push({
            identifier: c,
            updater: g(l, e),
            references: 1
          }), n.push(c);
        }

        return n;
      }

      function u(t) {
        var e = document.createElement("style"),
            n = t.attributes || {};

        if (void 0 === n.nonce) {
          var o = r.nc;
          o && (n.nonce = o);
        }

        if (Object.keys(n).forEach(function (t) {
          e.setAttribute(t, n[t]);
        }), "function" == typeof t.insert) t.insert(e);else {
          var s = i(t.insert || "head");
          if (!s) throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
          s.appendChild(e);
        }
        return e;
      }

      var f,
          c = (f = [], function (t, e) {
        return f[t] = e, f.filter(Boolean).join("\n");
      });

      function h(t, e, r, n) {
        var i = r ? "" : n.media ? "@media ".concat(n.media, " {").concat(n.css, "}") : n.css;
        if (t.styleSheet) t.styleSheet.cssText = c(e, i);else {
          var o = document.createTextNode(i),
              s = t.childNodes;
          s[e] && t.removeChild(s[e]), s.length ? t.insertBefore(o, s[e]) : t.appendChild(o);
        }
      }

      function l(t, e, r) {
        var n = r.css,
            i = r.media,
            o = r.sourceMap;
        if (i ? t.setAttribute("media", i) : t.removeAttribute("media"), o && btoa && (n += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(o)))), " */")), t.styleSheet) t.styleSheet.cssText = n;else {
          for (; t.firstChild;) {
            t.removeChild(t.firstChild);
          }

          t.appendChild(document.createTextNode(n));
        }
      }

      var d = null,
          p = 0;

      function g(t, e) {
        var r, n, i;

        if (e.singleton) {
          var o = p++;
          r = d || (d = u(e)), n = h.bind(null, r, o, !1), i = h.bind(null, r, o, !0);
        } else r = u(e), n = l.bind(null, r, e), i = function i() {
          !function (t) {
            if (null === t.parentNode) return !1;
            t.parentNode.removeChild(t);
          }(r);
        };

        return n(t), function (e) {
          if (e) {
            if (e.css === t.css && e.media === t.media && e.sourceMap === t.sourceMap) return;
            n(t = e);
          } else i();
        };
      }

      t.exports = function (t, e) {
        (e = e || {}).singleton || "boolean" == typeof e.singleton || (e.singleton = (void 0 === n && (n = Boolean(window && document && document.all && !window.atob)), n));
        var r = a(t = t || [], e);
        return function (t) {
          if (t = t || [], "[object Array]" === Object.prototype.toString.call(t)) {
            for (var n = 0; n < r.length; n++) {
              var i = s(r[n]);
              o[i].references--;
            }

            for (var u = a(t, e), f = 0; f < r.length; f++) {
              var c = s(r[f]);
              0 === o[c].references && (o[c].updater(), o.splice(c, 1));
            }

            r = u;
          }
        };
      };
    }, function (t, e, r) {
      (e = r(69)(!1)).push([t.i, ":root {\n  --animation-duration: 300ms;\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n@keyframes fadeOut {\n  from { opacity: 1; }\n  to { opacity: 0; }\n}\n\n.animated {\n  animation-duration: var(--animation-duration);\n  animation-fill-mode: both;\n}\n\n.fadeIn {\n  animation-name: fadeIn;\n}\n  \n.fadeOut {\n  animation-name: fadeOut;\n}\n\n.walletconnect-modal__base {\n  position: relative;\n  top: 50%;\n  display: inline-block;\n  z-index: 2147483000;\n  background: #fff;\n  transform: translateY(-50%);\n  margin: 0 auto;\n  border-radius: 8px;\n  overflow: hidden;\n  box-shadow: 0 12px 24px 0 rgba(0,0,0,0.1);\n  width: 100%;\n  max-width: 500px;\n}\n\n.walletconnect-modal__header {\n  position: relative;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.walletconnect-modal__headerLogo {\n  width: 100%;\n  max-width: 320px;\n  margin: 20px auto;\n  height: 100%;\n}\n\n.walletconnect-modal__close__wrapper {\n  position: absolute;\n  top: 15px;\n  right: 15px;\n  z-index: 10000;\n}\n\n.walletconnect-modal__close__icon {\n  width: 25px;\n  height: 25px;\n  position: relative;\n  top: 0;\n  right: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transform: rotate(45deg);\n}\n\n.walletconnect-modal__close__line1 {\n  position: absolute;\n  width: 90%;\n  border: 1px solid #7C828B;\n}\n\n.walletconnect-modal__close__line2 {\n  position: absolute;\n  width: 90%;\n  border: 1px solid #7C828B;\n  transform: rotate(90deg);\n}\n\n.walletconnect-qrcode__base {\n  position: fixed;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 2147482999;\n  background-color: rgba(0,0,0,0.5);\n  text-align: center;\n}\n\n.walletconnect-qrcode__text {\n  color: #7C828B;\n  font-family: Avenir;\n  font-size: 18px;\n  text-align: center;\n  margin: 0 auto;\n  padding: 0 30px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.walletconnect-qrcode__image {\n  width: 100%;\n  padding: 30px;\n  box-sizing: border-box;\n}\n", ""]), t.exports = e;
    }, function (t, e, r) {
      "use strict";

      t.exports = function (t) {
        var e = [];
        return e.toString = function () {
          return this.map(function (e) {
            var r = function (t, e) {
              var r,
                  n,
                  i,
                  o = t[1] || "",
                  s = t[3];
              if (!s) return o;

              if (e && "function" == typeof btoa) {
                var a = (r = s, n = btoa(unescape(encodeURIComponent(JSON.stringify(r)))), i = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(n), "/*# ".concat(i, " */")),
                    u = s.sources.map(function (t) {
                  return "/*# sourceURL=".concat(s.sourceRoot || "").concat(t, " */");
                });
                return [o].concat(u).concat([a]).join("\n");
              }

              return [o].join("\n");
            }(e, t);

            return e[2] ? "@media ".concat(e[2], " {").concat(r, "}") : r;
          }).join("");
        }, e.i = function (t, r, n) {
          "string" == typeof t && (t = [[null, t, ""]]);
          var i = {};
          if (n) for (var o = 0; o < this.length; o++) {
            var s = this[o][0];
            null != s && (i[s] = !0);
          }

          for (var a = 0; a < t.length; a++) {
            var u = [].concat(t[a]);
            n && i[u[0]] || (r && (u[2] ? u[2] = "".concat(r, " and ").concat(u[2]) : u[2] = r), e.push(u));
          }
        }, e;
      };
    }, function (t, e, r) {
      "use strict";

      Object.defineProperty(e, "__esModule", {
        value: !0
      });
      var n = r(71);
      e.default = {
        open: function open(t, e) {
          n.generate(t, {
            small: !0
          });
        },
        close: function close() {}
      };
    }, function (t, e, r) {
      var n = r(72),
          i = r(27),
          o = "[47m  [0m",
          s = function s(t) {
        return t ? "[40m  [0m" : o;
      },
          a = function a(t) {
        return {
          times: function times(e) {
            return new Array(e).join(t);
          }
        };
      };

      t.exports = {
        error: i.L,
        generate: function generate(t, e, r) {
          "function" == typeof e && (r = e, e = {});
          var i = new n(-1, this.error);
          i.addData(t), i.make();
          var u = "";

          if (e && e.small) {
            var f = i.getModuleCount(),
                c = i.modules.slice(),
                h = f % 2 == 1;
            h && c.push(function (t, e) {
              for (var r = new Array(t), n = 0; n < t; n++) {
                r[n] = !1;
              }

              return r;
            }(f));
            var l = {
              WHITE_ALL: "█",
              WHITE_BLACK: "▀",
              BLACK_WHITE: "▄",
              BLACK_ALL: " "
            },
                d = a(l.BLACK_WHITE).times(f + 3),
                p = a(l.WHITE_BLACK).times(f + 3);
            u += d + "\n";

            for (var g = 0; g < f; g += 2) {
              u += l.WHITE_ALL;

              for (var m = 0; m < f; m++) {
                !1 === c[g][m] && !1 === c[g + 1][m] ? u += l.WHITE_ALL : !1 === c[g][m] && !0 === c[g + 1][m] ? u += l.WHITE_BLACK : !0 === c[g][m] && !1 === c[g + 1][m] ? u += l.BLACK_WHITE : u += l.BLACK_ALL;
              }

              u += l.WHITE_ALL + "\n";
            }

            h || (u += p);
          } else {
            var b = a(o).times(i.getModuleCount() + 3);
            u += b + "\n", i.modules.forEach(function (t) {
              u += o, u += t.map(s).join(""), u += o + "\n";
            }), u += b;
          }

          r ? r(u) : console.log(u);
        },
        setErrorLevel: function setErrorLevel(t) {
          this.error = i[t] || this.error;
        }
      };
    }, function (t, e, r) {
      var n = r(73),
          i = r(74),
          o = r(25),
          s = r(76),
          a = r(77);

      function u(t, e) {
        this.typeNumber = t, this.errorCorrectLevel = e, this.modules = null, this.moduleCount = 0, this.dataCache = null, this.dataList = [];
      }

      u.prototype = {
        addData: function addData(t) {
          var e = new n(t);
          this.dataList.push(e), this.dataCache = null;
        },
        isDark: function isDark(t, e) {
          if (t < 0 || this.moduleCount <= t || e < 0 || this.moduleCount <= e) throw new Error(t + "," + e);
          return this.modules[t][e];
        },
        getModuleCount: function getModuleCount() {
          return this.moduleCount;
        },
        make: function make() {
          if (this.typeNumber < 1) {
            var t = 1;

            for (t = 1; t < 40; t++) {
              for (var e = s.getRSBlocks(t, this.errorCorrectLevel), r = new a(), n = 0, o = 0; o < e.length; o++) {
                n += e[o].dataCount;
              }

              for (var u = 0; u < this.dataList.length; u++) {
                var f = this.dataList[u];
                r.put(f.mode, 4), r.put(f.getLength(), i.getLengthInBits(f.mode, t)), f.write(r);
              }

              if (r.getLengthInBits() <= 8 * n) break;
            }

            this.typeNumber = t;
          }

          this.makeImpl(!1, this.getBestMaskPattern());
        },
        makeImpl: function makeImpl(t, e) {
          this.moduleCount = 4 * this.typeNumber + 17, this.modules = new Array(this.moduleCount);

          for (var r = 0; r < this.moduleCount; r++) {
            this.modules[r] = new Array(this.moduleCount);

            for (var n = 0; n < this.moduleCount; n++) {
              this.modules[r][n] = null;
            }
          }

          this.setupPositionProbePattern(0, 0), this.setupPositionProbePattern(this.moduleCount - 7, 0), this.setupPositionProbePattern(0, this.moduleCount - 7), this.setupPositionAdjustPattern(), this.setupTimingPattern(), this.setupTypeInfo(t, e), this.typeNumber >= 7 && this.setupTypeNumber(t), null === this.dataCache && (this.dataCache = u.createData(this.typeNumber, this.errorCorrectLevel, this.dataList)), this.mapData(this.dataCache, e);
        },
        setupPositionProbePattern: function setupPositionProbePattern(t, e) {
          for (var r = -1; r <= 7; r++) {
            if (!(t + r <= -1 || this.moduleCount <= t + r)) for (var n = -1; n <= 7; n++) {
              e + n <= -1 || this.moduleCount <= e + n || (this.modules[t + r][e + n] = 0 <= r && r <= 6 && (0 === n || 6 === n) || 0 <= n && n <= 6 && (0 === r || 6 === r) || 2 <= r && r <= 4 && 2 <= n && n <= 4);
            }
          }
        },
        getBestMaskPattern: function getBestMaskPattern() {
          for (var t = 0, e = 0, r = 0; r < 8; r++) {
            this.makeImpl(!0, r);
            var n = i.getLostPoint(this);
            (0 === r || t > n) && (t = n, e = r);
          }

          return e;
        },
        createMovieClip: function createMovieClip(t, e, r) {
          var n = t.createEmptyMovieClip(e, r);
          this.make();

          for (var i = 0; i < this.modules.length; i++) {
            for (var o = 1 * i, s = 0; s < this.modules[i].length; s++) {
              var a = 1 * s;
              this.modules[i][s] && (n.beginFill(0, 100), n.moveTo(a, o), n.lineTo(a + 1, o), n.lineTo(a + 1, o + 1), n.lineTo(a, o + 1), n.endFill());
            }
          }

          return n;
        },
        setupTimingPattern: function setupTimingPattern() {
          for (var t = 8; t < this.moduleCount - 8; t++) {
            null === this.modules[t][6] && (this.modules[t][6] = t % 2 == 0);
          }

          for (var e = 8; e < this.moduleCount - 8; e++) {
            null === this.modules[6][e] && (this.modules[6][e] = e % 2 == 0);
          }
        },
        setupPositionAdjustPattern: function setupPositionAdjustPattern() {
          for (var t = i.getPatternPosition(this.typeNumber), e = 0; e < t.length; e++) {
            for (var r = 0; r < t.length; r++) {
              var n = t[e],
                  o = t[r];
              if (null === this.modules[n][o]) for (var s = -2; s <= 2; s++) {
                for (var a = -2; a <= 2; a++) {
                  2 === Math.abs(s) || 2 === Math.abs(a) || 0 === s && 0 === a ? this.modules[n + s][o + a] = !0 : this.modules[n + s][o + a] = !1;
                }
              }
            }
          }
        },
        setupTypeNumber: function setupTypeNumber(t) {
          for (var e, r = i.getBCHTypeNumber(this.typeNumber), n = 0; n < 18; n++) {
            e = !t && 1 == (r >> n & 1), this.modules[Math.floor(n / 3)][n % 3 + this.moduleCount - 8 - 3] = e;
          }

          for (var o = 0; o < 18; o++) {
            e = !t && 1 == (r >> o & 1), this.modules[o % 3 + this.moduleCount - 8 - 3][Math.floor(o / 3)] = e;
          }
        },
        setupTypeInfo: function setupTypeInfo(t, e) {
          for (var r, n = this.errorCorrectLevel << 3 | e, o = i.getBCHTypeInfo(n), s = 0; s < 15; s++) {
            r = !t && 1 == (o >> s & 1), s < 6 ? this.modules[s][8] = r : s < 8 ? this.modules[s + 1][8] = r : this.modules[this.moduleCount - 15 + s][8] = r;
          }

          for (var a = 0; a < 15; a++) {
            r = !t && 1 == (o >> a & 1), a < 8 ? this.modules[8][this.moduleCount - a - 1] = r : a < 9 ? this.modules[8][15 - a - 1 + 1] = r : this.modules[8][15 - a - 1] = r;
          }

          this.modules[this.moduleCount - 8][8] = !t;
        },
        mapData: function mapData(t, e) {
          for (var r = -1, n = this.moduleCount - 1, o = 7, s = 0, a = this.moduleCount - 1; a > 0; a -= 2) {
            for (6 === a && a--;;) {
              for (var u = 0; u < 2; u++) {
                if (null === this.modules[n][a - u]) {
                  var f = !1;
                  s < t.length && (f = 1 == (t[s] >>> o & 1)), i.getMask(e, n, a - u) && (f = !f), this.modules[n][a - u] = f, -1 == --o && (s++, o = 7);
                }
              }

              if ((n += r) < 0 || this.moduleCount <= n) {
                n -= r, r = -r;
                break;
              }
            }
          }
        }
      }, u.PAD0 = 236, u.PAD1 = 17, u.createData = function (t, e, r) {
        for (var n = s.getRSBlocks(t, e), o = new a(), f = 0; f < r.length; f++) {
          var c = r[f];
          o.put(c.mode, 4), o.put(c.getLength(), i.getLengthInBits(c.mode, t)), c.write(o);
        }

        for (var h = 0, l = 0; l < n.length; l++) {
          h += n[l].dataCount;
        }

        if (o.getLengthInBits() > 8 * h) throw new Error("code length overflow. (" + o.getLengthInBits() + ">" + 8 * h + ")");

        for (o.getLengthInBits() + 4 <= 8 * h && o.put(0, 4); o.getLengthInBits() % 8 != 0;) {
          o.putBit(!1);
        }

        for (; !(o.getLengthInBits() >= 8 * h || (o.put(u.PAD0, 8), o.getLengthInBits() >= 8 * h));) {
          o.put(u.PAD1, 8);
        }

        return u.createBytes(o, n);
      }, u.createBytes = function (t, e) {
        for (var r = 0, n = 0, s = 0, a = new Array(e.length), u = new Array(e.length), f = 0; f < e.length; f++) {
          var c = e[f].dataCount,
              h = e[f].totalCount - c;
          n = Math.max(n, c), s = Math.max(s, h), a[f] = new Array(c);

          for (var l = 0; l < a[f].length; l++) {
            a[f][l] = 255 & t.buffer[l + r];
          }

          r += c;
          var d = i.getErrorCorrectPolynomial(h),
              p = new o(a[f], d.getLength() - 1).mod(d);
          u[f] = new Array(d.getLength() - 1);

          for (var g = 0; g < u[f].length; g++) {
            var m = g + p.getLength() - u[f].length;
            u[f][g] = m >= 0 ? p.get(m) : 0;
          }
        }

        for (var b = 0, v = 0; v < e.length; v++) {
          b += e[v].totalCount;
        }

        for (var y = new Array(b), _ = 0, w = 0; w < n; w++) {
          for (var E = 0; E < e.length; E++) {
            w < a[E].length && (y[_++] = a[E][w]);
          }
        }

        for (var M = 0; M < s; M++) {
          for (var S = 0; S < e.length; S++) {
            M < u[S].length && (y[_++] = u[S][M]);
          }
        }

        return y;
      }, t.exports = u;
    }, function (t, e, r) {
      var n = r(24);

      function i(t) {
        this.mode = n.MODE_8BIT_BYTE, this.data = t;
      }

      i.prototype = {
        getLength: function getLength() {
          return this.data.length;
        },
        write: function write(t) {
          for (var e = 0; e < this.data.length; e++) {
            t.put(this.data.charCodeAt(e), 8);
          }
        }
      }, t.exports = i;
    }, function (t, e, r) {
      var n = r(24),
          i = r(25),
          o = r(26),
          s = r(75),
          a = {
        PATTERN_POSITION_TABLE: [[], [6, 18], [6, 22], [6, 26], [6, 30], [6, 34], [6, 22, 38], [6, 24, 42], [6, 26, 46], [6, 28, 50], [6, 30, 54], [6, 32, 58], [6, 34, 62], [6, 26, 46, 66], [6, 26, 48, 70], [6, 26, 50, 74], [6, 30, 54, 78], [6, 30, 56, 82], [6, 30, 58, 86], [6, 34, 62, 90], [6, 28, 50, 72, 94], [6, 26, 50, 74, 98], [6, 30, 54, 78, 102], [6, 28, 54, 80, 106], [6, 32, 58, 84, 110], [6, 30, 58, 86, 114], [6, 34, 62, 90, 118], [6, 26, 50, 74, 98, 122], [6, 30, 54, 78, 102, 126], [6, 26, 52, 78, 104, 130], [6, 30, 56, 82, 108, 134], [6, 34, 60, 86, 112, 138], [6, 30, 58, 86, 114, 142], [6, 34, 62, 90, 118, 146], [6, 30, 54, 78, 102, 126, 150], [6, 24, 50, 76, 102, 128, 154], [6, 28, 54, 80, 106, 132, 158], [6, 32, 58, 84, 110, 136, 162], [6, 26, 54, 82, 110, 138, 166], [6, 30, 58, 86, 114, 142, 170]],
        G15: 1335,
        G18: 7973,
        G15_MASK: 21522,
        getBCHTypeInfo: function getBCHTypeInfo(t) {
          for (var e = t << 10; a.getBCHDigit(e) - a.getBCHDigit(a.G15) >= 0;) {
            e ^= a.G15 << a.getBCHDigit(e) - a.getBCHDigit(a.G15);
          }

          return (t << 10 | e) ^ a.G15_MASK;
        },
        getBCHTypeNumber: function getBCHTypeNumber(t) {
          for (var e = t << 12; a.getBCHDigit(e) - a.getBCHDigit(a.G18) >= 0;) {
            e ^= a.G18 << a.getBCHDigit(e) - a.getBCHDigit(a.G18);
          }

          return t << 12 | e;
        },
        getBCHDigit: function getBCHDigit(t) {
          for (var e = 0; 0 !== t;) {
            e++, t >>>= 1;
          }

          return e;
        },
        getPatternPosition: function getPatternPosition(t) {
          return a.PATTERN_POSITION_TABLE[t - 1];
        },
        getMask: function getMask(t, e, r) {
          switch (t) {
            case s.PATTERN000:
              return (e + r) % 2 == 0;

            case s.PATTERN001:
              return e % 2 == 0;

            case s.PATTERN010:
              return r % 3 == 0;

            case s.PATTERN011:
              return (e + r) % 3 == 0;

            case s.PATTERN100:
              return (Math.floor(e / 2) + Math.floor(r / 3)) % 2 == 0;

            case s.PATTERN101:
              return e * r % 2 + e * r % 3 == 0;

            case s.PATTERN110:
              return (e * r % 2 + e * r % 3) % 2 == 0;

            case s.PATTERN111:
              return (e * r % 3 + (e + r) % 2) % 2 == 0;

            default:
              throw new Error("bad maskPattern:" + t);
          }
        },
        getErrorCorrectPolynomial: function getErrorCorrectPolynomial(t) {
          for (var e = new i([1], 0), r = 0; r < t; r++) {
            e = e.multiply(new i([1, o.gexp(r)], 0));
          }

          return e;
        },
        getLengthInBits: function getLengthInBits(t, e) {
          if (1 <= e && e < 10) switch (t) {
            case n.MODE_NUMBER:
              return 10;

            case n.MODE_ALPHA_NUM:
              return 9;

            case n.MODE_8BIT_BYTE:
            case n.MODE_KANJI:
              return 8;

            default:
              throw new Error("mode:" + t);
          } else if (e < 27) switch (t) {
            case n.MODE_NUMBER:
              return 12;

            case n.MODE_ALPHA_NUM:
              return 11;

            case n.MODE_8BIT_BYTE:
              return 16;

            case n.MODE_KANJI:
              return 10;

            default:
              throw new Error("mode:" + t);
          } else {
            if (!(e < 41)) throw new Error("type:" + e);

            switch (t) {
              case n.MODE_NUMBER:
                return 14;

              case n.MODE_ALPHA_NUM:
                return 13;

              case n.MODE_8BIT_BYTE:
                return 16;

              case n.MODE_KANJI:
                return 12;

              default:
                throw new Error("mode:" + t);
            }
          }
        },
        getLostPoint: function getLostPoint(t) {
          var e = t.getModuleCount(),
              r = 0,
              n = 0,
              i = 0;

          for (n = 0; n < e; n++) {
            for (i = 0; i < e; i++) {
              for (var o = 0, s = t.isDark(n, i), a = -1; a <= 1; a++) {
                if (!(n + a < 0 || e <= n + a)) for (var u = -1; u <= 1; u++) {
                  i + u < 0 || e <= i + u || 0 === a && 0 === u || s === t.isDark(n + a, i + u) && o++;
                }
              }

              o > 5 && (r += 3 + o - 5);
            }
          }

          for (n = 0; n < e - 1; n++) {
            for (i = 0; i < e - 1; i++) {
              var f = 0;
              t.isDark(n, i) && f++, t.isDark(n + 1, i) && f++, t.isDark(n, i + 1) && f++, t.isDark(n + 1, i + 1) && f++, 0 !== f && 4 !== f || (r += 3);
            }
          }

          for (n = 0; n < e; n++) {
            for (i = 0; i < e - 6; i++) {
              t.isDark(n, i) && !t.isDark(n, i + 1) && t.isDark(n, i + 2) && t.isDark(n, i + 3) && t.isDark(n, i + 4) && !t.isDark(n, i + 5) && t.isDark(n, i + 6) && (r += 40);
            }
          }

          for (i = 0; i < e; i++) {
            for (n = 0; n < e - 6; n++) {
              t.isDark(n, i) && !t.isDark(n + 1, i) && t.isDark(n + 2, i) && t.isDark(n + 3, i) && t.isDark(n + 4, i) && !t.isDark(n + 5, i) && t.isDark(n + 6, i) && (r += 40);
            }
          }

          var c = 0;

          for (i = 0; i < e; i++) {
            for (n = 0; n < e; n++) {
              t.isDark(n, i) && c++;
            }
          }

          return r + Math.abs(100 * c / e / e - 50) / 5 * 10;
        }
      };
      t.exports = a;
    }, function (t, e) {
      t.exports = {
        PATTERN000: 0,
        PATTERN001: 1,
        PATTERN010: 2,
        PATTERN011: 3,
        PATTERN100: 4,
        PATTERN101: 5,
        PATTERN110: 6,
        PATTERN111: 7
      };
    }, function (t, e, r) {
      var n = r(27);

      function i(t, e) {
        this.totalCount = t, this.dataCount = e;
      }

      i.RS_BLOCK_TABLE = [[1, 26, 19], [1, 26, 16], [1, 26, 13], [1, 26, 9], [1, 44, 34], [1, 44, 28], [1, 44, 22], [1, 44, 16], [1, 70, 55], [1, 70, 44], [2, 35, 17], [2, 35, 13], [1, 100, 80], [2, 50, 32], [2, 50, 24], [4, 25, 9], [1, 134, 108], [2, 67, 43], [2, 33, 15, 2, 34, 16], [2, 33, 11, 2, 34, 12], [2, 86, 68], [4, 43, 27], [4, 43, 19], [4, 43, 15], [2, 98, 78], [4, 49, 31], [2, 32, 14, 4, 33, 15], [4, 39, 13, 1, 40, 14], [2, 121, 97], [2, 60, 38, 2, 61, 39], [4, 40, 18, 2, 41, 19], [4, 40, 14, 2, 41, 15], [2, 146, 116], [3, 58, 36, 2, 59, 37], [4, 36, 16, 4, 37, 17], [4, 36, 12, 4, 37, 13], [2, 86, 68, 2, 87, 69], [4, 69, 43, 1, 70, 44], [6, 43, 19, 2, 44, 20], [6, 43, 15, 2, 44, 16], [4, 101, 81], [1, 80, 50, 4, 81, 51], [4, 50, 22, 4, 51, 23], [3, 36, 12, 8, 37, 13], [2, 116, 92, 2, 117, 93], [6, 58, 36, 2, 59, 37], [4, 46, 20, 6, 47, 21], [7, 42, 14, 4, 43, 15], [4, 133, 107], [8, 59, 37, 1, 60, 38], [8, 44, 20, 4, 45, 21], [12, 33, 11, 4, 34, 12], [3, 145, 115, 1, 146, 116], [4, 64, 40, 5, 65, 41], [11, 36, 16, 5, 37, 17], [11, 36, 12, 5, 37, 13], [5, 109, 87, 1, 110, 88], [5, 65, 41, 5, 66, 42], [5, 54, 24, 7, 55, 25], [11, 36, 12], [5, 122, 98, 1, 123, 99], [7, 73, 45, 3, 74, 46], [15, 43, 19, 2, 44, 20], [3, 45, 15, 13, 46, 16], [1, 135, 107, 5, 136, 108], [10, 74, 46, 1, 75, 47], [1, 50, 22, 15, 51, 23], [2, 42, 14, 17, 43, 15], [5, 150, 120, 1, 151, 121], [9, 69, 43, 4, 70, 44], [17, 50, 22, 1, 51, 23], [2, 42, 14, 19, 43, 15], [3, 141, 113, 4, 142, 114], [3, 70, 44, 11, 71, 45], [17, 47, 21, 4, 48, 22], [9, 39, 13, 16, 40, 14], [3, 135, 107, 5, 136, 108], [3, 67, 41, 13, 68, 42], [15, 54, 24, 5, 55, 25], [15, 43, 15, 10, 44, 16], [4, 144, 116, 4, 145, 117], [17, 68, 42], [17, 50, 22, 6, 51, 23], [19, 46, 16, 6, 47, 17], [2, 139, 111, 7, 140, 112], [17, 74, 46], [7, 54, 24, 16, 55, 25], [34, 37, 13], [4, 151, 121, 5, 152, 122], [4, 75, 47, 14, 76, 48], [11, 54, 24, 14, 55, 25], [16, 45, 15, 14, 46, 16], [6, 147, 117, 4, 148, 118], [6, 73, 45, 14, 74, 46], [11, 54, 24, 16, 55, 25], [30, 46, 16, 2, 47, 17], [8, 132, 106, 4, 133, 107], [8, 75, 47, 13, 76, 48], [7, 54, 24, 22, 55, 25], [22, 45, 15, 13, 46, 16], [10, 142, 114, 2, 143, 115], [19, 74, 46, 4, 75, 47], [28, 50, 22, 6, 51, 23], [33, 46, 16, 4, 47, 17], [8, 152, 122, 4, 153, 123], [22, 73, 45, 3, 74, 46], [8, 53, 23, 26, 54, 24], [12, 45, 15, 28, 46, 16], [3, 147, 117, 10, 148, 118], [3, 73, 45, 23, 74, 46], [4, 54, 24, 31, 55, 25], [11, 45, 15, 31, 46, 16], [7, 146, 116, 7, 147, 117], [21, 73, 45, 7, 74, 46], [1, 53, 23, 37, 54, 24], [19, 45, 15, 26, 46, 16], [5, 145, 115, 10, 146, 116], [19, 75, 47, 10, 76, 48], [15, 54, 24, 25, 55, 25], [23, 45, 15, 25, 46, 16], [13, 145, 115, 3, 146, 116], [2, 74, 46, 29, 75, 47], [42, 54, 24, 1, 55, 25], [23, 45, 15, 28, 46, 16], [17, 145, 115], [10, 74, 46, 23, 75, 47], [10, 54, 24, 35, 55, 25], [19, 45, 15, 35, 46, 16], [17, 145, 115, 1, 146, 116], [14, 74, 46, 21, 75, 47], [29, 54, 24, 19, 55, 25], [11, 45, 15, 46, 46, 16], [13, 145, 115, 6, 146, 116], [14, 74, 46, 23, 75, 47], [44, 54, 24, 7, 55, 25], [59, 46, 16, 1, 47, 17], [12, 151, 121, 7, 152, 122], [12, 75, 47, 26, 76, 48], [39, 54, 24, 14, 55, 25], [22, 45, 15, 41, 46, 16], [6, 151, 121, 14, 152, 122], [6, 75, 47, 34, 76, 48], [46, 54, 24, 10, 55, 25], [2, 45, 15, 64, 46, 16], [17, 152, 122, 4, 153, 123], [29, 74, 46, 14, 75, 47], [49, 54, 24, 10, 55, 25], [24, 45, 15, 46, 46, 16], [4, 152, 122, 18, 153, 123], [13, 74, 46, 32, 75, 47], [48, 54, 24, 14, 55, 25], [42, 45, 15, 32, 46, 16], [20, 147, 117, 4, 148, 118], [40, 75, 47, 7, 76, 48], [43, 54, 24, 22, 55, 25], [10, 45, 15, 67, 46, 16], [19, 148, 118, 6, 149, 119], [18, 75, 47, 31, 76, 48], [34, 54, 24, 34, 55, 25], [20, 45, 15, 61, 46, 16]], i.getRSBlocks = function (t, e) {
        var r = i.getRsBlockTable(t, e);
        if (void 0 === r) throw new Error("bad rs block @ typeNumber:" + t + "/errorCorrectLevel:" + e);

        for (var n = r.length / 3, o = [], s = 0; s < n; s++) {
          for (var a = r[3 * s + 0], u = r[3 * s + 1], f = r[3 * s + 2], c = 0; c < a; c++) {
            o.push(new i(u, f));
          }
        }

        return o;
      }, i.getRsBlockTable = function (t, e) {
        switch (e) {
          case n.L:
            return i.RS_BLOCK_TABLE[4 * (t - 1) + 0];

          case n.M:
            return i.RS_BLOCK_TABLE[4 * (t - 1) + 1];

          case n.Q:
            return i.RS_BLOCK_TABLE[4 * (t - 1) + 2];

          case n.H:
            return i.RS_BLOCK_TABLE[4 * (t - 1) + 3];

          default:
            return;
        }
      }, t.exports = i;
    }, function (t, e) {
      function r() {
        this.buffer = [], this.length = 0;
      }

      r.prototype = {
        get: function get(t) {
          var e = Math.floor(t / 8);
          return 1 == (this.buffer[e] >>> 7 - t % 8 & 1);
        },
        put: function put(t, e) {
          for (var r = 0; r < e; r++) {
            this.putBit(1 == (t >>> e - r - 1 & 1));
          }
        },
        getLengthInBits: function getLengthInBits() {
          return this.length;
        },
        putBit: function putBit(t) {
          var e = Math.floor(this.length / 8);
          this.buffer.length <= e && this.buffer.push(0), t && (this.buffer[e] |= 128 >>> this.length % 8), this.length++;
        }
      }, t.exports = r;
    }]);
  }, function (t, e) {
    var r = {}.toString;

    t.exports = Array.isArray || function (t) {
      return "[object Array]" == r.call(t);
    };
  }, function (t, e, r) {
    "use strict";

    (function (e, n) {
      var i = r(24);
      t.exports = y;
      var o,
          s = r(54);
      y.ReadableState = v;
      r(8).EventEmitter;

      var a = function a(t, e) {
        return t.listeners(e).length;
      },
          u = r(56),
          f = r(1).Buffer,
          c = e.Uint8Array || function () {};

      var h = r(18);
      h.inherits = r(0);
      var l = r(106),
          d = void 0;
      d = l && l.debuglog ? l.debuglog("stream") : function () {};
      var p,
          g = r(107),
          m = r(57);
      h.inherits(y, u);
      var b = ["error", "close", "destroy", "pause", "resume"];

      function v(t, e) {
        t = t || {};
        var n = e instanceof (o = o || r(10));
        this.objectMode = !!t.objectMode, n && (this.objectMode = this.objectMode || !!t.readableObjectMode);
        var i = t.highWaterMark,
            s = t.readableHighWaterMark,
            a = this.objectMode ? 16 : 16384;
        this.highWaterMark = i || 0 === i ? i : n && (s || 0 === s) ? s : a, this.highWaterMark = Math.floor(this.highWaterMark), this.buffer = new g(), this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.destroyed = !1, this.defaultEncoding = t.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, t.encoding && (p || (p = r(34).StringDecoder), this.decoder = new p(t.encoding), this.encoding = t.encoding);
      }

      function y(t) {
        if (o = o || r(10), !(this instanceof y)) return new y(t);
        this._readableState = new v(t, this), this.readable = !0, t && ("function" == typeof t.read && (this._read = t.read), "function" == typeof t.destroy && (this._destroy = t.destroy)), u.call(this);
      }

      function _(t, e, r, n, i) {
        var o,
            s = t._readableState;
        null === e ? (s.reading = !1, function (t, e) {
          if (e.ended) return;

          if (e.decoder) {
            var r = e.decoder.end();
            r && r.length && (e.buffer.push(r), e.length += e.objectMode ? 1 : r.length);
          }

          e.ended = !0, M(t);
        }(t, s)) : (i || (o = function (t, e) {
          var r;
          n = e, f.isBuffer(n) || n instanceof c || "string" == typeof e || void 0 === e || t.objectMode || (r = new TypeError("Invalid non-string/buffer chunk"));
          var n;
          return r;
        }(s, e)), o ? t.emit("error", o) : s.objectMode || e && e.length > 0 ? ("string" == typeof e || s.objectMode || Object.getPrototypeOf(e) === f.prototype || (e = function (t) {
          return f.from(t);
        }(e)), n ? s.endEmitted ? t.emit("error", new Error("stream.unshift() after end event")) : w(t, s, e, !0) : s.ended ? t.emit("error", new Error("stream.push() after EOF")) : (s.reading = !1, s.decoder && !r ? (e = s.decoder.write(e), s.objectMode || 0 !== e.length ? w(t, s, e, !1) : A(t, s)) : w(t, s, e, !1))) : n || (s.reading = !1));
        return function (t) {
          return !t.ended && (t.needReadable || t.length < t.highWaterMark || 0 === t.length);
        }(s);
      }

      function w(t, e, r, n) {
        e.flowing && 0 === e.length && !e.sync ? (t.emit("data", r), t.read(0)) : (e.length += e.objectMode ? 1 : r.length, n ? e.buffer.unshift(r) : e.buffer.push(r), e.needReadable && M(t)), A(t, e);
      }

      Object.defineProperty(y.prototype, "destroyed", {
        get: function get() {
          return void 0 !== this._readableState && this._readableState.destroyed;
        },
        set: function set(t) {
          this._readableState && (this._readableState.destroyed = t);
        }
      }), y.prototype.destroy = m.destroy, y.prototype._undestroy = m.undestroy, y.prototype._destroy = function (t, e) {
        this.push(null), e(t);
      }, y.prototype.push = function (t, e) {
        var r,
            n = this._readableState;
        return n.objectMode ? r = !0 : "string" == typeof t && ((e = e || n.defaultEncoding) !== n.encoding && (t = f.from(t, e), e = ""), r = !0), _(this, t, e, !1, r);
      }, y.prototype.unshift = function (t) {
        return _(this, t, null, !0, !1);
      }, y.prototype.isPaused = function () {
        return !1 === this._readableState.flowing;
      }, y.prototype.setEncoding = function (t) {
        return p || (p = r(34).StringDecoder), this._readableState.decoder = new p(t), this._readableState.encoding = t, this;
      };

      function E(t, e) {
        return t <= 0 || 0 === e.length && e.ended ? 0 : e.objectMode ? 1 : t != t ? e.flowing && e.length ? e.buffer.head.data.length : e.length : (t > e.highWaterMark && (e.highWaterMark = function (t) {
          return t >= 8388608 ? t = 8388608 : (t--, t |= t >>> 1, t |= t >>> 2, t |= t >>> 4, t |= t >>> 8, t |= t >>> 16, t++), t;
        }(t)), t <= e.length ? t : e.ended ? e.length : (e.needReadable = !0, 0));
      }

      function M(t) {
        var e = t._readableState;
        e.needReadable = !1, e.emittedReadable || (d("emitReadable", e.flowing), e.emittedReadable = !0, e.sync ? i.nextTick(S, t) : S(t));
      }

      function S(t) {
        d("emit readable"), t.emit("readable"), k(t);
      }

      function A(t, e) {
        e.readingMore || (e.readingMore = !0, i.nextTick(x, t, e));
      }

      function x(t, e) {
        for (var r = e.length; !e.reading && !e.flowing && !e.ended && e.length < e.highWaterMark && (d("maybeReadMore read 0"), t.read(0), r !== e.length);) {
          r = e.length;
        }

        e.readingMore = !1;
      }

      function R(t) {
        d("readable nexttick read 0"), t.read(0);
      }

      function T(t, e) {
        e.reading || (d("resume read 0"), t.read(0)), e.resumeScheduled = !1, e.awaitDrain = 0, t.emit("resume"), k(t), e.flowing && !e.reading && t.read(0);
      }

      function k(t) {
        var e = t._readableState;

        for (d("flow", e.flowing); e.flowing && null !== t.read();) {
          ;
        }
      }

      function I(t, e) {
        return 0 === e.length ? null : (e.objectMode ? r = e.buffer.shift() : !t || t >= e.length ? (r = e.decoder ? e.buffer.join("") : 1 === e.buffer.length ? e.buffer.head.data : e.buffer.concat(e.length), e.buffer.clear()) : r = function (t, e, r) {
          var n;
          t < e.head.data.length ? (n = e.head.data.slice(0, t), e.head.data = e.head.data.slice(t)) : n = t === e.head.data.length ? e.shift() : r ? function (t, e) {
            var r = e.head,
                n = 1,
                i = r.data;
            t -= i.length;

            for (; r = r.next;) {
              var o = r.data,
                  s = t > o.length ? o.length : t;

              if (s === o.length ? i += o : i += o.slice(0, t), 0 === (t -= s)) {
                s === o.length ? (++n, r.next ? e.head = r.next : e.head = e.tail = null) : (e.head = r, r.data = o.slice(s));
                break;
              }

              ++n;
            }

            return e.length -= n, i;
          }(t, e) : function (t, e) {
            var r = f.allocUnsafe(t),
                n = e.head,
                i = 1;
            n.data.copy(r), t -= n.data.length;

            for (; n = n.next;) {
              var o = n.data,
                  s = t > o.length ? o.length : t;

              if (o.copy(r, r.length - t, 0, s), 0 === (t -= s)) {
                s === o.length ? (++i, n.next ? e.head = n.next : e.head = e.tail = null) : (e.head = n, n.data = o.slice(s));
                break;
              }

              ++i;
            }

            return e.length -= i, r;
          }(t, e);
          return n;
        }(t, e.buffer, e.decoder), r);
        var r;
      }

      function B(t) {
        var e = t._readableState;
        if (e.length > 0) throw new Error('"endReadable()" called on non-empty stream');
        e.endEmitted || (e.ended = !0, i.nextTick(O, e, t));
      }

      function O(t, e) {
        t.endEmitted || 0 !== t.length || (t.endEmitted = !0, e.readable = !1, e.emit("end"));
      }

      function P(t, e) {
        for (var r = 0, n = t.length; r < n; r++) {
          if (t[r] === e) return r;
        }

        return -1;
      }

      y.prototype.read = function (t) {
        d("read", t), t = parseInt(t, 10);
        var e = this._readableState,
            r = t;
        if (0 !== t && (e.emittedReadable = !1), 0 === t && e.needReadable && (e.length >= e.highWaterMark || e.ended)) return d("read: emitReadable", e.length, e.ended), 0 === e.length && e.ended ? B(this) : M(this), null;
        if (0 === (t = E(t, e)) && e.ended) return 0 === e.length && B(this), null;
        var n,
            i = e.needReadable;
        return d("need readable", i), (0 === e.length || e.length - t < e.highWaterMark) && d("length less than watermark", i = !0), e.ended || e.reading ? d("reading or ended", i = !1) : i && (d("do read"), e.reading = !0, e.sync = !0, 0 === e.length && (e.needReadable = !0), this._read(e.highWaterMark), e.sync = !1, e.reading || (t = E(r, e))), null === (n = t > 0 ? I(t, e) : null) ? (e.needReadable = !0, t = 0) : e.length -= t, 0 === e.length && (e.ended || (e.needReadable = !0), r !== t && e.ended && B(this)), null !== n && this.emit("data", n), n;
      }, y.prototype._read = function (t) {
        this.emit("error", new Error("_read() is not implemented"));
      }, y.prototype.pipe = function (t, e) {
        var r = this,
            o = this._readableState;

        switch (o.pipesCount) {
          case 0:
            o.pipes = t;
            break;

          case 1:
            o.pipes = [o.pipes, t];
            break;

          default:
            o.pipes.push(t);
        }

        o.pipesCount += 1, d("pipe count=%d opts=%j", o.pipesCount, e);
        var u = (!e || !1 !== e.end) && t !== n.stdout && t !== n.stderr ? c : y;

        function f(e, n) {
          d("onunpipe"), e === r && n && !1 === n.hasUnpiped && (n.hasUnpiped = !0, d("cleanup"), t.removeListener("close", b), t.removeListener("finish", v), t.removeListener("drain", h), t.removeListener("error", m), t.removeListener("unpipe", f), r.removeListener("end", c), r.removeListener("end", y), r.removeListener("data", g), l = !0, !o.awaitDrain || t._writableState && !t._writableState.needDrain || h());
        }

        function c() {
          d("onend"), t.end();
        }

        o.endEmitted ? i.nextTick(u) : r.once("end", u), t.on("unpipe", f);

        var h = function (t) {
          return function () {
            var e = t._readableState;
            d("pipeOnDrain", e.awaitDrain), e.awaitDrain && e.awaitDrain--, 0 === e.awaitDrain && a(t, "data") && (e.flowing = !0, k(t));
          };
        }(r);

        t.on("drain", h);
        var l = !1;
        var p = !1;

        function g(e) {
          d("ondata"), p = !1, !1 !== t.write(e) || p || ((1 === o.pipesCount && o.pipes === t || o.pipesCount > 1 && -1 !== P(o.pipes, t)) && !l && (d("false write response, pause", r._readableState.awaitDrain), r._readableState.awaitDrain++, p = !0), r.pause());
        }

        function m(e) {
          d("onerror", e), y(), t.removeListener("error", m), 0 === a(t, "error") && t.emit("error", e);
        }

        function b() {
          t.removeListener("finish", v), y();
        }

        function v() {
          d("onfinish"), t.removeListener("close", b), y();
        }

        function y() {
          d("unpipe"), r.unpipe(t);
        }

        return r.on("data", g), function (t, e, r) {
          if ("function" == typeof t.prependListener) return t.prependListener(e, r);
          t._events && t._events[e] ? s(t._events[e]) ? t._events[e].unshift(r) : t._events[e] = [r, t._events[e]] : t.on(e, r);
        }(t, "error", m), t.once("close", b), t.once("finish", v), t.emit("pipe", r), o.flowing || (d("pipe resume"), r.resume()), t;
      }, y.prototype.unpipe = function (t) {
        var e = this._readableState,
            r = {
          hasUnpiped: !1
        };
        if (0 === e.pipesCount) return this;
        if (1 === e.pipesCount) return t && t !== e.pipes ? this : (t || (t = e.pipes), e.pipes = null, e.pipesCount = 0, e.flowing = !1, t && t.emit("unpipe", this, r), this);

        if (!t) {
          var n = e.pipes,
              i = e.pipesCount;
          e.pipes = null, e.pipesCount = 0, e.flowing = !1;

          for (var o = 0; o < i; o++) {
            n[o].emit("unpipe", this, r);
          }

          return this;
        }

        var s = P(e.pipes, t);
        return -1 === s ? this : (e.pipes.splice(s, 1), e.pipesCount -= 1, 1 === e.pipesCount && (e.pipes = e.pipes[0]), t.emit("unpipe", this, r), this);
      }, y.prototype.on = function (t, e) {
        var r = u.prototype.on.call(this, t, e);
        if ("data" === t) !1 !== this._readableState.flowing && this.resume();else if ("readable" === t) {
          var n = this._readableState;
          n.endEmitted || n.readableListening || (n.readableListening = n.needReadable = !0, n.emittedReadable = !1, n.reading ? n.length && M(this) : i.nextTick(R, this));
        }
        return r;
      }, y.prototype.addListener = y.prototype.on, y.prototype.resume = function () {
        var t = this._readableState;
        return t.flowing || (d("resume"), t.flowing = !0, function (t, e) {
          e.resumeScheduled || (e.resumeScheduled = !0, i.nextTick(T, t, e));
        }(this, t)), this;
      }, y.prototype.pause = function () {
        return d("call pause flowing=%j", this._readableState.flowing), !1 !== this._readableState.flowing && (d("pause"), this._readableState.flowing = !1, this.emit("pause")), this;
      }, y.prototype.wrap = function (t) {
        var e = this,
            r = this._readableState,
            n = !1;

        for (var i in t.on("end", function () {
          if (d("wrapped end"), r.decoder && !r.ended) {
            var t = r.decoder.end();
            t && t.length && e.push(t);
          }

          e.push(null);
        }), t.on("data", function (i) {
          (d("wrapped data"), r.decoder && (i = r.decoder.write(i)), r.objectMode && null == i) || (r.objectMode || i && i.length) && (e.push(i) || (n = !0, t.pause()));
        }), t) {
          void 0 === this[i] && "function" == typeof t[i] && (this[i] = function (e) {
            return function () {
              return t[e].apply(t, arguments);
            };
          }(i));
        }

        for (var o = 0; o < b.length; o++) {
          t.on(b[o], this.emit.bind(this, b[o]));
        }

        return this._read = function (e) {
          d("wrapped _read", e), n && (n = !1, t.resume());
        }, this;
      }, Object.defineProperty(y.prototype, "readableHighWaterMark", {
        enumerable: !1,
        get: function get() {
          return this._readableState.highWaterMark;
        }
      }), y._fromList = I;
    }).call(this, r(4), r(6));
  }, function (t, e, r) {
    t.exports = r(8).EventEmitter;
  }, function (t, e, r) {
    "use strict";

    var n = r(24);

    function i(t, e) {
      t.emit("error", e);
    }

    t.exports = {
      destroy: function destroy(t, e) {
        var r = this,
            o = this._readableState && this._readableState.destroyed,
            s = this._writableState && this._writableState.destroyed;
        return o || s ? (e ? e(t) : !t || this._writableState && this._writableState.errorEmitted || n.nextTick(i, this, t), this) : (this._readableState && (this._readableState.destroyed = !0), this._writableState && (this._writableState.destroyed = !0), this._destroy(t || null, function (t) {
          !e && t ? (n.nextTick(i, r, t), r._writableState && (r._writableState.errorEmitted = !0)) : e && e(t);
        }), this);
      },
      undestroy: function undestroy() {
        this._readableState && (this._readableState.destroyed = !1, this._readableState.reading = !1, this._readableState.ended = !1, this._readableState.endEmitted = !1), this._writableState && (this._writableState.destroyed = !1, this._writableState.ended = !1, this._writableState.ending = !1, this._writableState.finished = !1, this._writableState.errorEmitted = !1);
      }
    };
  }, function (t, e, r) {
    "use strict";

    t.exports = s;
    var n = r(10),
        i = r(18);

    function o(t, e) {
      var r = this._transformState;
      r.transforming = !1;
      var n = r.writecb;
      if (!n) return this.emit("error", new Error("write callback called multiple times"));
      r.writechunk = null, r.writecb = null, null != e && this.push(e), n(t);
      var i = this._readableState;
      i.reading = !1, (i.needReadable || i.length < i.highWaterMark) && this._read(i.highWaterMark);
    }

    function s(t) {
      if (!(this instanceof s)) return new s(t);
      n.call(this, t), this._transformState = {
        afterTransform: o.bind(this),
        needTransform: !1,
        transforming: !1,
        writecb: null,
        writechunk: null,
        writeencoding: null
      }, this._readableState.needReadable = !0, this._readableState.sync = !1, t && ("function" == typeof t.transform && (this._transform = t.transform), "function" == typeof t.flush && (this._flush = t.flush)), this.on("prefinish", a);
    }

    function a() {
      var t = this;
      "function" == typeof this._flush ? this._flush(function (e, r) {
        u(t, e, r);
      }) : u(this, null, null);
    }

    function u(t, e, r) {
      if (e) return t.emit("error", e);
      if (null != r && t.push(r), t._writableState.length) throw new Error("Calling transform done when ws.length != 0");
      if (t._transformState.transforming) throw new Error("Calling transform done when still transforming");
      return t.push(null);
    }

    i.inherits = r(0), i.inherits(s, n), s.prototype.push = function (t, e) {
      return this._transformState.needTransform = !1, n.prototype.push.call(this, t, e);
    }, s.prototype._transform = function (t, e, r) {
      throw new Error("_transform() is not implemented");
    }, s.prototype._write = function (t, e, r) {
      var n = this._transformState;

      if (n.writecb = r, n.writechunk = t, n.writeencoding = e, !n.transforming) {
        var i = this._readableState;
        (n.needTransform || i.needReadable || i.length < i.highWaterMark) && this._read(i.highWaterMark);
      }
    }, s.prototype._read = function (t) {
      var e = this._transformState;
      null !== e.writechunk && e.writecb && !e.transforming ? (e.transforming = !0, this._transform(e.writechunk, e.writeencoding, e.afterTransform)) : e.needTransform = !0;
    }, s.prototype._destroy = function (t, e) {
      var r = this;

      n.prototype._destroy.call(this, t, function (t) {
        e(t), r.emit("close");
      });
    };
  }, function (t) {
    t.exports = JSON.parse('{"COMPRESSED_TYPE_INVALID":"compressed should be a boolean","EC_PRIVATE_KEY_TYPE_INVALID":"private key should be a Buffer","EC_PRIVATE_KEY_LENGTH_INVALID":"private key length is invalid","EC_PRIVATE_KEY_RANGE_INVALID":"private key range is invalid","EC_PRIVATE_KEY_TWEAK_ADD_FAIL":"tweak out of range or resulting private key is invalid","EC_PRIVATE_KEY_TWEAK_MUL_FAIL":"tweak out of range","EC_PRIVATE_KEY_EXPORT_DER_FAIL":"couldn\'t export to DER format","EC_PRIVATE_KEY_IMPORT_DER_FAIL":"couldn\'t import from DER format","EC_PUBLIC_KEYS_TYPE_INVALID":"public keys should be an Array","EC_PUBLIC_KEYS_LENGTH_INVALID":"public keys Array should have at least 1 element","EC_PUBLIC_KEY_TYPE_INVALID":"public key should be a Buffer","EC_PUBLIC_KEY_LENGTH_INVALID":"public key length is invalid","EC_PUBLIC_KEY_PARSE_FAIL":"the public key could not be parsed or is invalid","EC_PUBLIC_KEY_CREATE_FAIL":"private was invalid, try again","EC_PUBLIC_KEY_TWEAK_ADD_FAIL":"tweak out of range or resulting public key is invalid","EC_PUBLIC_KEY_TWEAK_MUL_FAIL":"tweak out of range","EC_PUBLIC_KEY_COMBINE_FAIL":"the sum of the public keys is not valid","ECDH_FAIL":"scalar was invalid (zero or overflow)","ECDSA_SIGNATURE_TYPE_INVALID":"signature should be a Buffer","ECDSA_SIGNATURE_LENGTH_INVALID":"signature length is invalid","ECDSA_SIGNATURE_PARSE_FAIL":"couldn\'t parse signature","ECDSA_SIGNATURE_PARSE_DER_FAIL":"couldn\'t parse DER signature","ECDSA_SIGNATURE_SERIALIZE_DER_FAIL":"couldn\'t serialize signature to DER format","ECDSA_SIGN_FAIL":"nonce generation function failed or private key is invalid","ECDSA_RECOVER_FAIL":"couldn\'t recover public key from signature","MSG32_TYPE_INVALID":"message should be a Buffer","MSG32_LENGTH_INVALID":"message length is invalid","OPTIONS_TYPE_INVALID":"options should be an Object","OPTIONS_DATA_TYPE_INVALID":"options.data should be a Buffer","OPTIONS_DATA_LENGTH_INVALID":"options.data length is invalid","OPTIONS_NONCEFN_TYPE_INVALID":"options.noncefn should be a Function","RECOVERY_ID_TYPE_INVALID":"recovery should be a Number","RECOVERY_ID_VALUE_INVALID":"recovery should have value between -1 and 4","TWEAK_TYPE_INVALID":"tweak should be a Buffer","TWEAK_LENGTH_INVALID":"tweak length is invalid"}');
  }, function (t, e, r) {
    "use strict";

    var n = r(1).Buffer,
        i = r(13).Transform;

    function o(t) {
      i.call(this), this._block = n.allocUnsafe(t), this._blockSize = t, this._blockOffset = 0, this._length = [0, 0, 0, 0], this._finalized = !1;
    }

    r(0)(o, i), o.prototype._transform = function (t, e, r) {
      var n = null;

      try {
        this.update(t, e);
      } catch (t) {
        n = t;
      }

      r(n);
    }, o.prototype._flush = function (t) {
      var e = null;

      try {
        this.push(this.digest());
      } catch (t) {
        e = t;
      }

      t(e);
    }, o.prototype.update = function (t, e) {
      if (function (t, e) {
        if (!n.isBuffer(t) && "string" != typeof t) throw new TypeError(e + " must be a string or a buffer");
      }(t, "Data"), this._finalized) throw new Error("Digest already called");
      n.isBuffer(t) || (t = n.from(t, e));

      for (var r = this._block, i = 0; this._blockOffset + t.length - i >= this._blockSize;) {
        for (var o = this._blockOffset; o < this._blockSize;) {
          r[o++] = t[i++];
        }

        this._update(), this._blockOffset = 0;
      }

      for (; i < t.length;) {
        r[this._blockOffset++] = t[i++];
      }

      for (var s = 0, a = 8 * t.length; a > 0; ++s) {
        this._length[s] += a, (a = this._length[s] / 4294967296 | 0) > 0 && (this._length[s] -= 4294967296 * a);
      }

      return this;
    }, o.prototype._update = function () {
      throw new Error("_update is not implemented");
    }, o.prototype.digest = function (t) {
      if (this._finalized) throw new Error("Digest already called");
      this._finalized = !0;

      var e = this._digest();

      void 0 !== t && (e = e.toString(t)), this._block.fill(0), this._blockOffset = 0;

      for (var r = 0; r < 4; ++r) {
        this._length[r] = 0;
      }

      return e;
    }, o.prototype._digest = function () {
      throw new Error("_digest is not implemented");
    }, t.exports = o;
  }, function (t, e, r) {
    var n = r(0),
        i = r(14),
        o = r(1).Buffer,
        s = [1116352408, 1899447441, 3049323471, 3921009573, 961987163, 1508970993, 2453635748, 2870763221, 3624381080, 310598401, 607225278, 1426881987, 1925078388, 2162078206, 2614888103, 3248222580, 3835390401, 4022224774, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986, 2554220882, 2821834349, 2952996808, 3210313671, 3336571891, 3584528711, 113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, 2177026350, 2456956037, 2730485921, 2820302411, 3259730800, 3345764771, 3516065817, 3600352804, 4094571909, 275423344, 430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779, 1955562222, 2024104815, 2227730452, 2361852424, 2428436474, 2756734187, 3204031479, 3329325298],
        a = new Array(64);

    function u() {
      this.init(), this._w = a, i.call(this, 64, 56);
    }

    function f(t, e, r) {
      return r ^ t & (e ^ r);
    }

    function c(t, e, r) {
      return t & e | r & (t | e);
    }

    function h(t) {
      return (t >>> 2 | t << 30) ^ (t >>> 13 | t << 19) ^ (t >>> 22 | t << 10);
    }

    function l(t) {
      return (t >>> 6 | t << 26) ^ (t >>> 11 | t << 21) ^ (t >>> 25 | t << 7);
    }

    function d(t) {
      return (t >>> 7 | t << 25) ^ (t >>> 18 | t << 14) ^ t >>> 3;
    }

    n(u, i), u.prototype.init = function () {
      return this._a = 1779033703, this._b = 3144134277, this._c = 1013904242, this._d = 2773480762, this._e = 1359893119, this._f = 2600822924, this._g = 528734635, this._h = 1541459225, this;
    }, u.prototype._update = function (t) {
      for (var e, r = this._w, n = 0 | this._a, i = 0 | this._b, o = 0 | this._c, a = 0 | this._d, u = 0 | this._e, p = 0 | this._f, g = 0 | this._g, m = 0 | this._h, b = 0; b < 16; ++b) {
        r[b] = t.readInt32BE(4 * b);
      }

      for (; b < 64; ++b) {
        r[b] = 0 | (((e = r[b - 2]) >>> 17 | e << 15) ^ (e >>> 19 | e << 13) ^ e >>> 10) + r[b - 7] + d(r[b - 15]) + r[b - 16];
      }

      for (var v = 0; v < 64; ++v) {
        var y = m + l(u) + f(u, p, g) + s[v] + r[v] | 0,
            _ = h(n) + c(n, i, o) | 0;

        m = g, g = p, p = u, u = a + y | 0, a = o, o = i, i = n, n = y + _ | 0;
      }

      this._a = n + this._a | 0, this._b = i + this._b | 0, this._c = o + this._c | 0, this._d = a + this._d | 0, this._e = u + this._e | 0, this._f = p + this._f | 0, this._g = g + this._g | 0, this._h = m + this._h | 0;
    }, u.prototype._hash = function () {
      var t = o.allocUnsafe(32);
      return t.writeInt32BE(this._a, 0), t.writeInt32BE(this._b, 4), t.writeInt32BE(this._c, 8), t.writeInt32BE(this._d, 12), t.writeInt32BE(this._e, 16), t.writeInt32BE(this._f, 20), t.writeInt32BE(this._g, 24), t.writeInt32BE(this._h, 28), t;
    }, t.exports = u;
  }, function (t, e, r) {
    var n = r(0),
        i = r(14),
        o = r(1).Buffer,
        s = [1116352408, 3609767458, 1899447441, 602891725, 3049323471, 3964484399, 3921009573, 2173295548, 961987163, 4081628472, 1508970993, 3053834265, 2453635748, 2937671579, 2870763221, 3664609560, 3624381080, 2734883394, 310598401, 1164996542, 607225278, 1323610764, 1426881987, 3590304994, 1925078388, 4068182383, 2162078206, 991336113, 2614888103, 633803317, 3248222580, 3479774868, 3835390401, 2666613458, 4022224774, 944711139, 264347078, 2341262773, 604807628, 2007800933, 770255983, 1495990901, 1249150122, 1856431235, 1555081692, 3175218132, 1996064986, 2198950837, 2554220882, 3999719339, 2821834349, 766784016, 2952996808, 2566594879, 3210313671, 3203337956, 3336571891, 1034457026, 3584528711, 2466948901, 113926993, 3758326383, 338241895, 168717936, 666307205, 1188179964, 773529912, 1546045734, 1294757372, 1522805485, 1396182291, 2643833823, 1695183700, 2343527390, 1986661051, 1014477480, 2177026350, 1206759142, 2456956037, 344077627, 2730485921, 1290863460, 2820302411, 3158454273, 3259730800, 3505952657, 3345764771, 106217008, 3516065817, 3606008344, 3600352804, 1432725776, 4094571909, 1467031594, 275423344, 851169720, 430227734, 3100823752, 506948616, 1363258195, 659060556, 3750685593, 883997877, 3785050280, 958139571, 3318307427, 1322822218, 3812723403, 1537002063, 2003034995, 1747873779, 3602036899, 1955562222, 1575990012, 2024104815, 1125592928, 2227730452, 2716904306, 2361852424, 442776044, 2428436474, 593698344, 2756734187, 3733110249, 3204031479, 2999351573, 3329325298, 3815920427, 3391569614, 3928383900, 3515267271, 566280711, 3940187606, 3454069534, 4118630271, 4000239992, 116418474, 1914138554, 174292421, 2731055270, 289380356, 3203993006, 460393269, 320620315, 685471733, 587496836, 852142971, 1086792851, 1017036298, 365543100, 1126000580, 2618297676, 1288033470, 3409855158, 1501505948, 4234509866, 1607167915, 987167468, 1816402316, 1246189591],
        a = new Array(160);

    function u() {
      this.init(), this._w = a, i.call(this, 128, 112);
    }

    function f(t, e, r) {
      return r ^ t & (e ^ r);
    }

    function c(t, e, r) {
      return t & e | r & (t | e);
    }

    function h(t, e) {
      return (t >>> 28 | e << 4) ^ (e >>> 2 | t << 30) ^ (e >>> 7 | t << 25);
    }

    function l(t, e) {
      return (t >>> 14 | e << 18) ^ (t >>> 18 | e << 14) ^ (e >>> 9 | t << 23);
    }

    function d(t, e) {
      return (t >>> 1 | e << 31) ^ (t >>> 8 | e << 24) ^ t >>> 7;
    }

    function p(t, e) {
      return (t >>> 1 | e << 31) ^ (t >>> 8 | e << 24) ^ (t >>> 7 | e << 25);
    }

    function g(t, e) {
      return (t >>> 19 | e << 13) ^ (e >>> 29 | t << 3) ^ t >>> 6;
    }

    function m(t, e) {
      return (t >>> 19 | e << 13) ^ (e >>> 29 | t << 3) ^ (t >>> 6 | e << 26);
    }

    function b(t, e) {
      return t >>> 0 < e >>> 0 ? 1 : 0;
    }

    n(u, i), u.prototype.init = function () {
      return this._ah = 1779033703, this._bh = 3144134277, this._ch = 1013904242, this._dh = 2773480762, this._eh = 1359893119, this._fh = 2600822924, this._gh = 528734635, this._hh = 1541459225, this._al = 4089235720, this._bl = 2227873595, this._cl = 4271175723, this._dl = 1595750129, this._el = 2917565137, this._fl = 725511199, this._gl = 4215389547, this._hl = 327033209, this;
    }, u.prototype._update = function (t) {
      for (var e = this._w, r = 0 | this._ah, n = 0 | this._bh, i = 0 | this._ch, o = 0 | this._dh, a = 0 | this._eh, u = 0 | this._fh, v = 0 | this._gh, y = 0 | this._hh, _ = 0 | this._al, w = 0 | this._bl, E = 0 | this._cl, M = 0 | this._dl, S = 0 | this._el, A = 0 | this._fl, x = 0 | this._gl, R = 0 | this._hl, T = 0; T < 32; T += 2) {
        e[T] = t.readInt32BE(4 * T), e[T + 1] = t.readInt32BE(4 * T + 4);
      }

      for (; T < 160; T += 2) {
        var k = e[T - 30],
            I = e[T - 30 + 1],
            B = d(k, I),
            O = p(I, k),
            P = g(k = e[T - 4], I = e[T - 4 + 1]),
            N = m(I, k),
            C = e[T - 14],
            L = e[T - 14 + 1],
            j = e[T - 32],
            U = e[T - 32 + 1],
            D = O + L | 0,
            F = B + C + b(D, O) | 0;
        F = (F = F + P + b(D = D + N | 0, N) | 0) + j + b(D = D + U | 0, U) | 0, e[T] = F, e[T + 1] = D;
      }

      for (var z = 0; z < 160; z += 2) {
        F = e[z], D = e[z + 1];
        var q = c(r, n, i),
            H = c(_, w, E),
            Y = h(r, _),
            G = h(_, r),
            K = l(a, S),
            Z = l(S, a),
            V = s[z],
            W = s[z + 1],
            J = f(a, u, v),
            X = f(S, A, x),
            $ = R + Z | 0,
            Q = y + K + b($, R) | 0;
        Q = (Q = (Q = Q + J + b($ = $ + X | 0, X) | 0) + V + b($ = $ + W | 0, W) | 0) + F + b($ = $ + D | 0, D) | 0;
        var tt = G + H | 0,
            et = Y + q + b(tt, G) | 0;
        y = v, R = x, v = u, x = A, u = a, A = S, a = o + Q + b(S = M + $ | 0, M) | 0, o = i, M = E, i = n, E = w, n = r, w = _, r = Q + et + b(_ = $ + tt | 0, $) | 0;
      }

      this._al = this._al + _ | 0, this._bl = this._bl + w | 0, this._cl = this._cl + E | 0, this._dl = this._dl + M | 0, this._el = this._el + S | 0, this._fl = this._fl + A | 0, this._gl = this._gl + x | 0, this._hl = this._hl + R | 0, this._ah = this._ah + r + b(this._al, _) | 0, this._bh = this._bh + n + b(this._bl, w) | 0, this._ch = this._ch + i + b(this._cl, E) | 0, this._dh = this._dh + o + b(this._dl, M) | 0, this._eh = this._eh + a + b(this._el, S) | 0, this._fh = this._fh + u + b(this._fl, A) | 0, this._gh = this._gh + v + b(this._gl, x) | 0, this._hh = this._hh + y + b(this._hl, R) | 0;
    }, u.prototype._hash = function () {
      var t = o.allocUnsafe(64);

      function e(e, r, n) {
        t.writeInt32BE(e, n), t.writeInt32BE(r, n + 4);
      }

      return e(this._ah, this._al, 0), e(this._bh, this._bl, 8), e(this._ch, this._cl, 16), e(this._dh, this._dl, 24), e(this._eh, this._el, 32), e(this._fh, this._fl, 40), e(this._gh, this._gl, 48), e(this._hh, this._hl, 56), t;
    }, t.exports = u;
  }, function (t, e, r) {
    "use strict";

    var n = e;

    function i(t) {
      return 1 === t.length ? "0" + t : t;
    }

    function o(t) {
      for (var e = "", r = 0; r < t.length; r++) {
        e += i(t[r].toString(16));
      }

      return e;
    }

    n.toArray = function (t, e) {
      if (Array.isArray(t)) return t.slice();
      if (!t) return [];
      var r = [];

      if ("string" != typeof t) {
        for (var n = 0; n < t.length; n++) {
          r[n] = 0 | t[n];
        }

        return r;
      }

      if ("hex" === e) {
        (t = t.replace(/[^a-z0-9]+/gi, "")).length % 2 != 0 && (t = "0" + t);

        for (n = 0; n < t.length; n += 2) {
          r.push(parseInt(t[n] + t[n + 1], 16));
        }
      } else for (n = 0; n < t.length; n++) {
        var i = t.charCodeAt(n),
            o = i >> 8,
            s = 255 & i;
        o ? r.push(o, s) : r.push(s);
      }

      return r;
    }, n.zero2 = i, n.toHex = o, n.encode = function (t, e) {
      return "hex" === e ? o(t) : t;
    };
  }, function (t, e, r) {
    var n;

    function i(t) {
      this.rand = t;
    }

    if (t.exports = function (t) {
      return n || (n = new i(null)), n.generate(t);
    }, t.exports.Rand = i, i.prototype.generate = function (t) {
      return this._rand(t);
    }, i.prototype._rand = function (t) {
      if (this.rand.getBytes) return this.rand.getBytes(t);

      for (var e = new Uint8Array(t), r = 0; r < e.length; r++) {
        e[r] = this.rand.getByte();
      }

      return e;
    }, "object" == typeof self) self.crypto && self.crypto.getRandomValues ? i.prototype._rand = function (t) {
      var e = new Uint8Array(t);
      return self.crypto.getRandomValues(e), e;
    } : self.msCrypto && self.msCrypto.getRandomValues ? i.prototype._rand = function (t) {
      var e = new Uint8Array(t);
      return self.msCrypto.getRandomValues(e), e;
    } : "object" == typeof window && (i.prototype._rand = function () {
      throw new Error("Not implemented yet");
    });else try {
      var o = r(135);
      if ("function" != typeof o.randomBytes) throw new Error("Not supported");

      i.prototype._rand = function (t) {
        return o.randomBytes(t);
      };
    } catch (t) {}
  }, function (t, e, r) {
    "use strict";

    var n = e;
    n.base = r(27), n.short = r(136), n.mont = r(137), n.edwards = r(138);
  }, function (t, e, r) {
    "use strict";

    var n = r(7).rotr32;

    function i(t, e, r) {
      return t & e ^ ~t & r;
    }

    function o(t, e, r) {
      return t & e ^ t & r ^ e & r;
    }

    function s(t, e, r) {
      return t ^ e ^ r;
    }

    e.ft_1 = function (t, e, r, n) {
      return 0 === t ? i(e, r, n) : 1 === t || 3 === t ? s(e, r, n) : 2 === t ? o(e, r, n) : void 0;
    }, e.ch32 = i, e.maj32 = o, e.p32 = s, e.s0_256 = function (t) {
      return n(t, 2) ^ n(t, 13) ^ n(t, 22);
    }, e.s1_256 = function (t) {
      return n(t, 6) ^ n(t, 11) ^ n(t, 25);
    }, e.g0_256 = function (t) {
      return n(t, 7) ^ n(t, 18) ^ t >>> 3;
    }, e.g1_256 = function (t) {
      return n(t, 17) ^ n(t, 19) ^ t >>> 10;
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(7),
        i = r(20),
        o = r(66),
        s = r(11),
        a = n.sum32,
        u = n.sum32_4,
        f = n.sum32_5,
        c = o.ch32,
        h = o.maj32,
        l = o.s0_256,
        d = o.s1_256,
        p = o.g0_256,
        g = o.g1_256,
        m = i.BlockHash,
        b = [1116352408, 1899447441, 3049323471, 3921009573, 961987163, 1508970993, 2453635748, 2870763221, 3624381080, 310598401, 607225278, 1426881987, 1925078388, 2162078206, 2614888103, 3248222580, 3835390401, 4022224774, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986, 2554220882, 2821834349, 2952996808, 3210313671, 3336571891, 3584528711, 113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, 2177026350, 2456956037, 2730485921, 2820302411, 3259730800, 3345764771, 3516065817, 3600352804, 4094571909, 275423344, 430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779, 1955562222, 2024104815, 2227730452, 2361852424, 2428436474, 2756734187, 3204031479, 3329325298];

    function v() {
      if (!(this instanceof v)) return new v();
      m.call(this), this.h = [1779033703, 3144134277, 1013904242, 2773480762, 1359893119, 2600822924, 528734635, 1541459225], this.k = b, this.W = new Array(64);
    }

    n.inherits(v, m), t.exports = v, v.blockSize = 512, v.outSize = 256, v.hmacStrength = 192, v.padLength = 64, v.prototype._update = function (t, e) {
      for (var r = this.W, n = 0; n < 16; n++) {
        r[n] = t[e + n];
      }

      for (; n < r.length; n++) {
        r[n] = u(g(r[n - 2]), r[n - 7], p(r[n - 15]), r[n - 16]);
      }

      var i = this.h[0],
          o = this.h[1],
          m = this.h[2],
          b = this.h[3],
          v = this.h[4],
          y = this.h[5],
          _ = this.h[6],
          w = this.h[7];

      for (s(this.k.length === r.length), n = 0; n < r.length; n++) {
        var E = f(w, d(v), c(v, y, _), this.k[n], r[n]),
            M = a(l(i), h(i, o, m));
        w = _, _ = y, y = v, v = a(b, E), b = m, m = o, o = i, i = a(E, M);
      }

      this.h[0] = a(this.h[0], i), this.h[1] = a(this.h[1], o), this.h[2] = a(this.h[2], m), this.h[3] = a(this.h[3], b), this.h[4] = a(this.h[4], v), this.h[5] = a(this.h[5], y), this.h[6] = a(this.h[6], _), this.h[7] = a(this.h[7], w);
    }, v.prototype._digest = function (t) {
      return "hex" === t ? n.toHex32(this.h, "big") : n.split32(this.h, "big");
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(7),
        i = r(20),
        o = r(11),
        s = n.rotr64_hi,
        a = n.rotr64_lo,
        u = n.shr64_hi,
        f = n.shr64_lo,
        c = n.sum64,
        h = n.sum64_hi,
        l = n.sum64_lo,
        d = n.sum64_4_hi,
        p = n.sum64_4_lo,
        g = n.sum64_5_hi,
        m = n.sum64_5_lo,
        b = i.BlockHash,
        v = [1116352408, 3609767458, 1899447441, 602891725, 3049323471, 3964484399, 3921009573, 2173295548, 961987163, 4081628472, 1508970993, 3053834265, 2453635748, 2937671579, 2870763221, 3664609560, 3624381080, 2734883394, 310598401, 1164996542, 607225278, 1323610764, 1426881987, 3590304994, 1925078388, 4068182383, 2162078206, 991336113, 2614888103, 633803317, 3248222580, 3479774868, 3835390401, 2666613458, 4022224774, 944711139, 264347078, 2341262773, 604807628, 2007800933, 770255983, 1495990901, 1249150122, 1856431235, 1555081692, 3175218132, 1996064986, 2198950837, 2554220882, 3999719339, 2821834349, 766784016, 2952996808, 2566594879, 3210313671, 3203337956, 3336571891, 1034457026, 3584528711, 2466948901, 113926993, 3758326383, 338241895, 168717936, 666307205, 1188179964, 773529912, 1546045734, 1294757372, 1522805485, 1396182291, 2643833823, 1695183700, 2343527390, 1986661051, 1014477480, 2177026350, 1206759142, 2456956037, 344077627, 2730485921, 1290863460, 2820302411, 3158454273, 3259730800, 3505952657, 3345764771, 106217008, 3516065817, 3606008344, 3600352804, 1432725776, 4094571909, 1467031594, 275423344, 851169720, 430227734, 3100823752, 506948616, 1363258195, 659060556, 3750685593, 883997877, 3785050280, 958139571, 3318307427, 1322822218, 3812723403, 1537002063, 2003034995, 1747873779, 3602036899, 1955562222, 1575990012, 2024104815, 1125592928, 2227730452, 2716904306, 2361852424, 442776044, 2428436474, 593698344, 2756734187, 3733110249, 3204031479, 2999351573, 3329325298, 3815920427, 3391569614, 3928383900, 3515267271, 566280711, 3940187606, 3454069534, 4118630271, 4000239992, 116418474, 1914138554, 174292421, 2731055270, 289380356, 3203993006, 460393269, 320620315, 685471733, 587496836, 852142971, 1086792851, 1017036298, 365543100, 1126000580, 2618297676, 1288033470, 3409855158, 1501505948, 4234509866, 1607167915, 987167468, 1816402316, 1246189591];

    function y() {
      if (!(this instanceof y)) return new y();
      b.call(this), this.h = [1779033703, 4089235720, 3144134277, 2227873595, 1013904242, 4271175723, 2773480762, 1595750129, 1359893119, 2917565137, 2600822924, 725511199, 528734635, 4215389547, 1541459225, 327033209], this.k = v, this.W = new Array(160);
    }

    function _(t, e, r, n, i) {
      var o = t & r ^ ~t & i;
      return o < 0 && (o += 4294967296), o;
    }

    function w(t, e, r, n, i, o) {
      var s = e & n ^ ~e & o;
      return s < 0 && (s += 4294967296), s;
    }

    function E(t, e, r, n, i) {
      var o = t & r ^ t & i ^ r & i;
      return o < 0 && (o += 4294967296), o;
    }

    function M(t, e, r, n, i, o) {
      var s = e & n ^ e & o ^ n & o;
      return s < 0 && (s += 4294967296), s;
    }

    function S(t, e) {
      var r = s(t, e, 28) ^ s(e, t, 2) ^ s(e, t, 7);
      return r < 0 && (r += 4294967296), r;
    }

    function A(t, e) {
      var r = a(t, e, 28) ^ a(e, t, 2) ^ a(e, t, 7);
      return r < 0 && (r += 4294967296), r;
    }

    function x(t, e) {
      var r = s(t, e, 14) ^ s(t, e, 18) ^ s(e, t, 9);
      return r < 0 && (r += 4294967296), r;
    }

    function R(t, e) {
      var r = a(t, e, 14) ^ a(t, e, 18) ^ a(e, t, 9);
      return r < 0 && (r += 4294967296), r;
    }

    function T(t, e) {
      var r = s(t, e, 1) ^ s(t, e, 8) ^ u(t, e, 7);
      return r < 0 && (r += 4294967296), r;
    }

    function k(t, e) {
      var r = a(t, e, 1) ^ a(t, e, 8) ^ f(t, e, 7);
      return r < 0 && (r += 4294967296), r;
    }

    function I(t, e) {
      var r = s(t, e, 19) ^ s(e, t, 29) ^ u(t, e, 6);
      return r < 0 && (r += 4294967296), r;
    }

    function B(t, e) {
      var r = a(t, e, 19) ^ a(e, t, 29) ^ f(t, e, 6);
      return r < 0 && (r += 4294967296), r;
    }

    n.inherits(y, b), t.exports = y, y.blockSize = 1024, y.outSize = 512, y.hmacStrength = 192, y.padLength = 128, y.prototype._prepareBlock = function (t, e) {
      for (var r = this.W, n = 0; n < 32; n++) {
        r[n] = t[e + n];
      }

      for (; n < r.length; n += 2) {
        var i = I(r[n - 4], r[n - 3]),
            o = B(r[n - 4], r[n - 3]),
            s = r[n - 14],
            a = r[n - 13],
            u = T(r[n - 30], r[n - 29]),
            f = k(r[n - 30], r[n - 29]),
            c = r[n - 32],
            h = r[n - 31];
        r[n] = d(i, o, s, a, u, f, c, h), r[n + 1] = p(i, o, s, a, u, f, c, h);
      }
    }, y.prototype._update = function (t, e) {
      this._prepareBlock(t, e);

      var r = this.W,
          n = this.h[0],
          i = this.h[1],
          s = this.h[2],
          a = this.h[3],
          u = this.h[4],
          f = this.h[5],
          d = this.h[6],
          p = this.h[7],
          b = this.h[8],
          v = this.h[9],
          y = this.h[10],
          T = this.h[11],
          k = this.h[12],
          I = this.h[13],
          B = this.h[14],
          O = this.h[15];
      o(this.k.length === r.length);

      for (var P = 0; P < r.length; P += 2) {
        var N = B,
            C = O,
            L = x(b, v),
            j = R(b, v),
            U = _(b, v, y, T, k),
            D = w(b, v, y, T, k, I),
            F = this.k[P],
            z = this.k[P + 1],
            q = r[P],
            H = r[P + 1],
            Y = g(N, C, L, j, U, D, F, z, q, H),
            G = m(N, C, L, j, U, D, F, z, q, H);

        N = S(n, i), C = A(n, i), L = E(n, i, s, a, u), j = M(n, i, s, a, u, f);
        var K = h(N, C, L, j),
            Z = l(N, C, L, j);
        B = k, O = I, k = y, I = T, y = b, T = v, b = h(d, p, Y, G), v = l(p, p, Y, G), d = u, p = f, u = s, f = a, s = n, a = i, n = h(Y, G, K, Z), i = l(Y, G, K, Z);
      }

      c(this.h, 0, n, i), c(this.h, 2, s, a), c(this.h, 4, u, f), c(this.h, 6, d, p), c(this.h, 8, b, v), c(this.h, 10, y, T), c(this.h, 12, k, I), c(this.h, 14, B, O);
    }, y.prototype._digest = function (t) {
      return "hex" === t ? n.toHex32(this.h, "big") : n.split32(this.h, "big");
    };
  }, function (t, e) {
    t.exports = function (t) {
      if ("string" != typeof t) throw new Error("[is-hex-prefixed] value must be type 'string', is currently type " + typeof t + ", while checking isHexPrefixed.");
      return "0x" === t.slice(0, 2);
    };
  }, function (t, e, r) {
    "use strict";

    var n = function n(t, e) {
      return function () {
        var _this4 = this;

        var r = e.promiseModule,
            n = new Array(arguments.length);

        for (var _t2 = 0; _t2 < arguments.length; _t2++) {
          n[_t2] = arguments[_t2];
        }

        return new r(function (r, i) {
          e.errorFirst ? n.push(function (t, n) {
            if (e.multiArgs) {
              var _e = new Array(arguments.length - 1);

              for (var _t3 = 1; _t3 < arguments.length; _t3++) {
                _e[_t3 - 1] = arguments[_t3];
              }

              t ? (_e.unshift(t), i(_e)) : r(_e);
            } else t ? i(t) : r(n);
          }) : n.push(function (t) {
            if (e.multiArgs) {
              var _t4 = new Array(arguments.length - 1);

              for (var _e2 = 0; _e2 < arguments.length; _e2++) {
                _t4[_e2] = arguments[_e2];
              }

              r(_t4);
            } else r(t);
          }), t.apply(_this4, n);
        });
      };
    };

    t.exports = function (t, e) {
      e = Object.assign({
        exclude: [/.+(Sync|Stream)$/],
        errorFirst: !0,
        promiseModule: Promise
      }, e);

      var r = function r(t) {
        var r = function r(e) {
          return "string" == typeof e ? t === e : e.test(t);
        };

        return e.include ? e.include.some(r) : !e.exclude.some(r);
      };

      var i;
      i = "function" == typeof t ? function () {
        return e.excludeMain ? t.apply(this, arguments) : n(t, e).apply(this, arguments);
      } : Object.create(Object.getPrototypeOf(t));

      for (var o in t) {
        var s = t[o];
        i[o] = "function" == typeof s && r(o) ? n(s, e) : s;
      }

      return i;
    };
  }, function (t, e, r) {
    var n = r(29),
        i = r(157)();

    function o(t) {
      this.currentProvider = t;
    }

    function s(t) {
      return function () {
        var e = this;
        var r = [].slice.call(arguments),
            n = r.pop();
        e.sendAsync({
          method: t,
          params: r
        }, n);
      };
    }

    function a(t, e) {
      return function () {
        var r = this;
        var n = [].slice.call(arguments),
            i = n.pop();
        n.length < t && n.push("latest"), r.sendAsync({
          method: e,
          params: n
        }, i);
      };
    }

    t.exports = o, o.prototype.getBalance = a(2, "eth_getBalance"), o.prototype.getCode = a(2, "eth_getCode"), o.prototype.getTransactionCount = a(2, "eth_getTransactionCount"), o.prototype.getStorageAt = a(3, "eth_getStorageAt"), o.prototype.call = a(2, "eth_call"), o.prototype.protocolVersion = s("eth_protocolVersion"), o.prototype.syncing = s("eth_syncing"), o.prototype.coinbase = s("eth_coinbase"), o.prototype.mining = s("eth_mining"), o.prototype.hashrate = s("eth_hashrate"), o.prototype.gasPrice = s("eth_gasPrice"), o.prototype.accounts = s("eth_accounts"), o.prototype.blockNumber = s("eth_blockNumber"), o.prototype.getBlockTransactionCountByHash = s("eth_getBlockTransactionCountByHash"), o.prototype.getBlockTransactionCountByNumber = s("eth_getBlockTransactionCountByNumber"), o.prototype.getUncleCountByBlockHash = s("eth_getUncleCountByBlockHash"), o.prototype.getUncleCountByBlockNumber = s("eth_getUncleCountByBlockNumber"), o.prototype.sign = s("eth_sign"), o.prototype.sendTransaction = s("eth_sendTransaction"), o.prototype.sendRawTransaction = s("eth_sendRawTransaction"), o.prototype.estimateGas = s("eth_estimateGas"), o.prototype.getBlockByHash = s("eth_getBlockByHash"), o.prototype.getBlockByNumber = s("eth_getBlockByNumber"), o.prototype.getTransactionByHash = s("eth_getTransactionByHash"), o.prototype.getTransactionByBlockHashAndIndex = s("eth_getTransactionByBlockHashAndIndex"), o.prototype.getTransactionByBlockNumberAndIndex = s("eth_getTransactionByBlockNumberAndIndex"), o.prototype.getTransactionReceipt = s("eth_getTransactionReceipt"), o.prototype.getUncleByBlockHashAndIndex = s("eth_getUncleByBlockHashAndIndex"), o.prototype.getUncleByBlockNumberAndIndex = s("eth_getUncleByBlockNumberAndIndex"), o.prototype.getCompilers = s("eth_getCompilers"), o.prototype.compileLLL = s("eth_compileLLL"), o.prototype.compileSolidity = s("eth_compileSolidity"), o.prototype.compileSerpent = s("eth_compileSerpent"), o.prototype.newFilter = s("eth_newFilter"), o.prototype.newBlockFilter = s("eth_newBlockFilter"), o.prototype.newPendingTransactionFilter = s("eth_newPendingTransactionFilter"), o.prototype.uninstallFilter = s("eth_uninstallFilter"), o.prototype.getFilterChanges = s("eth_getFilterChanges"), o.prototype.getFilterLogs = s("eth_getFilterLogs"), o.prototype.getLogs = s("eth_getLogs"), o.prototype.getWork = s("eth_getWork"), o.prototype.submitWork = s("eth_submitWork"), o.prototype.submitHashrate = s("eth_submitHashrate"), o.prototype.sendAsync = function (t, e) {
      var r;
      this.currentProvider.sendAsync((r = t, n({
        id: i(),
        jsonrpc: "2.0",
        params: []
      }, r)), function (t, r) {
        if (!t && r.error && (t = new Error("EthQuery - RPC Error - " + r.error.message)), t) return e(t);
        e(null, r.result);
      });
    };
  }, function (t, e, r) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = function (t, e, r) {
      ((0, n.default)(t) ? l : d)(t, (0, c.default)(e), r);
    };
    var n = h(r(30)),
        i = h(r(78)),
        o = h(r(163)),
        s = h(r(81)),
        a = h(r(21)),
        u = h(r(41)),
        f = h(r(43)),
        c = h(r(12));

    function h(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }

    function l(t, e, r) {
      r = (0, u.default)(r || a.default);
      var n = 0,
          o = 0,
          s = t.length;

      function c(t, e) {
        t ? r(t) : ++o !== s && e !== i.default || r(null);
      }

      for (0 === s && r(null); n < s; n++) {
        e(t[n], n, (0, f.default)(c));
      }
    }

    var d = (0, s.default)(o.default, 1 / 0);
    t.exports = e.default;
  }, function (t, e, r) {
    var n = r(74).Symbol;
    t.exports = n;
  }, function (t, e, r) {
    var n = r(75),
        i = "object" == typeof self && self && self.Object === Object && self,
        o = n || i || Function("return this")();
    t.exports = o;
  }, function (t, e, r) {
    (function (e) {
      var r = "object" == typeof e && e && e.Object === Object && e;
      t.exports = r;
    }).call(this, r(4));
  }, function (t, e) {
    t.exports = function (t) {
      var e = typeof t;
      return null != t && ("object" == e || "function" == e);
    };
  }, function (t, e) {
    t.exports = function (t) {
      return "number" == typeof t && t > -1 && t % 1 == 0 && t <= 9007199254740991;
    };
  }, function (t, e, r) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = {}, t.exports = e.default;
  }, function (t, e, r) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = function (t) {
      return function (e, r, u) {
        if (u = (0, i.default)(u || n.default), t <= 0 || !e) return u(null);
        var f = (0, o.default)(e),
            c = !1,
            h = 0,
            l = !1;

        function d(t, e) {
          if (h -= 1, t) c = !0, u(t);else {
            if (e === a.default || c && h <= 0) return c = !0, u(null);
            l || p();
          }
        }

        function p() {
          for (l = !0; h < t && !c;) {
            var e = f();
            if (null === e) return c = !0, void (h <= 0 && u(null));
            h += 1, r(e.value, e.key, (0, s.default)(d));
          }

          l = !1;
        }

        p();
      };
    };
    var n = u(r(21)),
        i = u(r(41)),
        o = u(r(164)),
        s = u(r(43)),
        a = u(r(78));

    function u(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }

    t.exports = e.default;
  }, function (t, e) {
    var r = Array.isArray;
    t.exports = r;
  }, function (t, e, r) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = function (t, e) {
      return function (r, n, i) {
        return t(r, e, n, i);
      };
    }, t.exports = e.default;
  }, function (t, e, r) {
    var n = r(83);

    function i(t) {
      return "never" !== a(t);
    }

    function o(t) {
      var e = s(t);
      return e >= t.params.length ? t.params : "eth_getBlockByNumber" === t.method ? t.params.slice(1) : t.params.slice(0, e);
    }

    function s(t) {
      switch (t.method) {
        case "eth_getStorageAt":
          return 2;

        case "eth_getBalance":
        case "eth_getCode":
        case "eth_getTransactionCount":
        case "eth_call":
        case "eth_estimateGas":
          return 1;

        case "eth_getBlockByNumber":
          return 0;

        default:
          return;
      }
    }

    function a(t) {
      switch (t.method) {
        case "web3_clientVersion":
        case "web3_sha3":
        case "eth_protocolVersion":
        case "eth_getBlockTransactionCountByHash":
        case "eth_getUncleCountByBlockHash":
        case "eth_getCode":
        case "eth_getBlockByHash":
        case "eth_getTransactionByHash":
        case "eth_getTransactionByBlockHashAndIndex":
        case "eth_getTransactionReceipt":
        case "eth_getUncleByBlockHashAndIndex":
        case "eth_getCompilers":
        case "eth_compileLLL":
        case "eth_compileSolidity":
        case "eth_compileSerpent":
        case "shh_version":
          return "perma";

        case "eth_getBlockByNumber":
        case "eth_getBlockTransactionCountByNumber":
        case "eth_getUncleCountByBlockNumber":
        case "eth_getTransactionByBlockNumberAndIndex":
        case "eth_getUncleByBlockNumberAndIndex":
          return "fork";

        case "eth_gasPrice":
        case "eth_getBalance":
        case "eth_getStorageAt":
        case "eth_getTransactionCount":
        case "eth_call":
        case "eth_estimateGas":
        case "eth_getFilterLogs":
        case "eth_getLogs":
        case "eth_blockNumber":
          return "block";

        case "net_version":
        case "net_peerCount":
        case "net_listening":
        case "eth_syncing":
        case "eth_sign":
        case "eth_coinbase":
        case "eth_mining":
        case "eth_hashrate":
        case "eth_accounts":
        case "eth_sendTransaction":
        case "eth_sendRawTransaction":
        case "eth_newFilter":
        case "eth_newBlockFilter":
        case "eth_newPendingTransactionFilter":
        case "eth_uninstallFilter":
        case "eth_getFilterChanges":
        case "eth_getWork":
        case "eth_submitWork":
        case "eth_submitHashrate":
        case "db_putString":
        case "db_getString":
        case "db_putHex":
        case "db_getHex":
        case "shh_post":
        case "shh_newIdentity":
        case "shh_hasIdentity":
        case "shh_newGroup":
        case "shh_addToGroup":
        case "shh_newFilter":
        case "shh_uninstallFilter":
        case "shh_getFilterChanges":
        case "shh_getMessages":
          return "never";
      }
    }

    t.exports = {
      cacheIdentifierForPayload: function cacheIdentifierForPayload(t) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (!i(t)) return null;
        var r = e.includeBlockRef,
            s = r ? t.params : o(t);
        return t.method + ":" + n(s);
      },
      canCache: i,
      blockTagForPayload: function blockTagForPayload(t) {
        var e = s(t);
        if (e >= t.params.length) return null;
        return t.params[e];
      },
      paramsWithoutBlockTag: o,
      blockTagParamIndex: s,
      cacheTypeForPayload: a
    };
  }, function (t, e, r) {
    var n = "undefined" != typeof JSON ? JSON : r(190);

    t.exports = function (t, e) {
      e || (e = {}), "function" == typeof e && (e = {
        cmp: e
      });
      var r = e.space || "";
      "number" == typeof r && (r = Array(r + 1).join(" "));

      var s,
          a = "boolean" == typeof e.cycles && e.cycles,
          u = e.replacer || function (t, e) {
        return e;
      },
          f = e.cmp && (s = e.cmp, function (t) {
        return function (e, r) {
          var n = {
            key: e,
            value: t[e]
          },
              i = {
            key: r,
            value: t[r]
          };
          return s(n, i);
        };
      }),
          c = [];

      return function t(e, s, h, l) {
        var d = r ? "\n" + new Array(l + 1).join(r) : "",
            p = r ? ": " : ":";

        if (h && h.toJSON && "function" == typeof h.toJSON && (h = h.toJSON()), void 0 !== (h = u.call(e, s, h))) {
          if ("object" != typeof h || null === h) return n.stringify(h);

          if (i(h)) {
            for (var g = [], m = 0; m < h.length; m++) {
              var b = t(h, m, h[m], l + 1) || n.stringify(null);
              g.push(d + r + b);
            }

            return "[" + g.join(",") + d + "]";
          }

          if (-1 !== c.indexOf(h)) {
            if (a) return n.stringify("__cycle__");
            throw new TypeError("Converting circular structure to JSON");
          }

          c.push(h);
          var v = o(h).sort(f && f(h));

          for (g = [], m = 0; m < v.length; m++) {
            var y = t(h, s = v[m], h[s], l + 1);

            if (y) {
              var _ = n.stringify(s) + p + y;

              g.push(d + r + _);
            }
          }

          return c.splice(c.indexOf(h), 1), "{" + g.join(",") + d + "}";
        }
      }({
        "": t
      }, "", t, 0);
    };

    var i = Array.isArray || function (t) {
      return "[object Array]" === {}.toString.call(t);
    },
        o = Object.keys || function (t) {
      var e = Object.prototype.hasOwnProperty || function () {
        return !0;
      },
          r = [];

      for (var n in t) {
        e.call(t, n) && r.push(n);
      }

      return r;
    };
  }, function (t, e, r) {
    var n = r(199).Mutex,
        i = r(46),
        o = r(85),
        s = r(201),
        a = r(204),
        u = r(205),
        _r2 = r(22),
        f = _r2.intToHex,
        c = _r2.hexToInt;

    function h(t) {
      return l(
      /*#__PURE__*/
      _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5() {
        var r,
            _args5 = arguments;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return t.apply(void 0, _args5);

              case 2:
                r = _context5.sent;
                return _context5.abrupt("return", f(r.id));

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      })));
    }

    function l(t) {
      return i(
      /*#__PURE__*/
      function () {
        var _ref5 = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee6(e, r) {
          var n;
          return _regeneratorRuntime.wrap(function _callee6$(_context6) {
            while (1) {
              switch (_context6.prev = _context6.next) {
                case 0:
                  _context6.next = 2;
                  return t.apply(null, e.params);

                case 2:
                  n = _context6.sent;
                  r.result = n;

                case 4:
                case "end":
                  return _context6.stop();
              }
            }
          }, _callee6);
        }));

        return function (_x2, _x3) {
          return _ref5.apply(this, arguments);
        };
      }());
    }

    function d(t, e) {
      var r = [];

      for (var _e3 in t) {
        r.push(t[_e3]);
      }

      return r;
    }

    t.exports = function (_ref6) {
      var t = _ref6.blockTracker,
          e = _ref6.provider;
      var r = 0,
          i = {};

      var p = new n(),
          g = function (_ref7) {
        var t = _ref7.mutex;
        return function (e) {
          return (
            /*#__PURE__*/
            function () {
              var _ref8 = _asyncToGenerator(
              /*#__PURE__*/
              _regeneratorRuntime.mark(function _callee7(r, n, i, o) {
                return _regeneratorRuntime.wrap(function _callee7$(_context7) {
                  while (1) {
                    switch (_context7.prev = _context7.next) {
                      case 0:
                        _context7.next = 2;
                        return t.acquire();

                      case 2:
                        _context7.t0 = _context7.sent;
                        (0, _context7.t0)();
                        e(r, n, i, o);

                      case 5:
                      case "end":
                        return _context7.stop();
                    }
                  }
                }, _callee7);
              }));

              return function (_x4, _x5, _x6, _x7) {
                return _ref8.apply(this, arguments);
              };
            }()
          );
        };
      }({
        mutex: p
      }),
          m = o({
        eth_newFilter: g(h(v)),
        eth_newBlockFilter: g(h(y)),
        eth_newPendingTransactionFilter: g(h(_)),
        eth_uninstallFilter: g(l(M)),
        eth_getFilterChanges: g(l(w)),
        eth_getFilterLogs: g(l(E))
      }),
          b =
      /*#__PURE__*/
      function () {
        var _ref10 = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee9(_ref9) {
          var t, e, r;
          return _regeneratorRuntime.wrap(function _callee9$(_context9) {
            while (1) {
              switch (_context9.prev = _context9.next) {
                case 0:
                  t = _ref9.oldBlock, e = _ref9.newBlock;

                  if (!(0 === i.length)) {
                    _context9.next = 3;
                    break;
                  }

                  return _context9.abrupt("return");

                case 3:
                  _context9.next = 5;
                  return p.acquire();

                case 5:
                  r = _context9.sent;
                  _context9.prev = 6;
                  _context9.next = 9;
                  return Promise.all(d(i).map(
                  /*#__PURE__*/
                  function () {
                    var _ref11 = _asyncToGenerator(
                    /*#__PURE__*/
                    _regeneratorRuntime.mark(function _callee8(r) {
                      return _regeneratorRuntime.wrap(function _callee8$(_context8) {
                        while (1) {
                          switch (_context8.prev = _context8.next) {
                            case 0:
                              _context8.prev = 0;
                              _context8.next = 3;
                              return r.update({
                                oldBlock: t,
                                newBlock: e
                              });

                            case 3:
                              _context8.next = 8;
                              break;

                            case 5:
                              _context8.prev = 5;
                              _context8.t0 = _context8["catch"](0);
                              console.error(_context8.t0);

                            case 8:
                            case "end":
                              return _context8.stop();
                          }
                        }
                      }, _callee8, null, [[0, 5]]);
                    }));

                    return function (_x9) {
                      return _ref11.apply(this, arguments);
                    };
                  }()));

                case 9:
                  _context9.next = 14;
                  break;

                case 11:
                  _context9.prev = 11;
                  _context9.t0 = _context9["catch"](6);
                  console.error(_context9.t0);

                case 14:
                  r();

                case 15:
                case "end":
                  return _context9.stop();
              }
            }
          }, _callee9, null, [[6, 11]]);
        }));

        return function b(_x8) {
          return _ref10.apply(this, arguments);
        };
      }();

      return m.newLogFilter = v, m.newBlockFilter = y, m.newPendingTransactionFilter = _, m.uninstallFilter = M, m.getFilterChanges = w, m.getFilterLogs = E, m.destroy = function () {
        !_asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee10() {
          var t;
          return _regeneratorRuntime.wrap(function _callee10$(_context10) {
            while (1) {
              switch (_context10.prev = _context10.next) {
                case 0:
                  t = d(i).length;
                  i = {}, A({
                    prevFilterCount: t,
                    newFilterCount: 0
                  });

                case 2:
                case "end":
                  return _context10.stop();
              }
            }
          }, _callee10);
        }))();
      }, m;

      function v(_x10) {
        return _v.apply(this, arguments);
      }

      function _v() {
        _v = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee11(t) {
          var r;
          return _regeneratorRuntime.wrap(function _callee11$(_context11) {
            while (1) {
              switch (_context11.prev = _context11.next) {
                case 0:
                  r = new s({
                    provider: e,
                    params: t
                  });
                  _context11.next = 3;
                  return S(r);

                case 3:
                  return _context11.abrupt("return", r);

                case 4:
                case "end":
                  return _context11.stop();
              }
            }
          }, _callee11);
        }));
        return _v.apply(this, arguments);
      }

      function y() {
        return _y.apply(this, arguments);
      }

      function _y() {
        _y = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee12() {
          var t;
          return _regeneratorRuntime.wrap(function _callee12$(_context12) {
            while (1) {
              switch (_context12.prev = _context12.next) {
                case 0:
                  t = new a({
                    provider: e
                  });
                  _context12.next = 3;
                  return S(t);

                case 3:
                  return _context12.abrupt("return", t);

                case 4:
                case "end":
                  return _context12.stop();
              }
            }
          }, _callee12);
        }));
        return _y.apply(this, arguments);
      }

      function _() {
        return _2.apply(this, arguments);
      }

      function _2() {
        _2 = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee13() {
          var t;
          return _regeneratorRuntime.wrap(function _callee13$(_context13) {
            while (1) {
              switch (_context13.prev = _context13.next) {
                case 0:
                  t = new u({
                    provider: e
                  });
                  _context13.next = 3;
                  return S(t);

                case 3:
                  return _context13.abrupt("return", t);

                case 4:
                case "end":
                  return _context13.stop();
              }
            }
          }, _callee13);
        }));
        return _2.apply(this, arguments);
      }

      function w(_x11) {
        return _w.apply(this, arguments);
      }

      function _w() {
        _w = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee14(t) {
          var e, r;
          return _regeneratorRuntime.wrap(function _callee14$(_context14) {
            while (1) {
              switch (_context14.prev = _context14.next) {
                case 0:
                  e = c(t), r = i[e];

                  if (r) {
                    _context14.next = 3;
                    break;
                  }

                  throw new Error("No filter for index \"".concat(e, "\""));

                case 3:
                  return _context14.abrupt("return", r.getChangesAndClear());

                case 4:
                case "end":
                  return _context14.stop();
              }
            }
          }, _callee14);
        }));
        return _w.apply(this, arguments);
      }

      function E(_x12) {
        return _E.apply(this, arguments);
      }

      function _E() {
        _E = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee15(t) {
          var e, r;
          return _regeneratorRuntime.wrap(function _callee15$(_context15) {
            while (1) {
              switch (_context15.prev = _context15.next) {
                case 0:
                  e = c(t), r = i[e];

                  if (r) {
                    _context15.next = 3;
                    break;
                  }

                  throw new Error("No filter for index \"".concat(e, "\""));

                case 3:
                  return _context15.abrupt("return", ("log" === r.type ? results = r.getAllResults() : results = [], results));

                case 4:
                case "end":
                  return _context15.stop();
              }
            }
          }, _callee15);
        }));
        return _E.apply(this, arguments);
      }

      function M(_x13) {
        return _M.apply(this, arguments);
      }

      function _M() {
        _M = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee17(t) {
          var e, r, n;
          return _regeneratorRuntime.wrap(function _callee17$(_context17) {
            while (1) {
              switch (_context17.prev = _context17.next) {
                case 0:
                  e = c(t), r = i[e], n = Boolean(r);
                  _context17.t0 = n;

                  if (!_context17.t0) {
                    _context17.next = 5;
                    break;
                  }

                  _context17.next = 5;
                  return function () {
                    var _ref14 = _asyncToGenerator(
                    /*#__PURE__*/
                    _regeneratorRuntime.mark(function _callee16(t) {
                      var e, r;
                      return _regeneratorRuntime.wrap(function _callee16$(_context16) {
                        while (1) {
                          switch (_context16.prev = _context16.next) {
                            case 0:
                              e = d(i).length;
                              delete i[t];
                              r = d(i).length;
                              A({
                                prevFilterCount: e,
                                newFilterCount: r
                              });

                            case 4:
                            case "end":
                              return _context16.stop();
                          }
                        }
                      }, _callee16);
                    }));

                    return function (_x15) {
                      return _ref14.apply(this, arguments);
                    };
                  }()(e);

                case 5:
                  return _context17.abrupt("return", n);

                case 6:
                case "end":
                  return _context17.stop();
              }
            }
          }, _callee17);
        }));
        return _M.apply(this, arguments);
      }

      function S(_x14) {
        return _S.apply(this, arguments);
      }

      function _S() {
        _S = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee18(e) {
          var n, o;
          return _regeneratorRuntime.wrap(function _callee18$(_context18) {
            while (1) {
              switch (_context18.prev = _context18.next) {
                case 0:
                  n = d(i).length;
                  _context18.next = 3;
                  return t.getLatestBlock();

                case 3:
                  o = _context18.sent;
                  _context18.next = 6;
                  return e.initialize({
                    currentBlock: o
                  });

                case 6:
                  r++;
                  i[r] = e;
                  e.id = r;
                  e.idHex = f(r);
                  A({
                    prevFilterCount: n,
                    newFilterCount: d(i).length
                  });
                  return _context18.abrupt("return", r);

                case 12:
                case "end":
                  return _context18.stop();
              }
            }
          }, _callee18);
        }));
        return _S.apply(this, arguments);
      }

      function A(_ref13) {
        var e = _ref13.prevFilterCount,
            r = _ref13.newFilterCount;
        0 === e && r > 0 ? t.on("sync", b) : e > 0 && 0 === r && t.removeListener("sync", b);
      }
    };
  }, function (t, e, r) {
    t.exports = r(200);
  }, function (t, e) {
    "function" == typeof Object.create ? t.exports = function (t, e) {
      e && (t.super_ = e, t.prototype = Object.create(e.prototype, {
        constructor: {
          value: t,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }));
    } : t.exports = function (t, e) {
      if (e) {
        t.super_ = e;

        var r = function r() {};

        r.prototype = e.prototype, t.prototype = new r(), t.prototype.constructor = t;
      }
    };
  }, function (t, e, r) {
    (function (t) {
      var n = r(230),
          i = r(89),
          o = r(29),
          s = r(232),
          a = r(51),
          u = e;
      u.request = function (e, r) {
        e = "string" == typeof e ? a.parse(e) : o(e);
        var i = -1 === t.location.protocol.search(/^https?:$/) ? "http:" : "",
            s = e.protocol || i,
            u = e.hostname || e.host,
            f = e.port,
            c = e.path || "/";
        u && -1 !== u.indexOf(":") && (u = "[" + u + "]"), e.url = (u ? s + "//" + u : "") + (f ? ":" + f : "") + c, e.method = (e.method || "GET").toUpperCase(), e.headers = e.headers || {};
        var h = new n(e);
        return r && h.on("response", r), h;
      }, u.get = function (t, e) {
        var r = u.request(t, e);
        return r.end(), r;
      }, u.ClientRequest = n, u.IncomingMessage = i.IncomingMessage, u.Agent = function () {}, u.Agent.defaultMaxSockets = 4, u.globalAgent = new u.Agent(), u.STATUS_CODES = s, u.METHODS = ["CHECKOUT", "CONNECT", "COPY", "DELETE", "GET", "HEAD", "LOCK", "M-SEARCH", "MERGE", "MKACTIVITY", "MKCOL", "MOVE", "NOTIFY", "OPTIONS", "PATCH", "POST", "PROPFIND", "PROPPATCH", "PURGE", "PUT", "REPORT", "SEARCH", "SUBSCRIBE", "TRACE", "UNLOCK", "UNSUBSCRIBE"];
    }).call(this, r(4));
  }, function (t, e, r) {
    (function (t) {
      e.fetch = a(t.fetch) && a(t.ReadableStream), e.writableStream = a(t.WritableStream), e.abortController = a(t.AbortController), e.blobConstructor = !1;

      try {
        new Blob([new ArrayBuffer(1)]), e.blobConstructor = !0;
      } catch (t) {}

      var r;

      function n() {
        if (void 0 !== r) return r;

        if (t.XMLHttpRequest) {
          r = new t.XMLHttpRequest();

          try {
            r.open("GET", t.XDomainRequest ? "/" : "https://example.com");
          } catch (t) {
            r = null;
          }
        } else r = null;

        return r;
      }

      function i(t) {
        var e = n();
        if (!e) return !1;

        try {
          return e.responseType = t, e.responseType === t;
        } catch (t) {}

        return !1;
      }

      var o = void 0 !== t.ArrayBuffer,
          s = o && a(t.ArrayBuffer.prototype.slice);

      function a(t) {
        return "function" == typeof t;
      }

      e.arraybuffer = e.fetch || o && i("arraybuffer"), e.msstream = !e.fetch && s && i("ms-stream"), e.mozchunkedarraybuffer = !e.fetch && o && i("moz-chunked-arraybuffer"), e.overrideMimeType = e.fetch || !!n() && a(n().overrideMimeType), e.vbArray = a(t.VBArray), r = null;
    }).call(this, r(4));
  }, function (t, e, r) {
    (function (t, n, i) {
      var o = r(88),
          s = r(0),
          a = r(17),
          u = e.readyStates = {
        UNSENT: 0,
        OPENED: 1,
        HEADERS_RECEIVED: 2,
        LOADING: 3,
        DONE: 4
      },
          f = e.IncomingMessage = function (e, r, s, u) {
        var f = this;

        if (a.Readable.call(f), f._mode = s, f.headers = {}, f.rawHeaders = [], f.trailers = {}, f.rawTrailers = [], f.on("end", function () {
          t.nextTick(function () {
            f.emit("close");
          });
        }), "fetch" === s) {
          if (f._fetchResponse = r, f.url = r.url, f.statusCode = r.status, f.statusMessage = r.statusText, r.headers.forEach(function (t, e) {
            f.headers[e.toLowerCase()] = t, f.rawHeaders.push(e, t);
          }), o.writableStream) {
            var c = new WritableStream({
              write: function write(t) {
                return new Promise(function (e, r) {
                  f._destroyed ? r() : f.push(new n(t)) ? e() : f._resumeFetch = e;
                });
              },
              close: function close() {
                i.clearTimeout(u), f._destroyed || f.push(null);
              },
              abort: function abort(t) {
                f._destroyed || f.emit("error", t);
              }
            });

            try {
              return void r.body.pipeTo(c).catch(function (t) {
                i.clearTimeout(u), f._destroyed || f.emit("error", t);
              });
            } catch (t) {}
          }

          var h = r.body.getReader();
          !function t() {
            h.read().then(function (e) {
              if (!f._destroyed) {
                if (e.done) return i.clearTimeout(u), void f.push(null);
                f.push(new n(e.value)), t();
              }
            }).catch(function (t) {
              i.clearTimeout(u), f._destroyed || f.emit("error", t);
            });
          }();
        } else {
          if (f._xhr = e, f._pos = 0, f.url = e.responseURL, f.statusCode = e.status, f.statusMessage = e.statusText, e.getAllResponseHeaders().split(/\r?\n/).forEach(function (t) {
            var e = t.match(/^([^:]+):\s*(.*)/);

            if (e) {
              var r = e[1].toLowerCase();
              "set-cookie" === r ? (void 0 === f.headers[r] && (f.headers[r] = []), f.headers[r].push(e[2])) : void 0 !== f.headers[r] ? f.headers[r] += ", " + e[2] : f.headers[r] = e[2], f.rawHeaders.push(e[1], e[2]);
            }
          }), f._charset = "x-user-defined", !o.overrideMimeType) {
            var l = f.rawHeaders["mime-type"];

            if (l) {
              var d = l.match(/;\s*charset=([^;])(;|$)/);
              d && (f._charset = d[1].toLowerCase());
            }

            f._charset || (f._charset = "utf-8");
          }
        }
      };

      s(f, a.Readable), f.prototype._read = function () {
        var t = this._resumeFetch;
        t && (this._resumeFetch = null, t());
      }, f.prototype._onXHRProgress = function () {
        var t = this,
            e = t._xhr,
            r = null;

        switch (t._mode) {
          case "text:vbarray":
            if (e.readyState !== u.DONE) break;

            try {
              r = new i.VBArray(e.responseBody).toArray();
            } catch (t) {}

            if (null !== r) {
              t.push(new n(r));
              break;
            }

          case "text":
            try {
              r = e.responseText;
            } catch (e) {
              t._mode = "text:vbarray";
              break;
            }

            if (r.length > t._pos) {
              var o = r.substr(t._pos);

              if ("x-user-defined" === t._charset) {
                for (var s = new n(o.length), a = 0; a < o.length; a++) {
                  s[a] = 255 & o.charCodeAt(a);
                }

                t.push(s);
              } else t.push(o, t._charset);

              t._pos = r.length;
            }

            break;

          case "arraybuffer":
            if (e.readyState !== u.DONE || !e.response) break;
            r = e.response, t.push(new n(new Uint8Array(r)));
            break;

          case "moz-chunked-arraybuffer":
            if (r = e.response, e.readyState !== u.LOADING || !r) break;
            t.push(new n(new Uint8Array(r)));
            break;

          case "ms-stream":
            if (r = e.response, e.readyState !== u.LOADING) break;
            var f = new i.MSStreamReader();
            f.onprogress = function () {
              f.result.byteLength > t._pos && (t.push(new n(new Uint8Array(f.result.slice(t._pos)))), t._pos = f.result.byteLength);
            }, f.onload = function () {
              t.push(null);
            }, f.readAsArrayBuffer(r);
        }

        t._xhr.readyState === u.DONE && "ms-stream" !== t._mode && t.push(null);
      };
    }).call(this, r(6), r(2).Buffer, r(4));
  }, function (t) {
    t.exports = JSON.parse('{"name":"@walletconnect/web3-provider","version":"1.0.0-beta.47","description":"Web3 Provider for WalletConnect","scripts":{"clean":"rm -rf lib","build":"webpack","test":"mocha --require ./babel-polyfill.js test/**/*.spec.js"},"keywords":["walletconnect","ethereum","web3","crypto","dapp","wallet"],"author":"WalletConnect <walletconnect.org>","homepage":"https://github.com/WalletConnect/walletconnect-monorepo/tree/v1.0.0-beta","license":"LGPL-3.0","main":"lib/index.js","directories":{"lib":"lib","test":"test"},"files":["lib","src"],"repository":{"type":"git","url":"git+https://github.com/walletconnect/walletconnect-monorepo.git"},"bugs":{"url":"https://github.com/walletconnect/walletconnect-monorepo/issues"},"devDependencies":{"@babel/cli":"7.8.3","@babel/core":"7.8.3","@babel/node":"7.8.3","@babel/polyfill":"7.8.3","@babel/preset-env":"7.8.3","@babel/preset-typescript":"7.8.3","@babel/register":"7.8.3","@types/chai":"4.2.7","@types/mocha":"5.2.7","@types/web3-provider-engine":"14.0.0","chai":"4.2.0","isomorphic-fetch":"2.2.1","mocha":"5.2.0","ts-loader":"5.4.5","typescript":"3.7.5","webpack":"4.41.5","webpack-cli":"3.3.10"},"dependencies":{"@walletconnect/browser":"^1.0.0-beta.47","@walletconnect/qrcode-modal":"^1.0.0-beta.47","@walletconnect/types":"^1.0.0-beta.47","web3-provider-engine":"15.0.4","xhr2-cookies":"1.1.0"},"gitHead":"165f7993c2acc907c653c02847fb02721052c6e7"}');
  }, function (t, e, r) {
    t.exports = function (t) {
      var e = {};

      function r(n) {
        if (e[n]) return e[n].exports;
        var i = e[n] = {
          i: n,
          l: !1,
          exports: {}
        };
        return t[n].call(i.exports, i, i.exports, r), i.l = !0, i.exports;
      }

      return r.m = t, r.c = e, r.d = function (t, e, n) {
        r.o(t, e) || Object.defineProperty(t, e, {
          enumerable: !0,
          get: n
        });
      }, r.r = function (t) {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
          value: "Module"
        }), Object.defineProperty(t, "__esModule", {
          value: !0
        });
      }, r.t = function (t, e) {
        if (1 & e && (t = r(t)), 8 & e) return t;
        if (4 & e && "object" == typeof t && t && t.__esModule) return t;
        var n = Object.create(null);
        if (r.r(n), Object.defineProperty(n, "default", {
          enumerable: !0,
          value: t
        }), 2 & e && "string" != typeof t) for (var i in t) {
          r.d(n, i, function (e) {
            return t[e];
          }.bind(null, i));
        }
        return n;
      }, r.n = function (t) {
        var e = t && t.__esModule ? function () {
          return t.default;
        } : function () {
          return t;
        };
        return r.d(e, "a", e), e;
      }, r.o = function (t, e) {
        return Object.prototype.hasOwnProperty.call(t, e);
      }, r.p = "", r(r.s = 2);
    }([function (t, e, r) {
      "use strict";

      r.r(e), r.d(e, "__extends", function () {
        return i;
      }), r.d(e, "__assign", function () {
        return _o2;
      }), r.d(e, "__rest", function () {
        return s;
      }), r.d(e, "__decorate", function () {
        return a;
      }), r.d(e, "__param", function () {
        return u;
      }), r.d(e, "__metadata", function () {
        return f;
      }), r.d(e, "__awaiter", function () {
        return c;
      }), r.d(e, "__generator", function () {
        return h;
      }), r.d(e, "__exportStar", function () {
        return l;
      }), r.d(e, "__values", function () {
        return d;
      }), r.d(e, "__read", function () {
        return p;
      }), r.d(e, "__spread", function () {
        return g;
      }), r.d(e, "__await", function () {
        return m;
      }), r.d(e, "__asyncGenerator", function () {
        return b;
      }), r.d(e, "__asyncDelegator", function () {
        return v;
      }), r.d(e, "__asyncValues", function () {
        return y;
      }), r.d(e, "__makeTemplateObject", function () {
        return _;
      }), r.d(e, "__importStar", function () {
        return w;
      }), r.d(e, "__importDefault", function () {
        return E;
      });
      /*! *****************************************************************************
      Copyright (c) Microsoft Corporation. All rights reserved.
      Licensed under the Apache License, Version 2.0 (the "License"); you may not use
      this file except in compliance with the License. You may obtain a copy of the
      License at http://www.apache.org/licenses/LICENSE-2.0
      
      THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
      KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
      WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
      MERCHANTABLITY OR NON-INFRINGEMENT.
      
      See the Apache Version 2.0 License for specific language governing permissions
      and limitations under the License.
      ***************************************************************************** */

      var _n4 = function n(t, e) {
        return (_n4 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (t, e) {
          t.__proto__ = e;
        } || function (t, e) {
          for (var r in e) {
            e.hasOwnProperty(r) && (t[r] = e[r]);
          }
        })(t, e);
      };

      function i(t, e) {
        function r() {
          this.constructor = t;
        }

        _n4(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
      }

      var _o2 = function o() {
        return (_o2 = Object.assign || function (t) {
          for (var e, r = 1, n = arguments.length; r < n; r++) {
            for (var i in e = arguments[r]) {
              Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
            }
          }

          return t;
        }).apply(this, arguments);
      };

      function s(t, e) {
        var r = {};

        for (var n in t) {
          Object.prototype.hasOwnProperty.call(t, n) && e.indexOf(n) < 0 && (r[n] = t[n]);
        }

        if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
          var i = 0;

          for (n = Object.getOwnPropertySymbols(t); i < n.length; i++) {
            e.indexOf(n[i]) < 0 && (r[n[i]] = t[n[i]]);
          }
        }

        return r;
      }

      function a(t, e, r, n) {
        var i,
            o = arguments.length,
            s = o < 3 ? e : null === n ? n = Object.getOwnPropertyDescriptor(e, r) : n;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) s = Reflect.decorate(t, e, r, n);else for (var a = t.length - 1; a >= 0; a--) {
          (i = t[a]) && (s = (o < 3 ? i(s) : o > 3 ? i(e, r, s) : i(e, r)) || s);
        }
        return o > 3 && s && Object.defineProperty(e, r, s), s;
      }

      function u(t, e) {
        return function (r, n) {
          e(r, n, t);
        };
      }

      function f(t, e) {
        if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(t, e);
      }

      function c(t, e, r, n) {
        return new (r || (r = Promise))(function (i, o) {
          function s(t) {
            try {
              u(n.next(t));
            } catch (t) {
              o(t);
            }
          }

          function a(t) {
            try {
              u(n.throw(t));
            } catch (t) {
              o(t);
            }
          }

          function u(t) {
            t.done ? i(t.value) : new r(function (e) {
              e(t.value);
            }).then(s, a);
          }

          u((n = n.apply(t, e || [])).next());
        });
      }

      function h(t, e) {
        var r,
            n,
            i,
            o,
            s = {
          label: 0,
          sent: function sent() {
            if (1 & i[0]) throw i[1];
            return i[1];
          },
          trys: [],
          ops: []
        };
        return o = {
          next: a(0),
          throw: a(1),
          return: a(2)
        }, "function" == typeof Symbol && (o[Symbol.iterator] = function () {
          return this;
        }), o;

        function a(o) {
          return function (a) {
            return function (o) {
              if (r) throw new TypeError("Generator is already executing.");

              for (; s;) {
                try {
                  if (r = 1, n && (i = 2 & o[0] ? n.return : o[0] ? n.throw || ((i = n.return) && i.call(n), 0) : n.next) && !(i = i.call(n, o[1])).done) return i;

                  switch (n = 0, i && (o = [2 & o[0], i.value]), o[0]) {
                    case 0:
                    case 1:
                      i = o;
                      break;

                    case 4:
                      return s.label++, {
                        value: o[1],
                        done: !1
                      };

                    case 5:
                      s.label++, n = o[1], o = [0];
                      continue;

                    case 7:
                      o = s.ops.pop(), s.trys.pop();
                      continue;

                    default:
                      if (!(i = (i = s.trys).length > 0 && i[i.length - 1]) && (6 === o[0] || 2 === o[0])) {
                        s = 0;
                        continue;
                      }

                      if (3 === o[0] && (!i || o[1] > i[0] && o[1] < i[3])) {
                        s.label = o[1];
                        break;
                      }

                      if (6 === o[0] && s.label < i[1]) {
                        s.label = i[1], i = o;
                        break;
                      }

                      if (i && s.label < i[2]) {
                        s.label = i[2], s.ops.push(o);
                        break;
                      }

                      i[2] && s.ops.pop(), s.trys.pop();
                      continue;
                  }

                  o = e.call(t, s);
                } catch (t) {
                  o = [6, t], n = 0;
                } finally {
                  r = i = 0;
                }
              }

              if (5 & o[0]) throw o[1];
              return {
                value: o[0] ? o[1] : void 0,
                done: !0
              };
            }([o, a]);
          };
        }
      }

      function l(t, e) {
        for (var r in t) {
          e.hasOwnProperty(r) || (e[r] = t[r]);
        }
      }

      function d(t) {
        var e = "function" == typeof Symbol && t[Symbol.iterator],
            r = 0;
        return e ? e.call(t) : {
          next: function next() {
            return t && r >= t.length && (t = void 0), {
              value: t && t[r++],
              done: !t
            };
          }
        };
      }

      function p(t, e) {
        var r = "function" == typeof Symbol && t[Symbol.iterator];
        if (!r) return t;
        var n,
            i,
            o = r.call(t),
            s = [];

        try {
          for (; (void 0 === e || e-- > 0) && !(n = o.next()).done;) {
            s.push(n.value);
          }
        } catch (t) {
          i = {
            error: t
          };
        } finally {
          try {
            n && !n.done && (r = o.return) && r.call(o);
          } finally {
            if (i) throw i.error;
          }
        }

        return s;
      }

      function g() {
        for (var t = [], e = 0; e < arguments.length; e++) {
          t = t.concat(p(arguments[e]));
        }

        return t;
      }

      function m(t) {
        return this instanceof m ? (this.v = t, this) : new m(t);
      }

      function b(t, e, r) {
        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
        var n,
            i = r.apply(t, e || []),
            o = [];
        return n = {}, s("next"), s("throw"), s("return"), n[Symbol.asyncIterator] = function () {
          return this;
        }, n;

        function s(t) {
          i[t] && (n[t] = function (e) {
            return new Promise(function (r, n) {
              o.push([t, e, r, n]) > 1 || a(t, e);
            });
          });
        }

        function a(t, e) {
          try {
            (r = i[t](e)).value instanceof m ? Promise.resolve(r.value.v).then(u, f) : c(o[0][2], r);
          } catch (t) {
            c(o[0][3], t);
          }

          var r;
        }

        function u(t) {
          a("next", t);
        }

        function f(t) {
          a("throw", t);
        }

        function c(t, e) {
          t(e), o.shift(), o.length && a(o[0][0], o[0][1]);
        }
      }

      function v(t) {
        var e, r;
        return e = {}, n("next"), n("throw", function (t) {
          throw t;
        }), n("return"), e[Symbol.iterator] = function () {
          return this;
        }, e;

        function n(n, i) {
          e[n] = t[n] ? function (e) {
            return (r = !r) ? {
              value: m(t[n](e)),
              done: "return" === n
            } : i ? i(e) : e;
          } : i;
        }
      }

      function y(t) {
        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
        var e,
            r = t[Symbol.asyncIterator];
        return r ? r.call(t) : (t = d(t), e = {}, n("next"), n("throw"), n("return"), e[Symbol.asyncIterator] = function () {
          return this;
        }, e);

        function n(r) {
          e[r] = t[r] && function (e) {
            return new Promise(function (n, i) {
              !function (t, e, r, n) {
                Promise.resolve(n).then(function (e) {
                  t({
                    value: e,
                    done: r
                  });
                }, e);
              }(n, i, (e = t[r](e)).done, e.value);
            });
          };
        }
      }

      function _(t, e) {
        return Object.defineProperty ? Object.defineProperty(t, "raw", {
          value: e
        }) : t.raw = e, t;
      }

      function w(t) {
        if (t && t.__esModule) return t;
        var e = {};
        if (null != t) for (var r in t) {
          Object.hasOwnProperty.call(t, r) && (e[r] = t[r]);
        }
        return e.default = t, e;
      }

      function E(t) {
        return t && t.__esModule ? t : {
          default: t
        };
      }
    }, function (t, e, r) {
      t.exports = function (t) {
        var e = {};

        function r(n) {
          if (e[n]) return e[n].exports;
          var i = e[n] = {
            i: n,
            l: !1,
            exports: {}
          };
          return t[n].call(i.exports, i, i.exports, r), i.l = !0, i.exports;
        }

        return r.m = t, r.c = e, r.d = function (t, e, n) {
          r.o(t, e) || Object.defineProperty(t, e, {
            enumerable: !0,
            get: n
          });
        }, r.r = function (t) {
          "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
            value: "Module"
          }), Object.defineProperty(t, "__esModule", {
            value: !0
          });
        }, r.t = function (t, e) {
          if (1 & e && (t = r(t)), 8 & e) return t;
          if (4 & e && "object" == typeof t && t && t.__esModule) return t;
          var n = Object.create(null);
          if (r.r(n), Object.defineProperty(n, "default", {
            enumerable: !0,
            value: t
          }), 2 & e && "string" != typeof t) for (var i in t) {
            r.d(n, i, function (e) {
              return t[e];
            }.bind(null, i));
          }
          return n;
        }, r.n = function (t) {
          var e = t && t.__esModule ? function () {
            return t.default;
          } : function () {
            return t;
          };
          return r.d(e, "a", e), e;
        }, r.o = function (t, e) {
          return Object.prototype.hasOwnProperty.call(t, e);
        }, r.p = "", r(r.s = 6);
      }([function (t, e, r) {
        "use strict";

        r.r(e);
        var n = r(1);
        r.d(e, "isBytesLike", function () {
          return a;
        }), r.d(e, "isBytes", function () {
          return u;
        }), r.d(e, "arrayify", function () {
          return f;
        }), r.d(e, "concat", function () {
          return c;
        }), r.d(e, "stripZeros", function () {
          return h;
        }), r.d(e, "zeroPad", function () {
          return l;
        }), r.d(e, "isHexString", function () {
          return d;
        }), r.d(e, "hexlify", function () {
          return p;
        }), r.d(e, "hexDataLength", function () {
          return g;
        }), r.d(e, "hexDataSlice", function () {
          return m;
        }), r.d(e, "hexConcat", function () {
          return b;
        }), r.d(e, "hexValue", function () {
          return v;
        }), r.d(e, "hexStripZeros", function () {
          return y;
        }), r.d(e, "hexZeroPad", function () {
          return _;
        }), r.d(e, "splitSignature", function () {
          return w;
        }), r.d(e, "joinSignature", function () {
          return E;
        });
        var i = new n.a("bytes/5.0.0-beta.136");

        function o(t) {
          return !!t.toHexString;
        }

        function s(t) {
          return t.slice ? t : (t.slice = function () {
            var e = Array.prototype.slice.call(arguments);
            return s(new Uint8Array(Array.prototype.slice.apply(t, e)));
          }, t);
        }

        function a(t) {
          return d(t) && !(t.length % 2) || u(t);
        }

        function u(t) {
          if (null == t) return !1;
          if (t.constructor === Uint8Array) return !0;
          if ("string" == typeof t) return !1;
          if (null == t.length) return !1;

          for (var _e4 = 0; _e4 < t.length; _e4++) {
            var _r3 = t[_e4];
            if (_r3 < 0 || _r3 >= 256 || _r3 % 1) return !1;
          }

          return !0;
        }

        function f(t, e) {
          if (e || (e = {}), "number" == typeof t) {
            i.checkSafeUint53(t, "invalid arrayify value");
            var _e5 = [];

            for (; t;) {
              _e5.unshift(255 & t), t /= 256;
            }

            return 0 === _e5.length && _e5.push(0), s(new Uint8Array(_e5));
          }

          if (e.allowMissingPrefix && "string" == typeof t && "0x" !== t.substring(0, 2) && (t = "0x" + t), o(t) && (t = t.toHexString()), d(t)) {
            var _r4 = t.substring(2);

            _r4.length % 2 && ("left" === e.hexPad ? _r4 = "0x0" + _r4.substring(2) : "right" === e.hexPad ? _r4 += "0" : i.throwArgumentError("hex data is odd-length", "value", t));
            var _n5 = [];

            for (var _t5 = 0; _t5 < _r4.length; _t5 += 2) {
              _n5.push(parseInt(_r4.substring(_t5, _t5 + 2), 16));
            }

            return s(new Uint8Array(_n5));
          }

          return u(t) ? s(new Uint8Array(t)) : i.throwArgumentError("invalid arrayify value", "value", t);
        }

        function c(t) {
          var e = t.map(function (t) {
            return f(t);
          }),
              r = e.reduce(function (t, e) {
            return t + e.length;
          }, 0),
              n = new Uint8Array(r);
          return e.reduce(function (t, e) {
            return n.set(e, t), t + e.length;
          }, 0), s(n);
        }

        function h(t) {
          var e = f(t);
          if (0 === e.length) return e;
          var r = 0;

          for (; r < e.length && 0 === e[r];) {
            r++;
          }

          return r && (e = e.slice(r)), e;
        }

        function l(t, e) {
          (t = f(t)).length > e && i.throwArgumentError("value out of range", "value", arguments[0]);
          var r = new Uint8Array(e);
          return r.set(t, e - t.length), s(r);
        }

        function d(t, e) {
          return !("string" != typeof t || !t.match(/^0x[0-9A-Fa-f]*$/) || e && t.length !== 2 + 2 * e);
        }

        function p(t, e) {
          if (e || (e = {}), "number" == typeof t) {
            i.checkSafeUint53(t, "invalid hexlify value");
            var _e6 = "";

            for (; t;) {
              _e6 = "0123456789abcdef"[15 & t] + _e6, t = Math.floor(t / 16);
            }

            return _e6.length ? (_e6.length % 2 && (_e6 = "0" + _e6), "0x" + _e6) : "0x00";
          }

          if (e.allowMissingPrefix && "string" == typeof t && "0x" !== t.substring(0, 2) && (t = "0x" + t), o(t)) return t.toHexString();
          if (d(t)) return t.length % 2 && ("left" === e.hexPad ? t = "0x0" + t.substring(2) : "right" === e.hexPad ? t += "0" : i.throwArgumentError("hex data is odd-length", "value", t)), t.toLowerCase();

          if (u(t)) {
            var _e7 = "0x";

            for (var _r5 = 0; _r5 < t.length; _r5++) {
              var _n6 = t[_r5];
              _e7 += "0123456789abcdef"[(240 & _n6) >> 4] + "0123456789abcdef"[15 & _n6];
            }

            return _e7;
          }

          return i.throwArgumentError("invalid hexlify value", "value", t);
        }

        function g(t) {
          if ("string" != typeof t) t = p(t);else if (!d(t) || t.length % 2) return null;
          return (t.length - 2) / 2;
        }

        function m(t, e, r) {
          return "string" != typeof t ? t = p(t) : (!d(t) || t.length % 2) && i.throwArgumentError("invalid hexData", "value", t), e = 2 + 2 * e, null != r ? "0x" + t.substring(e, 2 + 2 * r) : "0x" + t.substring(e);
        }

        function b(t) {
          var e = "0x";
          return t.forEach(function (t) {
            e += p(t).substring(2);
          }), e;
        }

        function v(t) {
          var e = y(p(t, {
            hexPad: "left"
          }));
          return "0x" === e ? "0x0" : e;
        }

        function y(t) {
          "string" != typeof t && (t = p(t)), d(t) || i.throwArgumentError("invalid hex string", "value", t), t = t.substring(2);
          var e = 0;

          for (; e < t.length && "0" === t[e];) {
            e++;
          }

          return "0x" + t.substring(e);
        }

        function _(t, e) {
          for ("string" != typeof t ? t = p(t) : d(t) || i.throwArgumentError("invalid hex string", "value", t), t.length > 2 * e + 2 && i.throwArgumentError("value out of range", "value", arguments[1]); t.length < 2 * e + 2;) {
            t = "0x0" + t.substring(2);
          }

          return t;
        }

        function w(t) {
          var e = {
            r: "0x",
            s: "0x",
            _vs: "0x",
            recoveryParam: 0,
            v: 0
          };

          if (a(t)) {
            var _r6 = f(t);

            65 !== _r6.length && i.throwArgumentError("invalid signature string; must be 65 bytes", "signature", t), e.r = p(_r6.slice(0, 32)), e.s = p(_r6.slice(32, 64)), e.v = _r6[64], e.recoveryParam = 1 - e.v % 2, e.v < 27 && (0 === e.v || 1 === e.v ? e.v += 27 : i.throwArgumentError("signature invalid v byte", "signature", t)), e.recoveryParam && (_r6[32] |= 128), e._vs = p(_r6.slice(32, 64));
          } else {
            if (e.r = t.r, e.s = t.s, e.v = t.v, e.recoveryParam = t.recoveryParam, e._vs = t._vs, null != e._vs) {
              var _r8 = l(f(e._vs), 32);

              e._vs = p(_r8);

              var _n8 = _r8[0] >= 128 ? 1 : 0;

              null == e.recoveryParam ? e.recoveryParam = _n8 : e.recoveryParam !== _n8 && i.throwArgumentError("signature recoveryParam mismatch _vs", "signature", t), _r8[0] &= 127;

              var _o3 = p(_r8);

              null == e.s ? e.s = _o3 : e.s !== _o3 && i.throwArgumentError("signature v mismatch _vs", "signature", t);
            }

            null == e.recoveryParam ? null == e.v ? i.throwArgumentError("signature missing v and recoveryParam", "signature", t) : e.recoveryParam = 1 - e.v % 2 : null == e.v ? e.v = 27 + e.recoveryParam : e.recoveryParam !== 1 - e.v % 2 && i.throwArgumentError("signature recoveryParam mismatch v", "signature", t), null != e.r && d(e.r) ? e.r = _(e.r, 32) : i.throwArgumentError("signature missing or invalid r", "signature", t), null != e.s && d(e.s) ? e.s = _(e.s, 32) : i.throwArgumentError("signature missing or invalid s", "signature", t);

            var _r7 = f(e.s);

            _r7[0] >= 128 && i.throwArgumentError("signature s out of range", "signature", t), e.recoveryParam && (_r7[0] |= 128);

            var _n7 = p(_r7);

            e._vs && (d(e._vs) || i.throwArgumentError("signature invalid _vs", "signature", t), e._vs = _(e._vs, 32)), null == e._vs ? e._vs = _n7 : e._vs !== _n7 && i.throwArgumentError("signature _vs mismatch v and s", "signature", t);
          }

          return e;
        }

        function E(t) {
          return p(c([(t = w(t)).r, t.s, t.recoveryParam ? "0x1c" : "0x1b"]));
        }
      }, function (t, e, r) {
        "use strict";

        r.d(e, "a", function () {
          return f;
        });
        var n = !1,
            i = !1;
        var o = {
          debug: 1,
          default: 2,
          info: 2,
          warn: 3,
          error: 4,
          off: 5
        };
        var s = o.default,
            a = null;

        var u = function () {
          try {
            var _t6 = [];
            if (["NFD", "NFC", "NFKD", "NFKC"].forEach(function (e) {
              try {
                if ("test" !== "test".normalize(e)) throw new Error("bad normalize");
              } catch (r) {
                _t6.push(e);
              }
            }), _t6.length) throw new Error("missing " + _t6.join(", "));
            if (String.fromCharCode(233).normalize("NFD") !== String.fromCharCode(101, 769)) throw new Error("broken implementation");
          } catch (t) {
            return t.message;
          }

          return null;
        }();

        var f =
        /*#__PURE__*/
        function () {
          function f(t) {
            _classCallCheck(this, f);

            Object.defineProperty(this, "version", {
              enumerable: !0,
              value: t,
              writable: !1
            });
          }

          _createClass(f, [{
            key: "setLogLevel",
            value: function setLogLevel(t) {
              var e = o[t];
              null != e ? s = e : this.warn("invalid log level - " + t);
            }
          }, {
            key: "_log",
            value: function _log(t, e) {
              s > o[t] || console.log.apply(console, e);
            }
          }, {
            key: "debug",
            value: function debug() {
              for (var _len3 = arguments.length, t = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
                t[_key3] = arguments[_key3];
              }

              this._log(f.levels.DEBUG, t);
            }
          }, {
            key: "info",
            value: function info() {
              for (var _len4 = arguments.length, t = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
                t[_key4] = arguments[_key4];
              }

              this._log(f.levels.INFO, t);
            }
          }, {
            key: "warn",
            value: function warn() {
              for (var _len5 = arguments.length, t = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
                t[_key5] = arguments[_key5];
              }

              this._log(f.levels.WARNING, t);
            }
          }, {
            key: "makeError",
            value: function makeError(t, e, r) {
              if (i) return new Error("unknown error");
              e || (e = f.errors.UNKNOWN_ERROR), r || (r = {});
              var n = [];
              Object.keys(r).forEach(function (t) {
                try {
                  n.push(t + "=" + JSON.stringify(r[t]));
                } catch (e) {
                  n.push(t + "=" + JSON.stringify(r[t].toString()));
                }
              }), n.push("code=".concat(e)), n.push("version=".concat(this.version));
              var o = t;
              n.length && (t += " (" + n.join(", ") + ")");
              var s = new Error(t);
              return s.reason = o, s.code = e, Object.keys(r).forEach(function (t) {
                s[t] = r[t];
              }), s;
            }
          }, {
            key: "throwError",
            value: function throwError(t, e, r) {
              throw this.makeError(t, e, r);
            }
          }, {
            key: "throwArgumentError",
            value: function throwArgumentError(t, e, r) {
              return this.throwError(t, f.errors.INVALID_ARGUMENT, {
                argument: e,
                value: r
              });
            }
          }, {
            key: "checkNormalize",
            value: function checkNormalize(t) {
              null == t && (t = "platform missing String.prototype.normalize"), u && this.throwError("platform missing String.prototype.normalize", f.errors.UNSUPPORTED_OPERATION, {
                operation: "String.prototype.normalize",
                form: u
              });
            }
          }, {
            key: "checkSafeUint53",
            value: function checkSafeUint53(t, e) {
              "number" == typeof t && (null == e && (e = "value not safe"), (t < 0 || t >= 9007199254740991) && this.throwError(e, f.errors.NUMERIC_FAULT, {
                operation: "checkSafeInteger",
                fault: "out-of-safe-range",
                value: t
              }), t % 1 && this.throwError(e, f.errors.NUMERIC_FAULT, {
                operation: "checkSafeInteger",
                fault: "non-integer",
                value: t
              }));
            }
          }, {
            key: "checkArgumentCount",
            value: function checkArgumentCount(t, e, r) {
              r = r ? ": " + r : "", t < e && this.throwError("missing argument" + r, f.errors.MISSING_ARGUMENT, {
                count: t,
                expectedCount: e
              }), t > e && this.throwError("too many arguments" + r, f.errors.UNEXPECTED_ARGUMENT, {
                count: t,
                expectedCount: e
              });
            }
          }, {
            key: "checkNew",
            value: function checkNew(t, e) {
              t !== Object && null != t || this.throwError("missing new", f.errors.MISSING_NEW, {
                name: e.name
              });
            }
          }, {
            key: "checkAbstract",
            value: function checkAbstract(t, e) {
              t === e ? this.throwError("cannot instantiate abstract class " + JSON.stringify(e.name) + " directly; use a sub-class", f.errors.UNSUPPORTED_OPERATION, {
                name: t.name,
                operation: "new"
              }) : t !== Object && null != t || this.throwError("missing new", f.errors.MISSING_NEW, {
                name: e.name
              });
            }
          }], [{
            key: "globalLogger",
            value: function globalLogger() {
              return a || (a = new f("logger/5.0.0-beta.134")), a;
            }
          }, {
            key: "setCensorship",
            value: function setCensorship(t, e) {
              if (n) {
                if (!t) return;
                this.globalLogger().throwError("error censorship permanent", f.errors.UNSUPPORTED_OPERATION, {
                  operation: "setCensorship"
                });
              }

              i = !!t, n = !!e;
            }
          }]);

          return f;
        }();

        f.errors = {
          UNKNOWN_ERROR: "UNKNOWN_ERROR",
          NOT_IMPLEMENTED: "NOT_IMPLEMENTED",
          UNSUPPORTED_OPERATION: "UNSUPPORTED_OPERATION",
          NETWORK_ERROR: "NETWORK_ERROR",
          SERVER_ERROR: "SERVER_ERROR",
          TIMEOUT: "TIMEOUT",
          BUFFER_OVERRUN: "BUFFER_OVERRUN",
          NUMERIC_FAULT: "NUMERIC_FAULT",
          MISSING_NEW: "MISSING_NEW",
          INVALID_ARGUMENT: "INVALID_ARGUMENT",
          MISSING_ARGUMENT: "MISSING_ARGUMENT",
          UNEXPECTED_ARGUMENT: "UNEXPECTED_ARGUMENT",
          CALL_EXCEPTION: "CALL_EXCEPTION",
          INSUFFICIENT_FUNDS: "INSUFFICIENT_FUNDS",
          NONCE_EXPIRED: "NONCE_EXPIRED",
          REPLACEMENT_UNDERPRICED: "REPLACEMENT_UNDERPRICED",
          UNPREDICTABLE_GAS_LIMIT: "UNPREDICTABLE_GAS_LIMIT"
        }, f.levels = {
          DEBUG: "DEBUG",
          INFO: "INFO",
          WARNING: "WARNING",
          ERROR: "ERROR",
          OFF: "OFF"
        };
      }, function (t, e, r) {
        "use strict";

        var n = r(3),
            i = r(0),
            o = r(1);
        var s = "bignumber/5.0.0-beta.135",
            a = new o.a(s),
            u = {};

        var f =
        /*#__PURE__*/
        function () {
          function f(t, e) {
            _classCallCheck(this, f);

            a.checkNew(this instanceof f ? this.constructor : void 0, f), t !== u && a.throwError("cannot call consturtor directly; use BigNumber.from", o.a.errors.UNSUPPORTED_OPERATION, {
              operation: "new (BigNumber)"
            }), this._hex = e, this._isBigNumber = !0, Object.freeze(this);
          }

          _createClass(f, [{
            key: "fromTwos",
            value: function fromTwos(t) {
              return h(l(this).fromTwos(t));
            }
          }, {
            key: "toTwos",
            value: function toTwos(t) {
              return h(l(this).toTwos(t));
            }
          }, {
            key: "abs",
            value: function abs() {
              return "-" === this._hex[0] ? f.from(this._hex.substring(1)) : this;
            }
          }, {
            key: "add",
            value: function add(t) {
              return h(l(this).add(l(t)));
            }
          }, {
            key: "sub",
            value: function sub(t) {
              return h(l(this).sub(l(t)));
            }
          }, {
            key: "div",
            value: function div(t) {
              return f.from(t).isZero() && d("division by zero", "div"), h(l(this).div(l(t)));
            }
          }, {
            key: "mul",
            value: function mul(t) {
              return h(l(this).mul(l(t)));
            }
          }, {
            key: "mod",
            value: function mod(t) {
              return h(l(this).mod(l(t)));
            }
          }, {
            key: "pow",
            value: function pow(t) {
              return h(l(this).pow(l(t)));
            }
          }, {
            key: "maskn",
            value: function maskn(t) {
              return h(l(this).maskn(t));
            }
          }, {
            key: "eq",
            value: function eq(t) {
              return l(this).eq(l(t));
            }
          }, {
            key: "lt",
            value: function lt(t) {
              return l(this).lt(l(t));
            }
          }, {
            key: "lte",
            value: function lte(t) {
              return l(this).lte(l(t));
            }
          }, {
            key: "gt",
            value: function gt(t) {
              return l(this).gt(l(t));
            }
          }, {
            key: "gte",
            value: function gte(t) {
              return l(this).gte(l(t));
            }
          }, {
            key: "isZero",
            value: function isZero() {
              return l(this).isZero();
            }
          }, {
            key: "toNumber",
            value: function toNumber() {
              try {
                return l(this).toNumber();
              } catch (t) {
                d("overflow", "toNumber", this.toString());
              }

              return null;
            }
          }, {
            key: "toString",
            value: function toString() {
              return 0 !== arguments.length && a.throwError("bigNumber.toString does not accept parameters", o.a.errors.UNEXPECTED_ARGUMENT, {}), l(this).toString(10);
            }
          }, {
            key: "toHexString",
            value: function toHexString() {
              return this._hex;
            }
          }], [{
            key: "from",
            value: function from(t) {
              return t instanceof f ? t : "string" == typeof t ? t.match(/-?0x[0-9a-f]+/i) ? new f(u, c(t)) : t.match(/^-?[0-9]+$/) ? new f(u, c(new n.BN(t))) : a.throwArgumentError("invalid BigNumber string", "value", t) : "number" == typeof t ? (t % 1 && d("underflow", "BigNumber.from", t), (t >= 9007199254740991 || t <= -9007199254740991) && d("overflow", "BigNumber.from", t), f.from(String(t))) : "bigint" == typeof t ? f.from(t.toString()) : Object(i.isBytes)(t) ? f.from(Object(i.hexlify)(t)) : t._hex && Object(i.isHexString)(t._hex) ? f.from(t._hex) : t.toHexString && "string" == typeof (t = t.toHexString()) ? f.from(t) : a.throwArgumentError("invalid BigNumber value", "value", t);
            }
          }, {
            key: "isBigNumber",
            value: function isBigNumber(t) {
              return !(!t || !t._isBigNumber);
            }
          }]);

          return f;
        }();

        function c(t) {
          if ("string" != typeof t) return c(t.toString(16));
          if ("-" === t[0]) return "-" === (t = t.substring(1))[0] && a.throwArgumentError("invalid hex", "value", t), "0x00" === (t = c(t)) ? t : "-" + t;
          if ("0x" !== t.substring(0, 2) && (t = "0x" + t), "0x" === t) return "0x00";

          for (t.length % 2 && (t = "0x0" + t.substring(2)); t.length > 4 && "0x00" === t.substring(0, 4);) {
            t = "0x" + t.substring(4);
          }

          return t;
        }

        function h(t) {
          return f.from(c(t));
        }

        function l(t) {
          var e = f.from(t).toHexString();
          return "-" === e[0] ? new n.BN("-" + e.substring(3), 16) : new n.BN(e.substring(2), 16);
        }

        function d(t, e, r) {
          var n = {
            fault: t,
            operation: e
          };
          return null != r && (n.value = r), a.throwError(t, o.a.errors.NUMERIC_FAULT, n);
        }

        new o.a(s), f.from(0), f.from(-1);
        var p = "0";

        for (; p.length < 256;) {
          p += p;
        }

        r.d(e, "a", function () {
          return f;
        });
      }, function (t, e, r) {
        (function (t) {
          !function (t, e) {
            "use strict";

            function n(t, e) {
              if (!t) throw new Error(e || "Assertion failed");
            }

            function i(t, e) {
              t.super_ = e;

              var r = function r() {};

              r.prototype = e.prototype, t.prototype = new r(), t.prototype.constructor = t;
            }

            function o(t, e, r) {
              if (o.isBN(t)) return t;
              this.negative = 0, this.words = null, this.length = 0, this.red = null, null !== t && ("le" !== e && "be" !== e || (r = e, e = 10), this._init(t || 0, e || 10, r || "be"));
            }

            var s;
            "object" == typeof t ? t.exports = o : e.BN = o, o.BN = o, o.wordSize = 26;

            try {
              s = r(14).Buffer;
            } catch (t) {}

            function a(t, e, r) {
              for (var n = 0, i = Math.min(t.length, r), o = e; o < i; o++) {
                var s = t.charCodeAt(o) - 48;
                n <<= 4, n |= s >= 49 && s <= 54 ? s - 49 + 10 : s >= 17 && s <= 22 ? s - 17 + 10 : 15 & s;
              }

              return n;
            }

            function u(t, e, r, n) {
              for (var i = 0, o = Math.min(t.length, r), s = e; s < o; s++) {
                var a = t.charCodeAt(s) - 48;
                i *= n, i += a >= 49 ? a - 49 + 10 : a >= 17 ? a - 17 + 10 : a;
              }

              return i;
            }

            o.isBN = function (t) {
              return t instanceof o || null !== t && "object" == typeof t && t.constructor.wordSize === o.wordSize && Array.isArray(t.words);
            }, o.max = function (t, e) {
              return t.cmp(e) > 0 ? t : e;
            }, o.min = function (t, e) {
              return t.cmp(e) < 0 ? t : e;
            }, o.prototype._init = function (t, e, r) {
              if ("number" == typeof t) return this._initNumber(t, e, r);
              if ("object" == typeof t) return this._initArray(t, e, r);
              "hex" === e && (e = 16), n(e === (0 | e) && e >= 2 && e <= 36);
              var i = 0;
              "-" === (t = t.toString().replace(/\s+/g, ""))[0] && i++, 16 === e ? this._parseHex(t, i) : this._parseBase(t, e, i), "-" === t[0] && (this.negative = 1), this.strip(), "le" === r && this._initArray(this.toArray(), e, r);
            }, o.prototype._initNumber = function (t, e, r) {
              t < 0 && (this.negative = 1, t = -t), t < 67108864 ? (this.words = [67108863 & t], this.length = 1) : t < 4503599627370496 ? (this.words = [67108863 & t, t / 67108864 & 67108863], this.length = 2) : (n(t < 9007199254740992), this.words = [67108863 & t, t / 67108864 & 67108863, 1], this.length = 3), "le" === r && this._initArray(this.toArray(), e, r);
            }, o.prototype._initArray = function (t, e, r) {
              if (n("number" == typeof t.length), t.length <= 0) return this.words = [0], this.length = 1, this;
              this.length = Math.ceil(t.length / 3), this.words = new Array(this.length);

              for (var i = 0; i < this.length; i++) {
                this.words[i] = 0;
              }

              var o,
                  s,
                  a = 0;
              if ("be" === r) for (i = t.length - 1, o = 0; i >= 0; i -= 3) {
                s = t[i] | t[i - 1] << 8 | t[i - 2] << 16, this.words[o] |= s << a & 67108863, this.words[o + 1] = s >>> 26 - a & 67108863, (a += 24) >= 26 && (a -= 26, o++);
              } else if ("le" === r) for (i = 0, o = 0; i < t.length; i += 3) {
                s = t[i] | t[i + 1] << 8 | t[i + 2] << 16, this.words[o] |= s << a & 67108863, this.words[o + 1] = s >>> 26 - a & 67108863, (a += 24) >= 26 && (a -= 26, o++);
              }
              return this.strip();
            }, o.prototype._parseHex = function (t, e) {
              this.length = Math.ceil((t.length - e) / 6), this.words = new Array(this.length);

              for (var r = 0; r < this.length; r++) {
                this.words[r] = 0;
              }

              var n,
                  i,
                  o = 0;

              for (r = t.length - 6, n = 0; r >= e; r -= 6) {
                i = a(t, r, r + 6), this.words[n] |= i << o & 67108863, this.words[n + 1] |= i >>> 26 - o & 4194303, (o += 24) >= 26 && (o -= 26, n++);
              }

              r + 6 !== e && (i = a(t, e, r + 6), this.words[n] |= i << o & 67108863, this.words[n + 1] |= i >>> 26 - o & 4194303), this.strip();
            }, o.prototype._parseBase = function (t, e, r) {
              this.words = [0], this.length = 1;

              for (var n = 0, i = 1; i <= 67108863; i *= e) {
                n++;
              }

              n--, i = i / e | 0;

              for (var o = t.length - r, s = o % n, a = Math.min(o, o - s) + r, f = 0, c = r; c < a; c += n) {
                f = u(t, c, c + n, e), this.imuln(i), this.words[0] + f < 67108864 ? this.words[0] += f : this._iaddn(f);
              }

              if (0 !== s) {
                var h = 1;

                for (f = u(t, c, t.length, e), c = 0; c < s; c++) {
                  h *= e;
                }

                this.imuln(h), this.words[0] + f < 67108864 ? this.words[0] += f : this._iaddn(f);
              }
            }, o.prototype.copy = function (t) {
              t.words = new Array(this.length);

              for (var e = 0; e < this.length; e++) {
                t.words[e] = this.words[e];
              }

              t.length = this.length, t.negative = this.negative, t.red = this.red;
            }, o.prototype.clone = function () {
              var t = new o(null);
              return this.copy(t), t;
            }, o.prototype._expand = function (t) {
              for (; this.length < t;) {
                this.words[this.length++] = 0;
              }

              return this;
            }, o.prototype.strip = function () {
              for (; this.length > 1 && 0 === this.words[this.length - 1];) {
                this.length--;
              }

              return this._normSign();
            }, o.prototype._normSign = function () {
              return 1 === this.length && 0 === this.words[0] && (this.negative = 0), this;
            }, o.prototype.inspect = function () {
              return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
            };
            var f = ["", "0", "00", "000", "0000", "00000", "000000", "0000000", "00000000", "000000000", "0000000000", "00000000000", "000000000000", "0000000000000", "00000000000000", "000000000000000", "0000000000000000", "00000000000000000", "000000000000000000", "0000000000000000000", "00000000000000000000", "000000000000000000000", "0000000000000000000000", "00000000000000000000000", "000000000000000000000000", "0000000000000000000000000"],
                c = [0, 0, 25, 16, 12, 11, 10, 9, 8, 8, 7, 7, 7, 7, 6, 6, 6, 6, 6, 6, 6, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5],
                h = [0, 0, 33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216, 43046721, 1e7, 19487171, 35831808, 62748517, 7529536, 11390625, 16777216, 24137569, 34012224, 47045881, 64e6, 4084101, 5153632, 6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149, 243e5, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176];

            function l(t, e, r) {
              r.negative = e.negative ^ t.negative;
              var n = t.length + e.length | 0;
              r.length = n, n = n - 1 | 0;
              var i = 0 | t.words[0],
                  o = 0 | e.words[0],
                  s = i * o,
                  a = 67108863 & s,
                  u = s / 67108864 | 0;
              r.words[0] = a;

              for (var f = 1; f < n; f++) {
                for (var c = u >>> 26, h = 67108863 & u, l = Math.min(f, e.length - 1), d = Math.max(0, f - t.length + 1); d <= l; d++) {
                  var p = f - d | 0;
                  c += (s = (i = 0 | t.words[p]) * (o = 0 | e.words[d]) + h) / 67108864 | 0, h = 67108863 & s;
                }

                r.words[f] = 0 | h, u = 0 | c;
              }

              return 0 !== u ? r.words[f] = 0 | u : r.length--, r.strip();
            }

            o.prototype.toString = function (t, e) {
              var r;

              if (e = 0 | e || 1, 16 === (t = t || 10) || "hex" === t) {
                r = "";

                for (var i = 0, o = 0, s = 0; s < this.length; s++) {
                  var a = this.words[s],
                      u = (16777215 & (a << i | o)).toString(16);
                  r = 0 != (o = a >>> 24 - i & 16777215) || s !== this.length - 1 ? f[6 - u.length] + u + r : u + r, (i += 2) >= 26 && (i -= 26, s--);
                }

                for (0 !== o && (r = o.toString(16) + r); r.length % e != 0;) {
                  r = "0" + r;
                }

                return 0 !== this.negative && (r = "-" + r), r;
              }

              if (t === (0 | t) && t >= 2 && t <= 36) {
                var l = c[t],
                    d = h[t];
                r = "";
                var p = this.clone();

                for (p.negative = 0; !p.isZero();) {
                  var g = p.modn(d).toString(t);
                  r = (p = p.idivn(d)).isZero() ? g + r : f[l - g.length] + g + r;
                }

                for (this.isZero() && (r = "0" + r); r.length % e != 0;) {
                  r = "0" + r;
                }

                return 0 !== this.negative && (r = "-" + r), r;
              }

              n(!1, "Base should be between 2 and 36");
            }, o.prototype.toNumber = function () {
              var t = this.words[0];
              return 2 === this.length ? t += 67108864 * this.words[1] : 3 === this.length && 1 === this.words[2] ? t += 4503599627370496 + 67108864 * this.words[1] : this.length > 2 && n(!1, "Number can only safely store up to 53 bits"), 0 !== this.negative ? -t : t;
            }, o.prototype.toJSON = function () {
              return this.toString(16);
            }, o.prototype.toBuffer = function (t, e) {
              return n(void 0 !== s), this.toArrayLike(s, t, e);
            }, o.prototype.toArray = function (t, e) {
              return this.toArrayLike(Array, t, e);
            }, o.prototype.toArrayLike = function (t, e, r) {
              var i = this.byteLength(),
                  o = r || Math.max(1, i);
              n(i <= o, "byte array longer than desired length"), n(o > 0, "Requested array length <= 0"), this.strip();
              var s,
                  a,
                  u = "le" === e,
                  f = new t(o),
                  c = this.clone();

              if (u) {
                for (a = 0; !c.isZero(); a++) {
                  s = c.andln(255), c.iushrn(8), f[a] = s;
                }

                for (; a < o; a++) {
                  f[a] = 0;
                }
              } else {
                for (a = 0; a < o - i; a++) {
                  f[a] = 0;
                }

                for (a = 0; !c.isZero(); a++) {
                  s = c.andln(255), c.iushrn(8), f[o - a - 1] = s;
                }
              }

              return f;
            }, Math.clz32 ? o.prototype._countBits = function (t) {
              return 32 - Math.clz32(t);
            } : o.prototype._countBits = function (t) {
              var e = t,
                  r = 0;
              return e >= 4096 && (r += 13, e >>>= 13), e >= 64 && (r += 7, e >>>= 7), e >= 8 && (r += 4, e >>>= 4), e >= 2 && (r += 2, e >>>= 2), r + e;
            }, o.prototype._zeroBits = function (t) {
              if (0 === t) return 26;
              var e = t,
                  r = 0;
              return 0 == (8191 & e) && (r += 13, e >>>= 13), 0 == (127 & e) && (r += 7, e >>>= 7), 0 == (15 & e) && (r += 4, e >>>= 4), 0 == (3 & e) && (r += 2, e >>>= 2), 0 == (1 & e) && r++, r;
            }, o.prototype.bitLength = function () {
              var t = this.words[this.length - 1],
                  e = this._countBits(t);

              return 26 * (this.length - 1) + e;
            }, o.prototype.zeroBits = function () {
              if (this.isZero()) return 0;

              for (var t = 0, e = 0; e < this.length; e++) {
                var r = this._zeroBits(this.words[e]);

                if (t += r, 26 !== r) break;
              }

              return t;
            }, o.prototype.byteLength = function () {
              return Math.ceil(this.bitLength() / 8);
            }, o.prototype.toTwos = function (t) {
              return 0 !== this.negative ? this.abs().inotn(t).iaddn(1) : this.clone();
            }, o.prototype.fromTwos = function (t) {
              return this.testn(t - 1) ? this.notn(t).iaddn(1).ineg() : this.clone();
            }, o.prototype.isNeg = function () {
              return 0 !== this.negative;
            }, o.prototype.neg = function () {
              return this.clone().ineg();
            }, o.prototype.ineg = function () {
              return this.isZero() || (this.negative ^= 1), this;
            }, o.prototype.iuor = function (t) {
              for (; this.length < t.length;) {
                this.words[this.length++] = 0;
              }

              for (var e = 0; e < t.length; e++) {
                this.words[e] = this.words[e] | t.words[e];
              }

              return this.strip();
            }, o.prototype.ior = function (t) {
              return n(0 == (this.negative | t.negative)), this.iuor(t);
            }, o.prototype.or = function (t) {
              return this.length > t.length ? this.clone().ior(t) : t.clone().ior(this);
            }, o.prototype.uor = function (t) {
              return this.length > t.length ? this.clone().iuor(t) : t.clone().iuor(this);
            }, o.prototype.iuand = function (t) {
              var e;
              e = this.length > t.length ? t : this;

              for (var r = 0; r < e.length; r++) {
                this.words[r] = this.words[r] & t.words[r];
              }

              return this.length = e.length, this.strip();
            }, o.prototype.iand = function (t) {
              return n(0 == (this.negative | t.negative)), this.iuand(t);
            }, o.prototype.and = function (t) {
              return this.length > t.length ? this.clone().iand(t) : t.clone().iand(this);
            }, o.prototype.uand = function (t) {
              return this.length > t.length ? this.clone().iuand(t) : t.clone().iuand(this);
            }, o.prototype.iuxor = function (t) {
              var e, r;
              this.length > t.length ? (e = this, r = t) : (e = t, r = this);

              for (var n = 0; n < r.length; n++) {
                this.words[n] = e.words[n] ^ r.words[n];
              }

              if (this !== e) for (; n < e.length; n++) {
                this.words[n] = e.words[n];
              }
              return this.length = e.length, this.strip();
            }, o.prototype.ixor = function (t) {
              return n(0 == (this.negative | t.negative)), this.iuxor(t);
            }, o.prototype.xor = function (t) {
              return this.length > t.length ? this.clone().ixor(t) : t.clone().ixor(this);
            }, o.prototype.uxor = function (t) {
              return this.length > t.length ? this.clone().iuxor(t) : t.clone().iuxor(this);
            }, o.prototype.inotn = function (t) {
              n("number" == typeof t && t >= 0);
              var e = 0 | Math.ceil(t / 26),
                  r = t % 26;
              this._expand(e), r > 0 && e--;

              for (var i = 0; i < e; i++) {
                this.words[i] = 67108863 & ~this.words[i];
              }

              return r > 0 && (this.words[i] = ~this.words[i] & 67108863 >> 26 - r), this.strip();
            }, o.prototype.notn = function (t) {
              return this.clone().inotn(t);
            }, o.prototype.setn = function (t, e) {
              n("number" == typeof t && t >= 0);
              var r = t / 26 | 0,
                  i = t % 26;
              return this._expand(r + 1), this.words[r] = e ? this.words[r] | 1 << i : this.words[r] & ~(1 << i), this.strip();
            }, o.prototype.iadd = function (t) {
              var e, r, n;
              if (0 !== this.negative && 0 === t.negative) return this.negative = 0, e = this.isub(t), this.negative ^= 1, this._normSign();
              if (0 === this.negative && 0 !== t.negative) return t.negative = 0, e = this.isub(t), t.negative = 1, e._normSign();
              this.length > t.length ? (r = this, n = t) : (r = t, n = this);

              for (var i = 0, o = 0; o < n.length; o++) {
                e = (0 | r.words[o]) + (0 | n.words[o]) + i, this.words[o] = 67108863 & e, i = e >>> 26;
              }

              for (; 0 !== i && o < r.length; o++) {
                e = (0 | r.words[o]) + i, this.words[o] = 67108863 & e, i = e >>> 26;
              }

              if (this.length = r.length, 0 !== i) this.words[this.length] = i, this.length++;else if (r !== this) for (; o < r.length; o++) {
                this.words[o] = r.words[o];
              }
              return this;
            }, o.prototype.add = function (t) {
              var e;
              return 0 !== t.negative && 0 === this.negative ? (t.negative = 0, e = this.sub(t), t.negative ^= 1, e) : 0 === t.negative && 0 !== this.negative ? (this.negative = 0, e = t.sub(this), this.negative = 1, e) : this.length > t.length ? this.clone().iadd(t) : t.clone().iadd(this);
            }, o.prototype.isub = function (t) {
              if (0 !== t.negative) {
                t.negative = 0;
                var e = this.iadd(t);
                return t.negative = 1, e._normSign();
              }

              if (0 !== this.negative) return this.negative = 0, this.iadd(t), this.negative = 1, this._normSign();
              var r,
                  n,
                  i = this.cmp(t);
              if (0 === i) return this.negative = 0, this.length = 1, this.words[0] = 0, this;
              i > 0 ? (r = this, n = t) : (r = t, n = this);

              for (var o = 0, s = 0; s < n.length; s++) {
                o = (e = (0 | r.words[s]) - (0 | n.words[s]) + o) >> 26, this.words[s] = 67108863 & e;
              }

              for (; 0 !== o && s < r.length; s++) {
                o = (e = (0 | r.words[s]) + o) >> 26, this.words[s] = 67108863 & e;
              }

              if (0 === o && s < r.length && r !== this) for (; s < r.length; s++) {
                this.words[s] = r.words[s];
              }
              return this.length = Math.max(this.length, s), r !== this && (this.negative = 1), this.strip();
            }, o.prototype.sub = function (t) {
              return this.clone().isub(t);
            };

            var d = function d(t, e, r) {
              var n,
                  i,
                  o,
                  s = t.words,
                  a = e.words,
                  u = r.words,
                  f = 0,
                  c = 0 | s[0],
                  h = 8191 & c,
                  l = c >>> 13,
                  d = 0 | s[1],
                  p = 8191 & d,
                  g = d >>> 13,
                  m = 0 | s[2],
                  b = 8191 & m,
                  v = m >>> 13,
                  y = 0 | s[3],
                  _ = 8191 & y,
                  w = y >>> 13,
                  E = 0 | s[4],
                  M = 8191 & E,
                  S = E >>> 13,
                  A = 0 | s[5],
                  x = 8191 & A,
                  R = A >>> 13,
                  T = 0 | s[6],
                  k = 8191 & T,
                  I = T >>> 13,
                  B = 0 | s[7],
                  O = 8191 & B,
                  P = B >>> 13,
                  N = 0 | s[8],
                  C = 8191 & N,
                  L = N >>> 13,
                  j = 0 | s[9],
                  U = 8191 & j,
                  D = j >>> 13,
                  F = 0 | a[0],
                  z = 8191 & F,
                  q = F >>> 13,
                  H = 0 | a[1],
                  Y = 8191 & H,
                  G = H >>> 13,
                  K = 0 | a[2],
                  Z = 8191 & K,
                  V = K >>> 13,
                  W = 0 | a[3],
                  J = 8191 & W,
                  X = W >>> 13,
                  $ = 0 | a[4],
                  Q = 8191 & $,
                  tt = $ >>> 13,
                  et = 0 | a[5],
                  rt = 8191 & et,
                  nt = et >>> 13,
                  it = 0 | a[6],
                  ot = 8191 & it,
                  st = it >>> 13,
                  at = 0 | a[7],
                  ut = 8191 & at,
                  ft = at >>> 13,
                  ct = 0 | a[8],
                  ht = 8191 & ct,
                  lt = ct >>> 13,
                  dt = 0 | a[9],
                  pt = 8191 & dt,
                  gt = dt >>> 13;

              r.negative = t.negative ^ e.negative, r.length = 19;
              var mt = (f + (n = Math.imul(h, z)) | 0) + ((8191 & (i = (i = Math.imul(h, q)) + Math.imul(l, z) | 0)) << 13) | 0;
              f = ((o = Math.imul(l, q)) + (i >>> 13) | 0) + (mt >>> 26) | 0, mt &= 67108863, n = Math.imul(p, z), i = (i = Math.imul(p, q)) + Math.imul(g, z) | 0, o = Math.imul(g, q);
              var bt = (f + (n = n + Math.imul(h, Y) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, G) | 0) + Math.imul(l, Y) | 0)) << 13) | 0;
              f = ((o = o + Math.imul(l, G) | 0) + (i >>> 13) | 0) + (bt >>> 26) | 0, bt &= 67108863, n = Math.imul(b, z), i = (i = Math.imul(b, q)) + Math.imul(v, z) | 0, o = Math.imul(v, q), n = n + Math.imul(p, Y) | 0, i = (i = i + Math.imul(p, G) | 0) + Math.imul(g, Y) | 0, o = o + Math.imul(g, G) | 0;
              var vt = (f + (n = n + Math.imul(h, Z) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, V) | 0) + Math.imul(l, Z) | 0)) << 13) | 0;
              f = ((o = o + Math.imul(l, V) | 0) + (i >>> 13) | 0) + (vt >>> 26) | 0, vt &= 67108863, n = Math.imul(_, z), i = (i = Math.imul(_, q)) + Math.imul(w, z) | 0, o = Math.imul(w, q), n = n + Math.imul(b, Y) | 0, i = (i = i + Math.imul(b, G) | 0) + Math.imul(v, Y) | 0, o = o + Math.imul(v, G) | 0, n = n + Math.imul(p, Z) | 0, i = (i = i + Math.imul(p, V) | 0) + Math.imul(g, Z) | 0, o = o + Math.imul(g, V) | 0;
              var yt = (f + (n = n + Math.imul(h, J) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, X) | 0) + Math.imul(l, J) | 0)) << 13) | 0;
              f = ((o = o + Math.imul(l, X) | 0) + (i >>> 13) | 0) + (yt >>> 26) | 0, yt &= 67108863, n = Math.imul(M, z), i = (i = Math.imul(M, q)) + Math.imul(S, z) | 0, o = Math.imul(S, q), n = n + Math.imul(_, Y) | 0, i = (i = i + Math.imul(_, G) | 0) + Math.imul(w, Y) | 0, o = o + Math.imul(w, G) | 0, n = n + Math.imul(b, Z) | 0, i = (i = i + Math.imul(b, V) | 0) + Math.imul(v, Z) | 0, o = o + Math.imul(v, V) | 0, n = n + Math.imul(p, J) | 0, i = (i = i + Math.imul(p, X) | 0) + Math.imul(g, J) | 0, o = o + Math.imul(g, X) | 0;

              var _t = (f + (n = n + Math.imul(h, Q) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, tt) | 0) + Math.imul(l, Q) | 0)) << 13) | 0;

              f = ((o = o + Math.imul(l, tt) | 0) + (i >>> 13) | 0) + (_t >>> 26) | 0, _t &= 67108863, n = Math.imul(x, z), i = (i = Math.imul(x, q)) + Math.imul(R, z) | 0, o = Math.imul(R, q), n = n + Math.imul(M, Y) | 0, i = (i = i + Math.imul(M, G) | 0) + Math.imul(S, Y) | 0, o = o + Math.imul(S, G) | 0, n = n + Math.imul(_, Z) | 0, i = (i = i + Math.imul(_, V) | 0) + Math.imul(w, Z) | 0, o = o + Math.imul(w, V) | 0, n = n + Math.imul(b, J) | 0, i = (i = i + Math.imul(b, X) | 0) + Math.imul(v, J) | 0, o = o + Math.imul(v, X) | 0, n = n + Math.imul(p, Q) | 0, i = (i = i + Math.imul(p, tt) | 0) + Math.imul(g, Q) | 0, o = o + Math.imul(g, tt) | 0;
              var wt = (f + (n = n + Math.imul(h, rt) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, nt) | 0) + Math.imul(l, rt) | 0)) << 13) | 0;
              f = ((o = o + Math.imul(l, nt) | 0) + (i >>> 13) | 0) + (wt >>> 26) | 0, wt &= 67108863, n = Math.imul(k, z), i = (i = Math.imul(k, q)) + Math.imul(I, z) | 0, o = Math.imul(I, q), n = n + Math.imul(x, Y) | 0, i = (i = i + Math.imul(x, G) | 0) + Math.imul(R, Y) | 0, o = o + Math.imul(R, G) | 0, n = n + Math.imul(M, Z) | 0, i = (i = i + Math.imul(M, V) | 0) + Math.imul(S, Z) | 0, o = o + Math.imul(S, V) | 0, n = n + Math.imul(_, J) | 0, i = (i = i + Math.imul(_, X) | 0) + Math.imul(w, J) | 0, o = o + Math.imul(w, X) | 0, n = n + Math.imul(b, Q) | 0, i = (i = i + Math.imul(b, tt) | 0) + Math.imul(v, Q) | 0, o = o + Math.imul(v, tt) | 0, n = n + Math.imul(p, rt) | 0, i = (i = i + Math.imul(p, nt) | 0) + Math.imul(g, rt) | 0, o = o + Math.imul(g, nt) | 0;
              var Et = (f + (n = n + Math.imul(h, ot) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, st) | 0) + Math.imul(l, ot) | 0)) << 13) | 0;
              f = ((o = o + Math.imul(l, st) | 0) + (i >>> 13) | 0) + (Et >>> 26) | 0, Et &= 67108863, n = Math.imul(O, z), i = (i = Math.imul(O, q)) + Math.imul(P, z) | 0, o = Math.imul(P, q), n = n + Math.imul(k, Y) | 0, i = (i = i + Math.imul(k, G) | 0) + Math.imul(I, Y) | 0, o = o + Math.imul(I, G) | 0, n = n + Math.imul(x, Z) | 0, i = (i = i + Math.imul(x, V) | 0) + Math.imul(R, Z) | 0, o = o + Math.imul(R, V) | 0, n = n + Math.imul(M, J) | 0, i = (i = i + Math.imul(M, X) | 0) + Math.imul(S, J) | 0, o = o + Math.imul(S, X) | 0, n = n + Math.imul(_, Q) | 0, i = (i = i + Math.imul(_, tt) | 0) + Math.imul(w, Q) | 0, o = o + Math.imul(w, tt) | 0, n = n + Math.imul(b, rt) | 0, i = (i = i + Math.imul(b, nt) | 0) + Math.imul(v, rt) | 0, o = o + Math.imul(v, nt) | 0, n = n + Math.imul(p, ot) | 0, i = (i = i + Math.imul(p, st) | 0) + Math.imul(g, ot) | 0, o = o + Math.imul(g, st) | 0;
              var Mt = (f + (n = n + Math.imul(h, ut) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, ft) | 0) + Math.imul(l, ut) | 0)) << 13) | 0;
              f = ((o = o + Math.imul(l, ft) | 0) + (i >>> 13) | 0) + (Mt >>> 26) | 0, Mt &= 67108863, n = Math.imul(C, z), i = (i = Math.imul(C, q)) + Math.imul(L, z) | 0, o = Math.imul(L, q), n = n + Math.imul(O, Y) | 0, i = (i = i + Math.imul(O, G) | 0) + Math.imul(P, Y) | 0, o = o + Math.imul(P, G) | 0, n = n + Math.imul(k, Z) | 0, i = (i = i + Math.imul(k, V) | 0) + Math.imul(I, Z) | 0, o = o + Math.imul(I, V) | 0, n = n + Math.imul(x, J) | 0, i = (i = i + Math.imul(x, X) | 0) + Math.imul(R, J) | 0, o = o + Math.imul(R, X) | 0, n = n + Math.imul(M, Q) | 0, i = (i = i + Math.imul(M, tt) | 0) + Math.imul(S, Q) | 0, o = o + Math.imul(S, tt) | 0, n = n + Math.imul(_, rt) | 0, i = (i = i + Math.imul(_, nt) | 0) + Math.imul(w, rt) | 0, o = o + Math.imul(w, nt) | 0, n = n + Math.imul(b, ot) | 0, i = (i = i + Math.imul(b, st) | 0) + Math.imul(v, ot) | 0, o = o + Math.imul(v, st) | 0, n = n + Math.imul(p, ut) | 0, i = (i = i + Math.imul(p, ft) | 0) + Math.imul(g, ut) | 0, o = o + Math.imul(g, ft) | 0;
              var St = (f + (n = n + Math.imul(h, ht) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, lt) | 0) + Math.imul(l, ht) | 0)) << 13) | 0;
              f = ((o = o + Math.imul(l, lt) | 0) + (i >>> 13) | 0) + (St >>> 26) | 0, St &= 67108863, n = Math.imul(U, z), i = (i = Math.imul(U, q)) + Math.imul(D, z) | 0, o = Math.imul(D, q), n = n + Math.imul(C, Y) | 0, i = (i = i + Math.imul(C, G) | 0) + Math.imul(L, Y) | 0, o = o + Math.imul(L, G) | 0, n = n + Math.imul(O, Z) | 0, i = (i = i + Math.imul(O, V) | 0) + Math.imul(P, Z) | 0, o = o + Math.imul(P, V) | 0, n = n + Math.imul(k, J) | 0, i = (i = i + Math.imul(k, X) | 0) + Math.imul(I, J) | 0, o = o + Math.imul(I, X) | 0, n = n + Math.imul(x, Q) | 0, i = (i = i + Math.imul(x, tt) | 0) + Math.imul(R, Q) | 0, o = o + Math.imul(R, tt) | 0, n = n + Math.imul(M, rt) | 0, i = (i = i + Math.imul(M, nt) | 0) + Math.imul(S, rt) | 0, o = o + Math.imul(S, nt) | 0, n = n + Math.imul(_, ot) | 0, i = (i = i + Math.imul(_, st) | 0) + Math.imul(w, ot) | 0, o = o + Math.imul(w, st) | 0, n = n + Math.imul(b, ut) | 0, i = (i = i + Math.imul(b, ft) | 0) + Math.imul(v, ut) | 0, o = o + Math.imul(v, ft) | 0, n = n + Math.imul(p, ht) | 0, i = (i = i + Math.imul(p, lt) | 0) + Math.imul(g, ht) | 0, o = o + Math.imul(g, lt) | 0;
              var At = (f + (n = n + Math.imul(h, pt) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, gt) | 0) + Math.imul(l, pt) | 0)) << 13) | 0;
              f = ((o = o + Math.imul(l, gt) | 0) + (i >>> 13) | 0) + (At >>> 26) | 0, At &= 67108863, n = Math.imul(U, Y), i = (i = Math.imul(U, G)) + Math.imul(D, Y) | 0, o = Math.imul(D, G), n = n + Math.imul(C, Z) | 0, i = (i = i + Math.imul(C, V) | 0) + Math.imul(L, Z) | 0, o = o + Math.imul(L, V) | 0, n = n + Math.imul(O, J) | 0, i = (i = i + Math.imul(O, X) | 0) + Math.imul(P, J) | 0, o = o + Math.imul(P, X) | 0, n = n + Math.imul(k, Q) | 0, i = (i = i + Math.imul(k, tt) | 0) + Math.imul(I, Q) | 0, o = o + Math.imul(I, tt) | 0, n = n + Math.imul(x, rt) | 0, i = (i = i + Math.imul(x, nt) | 0) + Math.imul(R, rt) | 0, o = o + Math.imul(R, nt) | 0, n = n + Math.imul(M, ot) | 0, i = (i = i + Math.imul(M, st) | 0) + Math.imul(S, ot) | 0, o = o + Math.imul(S, st) | 0, n = n + Math.imul(_, ut) | 0, i = (i = i + Math.imul(_, ft) | 0) + Math.imul(w, ut) | 0, o = o + Math.imul(w, ft) | 0, n = n + Math.imul(b, ht) | 0, i = (i = i + Math.imul(b, lt) | 0) + Math.imul(v, ht) | 0, o = o + Math.imul(v, lt) | 0;
              var xt = (f + (n = n + Math.imul(p, pt) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(p, gt) | 0) + Math.imul(g, pt) | 0)) << 13) | 0;
              f = ((o = o + Math.imul(g, gt) | 0) + (i >>> 13) | 0) + (xt >>> 26) | 0, xt &= 67108863, n = Math.imul(U, Z), i = (i = Math.imul(U, V)) + Math.imul(D, Z) | 0, o = Math.imul(D, V), n = n + Math.imul(C, J) | 0, i = (i = i + Math.imul(C, X) | 0) + Math.imul(L, J) | 0, o = o + Math.imul(L, X) | 0, n = n + Math.imul(O, Q) | 0, i = (i = i + Math.imul(O, tt) | 0) + Math.imul(P, Q) | 0, o = o + Math.imul(P, tt) | 0, n = n + Math.imul(k, rt) | 0, i = (i = i + Math.imul(k, nt) | 0) + Math.imul(I, rt) | 0, o = o + Math.imul(I, nt) | 0, n = n + Math.imul(x, ot) | 0, i = (i = i + Math.imul(x, st) | 0) + Math.imul(R, ot) | 0, o = o + Math.imul(R, st) | 0, n = n + Math.imul(M, ut) | 0, i = (i = i + Math.imul(M, ft) | 0) + Math.imul(S, ut) | 0, o = o + Math.imul(S, ft) | 0, n = n + Math.imul(_, ht) | 0, i = (i = i + Math.imul(_, lt) | 0) + Math.imul(w, ht) | 0, o = o + Math.imul(w, lt) | 0;
              var Rt = (f + (n = n + Math.imul(b, pt) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(b, gt) | 0) + Math.imul(v, pt) | 0)) << 13) | 0;
              f = ((o = o + Math.imul(v, gt) | 0) + (i >>> 13) | 0) + (Rt >>> 26) | 0, Rt &= 67108863, n = Math.imul(U, J), i = (i = Math.imul(U, X)) + Math.imul(D, J) | 0, o = Math.imul(D, X), n = n + Math.imul(C, Q) | 0, i = (i = i + Math.imul(C, tt) | 0) + Math.imul(L, Q) | 0, o = o + Math.imul(L, tt) | 0, n = n + Math.imul(O, rt) | 0, i = (i = i + Math.imul(O, nt) | 0) + Math.imul(P, rt) | 0, o = o + Math.imul(P, nt) | 0, n = n + Math.imul(k, ot) | 0, i = (i = i + Math.imul(k, st) | 0) + Math.imul(I, ot) | 0, o = o + Math.imul(I, st) | 0, n = n + Math.imul(x, ut) | 0, i = (i = i + Math.imul(x, ft) | 0) + Math.imul(R, ut) | 0, o = o + Math.imul(R, ft) | 0, n = n + Math.imul(M, ht) | 0, i = (i = i + Math.imul(M, lt) | 0) + Math.imul(S, ht) | 0, o = o + Math.imul(S, lt) | 0;
              var Tt = (f + (n = n + Math.imul(_, pt) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(_, gt) | 0) + Math.imul(w, pt) | 0)) << 13) | 0;
              f = ((o = o + Math.imul(w, gt) | 0) + (i >>> 13) | 0) + (Tt >>> 26) | 0, Tt &= 67108863, n = Math.imul(U, Q), i = (i = Math.imul(U, tt)) + Math.imul(D, Q) | 0, o = Math.imul(D, tt), n = n + Math.imul(C, rt) | 0, i = (i = i + Math.imul(C, nt) | 0) + Math.imul(L, rt) | 0, o = o + Math.imul(L, nt) | 0, n = n + Math.imul(O, ot) | 0, i = (i = i + Math.imul(O, st) | 0) + Math.imul(P, ot) | 0, o = o + Math.imul(P, st) | 0, n = n + Math.imul(k, ut) | 0, i = (i = i + Math.imul(k, ft) | 0) + Math.imul(I, ut) | 0, o = o + Math.imul(I, ft) | 0, n = n + Math.imul(x, ht) | 0, i = (i = i + Math.imul(x, lt) | 0) + Math.imul(R, ht) | 0, o = o + Math.imul(R, lt) | 0;
              var kt = (f + (n = n + Math.imul(M, pt) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(M, gt) | 0) + Math.imul(S, pt) | 0)) << 13) | 0;
              f = ((o = o + Math.imul(S, gt) | 0) + (i >>> 13) | 0) + (kt >>> 26) | 0, kt &= 67108863, n = Math.imul(U, rt), i = (i = Math.imul(U, nt)) + Math.imul(D, rt) | 0, o = Math.imul(D, nt), n = n + Math.imul(C, ot) | 0, i = (i = i + Math.imul(C, st) | 0) + Math.imul(L, ot) | 0, o = o + Math.imul(L, st) | 0, n = n + Math.imul(O, ut) | 0, i = (i = i + Math.imul(O, ft) | 0) + Math.imul(P, ut) | 0, o = o + Math.imul(P, ft) | 0, n = n + Math.imul(k, ht) | 0, i = (i = i + Math.imul(k, lt) | 0) + Math.imul(I, ht) | 0, o = o + Math.imul(I, lt) | 0;
              var It = (f + (n = n + Math.imul(x, pt) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(x, gt) | 0) + Math.imul(R, pt) | 0)) << 13) | 0;
              f = ((o = o + Math.imul(R, gt) | 0) + (i >>> 13) | 0) + (It >>> 26) | 0, It &= 67108863, n = Math.imul(U, ot), i = (i = Math.imul(U, st)) + Math.imul(D, ot) | 0, o = Math.imul(D, st), n = n + Math.imul(C, ut) | 0, i = (i = i + Math.imul(C, ft) | 0) + Math.imul(L, ut) | 0, o = o + Math.imul(L, ft) | 0, n = n + Math.imul(O, ht) | 0, i = (i = i + Math.imul(O, lt) | 0) + Math.imul(P, ht) | 0, o = o + Math.imul(P, lt) | 0;
              var Bt = (f + (n = n + Math.imul(k, pt) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(k, gt) | 0) + Math.imul(I, pt) | 0)) << 13) | 0;
              f = ((o = o + Math.imul(I, gt) | 0) + (i >>> 13) | 0) + (Bt >>> 26) | 0, Bt &= 67108863, n = Math.imul(U, ut), i = (i = Math.imul(U, ft)) + Math.imul(D, ut) | 0, o = Math.imul(D, ft), n = n + Math.imul(C, ht) | 0, i = (i = i + Math.imul(C, lt) | 0) + Math.imul(L, ht) | 0, o = o + Math.imul(L, lt) | 0;
              var Ot = (f + (n = n + Math.imul(O, pt) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(O, gt) | 0) + Math.imul(P, pt) | 0)) << 13) | 0;
              f = ((o = o + Math.imul(P, gt) | 0) + (i >>> 13) | 0) + (Ot >>> 26) | 0, Ot &= 67108863, n = Math.imul(U, ht), i = (i = Math.imul(U, lt)) + Math.imul(D, ht) | 0, o = Math.imul(D, lt);
              var Pt = (f + (n = n + Math.imul(C, pt) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(C, gt) | 0) + Math.imul(L, pt) | 0)) << 13) | 0;
              f = ((o = o + Math.imul(L, gt) | 0) + (i >>> 13) | 0) + (Pt >>> 26) | 0, Pt &= 67108863;
              var Nt = (f + (n = Math.imul(U, pt)) | 0) + ((8191 & (i = (i = Math.imul(U, gt)) + Math.imul(D, pt) | 0)) << 13) | 0;
              return f = ((o = Math.imul(D, gt)) + (i >>> 13) | 0) + (Nt >>> 26) | 0, Nt &= 67108863, u[0] = mt, u[1] = bt, u[2] = vt, u[3] = yt, u[4] = _t, u[5] = wt, u[6] = Et, u[7] = Mt, u[8] = St, u[9] = At, u[10] = xt, u[11] = Rt, u[12] = Tt, u[13] = kt, u[14] = It, u[15] = Bt, u[16] = Ot, u[17] = Pt, u[18] = Nt, 0 !== f && (u[19] = f, r.length++), r;
            };

            function p(t, e, r) {
              return new g().mulp(t, e, r);
            }

            function g(t, e) {
              this.x = t, this.y = e;
            }

            Math.imul || (d = l), o.prototype.mulTo = function (t, e) {
              var r = this.length + t.length;
              return 10 === this.length && 10 === t.length ? d(this, t, e) : r < 63 ? l(this, t, e) : r < 1024 ? function (t, e, r) {
                r.negative = e.negative ^ t.negative, r.length = t.length + e.length;

                for (var n = 0, i = 0, o = 0; o < r.length - 1; o++) {
                  var s = i;
                  i = 0;

                  for (var a = 67108863 & n, u = Math.min(o, e.length - 1), f = Math.max(0, o - t.length + 1); f <= u; f++) {
                    var c = o - f,
                        h = (0 | t.words[c]) * (0 | e.words[f]),
                        l = 67108863 & h;
                    a = 67108863 & (l = l + a | 0), i += (s = (s = s + (h / 67108864 | 0) | 0) + (l >>> 26) | 0) >>> 26, s &= 67108863;
                  }

                  r.words[o] = a, n = s, s = i;
                }

                return 0 !== n ? r.words[o] = n : r.length--, r.strip();
              }(this, t, e) : p(this, t, e);
            }, g.prototype.makeRBT = function (t) {
              for (var e = new Array(t), r = o.prototype._countBits(t) - 1, n = 0; n < t; n++) {
                e[n] = this.revBin(n, r, t);
              }

              return e;
            }, g.prototype.revBin = function (t, e, r) {
              if (0 === t || t === r - 1) return t;

              for (var n = 0, i = 0; i < e; i++) {
                n |= (1 & t) << e - i - 1, t >>= 1;
              }

              return n;
            }, g.prototype.permute = function (t, e, r, n, i, o) {
              for (var s = 0; s < o; s++) {
                n[s] = e[t[s]], i[s] = r[t[s]];
              }
            }, g.prototype.transform = function (t, e, r, n, i, o) {
              this.permute(o, t, e, r, n, i);

              for (var s = 1; s < i; s <<= 1) {
                for (var a = s << 1, u = Math.cos(2 * Math.PI / a), f = Math.sin(2 * Math.PI / a), c = 0; c < i; c += a) {
                  for (var h = u, l = f, d = 0; d < s; d++) {
                    var p = r[c + d],
                        g = n[c + d],
                        m = r[c + d + s],
                        b = n[c + d + s],
                        v = h * m - l * b;
                    b = h * b + l * m, m = v, r[c + d] = p + m, n[c + d] = g + b, r[c + d + s] = p - m, n[c + d + s] = g - b, d !== a && (v = u * h - f * l, l = u * l + f * h, h = v);
                  }
                }
              }
            }, g.prototype.guessLen13b = function (t, e) {
              var r = 1 | Math.max(e, t),
                  n = 1 & r,
                  i = 0;

              for (r = r / 2 | 0; r; r >>>= 1) {
                i++;
              }

              return 1 << i + 1 + n;
            }, g.prototype.conjugate = function (t, e, r) {
              if (!(r <= 1)) for (var n = 0; n < r / 2; n++) {
                var i = t[n];
                t[n] = t[r - n - 1], t[r - n - 1] = i, i = e[n], e[n] = -e[r - n - 1], e[r - n - 1] = -i;
              }
            }, g.prototype.normalize13b = function (t, e) {
              for (var r = 0, n = 0; n < e / 2; n++) {
                var i = 8192 * Math.round(t[2 * n + 1] / e) + Math.round(t[2 * n] / e) + r;
                t[n] = 67108863 & i, r = i < 67108864 ? 0 : i / 67108864 | 0;
              }

              return t;
            }, g.prototype.convert13b = function (t, e, r, i) {
              for (var o = 0, s = 0; s < e; s++) {
                o += 0 | t[s], r[2 * s] = 8191 & o, o >>>= 13, r[2 * s + 1] = 8191 & o, o >>>= 13;
              }

              for (s = 2 * e; s < i; ++s) {
                r[s] = 0;
              }

              n(0 === o), n(0 == (-8192 & o));
            }, g.prototype.stub = function (t) {
              for (var e = new Array(t), r = 0; r < t; r++) {
                e[r] = 0;
              }

              return e;
            }, g.prototype.mulp = function (t, e, r) {
              var n = 2 * this.guessLen13b(t.length, e.length),
                  i = this.makeRBT(n),
                  o = this.stub(n),
                  s = new Array(n),
                  a = new Array(n),
                  u = new Array(n),
                  f = new Array(n),
                  c = new Array(n),
                  h = new Array(n),
                  l = r.words;
              l.length = n, this.convert13b(t.words, t.length, s, n), this.convert13b(e.words, e.length, f, n), this.transform(s, o, a, u, n, i), this.transform(f, o, c, h, n, i);

              for (var d = 0; d < n; d++) {
                var p = a[d] * c[d] - u[d] * h[d];
                u[d] = a[d] * h[d] + u[d] * c[d], a[d] = p;
              }

              return this.conjugate(a, u, n), this.transform(a, u, l, o, n, i), this.conjugate(l, o, n), this.normalize13b(l, n), r.negative = t.negative ^ e.negative, r.length = t.length + e.length, r.strip();
            }, o.prototype.mul = function (t) {
              var e = new o(null);
              return e.words = new Array(this.length + t.length), this.mulTo(t, e);
            }, o.prototype.mulf = function (t) {
              var e = new o(null);
              return e.words = new Array(this.length + t.length), p(this, t, e);
            }, o.prototype.imul = function (t) {
              return this.clone().mulTo(t, this);
            }, o.prototype.imuln = function (t) {
              n("number" == typeof t), n(t < 67108864);

              for (var e = 0, r = 0; r < this.length; r++) {
                var i = (0 | this.words[r]) * t,
                    o = (67108863 & i) + (67108863 & e);
                e >>= 26, e += i / 67108864 | 0, e += o >>> 26, this.words[r] = 67108863 & o;
              }

              return 0 !== e && (this.words[r] = e, this.length++), this;
            }, o.prototype.muln = function (t) {
              return this.clone().imuln(t);
            }, o.prototype.sqr = function () {
              return this.mul(this);
            }, o.prototype.isqr = function () {
              return this.imul(this.clone());
            }, o.prototype.pow = function (t) {
              var e = function (t) {
                for (var e = new Array(t.bitLength()), r = 0; r < e.length; r++) {
                  var n = r / 26 | 0,
                      i = r % 26;
                  e[r] = (t.words[n] & 1 << i) >>> i;
                }

                return e;
              }(t);

              if (0 === e.length) return new o(1);

              for (var r = this, n = 0; n < e.length && 0 === e[n]; n++, r = r.sqr()) {
                ;
              }

              if (++n < e.length) for (var i = r.sqr(); n < e.length; n++, i = i.sqr()) {
                0 !== e[n] && (r = r.mul(i));
              }
              return r;
            }, o.prototype.iushln = function (t) {
              n("number" == typeof t && t >= 0);
              var e,
                  r = t % 26,
                  i = (t - r) / 26,
                  o = 67108863 >>> 26 - r << 26 - r;

              if (0 !== r) {
                var s = 0;

                for (e = 0; e < this.length; e++) {
                  var a = this.words[e] & o,
                      u = (0 | this.words[e]) - a << r;
                  this.words[e] = u | s, s = a >>> 26 - r;
                }

                s && (this.words[e] = s, this.length++);
              }

              if (0 !== i) {
                for (e = this.length - 1; e >= 0; e--) {
                  this.words[e + i] = this.words[e];
                }

                for (e = 0; e < i; e++) {
                  this.words[e] = 0;
                }

                this.length += i;
              }

              return this.strip();
            }, o.prototype.ishln = function (t) {
              return n(0 === this.negative), this.iushln(t);
            }, o.prototype.iushrn = function (t, e, r) {
              var i;
              n("number" == typeof t && t >= 0), i = e ? (e - e % 26) / 26 : 0;
              var o = t % 26,
                  s = Math.min((t - o) / 26, this.length),
                  a = 67108863 ^ 67108863 >>> o << o,
                  u = r;

              if (i -= s, i = Math.max(0, i), u) {
                for (var f = 0; f < s; f++) {
                  u.words[f] = this.words[f];
                }

                u.length = s;
              }

              if (0 === s) ;else if (this.length > s) for (this.length -= s, f = 0; f < this.length; f++) {
                this.words[f] = this.words[f + s];
              } else this.words[0] = 0, this.length = 1;
              var c = 0;

              for (f = this.length - 1; f >= 0 && (0 !== c || f >= i); f--) {
                var h = 0 | this.words[f];
                this.words[f] = c << 26 - o | h >>> o, c = h & a;
              }

              return u && 0 !== c && (u.words[u.length++] = c), 0 === this.length && (this.words[0] = 0, this.length = 1), this.strip();
            }, o.prototype.ishrn = function (t, e, r) {
              return n(0 === this.negative), this.iushrn(t, e, r);
            }, o.prototype.shln = function (t) {
              return this.clone().ishln(t);
            }, o.prototype.ushln = function (t) {
              return this.clone().iushln(t);
            }, o.prototype.shrn = function (t) {
              return this.clone().ishrn(t);
            }, o.prototype.ushrn = function (t) {
              return this.clone().iushrn(t);
            }, o.prototype.testn = function (t) {
              n("number" == typeof t && t >= 0);
              var e = t % 26,
                  r = (t - e) / 26,
                  i = 1 << e;
              return !(this.length <= r || !(this.words[r] & i));
            }, o.prototype.imaskn = function (t) {
              n("number" == typeof t && t >= 0);
              var e = t % 26,
                  r = (t - e) / 26;
              if (n(0 === this.negative, "imaskn works only with positive numbers"), this.length <= r) return this;

              if (0 !== e && r++, this.length = Math.min(r, this.length), 0 !== e) {
                var i = 67108863 ^ 67108863 >>> e << e;
                this.words[this.length - 1] &= i;
              }

              return this.strip();
            }, o.prototype.maskn = function (t) {
              return this.clone().imaskn(t);
            }, o.prototype.iaddn = function (t) {
              return n("number" == typeof t), n(t < 67108864), t < 0 ? this.isubn(-t) : 0 !== this.negative ? 1 === this.length && (0 | this.words[0]) < t ? (this.words[0] = t - (0 | this.words[0]), this.negative = 0, this) : (this.negative = 0, this.isubn(t), this.negative = 1, this) : this._iaddn(t);
            }, o.prototype._iaddn = function (t) {
              this.words[0] += t;

              for (var e = 0; e < this.length && this.words[e] >= 67108864; e++) {
                this.words[e] -= 67108864, e === this.length - 1 ? this.words[e + 1] = 1 : this.words[e + 1]++;
              }

              return this.length = Math.max(this.length, e + 1), this;
            }, o.prototype.isubn = function (t) {
              if (n("number" == typeof t), n(t < 67108864), t < 0) return this.iaddn(-t);
              if (0 !== this.negative) return this.negative = 0, this.iaddn(t), this.negative = 1, this;
              if (this.words[0] -= t, 1 === this.length && this.words[0] < 0) this.words[0] = -this.words[0], this.negative = 1;else for (var e = 0; e < this.length && this.words[e] < 0; e++) {
                this.words[e] += 67108864, this.words[e + 1] -= 1;
              }
              return this.strip();
            }, o.prototype.addn = function (t) {
              return this.clone().iaddn(t);
            }, o.prototype.subn = function (t) {
              return this.clone().isubn(t);
            }, o.prototype.iabs = function () {
              return this.negative = 0, this;
            }, o.prototype.abs = function () {
              return this.clone().iabs();
            }, o.prototype._ishlnsubmul = function (t, e, r) {
              var i,
                  o,
                  s = t.length + r;

              this._expand(s);

              var a = 0;

              for (i = 0; i < t.length; i++) {
                o = (0 | this.words[i + r]) + a;
                var u = (0 | t.words[i]) * e;
                a = ((o -= 67108863 & u) >> 26) - (u / 67108864 | 0), this.words[i + r] = 67108863 & o;
              }

              for (; i < this.length - r; i++) {
                a = (o = (0 | this.words[i + r]) + a) >> 26, this.words[i + r] = 67108863 & o;
              }

              if (0 === a) return this.strip();

              for (n(-1 === a), a = 0, i = 0; i < this.length; i++) {
                a = (o = -(0 | this.words[i]) + a) >> 26, this.words[i] = 67108863 & o;
              }

              return this.negative = 1, this.strip();
            }, o.prototype._wordDiv = function (t, e) {
              var r = (this.length, t.length),
                  n = this.clone(),
                  i = t,
                  s = 0 | i.words[i.length - 1];
              0 != (r = 26 - this._countBits(s)) && (i = i.ushln(r), n.iushln(r), s = 0 | i.words[i.length - 1]);
              var a,
                  u = n.length - i.length;

              if ("mod" !== e) {
                (a = new o(null)).length = u + 1, a.words = new Array(a.length);

                for (var f = 0; f < a.length; f++) {
                  a.words[f] = 0;
                }
              }

              var c = n.clone()._ishlnsubmul(i, 1, u);

              0 === c.negative && (n = c, a && (a.words[u] = 1));

              for (var h = u - 1; h >= 0; h--) {
                var l = 67108864 * (0 | n.words[i.length + h]) + (0 | n.words[i.length + h - 1]);

                for (l = Math.min(l / s | 0, 67108863), n._ishlnsubmul(i, l, h); 0 !== n.negative;) {
                  l--, n.negative = 0, n._ishlnsubmul(i, 1, h), n.isZero() || (n.negative ^= 1);
                }

                a && (a.words[h] = l);
              }

              return a && a.strip(), n.strip(), "div" !== e && 0 !== r && n.iushrn(r), {
                div: a || null,
                mod: n
              };
            }, o.prototype.divmod = function (t, e, r) {
              return n(!t.isZero()), this.isZero() ? {
                div: new o(0),
                mod: new o(0)
              } : 0 !== this.negative && 0 === t.negative ? (a = this.neg().divmod(t, e), "mod" !== e && (i = a.div.neg()), "div" !== e && (s = a.mod.neg(), r && 0 !== s.negative && s.iadd(t)), {
                div: i,
                mod: s
              }) : 0 === this.negative && 0 !== t.negative ? (a = this.divmod(t.neg(), e), "mod" !== e && (i = a.div.neg()), {
                div: i,
                mod: a.mod
              }) : 0 != (this.negative & t.negative) ? (a = this.neg().divmod(t.neg(), e), "div" !== e && (s = a.mod.neg(), r && 0 !== s.negative && s.isub(t)), {
                div: a.div,
                mod: s
              }) : t.length > this.length || this.cmp(t) < 0 ? {
                div: new o(0),
                mod: this
              } : 1 === t.length ? "div" === e ? {
                div: this.divn(t.words[0]),
                mod: null
              } : "mod" === e ? {
                div: null,
                mod: new o(this.modn(t.words[0]))
              } : {
                div: this.divn(t.words[0]),
                mod: new o(this.modn(t.words[0]))
              } : this._wordDiv(t, e);
              var i, s, a;
            }, o.prototype.div = function (t) {
              return this.divmod(t, "div", !1).div;
            }, o.prototype.mod = function (t) {
              return this.divmod(t, "mod", !1).mod;
            }, o.prototype.umod = function (t) {
              return this.divmod(t, "mod", !0).mod;
            }, o.prototype.divRound = function (t) {
              var e = this.divmod(t);
              if (e.mod.isZero()) return e.div;
              var r = 0 !== e.div.negative ? e.mod.isub(t) : e.mod,
                  n = t.ushrn(1),
                  i = t.andln(1),
                  o = r.cmp(n);
              return o < 0 || 1 === i && 0 === o ? e.div : 0 !== e.div.negative ? e.div.isubn(1) : e.div.iaddn(1);
            }, o.prototype.modn = function (t) {
              n(t <= 67108863);

              for (var e = (1 << 26) % t, r = 0, i = this.length - 1; i >= 0; i--) {
                r = (e * r + (0 | this.words[i])) % t;
              }

              return r;
            }, o.prototype.idivn = function (t) {
              n(t <= 67108863);

              for (var e = 0, r = this.length - 1; r >= 0; r--) {
                var i = (0 | this.words[r]) + 67108864 * e;
                this.words[r] = i / t | 0, e = i % t;
              }

              return this.strip();
            }, o.prototype.divn = function (t) {
              return this.clone().idivn(t);
            }, o.prototype.egcd = function (t) {
              n(0 === t.negative), n(!t.isZero());
              var e = this,
                  r = t.clone();
              e = 0 !== e.negative ? e.umod(t) : e.clone();

              for (var i = new o(1), s = new o(0), a = new o(0), u = new o(1), f = 0; e.isEven() && r.isEven();) {
                e.iushrn(1), r.iushrn(1), ++f;
              }

              for (var c = r.clone(), h = e.clone(); !e.isZero();) {
                for (var l = 0, d = 1; 0 == (e.words[0] & d) && l < 26; ++l, d <<= 1) {
                  ;
                }

                if (l > 0) for (e.iushrn(l); l-- > 0;) {
                  (i.isOdd() || s.isOdd()) && (i.iadd(c), s.isub(h)), i.iushrn(1), s.iushrn(1);
                }

                for (var p = 0, g = 1; 0 == (r.words[0] & g) && p < 26; ++p, g <<= 1) {
                  ;
                }

                if (p > 0) for (r.iushrn(p); p-- > 0;) {
                  (a.isOdd() || u.isOdd()) && (a.iadd(c), u.isub(h)), a.iushrn(1), u.iushrn(1);
                }
                e.cmp(r) >= 0 ? (e.isub(r), i.isub(a), s.isub(u)) : (r.isub(e), a.isub(i), u.isub(s));
              }

              return {
                a: a,
                b: u,
                gcd: r.iushln(f)
              };
            }, o.prototype._invmp = function (t) {
              n(0 === t.negative), n(!t.isZero());
              var e = this,
                  r = t.clone();
              e = 0 !== e.negative ? e.umod(t) : e.clone();

              for (var i, s = new o(1), a = new o(0), u = r.clone(); e.cmpn(1) > 0 && r.cmpn(1) > 0;) {
                for (var f = 0, c = 1; 0 == (e.words[0] & c) && f < 26; ++f, c <<= 1) {
                  ;
                }

                if (f > 0) for (e.iushrn(f); f-- > 0;) {
                  s.isOdd() && s.iadd(u), s.iushrn(1);
                }

                for (var h = 0, l = 1; 0 == (r.words[0] & l) && h < 26; ++h, l <<= 1) {
                  ;
                }

                if (h > 0) for (r.iushrn(h); h-- > 0;) {
                  a.isOdd() && a.iadd(u), a.iushrn(1);
                }
                e.cmp(r) >= 0 ? (e.isub(r), s.isub(a)) : (r.isub(e), a.isub(s));
              }

              return (i = 0 === e.cmpn(1) ? s : a).cmpn(0) < 0 && i.iadd(t), i;
            }, o.prototype.gcd = function (t) {
              if (this.isZero()) return t.abs();
              if (t.isZero()) return this.abs();
              var e = this.clone(),
                  r = t.clone();
              e.negative = 0, r.negative = 0;

              for (var n = 0; e.isEven() && r.isEven(); n++) {
                e.iushrn(1), r.iushrn(1);
              }

              for (;;) {
                for (; e.isEven();) {
                  e.iushrn(1);
                }

                for (; r.isEven();) {
                  r.iushrn(1);
                }

                var i = e.cmp(r);

                if (i < 0) {
                  var o = e;
                  e = r, r = o;
                } else if (0 === i || 0 === r.cmpn(1)) break;

                e.isub(r);
              }

              return r.iushln(n);
            }, o.prototype.invm = function (t) {
              return this.egcd(t).a.umod(t);
            }, o.prototype.isEven = function () {
              return 0 == (1 & this.words[0]);
            }, o.prototype.isOdd = function () {
              return 1 == (1 & this.words[0]);
            }, o.prototype.andln = function (t) {
              return this.words[0] & t;
            }, o.prototype.bincn = function (t) {
              n("number" == typeof t);
              var e = t % 26,
                  r = (t - e) / 26,
                  i = 1 << e;
              if (this.length <= r) return this._expand(r + 1), this.words[r] |= i, this;

              for (var o = i, s = r; 0 !== o && s < this.length; s++) {
                var a = 0 | this.words[s];
                o = (a += o) >>> 26, a &= 67108863, this.words[s] = a;
              }

              return 0 !== o && (this.words[s] = o, this.length++), this;
            }, o.prototype.isZero = function () {
              return 1 === this.length && 0 === this.words[0];
            }, o.prototype.cmpn = function (t) {
              var e,
                  r = t < 0;
              if (0 !== this.negative && !r) return -1;
              if (0 === this.negative && r) return 1;
              if (this.strip(), this.length > 1) e = 1;else {
                r && (t = -t), n(t <= 67108863, "Number is too big");
                var i = 0 | this.words[0];
                e = i === t ? 0 : i < t ? -1 : 1;
              }
              return 0 !== this.negative ? 0 | -e : e;
            }, o.prototype.cmp = function (t) {
              if (0 !== this.negative && 0 === t.negative) return -1;
              if (0 === this.negative && 0 !== t.negative) return 1;
              var e = this.ucmp(t);
              return 0 !== this.negative ? 0 | -e : e;
            }, o.prototype.ucmp = function (t) {
              if (this.length > t.length) return 1;
              if (this.length < t.length) return -1;

              for (var e = 0, r = this.length - 1; r >= 0; r--) {
                var n = 0 | this.words[r],
                    i = 0 | t.words[r];

                if (n !== i) {
                  n < i ? e = -1 : n > i && (e = 1);
                  break;
                }
              }

              return e;
            }, o.prototype.gtn = function (t) {
              return 1 === this.cmpn(t);
            }, o.prototype.gt = function (t) {
              return 1 === this.cmp(t);
            }, o.prototype.gten = function (t) {
              return this.cmpn(t) >= 0;
            }, o.prototype.gte = function (t) {
              return this.cmp(t) >= 0;
            }, o.prototype.ltn = function (t) {
              return -1 === this.cmpn(t);
            }, o.prototype.lt = function (t) {
              return -1 === this.cmp(t);
            }, o.prototype.lten = function (t) {
              return this.cmpn(t) <= 0;
            }, o.prototype.lte = function (t) {
              return this.cmp(t) <= 0;
            }, o.prototype.eqn = function (t) {
              return 0 === this.cmpn(t);
            }, o.prototype.eq = function (t) {
              return 0 === this.cmp(t);
            }, o.red = function (t) {
              return new E(t);
            }, o.prototype.toRed = function (t) {
              return n(!this.red, "Already a number in reduction context"), n(0 === this.negative, "red works only with positives"), t.convertTo(this)._forceRed(t);
            }, o.prototype.fromRed = function () {
              return n(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
            }, o.prototype._forceRed = function (t) {
              return this.red = t, this;
            }, o.prototype.forceRed = function (t) {
              return n(!this.red, "Already a number in reduction context"), this._forceRed(t);
            }, o.prototype.redAdd = function (t) {
              return n(this.red, "redAdd works only with red numbers"), this.red.add(this, t);
            }, o.prototype.redIAdd = function (t) {
              return n(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, t);
            }, o.prototype.redSub = function (t) {
              return n(this.red, "redSub works only with red numbers"), this.red.sub(this, t);
            }, o.prototype.redISub = function (t) {
              return n(this.red, "redISub works only with red numbers"), this.red.isub(this, t);
            }, o.prototype.redShl = function (t) {
              return n(this.red, "redShl works only with red numbers"), this.red.shl(this, t);
            }, o.prototype.redMul = function (t) {
              return n(this.red, "redMul works only with red numbers"), this.red._verify2(this, t), this.red.mul(this, t);
            }, o.prototype.redIMul = function (t) {
              return n(this.red, "redMul works only with red numbers"), this.red._verify2(this, t), this.red.imul(this, t);
            }, o.prototype.redSqr = function () {
              return n(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
            }, o.prototype.redISqr = function () {
              return n(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
            }, o.prototype.redSqrt = function () {
              return n(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
            }, o.prototype.redInvm = function () {
              return n(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
            }, o.prototype.redNeg = function () {
              return n(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
            }, o.prototype.redPow = function (t) {
              return n(this.red && !t.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, t);
            };
            var m = {
              k256: null,
              p224: null,
              p192: null,
              p25519: null
            };

            function b(t, e) {
              this.name = t, this.p = new o(e, 16), this.n = this.p.bitLength(), this.k = new o(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
            }

            function v() {
              b.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
            }

            function y() {
              b.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
            }

            function _() {
              b.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
            }

            function w() {
              b.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
            }

            function E(t) {
              if ("string" == typeof t) {
                var e = o._prime(t);

                this.m = e.p, this.prime = e;
              } else n(t.gtn(1), "modulus must be greater than 1"), this.m = t, this.prime = null;
            }

            function M(t) {
              E.call(this, t), this.shift = this.m.bitLength(), this.shift % 26 != 0 && (this.shift += 26 - this.shift % 26), this.r = new o(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
            }

            b.prototype._tmp = function () {
              var t = new o(null);
              return t.words = new Array(Math.ceil(this.n / 13)), t;
            }, b.prototype.ireduce = function (t) {
              var e,
                  r = t;

              do {
                this.split(r, this.tmp), e = (r = (r = this.imulK(r)).iadd(this.tmp)).bitLength();
              } while (e > this.n);

              var n = e < this.n ? -1 : r.ucmp(this.p);
              return 0 === n ? (r.words[0] = 0, r.length = 1) : n > 0 ? r.isub(this.p) : r.strip(), r;
            }, b.prototype.split = function (t, e) {
              t.iushrn(this.n, 0, e);
            }, b.prototype.imulK = function (t) {
              return t.imul(this.k);
            }, i(v, b), v.prototype.split = function (t, e) {
              for (var r = Math.min(t.length, 9), n = 0; n < r; n++) {
                e.words[n] = t.words[n];
              }

              if (e.length = r, t.length <= 9) return t.words[0] = 0, void (t.length = 1);
              var i = t.words[9];

              for (e.words[e.length++] = 4194303 & i, n = 10; n < t.length; n++) {
                var o = 0 | t.words[n];
                t.words[n - 10] = (4194303 & o) << 4 | i >>> 22, i = o;
              }

              i >>>= 22, t.words[n - 10] = i, 0 === i && t.length > 10 ? t.length -= 10 : t.length -= 9;
            }, v.prototype.imulK = function (t) {
              t.words[t.length] = 0, t.words[t.length + 1] = 0, t.length += 2;

              for (var e = 0, r = 0; r < t.length; r++) {
                var n = 0 | t.words[r];
                e += 977 * n, t.words[r] = 67108863 & e, e = 64 * n + (e / 67108864 | 0);
              }

              return 0 === t.words[t.length - 1] && (t.length--, 0 === t.words[t.length - 1] && t.length--), t;
            }, i(y, b), i(_, b), i(w, b), w.prototype.imulK = function (t) {
              for (var e = 0, r = 0; r < t.length; r++) {
                var n = 19 * (0 | t.words[r]) + e,
                    i = 67108863 & n;
                n >>>= 26, t.words[r] = i, e = n;
              }

              return 0 !== e && (t.words[t.length++] = e), t;
            }, o._prime = function (t) {
              if (m[t]) return m[t];
              var e;
              if ("k256" === t) e = new v();else if ("p224" === t) e = new y();else if ("p192" === t) e = new _();else {
                if ("p25519" !== t) throw new Error("Unknown prime " + t);
                e = new w();
              }
              return m[t] = e, e;
            }, E.prototype._verify1 = function (t) {
              n(0 === t.negative, "red works only with positives"), n(t.red, "red works only with red numbers");
            }, E.prototype._verify2 = function (t, e) {
              n(0 == (t.negative | e.negative), "red works only with positives"), n(t.red && t.red === e.red, "red works only with red numbers");
            }, E.prototype.imod = function (t) {
              return this.prime ? this.prime.ireduce(t)._forceRed(this) : t.umod(this.m)._forceRed(this);
            }, E.prototype.neg = function (t) {
              return t.isZero() ? t.clone() : this.m.sub(t)._forceRed(this);
            }, E.prototype.add = function (t, e) {
              this._verify2(t, e);

              var r = t.add(e);
              return r.cmp(this.m) >= 0 && r.isub(this.m), r._forceRed(this);
            }, E.prototype.iadd = function (t, e) {
              this._verify2(t, e);

              var r = t.iadd(e);
              return r.cmp(this.m) >= 0 && r.isub(this.m), r;
            }, E.prototype.sub = function (t, e) {
              this._verify2(t, e);

              var r = t.sub(e);
              return r.cmpn(0) < 0 && r.iadd(this.m), r._forceRed(this);
            }, E.prototype.isub = function (t, e) {
              this._verify2(t, e);

              var r = t.isub(e);
              return r.cmpn(0) < 0 && r.iadd(this.m), r;
            }, E.prototype.shl = function (t, e) {
              return this._verify1(t), this.imod(t.ushln(e));
            }, E.prototype.imul = function (t, e) {
              return this._verify2(t, e), this.imod(t.imul(e));
            }, E.prototype.mul = function (t, e) {
              return this._verify2(t, e), this.imod(t.mul(e));
            }, E.prototype.isqr = function (t) {
              return this.imul(t, t.clone());
            }, E.prototype.sqr = function (t) {
              return this.mul(t, t);
            }, E.prototype.sqrt = function (t) {
              if (t.isZero()) return t.clone();
              var e = this.m.andln(3);

              if (n(e % 2 == 1), 3 === e) {
                var r = this.m.add(new o(1)).iushrn(2);
                return this.pow(t, r);
              }

              for (var i = this.m.subn(1), s = 0; !i.isZero() && 0 === i.andln(1);) {
                s++, i.iushrn(1);
              }

              n(!i.isZero());
              var a = new o(1).toRed(this),
                  u = a.redNeg(),
                  f = this.m.subn(1).iushrn(1),
                  c = this.m.bitLength();

              for (c = new o(2 * c * c).toRed(this); 0 !== this.pow(c, f).cmp(u);) {
                c.redIAdd(u);
              }

              for (var h = this.pow(c, i), l = this.pow(t, i.addn(1).iushrn(1)), d = this.pow(t, i), p = s; 0 !== d.cmp(a);) {
                for (var g = d, m = 0; 0 !== g.cmp(a); m++) {
                  g = g.redSqr();
                }

                n(m < p);
                var b = this.pow(h, new o(1).iushln(p - m - 1));
                l = l.redMul(b), h = b.redSqr(), d = d.redMul(h), p = m;
              }

              return l;
            }, E.prototype.invm = function (t) {
              var e = t._invmp(this.m);

              return 0 !== e.negative ? (e.negative = 0, this.imod(e).redNeg()) : this.imod(e);
            }, E.prototype.pow = function (t, e) {
              if (e.isZero()) return new o(1).toRed(this);
              if (0 === e.cmpn(1)) return t.clone();
              var r = new Array(16);
              r[0] = new o(1).toRed(this), r[1] = t;

              for (var n = 2; n < r.length; n++) {
                r[n] = this.mul(r[n - 1], t);
              }

              var i = r[0],
                  s = 0,
                  a = 0,
                  u = e.bitLength() % 26;

              for (0 === u && (u = 26), n = e.length - 1; n >= 0; n--) {
                for (var f = e.words[n], c = u - 1; c >= 0; c--) {
                  var h = f >> c & 1;
                  i !== r[0] && (i = this.sqr(i)), 0 !== h || 0 !== s ? (s <<= 1, s |= h, (4 == ++a || 0 === n && 0 === c) && (i = this.mul(i, r[s]), a = 0, s = 0)) : a = 0;
                }

                u = 26;
              }

              return i;
            }, E.prototype.convertTo = function (t) {
              var e = t.umod(this.m);
              return e === t ? e.clone() : e;
            }, E.prototype.convertFrom = function (t) {
              var e = t.clone();
              return e.red = null, e;
            }, o.mont = function (t) {
              return new M(t);
            }, i(M, E), M.prototype.convertTo = function (t) {
              return this.imod(t.ushln(this.shift));
            }, M.prototype.convertFrom = function (t) {
              var e = this.imod(t.mul(this.rinv));
              return e.red = null, e;
            }, M.prototype.imul = function (t, e) {
              if (t.isZero() || e.isZero()) return t.words[0] = 0, t.length = 1, t;
              var r = t.imul(e),
                  n = r.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m),
                  i = r.isub(n).iushrn(this.shift),
                  o = i;
              return i.cmp(this.m) >= 0 ? o = i.isub(this.m) : i.cmpn(0) < 0 && (o = i.iadd(this.m)), o._forceRed(this);
            }, M.prototype.mul = function (t, e) {
              if (t.isZero() || e.isZero()) return new o(0)._forceRed(this);
              var r = t.mul(e),
                  n = r.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m),
                  i = r.isub(n).iushrn(this.shift),
                  s = i;
              return i.cmp(this.m) >= 0 ? s = i.isub(this.m) : i.cmpn(0) < 0 && (s = i.iadd(this.m)), s._forceRed(this);
            }, M.prototype.invm = function (t) {
              return this.imod(t._invmp(this.m).mul(this.r2))._forceRed(this);
            };
          }(t, this);
        }).call(this, r(13)(t));
      }, function (t, e) {
        var r;

        r = function () {
          return this;
        }();

        try {
          r = r || new Function("return this")();
        } catch (t) {
          "object" == typeof window && (r = window);
        }

        t.exports = r;
      }, function (t, e, r) {
        (function (e, r) {
          /**
           * [js-sha3]{@link https://github.com/emn178/js-sha3}
           *
           * @version 0.5.7
           * @author Chen, Yi-Cyuan [emn178@gmail.com]
           * @copyright Chen, Yi-Cyuan 2015-2016
           * @license MIT
           */
          !function () {
            "use strict";

            var n = "object" == typeof window ? window : {};
            !n.JS_SHA3_NO_NODE_JS && "object" == typeof e && e.versions && e.versions.node && (n = r);

            for (var i = !n.JS_SHA3_NO_COMMON_JS && "object" == typeof t && t.exports, o = "0123456789abcdef".split(""), s = [0, 8, 16, 24], a = [1, 0, 32898, 0, 32906, 2147483648, 2147516416, 2147483648, 32907, 0, 2147483649, 0, 2147516545, 2147483648, 32777, 2147483648, 138, 0, 136, 0, 2147516425, 0, 2147483658, 0, 2147516555, 0, 139, 2147483648, 32905, 2147483648, 32771, 2147483648, 32770, 2147483648, 128, 2147483648, 32778, 0, 2147483658, 2147483648, 2147516545, 2147483648, 32896, 2147483648, 2147483649, 0, 2147516424, 2147483648], u = [224, 256, 384, 512], f = ["hex", "buffer", "arrayBuffer", "array"], c = function c(t, e, r) {
              return function (n) {
                return new w(t, e, t).update(n)[r]();
              };
            }, h = function h(t, e, r) {
              return function (n, i) {
                return new w(t, e, i).update(n)[r]();
              };
            }, l = function l(t, e) {
              var r = c(t, e, "hex");
              r.create = function () {
                return new w(t, e, t);
              }, r.update = function (t) {
                return r.create().update(t);
              };

              for (var n = 0; n < f.length; ++n) {
                var i = f[n];
                r[i] = c(t, e, i);
              }

              return r;
            }, d = [{
              name: "keccak",
              padding: [1, 256, 65536, 16777216],
              bits: u,
              createMethod: l
            }, {
              name: "sha3",
              padding: [6, 1536, 393216, 100663296],
              bits: u,
              createMethod: l
            }, {
              name: "shake",
              padding: [31, 7936, 2031616, 520093696],
              bits: [128, 256],
              createMethod: function createMethod(t, e) {
                var r = h(t, e, "hex");
                r.create = function (r) {
                  return new w(t, e, r);
                }, r.update = function (t, e) {
                  return r.create(e).update(t);
                };

                for (var n = 0; n < f.length; ++n) {
                  var i = f[n];
                  r[i] = h(t, e, i);
                }

                return r;
              }
            }], p = {}, g = [], m = 0; m < d.length; ++m) {
              for (var b = d[m], v = b.bits, y = 0; y < v.length; ++y) {
                var _ = b.name + "_" + v[y];

                g.push(_), p[_] = b.createMethod(v[y], b.padding);
              }
            }

            function w(t, e, r) {
              this.blocks = [], this.s = [], this.padding = e, this.outputBits = r, this.reset = !0, this.block = 0, this.start = 0, this.blockCount = 1600 - (t << 1) >> 5, this.byteCount = this.blockCount << 2, this.outputBlocks = r >> 5, this.extraBytes = (31 & r) >> 3;

              for (var n = 0; n < 50; ++n) {
                this.s[n] = 0;
              }
            }

            w.prototype.update = function (t) {
              var e = "string" != typeof t;
              e && t.constructor === ArrayBuffer && (t = new Uint8Array(t));

              for (var r, n, i = t.length, o = this.blocks, a = this.byteCount, u = this.blockCount, f = 0, c = this.s; f < i;) {
                if (this.reset) for (this.reset = !1, o[0] = this.block, r = 1; r < u + 1; ++r) {
                  o[r] = 0;
                }
                if (e) for (r = this.start; f < i && r < a; ++f) {
                  o[r >> 2] |= t[f] << s[3 & r++];
                } else for (r = this.start; f < i && r < a; ++f) {
                  (n = t.charCodeAt(f)) < 128 ? o[r >> 2] |= n << s[3 & r++] : n < 2048 ? (o[r >> 2] |= (192 | n >> 6) << s[3 & r++], o[r >> 2] |= (128 | 63 & n) << s[3 & r++]) : n < 55296 || n >= 57344 ? (o[r >> 2] |= (224 | n >> 12) << s[3 & r++], o[r >> 2] |= (128 | n >> 6 & 63) << s[3 & r++], o[r >> 2] |= (128 | 63 & n) << s[3 & r++]) : (n = 65536 + ((1023 & n) << 10 | 1023 & t.charCodeAt(++f)), o[r >> 2] |= (240 | n >> 18) << s[3 & r++], o[r >> 2] |= (128 | n >> 12 & 63) << s[3 & r++], o[r >> 2] |= (128 | n >> 6 & 63) << s[3 & r++], o[r >> 2] |= (128 | 63 & n) << s[3 & r++]);
                }

                if (this.lastByteIndex = r, r >= a) {
                  for (this.start = r - a, this.block = o[u], r = 0; r < u; ++r) {
                    c[r] ^= o[r];
                  }

                  E(c), this.reset = !0;
                } else this.start = r;
              }

              return this;
            }, w.prototype.finalize = function () {
              var t = this.blocks,
                  e = this.lastByteIndex,
                  r = this.blockCount,
                  n = this.s;
              if (t[e >> 2] |= this.padding[3 & e], this.lastByteIndex === this.byteCount) for (t[0] = t[r], e = 1; e < r + 1; ++e) {
                t[e] = 0;
              }

              for (t[r - 1] |= 2147483648, e = 0; e < r; ++e) {
                n[e] ^= t[e];
              }

              E(n);
            }, w.prototype.toString = w.prototype.hex = function () {
              this.finalize();

              for (var t, e = this.blockCount, r = this.s, n = this.outputBlocks, i = this.extraBytes, s = 0, a = 0, u = ""; a < n;) {
                for (s = 0; s < e && a < n; ++s, ++a) {
                  t = r[s], u += o[t >> 4 & 15] + o[15 & t] + o[t >> 12 & 15] + o[t >> 8 & 15] + o[t >> 20 & 15] + o[t >> 16 & 15] + o[t >> 28 & 15] + o[t >> 24 & 15];
                }

                a % e == 0 && (E(r), s = 0);
              }

              return i && (t = r[s], i > 0 && (u += o[t >> 4 & 15] + o[15 & t]), i > 1 && (u += o[t >> 12 & 15] + o[t >> 8 & 15]), i > 2 && (u += o[t >> 20 & 15] + o[t >> 16 & 15])), u;
            }, w.prototype.arrayBuffer = function () {
              this.finalize();
              var t,
                  e = this.blockCount,
                  r = this.s,
                  n = this.outputBlocks,
                  i = this.extraBytes,
                  o = 0,
                  s = 0,
                  a = this.outputBits >> 3;
              t = i ? new ArrayBuffer(n + 1 << 2) : new ArrayBuffer(a);

              for (var u = new Uint32Array(t); s < n;) {
                for (o = 0; o < e && s < n; ++o, ++s) {
                  u[s] = r[o];
                }

                s % e == 0 && E(r);
              }

              return i && (u[o] = r[o], t = t.slice(0, a)), t;
            }, w.prototype.buffer = w.prototype.arrayBuffer, w.prototype.digest = w.prototype.array = function () {
              this.finalize();

              for (var t, e, r = this.blockCount, n = this.s, i = this.outputBlocks, o = this.extraBytes, s = 0, a = 0, u = []; a < i;) {
                for (s = 0; s < r && a < i; ++s, ++a) {
                  t = a << 2, e = n[s], u[t] = 255 & e, u[t + 1] = e >> 8 & 255, u[t + 2] = e >> 16 & 255, u[t + 3] = e >> 24 & 255;
                }

                a % r == 0 && E(n);
              }

              return o && (t = a << 2, e = n[s], o > 0 && (u[t] = 255 & e), o > 1 && (u[t + 1] = e >> 8 & 255), o > 2 && (u[t + 2] = e >> 16 & 255)), u;
            };

            var E = function E(t) {
              var e, r, n, i, o, s, u, f, c, h, l, d, p, g, m, b, v, y, _, w, E, M, S, A, x, R, T, k, I, B, O, P, N, C, L, j, U, D, F, z, q, H, Y, G, K, Z, V, W, J, X, $, Q, tt, et, rt, nt, it, ot, st, at, ut, ft, ct;

              for (n = 0; n < 48; n += 2) {
                i = t[0] ^ t[10] ^ t[20] ^ t[30] ^ t[40], o = t[1] ^ t[11] ^ t[21] ^ t[31] ^ t[41], s = t[2] ^ t[12] ^ t[22] ^ t[32] ^ t[42], u = t[3] ^ t[13] ^ t[23] ^ t[33] ^ t[43], f = t[4] ^ t[14] ^ t[24] ^ t[34] ^ t[44], c = t[5] ^ t[15] ^ t[25] ^ t[35] ^ t[45], h = t[6] ^ t[16] ^ t[26] ^ t[36] ^ t[46], l = t[7] ^ t[17] ^ t[27] ^ t[37] ^ t[47], e = (d = t[8] ^ t[18] ^ t[28] ^ t[38] ^ t[48]) ^ (s << 1 | u >>> 31), r = (p = t[9] ^ t[19] ^ t[29] ^ t[39] ^ t[49]) ^ (u << 1 | s >>> 31), t[0] ^= e, t[1] ^= r, t[10] ^= e, t[11] ^= r, t[20] ^= e, t[21] ^= r, t[30] ^= e, t[31] ^= r, t[40] ^= e, t[41] ^= r, e = i ^ (f << 1 | c >>> 31), r = o ^ (c << 1 | f >>> 31), t[2] ^= e, t[3] ^= r, t[12] ^= e, t[13] ^= r, t[22] ^= e, t[23] ^= r, t[32] ^= e, t[33] ^= r, t[42] ^= e, t[43] ^= r, e = s ^ (h << 1 | l >>> 31), r = u ^ (l << 1 | h >>> 31), t[4] ^= e, t[5] ^= r, t[14] ^= e, t[15] ^= r, t[24] ^= e, t[25] ^= r, t[34] ^= e, t[35] ^= r, t[44] ^= e, t[45] ^= r, e = f ^ (d << 1 | p >>> 31), r = c ^ (p << 1 | d >>> 31), t[6] ^= e, t[7] ^= r, t[16] ^= e, t[17] ^= r, t[26] ^= e, t[27] ^= r, t[36] ^= e, t[37] ^= r, t[46] ^= e, t[47] ^= r, e = h ^ (i << 1 | o >>> 31), r = l ^ (o << 1 | i >>> 31), t[8] ^= e, t[9] ^= r, t[18] ^= e, t[19] ^= r, t[28] ^= e, t[29] ^= r, t[38] ^= e, t[39] ^= r, t[48] ^= e, t[49] ^= r, g = t[0], m = t[1], Z = t[11] << 4 | t[10] >>> 28, V = t[10] << 4 | t[11] >>> 28, k = t[20] << 3 | t[21] >>> 29, I = t[21] << 3 | t[20] >>> 29, at = t[31] << 9 | t[30] >>> 23, ut = t[30] << 9 | t[31] >>> 23, H = t[40] << 18 | t[41] >>> 14, Y = t[41] << 18 | t[40] >>> 14, C = t[2] << 1 | t[3] >>> 31, L = t[3] << 1 | t[2] >>> 31, b = t[13] << 12 | t[12] >>> 20, v = t[12] << 12 | t[13] >>> 20, W = t[22] << 10 | t[23] >>> 22, J = t[23] << 10 | t[22] >>> 22, B = t[33] << 13 | t[32] >>> 19, O = t[32] << 13 | t[33] >>> 19, ft = t[42] << 2 | t[43] >>> 30, ct = t[43] << 2 | t[42] >>> 30, et = t[5] << 30 | t[4] >>> 2, rt = t[4] << 30 | t[5] >>> 2, j = t[14] << 6 | t[15] >>> 26, U = t[15] << 6 | t[14] >>> 26, y = t[25] << 11 | t[24] >>> 21, _ = t[24] << 11 | t[25] >>> 21, X = t[34] << 15 | t[35] >>> 17, $ = t[35] << 15 | t[34] >>> 17, P = t[45] << 29 | t[44] >>> 3, N = t[44] << 29 | t[45] >>> 3, A = t[6] << 28 | t[7] >>> 4, x = t[7] << 28 | t[6] >>> 4, nt = t[17] << 23 | t[16] >>> 9, it = t[16] << 23 | t[17] >>> 9, D = t[26] << 25 | t[27] >>> 7, F = t[27] << 25 | t[26] >>> 7, w = t[36] << 21 | t[37] >>> 11, E = t[37] << 21 | t[36] >>> 11, Q = t[47] << 24 | t[46] >>> 8, tt = t[46] << 24 | t[47] >>> 8, G = t[8] << 27 | t[9] >>> 5, K = t[9] << 27 | t[8] >>> 5, R = t[18] << 20 | t[19] >>> 12, T = t[19] << 20 | t[18] >>> 12, ot = t[29] << 7 | t[28] >>> 25, st = t[28] << 7 | t[29] >>> 25, z = t[38] << 8 | t[39] >>> 24, q = t[39] << 8 | t[38] >>> 24, M = t[48] << 14 | t[49] >>> 18, S = t[49] << 14 | t[48] >>> 18, t[0] = g ^ ~b & y, t[1] = m ^ ~v & _, t[10] = A ^ ~R & k, t[11] = x ^ ~T & I, t[20] = C ^ ~j & D, t[21] = L ^ ~U & F, t[30] = G ^ ~Z & W, t[31] = K ^ ~V & J, t[40] = et ^ ~nt & ot, t[41] = rt ^ ~it & st, t[2] = b ^ ~y & w, t[3] = v ^ ~_ & E, t[12] = R ^ ~k & B, t[13] = T ^ ~I & O, t[22] = j ^ ~D & z, t[23] = U ^ ~F & q, t[32] = Z ^ ~W & X, t[33] = V ^ ~J & $, t[42] = nt ^ ~ot & at, t[43] = it ^ ~st & ut, t[4] = y ^ ~w & M, t[5] = _ ^ ~E & S, t[14] = k ^ ~B & P, t[15] = I ^ ~O & N, t[24] = D ^ ~z & H, t[25] = F ^ ~q & Y, t[34] = W ^ ~X & Q, t[35] = J ^ ~$ & tt, t[44] = ot ^ ~at & ft, t[45] = st ^ ~ut & ct, t[6] = w ^ ~M & g, t[7] = E ^ ~S & m, t[16] = B ^ ~P & A, t[17] = O ^ ~N & x, t[26] = z ^ ~H & C, t[27] = q ^ ~Y & L, t[36] = X ^ ~Q & G, t[37] = $ ^ ~tt & K, t[46] = at ^ ~ft & et, t[47] = ut ^ ~ct & rt, t[8] = M ^ ~g & b, t[9] = S ^ ~m & v, t[18] = P ^ ~A & R, t[19] = N ^ ~x & T, t[28] = H ^ ~C & j, t[29] = Y ^ ~L & U, t[38] = Q ^ ~G & Z, t[39] = tt ^ ~K & V, t[48] = ft ^ ~et & nt, t[49] = ct ^ ~rt & it, t[0] ^= a[n], t[1] ^= a[n + 1];
              }
            };

            if (i) t.exports = p;else for (m = 0; m < g.length; ++m) {
              n[g[m]] = p[g[m]];
            }
          }();
        }).call(this, r(15), r(4));
      }, function (t, e, r) {
        "use strict";

        (function (t) {
          Object.defineProperty(e, "__esModule", {
            value: !0
          });

          var n = r(11),
              i = n.__importDefault(r(12)),
              o = r(0),
              s = r(17),
              a = r(16);

          function u(t) {
            return a.toUtf8String(new Uint8Array(t));
          }

          function f(t, e) {
            var r = o.hexlify(new Uint8Array(t));
            return e && (r = y(r)), r;
          }

          function c(t, e) {
            var r = t.toString("hex");
            return e || (r = v(r)), r;
          }

          function h(t) {
            return a.toUtf8Bytes(t).buffer;
          }

          function l(t, e) {
            return f(h(t), e);
          }

          function d(t, e) {
            var r = new i.default(t).toString(16);
            return r = b(r), e && (r = y(r)), r;
          }

          function p(e) {
            return e = y(e), t.from(e, "hex");
          }

          function g(t) {
            return t = v(t), o.arrayify(t).buffer;
          }

          function m(t) {
            return new i.default(t).toNumber();
          }

          function b(t) {
            return (t = (t = y(t)).length % 2 != 0 ? "0" + t : t) && (t = v(t)), t;
          }

          function v(t) {
            return "0x" === t.toLowerCase().substring(0, 2) ? t : "0x" + t;
          }

          function y(t) {
            return "0x" === t.toLowerCase().substring(0, 2) ? t.substring(2) : t;
          }

          function _(t) {
            return v(t = (t = y(t)).startsWith("0") ? t.substring(1) : t);
          }

          function w(t) {
            return o.isHexString(t);
          }

          function E(t) {
            return "" === t || "string" == typeof t && "" === t.trim();
          }

          function M(t) {
            for (var e = {}, r = ("?" === t[0] ? t.substr(1) : t).split("&"), n = 0; n < r.length; n++) {
              var i = r[n].match(/\w+(?==)/i) || [],
                  o = r[n].match(/=.+/i) || [];
              i[0] && (e[decodeURIComponent(i[0])] = decodeURIComponent(o[0].substr(1)));
            }

            return e;
          }

          function S(t) {
            return !(t && t.length);
          }

          e.convertArrayBufferToBuffer = function (t) {
            return p(f(t));
          }, e.convertArrayBufferToUtf8 = u, e.convertArrayBufferToHex = f, e.convertArrayBufferToNumber = function (t) {
            return m(f(t));
          }, e.concatArrayBuffers = function () {
            for (var t = [], e = 0; e < arguments.length; e++) {
              t[e] = arguments[e];
            }

            var r = t.map(function (t) {
              return f(t, !0);
            }).join(""),
                n = g(r);
            return n;
          }, e.convertBufferToArrayBuffer = function (t) {
            return g(c(t));
          }, e.convertBufferToUtf8 = function (t) {
            return t.toString("utf8");
          }, e.convertBufferToHex = c, e.convertBufferToNumber = function (t) {
            return m(c(t));
          }, e.concatBuffers = function () {
            for (var e = [], r = 0; r < arguments.length; r++) {
              e[r] = arguments[r];
            }

            var n = t.concat(e);
            return n;
          }, e.convertUtf8ToArrayBuffer = h, e.convertUtf8ToBuffer = function (e) {
            return t.from(e, "utf8");
          }, e.convertUtf8ToHex = l, e.convertUtf8ToNumber = function (t) {
            return new i.default(t).toNumber();
          }, e.convertNumberToBuffer = function (t) {
            return p(d(t));
          }, e.convertNumberToArrayBuffer = function (t) {
            return g(d(t));
          }, e.convertNumberToUtf8 = function (t) {
            return new i.default(t).toString();
          }, e.convertNumberToHex = d, e.convertHexToBuffer = p, e.convertHexToArrayBuffer = g, e.convertHexToUtf8 = function (t) {
            return u(g(t));
          }, e.convertHexToNumber = m, e.sanitizeHex = b, e.addHexPrefix = v, e.removeHexPrefix = y, e.removeHexLeadingZeros = _, e.isHexString = w, e.isEmptyString = E, e.payloadId = function () {
            return new Date().getTime() * Math.pow(10, 3) + Math.floor(Math.random() * Math.pow(10, 3));
          }, e.uuid = function () {
            return function (t, e) {
              for (e = t = ""; t++ < 36; e += 51 * t & 52 ? (15 ^ t ? 8 ^ Math.random() * (20 ^ t ? 16 : 4) : 4).toString(16) : "-") {
                ;
              }

              return e;
            }();
          }, e.toChecksumAddress = function (t) {
            return s.getAddress(t);
          }, e.isValidAddress = function (t) {
            return !(!t || "0x" !== t.toLowerCase().substring(0, 2) || !/^(0x)?[0-9a-f]{40}$/i.test(t) || !/^(0x)?[0-9a-f]{40}$/.test(t) && !/^(0x)?[0-9A-F]{40}$/.test(t) && t !== e.toChecksumAddress(t));
          }, e.getMeta = function () {
            if ("undefined" == typeof window || "undefined" == typeof document || void 0 === window.location) return null;

            function t() {
              for (var t = [], e = 0; e < arguments.length; e++) {
                t[e] = arguments[e];
              }

              for (var r = document.getElementsByTagName("meta"), n = function n(e) {
                var n = r[e],
                    i = ["itemprop", "property", "name"].map(function (t) {
                  return n.getAttribute(t);
                }).filter(function (e) {
                  e && t.includes(e);
                });

                if (i.length && i) {
                  var o = n.getAttribute("content");
                  if (o) return {
                    value: o
                  };
                }
              }, i = 0; i < r.length; i++) {
                var o = n(i);
                if ("object" == typeof o) return o.value;
              }

              return "";
            }

            var e = function () {
              var e = t("name", "og:site_name", "og:title", "twitter:title");
              return e || (e = document.title), e;
            }();

            return {
              description: t("description", "og:description", "twitter:description", "keywords"),
              url: window.location.origin,
              icons: function () {
                for (var t = document.getElementsByTagName("link"), e = [], r = 0; r < t.length; r++) {
                  var n = t[r],
                      i = n.getAttribute("rel");

                  if (i && i.toLowerCase().indexOf("icon") > -1) {
                    var o = n.getAttribute("href");
                    if (o) if (-1 === o.toLowerCase().indexOf("https:") && -1 === o.toLowerCase().indexOf("http:") && 0 !== o.indexOf("//")) {
                      var s = window.location.protocol + "//" + window.location.host;
                      if (0 === o.indexOf("/")) s += o;else {
                        var a = window.location.pathname.split("/");
                        a.pop(), s += a.join("/") + "/" + o;
                      }
                      e.push(s);
                    } else if (0 === o.indexOf("//")) {
                      var u = window.location.protocol + o;
                      e.push(u);
                    } else e.push(o);
                  }
                }

                return e;
              }(),
              name: e
            };
          }, e.parseQueryString = M, e.parseWalletConnectUri = function (t) {
            var e = t.indexOf(":"),
                r = -1 !== t.indexOf("?") ? t.indexOf("?") : void 0,
                i = t.substring(0, e),
                o = function (t) {
              var e = t.split("@");
              return {
                handshakeTopic: e[0],
                version: parseInt(e[1], 10)
              };
            }(t.substring(e + 1, r)),
                s = function (t) {
              var e = M(t);
              return {
                key: e.key || "",
                bridge: e.bridge || ""
              };
            }(void 0 !== r ? t.substr(r) : "");

            return n.__assign(n.__assign({
              protocol: i
            }, o), s);
          }, e.promisify = function (t, e) {
            var r = this;
            return function () {
              for (var i = [], o = 0; o < arguments.length; o++) {
                i[o] = arguments[o];
              }

              return n.__awaiter(r, void 0, void 0, function () {
                return n.__generator(this, function (r) {
                  return [2, new Promise(function (r, o) {
                    t.apply(e, n.__spread(i, [function (t, e) {
                      null == t && o(t), r(e);
                    }]));
                  })];
                });
              });
            };
          }, e.isEmptyArray = S, e.parsePersonalSign = function (t) {
            return S(t) || w(t[0]) || (t[0] = l(t[0])), t;
          }, e.parseTransactionData = function (t) {
            if (void 0 === t.from || !e.isValidAddress(t.from)) throw new Error("Transaction object must include a valid 'from' value.");

            function r(t) {
              var e = t;
              return ("number" == typeof t || "string" == typeof t && !E(t)) && (w(t) ? "string" == typeof t && (e = b(t)) : e = d(t)), "string" == typeof e && (e = _(e)), e;
            }

            var n = {
              from: b(t.from),
              to: void 0 === t.to ? "" : b(t.to),
              gasPrice: void 0 === t.gasPrice ? "" : r(t.gasPrice),
              gasLimit: void 0 === t.gasLimit ? void 0 === t.gas ? "" : r(t.gas) : r(t.gasLimit),
              value: void 0 === t.value ? "" : r(t.value),
              nonce: void 0 === t.nonce ? "" : r(t.nonce),
              data: void 0 === t.data ? "" : b(t.data) || "0x"
            },
                i = ["gasPrice", "gasLimit", "value", "nonce"];
            return Object.keys(n).forEach(function (t) {
              !n[t].trim().length && i.includes(t) && delete n[t];
            }), n;
          }, e.formatRpcError = function (t) {
            var e = t.message || "Failed or Rejected Request",
                r = -32e3;
            if (t && !t.code) switch (e) {
              case "Parse error":
                r = -32700;
                break;

              case "Invalid request":
                r = -32600;
                break;

              case "Method not found":
                r = -32601;
                break;

              case "Invalid params":
                r = -32602;
                break;

              case "Internal error":
                r = -32603;
                break;

              default:
                r = -32e3;
            }
            return {
              code: r,
              message: e
            };
          }, e.isJsonRpcSubscription = function (t) {
            return "object" == typeof t.params;
          }, e.isJsonRpcRequest = function (t) {
            return void 0 !== t.method;
          }, e.isJsonRpcResponseSuccess = function (t) {
            return void 0 !== t.result;
          }, e.isJsonRpcResponseError = function (t) {
            return void 0 !== t.error;
          }, e.isInternalEvent = function (t) {
            return void 0 !== t.event;
          }, e.isWalletConnectSession = function (t) {
            return void 0 !== t.bridge;
          }, e.isReservedEvent = function (t) {
            return ["session_request", "session_update", "exchange_key", "connect", "disconnect", "display_uri", "transport_open", "transport_close"].includes(t) || t.startsWith("wc_");
          }, e.signingMethods = ["eth_sendTransaction", "eth_signTransaction", "eth_sign", "eth_signTypedData", "eth_signTypedData_v1", "eth_signTypedData_v3", "personal_sign"], e.stateMethods = ["eth_accounts", "eth_chainId", "net_version"], e.isSilentPayload = function (t) {
            return !!t.method.startsWith("wc_") || !e.signingMethods.includes(t.method);
          };
        }).call(this, r(7).Buffer);
      }, function (t, e, r) {
        "use strict";

        (function (t) {
          /*!
           * The buffer module from node.js, for the browser.
           *
           * @author   Feross Aboukhadijeh <http://feross.org>
           * @license  MIT
           */
          var n = r(8),
              i = r(9),
              o = r(10);

          function s() {
            return u.TYPED_ARRAY_SUPPORT ? 2147483647 : 1073741823;
          }

          function a(t, e) {
            if (s() < e) throw new RangeError("Invalid typed array length");
            return u.TYPED_ARRAY_SUPPORT ? (t = new Uint8Array(e)).__proto__ = u.prototype : (null === t && (t = new u(e)), t.length = e), t;
          }

          function u(t, e, r) {
            if (!(u.TYPED_ARRAY_SUPPORT || this instanceof u)) return new u(t, e, r);

            if ("number" == typeof t) {
              if ("string" == typeof e) throw new Error("If encoding is specified then the first argument must be a string");
              return h(this, t);
            }

            return f(this, t, e, r);
          }

          function f(t, e, r, n) {
            if ("number" == typeof e) throw new TypeError('"value" argument must not be a number');
            return "undefined" != typeof ArrayBuffer && e instanceof ArrayBuffer ? function (t, e, r, n) {
              if (e.byteLength, r < 0 || e.byteLength < r) throw new RangeError("'offset' is out of bounds");
              if (e.byteLength < r + (n || 0)) throw new RangeError("'length' is out of bounds");
              return e = void 0 === r && void 0 === n ? new Uint8Array(e) : void 0 === n ? new Uint8Array(e, r) : new Uint8Array(e, r, n), u.TYPED_ARRAY_SUPPORT ? (t = e).__proto__ = u.prototype : t = l(t, e), t;
            }(t, e, r, n) : "string" == typeof e ? function (t, e, r) {
              if ("string" == typeof r && "" !== r || (r = "utf8"), !u.isEncoding(r)) throw new TypeError('"encoding" must be a valid string encoding');
              var n = 0 | p(e, r),
                  i = (t = a(t, n)).write(e, r);
              return i !== n && (t = t.slice(0, i)), t;
            }(t, e, r) : function (t, e) {
              if (u.isBuffer(e)) {
                var r = 0 | d(e.length);
                return 0 === (t = a(t, r)).length ? t : (e.copy(t, 0, 0, r), t);
              }

              if (e) {
                if ("undefined" != typeof ArrayBuffer && e.buffer instanceof ArrayBuffer || "length" in e) return "number" != typeof e.length || (n = e.length) != n ? a(t, 0) : l(t, e);
                if ("Buffer" === e.type && o(e.data)) return l(t, e.data);
              }

              var n;
              throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
            }(t, e);
          }

          function c(t) {
            if ("number" != typeof t) throw new TypeError('"size" argument must be a number');
            if (t < 0) throw new RangeError('"size" argument must not be negative');
          }

          function h(t, e) {
            if (c(e), t = a(t, e < 0 ? 0 : 0 | d(e)), !u.TYPED_ARRAY_SUPPORT) for (var r = 0; r < e; ++r) {
              t[r] = 0;
            }
            return t;
          }

          function l(t, e) {
            var r = e.length < 0 ? 0 : 0 | d(e.length);
            t = a(t, r);

            for (var n = 0; n < r; n += 1) {
              t[n] = 255 & e[n];
            }

            return t;
          }

          function d(t) {
            if (t >= s()) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + s().toString(16) + " bytes");
            return 0 | t;
          }

          function p(t, e) {
            if (u.isBuffer(t)) return t.length;
            if ("undefined" != typeof ArrayBuffer && "function" == typeof ArrayBuffer.isView && (ArrayBuffer.isView(t) || t instanceof ArrayBuffer)) return t.byteLength;
            "string" != typeof t && (t = "" + t);
            var r = t.length;
            if (0 === r) return 0;

            for (var n = !1;;) {
              switch (e) {
                case "ascii":
                case "latin1":
                case "binary":
                  return r;

                case "utf8":
                case "utf-8":
                case void 0:
                  return F(t).length;

                case "ucs2":
                case "ucs-2":
                case "utf16le":
                case "utf-16le":
                  return 2 * r;

                case "hex":
                  return r >>> 1;

                case "base64":
                  return z(t).length;

                default:
                  if (n) return F(t).length;
                  e = ("" + e).toLowerCase(), n = !0;
              }
            }
          }

          function g(t, e, r) {
            var n = !1;
            if ((void 0 === e || e < 0) && (e = 0), e > this.length) return "";
            if ((void 0 === r || r > this.length) && (r = this.length), r <= 0) return "";
            if ((r >>>= 0) <= (e >>>= 0)) return "";

            for (t || (t = "utf8");;) {
              switch (t) {
                case "hex":
                  return k(this, e, r);

                case "utf8":
                case "utf-8":
                  return x(this, e, r);

                case "ascii":
                  return R(this, e, r);

                case "latin1":
                case "binary":
                  return T(this, e, r);

                case "base64":
                  return A(this, e, r);

                case "ucs2":
                case "ucs-2":
                case "utf16le":
                case "utf-16le":
                  return I(this, e, r);

                default:
                  if (n) throw new TypeError("Unknown encoding: " + t);
                  t = (t + "").toLowerCase(), n = !0;
              }
            }
          }

          function m(t, e, r) {
            var n = t[e];
            t[e] = t[r], t[r] = n;
          }

          function b(t, e, r, n, i) {
            if (0 === t.length) return -1;

            if ("string" == typeof r ? (n = r, r = 0) : r > 2147483647 ? r = 2147483647 : r < -2147483648 && (r = -2147483648), r = +r, isNaN(r) && (r = i ? 0 : t.length - 1), r < 0 && (r = t.length + r), r >= t.length) {
              if (i) return -1;
              r = t.length - 1;
            } else if (r < 0) {
              if (!i) return -1;
              r = 0;
            }

            if ("string" == typeof e && (e = u.from(e, n)), u.isBuffer(e)) return 0 === e.length ? -1 : v(t, e, r, n, i);
            if ("number" == typeof e) return e &= 255, u.TYPED_ARRAY_SUPPORT && "function" == typeof Uint8Array.prototype.indexOf ? i ? Uint8Array.prototype.indexOf.call(t, e, r) : Uint8Array.prototype.lastIndexOf.call(t, e, r) : v(t, [e], r, n, i);
            throw new TypeError("val must be string, number or Buffer");
          }

          function v(t, e, r, n, i) {
            var o,
                s = 1,
                a = t.length,
                u = e.length;

            if (void 0 !== n && ("ucs2" === (n = String(n).toLowerCase()) || "ucs-2" === n || "utf16le" === n || "utf-16le" === n)) {
              if (t.length < 2 || e.length < 2) return -1;
              s = 2, a /= 2, u /= 2, r /= 2;
            }

            function f(t, e) {
              return 1 === s ? t[e] : t.readUInt16BE(e * s);
            }

            if (i) {
              var c = -1;

              for (o = r; o < a; o++) {
                if (f(t, o) === f(e, -1 === c ? 0 : o - c)) {
                  if (-1 === c && (c = o), o - c + 1 === u) return c * s;
                } else -1 !== c && (o -= o - c), c = -1;
              }
            } else for (r + u > a && (r = a - u), o = r; o >= 0; o--) {
              for (var h = !0, l = 0; l < u; l++) {
                if (f(t, o + l) !== f(e, l)) {
                  h = !1;
                  break;
                }
              }

              if (h) return o;
            }

            return -1;
          }

          function y(t, e, r, n) {
            r = Number(r) || 0;
            var i = t.length - r;
            n ? (n = Number(n)) > i && (n = i) : n = i;
            var o = e.length;
            if (o % 2 != 0) throw new TypeError("Invalid hex string");
            n > o / 2 && (n = o / 2);

            for (var s = 0; s < n; ++s) {
              var a = parseInt(e.substr(2 * s, 2), 16);
              if (isNaN(a)) return s;
              t[r + s] = a;
            }

            return s;
          }

          function _(t, e, r, n) {
            return q(F(e, t.length - r), t, r, n);
          }

          function w(t, e, r, n) {
            return q(function (t) {
              for (var e = [], r = 0; r < t.length; ++r) {
                e.push(255 & t.charCodeAt(r));
              }

              return e;
            }(e), t, r, n);
          }

          function E(t, e, r, n) {
            return w(t, e, r, n);
          }

          function M(t, e, r, n) {
            return q(z(e), t, r, n);
          }

          function S(t, e, r, n) {
            return q(function (t, e) {
              for (var r, n, i, o = [], s = 0; s < t.length && !((e -= 2) < 0); ++s) {
                n = (r = t.charCodeAt(s)) >> 8, i = r % 256, o.push(i), o.push(n);
              }

              return o;
            }(e, t.length - r), t, r, n);
          }

          function A(t, e, r) {
            return 0 === e && r === t.length ? n.fromByteArray(t) : n.fromByteArray(t.slice(e, r));
          }

          function x(t, e, r) {
            r = Math.min(t.length, r);

            for (var n = [], i = e; i < r;) {
              var o,
                  s,
                  a,
                  u,
                  f = t[i],
                  c = null,
                  h = f > 239 ? 4 : f > 223 ? 3 : f > 191 ? 2 : 1;
              if (i + h <= r) switch (h) {
                case 1:
                  f < 128 && (c = f);
                  break;

                case 2:
                  128 == (192 & (o = t[i + 1])) && (u = (31 & f) << 6 | 63 & o) > 127 && (c = u);
                  break;

                case 3:
                  o = t[i + 1], s = t[i + 2], 128 == (192 & o) && 128 == (192 & s) && (u = (15 & f) << 12 | (63 & o) << 6 | 63 & s) > 2047 && (u < 55296 || u > 57343) && (c = u);
                  break;

                case 4:
                  o = t[i + 1], s = t[i + 2], a = t[i + 3], 128 == (192 & o) && 128 == (192 & s) && 128 == (192 & a) && (u = (15 & f) << 18 | (63 & o) << 12 | (63 & s) << 6 | 63 & a) > 65535 && u < 1114112 && (c = u);
              }
              null === c ? (c = 65533, h = 1) : c > 65535 && (c -= 65536, n.push(c >>> 10 & 1023 | 55296), c = 56320 | 1023 & c), n.push(c), i += h;
            }

            return function (t) {
              var e = t.length;
              if (e <= 4096) return String.fromCharCode.apply(String, t);

              for (var r = "", n = 0; n < e;) {
                r += String.fromCharCode.apply(String, t.slice(n, n += 4096));
              }

              return r;
            }(n);
          }

          function R(t, e, r) {
            var n = "";
            r = Math.min(t.length, r);

            for (var i = e; i < r; ++i) {
              n += String.fromCharCode(127 & t[i]);
            }

            return n;
          }

          function T(t, e, r) {
            var n = "";
            r = Math.min(t.length, r);

            for (var i = e; i < r; ++i) {
              n += String.fromCharCode(t[i]);
            }

            return n;
          }

          function k(t, e, r) {
            var n = t.length;
            (!e || e < 0) && (e = 0), (!r || r < 0 || r > n) && (r = n);

            for (var i = "", o = e; o < r; ++o) {
              i += D(t[o]);
            }

            return i;
          }

          function I(t, e, r) {
            for (var n = t.slice(e, r), i = "", o = 0; o < n.length; o += 2) {
              i += String.fromCharCode(n[o] + 256 * n[o + 1]);
            }

            return i;
          }

          function B(t, e, r) {
            if (t % 1 != 0 || t < 0) throw new RangeError("offset is not uint");
            if (t + e > r) throw new RangeError("Trying to access beyond buffer length");
          }

          function O(t, e, r, n, i, o) {
            if (!u.isBuffer(t)) throw new TypeError('"buffer" argument must be a Buffer instance');
            if (e > i || e < o) throw new RangeError('"value" argument is out of bounds');
            if (r + n > t.length) throw new RangeError("Index out of range");
          }

          function P(t, e, r, n) {
            e < 0 && (e = 65535 + e + 1);

            for (var i = 0, o = Math.min(t.length - r, 2); i < o; ++i) {
              t[r + i] = (e & 255 << 8 * (n ? i : 1 - i)) >>> 8 * (n ? i : 1 - i);
            }
          }

          function N(t, e, r, n) {
            e < 0 && (e = 4294967295 + e + 1);

            for (var i = 0, o = Math.min(t.length - r, 4); i < o; ++i) {
              t[r + i] = e >>> 8 * (n ? i : 3 - i) & 255;
            }
          }

          function C(t, e, r, n, i, o) {
            if (r + n > t.length) throw new RangeError("Index out of range");
            if (r < 0) throw new RangeError("Index out of range");
          }

          function L(t, e, r, n, o) {
            return o || C(t, 0, r, 4), i.write(t, e, r, n, 23, 4), r + 4;
          }

          function j(t, e, r, n, o) {
            return o || C(t, 0, r, 8), i.write(t, e, r, n, 52, 8), r + 8;
          }

          e.Buffer = u, e.SlowBuffer = function (t) {
            return +t != t && (t = 0), u.alloc(+t);
          }, e.INSPECT_MAX_BYTES = 50, u.TYPED_ARRAY_SUPPORT = void 0 !== t.TYPED_ARRAY_SUPPORT ? t.TYPED_ARRAY_SUPPORT : function () {
            try {
              var t = new Uint8Array(1);
              return t.__proto__ = {
                __proto__: Uint8Array.prototype,
                foo: function foo() {
                  return 42;
                }
              }, 42 === t.foo() && "function" == typeof t.subarray && 0 === t.subarray(1, 1).byteLength;
            } catch (t) {
              return !1;
            }
          }(), e.kMaxLength = s(), u.poolSize = 8192, u._augment = function (t) {
            return t.__proto__ = u.prototype, t;
          }, u.from = function (t, e, r) {
            return f(null, t, e, r);
          }, u.TYPED_ARRAY_SUPPORT && (u.prototype.__proto__ = Uint8Array.prototype, u.__proto__ = Uint8Array, "undefined" != typeof Symbol && Symbol.species && u[Symbol.species] === u && Object.defineProperty(u, Symbol.species, {
            value: null,
            configurable: !0
          })), u.alloc = function (t, e, r) {
            return function (t, e, r, n) {
              return c(e), e <= 0 ? a(t, e) : void 0 !== r ? "string" == typeof n ? a(t, e).fill(r, n) : a(t, e).fill(r) : a(t, e);
            }(null, t, e, r);
          }, u.allocUnsafe = function (t) {
            return h(null, t);
          }, u.allocUnsafeSlow = function (t) {
            return h(null, t);
          }, u.isBuffer = function (t) {
            return !(null == t || !t._isBuffer);
          }, u.compare = function (t, e) {
            if (!u.isBuffer(t) || !u.isBuffer(e)) throw new TypeError("Arguments must be Buffers");
            if (t === e) return 0;

            for (var r = t.length, n = e.length, i = 0, o = Math.min(r, n); i < o; ++i) {
              if (t[i] !== e[i]) {
                r = t[i], n = e[i];
                break;
              }
            }

            return r < n ? -1 : n < r ? 1 : 0;
          }, u.isEncoding = function (t) {
            switch (String(t).toLowerCase()) {
              case "hex":
              case "utf8":
              case "utf-8":
              case "ascii":
              case "latin1":
              case "binary":
              case "base64":
              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                return !0;

              default:
                return !1;
            }
          }, u.concat = function (t, e) {
            if (!o(t)) throw new TypeError('"list" argument must be an Array of Buffers');
            if (0 === t.length) return u.alloc(0);
            var r;
            if (void 0 === e) for (e = 0, r = 0; r < t.length; ++r) {
              e += t[r].length;
            }
            var n = u.allocUnsafe(e),
                i = 0;

            for (r = 0; r < t.length; ++r) {
              var s = t[r];
              if (!u.isBuffer(s)) throw new TypeError('"list" argument must be an Array of Buffers');
              s.copy(n, i), i += s.length;
            }

            return n;
          }, u.byteLength = p, u.prototype._isBuffer = !0, u.prototype.swap16 = function () {
            var t = this.length;
            if (t % 2 != 0) throw new RangeError("Buffer size must be a multiple of 16-bits");

            for (var e = 0; e < t; e += 2) {
              m(this, e, e + 1);
            }

            return this;
          }, u.prototype.swap32 = function () {
            var t = this.length;
            if (t % 4 != 0) throw new RangeError("Buffer size must be a multiple of 32-bits");

            for (var e = 0; e < t; e += 4) {
              m(this, e, e + 3), m(this, e + 1, e + 2);
            }

            return this;
          }, u.prototype.swap64 = function () {
            var t = this.length;
            if (t % 8 != 0) throw new RangeError("Buffer size must be a multiple of 64-bits");

            for (var e = 0; e < t; e += 8) {
              m(this, e, e + 7), m(this, e + 1, e + 6), m(this, e + 2, e + 5), m(this, e + 3, e + 4);
            }

            return this;
          }, u.prototype.toString = function () {
            var t = 0 | this.length;
            return 0 === t ? "" : 0 === arguments.length ? x(this, 0, t) : g.apply(this, arguments);
          }, u.prototype.equals = function (t) {
            if (!u.isBuffer(t)) throw new TypeError("Argument must be a Buffer");
            return this === t || 0 === u.compare(this, t);
          }, u.prototype.inspect = function () {
            var t = "",
                r = e.INSPECT_MAX_BYTES;
            return this.length > 0 && (t = this.toString("hex", 0, r).match(/.{2}/g).join(" "), this.length > r && (t += " ... ")), "<Buffer " + t + ">";
          }, u.prototype.compare = function (t, e, r, n, i) {
            if (!u.isBuffer(t)) throw new TypeError("Argument must be a Buffer");
            if (void 0 === e && (e = 0), void 0 === r && (r = t ? t.length : 0), void 0 === n && (n = 0), void 0 === i && (i = this.length), e < 0 || r > t.length || n < 0 || i > this.length) throw new RangeError("out of range index");
            if (n >= i && e >= r) return 0;
            if (n >= i) return -1;
            if (e >= r) return 1;
            if (this === t) return 0;

            for (var o = (i >>>= 0) - (n >>>= 0), s = (r >>>= 0) - (e >>>= 0), a = Math.min(o, s), f = this.slice(n, i), c = t.slice(e, r), h = 0; h < a; ++h) {
              if (f[h] !== c[h]) {
                o = f[h], s = c[h];
                break;
              }
            }

            return o < s ? -1 : s < o ? 1 : 0;
          }, u.prototype.includes = function (t, e, r) {
            return -1 !== this.indexOf(t, e, r);
          }, u.prototype.indexOf = function (t, e, r) {
            return b(this, t, e, r, !0);
          }, u.prototype.lastIndexOf = function (t, e, r) {
            return b(this, t, e, r, !1);
          }, u.prototype.write = function (t, e, r, n) {
            if (void 0 === e) n = "utf8", r = this.length, e = 0;else if (void 0 === r && "string" == typeof e) n = e, r = this.length, e = 0;else {
              if (!isFinite(e)) throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
              e |= 0, isFinite(r) ? (r |= 0, void 0 === n && (n = "utf8")) : (n = r, r = void 0);
            }
            var i = this.length - e;
            if ((void 0 === r || r > i) && (r = i), t.length > 0 && (r < 0 || e < 0) || e > this.length) throw new RangeError("Attempt to write outside buffer bounds");
            n || (n = "utf8");

            for (var o = !1;;) {
              switch (n) {
                case "hex":
                  return y(this, t, e, r);

                case "utf8":
                case "utf-8":
                  return _(this, t, e, r);

                case "ascii":
                  return w(this, t, e, r);

                case "latin1":
                case "binary":
                  return E(this, t, e, r);

                case "base64":
                  return M(this, t, e, r);

                case "ucs2":
                case "ucs-2":
                case "utf16le":
                case "utf-16le":
                  return S(this, t, e, r);

                default:
                  if (o) throw new TypeError("Unknown encoding: " + n);
                  n = ("" + n).toLowerCase(), o = !0;
              }
            }
          }, u.prototype.toJSON = function () {
            return {
              type: "Buffer",
              data: Array.prototype.slice.call(this._arr || this, 0)
            };
          }, u.prototype.slice = function (t, e) {
            var r,
                n = this.length;
            if ((t = ~~t) < 0 ? (t += n) < 0 && (t = 0) : t > n && (t = n), (e = void 0 === e ? n : ~~e) < 0 ? (e += n) < 0 && (e = 0) : e > n && (e = n), e < t && (e = t), u.TYPED_ARRAY_SUPPORT) (r = this.subarray(t, e)).__proto__ = u.prototype;else {
              var i = e - t;
              r = new u(i, void 0);

              for (var o = 0; o < i; ++o) {
                r[o] = this[o + t];
              }
            }
            return r;
          }, u.prototype.readUIntLE = function (t, e, r) {
            t |= 0, e |= 0, r || B(t, e, this.length);

            for (var n = this[t], i = 1, o = 0; ++o < e && (i *= 256);) {
              n += this[t + o] * i;
            }

            return n;
          }, u.prototype.readUIntBE = function (t, e, r) {
            t |= 0, e |= 0, r || B(t, e, this.length);

            for (var n = this[t + --e], i = 1; e > 0 && (i *= 256);) {
              n += this[t + --e] * i;
            }

            return n;
          }, u.prototype.readUInt8 = function (t, e) {
            return e || B(t, 1, this.length), this[t];
          }, u.prototype.readUInt16LE = function (t, e) {
            return e || B(t, 2, this.length), this[t] | this[t + 1] << 8;
          }, u.prototype.readUInt16BE = function (t, e) {
            return e || B(t, 2, this.length), this[t] << 8 | this[t + 1];
          }, u.prototype.readUInt32LE = function (t, e) {
            return e || B(t, 4, this.length), (this[t] | this[t + 1] << 8 | this[t + 2] << 16) + 16777216 * this[t + 3];
          }, u.prototype.readUInt32BE = function (t, e) {
            return e || B(t, 4, this.length), 16777216 * this[t] + (this[t + 1] << 16 | this[t + 2] << 8 | this[t + 3]);
          }, u.prototype.readIntLE = function (t, e, r) {
            t |= 0, e |= 0, r || B(t, e, this.length);

            for (var n = this[t], i = 1, o = 0; ++o < e && (i *= 256);) {
              n += this[t + o] * i;
            }

            return n >= (i *= 128) && (n -= Math.pow(2, 8 * e)), n;
          }, u.prototype.readIntBE = function (t, e, r) {
            t |= 0, e |= 0, r || B(t, e, this.length);

            for (var n = e, i = 1, o = this[t + --n]; n > 0 && (i *= 256);) {
              o += this[t + --n] * i;
            }

            return o >= (i *= 128) && (o -= Math.pow(2, 8 * e)), o;
          }, u.prototype.readInt8 = function (t, e) {
            return e || B(t, 1, this.length), 128 & this[t] ? -1 * (255 - this[t] + 1) : this[t];
          }, u.prototype.readInt16LE = function (t, e) {
            e || B(t, 2, this.length);
            var r = this[t] | this[t + 1] << 8;
            return 32768 & r ? 4294901760 | r : r;
          }, u.prototype.readInt16BE = function (t, e) {
            e || B(t, 2, this.length);
            var r = this[t + 1] | this[t] << 8;
            return 32768 & r ? 4294901760 | r : r;
          }, u.prototype.readInt32LE = function (t, e) {
            return e || B(t, 4, this.length), this[t] | this[t + 1] << 8 | this[t + 2] << 16 | this[t + 3] << 24;
          }, u.prototype.readInt32BE = function (t, e) {
            return e || B(t, 4, this.length), this[t] << 24 | this[t + 1] << 16 | this[t + 2] << 8 | this[t + 3];
          }, u.prototype.readFloatLE = function (t, e) {
            return e || B(t, 4, this.length), i.read(this, t, !0, 23, 4);
          }, u.prototype.readFloatBE = function (t, e) {
            return e || B(t, 4, this.length), i.read(this, t, !1, 23, 4);
          }, u.prototype.readDoubleLE = function (t, e) {
            return e || B(t, 8, this.length), i.read(this, t, !0, 52, 8);
          }, u.prototype.readDoubleBE = function (t, e) {
            return e || B(t, 8, this.length), i.read(this, t, !1, 52, 8);
          }, u.prototype.writeUIntLE = function (t, e, r, n) {
            t = +t, e |= 0, r |= 0, n || O(this, t, e, r, Math.pow(2, 8 * r) - 1, 0);
            var i = 1,
                o = 0;

            for (this[e] = 255 & t; ++o < r && (i *= 256);) {
              this[e + o] = t / i & 255;
            }

            return e + r;
          }, u.prototype.writeUIntBE = function (t, e, r, n) {
            t = +t, e |= 0, r |= 0, n || O(this, t, e, r, Math.pow(2, 8 * r) - 1, 0);
            var i = r - 1,
                o = 1;

            for (this[e + i] = 255 & t; --i >= 0 && (o *= 256);) {
              this[e + i] = t / o & 255;
            }

            return e + r;
          }, u.prototype.writeUInt8 = function (t, e, r) {
            return t = +t, e |= 0, r || O(this, t, e, 1, 255, 0), u.TYPED_ARRAY_SUPPORT || (t = Math.floor(t)), this[e] = 255 & t, e + 1;
          }, u.prototype.writeUInt16LE = function (t, e, r) {
            return t = +t, e |= 0, r || O(this, t, e, 2, 65535, 0), u.TYPED_ARRAY_SUPPORT ? (this[e] = 255 & t, this[e + 1] = t >>> 8) : P(this, t, e, !0), e + 2;
          }, u.prototype.writeUInt16BE = function (t, e, r) {
            return t = +t, e |= 0, r || O(this, t, e, 2, 65535, 0), u.TYPED_ARRAY_SUPPORT ? (this[e] = t >>> 8, this[e + 1] = 255 & t) : P(this, t, e, !1), e + 2;
          }, u.prototype.writeUInt32LE = function (t, e, r) {
            return t = +t, e |= 0, r || O(this, t, e, 4, 4294967295, 0), u.TYPED_ARRAY_SUPPORT ? (this[e + 3] = t >>> 24, this[e + 2] = t >>> 16, this[e + 1] = t >>> 8, this[e] = 255 & t) : N(this, t, e, !0), e + 4;
          }, u.prototype.writeUInt32BE = function (t, e, r) {
            return t = +t, e |= 0, r || O(this, t, e, 4, 4294967295, 0), u.TYPED_ARRAY_SUPPORT ? (this[e] = t >>> 24, this[e + 1] = t >>> 16, this[e + 2] = t >>> 8, this[e + 3] = 255 & t) : N(this, t, e, !1), e + 4;
          }, u.prototype.writeIntLE = function (t, e, r, n) {
            if (t = +t, e |= 0, !n) {
              var i = Math.pow(2, 8 * r - 1);
              O(this, t, e, r, i - 1, -i);
            }

            var o = 0,
                s = 1,
                a = 0;

            for (this[e] = 255 & t; ++o < r && (s *= 256);) {
              t < 0 && 0 === a && 0 !== this[e + o - 1] && (a = 1), this[e + o] = (t / s >> 0) - a & 255;
            }

            return e + r;
          }, u.prototype.writeIntBE = function (t, e, r, n) {
            if (t = +t, e |= 0, !n) {
              var i = Math.pow(2, 8 * r - 1);
              O(this, t, e, r, i - 1, -i);
            }

            var o = r - 1,
                s = 1,
                a = 0;

            for (this[e + o] = 255 & t; --o >= 0 && (s *= 256);) {
              t < 0 && 0 === a && 0 !== this[e + o + 1] && (a = 1), this[e + o] = (t / s >> 0) - a & 255;
            }

            return e + r;
          }, u.prototype.writeInt8 = function (t, e, r) {
            return t = +t, e |= 0, r || O(this, t, e, 1, 127, -128), u.TYPED_ARRAY_SUPPORT || (t = Math.floor(t)), t < 0 && (t = 255 + t + 1), this[e] = 255 & t, e + 1;
          }, u.prototype.writeInt16LE = function (t, e, r) {
            return t = +t, e |= 0, r || O(this, t, e, 2, 32767, -32768), u.TYPED_ARRAY_SUPPORT ? (this[e] = 255 & t, this[e + 1] = t >>> 8) : P(this, t, e, !0), e + 2;
          }, u.prototype.writeInt16BE = function (t, e, r) {
            return t = +t, e |= 0, r || O(this, t, e, 2, 32767, -32768), u.TYPED_ARRAY_SUPPORT ? (this[e] = t >>> 8, this[e + 1] = 255 & t) : P(this, t, e, !1), e + 2;
          }, u.prototype.writeInt32LE = function (t, e, r) {
            return t = +t, e |= 0, r || O(this, t, e, 4, 2147483647, -2147483648), u.TYPED_ARRAY_SUPPORT ? (this[e] = 255 & t, this[e + 1] = t >>> 8, this[e + 2] = t >>> 16, this[e + 3] = t >>> 24) : N(this, t, e, !0), e + 4;
          }, u.prototype.writeInt32BE = function (t, e, r) {
            return t = +t, e |= 0, r || O(this, t, e, 4, 2147483647, -2147483648), t < 0 && (t = 4294967295 + t + 1), u.TYPED_ARRAY_SUPPORT ? (this[e] = t >>> 24, this[e + 1] = t >>> 16, this[e + 2] = t >>> 8, this[e + 3] = 255 & t) : N(this, t, e, !1), e + 4;
          }, u.prototype.writeFloatLE = function (t, e, r) {
            return L(this, t, e, !0, r);
          }, u.prototype.writeFloatBE = function (t, e, r) {
            return L(this, t, e, !1, r);
          }, u.prototype.writeDoubleLE = function (t, e, r) {
            return j(this, t, e, !0, r);
          }, u.prototype.writeDoubleBE = function (t, e, r) {
            return j(this, t, e, !1, r);
          }, u.prototype.copy = function (t, e, r, n) {
            if (r || (r = 0), n || 0 === n || (n = this.length), e >= t.length && (e = t.length), e || (e = 0), n > 0 && n < r && (n = r), n === r) return 0;
            if (0 === t.length || 0 === this.length) return 0;
            if (e < 0) throw new RangeError("targetStart out of bounds");
            if (r < 0 || r >= this.length) throw new RangeError("sourceStart out of bounds");
            if (n < 0) throw new RangeError("sourceEnd out of bounds");
            n > this.length && (n = this.length), t.length - e < n - r && (n = t.length - e + r);
            var i,
                o = n - r;
            if (this === t && r < e && e < n) for (i = o - 1; i >= 0; --i) {
              t[i + e] = this[i + r];
            } else if (o < 1e3 || !u.TYPED_ARRAY_SUPPORT) for (i = 0; i < o; ++i) {
              t[i + e] = this[i + r];
            } else Uint8Array.prototype.set.call(t, this.subarray(r, r + o), e);
            return o;
          }, u.prototype.fill = function (t, e, r, n) {
            if ("string" == typeof t) {
              if ("string" == typeof e ? (n = e, e = 0, r = this.length) : "string" == typeof r && (n = r, r = this.length), 1 === t.length) {
                var i = t.charCodeAt(0);
                i < 256 && (t = i);
              }

              if (void 0 !== n && "string" != typeof n) throw new TypeError("encoding must be a string");
              if ("string" == typeof n && !u.isEncoding(n)) throw new TypeError("Unknown encoding: " + n);
            } else "number" == typeof t && (t &= 255);

            if (e < 0 || this.length < e || this.length < r) throw new RangeError("Out of range index");
            if (r <= e) return this;
            var o;
            if (e >>>= 0, r = void 0 === r ? this.length : r >>> 0, t || (t = 0), "number" == typeof t) for (o = e; o < r; ++o) {
              this[o] = t;
            } else {
              var s = u.isBuffer(t) ? t : F(new u(t, n).toString()),
                  a = s.length;

              for (o = 0; o < r - e; ++o) {
                this[o + e] = s[o % a];
              }
            }
            return this;
          };
          var U = /[^+\/0-9A-Za-z-_]/g;

          function D(t) {
            return t < 16 ? "0" + t.toString(16) : t.toString(16);
          }

          function F(t, e) {
            var r;
            e = e || 1 / 0;

            for (var n = t.length, i = null, o = [], s = 0; s < n; ++s) {
              if ((r = t.charCodeAt(s)) > 55295 && r < 57344) {
                if (!i) {
                  if (r > 56319) {
                    (e -= 3) > -1 && o.push(239, 191, 189);
                    continue;
                  }

                  if (s + 1 === n) {
                    (e -= 3) > -1 && o.push(239, 191, 189);
                    continue;
                  }

                  i = r;
                  continue;
                }

                if (r < 56320) {
                  (e -= 3) > -1 && o.push(239, 191, 189), i = r;
                  continue;
                }

                r = 65536 + (i - 55296 << 10 | r - 56320);
              } else i && (e -= 3) > -1 && o.push(239, 191, 189);

              if (i = null, r < 128) {
                if ((e -= 1) < 0) break;
                o.push(r);
              } else if (r < 2048) {
                if ((e -= 2) < 0) break;
                o.push(r >> 6 | 192, 63 & r | 128);
              } else if (r < 65536) {
                if ((e -= 3) < 0) break;
                o.push(r >> 12 | 224, r >> 6 & 63 | 128, 63 & r | 128);
              } else {
                if (!(r < 1114112)) throw new Error("Invalid code point");
                if ((e -= 4) < 0) break;
                o.push(r >> 18 | 240, r >> 12 & 63 | 128, r >> 6 & 63 | 128, 63 & r | 128);
              }
            }

            return o;
          }

          function z(t) {
            return n.toByteArray(function (t) {
              if ((t = function (t) {
                return t.trim ? t.trim() : t.replace(/^\s+|\s+$/g, "");
              }(t).replace(U, "")).length < 2) return "";

              for (; t.length % 4 != 0;) {
                t += "=";
              }

              return t;
            }(t));
          }

          function q(t, e, r, n) {
            for (var i = 0; i < n && !(i + r >= e.length || i >= t.length); ++i) {
              e[i + r] = t[i];
            }

            return i;
          }
        }).call(this, r(4));
      }, function (t, e, r) {
        "use strict";

        e.byteLength = function (t) {
          var e = f(t),
              r = e[0],
              n = e[1];
          return 3 * (r + n) / 4 - n;
        }, e.toByteArray = function (t) {
          var e,
              r,
              n = f(t),
              s = n[0],
              a = n[1],
              u = new o(function (t, e, r) {
            return 3 * (e + r) / 4 - r;
          }(0, s, a)),
              c = 0,
              h = a > 0 ? s - 4 : s;

          for (r = 0; r < h; r += 4) {
            e = i[t.charCodeAt(r)] << 18 | i[t.charCodeAt(r + 1)] << 12 | i[t.charCodeAt(r + 2)] << 6 | i[t.charCodeAt(r + 3)], u[c++] = e >> 16 & 255, u[c++] = e >> 8 & 255, u[c++] = 255 & e;
          }

          return 2 === a && (e = i[t.charCodeAt(r)] << 2 | i[t.charCodeAt(r + 1)] >> 4, u[c++] = 255 & e), 1 === a && (e = i[t.charCodeAt(r)] << 10 | i[t.charCodeAt(r + 1)] << 4 | i[t.charCodeAt(r + 2)] >> 2, u[c++] = e >> 8 & 255, u[c++] = 255 & e), u;
        }, e.fromByteArray = function (t) {
          for (var e, r = t.length, i = r % 3, o = [], s = 0, a = r - i; s < a; s += 16383) {
            o.push(c(t, s, s + 16383 > a ? a : s + 16383));
          }

          return 1 === i ? (e = t[r - 1], o.push(n[e >> 2] + n[e << 4 & 63] + "==")) : 2 === i && (e = (t[r - 2] << 8) + t[r - 1], o.push(n[e >> 10] + n[e >> 4 & 63] + n[e << 2 & 63] + "=")), o.join("");
        };

        for (var n = [], i = [], o = "undefined" != typeof Uint8Array ? Uint8Array : Array, s = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", a = 0, u = s.length; a < u; ++a) {
          n[a] = s[a], i[s.charCodeAt(a)] = a;
        }

        function f(t) {
          var e = t.length;
          if (e % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
          var r = t.indexOf("=");
          return -1 === r && (r = e), [r, r === e ? 0 : 4 - r % 4];
        }

        function c(t, e, r) {
          for (var i, o, s = [], a = e; a < r; a += 3) {
            i = (t[a] << 16 & 16711680) + (t[a + 1] << 8 & 65280) + (255 & t[a + 2]), s.push(n[(o = i) >> 18 & 63] + n[o >> 12 & 63] + n[o >> 6 & 63] + n[63 & o]);
          }

          return s.join("");
        }

        i["-".charCodeAt(0)] = 62, i["_".charCodeAt(0)] = 63;
      }, function (t, e) {
        e.read = function (t, e, r, n, i) {
          var o,
              s,
              a = 8 * i - n - 1,
              u = (1 << a) - 1,
              f = u >> 1,
              c = -7,
              h = r ? i - 1 : 0,
              l = r ? -1 : 1,
              d = t[e + h];

          for (h += l, o = d & (1 << -c) - 1, d >>= -c, c += a; c > 0; o = 256 * o + t[e + h], h += l, c -= 8) {
            ;
          }

          for (s = o & (1 << -c) - 1, o >>= -c, c += n; c > 0; s = 256 * s + t[e + h], h += l, c -= 8) {
            ;
          }

          if (0 === o) o = 1 - f;else {
            if (o === u) return s ? NaN : 1 / 0 * (d ? -1 : 1);
            s += Math.pow(2, n), o -= f;
          }
          return (d ? -1 : 1) * s * Math.pow(2, o - n);
        }, e.write = function (t, e, r, n, i, o) {
          var s,
              a,
              u,
              f = 8 * o - i - 1,
              c = (1 << f) - 1,
              h = c >> 1,
              l = 23 === i ? Math.pow(2, -24) - Math.pow(2, -77) : 0,
              d = n ? 0 : o - 1,
              p = n ? 1 : -1,
              g = e < 0 || 0 === e && 1 / e < 0 ? 1 : 0;

          for (e = Math.abs(e), isNaN(e) || e === 1 / 0 ? (a = isNaN(e) ? 1 : 0, s = c) : (s = Math.floor(Math.log(e) / Math.LN2), e * (u = Math.pow(2, -s)) < 1 && (s--, u *= 2), (e += s + h >= 1 ? l / u : l * Math.pow(2, 1 - h)) * u >= 2 && (s++, u /= 2), s + h >= c ? (a = 0, s = c) : s + h >= 1 ? (a = (e * u - 1) * Math.pow(2, i), s += h) : (a = e * Math.pow(2, h - 1) * Math.pow(2, i), s = 0)); i >= 8; t[r + d] = 255 & a, d += p, a /= 256, i -= 8) {
            ;
          }

          for (s = s << i | a, f += i; f > 0; t[r + d] = 255 & s, d += p, s /= 256, f -= 8) {
            ;
          }

          t[r + d - p] |= 128 * g;
        };
      }, function (t, e) {
        var r = {}.toString;

        t.exports = Array.isArray || function (t) {
          return "[object Array]" == r.call(t);
        };
      }, function (t, e, r) {
        "use strict";

        r.r(e), r.d(e, "__extends", function () {
          return i;
        }), r.d(e, "__assign", function () {
          return _o4;
        }), r.d(e, "__rest", function () {
          return s;
        }), r.d(e, "__decorate", function () {
          return a;
        }), r.d(e, "__param", function () {
          return u;
        }), r.d(e, "__metadata", function () {
          return f;
        }), r.d(e, "__awaiter", function () {
          return c;
        }), r.d(e, "__generator", function () {
          return h;
        }), r.d(e, "__exportStar", function () {
          return l;
        }), r.d(e, "__values", function () {
          return d;
        }), r.d(e, "__read", function () {
          return p;
        }), r.d(e, "__spread", function () {
          return g;
        }), r.d(e, "__await", function () {
          return m;
        }), r.d(e, "__asyncGenerator", function () {
          return b;
        }), r.d(e, "__asyncDelegator", function () {
          return v;
        }), r.d(e, "__asyncValues", function () {
          return y;
        }), r.d(e, "__makeTemplateObject", function () {
          return _;
        }), r.d(e, "__importStar", function () {
          return w;
        }), r.d(e, "__importDefault", function () {
          return E;
        });
        /*! *****************************************************************************
        Copyright (c) Microsoft Corporation. All rights reserved.
        Licensed under the Apache License, Version 2.0 (the "License"); you may not use
        this file except in compliance with the License. You may obtain a copy of the
        License at http://www.apache.org/licenses/LICENSE-2.0
        
        THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
        KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
        WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
        MERCHANTABLITY OR NON-INFRINGEMENT.
        
        See the Apache Version 2.0 License for specific language governing permissions
        and limitations under the License.
        ***************************************************************************** */

        var _n9 = function n(t, e) {
          return (_n9 = Object.setPrototypeOf || {
            __proto__: []
          } instanceof Array && function (t, e) {
            t.__proto__ = e;
          } || function (t, e) {
            for (var r in e) {
              e.hasOwnProperty(r) && (t[r] = e[r]);
            }
          })(t, e);
        };

        function i(t, e) {
          function r() {
            this.constructor = t;
          }

          _n9(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
        }

        var _o4 = function o() {
          return (_o4 = Object.assign || function (t) {
            for (var e, r = 1, n = arguments.length; r < n; r++) {
              for (var i in e = arguments[r]) {
                Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
              }
            }

            return t;
          }).apply(this, arguments);
        };

        function s(t, e) {
          var r = {};

          for (var n in t) {
            Object.prototype.hasOwnProperty.call(t, n) && e.indexOf(n) < 0 && (r[n] = t[n]);
          }

          if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
            var i = 0;

            for (n = Object.getOwnPropertySymbols(t); i < n.length; i++) {
              e.indexOf(n[i]) < 0 && (r[n[i]] = t[n[i]]);
            }
          }

          return r;
        }

        function a(t, e, r, n) {
          var i,
              o = arguments.length,
              s = o < 3 ? e : null === n ? n = Object.getOwnPropertyDescriptor(e, r) : n;
          if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) s = Reflect.decorate(t, e, r, n);else for (var a = t.length - 1; a >= 0; a--) {
            (i = t[a]) && (s = (o < 3 ? i(s) : o > 3 ? i(e, r, s) : i(e, r)) || s);
          }
          return o > 3 && s && Object.defineProperty(e, r, s), s;
        }

        function u(t, e) {
          return function (r, n) {
            e(r, n, t);
          };
        }

        function f(t, e) {
          if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(t, e);
        }

        function c(t, e, r, n) {
          return new (r || (r = Promise))(function (i, o) {
            function s(t) {
              try {
                u(n.next(t));
              } catch (t) {
                o(t);
              }
            }

            function a(t) {
              try {
                u(n.throw(t));
              } catch (t) {
                o(t);
              }
            }

            function u(t) {
              t.done ? i(t.value) : new r(function (e) {
                e(t.value);
              }).then(s, a);
            }

            u((n = n.apply(t, e || [])).next());
          });
        }

        function h(t, e) {
          var r,
              n,
              i,
              o,
              s = {
            label: 0,
            sent: function sent() {
              if (1 & i[0]) throw i[1];
              return i[1];
            },
            trys: [],
            ops: []
          };
          return o = {
            next: a(0),
            throw: a(1),
            return: a(2)
          }, "function" == typeof Symbol && (o[Symbol.iterator] = function () {
            return this;
          }), o;

          function a(o) {
            return function (a) {
              return function (o) {
                if (r) throw new TypeError("Generator is already executing.");

                for (; s;) {
                  try {
                    if (r = 1, n && (i = 2 & o[0] ? n.return : o[0] ? n.throw || ((i = n.return) && i.call(n), 0) : n.next) && !(i = i.call(n, o[1])).done) return i;

                    switch (n = 0, i && (o = [2 & o[0], i.value]), o[0]) {
                      case 0:
                      case 1:
                        i = o;
                        break;

                      case 4:
                        return s.label++, {
                          value: o[1],
                          done: !1
                        };

                      case 5:
                        s.label++, n = o[1], o = [0];
                        continue;

                      case 7:
                        o = s.ops.pop(), s.trys.pop();
                        continue;

                      default:
                        if (!(i = (i = s.trys).length > 0 && i[i.length - 1]) && (6 === o[0] || 2 === o[0])) {
                          s = 0;
                          continue;
                        }

                        if (3 === o[0] && (!i || o[1] > i[0] && o[1] < i[3])) {
                          s.label = o[1];
                          break;
                        }

                        if (6 === o[0] && s.label < i[1]) {
                          s.label = i[1], i = o;
                          break;
                        }

                        if (i && s.label < i[2]) {
                          s.label = i[2], s.ops.push(o);
                          break;
                        }

                        i[2] && s.ops.pop(), s.trys.pop();
                        continue;
                    }

                    o = e.call(t, s);
                  } catch (t) {
                    o = [6, t], n = 0;
                  } finally {
                    r = i = 0;
                  }
                }

                if (5 & o[0]) throw o[1];
                return {
                  value: o[0] ? o[1] : void 0,
                  done: !0
                };
              }([o, a]);
            };
          }
        }

        function l(t, e) {
          for (var r in t) {
            e.hasOwnProperty(r) || (e[r] = t[r]);
          }
        }

        function d(t) {
          var e = "function" == typeof Symbol && t[Symbol.iterator],
              r = 0;
          return e ? e.call(t) : {
            next: function next() {
              return t && r >= t.length && (t = void 0), {
                value: t && t[r++],
                done: !t
              };
            }
          };
        }

        function p(t, e) {
          var r = "function" == typeof Symbol && t[Symbol.iterator];
          if (!r) return t;
          var n,
              i,
              o = r.call(t),
              s = [];

          try {
            for (; (void 0 === e || e-- > 0) && !(n = o.next()).done;) {
              s.push(n.value);
            }
          } catch (t) {
            i = {
              error: t
            };
          } finally {
            try {
              n && !n.done && (r = o.return) && r.call(o);
            } finally {
              if (i) throw i.error;
            }
          }

          return s;
        }

        function g() {
          for (var t = [], e = 0; e < arguments.length; e++) {
            t = t.concat(p(arguments[e]));
          }

          return t;
        }

        function m(t) {
          return this instanceof m ? (this.v = t, this) : new m(t);
        }

        function b(t, e, r) {
          if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
          var n,
              i = r.apply(t, e || []),
              o = [];
          return n = {}, s("next"), s("throw"), s("return"), n[Symbol.asyncIterator] = function () {
            return this;
          }, n;

          function s(t) {
            i[t] && (n[t] = function (e) {
              return new Promise(function (r, n) {
                o.push([t, e, r, n]) > 1 || a(t, e);
              });
            });
          }

          function a(t, e) {
            try {
              (r = i[t](e)).value instanceof m ? Promise.resolve(r.value.v).then(u, f) : c(o[0][2], r);
            } catch (t) {
              c(o[0][3], t);
            }

            var r;
          }

          function u(t) {
            a("next", t);
          }

          function f(t) {
            a("throw", t);
          }

          function c(t, e) {
            t(e), o.shift(), o.length && a(o[0][0], o[0][1]);
          }
        }

        function v(t) {
          var e, r;
          return e = {}, n("next"), n("throw", function (t) {
            throw t;
          }), n("return"), e[Symbol.iterator] = function () {
            return this;
          }, e;

          function n(n, i) {
            e[n] = t[n] ? function (e) {
              return (r = !r) ? {
                value: m(t[n](e)),
                done: "return" === n
              } : i ? i(e) : e;
            } : i;
          }
        }

        function y(t) {
          if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
          var e,
              r = t[Symbol.asyncIterator];
          return r ? r.call(t) : (t = d(t), e = {}, n("next"), n("throw"), n("return"), e[Symbol.asyncIterator] = function () {
            return this;
          }, e);

          function n(r) {
            e[r] = t[r] && function (e) {
              return new Promise(function (n, i) {
                !function (t, e, r, n) {
                  Promise.resolve(n).then(function (e) {
                    t({
                      value: e,
                      done: r
                    });
                  }, e);
                }(n, i, (e = t[r](e)).done, e.value);
              });
            };
          }
        }

        function _(t, e) {
          return Object.defineProperty ? Object.defineProperty(t, "raw", {
            value: e
          }) : t.raw = e, t;
        }

        function w(t) {
          if (t && t.__esModule) return t;
          var e = {};
          if (null != t) for (var r in t) {
            Object.hasOwnProperty.call(t, r) && (e[r] = t[r]);
          }
          return e.default = t, e;
        }

        function E(t) {
          return t && t.__esModule ? t : {
            default: t
          };
        }
      }, function (t, e, r) {
        var n;
        !function (i) {
          "use strict";

          var o,
              s = /^-?(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?$/i,
              a = Math.ceil,
              u = Math.floor,
              f = "[BigNumber Error] ",
              c = f + "Number primitive has more than 15 significant digits: ",
              h = [1, 10, 100, 1e3, 1e4, 1e5, 1e6, 1e7, 1e8, 1e9, 1e10, 1e11, 1e12, 1e13];

          function l(t) {
            var e = 0 | t;
            return t > 0 || t === e ? e : e - 1;
          }

          function d(t) {
            for (var e, r, n = 1, i = t.length, o = t[0] + ""; n < i;) {
              for (r = 14 - (e = t[n++] + "").length; r--; e = "0" + e) {
                ;
              }

              o += e;
            }

            for (i = o.length; 48 === o.charCodeAt(--i);) {
              ;
            }

            return o.slice(0, i + 1 || 1);
          }

          function p(t, e) {
            var r,
                n,
                i = t.c,
                o = e.c,
                s = t.s,
                a = e.s,
                u = t.e,
                f = e.e;
            if (!s || !a) return null;
            if (r = i && !i[0], n = o && !o[0], r || n) return r ? n ? 0 : -a : s;
            if (s != a) return s;
            if (r = s < 0, n = u == f, !i || !o) return n ? 0 : !i ^ r ? 1 : -1;
            if (!n) return u > f ^ r ? 1 : -1;

            for (a = (u = i.length) < (f = o.length) ? u : f, s = 0; s < a; s++) {
              if (i[s] != o[s]) return i[s] > o[s] ^ r ? 1 : -1;
            }

            return u == f ? 0 : u > f ^ r ? 1 : -1;
          }

          function g(t, e, r, n) {
            if (t < e || t > r || t !== u(t)) throw Error(f + (n || "Argument") + ("number" == typeof t ? t < e || t > r ? " out of range: " : " not an integer: " : " not a primitive number: ") + String(t));
          }

          function m(t) {
            var e = t.c.length - 1;
            return l(t.e / 14) == e && t.c[e] % 2 != 0;
          }

          function b(t, e) {
            return (t.length > 1 ? t.charAt(0) + "." + t.slice(1) : t) + (e < 0 ? "e" : "e+") + e;
          }

          function v(t, e, r) {
            var n, i;

            if (e < 0) {
              for (i = r + "."; ++e; i += r) {
                ;
              }

              t = i + t;
            } else if (++e > (n = t.length)) {
              for (i = r, e -= n; --e; i += r) {
                ;
              }

              t += i;
            } else e < n && (t = t.slice(0, e) + "." + t.slice(e));

            return t;
          }

          (o = function t(e) {
            var r,
                n,
                i,
                o,
                y,
                _,
                w,
                E,
                M,
                S = j.prototype = {
              constructor: j,
              toString: null,
              valueOf: null
            },
                A = new j(1),
                x = 20,
                R = 4,
                T = -7,
                k = 21,
                I = -1e7,
                B = 1e7,
                O = !1,
                P = 1,
                N = 0,
                C = {
              prefix: "",
              groupSize: 3,
              secondaryGroupSize: 0,
              groupSeparator: ",",
              decimalSeparator: ".",
              fractionGroupSize: 0,
              fractionGroupSeparator: " ",
              suffix: ""
            },
                L = "0123456789abcdefghijklmnopqrstuvwxyz";

            function j(t, e) {
              var r,
                  o,
                  a,
                  f,
                  h,
                  l,
                  d,
                  p,
                  m = this;
              if (!(m instanceof j)) return new j(t, e);

              if (null == e) {
                if (t && !0 === t._isBigNumber) return m.s = t.s, void (!t.c || t.e > B ? m.c = m.e = null : t.e < I ? m.c = [m.e = 0] : (m.e = t.e, m.c = t.c.slice()));

                if ((l = "number" == typeof t) && 0 * t == 0) {
                  if (m.s = 1 / t < 0 ? (t = -t, -1) : 1, t === ~~t) {
                    for (f = 0, h = t; h >= 10; h /= 10, f++) {
                      ;
                    }

                    return void (f > B ? m.c = m.e = null : (m.e = f, m.c = [t]));
                  }

                  p = String(t);
                } else {
                  if (!s.test(p = String(t))) return i(m, p, l);
                  m.s = 45 == p.charCodeAt(0) ? (p = p.slice(1), -1) : 1;
                }

                (f = p.indexOf(".")) > -1 && (p = p.replace(".", "")), (h = p.search(/e/i)) > 0 ? (f < 0 && (f = h), f += +p.slice(h + 1), p = p.substring(0, h)) : f < 0 && (f = p.length);
              } else {
                if (g(e, 2, L.length, "Base"), 10 == e) return z(m = new j(t), x + m.e + 1, R);

                if (p = String(t), l = "number" == typeof t) {
                  if (0 * t != 0) return i(m, p, l, e);
                  if (m.s = 1 / t < 0 ? (p = p.slice(1), -1) : 1, j.DEBUG && p.replace(/^0\.0*|\./, "").length > 15) throw Error(c + t);
                } else m.s = 45 === p.charCodeAt(0) ? (p = p.slice(1), -1) : 1;

                for (r = L.slice(0, e), f = h = 0, d = p.length; h < d; h++) {
                  if (r.indexOf(o = p.charAt(h)) < 0) {
                    if ("." == o) {
                      if (h > f) {
                        f = d;
                        continue;
                      }
                    } else if (!a && (p == p.toUpperCase() && (p = p.toLowerCase()) || p == p.toLowerCase() && (p = p.toUpperCase()))) {
                      a = !0, h = -1, f = 0;
                      continue;
                    }

                    return i(m, String(t), l, e);
                  }
                }

                l = !1, (f = (p = n(p, e, 10, m.s)).indexOf(".")) > -1 ? p = p.replace(".", "") : f = p.length;
              }

              for (h = 0; 48 === p.charCodeAt(h); h++) {
                ;
              }

              for (d = p.length; 48 === p.charCodeAt(--d);) {
                ;
              }

              if (p = p.slice(h, ++d)) {
                if (d -= h, l && j.DEBUG && d > 15 && (t > 9007199254740991 || t !== u(t))) throw Error(c + m.s * t);
                if ((f = f - h - 1) > B) m.c = m.e = null;else if (f < I) m.c = [m.e = 0];else {
                  if (m.e = f, m.c = [], h = (f + 1) % 14, f < 0 && (h += 14), h < d) {
                    for (h && m.c.push(+p.slice(0, h)), d -= 14; h < d;) {
                      m.c.push(+p.slice(h, h += 14));
                    }

                    h = 14 - (p = p.slice(h)).length;
                  } else h -= d;

                  for (; h--; p += "0") {
                    ;
                  }

                  m.c.push(+p);
                }
              } else m.c = [m.e = 0];
            }

            function U(t, e, r, n) {
              var i, o, s, a, u;
              if (null == r ? r = R : g(r, 0, 8), !t.c) return t.toString();
              if (i = t.c[0], s = t.e, null == e) u = d(t.c), u = 1 == n || 2 == n && (s <= T || s >= k) ? b(u, s) : v(u, s, "0");else if (o = (t = z(new j(t), e, r)).e, a = (u = d(t.c)).length, 1 == n || 2 == n && (e <= o || o <= T)) {
                for (; a < e; u += "0", a++) {
                  ;
                }

                u = b(u, o);
              } else if (e -= s, u = v(u, o, "0"), o + 1 > a) {
                if (--e > 0) for (u += "."; e--; u += "0") {
                  ;
                }
              } else if ((e += o - a) > 0) for (o + 1 == a && (u += "."); e--; u += "0") {
                ;
              }
              return t.s < 0 && i ? "-" + u : u;
            }

            function D(t, e) {
              for (var r, n = 1, i = new j(t[0]); n < t.length; n++) {
                if (!(r = new j(t[n])).s) {
                  i = r;
                  break;
                }

                e.call(i, r) && (i = r);
              }

              return i;
            }

            function F(t, e, r) {
              for (var n = 1, i = e.length; !e[--i]; e.pop()) {
                ;
              }

              for (i = e[0]; i >= 10; i /= 10, n++) {
                ;
              }

              return (r = n + 14 * r - 1) > B ? t.c = t.e = null : r < I ? t.c = [t.e = 0] : (t.e = r, t.c = e), t;
            }

            function z(t, e, r, n) {
              var i,
                  o,
                  s,
                  f,
                  c,
                  l,
                  d,
                  p = t.c,
                  g = h;

              if (p) {
                t: {
                  for (i = 1, f = p[0]; f >= 10; f /= 10, i++) {
                    ;
                  }

                  if ((o = e - i) < 0) o += 14, s = e, d = (c = p[l = 0]) / g[i - s - 1] % 10 | 0;else if ((l = a((o + 1) / 14)) >= p.length) {
                    if (!n) break t;

                    for (; p.length <= l; p.push(0)) {
                      ;
                    }

                    c = d = 0, i = 1, s = (o %= 14) - 14 + 1;
                  } else {
                    for (c = f = p[l], i = 1; f >= 10; f /= 10, i++) {
                      ;
                    }

                    d = (s = (o %= 14) - 14 + i) < 0 ? 0 : c / g[i - s - 1] % 10 | 0;
                  }
                  if (n = n || e < 0 || null != p[l + 1] || (s < 0 ? c : c % g[i - s - 1]), n = r < 4 ? (d || n) && (0 == r || r == (t.s < 0 ? 3 : 2)) : d > 5 || 5 == d && (4 == r || n || 6 == r && (o > 0 ? s > 0 ? c / g[i - s] : 0 : p[l - 1]) % 10 & 1 || r == (t.s < 0 ? 8 : 7)), e < 1 || !p[0]) return p.length = 0, n ? (e -= t.e + 1, p[0] = g[(14 - e % 14) % 14], t.e = -e || 0) : p[0] = t.e = 0, t;
                  if (0 == o ? (p.length = l, f = 1, l--) : (p.length = l + 1, f = g[14 - o], p[l] = s > 0 ? u(c / g[i - s] % g[s]) * f : 0), n) for (;;) {
                    if (0 == l) {
                      for (o = 1, s = p[0]; s >= 10; s /= 10, o++) {
                        ;
                      }

                      for (s = p[0] += f, f = 1; s >= 10; s /= 10, f++) {
                        ;
                      }

                      o != f && (t.e++, 1e14 == p[0] && (p[0] = 1));
                      break;
                    }

                    if (p[l] += f, 1e14 != p[l]) break;
                    p[l--] = 0, f = 1;
                  }

                  for (o = p.length; 0 === p[--o]; p.pop()) {
                    ;
                  }
                }

                t.e > B ? t.c = t.e = null : t.e < I && (t.c = [t.e = 0]);
              }

              return t;
            }

            function q(t) {
              var e,
                  r = t.e;
              return null === r ? t.toString() : (e = d(t.c), e = r <= T || r >= k ? b(e, r) : v(e, r, "0"), t.s < 0 ? "-" + e : e);
            }

            return j.clone = t, j.ROUND_UP = 0, j.ROUND_DOWN = 1, j.ROUND_CEIL = 2, j.ROUND_FLOOR = 3, j.ROUND_HALF_UP = 4, j.ROUND_HALF_DOWN = 5, j.ROUND_HALF_EVEN = 6, j.ROUND_HALF_CEIL = 7, j.ROUND_HALF_FLOOR = 8, j.EUCLID = 9, j.config = j.set = function (t) {
              var e, r;

              if (null != t) {
                if ("object" != typeof t) throw Error(f + "Object expected: " + t);
                if (t.hasOwnProperty(e = "DECIMAL_PLACES") && (g(r = t[e], 0, 1e9, e), x = r), t.hasOwnProperty(e = "ROUNDING_MODE") && (g(r = t[e], 0, 8, e), R = r), t.hasOwnProperty(e = "EXPONENTIAL_AT") && ((r = t[e]) && r.pop ? (g(r[0], -1e9, 0, e), g(r[1], 0, 1e9, e), T = r[0], k = r[1]) : (g(r, -1e9, 1e9, e), T = -(k = r < 0 ? -r : r))), t.hasOwnProperty(e = "RANGE")) if ((r = t[e]) && r.pop) g(r[0], -1e9, -1, e), g(r[1], 1, 1e9, e), I = r[0], B = r[1];else {
                  if (g(r, -1e9, 1e9, e), !r) throw Error(f + e + " cannot be zero: " + r);
                  I = -(B = r < 0 ? -r : r);
                }

                if (t.hasOwnProperty(e = "CRYPTO")) {
                  if ((r = t[e]) !== !!r) throw Error(f + e + " not true or false: " + r);

                  if (r) {
                    if ("undefined" == typeof crypto || !crypto || !crypto.getRandomValues && !crypto.randomBytes) throw O = !r, Error(f + "crypto unavailable");
                    O = r;
                  } else O = r;
                }

                if (t.hasOwnProperty(e = "MODULO_MODE") && (g(r = t[e], 0, 9, e), P = r), t.hasOwnProperty(e = "POW_PRECISION") && (g(r = t[e], 0, 1e9, e), N = r), t.hasOwnProperty(e = "FORMAT")) {
                  if ("object" != typeof (r = t[e])) throw Error(f + e + " not an object: " + r);
                  C = r;
                }

                if (t.hasOwnProperty(e = "ALPHABET")) {
                  if ("string" != typeof (r = t[e]) || /^.$|[+-.\s]|(.).*\1/.test(r)) throw Error(f + e + " invalid: " + r);
                  L = r;
                }
              }

              return {
                DECIMAL_PLACES: x,
                ROUNDING_MODE: R,
                EXPONENTIAL_AT: [T, k],
                RANGE: [I, B],
                CRYPTO: O,
                MODULO_MODE: P,
                POW_PRECISION: N,
                FORMAT: C,
                ALPHABET: L
              };
            }, j.isBigNumber = function (t) {
              if (!t || !0 !== t._isBigNumber) return !1;
              if (!j.DEBUG) return !0;
              var e,
                  r,
                  n = t.c,
                  i = t.e,
                  o = t.s;

              t: if ("[object Array]" == {}.toString.call(n)) {
                if ((1 === o || -1 === o) && i >= -1e9 && i <= 1e9 && i === u(i)) {
                  if (0 === n[0]) {
                    if (0 === i && 1 === n.length) return !0;
                    break t;
                  }

                  if ((e = (i + 1) % 14) < 1 && (e += 14), String(n[0]).length == e) {
                    for (e = 0; e < n.length; e++) {
                      if ((r = n[e]) < 0 || r >= 1e14 || r !== u(r)) break t;
                    }

                    if (0 !== r) return !0;
                  }
                }
              } else if (null === n && null === i && (null === o || 1 === o || -1 === o)) return !0;

              throw Error(f + "Invalid BigNumber: " + t);
            }, j.maximum = j.max = function () {
              return D(arguments, S.lt);
            }, j.minimum = j.min = function () {
              return D(arguments, S.gt);
            }, j.random = (o = 9007199254740992 * Math.random() & 2097151 ? function () {
              return u(9007199254740992 * Math.random());
            } : function () {
              return 8388608 * (1073741824 * Math.random() | 0) + (8388608 * Math.random() | 0);
            }, function (t) {
              var e,
                  r,
                  n,
                  i,
                  s,
                  c = 0,
                  l = [],
                  d = new j(A);
              if (null == t ? t = x : g(t, 0, 1e9), i = a(t / 14), O) if (crypto.getRandomValues) {
                for (e = crypto.getRandomValues(new Uint32Array(i *= 2)); c < i;) {
                  (s = 131072 * e[c] + (e[c + 1] >>> 11)) >= 9e15 ? (r = crypto.getRandomValues(new Uint32Array(2)), e[c] = r[0], e[c + 1] = r[1]) : (l.push(s % 1e14), c += 2);
                }

                c = i / 2;
              } else {
                if (!crypto.randomBytes) throw O = !1, Error(f + "crypto unavailable");

                for (e = crypto.randomBytes(i *= 7); c < i;) {
                  (s = 281474976710656 * (31 & e[c]) + 1099511627776 * e[c + 1] + 4294967296 * e[c + 2] + 16777216 * e[c + 3] + (e[c + 4] << 16) + (e[c + 5] << 8) + e[c + 6]) >= 9e15 ? crypto.randomBytes(7).copy(e, c) : (l.push(s % 1e14), c += 7);
                }

                c = i / 7;
              }
              if (!O) for (; c < i;) {
                (s = o()) < 9e15 && (l[c++] = s % 1e14);
              }

              for (t %= 14, (i = l[--c]) && t && (s = h[14 - t], l[c] = u(i / s) * s); 0 === l[c]; l.pop(), c--) {
                ;
              }

              if (c < 0) l = [n = 0];else {
                for (n = -1; 0 === l[0]; l.splice(0, 1), n -= 14) {
                  ;
                }

                for (c = 1, s = l[0]; s >= 10; s /= 10, c++) {
                  ;
                }

                c < 14 && (n -= 14 - c);
              }
              return d.e = n, d.c = l, d;
            }), j.sum = function () {
              for (var t = 1, e = arguments, r = new j(e[0]); t < e.length;) {
                r = r.plus(e[t++]);
              }

              return r;
            }, n = function () {
              function t(t, e, r, n) {
                for (var i, o, s = [0], a = 0, u = t.length; a < u;) {
                  for (o = s.length; o--; s[o] *= e) {
                    ;
                  }

                  for (s[0] += n.indexOf(t.charAt(a++)), i = 0; i < s.length; i++) {
                    s[i] > r - 1 && (null == s[i + 1] && (s[i + 1] = 0), s[i + 1] += s[i] / r | 0, s[i] %= r);
                  }
                }

                return s.reverse();
              }

              return function (e, n, i, o, s) {
                var a,
                    u,
                    f,
                    c,
                    h,
                    l,
                    p,
                    g,
                    m = e.indexOf("."),
                    b = x,
                    y = R;

                for (m >= 0 && (c = N, N = 0, e = e.replace(".", ""), l = (g = new j(n)).pow(e.length - m), N = c, g.c = t(v(d(l.c), l.e, "0"), 10, i, "0123456789"), g.e = g.c.length), f = c = (p = t(e, n, i, s ? (a = L, "0123456789") : (a = "0123456789", L))).length; 0 == p[--c]; p.pop()) {
                  ;
                }

                if (!p[0]) return a.charAt(0);
                if (m < 0 ? --f : (l.c = p, l.e = f, l.s = o, p = (l = r(l, g, b, y, i)).c, h = l.r, f = l.e), m = p[u = f + b + 1], c = i / 2, h = h || u < 0 || null != p[u + 1], h = y < 4 ? (null != m || h) && (0 == y || y == (l.s < 0 ? 3 : 2)) : m > c || m == c && (4 == y || h || 6 == y && 1 & p[u - 1] || y == (l.s < 0 ? 8 : 7)), u < 1 || !p[0]) e = h ? v(a.charAt(1), -b, a.charAt(0)) : a.charAt(0);else {
                  if (p.length = u, h) for (--i; ++p[--u] > i;) {
                    p[u] = 0, u || (++f, p = [1].concat(p));
                  }

                  for (c = p.length; !p[--c];) {
                    ;
                  }

                  for (m = 0, e = ""; m <= c; e += a.charAt(p[m++])) {
                    ;
                  }

                  e = v(e, f, a.charAt(0));
                }
                return e;
              };
            }(), r = function () {
              function t(t, e, r) {
                var n,
                    i,
                    o,
                    s,
                    a = 0,
                    u = t.length,
                    f = e % 1e7,
                    c = e / 1e7 | 0;

                for (t = t.slice(); u--;) {
                  a = ((i = f * (o = t[u] % 1e7) + (n = c * o + (s = t[u] / 1e7 | 0) * f) % 1e7 * 1e7 + a) / r | 0) + (n / 1e7 | 0) + c * s, t[u] = i % r;
                }

                return a && (t = [a].concat(t)), t;
              }

              function e(t, e, r, n) {
                var i, o;
                if (r != n) o = r > n ? 1 : -1;else for (i = o = 0; i < r; i++) {
                  if (t[i] != e[i]) {
                    o = t[i] > e[i] ? 1 : -1;
                    break;
                  }
                }
                return o;
              }

              function r(t, e, r, n) {
                for (var i = 0; r--;) {
                  t[r] -= i, i = t[r] < e[r] ? 1 : 0, t[r] = i * n + t[r] - e[r];
                }

                for (; !t[0] && t.length > 1; t.splice(0, 1)) {
                  ;
                }
              }

              return function (n, i, o, s, a) {
                var f,
                    c,
                    h,
                    d,
                    p,
                    g,
                    m,
                    b,
                    v,
                    y,
                    _,
                    w,
                    E,
                    M,
                    S,
                    A,
                    x,
                    R = n.s == i.s ? 1 : -1,
                    T = n.c,
                    k = i.c;

                if (!(T && T[0] && k && k[0])) return new j(n.s && i.s && (T ? !k || T[0] != k[0] : k) ? T && 0 == T[0] || !k ? 0 * R : R / 0 : NaN);

                for (v = (b = new j(R)).c = [], R = o + (c = n.e - i.e) + 1, a || (a = 1e14, c = l(n.e / 14) - l(i.e / 14), R = R / 14 | 0), h = 0; k[h] == (T[h] || 0); h++) {
                  ;
                }

                if (k[h] > (T[h] || 0) && c--, R < 0) v.push(1), d = !0;else {
                  for (M = T.length, A = k.length, h = 0, R += 2, (p = u(a / (k[0] + 1))) > 1 && (k = t(k, p, a), T = t(T, p, a), A = k.length, M = T.length), E = A, _ = (y = T.slice(0, A)).length; _ < A; y[_++] = 0) {
                    ;
                  }

                  x = k.slice(), x = [0].concat(x), S = k[0], k[1] >= a / 2 && S++;

                  do {
                    if (p = 0, (f = e(k, y, A, _)) < 0) {
                      if (w = y[0], A != _ && (w = w * a + (y[1] || 0)), (p = u(w / S)) > 1) for (p >= a && (p = a - 1), m = (g = t(k, p, a)).length, _ = y.length; 1 == e(g, y, m, _);) {
                        p--, r(g, A < m ? x : k, m, a), m = g.length, f = 1;
                      } else 0 == p && (f = p = 1), m = (g = k.slice()).length;
                      if (m < _ && (g = [0].concat(g)), r(y, g, _, a), _ = y.length, -1 == f) for (; e(k, y, A, _) < 1;) {
                        p++, r(y, A < _ ? x : k, _, a), _ = y.length;
                      }
                    } else 0 === f && (p++, y = [0]);

                    v[h++] = p, y[0] ? y[_++] = T[E] || 0 : (y = [T[E]], _ = 1);
                  } while ((E++ < M || null != y[0]) && R--);

                  d = null != y[0], v[0] || v.splice(0, 1);
                }

                if (1e14 == a) {
                  for (h = 1, R = v[0]; R >= 10; R /= 10, h++) {
                    ;
                  }

                  z(b, o + (b.e = h + 14 * c - 1) + 1, s, d);
                } else b.e = c, b.r = +d;

                return b;
              };
            }(), y = /^(-?)0([xbo])(?=\w[\w.]*$)/i, _ = /^([^.]+)\.$/, w = /^\.([^.]+)$/, E = /^-?(Infinity|NaN)$/, M = /^\s*\+(?=[\w.])|^\s+|\s+$/g, i = function i(t, e, r, n) {
              var i,
                  o = r ? e : e.replace(M, "");
              if (E.test(o)) t.s = isNaN(o) ? null : o < 0 ? -1 : 1;else {
                if (!r && (o = o.replace(y, function (t, e, r) {
                  return i = "x" == (r = r.toLowerCase()) ? 16 : "b" == r ? 2 : 8, n && n != i ? t : e;
                }), n && (i = n, o = o.replace(_, "$1").replace(w, "0.$1")), e != o)) return new j(o, i);
                if (j.DEBUG) throw Error(f + "Not a" + (n ? " base " + n : "") + " number: " + e);
                t.s = null;
              }
              t.c = t.e = null;
            }, S.absoluteValue = S.abs = function () {
              var t = new j(this);
              return t.s < 0 && (t.s = 1), t;
            }, S.comparedTo = function (t, e) {
              return p(this, new j(t, e));
            }, S.decimalPlaces = S.dp = function (t, e) {
              var r,
                  n,
                  i,
                  o = this;
              if (null != t) return g(t, 0, 1e9), null == e ? e = R : g(e, 0, 8), z(new j(o), t + o.e + 1, e);
              if (!(r = o.c)) return null;
              if (n = 14 * ((i = r.length - 1) - l(this.e / 14)), i = r[i]) for (; i % 10 == 0; i /= 10, n--) {
                ;
              }
              return n < 0 && (n = 0), n;
            }, S.dividedBy = S.div = function (t, e) {
              return r(this, new j(t, e), x, R);
            }, S.dividedToIntegerBy = S.idiv = function (t, e) {
              return r(this, new j(t, e), 0, 1);
            }, S.exponentiatedBy = S.pow = function (t, e) {
              var r,
                  n,
                  i,
                  o,
                  s,
                  c,
                  h,
                  l,
                  d = this;
              if ((t = new j(t)).c && !t.isInteger()) throw Error(f + "Exponent not an integer: " + q(t));
              if (null != e && (e = new j(e)), s = t.e > 14, !d.c || !d.c[0] || 1 == d.c[0] && !d.e && 1 == d.c.length || !t.c || !t.c[0]) return l = new j(Math.pow(+q(d), s ? 2 - m(t) : +q(t))), e ? l.mod(e) : l;

              if (c = t.s < 0, e) {
                if (e.c ? !e.c[0] : !e.s) return new j(NaN);
                (n = !c && d.isInteger() && e.isInteger()) && (d = d.mod(e));
              } else {
                if (t.e > 9 && (d.e > 0 || d.e < -1 || (0 == d.e ? d.c[0] > 1 || s && d.c[1] >= 24e7 : d.c[0] < 8e13 || s && d.c[0] <= 9999975e7))) return o = d.s < 0 && m(t) ? -0 : 0, d.e > -1 && (o = 1 / o), new j(c ? 1 / o : o);
                N && (o = a(N / 14 + 2));
              }

              for (s ? (r = new j(.5), c && (t.s = 1), h = m(t)) : h = (i = Math.abs(+q(t))) % 2, l = new j(A);;) {
                if (h) {
                  if (!(l = l.times(d)).c) break;
                  o ? l.c.length > o && (l.c.length = o) : n && (l = l.mod(e));
                }

                if (i) {
                  if (0 === (i = u(i / 2))) break;
                  h = i % 2;
                } else if (z(t = t.times(r), t.e + 1, 1), t.e > 14) h = m(t);else {
                  if (0 == (i = +q(t))) break;
                  h = i % 2;
                }

                d = d.times(d), o ? d.c && d.c.length > o && (d.c.length = o) : n && (d = d.mod(e));
              }

              return n ? l : (c && (l = A.div(l)), e ? l.mod(e) : o ? z(l, N, R, void 0) : l);
            }, S.integerValue = function (t) {
              var e = new j(this);
              return null == t ? t = R : g(t, 0, 8), z(e, e.e + 1, t);
            }, S.isEqualTo = S.eq = function (t, e) {
              return 0 === p(this, new j(t, e));
            }, S.isFinite = function () {
              return !!this.c;
            }, S.isGreaterThan = S.gt = function (t, e) {
              return p(this, new j(t, e)) > 0;
            }, S.isGreaterThanOrEqualTo = S.gte = function (t, e) {
              return 1 === (e = p(this, new j(t, e))) || 0 === e;
            }, S.isInteger = function () {
              return !!this.c && l(this.e / 14) > this.c.length - 2;
            }, S.isLessThan = S.lt = function (t, e) {
              return p(this, new j(t, e)) < 0;
            }, S.isLessThanOrEqualTo = S.lte = function (t, e) {
              return -1 === (e = p(this, new j(t, e))) || 0 === e;
            }, S.isNaN = function () {
              return !this.s;
            }, S.isNegative = function () {
              return this.s < 0;
            }, S.isPositive = function () {
              return this.s > 0;
            }, S.isZero = function () {
              return !!this.c && 0 == this.c[0];
            }, S.minus = function (t, e) {
              var r,
                  n,
                  i,
                  o,
                  s = this,
                  a = s.s;
              if (e = (t = new j(t, e)).s, !a || !e) return new j(NaN);
              if (a != e) return t.s = -e, s.plus(t);
              var u = s.e / 14,
                  f = t.e / 14,
                  c = s.c,
                  h = t.c;

              if (!u || !f) {
                if (!c || !h) return c ? (t.s = -e, t) : new j(h ? s : NaN);
                if (!c[0] || !h[0]) return h[0] ? (t.s = -e, t) : new j(c[0] ? s : 3 == R ? -0 : 0);
              }

              if (u = l(u), f = l(f), c = c.slice(), a = u - f) {
                for ((o = a < 0) ? (a = -a, i = c) : (f = u, i = h), i.reverse(), e = a; e--; i.push(0)) {
                  ;
                }

                i.reverse();
              } else for (n = (o = (a = c.length) < (e = h.length)) ? a : e, a = e = 0; e < n; e++) {
                if (c[e] != h[e]) {
                  o = c[e] < h[e];
                  break;
                }
              }

              if (o && (i = c, c = h, h = i, t.s = -t.s), (e = (n = h.length) - (r = c.length)) > 0) for (; e--; c[r++] = 0) {
                ;
              }

              for (e = 1e14 - 1; n > a;) {
                if (c[--n] < h[n]) {
                  for (r = n; r && !c[--r]; c[r] = e) {
                    ;
                  }

                  --c[r], c[n] += 1e14;
                }

                c[n] -= h[n];
              }

              for (; 0 == c[0]; c.splice(0, 1), --f) {
                ;
              }

              return c[0] ? F(t, c, f) : (t.s = 3 == R ? -1 : 1, t.c = [t.e = 0], t);
            }, S.modulo = S.mod = function (t, e) {
              var n,
                  i,
                  o = this;
              return t = new j(t, e), !o.c || !t.s || t.c && !t.c[0] ? new j(NaN) : !t.c || o.c && !o.c[0] ? new j(o) : (9 == P ? (i = t.s, t.s = 1, n = r(o, t, 0, 3), t.s = i, n.s *= i) : n = r(o, t, 0, P), (t = o.minus(n.times(t))).c[0] || 1 != P || (t.s = o.s), t);
            }, S.multipliedBy = S.times = function (t, e) {
              var r,
                  n,
                  i,
                  o,
                  s,
                  a,
                  u,
                  f,
                  c,
                  h,
                  d,
                  p,
                  g,
                  m = this,
                  b = m.c,
                  v = (t = new j(t, e)).c;
              if (!(b && v && b[0] && v[0])) return !m.s || !t.s || b && !b[0] && !v || v && !v[0] && !b ? t.c = t.e = t.s = null : (t.s *= m.s, b && v ? (t.c = [0], t.e = 0) : t.c = t.e = null), t;

              for (n = l(m.e / 14) + l(t.e / 14), t.s *= m.s, (u = b.length) < (h = v.length) && (g = b, b = v, v = g, i = u, u = h, h = i), i = u + h, g = []; i--; g.push(0)) {
                ;
              }

              for (i = h; --i >= 0;) {
                for (r = 0, d = v[i] % 1e7, p = v[i] / 1e7 | 0, o = i + (s = u); o > i;) {
                  r = ((f = d * (f = b[--s] % 1e7) + (a = p * f + (c = b[s] / 1e7 | 0) * d) % 1e7 * 1e7 + g[o] + r) / 1e14 | 0) + (a / 1e7 | 0) + p * c, g[o--] = f % 1e14;
                }

                g[o] = r;
              }

              return r ? ++n : g.splice(0, 1), F(t, g, n);
            }, S.negated = function () {
              var t = new j(this);
              return t.s = -t.s || null, t;
            }, S.plus = function (t, e) {
              var r,
                  n = this,
                  i = n.s;
              if (e = (t = new j(t, e)).s, !i || !e) return new j(NaN);
              if (i != e) return t.s = -e, n.minus(t);
              var o = n.e / 14,
                  s = t.e / 14,
                  a = n.c,
                  u = t.c;

              if (!o || !s) {
                if (!a || !u) return new j(i / 0);
                if (!a[0] || !u[0]) return u[0] ? t : new j(a[0] ? n : 0 * i);
              }

              if (o = l(o), s = l(s), a = a.slice(), i = o - s) {
                for (i > 0 ? (s = o, r = u) : (i = -i, r = a), r.reverse(); i--; r.push(0)) {
                  ;
                }

                r.reverse();
              }

              for ((i = a.length) - (e = u.length) < 0 && (r = u, u = a, a = r, e = i), i = 0; e;) {
                i = (a[--e] = a[e] + u[e] + i) / 1e14 | 0, a[e] = 1e14 === a[e] ? 0 : a[e] % 1e14;
              }

              return i && (a = [i].concat(a), ++s), F(t, a, s);
            }, S.precision = S.sd = function (t, e) {
              var r,
                  n,
                  i,
                  o = this;
              if (null != t && t !== !!t) return g(t, 1, 1e9), null == e ? e = R : g(e, 0, 8), z(new j(o), t, e);
              if (!(r = o.c)) return null;

              if (n = 14 * (i = r.length - 1) + 1, i = r[i]) {
                for (; i % 10 == 0; i /= 10, n--) {
                  ;
                }

                for (i = r[0]; i >= 10; i /= 10, n++) {
                  ;
                }
              }

              return t && o.e + 1 > n && (n = o.e + 1), n;
            }, S.shiftedBy = function (t) {
              return g(t, -9007199254740991, 9007199254740991), this.times("1e" + t);
            }, S.squareRoot = S.sqrt = function () {
              var t,
                  e,
                  n,
                  i,
                  o,
                  s = this,
                  a = s.c,
                  u = s.s,
                  f = s.e,
                  c = x + 4,
                  h = new j("0.5");
              if (1 !== u || !a || !a[0]) return new j(!u || u < 0 && (!a || a[0]) ? NaN : a ? s : 1 / 0);
              if (0 == (u = Math.sqrt(+q(s))) || u == 1 / 0 ? (((e = d(a)).length + f) % 2 == 0 && (e += "0"), u = Math.sqrt(+e), f = l((f + 1) / 2) - (f < 0 || f % 2), n = new j(e = u == 1 / 0 ? "1e" + f : (e = u.toExponential()).slice(0, e.indexOf("e") + 1) + f)) : n = new j(u + ""), n.c[0]) for ((u = (f = n.e) + c) < 3 && (u = 0);;) {
                if (o = n, n = h.times(o.plus(r(s, o, c, 1))), d(o.c).slice(0, u) === (e = d(n.c)).slice(0, u)) {
                  if (n.e < f && --u, "9999" != (e = e.slice(u - 3, u + 1)) && (i || "4999" != e)) {
                    +e && (+e.slice(1) || "5" != e.charAt(0)) || (z(n, n.e + x + 2, 1), t = !n.times(n).eq(s));
                    break;
                  }

                  if (!i && (z(o, o.e + x + 2, 0), o.times(o).eq(s))) {
                    n = o;
                    break;
                  }

                  c += 4, u += 4, i = 1;
                }
              }
              return z(n, n.e + x + 1, R, t);
            }, S.toExponential = function (t, e) {
              return null != t && (g(t, 0, 1e9), t++), U(this, t, e, 1);
            }, S.toFixed = function (t, e) {
              return null != t && (g(t, 0, 1e9), t = t + this.e + 1), U(this, t, e);
            }, S.toFormat = function (t, e, r) {
              var n,
                  i = this;
              if (null == r) null != t && e && "object" == typeof e ? (r = e, e = null) : t && "object" == typeof t ? (r = t, t = e = null) : r = C;else if ("object" != typeof r) throw Error(f + "Argument not an object: " + r);

              if (n = i.toFixed(t, e), i.c) {
                var o,
                    s = n.split("."),
                    a = +r.groupSize,
                    u = +r.secondaryGroupSize,
                    c = r.groupSeparator || "",
                    h = s[0],
                    l = s[1],
                    d = i.s < 0,
                    p = d ? h.slice(1) : h,
                    g = p.length;

                if (u && (o = a, a = u, u = o, g -= o), a > 0 && g > 0) {
                  for (o = g % a || a, h = p.substr(0, o); o < g; o += a) {
                    h += c + p.substr(o, a);
                  }

                  u > 0 && (h += c + p.slice(o)), d && (h = "-" + h);
                }

                n = l ? h + (r.decimalSeparator || "") + ((u = +r.fractionGroupSize) ? l.replace(new RegExp("\\d{" + u + "}\\B", "g"), "$&" + (r.fractionGroupSeparator || "")) : l) : h;
              }

              return (r.prefix || "") + n + (r.suffix || "");
            }, S.toFraction = function (t) {
              var e,
                  n,
                  i,
                  o,
                  s,
                  a,
                  u,
                  c,
                  l,
                  p,
                  g,
                  m,
                  b = this,
                  v = b.c;
              if (null != t && (!(u = new j(t)).isInteger() && (u.c || 1 !== u.s) || u.lt(A))) throw Error(f + "Argument " + (u.isInteger() ? "out of range: " : "not an integer: ") + q(u));
              if (!v) return new j(b);

              for (e = new j(A), l = n = new j(A), i = c = new j(A), m = d(v), s = e.e = m.length - b.e - 1, e.c[0] = h[(a = s % 14) < 0 ? 14 + a : a], t = !t || u.comparedTo(e) > 0 ? s > 0 ? e : l : u, a = B, B = 1 / 0, u = new j(m), c.c[0] = 0; p = r(u, e, 0, 1), 1 != (o = n.plus(p.times(i))).comparedTo(t);) {
                n = i, i = o, l = c.plus(p.times(o = l)), c = o, e = u.minus(p.times(o = e)), u = o;
              }

              return o = r(t.minus(n), i, 0, 1), c = c.plus(o.times(l)), n = n.plus(o.times(i)), c.s = l.s = b.s, g = r(l, i, s *= 2, R).minus(b).abs().comparedTo(r(c, n, s, R).minus(b).abs()) < 1 ? [l, i] : [c, n], B = a, g;
            }, S.toNumber = function () {
              return +q(this);
            }, S.toPrecision = function (t, e) {
              return null != t && g(t, 1, 1e9), U(this, t, e, 2);
            }, S.toString = function (t) {
              var e,
                  r = this,
                  i = r.s,
                  o = r.e;
              return null === o ? i ? (e = "Infinity", i < 0 && (e = "-" + e)) : e = "NaN" : (null == t ? e = o <= T || o >= k ? b(d(r.c), o) : v(d(r.c), o, "0") : 10 === t ? e = v(d((r = z(new j(r), x + o + 1, R)).c), r.e, "0") : (g(t, 2, L.length, "Base"), e = n(v(d(r.c), o, "0"), 10, t, i, !0)), i < 0 && r.c[0] && (e = "-" + e)), e;
            }, S.valueOf = S.toJSON = function () {
              return q(this);
            }, S._isBigNumber = !0, null != e && j.set(e), j;
          }()).default = o.BigNumber = o, void 0 === (n = function () {
            return o;
          }.call(e, r, e, t)) || (t.exports = n);
        }();
      }, function (t, e) {
        t.exports = function (t) {
          return t.webpackPolyfill || (t.deprecate = function () {}, t.paths = [], t.children || (t.children = []), Object.defineProperty(t, "loaded", {
            enumerable: !0,
            get: function get() {
              return t.l;
            }
          }), Object.defineProperty(t, "id", {
            enumerable: !0,
            get: function get() {
              return t.i;
            }
          }), t.webpackPolyfill = 1), t;
        };
      }, function (t, e) {}, function (t, e) {
        var r,
            n,
            i = t.exports = {};

        function o() {
          throw new Error("setTimeout has not been defined");
        }

        function s() {
          throw new Error("clearTimeout has not been defined");
        }

        function a(t) {
          if (r === setTimeout) return setTimeout(t, 0);
          if ((r === o || !r) && setTimeout) return r = setTimeout, setTimeout(t, 0);

          try {
            return r(t, 0);
          } catch (e) {
            try {
              return r.call(null, t, 0);
            } catch (e) {
              return r.call(this, t, 0);
            }
          }
        }

        !function () {
          try {
            r = "function" == typeof setTimeout ? setTimeout : o;
          } catch (t) {
            r = o;
          }

          try {
            n = "function" == typeof clearTimeout ? clearTimeout : s;
          } catch (t) {
            n = s;
          }
        }();
        var u,
            f = [],
            c = !1,
            h = -1;

        function l() {
          c && u && (c = !1, u.length ? f = u.concat(f) : h = -1, f.length && d());
        }

        function d() {
          if (!c) {
            var t = a(l);
            c = !0;

            for (var e = f.length; e;) {
              for (u = f, f = []; ++h < e;) {
                u && u[h].run();
              }

              h = -1, e = f.length;
            }

            u = null, c = !1, function (t) {
              if (n === clearTimeout) return clearTimeout(t);
              if ((n === s || !n) && clearTimeout) return n = clearTimeout, clearTimeout(t);

              try {
                n(t);
              } catch (e) {
                try {
                  return n.call(null, t);
                } catch (e) {
                  return n.call(this, t);
                }
              }
            }(t);
          }
        }

        function p(t, e) {
          this.fun = t, this.array = e;
        }

        function g() {}

        i.nextTick = function (t) {
          var e = new Array(arguments.length - 1);
          if (arguments.length > 1) for (var r = 1; r < arguments.length; r++) {
            e[r - 1] = arguments[r];
          }
          f.push(new p(t, e)), 1 !== f.length || c || a(d);
        }, p.prototype.run = function () {
          this.fun.apply(null, this.array);
        }, i.title = "browser", i.browser = !0, i.env = {}, i.argv = [], i.version = "", i.versions = {}, i.on = g, i.addListener = g, i.once = g, i.off = g, i.removeListener = g, i.removeAllListeners = g, i.emit = g, i.prependListener = g, i.prependOnceListener = g, i.listeners = function (t) {
          return [];
        }, i.binding = function (t) {
          throw new Error("process.binding is not supported");
        }, i.cwd = function () {
          return "/";
        }, i.chdir = function (t) {
          throw new Error("process.chdir is not supported");
        }, i.umask = function () {
          return 0;
        };
      }, function (t, e, r) {
        "use strict";

        r.r(e);
        var n = r(2);
        n.a.from(-1), n.a.from(0), n.a.from(1), n.a.from(2), n.a.from("1000000000000000000"), n.a.from("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
        var i = r(0);
        var o = new (r(1).a)("strings/5.0.0-beta.136");
        var s, a;

        function u(t, e, r, n, i) {
          if (t === a.BAD_PREFIX || t === a.UNEXPECTED_CONTINUE) {
            var _t7 = 0;

            for (var _n10 = e + 1; _n10 < r.length && r[_n10] >> 6 == 2; _n10++) {
              _t7++;
            }

            return _t7;
          }

          return t === a.OVERRUN ? r.length - e - 1 : 0;
        }

        !function (t) {
          t.current = "", t.NFC = "NFC", t.NFD = "NFD", t.NFKC = "NFKC", t.NFKD = "NFKD";
        }(s || (s = {})), function (t) {
          t.UNEXPECTED_CONTINUE = "unexpected continuation byte", t.BAD_PREFIX = "bad codepoint prefix", t.OVERRUN = "string overrun", t.MISSING_CONTINUE = "missing continuation byte", t.OUT_OF_RANGE = "out of UTF-8 range", t.UTF16_SURROGATE = "UTF-16 surrogate", t.OVERLONG = "overlong representation";
        }(a || (a = {}));
        var f = Object.freeze({
          error: function error(t, e, r, n, i) {
            return o.throwArgumentError("invalid codepoint at offset ".concat(e, "; ").concat(t), "bytes", r);
          },
          ignore: u,
          replace: function replace(t, e, r, n, i) {
            return t === a.OVERLONG ? (n.push(i), 0) : (n.push(65533), u(t, e, r));
          }
        });

        function c(t, e) {
          null == e && (e = f.error), t = Object(i.arrayify)(t);
          var r = [];
          var n = 0;

          for (; n < t.length;) {
            var _i = t[n++];

            if (_i >> 7 == 0) {
              r.push(_i);
              continue;
            }

            var _o5 = null,
                _s = null;
            if (192 == (224 & _i)) _o5 = 1, _s = 127;else if (224 == (240 & _i)) _o5 = 2, _s = 2047;else {
              if (240 != (248 & _i)) {
                n += e(128 == (192 & _i) ? a.UNEXPECTED_CONTINUE : a.BAD_PREFIX, n - 1, t, r);
                continue;
              }

              _o5 = 3, _s = 65535;
            }

            if (n - 1 + _o5 >= t.length) {
              n += e(a.OVERRUN, n - 1, t, r);
              continue;
            }

            var _u = _i & (1 << 8 - _o5 - 1) - 1;

            for (var _i2 = 0; _i2 < _o5; _i2++) {
              var _i3 = t[n];

              if (128 != (192 & _i3)) {
                n += e(a.MISSING_CONTINUE, n, t, r), _u = null;
                break;
              }

              _u = _u << 6 | 63 & _i3, n++;
            }

            null !== _u && (_u > 1114111 ? n += e(a.OUT_OF_RANGE, n - 1 - _o5, t, r, _u) : _u >= 55296 && _u <= 57343 ? n += e(a.UTF16_SURROGATE, n - 1 - _o5, t, r, _u) : _u <= _s ? n += e(a.OVERLONG, n - 1 - _o5, t, r, _u) : r.push(_u));
          }

          return r;
        }

        function h(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : s.current;
          e != s.current && (o.checkNormalize(), t = t.normalize(e));
          var r = [];

          for (var _e8 = 0; _e8 < t.length; _e8++) {
            var _n11 = t.charCodeAt(_e8);

            if (_n11 < 128) r.push(_n11);else if (_n11 < 2048) r.push(_n11 >> 6 | 192), r.push(63 & _n11 | 128);else if (55296 == (64512 & _n11)) {
              _e8++;

              var _i4 = t.charCodeAt(_e8);

              if (_e8 >= t.length || 56320 != (64512 & _i4)) throw new Error("invalid utf-8 string");

              var _o6 = 65536 + ((1023 & _n11) << 10) + (1023 & _i4);

              r.push(_o6 >> 18 | 240), r.push(_o6 >> 12 & 63 | 128), r.push(_o6 >> 6 & 63 | 128), r.push(63 & _o6 | 128);
            } else r.push(_n11 >> 12 | 224), r.push(_n11 >> 6 & 63 | 128), r.push(63 & _n11 | 128);
          }

          return Object(i.arrayify)(r);
        }

        function l(t) {
          var e = "0000" + t.toString(16);
          return "\\u" + e.substring(e.length - 4);
        }

        function d(t, e) {
          return '"' + c(t, e).map(function (t) {
            if (t < 256) {
              switch (t) {
                case 8:
                  return "\\b";

                case 9:
                  return "\\t";

                case 10:
                  return "\\n";

                case 13:
                  return "\\r";

                case 34:
                  return '\\"';

                case 92:
                  return "\\\\";
              }

              if (t >= 32 && t < 127) return String.fromCharCode(t);
            }

            return t <= 65535 ? l(t) : l(55296 + ((t -= 65536) >> 10 & 1023)) + l(56320 + (1023 & t));
          }).join("") + '"';
        }

        function p(t) {
          return t.map(function (t) {
            return t <= 65535 ? String.fromCharCode(t) : (t -= 65536, String.fromCharCode(55296 + (t >> 10 & 1023), 56320 + (1023 & t)));
          }).join("");
        }

        function g(t, e) {
          return p(c(t, e));
        }

        function m(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : s.current;
          return c(h(t, e));
        }

        function b(t) {
          var e = h(t);
          if (e.length > 31) throw new Error("bytes32 string must be less than 32 bytes");
          return Object(i.hexlify)(Object(i.concat)([e, "0x0000000000000000000000000000000000000000000000000000000000000000"]).slice(0, 32));
        }

        function v(t) {
          var e = Object(i.arrayify)(t);
          if (32 !== e.length) throw new Error("invalid bytes32 - not 32 bytes long");
          if (0 !== e[31]) throw new Error("invalid bytes32 string - no null terminator");
          var r = 31;

          for (; 0 === e[r - 1];) {
            r--;
          }

          return g(e.slice(0, r));
        }

        function y(t, e) {
          e || (e = function e(t) {
            return [parseInt(t, 16)];
          });
          var r = 0,
              n = {};
          return t.split(",").forEach(function (t) {
            var i = t.split(":");
            r += parseInt(i[0], 16), n[r] = e(i[1]);
          }), n;
        }

        function _(t) {
          var e = 0;
          return t.split(",").map(function (t) {
            var r = t.split("-");
            1 === r.length ? r[1] = "0" : "" === r[1] && (r[1] = "1");
            var n = e + parseInt(r[0], 16);
            return e = parseInt(r[1], 16), {
              l: n,
              h: e
            };
          });
        }

        function w(t, e) {
          var r = 0;

          for (var _n12 = 0; _n12 < e.length; _n12++) {
            var _i5 = e[_n12];

            if (r += _i5.l, t >= r && t <= r + _i5.h && (t - r) % (_i5.d || 1) == 0) {
              if (_i5.e && -1 !== _i5.e.indexOf(t - r)) continue;
              return _i5;
            }
          }

          return null;
        }

        var E = _("221,13-1b,5f-,40-10,51-f,11-3,3-3,2-2,2-4,8,2,15,2d,28-8,88,48,27-,3-5,11-20,27-,8,28,3-5,12,18,b-a,1c-4,6-16,2-d,2-2,2,1b-4,17-9,8f-,10,f,1f-2,1c-34,33-14e,4,36-,13-,6-2,1a-f,4,9-,3-,17,8,2-2,5-,2,8-,3-,4-8,2-3,3,6-,16-6,2-,7-3,3-,17,8,3,3,3-,2,6-3,3-,4-a,5,2-6,10-b,4,8,2,4,17,8,3,6-,b,4,4-,2-e,2-4,b-10,4,9-,3-,17,8,3-,5-,9-2,3-,4-7,3-3,3,4-3,c-10,3,7-2,4,5-2,3,2,3-2,3-2,4-2,9,4-3,6-2,4,5-8,2-e,d-d,4,9,4,18,b,6-3,8,4,5-6,3-8,3-3,b-11,3,9,4,18,b,6-3,8,4,5-6,3-6,2,3-3,b-11,3,9,4,18,11-3,7-,4,5-8,2-7,3-3,b-11,3,13-2,19,a,2-,8-2,2-3,7,2,9-11,4-b,3b-3,1e-24,3,2-,3,2-,2-5,5,8,4,2,2-,3,e,4-,6,2,7-,b-,3-21,49,23-5,1c-3,9,25,10-,2-2f,23,6,3,8-2,5-5,1b-45,27-9,2a-,2-3,5b-4,45-4,53-5,8,40,2,5-,8,2,5-,28,2,5-,20,2,5-,8,2,5-,8,8,18,20,2,5-,8,28,14-5,1d-22,56-b,277-8,1e-2,52-e,e,8-a,18-8,15-b,e,4,3-b,5e-2,b-15,10,b-5,59-7,2b-555,9d-3,5b-5,17-,7-,27-,7-,9,2,2,2,20-,36,10,f-,7,14-,4,a,54-3,2-6,6-5,9-,1c-10,13-1d,1c-14,3c-,10-6,32-b,240-30,28-18,c-14,a0,115-,3,66-,b-76,5,5-,1d,24,2,5-2,2,8-,35-2,19,f-10,1d-3,311-37f,1b,5a-b,d7-19,d-3,41,57-,68-4,29-3,5f,29-37,2e-2,25-c,2c-2,4e-3,30,78-3,64-,20,19b7-49,51a7-59,48e-2,38-738,2ba5-5b,222f-,3c-94,8-b,6-4,1b,6,2,3,3,6d-20,16e-f,41-,37-7,2e-2,11-f,5-b,18-,b,14,5-3,6,88-,2,bf-2,7-,7-,7-,4-2,8,8-9,8-2ff,20,5-b,1c-b4,27-,27-cbb1,f7-9,28-2,b5-221,56,48,3-,2-,3-,5,d,2,5,3,42,5-,9,8,1d,5,6,2-2,8,153-3,123-3,33-27fd,a6da-5128,21f-5df,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3,2-1d,61-ff7d"),
            M = "ad,34f,1806,180b,180c,180d,200b,200c,200d,2060,feff".split(",").map(function (t) {
          return parseInt(t, 16);
        }),
            S = [{
          h: 25,
          s: 32,
          l: 65
        }, {
          h: 30,
          s: 32,
          e: [23],
          l: 127
        }, {
          h: 54,
          s: 1,
          e: [48],
          l: 64,
          d: 2
        }, {
          h: 14,
          s: 1,
          l: 57,
          d: 2
        }, {
          h: 44,
          s: 1,
          l: 17,
          d: 2
        }, {
          h: 10,
          s: 1,
          e: [2, 6, 8],
          l: 61,
          d: 2
        }, {
          h: 16,
          s: 1,
          l: 68,
          d: 2
        }, {
          h: 84,
          s: 1,
          e: [18, 24, 66],
          l: 19,
          d: 2
        }, {
          h: 26,
          s: 32,
          e: [17],
          l: 435
        }, {
          h: 22,
          s: 1,
          l: 71,
          d: 2
        }, {
          h: 15,
          s: 80,
          l: 40
        }, {
          h: 31,
          s: 32,
          l: 16
        }, {
          h: 32,
          s: 1,
          l: 80,
          d: 2
        }, {
          h: 52,
          s: 1,
          l: 42,
          d: 2
        }, {
          h: 12,
          s: 1,
          l: 55,
          d: 2
        }, {
          h: 40,
          s: 1,
          e: [38],
          l: 15,
          d: 2
        }, {
          h: 14,
          s: 1,
          l: 48,
          d: 2
        }, {
          h: 37,
          s: 48,
          l: 49
        }, {
          h: 148,
          s: 1,
          l: 6351,
          d: 2
        }, {
          h: 88,
          s: 1,
          l: 160,
          d: 2
        }, {
          h: 15,
          s: 16,
          l: 704
        }, {
          h: 25,
          s: 26,
          l: 854
        }, {
          h: 25,
          s: 32,
          l: 55915
        }, {
          h: 37,
          s: 40,
          l: 1247
        }, {
          h: 25,
          s: -119711,
          l: 53248
        }, {
          h: 25,
          s: -119763,
          l: 52
        }, {
          h: 25,
          s: -119815,
          l: 52
        }, {
          h: 25,
          s: -119867,
          e: [1, 4, 5, 7, 8, 11, 12, 17],
          l: 52
        }, {
          h: 25,
          s: -119919,
          l: 52
        }, {
          h: 24,
          s: -119971,
          e: [2, 7, 8, 17],
          l: 52
        }, {
          h: 24,
          s: -120023,
          e: [2, 7, 13, 15, 16, 17],
          l: 52
        }, {
          h: 25,
          s: -120075,
          l: 52
        }, {
          h: 25,
          s: -120127,
          l: 52
        }, {
          h: 25,
          s: -120179,
          l: 52
        }, {
          h: 25,
          s: -120231,
          l: 52
        }, {
          h: 25,
          s: -120283,
          l: 52
        }, {
          h: 25,
          s: -120335,
          l: 52
        }, {
          h: 24,
          s: -119543,
          e: [17],
          l: 56
        }, {
          h: 24,
          s: -119601,
          e: [17],
          l: 58
        }, {
          h: 24,
          s: -119659,
          e: [17],
          l: 58
        }, {
          h: 24,
          s: -119717,
          e: [17],
          l: 58
        }, {
          h: 24,
          s: -119775,
          e: [17],
          l: 58
        }],
            A = y("b5:3bc,c3:ff,7:73,2:253,5:254,3:256,1:257,5:259,1:25b,3:260,1:263,2:269,1:268,5:26f,1:272,2:275,7:280,3:283,5:288,3:28a,1:28b,5:292,3f:195,1:1bf,29:19e,125:3b9,8b:3b2,1:3b8,1:3c5,3:3c6,1:3c0,1a:3ba,1:3c1,1:3c3,2:3b8,1:3b5,1bc9:3b9,1c:1f76,1:1f77,f:1f7a,1:1f7b,d:1f78,1:1f79,1:1f7c,1:1f7d,107:63,5:25b,4:68,1:68,1:68,3:69,1:69,1:6c,3:6e,4:70,1:71,1:72,1:72,1:72,7:7a,2:3c9,2:7a,2:6b,1:e5,1:62,1:63,3:65,1:66,2:6d,b:3b3,1:3c0,6:64,1b574:3b8,1a:3c3,20:3b8,1a:3c3,20:3b8,1a:3c3,20:3b8,1a:3c3,20:3b8,1a:3c3"),
            x = y("179:1,2:1,2:1,5:1,2:1,a:4f,a:1,8:1,2:1,2:1,3:1,5:1,3:1,4:1,2:1,3:1,4:1,8:2,1:1,2:2,1:1,2:2,27:2,195:26,2:25,1:25,1:25,2:40,2:3f,1:3f,33:1,11:-6,1:-9,1ac7:-3a,6d:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,b:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,c:-8,2:-8,2:-8,2:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,49:-8,1:-8,1:-4a,1:-4a,d:-56,1:-56,1:-56,1:-56,d:-8,1:-8,f:-8,1:-8,3:-7"),
            R = y("df:00730073,51:00690307,19:02BC006E,a7:006A030C,18a:002003B9,16:03B903080301,20:03C503080301,1d7:05650582,190f:00680331,1:00740308,1:0077030A,1:0079030A,1:006102BE,b6:03C50313,2:03C503130300,2:03C503130301,2:03C503130342,2a:1F0003B9,1:1F0103B9,1:1F0203B9,1:1F0303B9,1:1F0403B9,1:1F0503B9,1:1F0603B9,1:1F0703B9,1:1F0003B9,1:1F0103B9,1:1F0203B9,1:1F0303B9,1:1F0403B9,1:1F0503B9,1:1F0603B9,1:1F0703B9,1:1F2003B9,1:1F2103B9,1:1F2203B9,1:1F2303B9,1:1F2403B9,1:1F2503B9,1:1F2603B9,1:1F2703B9,1:1F2003B9,1:1F2103B9,1:1F2203B9,1:1F2303B9,1:1F2403B9,1:1F2503B9,1:1F2603B9,1:1F2703B9,1:1F6003B9,1:1F6103B9,1:1F6203B9,1:1F6303B9,1:1F6403B9,1:1F6503B9,1:1F6603B9,1:1F6703B9,1:1F6003B9,1:1F6103B9,1:1F6203B9,1:1F6303B9,1:1F6403B9,1:1F6503B9,1:1F6603B9,1:1F6703B9,3:1F7003B9,1:03B103B9,1:03AC03B9,2:03B10342,1:03B1034203B9,5:03B103B9,6:1F7403B9,1:03B703B9,1:03AE03B9,2:03B70342,1:03B7034203B9,5:03B703B9,6:03B903080300,1:03B903080301,3:03B90342,1:03B903080342,b:03C503080300,1:03C503080301,1:03C10313,2:03C50342,1:03C503080342,b:1F7C03B9,1:03C903B9,1:03CE03B9,2:03C90342,1:03C9034203B9,5:03C903B9,ac:00720073,5b:00B00063,6:00B00066,d:006E006F,a:0073006D,1:00740065006C,1:0074006D,124f:006800700061,2:00610075,2:006F0076,b:00700061,1:006E0061,1:03BC0061,1:006D0061,1:006B0061,1:006B0062,1:006D0062,1:00670062,3:00700066,1:006E0066,1:03BC0066,4:0068007A,1:006B0068007A,1:006D0068007A,1:00670068007A,1:00740068007A,15:00700061,1:006B00700061,1:006D00700061,1:006700700061,8:00700076,1:006E0076,1:03BC0076,1:006D0076,1:006B0076,1:006D0076,1:00700077,1:006E0077,1:03BC0077,1:006D0077,1:006B0077,1:006D0077,1:006B03C9,1:006D03C9,2:00620071,3:00632215006B0067,1:0063006F002E,1:00640062,1:00670079,2:00680070,2:006B006B,1:006B006D,9:00700068,2:00700070006D,1:00700072,2:00730076,1:00770062,c723:00660066,1:00660069,1:0066006C,1:006600660069,1:00660066006C,1:00730074,1:00730074,d:05740576,1:05740565,1:0574056B,1:057E0576,1:0574056D", function (t) {
          if (t.length % 4 != 0) throw new Error("bad data");
          var e = [];

          for (var _r9 = 0; _r9 < t.length; _r9 += 4) {
            e.push(parseInt(t.substring(_r9, _r9 + 4), 16));
          }

          return e;
        }),
            T = _("80-20,2a0-,39c,32,f71,18e,7f2-f,19-7,30-4,7-5,f81-b,5,a800-20ff,4d1-1f,110,fa-6,d174-7,2e84-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,2,1f-5f,ff7f-20001");

        function k(t) {
          if (t.match(/^[a-z0-9-]*$/i) && t.length <= 59) return t.toLowerCase();
          var e = m(t);
          var r;
          r = e.map(function (t) {
            return M.indexOf(t) >= 0 ? [] : t >= 65024 && t <= 65039 ? [] : function (t) {
              var e = w(t, S);
              if (e) return [t + e.s];
              var r = A[t];
              if (r) return r;
              var n = x[t];
              return n ? [t + n[0]] : R[t] || null;
            }(t) || [t];
          }), e = r.reduce(function (t, e) {
            return e.forEach(function (e) {
              t.push(e);
            }), t;
          }, []), e = m(p(e), s.NFKC), e.forEach(function (t) {
            if (w(t, T)) throw new Error("STRINGPREP_CONTAINS_PROHIBITED");
          }), e.forEach(function (t) {
            if (w(t, E)) throw new Error("STRINGPREP_CONTAINS_UNASSIGNED");
          });
          var n = p(e);
          if ("-" === n.substring(0, 1) || "--" === n.substring(2, 4) || "-" === n.substring(n.length - 1)) throw new Error("invalid hyphen");
          if (n.length > 63) throw new Error("too long");
          return n;
        }

        r.d(e, "_toEscapedUtf8String", function () {
          return d;
        }), r.d(e, "toUtf8Bytes", function () {
          return h;
        }), r.d(e, "toUtf8CodePoints", function () {
          return m;
        }), r.d(e, "toUtf8String", function () {
          return g;
        }), r.d(e, "Utf8ErrorFuncs", function () {
          return f;
        }), r.d(e, "Utf8ErrorReason", function () {
          return a;
        }), r.d(e, "UnicodeNormalizationForm", function () {
          return s;
        }), r.d(e, "formatBytes32String", function () {
          return b;
        }), r.d(e, "parseBytes32String", function () {
          return v;
        }), r.d(e, "nameprep", function () {
          return k;
        });
      }, function (t, e, r) {
        "use strict";

        r.r(e);
        var n = r(3),
            i = r(0),
            o = r(2),
            s = r(5),
            a = r.n(s);

        function u(t) {
          return "0x" + a.a.keccak_256(Object(i.arrayify)(t));
        }

        function f(t) {
          var e = [];

          for (; t;) {
            e.unshift(255 & t), t >>= 8;
          }

          return e;
        }

        var c = r(1);
        r.d(e, "getAddress", function () {
          return b;
        }), r.d(e, "isAddress", function () {
          return v;
        }), r.d(e, "getIcapAddress", function () {
          return y;
        }), r.d(e, "getContractAddress", function () {
          return _;
        }), r.d(e, "getCreate2Address", function () {
          return w;
        });
        var h = new c.a("address/5.0.0-beta.134");

        function l(t) {
          Object(i.isHexString)(t, 20) || h.throwArgumentError("invalid address", "address", t);
          var e = (t = t.toLowerCase()).substring(2).split(""),
              r = new Uint8Array(40);

          for (var _t8 = 0; _t8 < 40; _t8++) {
            r[_t8] = e[_t8].charCodeAt(0);
          }

          var n = Object(i.arrayify)(u(r));

          for (var _t9 = 0; _t9 < 40; _t9 += 2) {
            n[_t9 >> 1] >> 4 >= 8 && (e[_t9] = e[_t9].toUpperCase()), (15 & n[_t9 >> 1]) >= 8 && (e[_t9 + 1] = e[_t9 + 1].toUpperCase());
          }

          return "0x" + e.join("");
        }

        var d = {};

        for (var _t10 = 0; _t10 < 10; _t10++) {
          d[String(_t10)] = String(_t10);
        }

        for (var _t11 = 0; _t11 < 26; _t11++) {
          d[String.fromCharCode(65 + _t11)] = String(10 + _t11);
        }

        var p = Math.floor((g = 9007199254740991, Math.log10 ? Math.log10(g) : Math.log(g) / Math.LN10));
        var g;

        function m(t) {
          var e = (t = (t = t.toUpperCase()).substring(4) + t.substring(0, 2) + "00").split("").map(function (t) {
            return d[t];
          }).join("");

          for (; e.length >= p;) {
            var _t12 = e.substring(0, p);

            e = parseInt(_t12, 10) % 97 + e.substring(_t12.length);
          }

          var r = String(98 - parseInt(e, 10) % 97);

          for (; r.length < 2;) {
            r = "0" + r;
          }

          return r;
        }

        function b(t) {
          var e = null;
          if ("string" != typeof t && h.throwArgumentError("invalid address", "address", t), t.match(/^(0x)?[0-9a-fA-F]{40}$/)) "0x" !== t.substring(0, 2) && (t = "0x" + t), e = l(t), t.match(/([A-F].*[a-f])|([a-f].*[A-F])/) && e !== t && h.throwArgumentError("bad address checksum", "address", t);else if (t.match(/^XE[0-9]{2}[0-9A-Za-z]{30,31}$/)) {
            for (t.substring(2, 4) !== m(t) && h.throwArgumentError("bad icap checksum", "address", t), e = new n.BN(t.substring(4), 36).toString(16); e.length < 40;) {
              e = "0" + e;
            }

            e = l("0x" + e);
          } else h.throwArgumentError("invalid address", "address", t);
          return e;
        }

        function v(t) {
          try {
            return b(t), !0;
          } catch (t) {}

          return !1;
        }

        function y(t) {
          var e = new n.BN(b(t).substring(2), 16).toString(36).toUpperCase();

          for (; e.length < 30;) {
            e = "0" + e;
          }

          return "XE" + m("XE00" + e) + e;
        }

        function _(t) {
          var e = null;

          try {
            e = b(t.from);
          } catch (e) {
            h.throwArgumentError("missing from address", "transaction", t);
          }

          var r = Object(i.stripZeros)(Object(i.arrayify)(o.a.from(t.nonce).toHexString()));
          return b(Object(i.hexDataSlice)(u(function (t) {
            return Object(i.hexlify)(function t(e) {
              if (Array.isArray(e)) {
                var _r10 = [];
                if (e.forEach(function (e) {
                  _r10 = _r10.concat(t(e));
                }), _r10.length <= 55) return _r10.unshift(192 + _r10.length), _r10;

                var _n13 = f(_r10.length);

                return _n13.unshift(247 + _n13.length), _n13.concat(_r10);
              }

              var r = Array.prototype.slice.call(Object(i.arrayify)(e));
              if (1 === r.length && r[0] <= 127) return r;
              if (r.length <= 55) return r.unshift(128 + r.length), r;
              var n = f(r.length);
              return n.unshift(183 + n.length), n.concat(r);
            }(t));
          }([e, r])), 12));
        }

        function w(t, e, r) {
          return 32 !== Object(i.hexDataLength)(e) && h.throwArgumentError("salt must be 32 bytes", "salt", e), 32 !== Object(i.hexDataLength)(r) && h.throwArgumentError("initCodeHash must be 32 bytes", "initCodeHash", r), b(Object(i.hexDataSlice)(u(Object(i.concat)(["0xff", b(t), e, r])), 12));
        }
      }]);
    }, function (t, e, r) {
      "use strict";

      Object.defineProperty(e, "__esModule", {
        value: !0
      });

      var n = r(0),
          i = n.__importDefault(r(3)),
          o = n.__importStar(r(4)),
          s = n.__importDefault(r(5)),
          a = function (t) {
        function e(e) {
          return t.call(this, o, e, null, s.default) || this;
        }

        return n.__extends(e, t), e;
      }(i.default);

      e.default = a;
    }, function (t, e, r) {
      t.exports = function (t) {
        var e = {};

        function r(n) {
          if (e[n]) return e[n].exports;
          var i = e[n] = {
            i: n,
            l: !1,
            exports: {}
          };
          return t[n].call(i.exports, i, i.exports, r), i.l = !0, i.exports;
        }

        return r.m = t, r.c = e, r.d = function (t, e, n) {
          r.o(t, e) || Object.defineProperty(t, e, {
            enumerable: !0,
            get: n
          });
        }, r.r = function (t) {
          "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
            value: "Module"
          }), Object.defineProperty(t, "__esModule", {
            value: !0
          });
        }, r.t = function (t, e) {
          if (1 & e && (t = r(t)), 8 & e) return t;
          if (4 & e && "object" == typeof t && t && t.__esModule) return t;
          var n = Object.create(null);
          if (r.r(n), Object.defineProperty(n, "default", {
            enumerable: !0,
            value: t
          }), 2 & e && "string" != typeof t) for (var i in t) {
            r.d(n, i, function (e) {
              return t[e];
            }.bind(null, i));
          }
          return n;
        }, r.n = function (t) {
          var e = t && t.__esModule ? function () {
            return t.default;
          } : function () {
            return t;
          };
          return r.d(e, "a", e), e;
        }, r.o = function (t, e) {
          return Object.prototype.hasOwnProperty.call(t, e);
        }, r.p = "", r(r.s = 2);
      }([function (t, e, r) {
        "use strict";

        r.r(e), r.d(e, "__extends", function () {
          return i;
        }), r.d(e, "__assign", function () {
          return _o7;
        }), r.d(e, "__rest", function () {
          return s;
        }), r.d(e, "__decorate", function () {
          return a;
        }), r.d(e, "__param", function () {
          return u;
        }), r.d(e, "__metadata", function () {
          return f;
        }), r.d(e, "__awaiter", function () {
          return c;
        }), r.d(e, "__generator", function () {
          return h;
        }), r.d(e, "__exportStar", function () {
          return l;
        }), r.d(e, "__values", function () {
          return d;
        }), r.d(e, "__read", function () {
          return p;
        }), r.d(e, "__spread", function () {
          return g;
        }), r.d(e, "__await", function () {
          return m;
        }), r.d(e, "__asyncGenerator", function () {
          return b;
        }), r.d(e, "__asyncDelegator", function () {
          return v;
        }), r.d(e, "__asyncValues", function () {
          return y;
        }), r.d(e, "__makeTemplateObject", function () {
          return _;
        }), r.d(e, "__importStar", function () {
          return w;
        }), r.d(e, "__importDefault", function () {
          return E;
        });
        /*! *****************************************************************************
        Copyright (c) Microsoft Corporation. All rights reserved.
        Licensed under the Apache License, Version 2.0 (the "License"); you may not use
        this file except in compliance with the License. You may obtain a copy of the
        License at http://www.apache.org/licenses/LICENSE-2.0
        
        THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
        KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
        WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
        MERCHANTABLITY OR NON-INFRINGEMENT.
        
        See the Apache Version 2.0 License for specific language governing permissions
        and limitations under the License.
        ***************************************************************************** */

        var _n14 = function n(t, e) {
          return (_n14 = Object.setPrototypeOf || {
            __proto__: []
          } instanceof Array && function (t, e) {
            t.__proto__ = e;
          } || function (t, e) {
            for (var r in e) {
              e.hasOwnProperty(r) && (t[r] = e[r]);
            }
          })(t, e);
        };

        function i(t, e) {
          function r() {
            this.constructor = t;
          }

          _n14(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
        }

        var _o7 = function o() {
          return (_o7 = Object.assign || function (t) {
            for (var e, r = 1, n = arguments.length; r < n; r++) {
              for (var i in e = arguments[r]) {
                Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
              }
            }

            return t;
          }).apply(this, arguments);
        };

        function s(t, e) {
          var r = {};

          for (var n in t) {
            Object.prototype.hasOwnProperty.call(t, n) && e.indexOf(n) < 0 && (r[n] = t[n]);
          }

          if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
            var i = 0;

            for (n = Object.getOwnPropertySymbols(t); i < n.length; i++) {
              e.indexOf(n[i]) < 0 && (r[n[i]] = t[n[i]]);
            }
          }

          return r;
        }

        function a(t, e, r, n) {
          var i,
              o = arguments.length,
              s = o < 3 ? e : null === n ? n = Object.getOwnPropertyDescriptor(e, r) : n;
          if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) s = Reflect.decorate(t, e, r, n);else for (var a = t.length - 1; a >= 0; a--) {
            (i = t[a]) && (s = (o < 3 ? i(s) : o > 3 ? i(e, r, s) : i(e, r)) || s);
          }
          return o > 3 && s && Object.defineProperty(e, r, s), s;
        }

        function u(t, e) {
          return function (r, n) {
            e(r, n, t);
          };
        }

        function f(t, e) {
          if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(t, e);
        }

        function c(t, e, r, n) {
          return new (r || (r = Promise))(function (i, o) {
            function s(t) {
              try {
                u(n.next(t));
              } catch (t) {
                o(t);
              }
            }

            function a(t) {
              try {
                u(n.throw(t));
              } catch (t) {
                o(t);
              }
            }

            function u(t) {
              t.done ? i(t.value) : new r(function (e) {
                e(t.value);
              }).then(s, a);
            }

            u((n = n.apply(t, e || [])).next());
          });
        }

        function h(t, e) {
          var r,
              n,
              i,
              o,
              s = {
            label: 0,
            sent: function sent() {
              if (1 & i[0]) throw i[1];
              return i[1];
            },
            trys: [],
            ops: []
          };
          return o = {
            next: a(0),
            throw: a(1),
            return: a(2)
          }, "function" == typeof Symbol && (o[Symbol.iterator] = function () {
            return this;
          }), o;

          function a(o) {
            return function (a) {
              return function (o) {
                if (r) throw new TypeError("Generator is already executing.");

                for (; s;) {
                  try {
                    if (r = 1, n && (i = 2 & o[0] ? n.return : o[0] ? n.throw || ((i = n.return) && i.call(n), 0) : n.next) && !(i = i.call(n, o[1])).done) return i;

                    switch (n = 0, i && (o = [2 & o[0], i.value]), o[0]) {
                      case 0:
                      case 1:
                        i = o;
                        break;

                      case 4:
                        return s.label++, {
                          value: o[1],
                          done: !1
                        };

                      case 5:
                        s.label++, n = o[1], o = [0];
                        continue;

                      case 7:
                        o = s.ops.pop(), s.trys.pop();
                        continue;

                      default:
                        if (!(i = (i = s.trys).length > 0 && i[i.length - 1]) && (6 === o[0] || 2 === o[0])) {
                          s = 0;
                          continue;
                        }

                        if (3 === o[0] && (!i || o[1] > i[0] && o[1] < i[3])) {
                          s.label = o[1];
                          break;
                        }

                        if (6 === o[0] && s.label < i[1]) {
                          s.label = i[1], i = o;
                          break;
                        }

                        if (i && s.label < i[2]) {
                          s.label = i[2], s.ops.push(o);
                          break;
                        }

                        i[2] && s.ops.pop(), s.trys.pop();
                        continue;
                    }

                    o = e.call(t, s);
                  } catch (t) {
                    o = [6, t], n = 0;
                  } finally {
                    r = i = 0;
                  }
                }

                if (5 & o[0]) throw o[1];
                return {
                  value: o[0] ? o[1] : void 0,
                  done: !0
                };
              }([o, a]);
            };
          }
        }

        function l(t, e) {
          for (var r in t) {
            e.hasOwnProperty(r) || (e[r] = t[r]);
          }
        }

        function d(t) {
          var e = "function" == typeof Symbol && t[Symbol.iterator],
              r = 0;
          return e ? e.call(t) : {
            next: function next() {
              return t && r >= t.length && (t = void 0), {
                value: t && t[r++],
                done: !t
              };
            }
          };
        }

        function p(t, e) {
          var r = "function" == typeof Symbol && t[Symbol.iterator];
          if (!r) return t;
          var n,
              i,
              o = r.call(t),
              s = [];

          try {
            for (; (void 0 === e || e-- > 0) && !(n = o.next()).done;) {
              s.push(n.value);
            }
          } catch (t) {
            i = {
              error: t
            };
          } finally {
            try {
              n && !n.done && (r = o.return) && r.call(o);
            } finally {
              if (i) throw i.error;
            }
          }

          return s;
        }

        function g() {
          for (var t = [], e = 0; e < arguments.length; e++) {
            t = t.concat(p(arguments[e]));
          }

          return t;
        }

        function m(t) {
          return this instanceof m ? (this.v = t, this) : new m(t);
        }

        function b(t, e, r) {
          if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
          var n,
              i = r.apply(t, e || []),
              o = [];
          return n = {}, s("next"), s("throw"), s("return"), n[Symbol.asyncIterator] = function () {
            return this;
          }, n;

          function s(t) {
            i[t] && (n[t] = function (e) {
              return new Promise(function (r, n) {
                o.push([t, e, r, n]) > 1 || a(t, e);
              });
            });
          }

          function a(t, e) {
            try {
              (r = i[t](e)).value instanceof m ? Promise.resolve(r.value.v).then(u, f) : c(o[0][2], r);
            } catch (t) {
              c(o[0][3], t);
            }

            var r;
          }

          function u(t) {
            a("next", t);
          }

          function f(t) {
            a("throw", t);
          }

          function c(t, e) {
            t(e), o.shift(), o.length && a(o[0][0], o[0][1]);
          }
        }

        function v(t) {
          var e, r;
          return e = {}, n("next"), n("throw", function (t) {
            throw t;
          }), n("return"), e[Symbol.iterator] = function () {
            return this;
          }, e;

          function n(n, i) {
            e[n] = t[n] ? function (e) {
              return (r = !r) ? {
                value: m(t[n](e)),
                done: "return" === n
              } : i ? i(e) : e;
            } : i;
          }
        }

        function y(t) {
          if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
          var e,
              r = t[Symbol.asyncIterator];
          return r ? r.call(t) : (t = d(t), e = {}, n("next"), n("throw"), n("return"), e[Symbol.asyncIterator] = function () {
            return this;
          }, e);

          function n(r) {
            e[r] = t[r] && function (e) {
              return new Promise(function (n, i) {
                !function (t, e, r, n) {
                  Promise.resolve(n).then(function (e) {
                    t({
                      value: e,
                      done: r
                    });
                  }, e);
                }(n, i, (e = t[r](e)).done, e.value);
              });
            };
          }
        }

        function _(t, e) {
          return Object.defineProperty ? Object.defineProperty(t, "raw", {
            value: e
          }) : t.raw = e, t;
        }

        function w(t) {
          if (t && t.__esModule) return t;
          var e = {};
          if (null != t) for (var r in t) {
            Object.hasOwnProperty.call(t, r) && (e[r] = t[r]);
          }
          return e.default = t, e;
        }

        function E(t) {
          return t && t.__esModule ? t : {
            default: t
          };
        }
      }, function (t, e, r) {
        t.exports = function (t) {
          var e = {};

          function r(n) {
            if (e[n]) return e[n].exports;
            var i = e[n] = {
              i: n,
              l: !1,
              exports: {}
            };
            return t[n].call(i.exports, i, i.exports, r), i.l = !0, i.exports;
          }

          return r.m = t, r.c = e, r.d = function (t, e, n) {
            r.o(t, e) || Object.defineProperty(t, e, {
              enumerable: !0,
              get: n
            });
          }, r.r = function (t) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
              value: "Module"
            }), Object.defineProperty(t, "__esModule", {
              value: !0
            });
          }, r.t = function (t, e) {
            if (1 & e && (t = r(t)), 8 & e) return t;
            if (4 & e && "object" == typeof t && t && t.__esModule) return t;
            var n = Object.create(null);
            if (r.r(n), Object.defineProperty(n, "default", {
              enumerable: !0,
              value: t
            }), 2 & e && "string" != typeof t) for (var i in t) {
              r.d(n, i, function (e) {
                return t[e];
              }.bind(null, i));
            }
            return n;
          }, r.n = function (t) {
            var e = t && t.__esModule ? function () {
              return t.default;
            } : function () {
              return t;
            };
            return r.d(e, "a", e), e;
          }, r.o = function (t, e) {
            return Object.prototype.hasOwnProperty.call(t, e);
          }, r.p = "", r(r.s = 6);
        }([function (t, e, r) {
          "use strict";

          r.r(e);
          var n = r(1);
          r.d(e, "isBytesLike", function () {
            return a;
          }), r.d(e, "isBytes", function () {
            return u;
          }), r.d(e, "arrayify", function () {
            return f;
          }), r.d(e, "concat", function () {
            return c;
          }), r.d(e, "stripZeros", function () {
            return h;
          }), r.d(e, "zeroPad", function () {
            return l;
          }), r.d(e, "isHexString", function () {
            return d;
          }), r.d(e, "hexlify", function () {
            return p;
          }), r.d(e, "hexDataLength", function () {
            return g;
          }), r.d(e, "hexDataSlice", function () {
            return m;
          }), r.d(e, "hexConcat", function () {
            return b;
          }), r.d(e, "hexValue", function () {
            return v;
          }), r.d(e, "hexStripZeros", function () {
            return y;
          }), r.d(e, "hexZeroPad", function () {
            return _;
          }), r.d(e, "splitSignature", function () {
            return w;
          }), r.d(e, "joinSignature", function () {
            return E;
          });
          var i = new n.a("bytes/5.0.0-beta.136");

          function o(t) {
            return !!t.toHexString;
          }

          function s(t) {
            return t.slice ? t : (t.slice = function () {
              var e = Array.prototype.slice.call(arguments);
              return s(new Uint8Array(Array.prototype.slice.apply(t, e)));
            }, t);
          }

          function a(t) {
            return d(t) && !(t.length % 2) || u(t);
          }

          function u(t) {
            if (null == t) return !1;
            if (t.constructor === Uint8Array) return !0;
            if ("string" == typeof t) return !1;
            if (null == t.length) return !1;

            for (var _e9 = 0; _e9 < t.length; _e9++) {
              var _r11 = t[_e9];
              if (_r11 < 0 || _r11 >= 256 || _r11 % 1) return !1;
            }

            return !0;
          }

          function f(t, e) {
            if (e || (e = {}), "number" == typeof t) {
              i.checkSafeUint53(t, "invalid arrayify value");
              var _e10 = [];

              for (; t;) {
                _e10.unshift(255 & t), t /= 256;
              }

              return 0 === _e10.length && _e10.push(0), s(new Uint8Array(_e10));
            }

            if (e.allowMissingPrefix && "string" == typeof t && "0x" !== t.substring(0, 2) && (t = "0x" + t), o(t) && (t = t.toHexString()), d(t)) {
              var _r12 = t.substring(2);

              _r12.length % 2 && ("left" === e.hexPad ? _r12 = "0x0" + _r12.substring(2) : "right" === e.hexPad ? _r12 += "0" : i.throwArgumentError("hex data is odd-length", "value", t));
              var _n15 = [];

              for (var _t13 = 0; _t13 < _r12.length; _t13 += 2) {
                _n15.push(parseInt(_r12.substring(_t13, _t13 + 2), 16));
              }

              return s(new Uint8Array(_n15));
            }

            return u(t) ? s(new Uint8Array(t)) : i.throwArgumentError("invalid arrayify value", "value", t);
          }

          function c(t) {
            var e = t.map(function (t) {
              return f(t);
            }),
                r = e.reduce(function (t, e) {
              return t + e.length;
            }, 0),
                n = new Uint8Array(r);
            return e.reduce(function (t, e) {
              return n.set(e, t), t + e.length;
            }, 0), s(n);
          }

          function h(t) {
            var e = f(t);
            if (0 === e.length) return e;
            var r = 0;

            for (; r < e.length && 0 === e[r];) {
              r++;
            }

            return r && (e = e.slice(r)), e;
          }

          function l(t, e) {
            (t = f(t)).length > e && i.throwArgumentError("value out of range", "value", arguments[0]);
            var r = new Uint8Array(e);
            return r.set(t, e - t.length), s(r);
          }

          function d(t, e) {
            return !("string" != typeof t || !t.match(/^0x[0-9A-Fa-f]*$/) || e && t.length !== 2 + 2 * e);
          }

          function p(t, e) {
            if (e || (e = {}), "number" == typeof t) {
              i.checkSafeUint53(t, "invalid hexlify value");
              var _e11 = "";

              for (; t;) {
                _e11 = "0123456789abcdef"[15 & t] + _e11, t = Math.floor(t / 16);
              }

              return _e11.length ? (_e11.length % 2 && (_e11 = "0" + _e11), "0x" + _e11) : "0x00";
            }

            if (e.allowMissingPrefix && "string" == typeof t && "0x" !== t.substring(0, 2) && (t = "0x" + t), o(t)) return t.toHexString();
            if (d(t)) return t.length % 2 && ("left" === e.hexPad ? t = "0x0" + t.substring(2) : "right" === e.hexPad ? t += "0" : i.throwArgumentError("hex data is odd-length", "value", t)), t.toLowerCase();

            if (u(t)) {
              var _e12 = "0x";

              for (var _r13 = 0; _r13 < t.length; _r13++) {
                var _n16 = t[_r13];
                _e12 += "0123456789abcdef"[(240 & _n16) >> 4] + "0123456789abcdef"[15 & _n16];
              }

              return _e12;
            }

            return i.throwArgumentError("invalid hexlify value", "value", t);
          }

          function g(t) {
            if ("string" != typeof t) t = p(t);else if (!d(t) || t.length % 2) return null;
            return (t.length - 2) / 2;
          }

          function m(t, e, r) {
            return "string" != typeof t ? t = p(t) : (!d(t) || t.length % 2) && i.throwArgumentError("invalid hexData", "value", t), e = 2 + 2 * e, null != r ? "0x" + t.substring(e, 2 + 2 * r) : "0x" + t.substring(e);
          }

          function b(t) {
            var e = "0x";
            return t.forEach(function (t) {
              e += p(t).substring(2);
            }), e;
          }

          function v(t) {
            var e = y(p(t, {
              hexPad: "left"
            }));
            return "0x" === e ? "0x0" : e;
          }

          function y(t) {
            "string" != typeof t && (t = p(t)), d(t) || i.throwArgumentError("invalid hex string", "value", t), t = t.substring(2);
            var e = 0;

            for (; e < t.length && "0" === t[e];) {
              e++;
            }

            return "0x" + t.substring(e);
          }

          function _(t, e) {
            for ("string" != typeof t ? t = p(t) : d(t) || i.throwArgumentError("invalid hex string", "value", t), t.length > 2 * e + 2 && i.throwArgumentError("value out of range", "value", arguments[1]); t.length < 2 * e + 2;) {
              t = "0x0" + t.substring(2);
            }

            return t;
          }

          function w(t) {
            var e = {
              r: "0x",
              s: "0x",
              _vs: "0x",
              recoveryParam: 0,
              v: 0
            };

            if (a(t)) {
              var _r14 = f(t);

              65 !== _r14.length && i.throwArgumentError("invalid signature string; must be 65 bytes", "signature", t), e.r = p(_r14.slice(0, 32)), e.s = p(_r14.slice(32, 64)), e.v = _r14[64], e.recoveryParam = 1 - e.v % 2, e.v < 27 && (0 === e.v || 1 === e.v ? e.v += 27 : i.throwArgumentError("signature invalid v byte", "signature", t)), e.recoveryParam && (_r14[32] |= 128), e._vs = p(_r14.slice(32, 64));
            } else {
              if (e.r = t.r, e.s = t.s, e.v = t.v, e.recoveryParam = t.recoveryParam, e._vs = t._vs, null != e._vs) {
                var _r16 = l(f(e._vs), 32);

                e._vs = p(_r16);

                var _n18 = _r16[0] >= 128 ? 1 : 0;

                null == e.recoveryParam ? e.recoveryParam = _n18 : e.recoveryParam !== _n18 && i.throwArgumentError("signature recoveryParam mismatch _vs", "signature", t), _r16[0] &= 127;

                var _o8 = p(_r16);

                null == e.s ? e.s = _o8 : e.s !== _o8 && i.throwArgumentError("signature v mismatch _vs", "signature", t);
              }

              null == e.recoveryParam ? null == e.v ? i.throwArgumentError("signature missing v and recoveryParam", "signature", t) : e.recoveryParam = 1 - e.v % 2 : null == e.v ? e.v = 27 + e.recoveryParam : e.recoveryParam !== 1 - e.v % 2 && i.throwArgumentError("signature recoveryParam mismatch v", "signature", t), null != e.r && d(e.r) ? e.r = _(e.r, 32) : i.throwArgumentError("signature missing or invalid r", "signature", t), null != e.s && d(e.s) ? e.s = _(e.s, 32) : i.throwArgumentError("signature missing or invalid s", "signature", t);

              var _r15 = f(e.s);

              _r15[0] >= 128 && i.throwArgumentError("signature s out of range", "signature", t), e.recoveryParam && (_r15[0] |= 128);

              var _n17 = p(_r15);

              e._vs && (d(e._vs) || i.throwArgumentError("signature invalid _vs", "signature", t), e._vs = _(e._vs, 32)), null == e._vs ? e._vs = _n17 : e._vs !== _n17 && i.throwArgumentError("signature _vs mismatch v and s", "signature", t);
            }

            return e;
          }

          function E(t) {
            return p(c([(t = w(t)).r, t.s, t.recoveryParam ? "0x1c" : "0x1b"]));
          }
        }, function (t, e, r) {
          "use strict";

          r.d(e, "a", function () {
            return f;
          });
          var n = !1,
              i = !1;
          var o = {
            debug: 1,
            default: 2,
            info: 2,
            warn: 3,
            error: 4,
            off: 5
          };
          var s = o.default,
              a = null;

          var u = function () {
            try {
              var _t14 = [];
              if (["NFD", "NFC", "NFKD", "NFKC"].forEach(function (e) {
                try {
                  if ("test" !== "test".normalize(e)) throw new Error("bad normalize");
                } catch (r) {
                  _t14.push(e);
                }
              }), _t14.length) throw new Error("missing " + _t14.join(", "));
              if (String.fromCharCode(233).normalize("NFD") !== String.fromCharCode(101, 769)) throw new Error("broken implementation");
            } catch (t) {
              return t.message;
            }

            return null;
          }();

          var f =
          /*#__PURE__*/
          function () {
            function f(t) {
              _classCallCheck(this, f);

              Object.defineProperty(this, "version", {
                enumerable: !0,
                value: t,
                writable: !1
              });
            }

            _createClass(f, [{
              key: "setLogLevel",
              value: function setLogLevel(t) {
                var e = o[t];
                null != e ? s = e : this.warn("invalid log level - " + t);
              }
            }, {
              key: "_log",
              value: function _log(t, e) {
                s > o[t] || console.log.apply(console, e);
              }
            }, {
              key: "debug",
              value: function debug() {
                for (var _len6 = arguments.length, t = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
                  t[_key6] = arguments[_key6];
                }

                this._log(f.levels.DEBUG, t);
              }
            }, {
              key: "info",
              value: function info() {
                for (var _len7 = arguments.length, t = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
                  t[_key7] = arguments[_key7];
                }

                this._log(f.levels.INFO, t);
              }
            }, {
              key: "warn",
              value: function warn() {
                for (var _len8 = arguments.length, t = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
                  t[_key8] = arguments[_key8];
                }

                this._log(f.levels.WARNING, t);
              }
            }, {
              key: "makeError",
              value: function makeError(t, e, r) {
                if (i) return new Error("unknown error");
                e || (e = f.errors.UNKNOWN_ERROR), r || (r = {});
                var n = [];
                Object.keys(r).forEach(function (t) {
                  try {
                    n.push(t + "=" + JSON.stringify(r[t]));
                  } catch (e) {
                    n.push(t + "=" + JSON.stringify(r[t].toString()));
                  }
                }), n.push("code=".concat(e)), n.push("version=".concat(this.version));
                var o = t;
                n.length && (t += " (" + n.join(", ") + ")");
                var s = new Error(t);
                return s.reason = o, s.code = e, Object.keys(r).forEach(function (t) {
                  s[t] = r[t];
                }), s;
              }
            }, {
              key: "throwError",
              value: function throwError(t, e, r) {
                throw this.makeError(t, e, r);
              }
            }, {
              key: "throwArgumentError",
              value: function throwArgumentError(t, e, r) {
                return this.throwError(t, f.errors.INVALID_ARGUMENT, {
                  argument: e,
                  value: r
                });
              }
            }, {
              key: "checkNormalize",
              value: function checkNormalize(t) {
                null == t && (t = "platform missing String.prototype.normalize"), u && this.throwError("platform missing String.prototype.normalize", f.errors.UNSUPPORTED_OPERATION, {
                  operation: "String.prototype.normalize",
                  form: u
                });
              }
            }, {
              key: "checkSafeUint53",
              value: function checkSafeUint53(t, e) {
                "number" == typeof t && (null == e && (e = "value not safe"), (t < 0 || t >= 9007199254740991) && this.throwError(e, f.errors.NUMERIC_FAULT, {
                  operation: "checkSafeInteger",
                  fault: "out-of-safe-range",
                  value: t
                }), t % 1 && this.throwError(e, f.errors.NUMERIC_FAULT, {
                  operation: "checkSafeInteger",
                  fault: "non-integer",
                  value: t
                }));
              }
            }, {
              key: "checkArgumentCount",
              value: function checkArgumentCount(t, e, r) {
                r = r ? ": " + r : "", t < e && this.throwError("missing argument" + r, f.errors.MISSING_ARGUMENT, {
                  count: t,
                  expectedCount: e
                }), t > e && this.throwError("too many arguments" + r, f.errors.UNEXPECTED_ARGUMENT, {
                  count: t,
                  expectedCount: e
                });
              }
            }, {
              key: "checkNew",
              value: function checkNew(t, e) {
                t !== Object && null != t || this.throwError("missing new", f.errors.MISSING_NEW, {
                  name: e.name
                });
              }
            }, {
              key: "checkAbstract",
              value: function checkAbstract(t, e) {
                t === e ? this.throwError("cannot instantiate abstract class " + JSON.stringify(e.name) + " directly; use a sub-class", f.errors.UNSUPPORTED_OPERATION, {
                  name: t.name,
                  operation: "new"
                }) : t !== Object && null != t || this.throwError("missing new", f.errors.MISSING_NEW, {
                  name: e.name
                });
              }
            }], [{
              key: "globalLogger",
              value: function globalLogger() {
                return a || (a = new f("logger/5.0.0-beta.134")), a;
              }
            }, {
              key: "setCensorship",
              value: function setCensorship(t, e) {
                if (n) {
                  if (!t) return;
                  this.globalLogger().throwError("error censorship permanent", f.errors.UNSUPPORTED_OPERATION, {
                    operation: "setCensorship"
                  });
                }

                i = !!t, n = !!e;
              }
            }]);

            return f;
          }();

          f.errors = {
            UNKNOWN_ERROR: "UNKNOWN_ERROR",
            NOT_IMPLEMENTED: "NOT_IMPLEMENTED",
            UNSUPPORTED_OPERATION: "UNSUPPORTED_OPERATION",
            NETWORK_ERROR: "NETWORK_ERROR",
            SERVER_ERROR: "SERVER_ERROR",
            TIMEOUT: "TIMEOUT",
            BUFFER_OVERRUN: "BUFFER_OVERRUN",
            NUMERIC_FAULT: "NUMERIC_FAULT",
            MISSING_NEW: "MISSING_NEW",
            INVALID_ARGUMENT: "INVALID_ARGUMENT",
            MISSING_ARGUMENT: "MISSING_ARGUMENT",
            UNEXPECTED_ARGUMENT: "UNEXPECTED_ARGUMENT",
            CALL_EXCEPTION: "CALL_EXCEPTION",
            INSUFFICIENT_FUNDS: "INSUFFICIENT_FUNDS",
            NONCE_EXPIRED: "NONCE_EXPIRED",
            REPLACEMENT_UNDERPRICED: "REPLACEMENT_UNDERPRICED",
            UNPREDICTABLE_GAS_LIMIT: "UNPREDICTABLE_GAS_LIMIT"
          }, f.levels = {
            DEBUG: "DEBUG",
            INFO: "INFO",
            WARNING: "WARNING",
            ERROR: "ERROR",
            OFF: "OFF"
          };
        }, function (t, e, r) {
          "use strict";

          var n = r(3),
              i = r(0),
              o = r(1);
          var s = "bignumber/5.0.0-beta.135",
              a = new o.a(s),
              u = {};

          var f =
          /*#__PURE__*/
          function () {
            function f(t, e) {
              _classCallCheck(this, f);

              a.checkNew(this instanceof f ? this.constructor : void 0, f), t !== u && a.throwError("cannot call consturtor directly; use BigNumber.from", o.a.errors.UNSUPPORTED_OPERATION, {
                operation: "new (BigNumber)"
              }), this._hex = e, this._isBigNumber = !0, Object.freeze(this);
            }

            _createClass(f, [{
              key: "fromTwos",
              value: function fromTwos(t) {
                return h(l(this).fromTwos(t));
              }
            }, {
              key: "toTwos",
              value: function toTwos(t) {
                return h(l(this).toTwos(t));
              }
            }, {
              key: "abs",
              value: function abs() {
                return "-" === this._hex[0] ? f.from(this._hex.substring(1)) : this;
              }
            }, {
              key: "add",
              value: function add(t) {
                return h(l(this).add(l(t)));
              }
            }, {
              key: "sub",
              value: function sub(t) {
                return h(l(this).sub(l(t)));
              }
            }, {
              key: "div",
              value: function div(t) {
                return f.from(t).isZero() && d("division by zero", "div"), h(l(this).div(l(t)));
              }
            }, {
              key: "mul",
              value: function mul(t) {
                return h(l(this).mul(l(t)));
              }
            }, {
              key: "mod",
              value: function mod(t) {
                return h(l(this).mod(l(t)));
              }
            }, {
              key: "pow",
              value: function pow(t) {
                return h(l(this).pow(l(t)));
              }
            }, {
              key: "maskn",
              value: function maskn(t) {
                return h(l(this).maskn(t));
              }
            }, {
              key: "eq",
              value: function eq(t) {
                return l(this).eq(l(t));
              }
            }, {
              key: "lt",
              value: function lt(t) {
                return l(this).lt(l(t));
              }
            }, {
              key: "lte",
              value: function lte(t) {
                return l(this).lte(l(t));
              }
            }, {
              key: "gt",
              value: function gt(t) {
                return l(this).gt(l(t));
              }
            }, {
              key: "gte",
              value: function gte(t) {
                return l(this).gte(l(t));
              }
            }, {
              key: "isZero",
              value: function isZero() {
                return l(this).isZero();
              }
            }, {
              key: "toNumber",
              value: function toNumber() {
                try {
                  return l(this).toNumber();
                } catch (t) {
                  d("overflow", "toNumber", this.toString());
                }

                return null;
              }
            }, {
              key: "toString",
              value: function toString() {
                return 0 !== arguments.length && a.throwError("bigNumber.toString does not accept parameters", o.a.errors.UNEXPECTED_ARGUMENT, {}), l(this).toString(10);
              }
            }, {
              key: "toHexString",
              value: function toHexString() {
                return this._hex;
              }
            }], [{
              key: "from",
              value: function from(t) {
                return t instanceof f ? t : "string" == typeof t ? t.match(/-?0x[0-9a-f]+/i) ? new f(u, c(t)) : t.match(/^-?[0-9]+$/) ? new f(u, c(new n.BN(t))) : a.throwArgumentError("invalid BigNumber string", "value", t) : "number" == typeof t ? (t % 1 && d("underflow", "BigNumber.from", t), (t >= 9007199254740991 || t <= -9007199254740991) && d("overflow", "BigNumber.from", t), f.from(String(t))) : "bigint" == typeof t ? f.from(t.toString()) : Object(i.isBytes)(t) ? f.from(Object(i.hexlify)(t)) : t._hex && Object(i.isHexString)(t._hex) ? f.from(t._hex) : t.toHexString && "string" == typeof (t = t.toHexString()) ? f.from(t) : a.throwArgumentError("invalid BigNumber value", "value", t);
              }
            }, {
              key: "isBigNumber",
              value: function isBigNumber(t) {
                return !(!t || !t._isBigNumber);
              }
            }]);

            return f;
          }();

          function c(t) {
            if ("string" != typeof t) return c(t.toString(16));
            if ("-" === t[0]) return "-" === (t = t.substring(1))[0] && a.throwArgumentError("invalid hex", "value", t), "0x00" === (t = c(t)) ? t : "-" + t;
            if ("0x" !== t.substring(0, 2) && (t = "0x" + t), "0x" === t) return "0x00";

            for (t.length % 2 && (t = "0x0" + t.substring(2)); t.length > 4 && "0x00" === t.substring(0, 4);) {
              t = "0x" + t.substring(4);
            }

            return t;
          }

          function h(t) {
            return f.from(c(t));
          }

          function l(t) {
            var e = f.from(t).toHexString();
            return "-" === e[0] ? new n.BN("-" + e.substring(3), 16) : new n.BN(e.substring(2), 16);
          }

          function d(t, e, r) {
            var n = {
              fault: t,
              operation: e
            };
            return null != r && (n.value = r), a.throwError(t, o.a.errors.NUMERIC_FAULT, n);
          }

          new o.a(s), f.from(0), f.from(-1);
          var p = "0";

          for (; p.length < 256;) {
            p += p;
          }

          r.d(e, "a", function () {
            return f;
          });
        }, function (t, e, r) {
          (function (t) {
            !function (t, e) {
              "use strict";

              function n(t, e) {
                if (!t) throw new Error(e || "Assertion failed");
              }

              function i(t, e) {
                t.super_ = e;

                var r = function r() {};

                r.prototype = e.prototype, t.prototype = new r(), t.prototype.constructor = t;
              }

              function o(t, e, r) {
                if (o.isBN(t)) return t;
                this.negative = 0, this.words = null, this.length = 0, this.red = null, null !== t && ("le" !== e && "be" !== e || (r = e, e = 10), this._init(t || 0, e || 10, r || "be"));
              }

              var s;
              "object" == typeof t ? t.exports = o : e.BN = o, o.BN = o, o.wordSize = 26;

              try {
                s = r(14).Buffer;
              } catch (t) {}

              function a(t, e, r) {
                for (var n = 0, i = Math.min(t.length, r), o = e; o < i; o++) {
                  var s = t.charCodeAt(o) - 48;
                  n <<= 4, n |= s >= 49 && s <= 54 ? s - 49 + 10 : s >= 17 && s <= 22 ? s - 17 + 10 : 15 & s;
                }

                return n;
              }

              function u(t, e, r, n) {
                for (var i = 0, o = Math.min(t.length, r), s = e; s < o; s++) {
                  var a = t.charCodeAt(s) - 48;
                  i *= n, i += a >= 49 ? a - 49 + 10 : a >= 17 ? a - 17 + 10 : a;
                }

                return i;
              }

              o.isBN = function (t) {
                return t instanceof o || null !== t && "object" == typeof t && t.constructor.wordSize === o.wordSize && Array.isArray(t.words);
              }, o.max = function (t, e) {
                return t.cmp(e) > 0 ? t : e;
              }, o.min = function (t, e) {
                return t.cmp(e) < 0 ? t : e;
              }, o.prototype._init = function (t, e, r) {
                if ("number" == typeof t) return this._initNumber(t, e, r);
                if ("object" == typeof t) return this._initArray(t, e, r);
                "hex" === e && (e = 16), n(e === (0 | e) && e >= 2 && e <= 36);
                var i = 0;
                "-" === (t = t.toString().replace(/\s+/g, ""))[0] && i++, 16 === e ? this._parseHex(t, i) : this._parseBase(t, e, i), "-" === t[0] && (this.negative = 1), this.strip(), "le" === r && this._initArray(this.toArray(), e, r);
              }, o.prototype._initNumber = function (t, e, r) {
                t < 0 && (this.negative = 1, t = -t), t < 67108864 ? (this.words = [67108863 & t], this.length = 1) : t < 4503599627370496 ? (this.words = [67108863 & t, t / 67108864 & 67108863], this.length = 2) : (n(t < 9007199254740992), this.words = [67108863 & t, t / 67108864 & 67108863, 1], this.length = 3), "le" === r && this._initArray(this.toArray(), e, r);
              }, o.prototype._initArray = function (t, e, r) {
                if (n("number" == typeof t.length), t.length <= 0) return this.words = [0], this.length = 1, this;
                this.length = Math.ceil(t.length / 3), this.words = new Array(this.length);

                for (var i = 0; i < this.length; i++) {
                  this.words[i] = 0;
                }

                var o,
                    s,
                    a = 0;
                if ("be" === r) for (i = t.length - 1, o = 0; i >= 0; i -= 3) {
                  s = t[i] | t[i - 1] << 8 | t[i - 2] << 16, this.words[o] |= s << a & 67108863, this.words[o + 1] = s >>> 26 - a & 67108863, (a += 24) >= 26 && (a -= 26, o++);
                } else if ("le" === r) for (i = 0, o = 0; i < t.length; i += 3) {
                  s = t[i] | t[i + 1] << 8 | t[i + 2] << 16, this.words[o] |= s << a & 67108863, this.words[o + 1] = s >>> 26 - a & 67108863, (a += 24) >= 26 && (a -= 26, o++);
                }
                return this.strip();
              }, o.prototype._parseHex = function (t, e) {
                this.length = Math.ceil((t.length - e) / 6), this.words = new Array(this.length);

                for (var r = 0; r < this.length; r++) {
                  this.words[r] = 0;
                }

                var n,
                    i,
                    o = 0;

                for (r = t.length - 6, n = 0; r >= e; r -= 6) {
                  i = a(t, r, r + 6), this.words[n] |= i << o & 67108863, this.words[n + 1] |= i >>> 26 - o & 4194303, (o += 24) >= 26 && (o -= 26, n++);
                }

                r + 6 !== e && (i = a(t, e, r + 6), this.words[n] |= i << o & 67108863, this.words[n + 1] |= i >>> 26 - o & 4194303), this.strip();
              }, o.prototype._parseBase = function (t, e, r) {
                this.words = [0], this.length = 1;

                for (var n = 0, i = 1; i <= 67108863; i *= e) {
                  n++;
                }

                n--, i = i / e | 0;

                for (var o = t.length - r, s = o % n, a = Math.min(o, o - s) + r, f = 0, c = r; c < a; c += n) {
                  f = u(t, c, c + n, e), this.imuln(i), this.words[0] + f < 67108864 ? this.words[0] += f : this._iaddn(f);
                }

                if (0 !== s) {
                  var h = 1;

                  for (f = u(t, c, t.length, e), c = 0; c < s; c++) {
                    h *= e;
                  }

                  this.imuln(h), this.words[0] + f < 67108864 ? this.words[0] += f : this._iaddn(f);
                }
              }, o.prototype.copy = function (t) {
                t.words = new Array(this.length);

                for (var e = 0; e < this.length; e++) {
                  t.words[e] = this.words[e];
                }

                t.length = this.length, t.negative = this.negative, t.red = this.red;
              }, o.prototype.clone = function () {
                var t = new o(null);
                return this.copy(t), t;
              }, o.prototype._expand = function (t) {
                for (; this.length < t;) {
                  this.words[this.length++] = 0;
                }

                return this;
              }, o.prototype.strip = function () {
                for (; this.length > 1 && 0 === this.words[this.length - 1];) {
                  this.length--;
                }

                return this._normSign();
              }, o.prototype._normSign = function () {
                return 1 === this.length && 0 === this.words[0] && (this.negative = 0), this;
              }, o.prototype.inspect = function () {
                return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
              };
              var f = ["", "0", "00", "000", "0000", "00000", "000000", "0000000", "00000000", "000000000", "0000000000", "00000000000", "000000000000", "0000000000000", "00000000000000", "000000000000000", "0000000000000000", "00000000000000000", "000000000000000000", "0000000000000000000", "00000000000000000000", "000000000000000000000", "0000000000000000000000", "00000000000000000000000", "000000000000000000000000", "0000000000000000000000000"],
                  c = [0, 0, 25, 16, 12, 11, 10, 9, 8, 8, 7, 7, 7, 7, 6, 6, 6, 6, 6, 6, 6, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5],
                  h = [0, 0, 33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216, 43046721, 1e7, 19487171, 35831808, 62748517, 7529536, 11390625, 16777216, 24137569, 34012224, 47045881, 64e6, 4084101, 5153632, 6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149, 243e5, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176];

              function l(t, e, r) {
                r.negative = e.negative ^ t.negative;
                var n = t.length + e.length | 0;
                r.length = n, n = n - 1 | 0;
                var i = 0 | t.words[0],
                    o = 0 | e.words[0],
                    s = i * o,
                    a = 67108863 & s,
                    u = s / 67108864 | 0;
                r.words[0] = a;

                for (var f = 1; f < n; f++) {
                  for (var c = u >>> 26, h = 67108863 & u, l = Math.min(f, e.length - 1), d = Math.max(0, f - t.length + 1); d <= l; d++) {
                    var p = f - d | 0;
                    c += (s = (i = 0 | t.words[p]) * (o = 0 | e.words[d]) + h) / 67108864 | 0, h = 67108863 & s;
                  }

                  r.words[f] = 0 | h, u = 0 | c;
                }

                return 0 !== u ? r.words[f] = 0 | u : r.length--, r.strip();
              }

              o.prototype.toString = function (t, e) {
                var r;

                if (e = 0 | e || 1, 16 === (t = t || 10) || "hex" === t) {
                  r = "";

                  for (var i = 0, o = 0, s = 0; s < this.length; s++) {
                    var a = this.words[s],
                        u = (16777215 & (a << i | o)).toString(16);
                    r = 0 != (o = a >>> 24 - i & 16777215) || s !== this.length - 1 ? f[6 - u.length] + u + r : u + r, (i += 2) >= 26 && (i -= 26, s--);
                  }

                  for (0 !== o && (r = o.toString(16) + r); r.length % e != 0;) {
                    r = "0" + r;
                  }

                  return 0 !== this.negative && (r = "-" + r), r;
                }

                if (t === (0 | t) && t >= 2 && t <= 36) {
                  var l = c[t],
                      d = h[t];
                  r = "";
                  var p = this.clone();

                  for (p.negative = 0; !p.isZero();) {
                    var g = p.modn(d).toString(t);
                    r = (p = p.idivn(d)).isZero() ? g + r : f[l - g.length] + g + r;
                  }

                  for (this.isZero() && (r = "0" + r); r.length % e != 0;) {
                    r = "0" + r;
                  }

                  return 0 !== this.negative && (r = "-" + r), r;
                }

                n(!1, "Base should be between 2 and 36");
              }, o.prototype.toNumber = function () {
                var t = this.words[0];
                return 2 === this.length ? t += 67108864 * this.words[1] : 3 === this.length && 1 === this.words[2] ? t += 4503599627370496 + 67108864 * this.words[1] : this.length > 2 && n(!1, "Number can only safely store up to 53 bits"), 0 !== this.negative ? -t : t;
              }, o.prototype.toJSON = function () {
                return this.toString(16);
              }, o.prototype.toBuffer = function (t, e) {
                return n(void 0 !== s), this.toArrayLike(s, t, e);
              }, o.prototype.toArray = function (t, e) {
                return this.toArrayLike(Array, t, e);
              }, o.prototype.toArrayLike = function (t, e, r) {
                var i = this.byteLength(),
                    o = r || Math.max(1, i);
                n(i <= o, "byte array longer than desired length"), n(o > 0, "Requested array length <= 0"), this.strip();
                var s,
                    a,
                    u = "le" === e,
                    f = new t(o),
                    c = this.clone();

                if (u) {
                  for (a = 0; !c.isZero(); a++) {
                    s = c.andln(255), c.iushrn(8), f[a] = s;
                  }

                  for (; a < o; a++) {
                    f[a] = 0;
                  }
                } else {
                  for (a = 0; a < o - i; a++) {
                    f[a] = 0;
                  }

                  for (a = 0; !c.isZero(); a++) {
                    s = c.andln(255), c.iushrn(8), f[o - a - 1] = s;
                  }
                }

                return f;
              }, Math.clz32 ? o.prototype._countBits = function (t) {
                return 32 - Math.clz32(t);
              } : o.prototype._countBits = function (t) {
                var e = t,
                    r = 0;
                return e >= 4096 && (r += 13, e >>>= 13), e >= 64 && (r += 7, e >>>= 7), e >= 8 && (r += 4, e >>>= 4), e >= 2 && (r += 2, e >>>= 2), r + e;
              }, o.prototype._zeroBits = function (t) {
                if (0 === t) return 26;
                var e = t,
                    r = 0;
                return 0 == (8191 & e) && (r += 13, e >>>= 13), 0 == (127 & e) && (r += 7, e >>>= 7), 0 == (15 & e) && (r += 4, e >>>= 4), 0 == (3 & e) && (r += 2, e >>>= 2), 0 == (1 & e) && r++, r;
              }, o.prototype.bitLength = function () {
                var t = this.words[this.length - 1],
                    e = this._countBits(t);

                return 26 * (this.length - 1) + e;
              }, o.prototype.zeroBits = function () {
                if (this.isZero()) return 0;

                for (var t = 0, e = 0; e < this.length; e++) {
                  var r = this._zeroBits(this.words[e]);

                  if (t += r, 26 !== r) break;
                }

                return t;
              }, o.prototype.byteLength = function () {
                return Math.ceil(this.bitLength() / 8);
              }, o.prototype.toTwos = function (t) {
                return 0 !== this.negative ? this.abs().inotn(t).iaddn(1) : this.clone();
              }, o.prototype.fromTwos = function (t) {
                return this.testn(t - 1) ? this.notn(t).iaddn(1).ineg() : this.clone();
              }, o.prototype.isNeg = function () {
                return 0 !== this.negative;
              }, o.prototype.neg = function () {
                return this.clone().ineg();
              }, o.prototype.ineg = function () {
                return this.isZero() || (this.negative ^= 1), this;
              }, o.prototype.iuor = function (t) {
                for (; this.length < t.length;) {
                  this.words[this.length++] = 0;
                }

                for (var e = 0; e < t.length; e++) {
                  this.words[e] = this.words[e] | t.words[e];
                }

                return this.strip();
              }, o.prototype.ior = function (t) {
                return n(0 == (this.negative | t.negative)), this.iuor(t);
              }, o.prototype.or = function (t) {
                return this.length > t.length ? this.clone().ior(t) : t.clone().ior(this);
              }, o.prototype.uor = function (t) {
                return this.length > t.length ? this.clone().iuor(t) : t.clone().iuor(this);
              }, o.prototype.iuand = function (t) {
                var e;
                e = this.length > t.length ? t : this;

                for (var r = 0; r < e.length; r++) {
                  this.words[r] = this.words[r] & t.words[r];
                }

                return this.length = e.length, this.strip();
              }, o.prototype.iand = function (t) {
                return n(0 == (this.negative | t.negative)), this.iuand(t);
              }, o.prototype.and = function (t) {
                return this.length > t.length ? this.clone().iand(t) : t.clone().iand(this);
              }, o.prototype.uand = function (t) {
                return this.length > t.length ? this.clone().iuand(t) : t.clone().iuand(this);
              }, o.prototype.iuxor = function (t) {
                var e, r;
                this.length > t.length ? (e = this, r = t) : (e = t, r = this);

                for (var n = 0; n < r.length; n++) {
                  this.words[n] = e.words[n] ^ r.words[n];
                }

                if (this !== e) for (; n < e.length; n++) {
                  this.words[n] = e.words[n];
                }
                return this.length = e.length, this.strip();
              }, o.prototype.ixor = function (t) {
                return n(0 == (this.negative | t.negative)), this.iuxor(t);
              }, o.prototype.xor = function (t) {
                return this.length > t.length ? this.clone().ixor(t) : t.clone().ixor(this);
              }, o.prototype.uxor = function (t) {
                return this.length > t.length ? this.clone().iuxor(t) : t.clone().iuxor(this);
              }, o.prototype.inotn = function (t) {
                n("number" == typeof t && t >= 0);
                var e = 0 | Math.ceil(t / 26),
                    r = t % 26;
                this._expand(e), r > 0 && e--;

                for (var i = 0; i < e; i++) {
                  this.words[i] = 67108863 & ~this.words[i];
                }

                return r > 0 && (this.words[i] = ~this.words[i] & 67108863 >> 26 - r), this.strip();
              }, o.prototype.notn = function (t) {
                return this.clone().inotn(t);
              }, o.prototype.setn = function (t, e) {
                n("number" == typeof t && t >= 0);
                var r = t / 26 | 0,
                    i = t % 26;
                return this._expand(r + 1), this.words[r] = e ? this.words[r] | 1 << i : this.words[r] & ~(1 << i), this.strip();
              }, o.prototype.iadd = function (t) {
                var e, r, n;
                if (0 !== this.negative && 0 === t.negative) return this.negative = 0, e = this.isub(t), this.negative ^= 1, this._normSign();
                if (0 === this.negative && 0 !== t.negative) return t.negative = 0, e = this.isub(t), t.negative = 1, e._normSign();
                this.length > t.length ? (r = this, n = t) : (r = t, n = this);

                for (var i = 0, o = 0; o < n.length; o++) {
                  e = (0 | r.words[o]) + (0 | n.words[o]) + i, this.words[o] = 67108863 & e, i = e >>> 26;
                }

                for (; 0 !== i && o < r.length; o++) {
                  e = (0 | r.words[o]) + i, this.words[o] = 67108863 & e, i = e >>> 26;
                }

                if (this.length = r.length, 0 !== i) this.words[this.length] = i, this.length++;else if (r !== this) for (; o < r.length; o++) {
                  this.words[o] = r.words[o];
                }
                return this;
              }, o.prototype.add = function (t) {
                var e;
                return 0 !== t.negative && 0 === this.negative ? (t.negative = 0, e = this.sub(t), t.negative ^= 1, e) : 0 === t.negative && 0 !== this.negative ? (this.negative = 0, e = t.sub(this), this.negative = 1, e) : this.length > t.length ? this.clone().iadd(t) : t.clone().iadd(this);
              }, o.prototype.isub = function (t) {
                if (0 !== t.negative) {
                  t.negative = 0;
                  var e = this.iadd(t);
                  return t.negative = 1, e._normSign();
                }

                if (0 !== this.negative) return this.negative = 0, this.iadd(t), this.negative = 1, this._normSign();
                var r,
                    n,
                    i = this.cmp(t);
                if (0 === i) return this.negative = 0, this.length = 1, this.words[0] = 0, this;
                i > 0 ? (r = this, n = t) : (r = t, n = this);

                for (var o = 0, s = 0; s < n.length; s++) {
                  o = (e = (0 | r.words[s]) - (0 | n.words[s]) + o) >> 26, this.words[s] = 67108863 & e;
                }

                for (; 0 !== o && s < r.length; s++) {
                  o = (e = (0 | r.words[s]) + o) >> 26, this.words[s] = 67108863 & e;
                }

                if (0 === o && s < r.length && r !== this) for (; s < r.length; s++) {
                  this.words[s] = r.words[s];
                }
                return this.length = Math.max(this.length, s), r !== this && (this.negative = 1), this.strip();
              }, o.prototype.sub = function (t) {
                return this.clone().isub(t);
              };

              var d = function d(t, e, r) {
                var n,
                    i,
                    o,
                    s = t.words,
                    a = e.words,
                    u = r.words,
                    f = 0,
                    c = 0 | s[0],
                    h = 8191 & c,
                    l = c >>> 13,
                    d = 0 | s[1],
                    p = 8191 & d,
                    g = d >>> 13,
                    m = 0 | s[2],
                    b = 8191 & m,
                    v = m >>> 13,
                    y = 0 | s[3],
                    _ = 8191 & y,
                    w = y >>> 13,
                    E = 0 | s[4],
                    M = 8191 & E,
                    S = E >>> 13,
                    A = 0 | s[5],
                    x = 8191 & A,
                    R = A >>> 13,
                    T = 0 | s[6],
                    k = 8191 & T,
                    I = T >>> 13,
                    B = 0 | s[7],
                    O = 8191 & B,
                    P = B >>> 13,
                    N = 0 | s[8],
                    C = 8191 & N,
                    L = N >>> 13,
                    j = 0 | s[9],
                    U = 8191 & j,
                    D = j >>> 13,
                    F = 0 | a[0],
                    z = 8191 & F,
                    q = F >>> 13,
                    H = 0 | a[1],
                    Y = 8191 & H,
                    G = H >>> 13,
                    K = 0 | a[2],
                    Z = 8191 & K,
                    V = K >>> 13,
                    W = 0 | a[3],
                    J = 8191 & W,
                    X = W >>> 13,
                    $ = 0 | a[4],
                    Q = 8191 & $,
                    tt = $ >>> 13,
                    et = 0 | a[5],
                    rt = 8191 & et,
                    nt = et >>> 13,
                    it = 0 | a[6],
                    ot = 8191 & it,
                    st = it >>> 13,
                    at = 0 | a[7],
                    ut = 8191 & at,
                    ft = at >>> 13,
                    ct = 0 | a[8],
                    ht = 8191 & ct,
                    lt = ct >>> 13,
                    dt = 0 | a[9],
                    pt = 8191 & dt,
                    gt = dt >>> 13;

                r.negative = t.negative ^ e.negative, r.length = 19;
                var mt = (f + (n = Math.imul(h, z)) | 0) + ((8191 & (i = (i = Math.imul(h, q)) + Math.imul(l, z) | 0)) << 13) | 0;
                f = ((o = Math.imul(l, q)) + (i >>> 13) | 0) + (mt >>> 26) | 0, mt &= 67108863, n = Math.imul(p, z), i = (i = Math.imul(p, q)) + Math.imul(g, z) | 0, o = Math.imul(g, q);
                var bt = (f + (n = n + Math.imul(h, Y) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, G) | 0) + Math.imul(l, Y) | 0)) << 13) | 0;
                f = ((o = o + Math.imul(l, G) | 0) + (i >>> 13) | 0) + (bt >>> 26) | 0, bt &= 67108863, n = Math.imul(b, z), i = (i = Math.imul(b, q)) + Math.imul(v, z) | 0, o = Math.imul(v, q), n = n + Math.imul(p, Y) | 0, i = (i = i + Math.imul(p, G) | 0) + Math.imul(g, Y) | 0, o = o + Math.imul(g, G) | 0;
                var vt = (f + (n = n + Math.imul(h, Z) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, V) | 0) + Math.imul(l, Z) | 0)) << 13) | 0;
                f = ((o = o + Math.imul(l, V) | 0) + (i >>> 13) | 0) + (vt >>> 26) | 0, vt &= 67108863, n = Math.imul(_, z), i = (i = Math.imul(_, q)) + Math.imul(w, z) | 0, o = Math.imul(w, q), n = n + Math.imul(b, Y) | 0, i = (i = i + Math.imul(b, G) | 0) + Math.imul(v, Y) | 0, o = o + Math.imul(v, G) | 0, n = n + Math.imul(p, Z) | 0, i = (i = i + Math.imul(p, V) | 0) + Math.imul(g, Z) | 0, o = o + Math.imul(g, V) | 0;
                var yt = (f + (n = n + Math.imul(h, J) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, X) | 0) + Math.imul(l, J) | 0)) << 13) | 0;
                f = ((o = o + Math.imul(l, X) | 0) + (i >>> 13) | 0) + (yt >>> 26) | 0, yt &= 67108863, n = Math.imul(M, z), i = (i = Math.imul(M, q)) + Math.imul(S, z) | 0, o = Math.imul(S, q), n = n + Math.imul(_, Y) | 0, i = (i = i + Math.imul(_, G) | 0) + Math.imul(w, Y) | 0, o = o + Math.imul(w, G) | 0, n = n + Math.imul(b, Z) | 0, i = (i = i + Math.imul(b, V) | 0) + Math.imul(v, Z) | 0, o = o + Math.imul(v, V) | 0, n = n + Math.imul(p, J) | 0, i = (i = i + Math.imul(p, X) | 0) + Math.imul(g, J) | 0, o = o + Math.imul(g, X) | 0;

                var _t = (f + (n = n + Math.imul(h, Q) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, tt) | 0) + Math.imul(l, Q) | 0)) << 13) | 0;

                f = ((o = o + Math.imul(l, tt) | 0) + (i >>> 13) | 0) + (_t >>> 26) | 0, _t &= 67108863, n = Math.imul(x, z), i = (i = Math.imul(x, q)) + Math.imul(R, z) | 0, o = Math.imul(R, q), n = n + Math.imul(M, Y) | 0, i = (i = i + Math.imul(M, G) | 0) + Math.imul(S, Y) | 0, o = o + Math.imul(S, G) | 0, n = n + Math.imul(_, Z) | 0, i = (i = i + Math.imul(_, V) | 0) + Math.imul(w, Z) | 0, o = o + Math.imul(w, V) | 0, n = n + Math.imul(b, J) | 0, i = (i = i + Math.imul(b, X) | 0) + Math.imul(v, J) | 0, o = o + Math.imul(v, X) | 0, n = n + Math.imul(p, Q) | 0, i = (i = i + Math.imul(p, tt) | 0) + Math.imul(g, Q) | 0, o = o + Math.imul(g, tt) | 0;
                var wt = (f + (n = n + Math.imul(h, rt) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, nt) | 0) + Math.imul(l, rt) | 0)) << 13) | 0;
                f = ((o = o + Math.imul(l, nt) | 0) + (i >>> 13) | 0) + (wt >>> 26) | 0, wt &= 67108863, n = Math.imul(k, z), i = (i = Math.imul(k, q)) + Math.imul(I, z) | 0, o = Math.imul(I, q), n = n + Math.imul(x, Y) | 0, i = (i = i + Math.imul(x, G) | 0) + Math.imul(R, Y) | 0, o = o + Math.imul(R, G) | 0, n = n + Math.imul(M, Z) | 0, i = (i = i + Math.imul(M, V) | 0) + Math.imul(S, Z) | 0, o = o + Math.imul(S, V) | 0, n = n + Math.imul(_, J) | 0, i = (i = i + Math.imul(_, X) | 0) + Math.imul(w, J) | 0, o = o + Math.imul(w, X) | 0, n = n + Math.imul(b, Q) | 0, i = (i = i + Math.imul(b, tt) | 0) + Math.imul(v, Q) | 0, o = o + Math.imul(v, tt) | 0, n = n + Math.imul(p, rt) | 0, i = (i = i + Math.imul(p, nt) | 0) + Math.imul(g, rt) | 0, o = o + Math.imul(g, nt) | 0;
                var Et = (f + (n = n + Math.imul(h, ot) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, st) | 0) + Math.imul(l, ot) | 0)) << 13) | 0;
                f = ((o = o + Math.imul(l, st) | 0) + (i >>> 13) | 0) + (Et >>> 26) | 0, Et &= 67108863, n = Math.imul(O, z), i = (i = Math.imul(O, q)) + Math.imul(P, z) | 0, o = Math.imul(P, q), n = n + Math.imul(k, Y) | 0, i = (i = i + Math.imul(k, G) | 0) + Math.imul(I, Y) | 0, o = o + Math.imul(I, G) | 0, n = n + Math.imul(x, Z) | 0, i = (i = i + Math.imul(x, V) | 0) + Math.imul(R, Z) | 0, o = o + Math.imul(R, V) | 0, n = n + Math.imul(M, J) | 0, i = (i = i + Math.imul(M, X) | 0) + Math.imul(S, J) | 0, o = o + Math.imul(S, X) | 0, n = n + Math.imul(_, Q) | 0, i = (i = i + Math.imul(_, tt) | 0) + Math.imul(w, Q) | 0, o = o + Math.imul(w, tt) | 0, n = n + Math.imul(b, rt) | 0, i = (i = i + Math.imul(b, nt) | 0) + Math.imul(v, rt) | 0, o = o + Math.imul(v, nt) | 0, n = n + Math.imul(p, ot) | 0, i = (i = i + Math.imul(p, st) | 0) + Math.imul(g, ot) | 0, o = o + Math.imul(g, st) | 0;
                var Mt = (f + (n = n + Math.imul(h, ut) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, ft) | 0) + Math.imul(l, ut) | 0)) << 13) | 0;
                f = ((o = o + Math.imul(l, ft) | 0) + (i >>> 13) | 0) + (Mt >>> 26) | 0, Mt &= 67108863, n = Math.imul(C, z), i = (i = Math.imul(C, q)) + Math.imul(L, z) | 0, o = Math.imul(L, q), n = n + Math.imul(O, Y) | 0, i = (i = i + Math.imul(O, G) | 0) + Math.imul(P, Y) | 0, o = o + Math.imul(P, G) | 0, n = n + Math.imul(k, Z) | 0, i = (i = i + Math.imul(k, V) | 0) + Math.imul(I, Z) | 0, o = o + Math.imul(I, V) | 0, n = n + Math.imul(x, J) | 0, i = (i = i + Math.imul(x, X) | 0) + Math.imul(R, J) | 0, o = o + Math.imul(R, X) | 0, n = n + Math.imul(M, Q) | 0, i = (i = i + Math.imul(M, tt) | 0) + Math.imul(S, Q) | 0, o = o + Math.imul(S, tt) | 0, n = n + Math.imul(_, rt) | 0, i = (i = i + Math.imul(_, nt) | 0) + Math.imul(w, rt) | 0, o = o + Math.imul(w, nt) | 0, n = n + Math.imul(b, ot) | 0, i = (i = i + Math.imul(b, st) | 0) + Math.imul(v, ot) | 0, o = o + Math.imul(v, st) | 0, n = n + Math.imul(p, ut) | 0, i = (i = i + Math.imul(p, ft) | 0) + Math.imul(g, ut) | 0, o = o + Math.imul(g, ft) | 0;
                var St = (f + (n = n + Math.imul(h, ht) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, lt) | 0) + Math.imul(l, ht) | 0)) << 13) | 0;
                f = ((o = o + Math.imul(l, lt) | 0) + (i >>> 13) | 0) + (St >>> 26) | 0, St &= 67108863, n = Math.imul(U, z), i = (i = Math.imul(U, q)) + Math.imul(D, z) | 0, o = Math.imul(D, q), n = n + Math.imul(C, Y) | 0, i = (i = i + Math.imul(C, G) | 0) + Math.imul(L, Y) | 0, o = o + Math.imul(L, G) | 0, n = n + Math.imul(O, Z) | 0, i = (i = i + Math.imul(O, V) | 0) + Math.imul(P, Z) | 0, o = o + Math.imul(P, V) | 0, n = n + Math.imul(k, J) | 0, i = (i = i + Math.imul(k, X) | 0) + Math.imul(I, J) | 0, o = o + Math.imul(I, X) | 0, n = n + Math.imul(x, Q) | 0, i = (i = i + Math.imul(x, tt) | 0) + Math.imul(R, Q) | 0, o = o + Math.imul(R, tt) | 0, n = n + Math.imul(M, rt) | 0, i = (i = i + Math.imul(M, nt) | 0) + Math.imul(S, rt) | 0, o = o + Math.imul(S, nt) | 0, n = n + Math.imul(_, ot) | 0, i = (i = i + Math.imul(_, st) | 0) + Math.imul(w, ot) | 0, o = o + Math.imul(w, st) | 0, n = n + Math.imul(b, ut) | 0, i = (i = i + Math.imul(b, ft) | 0) + Math.imul(v, ut) | 0, o = o + Math.imul(v, ft) | 0, n = n + Math.imul(p, ht) | 0, i = (i = i + Math.imul(p, lt) | 0) + Math.imul(g, ht) | 0, o = o + Math.imul(g, lt) | 0;
                var At = (f + (n = n + Math.imul(h, pt) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, gt) | 0) + Math.imul(l, pt) | 0)) << 13) | 0;
                f = ((o = o + Math.imul(l, gt) | 0) + (i >>> 13) | 0) + (At >>> 26) | 0, At &= 67108863, n = Math.imul(U, Y), i = (i = Math.imul(U, G)) + Math.imul(D, Y) | 0, o = Math.imul(D, G), n = n + Math.imul(C, Z) | 0, i = (i = i + Math.imul(C, V) | 0) + Math.imul(L, Z) | 0, o = o + Math.imul(L, V) | 0, n = n + Math.imul(O, J) | 0, i = (i = i + Math.imul(O, X) | 0) + Math.imul(P, J) | 0, o = o + Math.imul(P, X) | 0, n = n + Math.imul(k, Q) | 0, i = (i = i + Math.imul(k, tt) | 0) + Math.imul(I, Q) | 0, o = o + Math.imul(I, tt) | 0, n = n + Math.imul(x, rt) | 0, i = (i = i + Math.imul(x, nt) | 0) + Math.imul(R, rt) | 0, o = o + Math.imul(R, nt) | 0, n = n + Math.imul(M, ot) | 0, i = (i = i + Math.imul(M, st) | 0) + Math.imul(S, ot) | 0, o = o + Math.imul(S, st) | 0, n = n + Math.imul(_, ut) | 0, i = (i = i + Math.imul(_, ft) | 0) + Math.imul(w, ut) | 0, o = o + Math.imul(w, ft) | 0, n = n + Math.imul(b, ht) | 0, i = (i = i + Math.imul(b, lt) | 0) + Math.imul(v, ht) | 0, o = o + Math.imul(v, lt) | 0;
                var xt = (f + (n = n + Math.imul(p, pt) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(p, gt) | 0) + Math.imul(g, pt) | 0)) << 13) | 0;
                f = ((o = o + Math.imul(g, gt) | 0) + (i >>> 13) | 0) + (xt >>> 26) | 0, xt &= 67108863, n = Math.imul(U, Z), i = (i = Math.imul(U, V)) + Math.imul(D, Z) | 0, o = Math.imul(D, V), n = n + Math.imul(C, J) | 0, i = (i = i + Math.imul(C, X) | 0) + Math.imul(L, J) | 0, o = o + Math.imul(L, X) | 0, n = n + Math.imul(O, Q) | 0, i = (i = i + Math.imul(O, tt) | 0) + Math.imul(P, Q) | 0, o = o + Math.imul(P, tt) | 0, n = n + Math.imul(k, rt) | 0, i = (i = i + Math.imul(k, nt) | 0) + Math.imul(I, rt) | 0, o = o + Math.imul(I, nt) | 0, n = n + Math.imul(x, ot) | 0, i = (i = i + Math.imul(x, st) | 0) + Math.imul(R, ot) | 0, o = o + Math.imul(R, st) | 0, n = n + Math.imul(M, ut) | 0, i = (i = i + Math.imul(M, ft) | 0) + Math.imul(S, ut) | 0, o = o + Math.imul(S, ft) | 0, n = n + Math.imul(_, ht) | 0, i = (i = i + Math.imul(_, lt) | 0) + Math.imul(w, ht) | 0, o = o + Math.imul(w, lt) | 0;
                var Rt = (f + (n = n + Math.imul(b, pt) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(b, gt) | 0) + Math.imul(v, pt) | 0)) << 13) | 0;
                f = ((o = o + Math.imul(v, gt) | 0) + (i >>> 13) | 0) + (Rt >>> 26) | 0, Rt &= 67108863, n = Math.imul(U, J), i = (i = Math.imul(U, X)) + Math.imul(D, J) | 0, o = Math.imul(D, X), n = n + Math.imul(C, Q) | 0, i = (i = i + Math.imul(C, tt) | 0) + Math.imul(L, Q) | 0, o = o + Math.imul(L, tt) | 0, n = n + Math.imul(O, rt) | 0, i = (i = i + Math.imul(O, nt) | 0) + Math.imul(P, rt) | 0, o = o + Math.imul(P, nt) | 0, n = n + Math.imul(k, ot) | 0, i = (i = i + Math.imul(k, st) | 0) + Math.imul(I, ot) | 0, o = o + Math.imul(I, st) | 0, n = n + Math.imul(x, ut) | 0, i = (i = i + Math.imul(x, ft) | 0) + Math.imul(R, ut) | 0, o = o + Math.imul(R, ft) | 0, n = n + Math.imul(M, ht) | 0, i = (i = i + Math.imul(M, lt) | 0) + Math.imul(S, ht) | 0, o = o + Math.imul(S, lt) | 0;
                var Tt = (f + (n = n + Math.imul(_, pt) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(_, gt) | 0) + Math.imul(w, pt) | 0)) << 13) | 0;
                f = ((o = o + Math.imul(w, gt) | 0) + (i >>> 13) | 0) + (Tt >>> 26) | 0, Tt &= 67108863, n = Math.imul(U, Q), i = (i = Math.imul(U, tt)) + Math.imul(D, Q) | 0, o = Math.imul(D, tt), n = n + Math.imul(C, rt) | 0, i = (i = i + Math.imul(C, nt) | 0) + Math.imul(L, rt) | 0, o = o + Math.imul(L, nt) | 0, n = n + Math.imul(O, ot) | 0, i = (i = i + Math.imul(O, st) | 0) + Math.imul(P, ot) | 0, o = o + Math.imul(P, st) | 0, n = n + Math.imul(k, ut) | 0, i = (i = i + Math.imul(k, ft) | 0) + Math.imul(I, ut) | 0, o = o + Math.imul(I, ft) | 0, n = n + Math.imul(x, ht) | 0, i = (i = i + Math.imul(x, lt) | 0) + Math.imul(R, ht) | 0, o = o + Math.imul(R, lt) | 0;
                var kt = (f + (n = n + Math.imul(M, pt) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(M, gt) | 0) + Math.imul(S, pt) | 0)) << 13) | 0;
                f = ((o = o + Math.imul(S, gt) | 0) + (i >>> 13) | 0) + (kt >>> 26) | 0, kt &= 67108863, n = Math.imul(U, rt), i = (i = Math.imul(U, nt)) + Math.imul(D, rt) | 0, o = Math.imul(D, nt), n = n + Math.imul(C, ot) | 0, i = (i = i + Math.imul(C, st) | 0) + Math.imul(L, ot) | 0, o = o + Math.imul(L, st) | 0, n = n + Math.imul(O, ut) | 0, i = (i = i + Math.imul(O, ft) | 0) + Math.imul(P, ut) | 0, o = o + Math.imul(P, ft) | 0, n = n + Math.imul(k, ht) | 0, i = (i = i + Math.imul(k, lt) | 0) + Math.imul(I, ht) | 0, o = o + Math.imul(I, lt) | 0;
                var It = (f + (n = n + Math.imul(x, pt) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(x, gt) | 0) + Math.imul(R, pt) | 0)) << 13) | 0;
                f = ((o = o + Math.imul(R, gt) | 0) + (i >>> 13) | 0) + (It >>> 26) | 0, It &= 67108863, n = Math.imul(U, ot), i = (i = Math.imul(U, st)) + Math.imul(D, ot) | 0, o = Math.imul(D, st), n = n + Math.imul(C, ut) | 0, i = (i = i + Math.imul(C, ft) | 0) + Math.imul(L, ut) | 0, o = o + Math.imul(L, ft) | 0, n = n + Math.imul(O, ht) | 0, i = (i = i + Math.imul(O, lt) | 0) + Math.imul(P, ht) | 0, o = o + Math.imul(P, lt) | 0;
                var Bt = (f + (n = n + Math.imul(k, pt) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(k, gt) | 0) + Math.imul(I, pt) | 0)) << 13) | 0;
                f = ((o = o + Math.imul(I, gt) | 0) + (i >>> 13) | 0) + (Bt >>> 26) | 0, Bt &= 67108863, n = Math.imul(U, ut), i = (i = Math.imul(U, ft)) + Math.imul(D, ut) | 0, o = Math.imul(D, ft), n = n + Math.imul(C, ht) | 0, i = (i = i + Math.imul(C, lt) | 0) + Math.imul(L, ht) | 0, o = o + Math.imul(L, lt) | 0;
                var Ot = (f + (n = n + Math.imul(O, pt) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(O, gt) | 0) + Math.imul(P, pt) | 0)) << 13) | 0;
                f = ((o = o + Math.imul(P, gt) | 0) + (i >>> 13) | 0) + (Ot >>> 26) | 0, Ot &= 67108863, n = Math.imul(U, ht), i = (i = Math.imul(U, lt)) + Math.imul(D, ht) | 0, o = Math.imul(D, lt);
                var Pt = (f + (n = n + Math.imul(C, pt) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(C, gt) | 0) + Math.imul(L, pt) | 0)) << 13) | 0;
                f = ((o = o + Math.imul(L, gt) | 0) + (i >>> 13) | 0) + (Pt >>> 26) | 0, Pt &= 67108863;
                var Nt = (f + (n = Math.imul(U, pt)) | 0) + ((8191 & (i = (i = Math.imul(U, gt)) + Math.imul(D, pt) | 0)) << 13) | 0;
                return f = ((o = Math.imul(D, gt)) + (i >>> 13) | 0) + (Nt >>> 26) | 0, Nt &= 67108863, u[0] = mt, u[1] = bt, u[2] = vt, u[3] = yt, u[4] = _t, u[5] = wt, u[6] = Et, u[7] = Mt, u[8] = St, u[9] = At, u[10] = xt, u[11] = Rt, u[12] = Tt, u[13] = kt, u[14] = It, u[15] = Bt, u[16] = Ot, u[17] = Pt, u[18] = Nt, 0 !== f && (u[19] = f, r.length++), r;
              };

              function p(t, e, r) {
                return new g().mulp(t, e, r);
              }

              function g(t, e) {
                this.x = t, this.y = e;
              }

              Math.imul || (d = l), o.prototype.mulTo = function (t, e) {
                var r = this.length + t.length;
                return 10 === this.length && 10 === t.length ? d(this, t, e) : r < 63 ? l(this, t, e) : r < 1024 ? function (t, e, r) {
                  r.negative = e.negative ^ t.negative, r.length = t.length + e.length;

                  for (var n = 0, i = 0, o = 0; o < r.length - 1; o++) {
                    var s = i;
                    i = 0;

                    for (var a = 67108863 & n, u = Math.min(o, e.length - 1), f = Math.max(0, o - t.length + 1); f <= u; f++) {
                      var c = o - f,
                          h = (0 | t.words[c]) * (0 | e.words[f]),
                          l = 67108863 & h;
                      a = 67108863 & (l = l + a | 0), i += (s = (s = s + (h / 67108864 | 0) | 0) + (l >>> 26) | 0) >>> 26, s &= 67108863;
                    }

                    r.words[o] = a, n = s, s = i;
                  }

                  return 0 !== n ? r.words[o] = n : r.length--, r.strip();
                }(this, t, e) : p(this, t, e);
              }, g.prototype.makeRBT = function (t) {
                for (var e = new Array(t), r = o.prototype._countBits(t) - 1, n = 0; n < t; n++) {
                  e[n] = this.revBin(n, r, t);
                }

                return e;
              }, g.prototype.revBin = function (t, e, r) {
                if (0 === t || t === r - 1) return t;

                for (var n = 0, i = 0; i < e; i++) {
                  n |= (1 & t) << e - i - 1, t >>= 1;
                }

                return n;
              }, g.prototype.permute = function (t, e, r, n, i, o) {
                for (var s = 0; s < o; s++) {
                  n[s] = e[t[s]], i[s] = r[t[s]];
                }
              }, g.prototype.transform = function (t, e, r, n, i, o) {
                this.permute(o, t, e, r, n, i);

                for (var s = 1; s < i; s <<= 1) {
                  for (var a = s << 1, u = Math.cos(2 * Math.PI / a), f = Math.sin(2 * Math.PI / a), c = 0; c < i; c += a) {
                    for (var h = u, l = f, d = 0; d < s; d++) {
                      var p = r[c + d],
                          g = n[c + d],
                          m = r[c + d + s],
                          b = n[c + d + s],
                          v = h * m - l * b;
                      b = h * b + l * m, m = v, r[c + d] = p + m, n[c + d] = g + b, r[c + d + s] = p - m, n[c + d + s] = g - b, d !== a && (v = u * h - f * l, l = u * l + f * h, h = v);
                    }
                  }
                }
              }, g.prototype.guessLen13b = function (t, e) {
                var r = 1 | Math.max(e, t),
                    n = 1 & r,
                    i = 0;

                for (r = r / 2 | 0; r; r >>>= 1) {
                  i++;
                }

                return 1 << i + 1 + n;
              }, g.prototype.conjugate = function (t, e, r) {
                if (!(r <= 1)) for (var n = 0; n < r / 2; n++) {
                  var i = t[n];
                  t[n] = t[r - n - 1], t[r - n - 1] = i, i = e[n], e[n] = -e[r - n - 1], e[r - n - 1] = -i;
                }
              }, g.prototype.normalize13b = function (t, e) {
                for (var r = 0, n = 0; n < e / 2; n++) {
                  var i = 8192 * Math.round(t[2 * n + 1] / e) + Math.round(t[2 * n] / e) + r;
                  t[n] = 67108863 & i, r = i < 67108864 ? 0 : i / 67108864 | 0;
                }

                return t;
              }, g.prototype.convert13b = function (t, e, r, i) {
                for (var o = 0, s = 0; s < e; s++) {
                  o += 0 | t[s], r[2 * s] = 8191 & o, o >>>= 13, r[2 * s + 1] = 8191 & o, o >>>= 13;
                }

                for (s = 2 * e; s < i; ++s) {
                  r[s] = 0;
                }

                n(0 === o), n(0 == (-8192 & o));
              }, g.prototype.stub = function (t) {
                for (var e = new Array(t), r = 0; r < t; r++) {
                  e[r] = 0;
                }

                return e;
              }, g.prototype.mulp = function (t, e, r) {
                var n = 2 * this.guessLen13b(t.length, e.length),
                    i = this.makeRBT(n),
                    o = this.stub(n),
                    s = new Array(n),
                    a = new Array(n),
                    u = new Array(n),
                    f = new Array(n),
                    c = new Array(n),
                    h = new Array(n),
                    l = r.words;
                l.length = n, this.convert13b(t.words, t.length, s, n), this.convert13b(e.words, e.length, f, n), this.transform(s, o, a, u, n, i), this.transform(f, o, c, h, n, i);

                for (var d = 0; d < n; d++) {
                  var p = a[d] * c[d] - u[d] * h[d];
                  u[d] = a[d] * h[d] + u[d] * c[d], a[d] = p;
                }

                return this.conjugate(a, u, n), this.transform(a, u, l, o, n, i), this.conjugate(l, o, n), this.normalize13b(l, n), r.negative = t.negative ^ e.negative, r.length = t.length + e.length, r.strip();
              }, o.prototype.mul = function (t) {
                var e = new o(null);
                return e.words = new Array(this.length + t.length), this.mulTo(t, e);
              }, o.prototype.mulf = function (t) {
                var e = new o(null);
                return e.words = new Array(this.length + t.length), p(this, t, e);
              }, o.prototype.imul = function (t) {
                return this.clone().mulTo(t, this);
              }, o.prototype.imuln = function (t) {
                n("number" == typeof t), n(t < 67108864);

                for (var e = 0, r = 0; r < this.length; r++) {
                  var i = (0 | this.words[r]) * t,
                      o = (67108863 & i) + (67108863 & e);
                  e >>= 26, e += i / 67108864 | 0, e += o >>> 26, this.words[r] = 67108863 & o;
                }

                return 0 !== e && (this.words[r] = e, this.length++), this;
              }, o.prototype.muln = function (t) {
                return this.clone().imuln(t);
              }, o.prototype.sqr = function () {
                return this.mul(this);
              }, o.prototype.isqr = function () {
                return this.imul(this.clone());
              }, o.prototype.pow = function (t) {
                var e = function (t) {
                  for (var e = new Array(t.bitLength()), r = 0; r < e.length; r++) {
                    var n = r / 26 | 0,
                        i = r % 26;
                    e[r] = (t.words[n] & 1 << i) >>> i;
                  }

                  return e;
                }(t);

                if (0 === e.length) return new o(1);

                for (var r = this, n = 0; n < e.length && 0 === e[n]; n++, r = r.sqr()) {
                  ;
                }

                if (++n < e.length) for (var i = r.sqr(); n < e.length; n++, i = i.sqr()) {
                  0 !== e[n] && (r = r.mul(i));
                }
                return r;
              }, o.prototype.iushln = function (t) {
                n("number" == typeof t && t >= 0);
                var e,
                    r = t % 26,
                    i = (t - r) / 26,
                    o = 67108863 >>> 26 - r << 26 - r;

                if (0 !== r) {
                  var s = 0;

                  for (e = 0; e < this.length; e++) {
                    var a = this.words[e] & o,
                        u = (0 | this.words[e]) - a << r;
                    this.words[e] = u | s, s = a >>> 26 - r;
                  }

                  s && (this.words[e] = s, this.length++);
                }

                if (0 !== i) {
                  for (e = this.length - 1; e >= 0; e--) {
                    this.words[e + i] = this.words[e];
                  }

                  for (e = 0; e < i; e++) {
                    this.words[e] = 0;
                  }

                  this.length += i;
                }

                return this.strip();
              }, o.prototype.ishln = function (t) {
                return n(0 === this.negative), this.iushln(t);
              }, o.prototype.iushrn = function (t, e, r) {
                var i;
                n("number" == typeof t && t >= 0), i = e ? (e - e % 26) / 26 : 0;
                var o = t % 26,
                    s = Math.min((t - o) / 26, this.length),
                    a = 67108863 ^ 67108863 >>> o << o,
                    u = r;

                if (i -= s, i = Math.max(0, i), u) {
                  for (var f = 0; f < s; f++) {
                    u.words[f] = this.words[f];
                  }

                  u.length = s;
                }

                if (0 === s) ;else if (this.length > s) for (this.length -= s, f = 0; f < this.length; f++) {
                  this.words[f] = this.words[f + s];
                } else this.words[0] = 0, this.length = 1;
                var c = 0;

                for (f = this.length - 1; f >= 0 && (0 !== c || f >= i); f--) {
                  var h = 0 | this.words[f];
                  this.words[f] = c << 26 - o | h >>> o, c = h & a;
                }

                return u && 0 !== c && (u.words[u.length++] = c), 0 === this.length && (this.words[0] = 0, this.length = 1), this.strip();
              }, o.prototype.ishrn = function (t, e, r) {
                return n(0 === this.negative), this.iushrn(t, e, r);
              }, o.prototype.shln = function (t) {
                return this.clone().ishln(t);
              }, o.prototype.ushln = function (t) {
                return this.clone().iushln(t);
              }, o.prototype.shrn = function (t) {
                return this.clone().ishrn(t);
              }, o.prototype.ushrn = function (t) {
                return this.clone().iushrn(t);
              }, o.prototype.testn = function (t) {
                n("number" == typeof t && t >= 0);
                var e = t % 26,
                    r = (t - e) / 26,
                    i = 1 << e;
                return !(this.length <= r || !(this.words[r] & i));
              }, o.prototype.imaskn = function (t) {
                n("number" == typeof t && t >= 0);
                var e = t % 26,
                    r = (t - e) / 26;
                if (n(0 === this.negative, "imaskn works only with positive numbers"), this.length <= r) return this;

                if (0 !== e && r++, this.length = Math.min(r, this.length), 0 !== e) {
                  var i = 67108863 ^ 67108863 >>> e << e;
                  this.words[this.length - 1] &= i;
                }

                return this.strip();
              }, o.prototype.maskn = function (t) {
                return this.clone().imaskn(t);
              }, o.prototype.iaddn = function (t) {
                return n("number" == typeof t), n(t < 67108864), t < 0 ? this.isubn(-t) : 0 !== this.negative ? 1 === this.length && (0 | this.words[0]) < t ? (this.words[0] = t - (0 | this.words[0]), this.negative = 0, this) : (this.negative = 0, this.isubn(t), this.negative = 1, this) : this._iaddn(t);
              }, o.prototype._iaddn = function (t) {
                this.words[0] += t;

                for (var e = 0; e < this.length && this.words[e] >= 67108864; e++) {
                  this.words[e] -= 67108864, e === this.length - 1 ? this.words[e + 1] = 1 : this.words[e + 1]++;
                }

                return this.length = Math.max(this.length, e + 1), this;
              }, o.prototype.isubn = function (t) {
                if (n("number" == typeof t), n(t < 67108864), t < 0) return this.iaddn(-t);
                if (0 !== this.negative) return this.negative = 0, this.iaddn(t), this.negative = 1, this;
                if (this.words[0] -= t, 1 === this.length && this.words[0] < 0) this.words[0] = -this.words[0], this.negative = 1;else for (var e = 0; e < this.length && this.words[e] < 0; e++) {
                  this.words[e] += 67108864, this.words[e + 1] -= 1;
                }
                return this.strip();
              }, o.prototype.addn = function (t) {
                return this.clone().iaddn(t);
              }, o.prototype.subn = function (t) {
                return this.clone().isubn(t);
              }, o.prototype.iabs = function () {
                return this.negative = 0, this;
              }, o.prototype.abs = function () {
                return this.clone().iabs();
              }, o.prototype._ishlnsubmul = function (t, e, r) {
                var i,
                    o,
                    s = t.length + r;

                this._expand(s);

                var a = 0;

                for (i = 0; i < t.length; i++) {
                  o = (0 | this.words[i + r]) + a;
                  var u = (0 | t.words[i]) * e;
                  a = ((o -= 67108863 & u) >> 26) - (u / 67108864 | 0), this.words[i + r] = 67108863 & o;
                }

                for (; i < this.length - r; i++) {
                  a = (o = (0 | this.words[i + r]) + a) >> 26, this.words[i + r] = 67108863 & o;
                }

                if (0 === a) return this.strip();

                for (n(-1 === a), a = 0, i = 0; i < this.length; i++) {
                  a = (o = -(0 | this.words[i]) + a) >> 26, this.words[i] = 67108863 & o;
                }

                return this.negative = 1, this.strip();
              }, o.prototype._wordDiv = function (t, e) {
                var r = (this.length, t.length),
                    n = this.clone(),
                    i = t,
                    s = 0 | i.words[i.length - 1];
                0 != (r = 26 - this._countBits(s)) && (i = i.ushln(r), n.iushln(r), s = 0 | i.words[i.length - 1]);
                var a,
                    u = n.length - i.length;

                if ("mod" !== e) {
                  (a = new o(null)).length = u + 1, a.words = new Array(a.length);

                  for (var f = 0; f < a.length; f++) {
                    a.words[f] = 0;
                  }
                }

                var c = n.clone()._ishlnsubmul(i, 1, u);

                0 === c.negative && (n = c, a && (a.words[u] = 1));

                for (var h = u - 1; h >= 0; h--) {
                  var l = 67108864 * (0 | n.words[i.length + h]) + (0 | n.words[i.length + h - 1]);

                  for (l = Math.min(l / s | 0, 67108863), n._ishlnsubmul(i, l, h); 0 !== n.negative;) {
                    l--, n.negative = 0, n._ishlnsubmul(i, 1, h), n.isZero() || (n.negative ^= 1);
                  }

                  a && (a.words[h] = l);
                }

                return a && a.strip(), n.strip(), "div" !== e && 0 !== r && n.iushrn(r), {
                  div: a || null,
                  mod: n
                };
              }, o.prototype.divmod = function (t, e, r) {
                return n(!t.isZero()), this.isZero() ? {
                  div: new o(0),
                  mod: new o(0)
                } : 0 !== this.negative && 0 === t.negative ? (a = this.neg().divmod(t, e), "mod" !== e && (i = a.div.neg()), "div" !== e && (s = a.mod.neg(), r && 0 !== s.negative && s.iadd(t)), {
                  div: i,
                  mod: s
                }) : 0 === this.negative && 0 !== t.negative ? (a = this.divmod(t.neg(), e), "mod" !== e && (i = a.div.neg()), {
                  div: i,
                  mod: a.mod
                }) : 0 != (this.negative & t.negative) ? (a = this.neg().divmod(t.neg(), e), "div" !== e && (s = a.mod.neg(), r && 0 !== s.negative && s.isub(t)), {
                  div: a.div,
                  mod: s
                }) : t.length > this.length || this.cmp(t) < 0 ? {
                  div: new o(0),
                  mod: this
                } : 1 === t.length ? "div" === e ? {
                  div: this.divn(t.words[0]),
                  mod: null
                } : "mod" === e ? {
                  div: null,
                  mod: new o(this.modn(t.words[0]))
                } : {
                  div: this.divn(t.words[0]),
                  mod: new o(this.modn(t.words[0]))
                } : this._wordDiv(t, e);
                var i, s, a;
              }, o.prototype.div = function (t) {
                return this.divmod(t, "div", !1).div;
              }, o.prototype.mod = function (t) {
                return this.divmod(t, "mod", !1).mod;
              }, o.prototype.umod = function (t) {
                return this.divmod(t, "mod", !0).mod;
              }, o.prototype.divRound = function (t) {
                var e = this.divmod(t);
                if (e.mod.isZero()) return e.div;
                var r = 0 !== e.div.negative ? e.mod.isub(t) : e.mod,
                    n = t.ushrn(1),
                    i = t.andln(1),
                    o = r.cmp(n);
                return o < 0 || 1 === i && 0 === o ? e.div : 0 !== e.div.negative ? e.div.isubn(1) : e.div.iaddn(1);
              }, o.prototype.modn = function (t) {
                n(t <= 67108863);

                for (var e = (1 << 26) % t, r = 0, i = this.length - 1; i >= 0; i--) {
                  r = (e * r + (0 | this.words[i])) % t;
                }

                return r;
              }, o.prototype.idivn = function (t) {
                n(t <= 67108863);

                for (var e = 0, r = this.length - 1; r >= 0; r--) {
                  var i = (0 | this.words[r]) + 67108864 * e;
                  this.words[r] = i / t | 0, e = i % t;
                }

                return this.strip();
              }, o.prototype.divn = function (t) {
                return this.clone().idivn(t);
              }, o.prototype.egcd = function (t) {
                n(0 === t.negative), n(!t.isZero());
                var e = this,
                    r = t.clone();
                e = 0 !== e.negative ? e.umod(t) : e.clone();

                for (var i = new o(1), s = new o(0), a = new o(0), u = new o(1), f = 0; e.isEven() && r.isEven();) {
                  e.iushrn(1), r.iushrn(1), ++f;
                }

                for (var c = r.clone(), h = e.clone(); !e.isZero();) {
                  for (var l = 0, d = 1; 0 == (e.words[0] & d) && l < 26; ++l, d <<= 1) {
                    ;
                  }

                  if (l > 0) for (e.iushrn(l); l-- > 0;) {
                    (i.isOdd() || s.isOdd()) && (i.iadd(c), s.isub(h)), i.iushrn(1), s.iushrn(1);
                  }

                  for (var p = 0, g = 1; 0 == (r.words[0] & g) && p < 26; ++p, g <<= 1) {
                    ;
                  }

                  if (p > 0) for (r.iushrn(p); p-- > 0;) {
                    (a.isOdd() || u.isOdd()) && (a.iadd(c), u.isub(h)), a.iushrn(1), u.iushrn(1);
                  }
                  e.cmp(r) >= 0 ? (e.isub(r), i.isub(a), s.isub(u)) : (r.isub(e), a.isub(i), u.isub(s));
                }

                return {
                  a: a,
                  b: u,
                  gcd: r.iushln(f)
                };
              }, o.prototype._invmp = function (t) {
                n(0 === t.negative), n(!t.isZero());
                var e = this,
                    r = t.clone();
                e = 0 !== e.negative ? e.umod(t) : e.clone();

                for (var i, s = new o(1), a = new o(0), u = r.clone(); e.cmpn(1) > 0 && r.cmpn(1) > 0;) {
                  for (var f = 0, c = 1; 0 == (e.words[0] & c) && f < 26; ++f, c <<= 1) {
                    ;
                  }

                  if (f > 0) for (e.iushrn(f); f-- > 0;) {
                    s.isOdd() && s.iadd(u), s.iushrn(1);
                  }

                  for (var h = 0, l = 1; 0 == (r.words[0] & l) && h < 26; ++h, l <<= 1) {
                    ;
                  }

                  if (h > 0) for (r.iushrn(h); h-- > 0;) {
                    a.isOdd() && a.iadd(u), a.iushrn(1);
                  }
                  e.cmp(r) >= 0 ? (e.isub(r), s.isub(a)) : (r.isub(e), a.isub(s));
                }

                return (i = 0 === e.cmpn(1) ? s : a).cmpn(0) < 0 && i.iadd(t), i;
              }, o.prototype.gcd = function (t) {
                if (this.isZero()) return t.abs();
                if (t.isZero()) return this.abs();
                var e = this.clone(),
                    r = t.clone();
                e.negative = 0, r.negative = 0;

                for (var n = 0; e.isEven() && r.isEven(); n++) {
                  e.iushrn(1), r.iushrn(1);
                }

                for (;;) {
                  for (; e.isEven();) {
                    e.iushrn(1);
                  }

                  for (; r.isEven();) {
                    r.iushrn(1);
                  }

                  var i = e.cmp(r);

                  if (i < 0) {
                    var o = e;
                    e = r, r = o;
                  } else if (0 === i || 0 === r.cmpn(1)) break;

                  e.isub(r);
                }

                return r.iushln(n);
              }, o.prototype.invm = function (t) {
                return this.egcd(t).a.umod(t);
              }, o.prototype.isEven = function () {
                return 0 == (1 & this.words[0]);
              }, o.prototype.isOdd = function () {
                return 1 == (1 & this.words[0]);
              }, o.prototype.andln = function (t) {
                return this.words[0] & t;
              }, o.prototype.bincn = function (t) {
                n("number" == typeof t);
                var e = t % 26,
                    r = (t - e) / 26,
                    i = 1 << e;
                if (this.length <= r) return this._expand(r + 1), this.words[r] |= i, this;

                for (var o = i, s = r; 0 !== o && s < this.length; s++) {
                  var a = 0 | this.words[s];
                  o = (a += o) >>> 26, a &= 67108863, this.words[s] = a;
                }

                return 0 !== o && (this.words[s] = o, this.length++), this;
              }, o.prototype.isZero = function () {
                return 1 === this.length && 0 === this.words[0];
              }, o.prototype.cmpn = function (t) {
                var e,
                    r = t < 0;
                if (0 !== this.negative && !r) return -1;
                if (0 === this.negative && r) return 1;
                if (this.strip(), this.length > 1) e = 1;else {
                  r && (t = -t), n(t <= 67108863, "Number is too big");
                  var i = 0 | this.words[0];
                  e = i === t ? 0 : i < t ? -1 : 1;
                }
                return 0 !== this.negative ? 0 | -e : e;
              }, o.prototype.cmp = function (t) {
                if (0 !== this.negative && 0 === t.negative) return -1;
                if (0 === this.negative && 0 !== t.negative) return 1;
                var e = this.ucmp(t);
                return 0 !== this.negative ? 0 | -e : e;
              }, o.prototype.ucmp = function (t) {
                if (this.length > t.length) return 1;
                if (this.length < t.length) return -1;

                for (var e = 0, r = this.length - 1; r >= 0; r--) {
                  var n = 0 | this.words[r],
                      i = 0 | t.words[r];

                  if (n !== i) {
                    n < i ? e = -1 : n > i && (e = 1);
                    break;
                  }
                }

                return e;
              }, o.prototype.gtn = function (t) {
                return 1 === this.cmpn(t);
              }, o.prototype.gt = function (t) {
                return 1 === this.cmp(t);
              }, o.prototype.gten = function (t) {
                return this.cmpn(t) >= 0;
              }, o.prototype.gte = function (t) {
                return this.cmp(t) >= 0;
              }, o.prototype.ltn = function (t) {
                return -1 === this.cmpn(t);
              }, o.prototype.lt = function (t) {
                return -1 === this.cmp(t);
              }, o.prototype.lten = function (t) {
                return this.cmpn(t) <= 0;
              }, o.prototype.lte = function (t) {
                return this.cmp(t) <= 0;
              }, o.prototype.eqn = function (t) {
                return 0 === this.cmpn(t);
              }, o.prototype.eq = function (t) {
                return 0 === this.cmp(t);
              }, o.red = function (t) {
                return new E(t);
              }, o.prototype.toRed = function (t) {
                return n(!this.red, "Already a number in reduction context"), n(0 === this.negative, "red works only with positives"), t.convertTo(this)._forceRed(t);
              }, o.prototype.fromRed = function () {
                return n(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
              }, o.prototype._forceRed = function (t) {
                return this.red = t, this;
              }, o.prototype.forceRed = function (t) {
                return n(!this.red, "Already a number in reduction context"), this._forceRed(t);
              }, o.prototype.redAdd = function (t) {
                return n(this.red, "redAdd works only with red numbers"), this.red.add(this, t);
              }, o.prototype.redIAdd = function (t) {
                return n(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, t);
              }, o.prototype.redSub = function (t) {
                return n(this.red, "redSub works only with red numbers"), this.red.sub(this, t);
              }, o.prototype.redISub = function (t) {
                return n(this.red, "redISub works only with red numbers"), this.red.isub(this, t);
              }, o.prototype.redShl = function (t) {
                return n(this.red, "redShl works only with red numbers"), this.red.shl(this, t);
              }, o.prototype.redMul = function (t) {
                return n(this.red, "redMul works only with red numbers"), this.red._verify2(this, t), this.red.mul(this, t);
              }, o.prototype.redIMul = function (t) {
                return n(this.red, "redMul works only with red numbers"), this.red._verify2(this, t), this.red.imul(this, t);
              }, o.prototype.redSqr = function () {
                return n(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
              }, o.prototype.redISqr = function () {
                return n(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
              }, o.prototype.redSqrt = function () {
                return n(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
              }, o.prototype.redInvm = function () {
                return n(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
              }, o.prototype.redNeg = function () {
                return n(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
              }, o.prototype.redPow = function (t) {
                return n(this.red && !t.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, t);
              };
              var m = {
                k256: null,
                p224: null,
                p192: null,
                p25519: null
              };

              function b(t, e) {
                this.name = t, this.p = new o(e, 16), this.n = this.p.bitLength(), this.k = new o(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
              }

              function v() {
                b.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
              }

              function y() {
                b.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
              }

              function _() {
                b.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
              }

              function w() {
                b.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
              }

              function E(t) {
                if ("string" == typeof t) {
                  var e = o._prime(t);

                  this.m = e.p, this.prime = e;
                } else n(t.gtn(1), "modulus must be greater than 1"), this.m = t, this.prime = null;
              }

              function M(t) {
                E.call(this, t), this.shift = this.m.bitLength(), this.shift % 26 != 0 && (this.shift += 26 - this.shift % 26), this.r = new o(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
              }

              b.prototype._tmp = function () {
                var t = new o(null);
                return t.words = new Array(Math.ceil(this.n / 13)), t;
              }, b.prototype.ireduce = function (t) {
                var e,
                    r = t;

                do {
                  this.split(r, this.tmp), e = (r = (r = this.imulK(r)).iadd(this.tmp)).bitLength();
                } while (e > this.n);

                var n = e < this.n ? -1 : r.ucmp(this.p);
                return 0 === n ? (r.words[0] = 0, r.length = 1) : n > 0 ? r.isub(this.p) : r.strip(), r;
              }, b.prototype.split = function (t, e) {
                t.iushrn(this.n, 0, e);
              }, b.prototype.imulK = function (t) {
                return t.imul(this.k);
              }, i(v, b), v.prototype.split = function (t, e) {
                for (var r = Math.min(t.length, 9), n = 0; n < r; n++) {
                  e.words[n] = t.words[n];
                }

                if (e.length = r, t.length <= 9) return t.words[0] = 0, void (t.length = 1);
                var i = t.words[9];

                for (e.words[e.length++] = 4194303 & i, n = 10; n < t.length; n++) {
                  var o = 0 | t.words[n];
                  t.words[n - 10] = (4194303 & o) << 4 | i >>> 22, i = o;
                }

                i >>>= 22, t.words[n - 10] = i, 0 === i && t.length > 10 ? t.length -= 10 : t.length -= 9;
              }, v.prototype.imulK = function (t) {
                t.words[t.length] = 0, t.words[t.length + 1] = 0, t.length += 2;

                for (var e = 0, r = 0; r < t.length; r++) {
                  var n = 0 | t.words[r];
                  e += 977 * n, t.words[r] = 67108863 & e, e = 64 * n + (e / 67108864 | 0);
                }

                return 0 === t.words[t.length - 1] && (t.length--, 0 === t.words[t.length - 1] && t.length--), t;
              }, i(y, b), i(_, b), i(w, b), w.prototype.imulK = function (t) {
                for (var e = 0, r = 0; r < t.length; r++) {
                  var n = 19 * (0 | t.words[r]) + e,
                      i = 67108863 & n;
                  n >>>= 26, t.words[r] = i, e = n;
                }

                return 0 !== e && (t.words[t.length++] = e), t;
              }, o._prime = function (t) {
                if (m[t]) return m[t];
                var e;
                if ("k256" === t) e = new v();else if ("p224" === t) e = new y();else if ("p192" === t) e = new _();else {
                  if ("p25519" !== t) throw new Error("Unknown prime " + t);
                  e = new w();
                }
                return m[t] = e, e;
              }, E.prototype._verify1 = function (t) {
                n(0 === t.negative, "red works only with positives"), n(t.red, "red works only with red numbers");
              }, E.prototype._verify2 = function (t, e) {
                n(0 == (t.negative | e.negative), "red works only with positives"), n(t.red && t.red === e.red, "red works only with red numbers");
              }, E.prototype.imod = function (t) {
                return this.prime ? this.prime.ireduce(t)._forceRed(this) : t.umod(this.m)._forceRed(this);
              }, E.prototype.neg = function (t) {
                return t.isZero() ? t.clone() : this.m.sub(t)._forceRed(this);
              }, E.prototype.add = function (t, e) {
                this._verify2(t, e);

                var r = t.add(e);
                return r.cmp(this.m) >= 0 && r.isub(this.m), r._forceRed(this);
              }, E.prototype.iadd = function (t, e) {
                this._verify2(t, e);

                var r = t.iadd(e);
                return r.cmp(this.m) >= 0 && r.isub(this.m), r;
              }, E.prototype.sub = function (t, e) {
                this._verify2(t, e);

                var r = t.sub(e);
                return r.cmpn(0) < 0 && r.iadd(this.m), r._forceRed(this);
              }, E.prototype.isub = function (t, e) {
                this._verify2(t, e);

                var r = t.isub(e);
                return r.cmpn(0) < 0 && r.iadd(this.m), r;
              }, E.prototype.shl = function (t, e) {
                return this._verify1(t), this.imod(t.ushln(e));
              }, E.prototype.imul = function (t, e) {
                return this._verify2(t, e), this.imod(t.imul(e));
              }, E.prototype.mul = function (t, e) {
                return this._verify2(t, e), this.imod(t.mul(e));
              }, E.prototype.isqr = function (t) {
                return this.imul(t, t.clone());
              }, E.prototype.sqr = function (t) {
                return this.mul(t, t);
              }, E.prototype.sqrt = function (t) {
                if (t.isZero()) return t.clone();
                var e = this.m.andln(3);

                if (n(e % 2 == 1), 3 === e) {
                  var r = this.m.add(new o(1)).iushrn(2);
                  return this.pow(t, r);
                }

                for (var i = this.m.subn(1), s = 0; !i.isZero() && 0 === i.andln(1);) {
                  s++, i.iushrn(1);
                }

                n(!i.isZero());
                var a = new o(1).toRed(this),
                    u = a.redNeg(),
                    f = this.m.subn(1).iushrn(1),
                    c = this.m.bitLength();

                for (c = new o(2 * c * c).toRed(this); 0 !== this.pow(c, f).cmp(u);) {
                  c.redIAdd(u);
                }

                for (var h = this.pow(c, i), l = this.pow(t, i.addn(1).iushrn(1)), d = this.pow(t, i), p = s; 0 !== d.cmp(a);) {
                  for (var g = d, m = 0; 0 !== g.cmp(a); m++) {
                    g = g.redSqr();
                  }

                  n(m < p);
                  var b = this.pow(h, new o(1).iushln(p - m - 1));
                  l = l.redMul(b), h = b.redSqr(), d = d.redMul(h), p = m;
                }

                return l;
              }, E.prototype.invm = function (t) {
                var e = t._invmp(this.m);

                return 0 !== e.negative ? (e.negative = 0, this.imod(e).redNeg()) : this.imod(e);
              }, E.prototype.pow = function (t, e) {
                if (e.isZero()) return new o(1).toRed(this);
                if (0 === e.cmpn(1)) return t.clone();
                var r = new Array(16);
                r[0] = new o(1).toRed(this), r[1] = t;

                for (var n = 2; n < r.length; n++) {
                  r[n] = this.mul(r[n - 1], t);
                }

                var i = r[0],
                    s = 0,
                    a = 0,
                    u = e.bitLength() % 26;

                for (0 === u && (u = 26), n = e.length - 1; n >= 0; n--) {
                  for (var f = e.words[n], c = u - 1; c >= 0; c--) {
                    var h = f >> c & 1;
                    i !== r[0] && (i = this.sqr(i)), 0 !== h || 0 !== s ? (s <<= 1, s |= h, (4 == ++a || 0 === n && 0 === c) && (i = this.mul(i, r[s]), a = 0, s = 0)) : a = 0;
                  }

                  u = 26;
                }

                return i;
              }, E.prototype.convertTo = function (t) {
                var e = t.umod(this.m);
                return e === t ? e.clone() : e;
              }, E.prototype.convertFrom = function (t) {
                var e = t.clone();
                return e.red = null, e;
              }, o.mont = function (t) {
                return new M(t);
              }, i(M, E), M.prototype.convertTo = function (t) {
                return this.imod(t.ushln(this.shift));
              }, M.prototype.convertFrom = function (t) {
                var e = this.imod(t.mul(this.rinv));
                return e.red = null, e;
              }, M.prototype.imul = function (t, e) {
                if (t.isZero() || e.isZero()) return t.words[0] = 0, t.length = 1, t;
                var r = t.imul(e),
                    n = r.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m),
                    i = r.isub(n).iushrn(this.shift),
                    o = i;
                return i.cmp(this.m) >= 0 ? o = i.isub(this.m) : i.cmpn(0) < 0 && (o = i.iadd(this.m)), o._forceRed(this);
              }, M.prototype.mul = function (t, e) {
                if (t.isZero() || e.isZero()) return new o(0)._forceRed(this);
                var r = t.mul(e),
                    n = r.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m),
                    i = r.isub(n).iushrn(this.shift),
                    s = i;
                return i.cmp(this.m) >= 0 ? s = i.isub(this.m) : i.cmpn(0) < 0 && (s = i.iadd(this.m)), s._forceRed(this);
              }, M.prototype.invm = function (t) {
                return this.imod(t._invmp(this.m).mul(this.r2))._forceRed(this);
              };
            }(t, this);
          }).call(this, r(13)(t));
        }, function (t, e) {
          var r;

          r = function () {
            return this;
          }();

          try {
            r = r || new Function("return this")();
          } catch (t) {
            "object" == typeof window && (r = window);
          }

          t.exports = r;
        }, function (t, e, r) {
          (function (e, r) {
            /**
             * [js-sha3]{@link https://github.com/emn178/js-sha3}
             *
             * @version 0.5.7
             * @author Chen, Yi-Cyuan [emn178@gmail.com]
             * @copyright Chen, Yi-Cyuan 2015-2016
             * @license MIT
             */
            !function () {
              "use strict";

              var n = "object" == typeof window ? window : {};
              !n.JS_SHA3_NO_NODE_JS && "object" == typeof e && e.versions && e.versions.node && (n = r);

              for (var i = !n.JS_SHA3_NO_COMMON_JS && "object" == typeof t && t.exports, o = "0123456789abcdef".split(""), s = [0, 8, 16, 24], a = [1, 0, 32898, 0, 32906, 2147483648, 2147516416, 2147483648, 32907, 0, 2147483649, 0, 2147516545, 2147483648, 32777, 2147483648, 138, 0, 136, 0, 2147516425, 0, 2147483658, 0, 2147516555, 0, 139, 2147483648, 32905, 2147483648, 32771, 2147483648, 32770, 2147483648, 128, 2147483648, 32778, 0, 2147483658, 2147483648, 2147516545, 2147483648, 32896, 2147483648, 2147483649, 0, 2147516424, 2147483648], u = [224, 256, 384, 512], f = ["hex", "buffer", "arrayBuffer", "array"], c = function c(t, e, r) {
                return function (n) {
                  return new w(t, e, t).update(n)[r]();
                };
              }, h = function h(t, e, r) {
                return function (n, i) {
                  return new w(t, e, i).update(n)[r]();
                };
              }, l = function l(t, e) {
                var r = c(t, e, "hex");
                r.create = function () {
                  return new w(t, e, t);
                }, r.update = function (t) {
                  return r.create().update(t);
                };

                for (var n = 0; n < f.length; ++n) {
                  var i = f[n];
                  r[i] = c(t, e, i);
                }

                return r;
              }, d = [{
                name: "keccak",
                padding: [1, 256, 65536, 16777216],
                bits: u,
                createMethod: l
              }, {
                name: "sha3",
                padding: [6, 1536, 393216, 100663296],
                bits: u,
                createMethod: l
              }, {
                name: "shake",
                padding: [31, 7936, 2031616, 520093696],
                bits: [128, 256],
                createMethod: function createMethod(t, e) {
                  var r = h(t, e, "hex");
                  r.create = function (r) {
                    return new w(t, e, r);
                  }, r.update = function (t, e) {
                    return r.create(e).update(t);
                  };

                  for (var n = 0; n < f.length; ++n) {
                    var i = f[n];
                    r[i] = h(t, e, i);
                  }

                  return r;
                }
              }], p = {}, g = [], m = 0; m < d.length; ++m) {
                for (var b = d[m], v = b.bits, y = 0; y < v.length; ++y) {
                  var _ = b.name + "_" + v[y];

                  g.push(_), p[_] = b.createMethod(v[y], b.padding);
                }
              }

              function w(t, e, r) {
                this.blocks = [], this.s = [], this.padding = e, this.outputBits = r, this.reset = !0, this.block = 0, this.start = 0, this.blockCount = 1600 - (t << 1) >> 5, this.byteCount = this.blockCount << 2, this.outputBlocks = r >> 5, this.extraBytes = (31 & r) >> 3;

                for (var n = 0; n < 50; ++n) {
                  this.s[n] = 0;
                }
              }

              w.prototype.update = function (t) {
                var e = "string" != typeof t;
                e && t.constructor === ArrayBuffer && (t = new Uint8Array(t));

                for (var r, n, i = t.length, o = this.blocks, a = this.byteCount, u = this.blockCount, f = 0, c = this.s; f < i;) {
                  if (this.reset) for (this.reset = !1, o[0] = this.block, r = 1; r < u + 1; ++r) {
                    o[r] = 0;
                  }
                  if (e) for (r = this.start; f < i && r < a; ++f) {
                    o[r >> 2] |= t[f] << s[3 & r++];
                  } else for (r = this.start; f < i && r < a; ++f) {
                    (n = t.charCodeAt(f)) < 128 ? o[r >> 2] |= n << s[3 & r++] : n < 2048 ? (o[r >> 2] |= (192 | n >> 6) << s[3 & r++], o[r >> 2] |= (128 | 63 & n) << s[3 & r++]) : n < 55296 || n >= 57344 ? (o[r >> 2] |= (224 | n >> 12) << s[3 & r++], o[r >> 2] |= (128 | n >> 6 & 63) << s[3 & r++], o[r >> 2] |= (128 | 63 & n) << s[3 & r++]) : (n = 65536 + ((1023 & n) << 10 | 1023 & t.charCodeAt(++f)), o[r >> 2] |= (240 | n >> 18) << s[3 & r++], o[r >> 2] |= (128 | n >> 12 & 63) << s[3 & r++], o[r >> 2] |= (128 | n >> 6 & 63) << s[3 & r++], o[r >> 2] |= (128 | 63 & n) << s[3 & r++]);
                  }

                  if (this.lastByteIndex = r, r >= a) {
                    for (this.start = r - a, this.block = o[u], r = 0; r < u; ++r) {
                      c[r] ^= o[r];
                    }

                    E(c), this.reset = !0;
                  } else this.start = r;
                }

                return this;
              }, w.prototype.finalize = function () {
                var t = this.blocks,
                    e = this.lastByteIndex,
                    r = this.blockCount,
                    n = this.s;
                if (t[e >> 2] |= this.padding[3 & e], this.lastByteIndex === this.byteCount) for (t[0] = t[r], e = 1; e < r + 1; ++e) {
                  t[e] = 0;
                }

                for (t[r - 1] |= 2147483648, e = 0; e < r; ++e) {
                  n[e] ^= t[e];
                }

                E(n);
              }, w.prototype.toString = w.prototype.hex = function () {
                this.finalize();

                for (var t, e = this.blockCount, r = this.s, n = this.outputBlocks, i = this.extraBytes, s = 0, a = 0, u = ""; a < n;) {
                  for (s = 0; s < e && a < n; ++s, ++a) {
                    t = r[s], u += o[t >> 4 & 15] + o[15 & t] + o[t >> 12 & 15] + o[t >> 8 & 15] + o[t >> 20 & 15] + o[t >> 16 & 15] + o[t >> 28 & 15] + o[t >> 24 & 15];
                  }

                  a % e == 0 && (E(r), s = 0);
                }

                return i && (t = r[s], i > 0 && (u += o[t >> 4 & 15] + o[15 & t]), i > 1 && (u += o[t >> 12 & 15] + o[t >> 8 & 15]), i > 2 && (u += o[t >> 20 & 15] + o[t >> 16 & 15])), u;
              }, w.prototype.arrayBuffer = function () {
                this.finalize();
                var t,
                    e = this.blockCount,
                    r = this.s,
                    n = this.outputBlocks,
                    i = this.extraBytes,
                    o = 0,
                    s = 0,
                    a = this.outputBits >> 3;
                t = i ? new ArrayBuffer(n + 1 << 2) : new ArrayBuffer(a);

                for (var u = new Uint32Array(t); s < n;) {
                  for (o = 0; o < e && s < n; ++o, ++s) {
                    u[s] = r[o];
                  }

                  s % e == 0 && E(r);
                }

                return i && (u[o] = r[o], t = t.slice(0, a)), t;
              }, w.prototype.buffer = w.prototype.arrayBuffer, w.prototype.digest = w.prototype.array = function () {
                this.finalize();

                for (var t, e, r = this.blockCount, n = this.s, i = this.outputBlocks, o = this.extraBytes, s = 0, a = 0, u = []; a < i;) {
                  for (s = 0; s < r && a < i; ++s, ++a) {
                    t = a << 2, e = n[s], u[t] = 255 & e, u[t + 1] = e >> 8 & 255, u[t + 2] = e >> 16 & 255, u[t + 3] = e >> 24 & 255;
                  }

                  a % r == 0 && E(n);
                }

                return o && (t = a << 2, e = n[s], o > 0 && (u[t] = 255 & e), o > 1 && (u[t + 1] = e >> 8 & 255), o > 2 && (u[t + 2] = e >> 16 & 255)), u;
              };

              var E = function E(t) {
                var e, r, n, i, o, s, u, f, c, h, l, d, p, g, m, b, v, y, _, w, E, M, S, A, x, R, T, k, I, B, O, P, N, C, L, j, U, D, F, z, q, H, Y, G, K, Z, V, W, J, X, $, Q, tt, et, rt, nt, it, ot, st, at, ut, ft, ct;

                for (n = 0; n < 48; n += 2) {
                  i = t[0] ^ t[10] ^ t[20] ^ t[30] ^ t[40], o = t[1] ^ t[11] ^ t[21] ^ t[31] ^ t[41], s = t[2] ^ t[12] ^ t[22] ^ t[32] ^ t[42], u = t[3] ^ t[13] ^ t[23] ^ t[33] ^ t[43], f = t[4] ^ t[14] ^ t[24] ^ t[34] ^ t[44], c = t[5] ^ t[15] ^ t[25] ^ t[35] ^ t[45], h = t[6] ^ t[16] ^ t[26] ^ t[36] ^ t[46], l = t[7] ^ t[17] ^ t[27] ^ t[37] ^ t[47], e = (d = t[8] ^ t[18] ^ t[28] ^ t[38] ^ t[48]) ^ (s << 1 | u >>> 31), r = (p = t[9] ^ t[19] ^ t[29] ^ t[39] ^ t[49]) ^ (u << 1 | s >>> 31), t[0] ^= e, t[1] ^= r, t[10] ^= e, t[11] ^= r, t[20] ^= e, t[21] ^= r, t[30] ^= e, t[31] ^= r, t[40] ^= e, t[41] ^= r, e = i ^ (f << 1 | c >>> 31), r = o ^ (c << 1 | f >>> 31), t[2] ^= e, t[3] ^= r, t[12] ^= e, t[13] ^= r, t[22] ^= e, t[23] ^= r, t[32] ^= e, t[33] ^= r, t[42] ^= e, t[43] ^= r, e = s ^ (h << 1 | l >>> 31), r = u ^ (l << 1 | h >>> 31), t[4] ^= e, t[5] ^= r, t[14] ^= e, t[15] ^= r, t[24] ^= e, t[25] ^= r, t[34] ^= e, t[35] ^= r, t[44] ^= e, t[45] ^= r, e = f ^ (d << 1 | p >>> 31), r = c ^ (p << 1 | d >>> 31), t[6] ^= e, t[7] ^= r, t[16] ^= e, t[17] ^= r, t[26] ^= e, t[27] ^= r, t[36] ^= e, t[37] ^= r, t[46] ^= e, t[47] ^= r, e = h ^ (i << 1 | o >>> 31), r = l ^ (o << 1 | i >>> 31), t[8] ^= e, t[9] ^= r, t[18] ^= e, t[19] ^= r, t[28] ^= e, t[29] ^= r, t[38] ^= e, t[39] ^= r, t[48] ^= e, t[49] ^= r, g = t[0], m = t[1], Z = t[11] << 4 | t[10] >>> 28, V = t[10] << 4 | t[11] >>> 28, k = t[20] << 3 | t[21] >>> 29, I = t[21] << 3 | t[20] >>> 29, at = t[31] << 9 | t[30] >>> 23, ut = t[30] << 9 | t[31] >>> 23, H = t[40] << 18 | t[41] >>> 14, Y = t[41] << 18 | t[40] >>> 14, C = t[2] << 1 | t[3] >>> 31, L = t[3] << 1 | t[2] >>> 31, b = t[13] << 12 | t[12] >>> 20, v = t[12] << 12 | t[13] >>> 20, W = t[22] << 10 | t[23] >>> 22, J = t[23] << 10 | t[22] >>> 22, B = t[33] << 13 | t[32] >>> 19, O = t[32] << 13 | t[33] >>> 19, ft = t[42] << 2 | t[43] >>> 30, ct = t[43] << 2 | t[42] >>> 30, et = t[5] << 30 | t[4] >>> 2, rt = t[4] << 30 | t[5] >>> 2, j = t[14] << 6 | t[15] >>> 26, U = t[15] << 6 | t[14] >>> 26, y = t[25] << 11 | t[24] >>> 21, _ = t[24] << 11 | t[25] >>> 21, X = t[34] << 15 | t[35] >>> 17, $ = t[35] << 15 | t[34] >>> 17, P = t[45] << 29 | t[44] >>> 3, N = t[44] << 29 | t[45] >>> 3, A = t[6] << 28 | t[7] >>> 4, x = t[7] << 28 | t[6] >>> 4, nt = t[17] << 23 | t[16] >>> 9, it = t[16] << 23 | t[17] >>> 9, D = t[26] << 25 | t[27] >>> 7, F = t[27] << 25 | t[26] >>> 7, w = t[36] << 21 | t[37] >>> 11, E = t[37] << 21 | t[36] >>> 11, Q = t[47] << 24 | t[46] >>> 8, tt = t[46] << 24 | t[47] >>> 8, G = t[8] << 27 | t[9] >>> 5, K = t[9] << 27 | t[8] >>> 5, R = t[18] << 20 | t[19] >>> 12, T = t[19] << 20 | t[18] >>> 12, ot = t[29] << 7 | t[28] >>> 25, st = t[28] << 7 | t[29] >>> 25, z = t[38] << 8 | t[39] >>> 24, q = t[39] << 8 | t[38] >>> 24, M = t[48] << 14 | t[49] >>> 18, S = t[49] << 14 | t[48] >>> 18, t[0] = g ^ ~b & y, t[1] = m ^ ~v & _, t[10] = A ^ ~R & k, t[11] = x ^ ~T & I, t[20] = C ^ ~j & D, t[21] = L ^ ~U & F, t[30] = G ^ ~Z & W, t[31] = K ^ ~V & J, t[40] = et ^ ~nt & ot, t[41] = rt ^ ~it & st, t[2] = b ^ ~y & w, t[3] = v ^ ~_ & E, t[12] = R ^ ~k & B, t[13] = T ^ ~I & O, t[22] = j ^ ~D & z, t[23] = U ^ ~F & q, t[32] = Z ^ ~W & X, t[33] = V ^ ~J & $, t[42] = nt ^ ~ot & at, t[43] = it ^ ~st & ut, t[4] = y ^ ~w & M, t[5] = _ ^ ~E & S, t[14] = k ^ ~B & P, t[15] = I ^ ~O & N, t[24] = D ^ ~z & H, t[25] = F ^ ~q & Y, t[34] = W ^ ~X & Q, t[35] = J ^ ~$ & tt, t[44] = ot ^ ~at & ft, t[45] = st ^ ~ut & ct, t[6] = w ^ ~M & g, t[7] = E ^ ~S & m, t[16] = B ^ ~P & A, t[17] = O ^ ~N & x, t[26] = z ^ ~H & C, t[27] = q ^ ~Y & L, t[36] = X ^ ~Q & G, t[37] = $ ^ ~tt & K, t[46] = at ^ ~ft & et, t[47] = ut ^ ~ct & rt, t[8] = M ^ ~g & b, t[9] = S ^ ~m & v, t[18] = P ^ ~A & R, t[19] = N ^ ~x & T, t[28] = H ^ ~C & j, t[29] = Y ^ ~L & U, t[38] = Q ^ ~G & Z, t[39] = tt ^ ~K & V, t[48] = ft ^ ~et & nt, t[49] = ct ^ ~rt & it, t[0] ^= a[n], t[1] ^= a[n + 1];
                }
              };

              if (i) t.exports = p;else for (m = 0; m < g.length; ++m) {
                n[g[m]] = p[g[m]];
              }
            }();
          }).call(this, r(15), r(4));
        }, function (t, e, r) {
          "use strict";

          (function (t) {
            Object.defineProperty(e, "__esModule", {
              value: !0
            });

            var n = r(11),
                i = n.__importDefault(r(12)),
                o = r(0),
                s = r(17),
                a = r(16);

            function u(t) {
              return a.toUtf8String(new Uint8Array(t));
            }

            function f(t, e) {
              var r = o.hexlify(new Uint8Array(t));
              return e && (r = y(r)), r;
            }

            function c(t, e) {
              var r = t.toString("hex");
              return e || (r = v(r)), r;
            }

            function h(t) {
              return a.toUtf8Bytes(t).buffer;
            }

            function l(t, e) {
              return f(h(t), e);
            }

            function d(t, e) {
              var r = new i.default(t).toString(16);
              return r = b(r), e && (r = y(r)), r;
            }

            function p(e) {
              return e = y(e), t.from(e, "hex");
            }

            function g(t) {
              return t = v(t), o.arrayify(t).buffer;
            }

            function m(t) {
              return new i.default(t).toNumber();
            }

            function b(t) {
              return (t = (t = y(t)).length % 2 != 0 ? "0" + t : t) && (t = v(t)), t;
            }

            function v(t) {
              return "0x" === t.toLowerCase().substring(0, 2) ? t : "0x" + t;
            }

            function y(t) {
              return "0x" === t.toLowerCase().substring(0, 2) ? t.substring(2) : t;
            }

            function _(t) {
              return v(t = (t = y(t)).startsWith("0") ? t.substring(1) : t);
            }

            function w(t) {
              return o.isHexString(t);
            }

            function E(t) {
              return "" === t || "string" == typeof t && "" === t.trim();
            }

            function M(t) {
              for (var e = {}, r = ("?" === t[0] ? t.substr(1) : t).split("&"), n = 0; n < r.length; n++) {
                var i = r[n].match(/\w+(?==)/i) || [],
                    o = r[n].match(/=.+/i) || [];
                i[0] && (e[decodeURIComponent(i[0])] = decodeURIComponent(o[0].substr(1)));
              }

              return e;
            }

            function S(t) {
              return !(t && t.length);
            }

            e.convertArrayBufferToBuffer = function (t) {
              return p(f(t));
            }, e.convertArrayBufferToUtf8 = u, e.convertArrayBufferToHex = f, e.convertArrayBufferToNumber = function (t) {
              return m(f(t));
            }, e.concatArrayBuffers = function () {
              for (var t = [], e = 0; e < arguments.length; e++) {
                t[e] = arguments[e];
              }

              var r = t.map(function (t) {
                return f(t, !0);
              }).join(""),
                  n = g(r);
              return n;
            }, e.convertBufferToArrayBuffer = function (t) {
              return g(c(t));
            }, e.convertBufferToUtf8 = function (t) {
              return t.toString("utf8");
            }, e.convertBufferToHex = c, e.convertBufferToNumber = function (t) {
              return m(c(t));
            }, e.concatBuffers = function () {
              for (var e = [], r = 0; r < arguments.length; r++) {
                e[r] = arguments[r];
              }

              var n = t.concat(e);
              return n;
            }, e.convertUtf8ToArrayBuffer = h, e.convertUtf8ToBuffer = function (e) {
              return t.from(e, "utf8");
            }, e.convertUtf8ToHex = l, e.convertUtf8ToNumber = function (t) {
              return new i.default(t).toNumber();
            }, e.convertNumberToBuffer = function (t) {
              return p(d(t));
            }, e.convertNumberToArrayBuffer = function (t) {
              return g(d(t));
            }, e.convertNumberToUtf8 = function (t) {
              return new i.default(t).toString();
            }, e.convertNumberToHex = d, e.convertHexToBuffer = p, e.convertHexToArrayBuffer = g, e.convertHexToUtf8 = function (t) {
              return u(g(t));
            }, e.convertHexToNumber = m, e.sanitizeHex = b, e.addHexPrefix = v, e.removeHexPrefix = y, e.removeHexLeadingZeros = _, e.isHexString = w, e.isEmptyString = E, e.payloadId = function () {
              return new Date().getTime() * Math.pow(10, 3) + Math.floor(Math.random() * Math.pow(10, 3));
            }, e.uuid = function () {
              return function (t, e) {
                for (e = t = ""; t++ < 36; e += 51 * t & 52 ? (15 ^ t ? 8 ^ Math.random() * (20 ^ t ? 16 : 4) : 4).toString(16) : "-") {
                  ;
                }

                return e;
              }();
            }, e.toChecksumAddress = function (t) {
              return s.getAddress(t);
            }, e.isValidAddress = function (t) {
              return !(!t || "0x" !== t.toLowerCase().substring(0, 2) || !/^(0x)?[0-9a-f]{40}$/i.test(t) || !/^(0x)?[0-9a-f]{40}$/.test(t) && !/^(0x)?[0-9A-F]{40}$/.test(t) && t !== e.toChecksumAddress(t));
            }, e.getMeta = function () {
              if ("undefined" == typeof window || "undefined" == typeof document || void 0 === window.location) return null;

              function t() {
                for (var t = [], e = 0; e < arguments.length; e++) {
                  t[e] = arguments[e];
                }

                for (var r = document.getElementsByTagName("meta"), n = function n(e) {
                  var n = r[e],
                      i = ["itemprop", "property", "name"].map(function (t) {
                    return n.getAttribute(t);
                  }).filter(function (e) {
                    e && t.includes(e);
                  });

                  if (i.length && i) {
                    var o = n.getAttribute("content");
                    if (o) return {
                      value: o
                    };
                  }
                }, i = 0; i < r.length; i++) {
                  var o = n(i);
                  if ("object" == typeof o) return o.value;
                }

                return "";
              }

              var e = function () {
                var e = t("name", "og:site_name", "og:title", "twitter:title");
                return e || (e = document.title), e;
              }();

              return {
                description: t("description", "og:description", "twitter:description", "keywords"),
                url: window.location.origin,
                icons: function () {
                  for (var t = document.getElementsByTagName("link"), e = [], r = 0; r < t.length; r++) {
                    var n = t[r],
                        i = n.getAttribute("rel");

                    if (i && i.toLowerCase().indexOf("icon") > -1) {
                      var o = n.getAttribute("href");
                      if (o) if (-1 === o.toLowerCase().indexOf("https:") && -1 === o.toLowerCase().indexOf("http:") && 0 !== o.indexOf("//")) {
                        var s = window.location.protocol + "//" + window.location.host;
                        if (0 === o.indexOf("/")) s += o;else {
                          var a = window.location.pathname.split("/");
                          a.pop(), s += a.join("/") + "/" + o;
                        }
                        e.push(s);
                      } else if (0 === o.indexOf("//")) {
                        var u = window.location.protocol + o;
                        e.push(u);
                      } else e.push(o);
                    }
                  }

                  return e;
                }(),
                name: e
              };
            }, e.parseQueryString = M, e.parseWalletConnectUri = function (t) {
              var e = t.indexOf(":"),
                  r = -1 !== t.indexOf("?") ? t.indexOf("?") : void 0,
                  i = t.substring(0, e),
                  o = function (t) {
                var e = t.split("@");
                return {
                  handshakeTopic: e[0],
                  version: parseInt(e[1], 10)
                };
              }(t.substring(e + 1, r)),
                  s = function (t) {
                var e = M(t);
                return {
                  key: e.key || "",
                  bridge: e.bridge || ""
                };
              }(void 0 !== r ? t.substr(r) : "");

              return n.__assign(n.__assign({
                protocol: i
              }, o), s);
            }, e.promisify = function (t, e) {
              var r = this;
              return function () {
                for (var i = [], o = 0; o < arguments.length; o++) {
                  i[o] = arguments[o];
                }

                return n.__awaiter(r, void 0, void 0, function () {
                  return n.__generator(this, function (r) {
                    return [2, new Promise(function (r, o) {
                      t.apply(e, n.__spread(i, [function (t, e) {
                        null == t && o(t), r(e);
                      }]));
                    })];
                  });
                });
              };
            }, e.isEmptyArray = S, e.parsePersonalSign = function (t) {
              return S(t) || w(t[0]) || (t[0] = l(t[0])), t;
            }, e.parseTransactionData = function (t) {
              if (void 0 === t.from || !e.isValidAddress(t.from)) throw new Error("Transaction object must include a valid 'from' value.");

              function r(t) {
                var e = t;
                return ("number" == typeof t || "string" == typeof t && !E(t)) && (w(t) ? "string" == typeof t && (e = b(t)) : e = d(t)), "string" == typeof e && (e = _(e)), e;
              }

              var n = {
                from: b(t.from),
                to: void 0 === t.to ? "" : b(t.to),
                gasPrice: void 0 === t.gasPrice ? "" : r(t.gasPrice),
                gasLimit: void 0 === t.gasLimit ? void 0 === t.gas ? "" : r(t.gas) : r(t.gasLimit),
                value: void 0 === t.value ? "" : r(t.value),
                nonce: void 0 === t.nonce ? "" : r(t.nonce),
                data: void 0 === t.data ? "" : b(t.data) || "0x"
              },
                  i = ["gasPrice", "gasLimit", "value", "nonce"];
              return Object.keys(n).forEach(function (t) {
                !n[t].trim().length && i.includes(t) && delete n[t];
              }), n;
            }, e.formatRpcError = function (t) {
              var e = t.message || "Failed or Rejected Request",
                  r = -32e3;
              if (t && !t.code) switch (e) {
                case "Parse error":
                  r = -32700;
                  break;

                case "Invalid request":
                  r = -32600;
                  break;

                case "Method not found":
                  r = -32601;
                  break;

                case "Invalid params":
                  r = -32602;
                  break;

                case "Internal error":
                  r = -32603;
                  break;

                default:
                  r = -32e3;
              }
              return {
                code: r,
                message: e
              };
            }, e.isJsonRpcSubscription = function (t) {
              return "object" == typeof t.params;
            }, e.isJsonRpcRequest = function (t) {
              return void 0 !== t.method;
            }, e.isJsonRpcResponseSuccess = function (t) {
              return void 0 !== t.result;
            }, e.isJsonRpcResponseError = function (t) {
              return void 0 !== t.error;
            }, e.isInternalEvent = function (t) {
              return void 0 !== t.event;
            }, e.isWalletConnectSession = function (t) {
              return void 0 !== t.bridge;
            }, e.isReservedEvent = function (t) {
              return ["session_request", "session_update", "exchange_key", "connect", "disconnect", "display_uri", "transport_open", "transport_close"].includes(t) || t.startsWith("wc_");
            }, e.signingMethods = ["eth_sendTransaction", "eth_signTransaction", "eth_sign", "eth_signTypedData", "eth_signTypedData_v1", "eth_signTypedData_v3", "personal_sign"], e.stateMethods = ["eth_accounts", "eth_chainId", "net_version"], e.isSilentPayload = function (t) {
              return !!t.method.startsWith("wc_") || !e.signingMethods.includes(t.method);
            };
          }).call(this, r(7).Buffer);
        }, function (t, e, r) {
          "use strict";

          (function (t) {
            /*!
             * The buffer module from node.js, for the browser.
             *
             * @author   Feross Aboukhadijeh <http://feross.org>
             * @license  MIT
             */
            var n = r(8),
                i = r(9),
                o = r(10);

            function s() {
              return u.TYPED_ARRAY_SUPPORT ? 2147483647 : 1073741823;
            }

            function a(t, e) {
              if (s() < e) throw new RangeError("Invalid typed array length");
              return u.TYPED_ARRAY_SUPPORT ? (t = new Uint8Array(e)).__proto__ = u.prototype : (null === t && (t = new u(e)), t.length = e), t;
            }

            function u(t, e, r) {
              if (!(u.TYPED_ARRAY_SUPPORT || this instanceof u)) return new u(t, e, r);

              if ("number" == typeof t) {
                if ("string" == typeof e) throw new Error("If encoding is specified then the first argument must be a string");
                return h(this, t);
              }

              return f(this, t, e, r);
            }

            function f(t, e, r, n) {
              if ("number" == typeof e) throw new TypeError('"value" argument must not be a number');
              return "undefined" != typeof ArrayBuffer && e instanceof ArrayBuffer ? function (t, e, r, n) {
                if (e.byteLength, r < 0 || e.byteLength < r) throw new RangeError("'offset' is out of bounds");
                if (e.byteLength < r + (n || 0)) throw new RangeError("'length' is out of bounds");
                return e = void 0 === r && void 0 === n ? new Uint8Array(e) : void 0 === n ? new Uint8Array(e, r) : new Uint8Array(e, r, n), u.TYPED_ARRAY_SUPPORT ? (t = e).__proto__ = u.prototype : t = l(t, e), t;
              }(t, e, r, n) : "string" == typeof e ? function (t, e, r) {
                if ("string" == typeof r && "" !== r || (r = "utf8"), !u.isEncoding(r)) throw new TypeError('"encoding" must be a valid string encoding');
                var n = 0 | p(e, r),
                    i = (t = a(t, n)).write(e, r);
                return i !== n && (t = t.slice(0, i)), t;
              }(t, e, r) : function (t, e) {
                if (u.isBuffer(e)) {
                  var r = 0 | d(e.length);
                  return 0 === (t = a(t, r)).length ? t : (e.copy(t, 0, 0, r), t);
                }

                if (e) {
                  if ("undefined" != typeof ArrayBuffer && e.buffer instanceof ArrayBuffer || "length" in e) return "number" != typeof e.length || (n = e.length) != n ? a(t, 0) : l(t, e);
                  if ("Buffer" === e.type && o(e.data)) return l(t, e.data);
                }

                var n;
                throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
              }(t, e);
            }

            function c(t) {
              if ("number" != typeof t) throw new TypeError('"size" argument must be a number');
              if (t < 0) throw new RangeError('"size" argument must not be negative');
            }

            function h(t, e) {
              if (c(e), t = a(t, e < 0 ? 0 : 0 | d(e)), !u.TYPED_ARRAY_SUPPORT) for (var r = 0; r < e; ++r) {
                t[r] = 0;
              }
              return t;
            }

            function l(t, e) {
              var r = e.length < 0 ? 0 : 0 | d(e.length);
              t = a(t, r);

              for (var n = 0; n < r; n += 1) {
                t[n] = 255 & e[n];
              }

              return t;
            }

            function d(t) {
              if (t >= s()) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + s().toString(16) + " bytes");
              return 0 | t;
            }

            function p(t, e) {
              if (u.isBuffer(t)) return t.length;
              if ("undefined" != typeof ArrayBuffer && "function" == typeof ArrayBuffer.isView && (ArrayBuffer.isView(t) || t instanceof ArrayBuffer)) return t.byteLength;
              "string" != typeof t && (t = "" + t);
              var r = t.length;
              if (0 === r) return 0;

              for (var n = !1;;) {
                switch (e) {
                  case "ascii":
                  case "latin1":
                  case "binary":
                    return r;

                  case "utf8":
                  case "utf-8":
                  case void 0:
                    return F(t).length;

                  case "ucs2":
                  case "ucs-2":
                  case "utf16le":
                  case "utf-16le":
                    return 2 * r;

                  case "hex":
                    return r >>> 1;

                  case "base64":
                    return z(t).length;

                  default:
                    if (n) return F(t).length;
                    e = ("" + e).toLowerCase(), n = !0;
                }
              }
            }

            function g(t, e, r) {
              var n = !1;
              if ((void 0 === e || e < 0) && (e = 0), e > this.length) return "";
              if ((void 0 === r || r > this.length) && (r = this.length), r <= 0) return "";
              if ((r >>>= 0) <= (e >>>= 0)) return "";

              for (t || (t = "utf8");;) {
                switch (t) {
                  case "hex":
                    return k(this, e, r);

                  case "utf8":
                  case "utf-8":
                    return x(this, e, r);

                  case "ascii":
                    return R(this, e, r);

                  case "latin1":
                  case "binary":
                    return T(this, e, r);

                  case "base64":
                    return A(this, e, r);

                  case "ucs2":
                  case "ucs-2":
                  case "utf16le":
                  case "utf-16le":
                    return I(this, e, r);

                  default:
                    if (n) throw new TypeError("Unknown encoding: " + t);
                    t = (t + "").toLowerCase(), n = !0;
                }
              }
            }

            function m(t, e, r) {
              var n = t[e];
              t[e] = t[r], t[r] = n;
            }

            function b(t, e, r, n, i) {
              if (0 === t.length) return -1;

              if ("string" == typeof r ? (n = r, r = 0) : r > 2147483647 ? r = 2147483647 : r < -2147483648 && (r = -2147483648), r = +r, isNaN(r) && (r = i ? 0 : t.length - 1), r < 0 && (r = t.length + r), r >= t.length) {
                if (i) return -1;
                r = t.length - 1;
              } else if (r < 0) {
                if (!i) return -1;
                r = 0;
              }

              if ("string" == typeof e && (e = u.from(e, n)), u.isBuffer(e)) return 0 === e.length ? -1 : v(t, e, r, n, i);
              if ("number" == typeof e) return e &= 255, u.TYPED_ARRAY_SUPPORT && "function" == typeof Uint8Array.prototype.indexOf ? i ? Uint8Array.prototype.indexOf.call(t, e, r) : Uint8Array.prototype.lastIndexOf.call(t, e, r) : v(t, [e], r, n, i);
              throw new TypeError("val must be string, number or Buffer");
            }

            function v(t, e, r, n, i) {
              var o,
                  s = 1,
                  a = t.length,
                  u = e.length;

              if (void 0 !== n && ("ucs2" === (n = String(n).toLowerCase()) || "ucs-2" === n || "utf16le" === n || "utf-16le" === n)) {
                if (t.length < 2 || e.length < 2) return -1;
                s = 2, a /= 2, u /= 2, r /= 2;
              }

              function f(t, e) {
                return 1 === s ? t[e] : t.readUInt16BE(e * s);
              }

              if (i) {
                var c = -1;

                for (o = r; o < a; o++) {
                  if (f(t, o) === f(e, -1 === c ? 0 : o - c)) {
                    if (-1 === c && (c = o), o - c + 1 === u) return c * s;
                  } else -1 !== c && (o -= o - c), c = -1;
                }
              } else for (r + u > a && (r = a - u), o = r; o >= 0; o--) {
                for (var h = !0, l = 0; l < u; l++) {
                  if (f(t, o + l) !== f(e, l)) {
                    h = !1;
                    break;
                  }
                }

                if (h) return o;
              }

              return -1;
            }

            function y(t, e, r, n) {
              r = Number(r) || 0;
              var i = t.length - r;
              n ? (n = Number(n)) > i && (n = i) : n = i;
              var o = e.length;
              if (o % 2 != 0) throw new TypeError("Invalid hex string");
              n > o / 2 && (n = o / 2);

              for (var s = 0; s < n; ++s) {
                var a = parseInt(e.substr(2 * s, 2), 16);
                if (isNaN(a)) return s;
                t[r + s] = a;
              }

              return s;
            }

            function _(t, e, r, n) {
              return q(F(e, t.length - r), t, r, n);
            }

            function w(t, e, r, n) {
              return q(function (t) {
                for (var e = [], r = 0; r < t.length; ++r) {
                  e.push(255 & t.charCodeAt(r));
                }

                return e;
              }(e), t, r, n);
            }

            function E(t, e, r, n) {
              return w(t, e, r, n);
            }

            function M(t, e, r, n) {
              return q(z(e), t, r, n);
            }

            function S(t, e, r, n) {
              return q(function (t, e) {
                for (var r, n, i, o = [], s = 0; s < t.length && !((e -= 2) < 0); ++s) {
                  n = (r = t.charCodeAt(s)) >> 8, i = r % 256, o.push(i), o.push(n);
                }

                return o;
              }(e, t.length - r), t, r, n);
            }

            function A(t, e, r) {
              return 0 === e && r === t.length ? n.fromByteArray(t) : n.fromByteArray(t.slice(e, r));
            }

            function x(t, e, r) {
              r = Math.min(t.length, r);

              for (var n = [], i = e; i < r;) {
                var o,
                    s,
                    a,
                    u,
                    f = t[i],
                    c = null,
                    h = f > 239 ? 4 : f > 223 ? 3 : f > 191 ? 2 : 1;
                if (i + h <= r) switch (h) {
                  case 1:
                    f < 128 && (c = f);
                    break;

                  case 2:
                    128 == (192 & (o = t[i + 1])) && (u = (31 & f) << 6 | 63 & o) > 127 && (c = u);
                    break;

                  case 3:
                    o = t[i + 1], s = t[i + 2], 128 == (192 & o) && 128 == (192 & s) && (u = (15 & f) << 12 | (63 & o) << 6 | 63 & s) > 2047 && (u < 55296 || u > 57343) && (c = u);
                    break;

                  case 4:
                    o = t[i + 1], s = t[i + 2], a = t[i + 3], 128 == (192 & o) && 128 == (192 & s) && 128 == (192 & a) && (u = (15 & f) << 18 | (63 & o) << 12 | (63 & s) << 6 | 63 & a) > 65535 && u < 1114112 && (c = u);
                }
                null === c ? (c = 65533, h = 1) : c > 65535 && (c -= 65536, n.push(c >>> 10 & 1023 | 55296), c = 56320 | 1023 & c), n.push(c), i += h;
              }

              return function (t) {
                var e = t.length;
                if (e <= 4096) return String.fromCharCode.apply(String, t);

                for (var r = "", n = 0; n < e;) {
                  r += String.fromCharCode.apply(String, t.slice(n, n += 4096));
                }

                return r;
              }(n);
            }

            function R(t, e, r) {
              var n = "";
              r = Math.min(t.length, r);

              for (var i = e; i < r; ++i) {
                n += String.fromCharCode(127 & t[i]);
              }

              return n;
            }

            function T(t, e, r) {
              var n = "";
              r = Math.min(t.length, r);

              for (var i = e; i < r; ++i) {
                n += String.fromCharCode(t[i]);
              }

              return n;
            }

            function k(t, e, r) {
              var n = t.length;
              (!e || e < 0) && (e = 0), (!r || r < 0 || r > n) && (r = n);

              for (var i = "", o = e; o < r; ++o) {
                i += D(t[o]);
              }

              return i;
            }

            function I(t, e, r) {
              for (var n = t.slice(e, r), i = "", o = 0; o < n.length; o += 2) {
                i += String.fromCharCode(n[o] + 256 * n[o + 1]);
              }

              return i;
            }

            function B(t, e, r) {
              if (t % 1 != 0 || t < 0) throw new RangeError("offset is not uint");
              if (t + e > r) throw new RangeError("Trying to access beyond buffer length");
            }

            function O(t, e, r, n, i, o) {
              if (!u.isBuffer(t)) throw new TypeError('"buffer" argument must be a Buffer instance');
              if (e > i || e < o) throw new RangeError('"value" argument is out of bounds');
              if (r + n > t.length) throw new RangeError("Index out of range");
            }

            function P(t, e, r, n) {
              e < 0 && (e = 65535 + e + 1);

              for (var i = 0, o = Math.min(t.length - r, 2); i < o; ++i) {
                t[r + i] = (e & 255 << 8 * (n ? i : 1 - i)) >>> 8 * (n ? i : 1 - i);
              }
            }

            function N(t, e, r, n) {
              e < 0 && (e = 4294967295 + e + 1);

              for (var i = 0, o = Math.min(t.length - r, 4); i < o; ++i) {
                t[r + i] = e >>> 8 * (n ? i : 3 - i) & 255;
              }
            }

            function C(t, e, r, n, i, o) {
              if (r + n > t.length) throw new RangeError("Index out of range");
              if (r < 0) throw new RangeError("Index out of range");
            }

            function L(t, e, r, n, o) {
              return o || C(t, 0, r, 4), i.write(t, e, r, n, 23, 4), r + 4;
            }

            function j(t, e, r, n, o) {
              return o || C(t, 0, r, 8), i.write(t, e, r, n, 52, 8), r + 8;
            }

            e.Buffer = u, e.SlowBuffer = function (t) {
              return +t != t && (t = 0), u.alloc(+t);
            }, e.INSPECT_MAX_BYTES = 50, u.TYPED_ARRAY_SUPPORT = void 0 !== t.TYPED_ARRAY_SUPPORT ? t.TYPED_ARRAY_SUPPORT : function () {
              try {
                var t = new Uint8Array(1);
                return t.__proto__ = {
                  __proto__: Uint8Array.prototype,
                  foo: function foo() {
                    return 42;
                  }
                }, 42 === t.foo() && "function" == typeof t.subarray && 0 === t.subarray(1, 1).byteLength;
              } catch (t) {
                return !1;
              }
            }(), e.kMaxLength = s(), u.poolSize = 8192, u._augment = function (t) {
              return t.__proto__ = u.prototype, t;
            }, u.from = function (t, e, r) {
              return f(null, t, e, r);
            }, u.TYPED_ARRAY_SUPPORT && (u.prototype.__proto__ = Uint8Array.prototype, u.__proto__ = Uint8Array, "undefined" != typeof Symbol && Symbol.species && u[Symbol.species] === u && Object.defineProperty(u, Symbol.species, {
              value: null,
              configurable: !0
            })), u.alloc = function (t, e, r) {
              return function (t, e, r, n) {
                return c(e), e <= 0 ? a(t, e) : void 0 !== r ? "string" == typeof n ? a(t, e).fill(r, n) : a(t, e).fill(r) : a(t, e);
              }(null, t, e, r);
            }, u.allocUnsafe = function (t) {
              return h(null, t);
            }, u.allocUnsafeSlow = function (t) {
              return h(null, t);
            }, u.isBuffer = function (t) {
              return !(null == t || !t._isBuffer);
            }, u.compare = function (t, e) {
              if (!u.isBuffer(t) || !u.isBuffer(e)) throw new TypeError("Arguments must be Buffers");
              if (t === e) return 0;

              for (var r = t.length, n = e.length, i = 0, o = Math.min(r, n); i < o; ++i) {
                if (t[i] !== e[i]) {
                  r = t[i], n = e[i];
                  break;
                }
              }

              return r < n ? -1 : n < r ? 1 : 0;
            }, u.isEncoding = function (t) {
              switch (String(t).toLowerCase()) {
                case "hex":
                case "utf8":
                case "utf-8":
                case "ascii":
                case "latin1":
                case "binary":
                case "base64":
                case "ucs2":
                case "ucs-2":
                case "utf16le":
                case "utf-16le":
                  return !0;

                default:
                  return !1;
              }
            }, u.concat = function (t, e) {
              if (!o(t)) throw new TypeError('"list" argument must be an Array of Buffers');
              if (0 === t.length) return u.alloc(0);
              var r;
              if (void 0 === e) for (e = 0, r = 0; r < t.length; ++r) {
                e += t[r].length;
              }
              var n = u.allocUnsafe(e),
                  i = 0;

              for (r = 0; r < t.length; ++r) {
                var s = t[r];
                if (!u.isBuffer(s)) throw new TypeError('"list" argument must be an Array of Buffers');
                s.copy(n, i), i += s.length;
              }

              return n;
            }, u.byteLength = p, u.prototype._isBuffer = !0, u.prototype.swap16 = function () {
              var t = this.length;
              if (t % 2 != 0) throw new RangeError("Buffer size must be a multiple of 16-bits");

              for (var e = 0; e < t; e += 2) {
                m(this, e, e + 1);
              }

              return this;
            }, u.prototype.swap32 = function () {
              var t = this.length;
              if (t % 4 != 0) throw new RangeError("Buffer size must be a multiple of 32-bits");

              for (var e = 0; e < t; e += 4) {
                m(this, e, e + 3), m(this, e + 1, e + 2);
              }

              return this;
            }, u.prototype.swap64 = function () {
              var t = this.length;
              if (t % 8 != 0) throw new RangeError("Buffer size must be a multiple of 64-bits");

              for (var e = 0; e < t; e += 8) {
                m(this, e, e + 7), m(this, e + 1, e + 6), m(this, e + 2, e + 5), m(this, e + 3, e + 4);
              }

              return this;
            }, u.prototype.toString = function () {
              var t = 0 | this.length;
              return 0 === t ? "" : 0 === arguments.length ? x(this, 0, t) : g.apply(this, arguments);
            }, u.prototype.equals = function (t) {
              if (!u.isBuffer(t)) throw new TypeError("Argument must be a Buffer");
              return this === t || 0 === u.compare(this, t);
            }, u.prototype.inspect = function () {
              var t = "",
                  r = e.INSPECT_MAX_BYTES;
              return this.length > 0 && (t = this.toString("hex", 0, r).match(/.{2}/g).join(" "), this.length > r && (t += " ... ")), "<Buffer " + t + ">";
            }, u.prototype.compare = function (t, e, r, n, i) {
              if (!u.isBuffer(t)) throw new TypeError("Argument must be a Buffer");
              if (void 0 === e && (e = 0), void 0 === r && (r = t ? t.length : 0), void 0 === n && (n = 0), void 0 === i && (i = this.length), e < 0 || r > t.length || n < 0 || i > this.length) throw new RangeError("out of range index");
              if (n >= i && e >= r) return 0;
              if (n >= i) return -1;
              if (e >= r) return 1;
              if (this === t) return 0;

              for (var o = (i >>>= 0) - (n >>>= 0), s = (r >>>= 0) - (e >>>= 0), a = Math.min(o, s), f = this.slice(n, i), c = t.slice(e, r), h = 0; h < a; ++h) {
                if (f[h] !== c[h]) {
                  o = f[h], s = c[h];
                  break;
                }
              }

              return o < s ? -1 : s < o ? 1 : 0;
            }, u.prototype.includes = function (t, e, r) {
              return -1 !== this.indexOf(t, e, r);
            }, u.prototype.indexOf = function (t, e, r) {
              return b(this, t, e, r, !0);
            }, u.prototype.lastIndexOf = function (t, e, r) {
              return b(this, t, e, r, !1);
            }, u.prototype.write = function (t, e, r, n) {
              if (void 0 === e) n = "utf8", r = this.length, e = 0;else if (void 0 === r && "string" == typeof e) n = e, r = this.length, e = 0;else {
                if (!isFinite(e)) throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
                e |= 0, isFinite(r) ? (r |= 0, void 0 === n && (n = "utf8")) : (n = r, r = void 0);
              }
              var i = this.length - e;
              if ((void 0 === r || r > i) && (r = i), t.length > 0 && (r < 0 || e < 0) || e > this.length) throw new RangeError("Attempt to write outside buffer bounds");
              n || (n = "utf8");

              for (var o = !1;;) {
                switch (n) {
                  case "hex":
                    return y(this, t, e, r);

                  case "utf8":
                  case "utf-8":
                    return _(this, t, e, r);

                  case "ascii":
                    return w(this, t, e, r);

                  case "latin1":
                  case "binary":
                    return E(this, t, e, r);

                  case "base64":
                    return M(this, t, e, r);

                  case "ucs2":
                  case "ucs-2":
                  case "utf16le":
                  case "utf-16le":
                    return S(this, t, e, r);

                  default:
                    if (o) throw new TypeError("Unknown encoding: " + n);
                    n = ("" + n).toLowerCase(), o = !0;
                }
              }
            }, u.prototype.toJSON = function () {
              return {
                type: "Buffer",
                data: Array.prototype.slice.call(this._arr || this, 0)
              };
            }, u.prototype.slice = function (t, e) {
              var r,
                  n = this.length;
              if ((t = ~~t) < 0 ? (t += n) < 0 && (t = 0) : t > n && (t = n), (e = void 0 === e ? n : ~~e) < 0 ? (e += n) < 0 && (e = 0) : e > n && (e = n), e < t && (e = t), u.TYPED_ARRAY_SUPPORT) (r = this.subarray(t, e)).__proto__ = u.prototype;else {
                var i = e - t;
                r = new u(i, void 0);

                for (var o = 0; o < i; ++o) {
                  r[o] = this[o + t];
                }
              }
              return r;
            }, u.prototype.readUIntLE = function (t, e, r) {
              t |= 0, e |= 0, r || B(t, e, this.length);

              for (var n = this[t], i = 1, o = 0; ++o < e && (i *= 256);) {
                n += this[t + o] * i;
              }

              return n;
            }, u.prototype.readUIntBE = function (t, e, r) {
              t |= 0, e |= 0, r || B(t, e, this.length);

              for (var n = this[t + --e], i = 1; e > 0 && (i *= 256);) {
                n += this[t + --e] * i;
              }

              return n;
            }, u.prototype.readUInt8 = function (t, e) {
              return e || B(t, 1, this.length), this[t];
            }, u.prototype.readUInt16LE = function (t, e) {
              return e || B(t, 2, this.length), this[t] | this[t + 1] << 8;
            }, u.prototype.readUInt16BE = function (t, e) {
              return e || B(t, 2, this.length), this[t] << 8 | this[t + 1];
            }, u.prototype.readUInt32LE = function (t, e) {
              return e || B(t, 4, this.length), (this[t] | this[t + 1] << 8 | this[t + 2] << 16) + 16777216 * this[t + 3];
            }, u.prototype.readUInt32BE = function (t, e) {
              return e || B(t, 4, this.length), 16777216 * this[t] + (this[t + 1] << 16 | this[t + 2] << 8 | this[t + 3]);
            }, u.prototype.readIntLE = function (t, e, r) {
              t |= 0, e |= 0, r || B(t, e, this.length);

              for (var n = this[t], i = 1, o = 0; ++o < e && (i *= 256);) {
                n += this[t + o] * i;
              }

              return n >= (i *= 128) && (n -= Math.pow(2, 8 * e)), n;
            }, u.prototype.readIntBE = function (t, e, r) {
              t |= 0, e |= 0, r || B(t, e, this.length);

              for (var n = e, i = 1, o = this[t + --n]; n > 0 && (i *= 256);) {
                o += this[t + --n] * i;
              }

              return o >= (i *= 128) && (o -= Math.pow(2, 8 * e)), o;
            }, u.prototype.readInt8 = function (t, e) {
              return e || B(t, 1, this.length), 128 & this[t] ? -1 * (255 - this[t] + 1) : this[t];
            }, u.prototype.readInt16LE = function (t, e) {
              e || B(t, 2, this.length);
              var r = this[t] | this[t + 1] << 8;
              return 32768 & r ? 4294901760 | r : r;
            }, u.prototype.readInt16BE = function (t, e) {
              e || B(t, 2, this.length);
              var r = this[t + 1] | this[t] << 8;
              return 32768 & r ? 4294901760 | r : r;
            }, u.prototype.readInt32LE = function (t, e) {
              return e || B(t, 4, this.length), this[t] | this[t + 1] << 8 | this[t + 2] << 16 | this[t + 3] << 24;
            }, u.prototype.readInt32BE = function (t, e) {
              return e || B(t, 4, this.length), this[t] << 24 | this[t + 1] << 16 | this[t + 2] << 8 | this[t + 3];
            }, u.prototype.readFloatLE = function (t, e) {
              return e || B(t, 4, this.length), i.read(this, t, !0, 23, 4);
            }, u.prototype.readFloatBE = function (t, e) {
              return e || B(t, 4, this.length), i.read(this, t, !1, 23, 4);
            }, u.prototype.readDoubleLE = function (t, e) {
              return e || B(t, 8, this.length), i.read(this, t, !0, 52, 8);
            }, u.prototype.readDoubleBE = function (t, e) {
              return e || B(t, 8, this.length), i.read(this, t, !1, 52, 8);
            }, u.prototype.writeUIntLE = function (t, e, r, n) {
              t = +t, e |= 0, r |= 0, n || O(this, t, e, r, Math.pow(2, 8 * r) - 1, 0);
              var i = 1,
                  o = 0;

              for (this[e] = 255 & t; ++o < r && (i *= 256);) {
                this[e + o] = t / i & 255;
              }

              return e + r;
            }, u.prototype.writeUIntBE = function (t, e, r, n) {
              t = +t, e |= 0, r |= 0, n || O(this, t, e, r, Math.pow(2, 8 * r) - 1, 0);
              var i = r - 1,
                  o = 1;

              for (this[e + i] = 255 & t; --i >= 0 && (o *= 256);) {
                this[e + i] = t / o & 255;
              }

              return e + r;
            }, u.prototype.writeUInt8 = function (t, e, r) {
              return t = +t, e |= 0, r || O(this, t, e, 1, 255, 0), u.TYPED_ARRAY_SUPPORT || (t = Math.floor(t)), this[e] = 255 & t, e + 1;
            }, u.prototype.writeUInt16LE = function (t, e, r) {
              return t = +t, e |= 0, r || O(this, t, e, 2, 65535, 0), u.TYPED_ARRAY_SUPPORT ? (this[e] = 255 & t, this[e + 1] = t >>> 8) : P(this, t, e, !0), e + 2;
            }, u.prototype.writeUInt16BE = function (t, e, r) {
              return t = +t, e |= 0, r || O(this, t, e, 2, 65535, 0), u.TYPED_ARRAY_SUPPORT ? (this[e] = t >>> 8, this[e + 1] = 255 & t) : P(this, t, e, !1), e + 2;
            }, u.prototype.writeUInt32LE = function (t, e, r) {
              return t = +t, e |= 0, r || O(this, t, e, 4, 4294967295, 0), u.TYPED_ARRAY_SUPPORT ? (this[e + 3] = t >>> 24, this[e + 2] = t >>> 16, this[e + 1] = t >>> 8, this[e] = 255 & t) : N(this, t, e, !0), e + 4;
            }, u.prototype.writeUInt32BE = function (t, e, r) {
              return t = +t, e |= 0, r || O(this, t, e, 4, 4294967295, 0), u.TYPED_ARRAY_SUPPORT ? (this[e] = t >>> 24, this[e + 1] = t >>> 16, this[e + 2] = t >>> 8, this[e + 3] = 255 & t) : N(this, t, e, !1), e + 4;
            }, u.prototype.writeIntLE = function (t, e, r, n) {
              if (t = +t, e |= 0, !n) {
                var i = Math.pow(2, 8 * r - 1);
                O(this, t, e, r, i - 1, -i);
              }

              var o = 0,
                  s = 1,
                  a = 0;

              for (this[e] = 255 & t; ++o < r && (s *= 256);) {
                t < 0 && 0 === a && 0 !== this[e + o - 1] && (a = 1), this[e + o] = (t / s >> 0) - a & 255;
              }

              return e + r;
            }, u.prototype.writeIntBE = function (t, e, r, n) {
              if (t = +t, e |= 0, !n) {
                var i = Math.pow(2, 8 * r - 1);
                O(this, t, e, r, i - 1, -i);
              }

              var o = r - 1,
                  s = 1,
                  a = 0;

              for (this[e + o] = 255 & t; --o >= 0 && (s *= 256);) {
                t < 0 && 0 === a && 0 !== this[e + o + 1] && (a = 1), this[e + o] = (t / s >> 0) - a & 255;
              }

              return e + r;
            }, u.prototype.writeInt8 = function (t, e, r) {
              return t = +t, e |= 0, r || O(this, t, e, 1, 127, -128), u.TYPED_ARRAY_SUPPORT || (t = Math.floor(t)), t < 0 && (t = 255 + t + 1), this[e] = 255 & t, e + 1;
            }, u.prototype.writeInt16LE = function (t, e, r) {
              return t = +t, e |= 0, r || O(this, t, e, 2, 32767, -32768), u.TYPED_ARRAY_SUPPORT ? (this[e] = 255 & t, this[e + 1] = t >>> 8) : P(this, t, e, !0), e + 2;
            }, u.prototype.writeInt16BE = function (t, e, r) {
              return t = +t, e |= 0, r || O(this, t, e, 2, 32767, -32768), u.TYPED_ARRAY_SUPPORT ? (this[e] = t >>> 8, this[e + 1] = 255 & t) : P(this, t, e, !1), e + 2;
            }, u.prototype.writeInt32LE = function (t, e, r) {
              return t = +t, e |= 0, r || O(this, t, e, 4, 2147483647, -2147483648), u.TYPED_ARRAY_SUPPORT ? (this[e] = 255 & t, this[e + 1] = t >>> 8, this[e + 2] = t >>> 16, this[e + 3] = t >>> 24) : N(this, t, e, !0), e + 4;
            }, u.prototype.writeInt32BE = function (t, e, r) {
              return t = +t, e |= 0, r || O(this, t, e, 4, 2147483647, -2147483648), t < 0 && (t = 4294967295 + t + 1), u.TYPED_ARRAY_SUPPORT ? (this[e] = t >>> 24, this[e + 1] = t >>> 16, this[e + 2] = t >>> 8, this[e + 3] = 255 & t) : N(this, t, e, !1), e + 4;
            }, u.prototype.writeFloatLE = function (t, e, r) {
              return L(this, t, e, !0, r);
            }, u.prototype.writeFloatBE = function (t, e, r) {
              return L(this, t, e, !1, r);
            }, u.prototype.writeDoubleLE = function (t, e, r) {
              return j(this, t, e, !0, r);
            }, u.prototype.writeDoubleBE = function (t, e, r) {
              return j(this, t, e, !1, r);
            }, u.prototype.copy = function (t, e, r, n) {
              if (r || (r = 0), n || 0 === n || (n = this.length), e >= t.length && (e = t.length), e || (e = 0), n > 0 && n < r && (n = r), n === r) return 0;
              if (0 === t.length || 0 === this.length) return 0;
              if (e < 0) throw new RangeError("targetStart out of bounds");
              if (r < 0 || r >= this.length) throw new RangeError("sourceStart out of bounds");
              if (n < 0) throw new RangeError("sourceEnd out of bounds");
              n > this.length && (n = this.length), t.length - e < n - r && (n = t.length - e + r);
              var i,
                  o = n - r;
              if (this === t && r < e && e < n) for (i = o - 1; i >= 0; --i) {
                t[i + e] = this[i + r];
              } else if (o < 1e3 || !u.TYPED_ARRAY_SUPPORT) for (i = 0; i < o; ++i) {
                t[i + e] = this[i + r];
              } else Uint8Array.prototype.set.call(t, this.subarray(r, r + o), e);
              return o;
            }, u.prototype.fill = function (t, e, r, n) {
              if ("string" == typeof t) {
                if ("string" == typeof e ? (n = e, e = 0, r = this.length) : "string" == typeof r && (n = r, r = this.length), 1 === t.length) {
                  var i = t.charCodeAt(0);
                  i < 256 && (t = i);
                }

                if (void 0 !== n && "string" != typeof n) throw new TypeError("encoding must be a string");
                if ("string" == typeof n && !u.isEncoding(n)) throw new TypeError("Unknown encoding: " + n);
              } else "number" == typeof t && (t &= 255);

              if (e < 0 || this.length < e || this.length < r) throw new RangeError("Out of range index");
              if (r <= e) return this;
              var o;
              if (e >>>= 0, r = void 0 === r ? this.length : r >>> 0, t || (t = 0), "number" == typeof t) for (o = e; o < r; ++o) {
                this[o] = t;
              } else {
                var s = u.isBuffer(t) ? t : F(new u(t, n).toString()),
                    a = s.length;

                for (o = 0; o < r - e; ++o) {
                  this[o + e] = s[o % a];
                }
              }
              return this;
            };
            var U = /[^+\/0-9A-Za-z-_]/g;

            function D(t) {
              return t < 16 ? "0" + t.toString(16) : t.toString(16);
            }

            function F(t, e) {
              var r;
              e = e || 1 / 0;

              for (var n = t.length, i = null, o = [], s = 0; s < n; ++s) {
                if ((r = t.charCodeAt(s)) > 55295 && r < 57344) {
                  if (!i) {
                    if (r > 56319) {
                      (e -= 3) > -1 && o.push(239, 191, 189);
                      continue;
                    }

                    if (s + 1 === n) {
                      (e -= 3) > -1 && o.push(239, 191, 189);
                      continue;
                    }

                    i = r;
                    continue;
                  }

                  if (r < 56320) {
                    (e -= 3) > -1 && o.push(239, 191, 189), i = r;
                    continue;
                  }

                  r = 65536 + (i - 55296 << 10 | r - 56320);
                } else i && (e -= 3) > -1 && o.push(239, 191, 189);

                if (i = null, r < 128) {
                  if ((e -= 1) < 0) break;
                  o.push(r);
                } else if (r < 2048) {
                  if ((e -= 2) < 0) break;
                  o.push(r >> 6 | 192, 63 & r | 128);
                } else if (r < 65536) {
                  if ((e -= 3) < 0) break;
                  o.push(r >> 12 | 224, r >> 6 & 63 | 128, 63 & r | 128);
                } else {
                  if (!(r < 1114112)) throw new Error("Invalid code point");
                  if ((e -= 4) < 0) break;
                  o.push(r >> 18 | 240, r >> 12 & 63 | 128, r >> 6 & 63 | 128, 63 & r | 128);
                }
              }

              return o;
            }

            function z(t) {
              return n.toByteArray(function (t) {
                if ((t = function (t) {
                  return t.trim ? t.trim() : t.replace(/^\s+|\s+$/g, "");
                }(t).replace(U, "")).length < 2) return "";

                for (; t.length % 4 != 0;) {
                  t += "=";
                }

                return t;
              }(t));
            }

            function q(t, e, r, n) {
              for (var i = 0; i < n && !(i + r >= e.length || i >= t.length); ++i) {
                e[i + r] = t[i];
              }

              return i;
            }
          }).call(this, r(4));
        }, function (t, e, r) {
          "use strict";

          e.byteLength = function (t) {
            var e = f(t),
                r = e[0],
                n = e[1];
            return 3 * (r + n) / 4 - n;
          }, e.toByteArray = function (t) {
            var e,
                r,
                n = f(t),
                s = n[0],
                a = n[1],
                u = new o(function (t, e, r) {
              return 3 * (e + r) / 4 - r;
            }(0, s, a)),
                c = 0,
                h = a > 0 ? s - 4 : s;

            for (r = 0; r < h; r += 4) {
              e = i[t.charCodeAt(r)] << 18 | i[t.charCodeAt(r + 1)] << 12 | i[t.charCodeAt(r + 2)] << 6 | i[t.charCodeAt(r + 3)], u[c++] = e >> 16 & 255, u[c++] = e >> 8 & 255, u[c++] = 255 & e;
            }

            return 2 === a && (e = i[t.charCodeAt(r)] << 2 | i[t.charCodeAt(r + 1)] >> 4, u[c++] = 255 & e), 1 === a && (e = i[t.charCodeAt(r)] << 10 | i[t.charCodeAt(r + 1)] << 4 | i[t.charCodeAt(r + 2)] >> 2, u[c++] = e >> 8 & 255, u[c++] = 255 & e), u;
          }, e.fromByteArray = function (t) {
            for (var e, r = t.length, i = r % 3, o = [], s = 0, a = r - i; s < a; s += 16383) {
              o.push(c(t, s, s + 16383 > a ? a : s + 16383));
            }

            return 1 === i ? (e = t[r - 1], o.push(n[e >> 2] + n[e << 4 & 63] + "==")) : 2 === i && (e = (t[r - 2] << 8) + t[r - 1], o.push(n[e >> 10] + n[e >> 4 & 63] + n[e << 2 & 63] + "=")), o.join("");
          };

          for (var n = [], i = [], o = "undefined" != typeof Uint8Array ? Uint8Array : Array, s = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", a = 0, u = s.length; a < u; ++a) {
            n[a] = s[a], i[s.charCodeAt(a)] = a;
          }

          function f(t) {
            var e = t.length;
            if (e % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
            var r = t.indexOf("=");
            return -1 === r && (r = e), [r, r === e ? 0 : 4 - r % 4];
          }

          function c(t, e, r) {
            for (var i, o, s = [], a = e; a < r; a += 3) {
              i = (t[a] << 16 & 16711680) + (t[a + 1] << 8 & 65280) + (255 & t[a + 2]), s.push(n[(o = i) >> 18 & 63] + n[o >> 12 & 63] + n[o >> 6 & 63] + n[63 & o]);
            }

            return s.join("");
          }

          i["-".charCodeAt(0)] = 62, i["_".charCodeAt(0)] = 63;
        }, function (t, e) {
          e.read = function (t, e, r, n, i) {
            var o,
                s,
                a = 8 * i - n - 1,
                u = (1 << a) - 1,
                f = u >> 1,
                c = -7,
                h = r ? i - 1 : 0,
                l = r ? -1 : 1,
                d = t[e + h];

            for (h += l, o = d & (1 << -c) - 1, d >>= -c, c += a; c > 0; o = 256 * o + t[e + h], h += l, c -= 8) {
              ;
            }

            for (s = o & (1 << -c) - 1, o >>= -c, c += n; c > 0; s = 256 * s + t[e + h], h += l, c -= 8) {
              ;
            }

            if (0 === o) o = 1 - f;else {
              if (o === u) return s ? NaN : 1 / 0 * (d ? -1 : 1);
              s += Math.pow(2, n), o -= f;
            }
            return (d ? -1 : 1) * s * Math.pow(2, o - n);
          }, e.write = function (t, e, r, n, i, o) {
            var s,
                a,
                u,
                f = 8 * o - i - 1,
                c = (1 << f) - 1,
                h = c >> 1,
                l = 23 === i ? Math.pow(2, -24) - Math.pow(2, -77) : 0,
                d = n ? 0 : o - 1,
                p = n ? 1 : -1,
                g = e < 0 || 0 === e && 1 / e < 0 ? 1 : 0;

            for (e = Math.abs(e), isNaN(e) || e === 1 / 0 ? (a = isNaN(e) ? 1 : 0, s = c) : (s = Math.floor(Math.log(e) / Math.LN2), e * (u = Math.pow(2, -s)) < 1 && (s--, u *= 2), (e += s + h >= 1 ? l / u : l * Math.pow(2, 1 - h)) * u >= 2 && (s++, u /= 2), s + h >= c ? (a = 0, s = c) : s + h >= 1 ? (a = (e * u - 1) * Math.pow(2, i), s += h) : (a = e * Math.pow(2, h - 1) * Math.pow(2, i), s = 0)); i >= 8; t[r + d] = 255 & a, d += p, a /= 256, i -= 8) {
              ;
            }

            for (s = s << i | a, f += i; f > 0; t[r + d] = 255 & s, d += p, s /= 256, f -= 8) {
              ;
            }

            t[r + d - p] |= 128 * g;
          };
        }, function (t, e) {
          var r = {}.toString;

          t.exports = Array.isArray || function (t) {
            return "[object Array]" == r.call(t);
          };
        }, function (t, e, r) {
          "use strict";

          r.r(e), r.d(e, "__extends", function () {
            return i;
          }), r.d(e, "__assign", function () {
            return _o9;
          }), r.d(e, "__rest", function () {
            return s;
          }), r.d(e, "__decorate", function () {
            return a;
          }), r.d(e, "__param", function () {
            return u;
          }), r.d(e, "__metadata", function () {
            return f;
          }), r.d(e, "__awaiter", function () {
            return c;
          }), r.d(e, "__generator", function () {
            return h;
          }), r.d(e, "__exportStar", function () {
            return l;
          }), r.d(e, "__values", function () {
            return d;
          }), r.d(e, "__read", function () {
            return p;
          }), r.d(e, "__spread", function () {
            return g;
          }), r.d(e, "__await", function () {
            return m;
          }), r.d(e, "__asyncGenerator", function () {
            return b;
          }), r.d(e, "__asyncDelegator", function () {
            return v;
          }), r.d(e, "__asyncValues", function () {
            return y;
          }), r.d(e, "__makeTemplateObject", function () {
            return _;
          }), r.d(e, "__importStar", function () {
            return w;
          }), r.d(e, "__importDefault", function () {
            return E;
          });
          /*! *****************************************************************************
          Copyright (c) Microsoft Corporation. All rights reserved.
          Licensed under the Apache License, Version 2.0 (the "License"); you may not use
          this file except in compliance with the License. You may obtain a copy of the
          License at http://www.apache.org/licenses/LICENSE-2.0
          
          THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
          KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
          WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
          MERCHANTABLITY OR NON-INFRINGEMENT.
          
          See the Apache Version 2.0 License for specific language governing permissions
          and limitations under the License.
          ***************************************************************************** */

          var _n19 = function n(t, e) {
            return (_n19 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) {
                e.hasOwnProperty(r) && (t[r] = e[r]);
              }
            })(t, e);
          };

          function i(t, e) {
            function r() {
              this.constructor = t;
            }

            _n19(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }

          var _o9 = function o() {
            return (_o9 = Object.assign || function (t) {
              for (var e, r = 1, n = arguments.length; r < n; r++) {
                for (var i in e = arguments[r]) {
                  Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
                }
              }

              return t;
            }).apply(this, arguments);
          };

          function s(t, e) {
            var r = {};

            for (var n in t) {
              Object.prototype.hasOwnProperty.call(t, n) && e.indexOf(n) < 0 && (r[n] = t[n]);
            }

            if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
              var i = 0;

              for (n = Object.getOwnPropertySymbols(t); i < n.length; i++) {
                e.indexOf(n[i]) < 0 && (r[n[i]] = t[n[i]]);
              }
            }

            return r;
          }

          function a(t, e, r, n) {
            var i,
                o = arguments.length,
                s = o < 3 ? e : null === n ? n = Object.getOwnPropertyDescriptor(e, r) : n;
            if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) s = Reflect.decorate(t, e, r, n);else for (var a = t.length - 1; a >= 0; a--) {
              (i = t[a]) && (s = (o < 3 ? i(s) : o > 3 ? i(e, r, s) : i(e, r)) || s);
            }
            return o > 3 && s && Object.defineProperty(e, r, s), s;
          }

          function u(t, e) {
            return function (r, n) {
              e(r, n, t);
            };
          }

          function f(t, e) {
            if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(t, e);
          }

          function c(t, e, r, n) {
            return new (r || (r = Promise))(function (i, o) {
              function s(t) {
                try {
                  u(n.next(t));
                } catch (t) {
                  o(t);
                }
              }

              function a(t) {
                try {
                  u(n.throw(t));
                } catch (t) {
                  o(t);
                }
              }

              function u(t) {
                t.done ? i(t.value) : new r(function (e) {
                  e(t.value);
                }).then(s, a);
              }

              u((n = n.apply(t, e || [])).next());
            });
          }

          function h(t, e) {
            var r,
                n,
                i,
                o,
                s = {
              label: 0,
              sent: function sent() {
                if (1 & i[0]) throw i[1];
                return i[1];
              },
              trys: [],
              ops: []
            };
            return o = {
              next: a(0),
              throw: a(1),
              return: a(2)
            }, "function" == typeof Symbol && (o[Symbol.iterator] = function () {
              return this;
            }), o;

            function a(o) {
              return function (a) {
                return function (o) {
                  if (r) throw new TypeError("Generator is already executing.");

                  for (; s;) {
                    try {
                      if (r = 1, n && (i = 2 & o[0] ? n.return : o[0] ? n.throw || ((i = n.return) && i.call(n), 0) : n.next) && !(i = i.call(n, o[1])).done) return i;

                      switch (n = 0, i && (o = [2 & o[0], i.value]), o[0]) {
                        case 0:
                        case 1:
                          i = o;
                          break;

                        case 4:
                          return s.label++, {
                            value: o[1],
                            done: !1
                          };

                        case 5:
                          s.label++, n = o[1], o = [0];
                          continue;

                        case 7:
                          o = s.ops.pop(), s.trys.pop();
                          continue;

                        default:
                          if (!(i = (i = s.trys).length > 0 && i[i.length - 1]) && (6 === o[0] || 2 === o[0])) {
                            s = 0;
                            continue;
                          }

                          if (3 === o[0] && (!i || o[1] > i[0] && o[1] < i[3])) {
                            s.label = o[1];
                            break;
                          }

                          if (6 === o[0] && s.label < i[1]) {
                            s.label = i[1], i = o;
                            break;
                          }

                          if (i && s.label < i[2]) {
                            s.label = i[2], s.ops.push(o);
                            break;
                          }

                          i[2] && s.ops.pop(), s.trys.pop();
                          continue;
                      }

                      o = e.call(t, s);
                    } catch (t) {
                      o = [6, t], n = 0;
                    } finally {
                      r = i = 0;
                    }
                  }

                  if (5 & o[0]) throw o[1];
                  return {
                    value: o[0] ? o[1] : void 0,
                    done: !0
                  };
                }([o, a]);
              };
            }
          }

          function l(t, e) {
            for (var r in t) {
              e.hasOwnProperty(r) || (e[r] = t[r]);
            }
          }

          function d(t) {
            var e = "function" == typeof Symbol && t[Symbol.iterator],
                r = 0;
            return e ? e.call(t) : {
              next: function next() {
                return t && r >= t.length && (t = void 0), {
                  value: t && t[r++],
                  done: !t
                };
              }
            };
          }

          function p(t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
                i,
                o = r.call(t),
                s = [];

            try {
              for (; (void 0 === e || e-- > 0) && !(n = o.next()).done;) {
                s.push(n.value);
              }
            } catch (t) {
              i = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = o.return) && r.call(o);
              } finally {
                if (i) throw i.error;
              }
            }

            return s;
          }

          function g() {
            for (var t = [], e = 0; e < arguments.length; e++) {
              t = t.concat(p(arguments[e]));
            }

            return t;
          }

          function m(t) {
            return this instanceof m ? (this.v = t, this) : new m(t);
          }

          function b(t, e, r) {
            if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
            var n,
                i = r.apply(t, e || []),
                o = [];
            return n = {}, s("next"), s("throw"), s("return"), n[Symbol.asyncIterator] = function () {
              return this;
            }, n;

            function s(t) {
              i[t] && (n[t] = function (e) {
                return new Promise(function (r, n) {
                  o.push([t, e, r, n]) > 1 || a(t, e);
                });
              });
            }

            function a(t, e) {
              try {
                (r = i[t](e)).value instanceof m ? Promise.resolve(r.value.v).then(u, f) : c(o[0][2], r);
              } catch (t) {
                c(o[0][3], t);
              }

              var r;
            }

            function u(t) {
              a("next", t);
            }

            function f(t) {
              a("throw", t);
            }

            function c(t, e) {
              t(e), o.shift(), o.length && a(o[0][0], o[0][1]);
            }
          }

          function v(t) {
            var e, r;
            return e = {}, n("next"), n("throw", function (t) {
              throw t;
            }), n("return"), e[Symbol.iterator] = function () {
              return this;
            }, e;

            function n(n, i) {
              e[n] = t[n] ? function (e) {
                return (r = !r) ? {
                  value: m(t[n](e)),
                  done: "return" === n
                } : i ? i(e) : e;
              } : i;
            }
          }

          function y(t) {
            if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
            var e,
                r = t[Symbol.asyncIterator];
            return r ? r.call(t) : (t = d(t), e = {}, n("next"), n("throw"), n("return"), e[Symbol.asyncIterator] = function () {
              return this;
            }, e);

            function n(r) {
              e[r] = t[r] && function (e) {
                return new Promise(function (n, i) {
                  !function (t, e, r, n) {
                    Promise.resolve(n).then(function (e) {
                      t({
                        value: e,
                        done: r
                      });
                    }, e);
                  }(n, i, (e = t[r](e)).done, e.value);
                });
              };
            }
          }

          function _(t, e) {
            return Object.defineProperty ? Object.defineProperty(t, "raw", {
              value: e
            }) : t.raw = e, t;
          }

          function w(t) {
            if (t && t.__esModule) return t;
            var e = {};
            if (null != t) for (var r in t) {
              Object.hasOwnProperty.call(t, r) && (e[r] = t[r]);
            }
            return e.default = t, e;
          }

          function E(t) {
            return t && t.__esModule ? t : {
              default: t
            };
          }
        }, function (t, e, r) {
          var n;
          !function (i) {
            "use strict";

            var o,
                s = /^-?(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?$/i,
                a = Math.ceil,
                u = Math.floor,
                f = "[BigNumber Error] ",
                c = f + "Number primitive has more than 15 significant digits: ",
                h = [1, 10, 100, 1e3, 1e4, 1e5, 1e6, 1e7, 1e8, 1e9, 1e10, 1e11, 1e12, 1e13];

            function l(t) {
              var e = 0 | t;
              return t > 0 || t === e ? e : e - 1;
            }

            function d(t) {
              for (var e, r, n = 1, i = t.length, o = t[0] + ""; n < i;) {
                for (r = 14 - (e = t[n++] + "").length; r--; e = "0" + e) {
                  ;
                }

                o += e;
              }

              for (i = o.length; 48 === o.charCodeAt(--i);) {
                ;
              }

              return o.slice(0, i + 1 || 1);
            }

            function p(t, e) {
              var r,
                  n,
                  i = t.c,
                  o = e.c,
                  s = t.s,
                  a = e.s,
                  u = t.e,
                  f = e.e;
              if (!s || !a) return null;
              if (r = i && !i[0], n = o && !o[0], r || n) return r ? n ? 0 : -a : s;
              if (s != a) return s;
              if (r = s < 0, n = u == f, !i || !o) return n ? 0 : !i ^ r ? 1 : -1;
              if (!n) return u > f ^ r ? 1 : -1;

              for (a = (u = i.length) < (f = o.length) ? u : f, s = 0; s < a; s++) {
                if (i[s] != o[s]) return i[s] > o[s] ^ r ? 1 : -1;
              }

              return u == f ? 0 : u > f ^ r ? 1 : -1;
            }

            function g(t, e, r, n) {
              if (t < e || t > r || t !== u(t)) throw Error(f + (n || "Argument") + ("number" == typeof t ? t < e || t > r ? " out of range: " : " not an integer: " : " not a primitive number: ") + String(t));
            }

            function m(t) {
              var e = t.c.length - 1;
              return l(t.e / 14) == e && t.c[e] % 2 != 0;
            }

            function b(t, e) {
              return (t.length > 1 ? t.charAt(0) + "." + t.slice(1) : t) + (e < 0 ? "e" : "e+") + e;
            }

            function v(t, e, r) {
              var n, i;

              if (e < 0) {
                for (i = r + "."; ++e; i += r) {
                  ;
                }

                t = i + t;
              } else if (++e > (n = t.length)) {
                for (i = r, e -= n; --e; i += r) {
                  ;
                }

                t += i;
              } else e < n && (t = t.slice(0, e) + "." + t.slice(e));

              return t;
            }

            (o = function t(e) {
              var r,
                  n,
                  i,
                  o,
                  y,
                  _,
                  w,
                  E,
                  M,
                  S = j.prototype = {
                constructor: j,
                toString: null,
                valueOf: null
              },
                  A = new j(1),
                  x = 20,
                  R = 4,
                  T = -7,
                  k = 21,
                  I = -1e7,
                  B = 1e7,
                  O = !1,
                  P = 1,
                  N = 0,
                  C = {
                prefix: "",
                groupSize: 3,
                secondaryGroupSize: 0,
                groupSeparator: ",",
                decimalSeparator: ".",
                fractionGroupSize: 0,
                fractionGroupSeparator: " ",
                suffix: ""
              },
                  L = "0123456789abcdefghijklmnopqrstuvwxyz";

              function j(t, e) {
                var r,
                    o,
                    a,
                    f,
                    h,
                    l,
                    d,
                    p,
                    m = this;
                if (!(m instanceof j)) return new j(t, e);

                if (null == e) {
                  if (t && !0 === t._isBigNumber) return m.s = t.s, void (!t.c || t.e > B ? m.c = m.e = null : t.e < I ? m.c = [m.e = 0] : (m.e = t.e, m.c = t.c.slice()));

                  if ((l = "number" == typeof t) && 0 * t == 0) {
                    if (m.s = 1 / t < 0 ? (t = -t, -1) : 1, t === ~~t) {
                      for (f = 0, h = t; h >= 10; h /= 10, f++) {
                        ;
                      }

                      return void (f > B ? m.c = m.e = null : (m.e = f, m.c = [t]));
                    }

                    p = String(t);
                  } else {
                    if (!s.test(p = String(t))) return i(m, p, l);
                    m.s = 45 == p.charCodeAt(0) ? (p = p.slice(1), -1) : 1;
                  }

                  (f = p.indexOf(".")) > -1 && (p = p.replace(".", "")), (h = p.search(/e/i)) > 0 ? (f < 0 && (f = h), f += +p.slice(h + 1), p = p.substring(0, h)) : f < 0 && (f = p.length);
                } else {
                  if (g(e, 2, L.length, "Base"), 10 == e) return z(m = new j(t), x + m.e + 1, R);

                  if (p = String(t), l = "number" == typeof t) {
                    if (0 * t != 0) return i(m, p, l, e);
                    if (m.s = 1 / t < 0 ? (p = p.slice(1), -1) : 1, j.DEBUG && p.replace(/^0\.0*|\./, "").length > 15) throw Error(c + t);
                  } else m.s = 45 === p.charCodeAt(0) ? (p = p.slice(1), -1) : 1;

                  for (r = L.slice(0, e), f = h = 0, d = p.length; h < d; h++) {
                    if (r.indexOf(o = p.charAt(h)) < 0) {
                      if ("." == o) {
                        if (h > f) {
                          f = d;
                          continue;
                        }
                      } else if (!a && (p == p.toUpperCase() && (p = p.toLowerCase()) || p == p.toLowerCase() && (p = p.toUpperCase()))) {
                        a = !0, h = -1, f = 0;
                        continue;
                      }

                      return i(m, String(t), l, e);
                    }
                  }

                  l = !1, (f = (p = n(p, e, 10, m.s)).indexOf(".")) > -1 ? p = p.replace(".", "") : f = p.length;
                }

                for (h = 0; 48 === p.charCodeAt(h); h++) {
                  ;
                }

                for (d = p.length; 48 === p.charCodeAt(--d);) {
                  ;
                }

                if (p = p.slice(h, ++d)) {
                  if (d -= h, l && j.DEBUG && d > 15 && (t > 9007199254740991 || t !== u(t))) throw Error(c + m.s * t);
                  if ((f = f - h - 1) > B) m.c = m.e = null;else if (f < I) m.c = [m.e = 0];else {
                    if (m.e = f, m.c = [], h = (f + 1) % 14, f < 0 && (h += 14), h < d) {
                      for (h && m.c.push(+p.slice(0, h)), d -= 14; h < d;) {
                        m.c.push(+p.slice(h, h += 14));
                      }

                      h = 14 - (p = p.slice(h)).length;
                    } else h -= d;

                    for (; h--; p += "0") {
                      ;
                    }

                    m.c.push(+p);
                  }
                } else m.c = [m.e = 0];
              }

              function U(t, e, r, n) {
                var i, o, s, a, u;
                if (null == r ? r = R : g(r, 0, 8), !t.c) return t.toString();
                if (i = t.c[0], s = t.e, null == e) u = d(t.c), u = 1 == n || 2 == n && (s <= T || s >= k) ? b(u, s) : v(u, s, "0");else if (o = (t = z(new j(t), e, r)).e, a = (u = d(t.c)).length, 1 == n || 2 == n && (e <= o || o <= T)) {
                  for (; a < e; u += "0", a++) {
                    ;
                  }

                  u = b(u, o);
                } else if (e -= s, u = v(u, o, "0"), o + 1 > a) {
                  if (--e > 0) for (u += "."; e--; u += "0") {
                    ;
                  }
                } else if ((e += o - a) > 0) for (o + 1 == a && (u += "."); e--; u += "0") {
                  ;
                }
                return t.s < 0 && i ? "-" + u : u;
              }

              function D(t, e) {
                for (var r, n = 1, i = new j(t[0]); n < t.length; n++) {
                  if (!(r = new j(t[n])).s) {
                    i = r;
                    break;
                  }

                  e.call(i, r) && (i = r);
                }

                return i;
              }

              function F(t, e, r) {
                for (var n = 1, i = e.length; !e[--i]; e.pop()) {
                  ;
                }

                for (i = e[0]; i >= 10; i /= 10, n++) {
                  ;
                }

                return (r = n + 14 * r - 1) > B ? t.c = t.e = null : r < I ? t.c = [t.e = 0] : (t.e = r, t.c = e), t;
              }

              function z(t, e, r, n) {
                var i,
                    o,
                    s,
                    f,
                    c,
                    l,
                    d,
                    p = t.c,
                    g = h;

                if (p) {
                  t: {
                    for (i = 1, f = p[0]; f >= 10; f /= 10, i++) {
                      ;
                    }

                    if ((o = e - i) < 0) o += 14, s = e, d = (c = p[l = 0]) / g[i - s - 1] % 10 | 0;else if ((l = a((o + 1) / 14)) >= p.length) {
                      if (!n) break t;

                      for (; p.length <= l; p.push(0)) {
                        ;
                      }

                      c = d = 0, i = 1, s = (o %= 14) - 14 + 1;
                    } else {
                      for (c = f = p[l], i = 1; f >= 10; f /= 10, i++) {
                        ;
                      }

                      d = (s = (o %= 14) - 14 + i) < 0 ? 0 : c / g[i - s - 1] % 10 | 0;
                    }
                    if (n = n || e < 0 || null != p[l + 1] || (s < 0 ? c : c % g[i - s - 1]), n = r < 4 ? (d || n) && (0 == r || r == (t.s < 0 ? 3 : 2)) : d > 5 || 5 == d && (4 == r || n || 6 == r && (o > 0 ? s > 0 ? c / g[i - s] : 0 : p[l - 1]) % 10 & 1 || r == (t.s < 0 ? 8 : 7)), e < 1 || !p[0]) return p.length = 0, n ? (e -= t.e + 1, p[0] = g[(14 - e % 14) % 14], t.e = -e || 0) : p[0] = t.e = 0, t;
                    if (0 == o ? (p.length = l, f = 1, l--) : (p.length = l + 1, f = g[14 - o], p[l] = s > 0 ? u(c / g[i - s] % g[s]) * f : 0), n) for (;;) {
                      if (0 == l) {
                        for (o = 1, s = p[0]; s >= 10; s /= 10, o++) {
                          ;
                        }

                        for (s = p[0] += f, f = 1; s >= 10; s /= 10, f++) {
                          ;
                        }

                        o != f && (t.e++, 1e14 == p[0] && (p[0] = 1));
                        break;
                      }

                      if (p[l] += f, 1e14 != p[l]) break;
                      p[l--] = 0, f = 1;
                    }

                    for (o = p.length; 0 === p[--o]; p.pop()) {
                      ;
                    }
                  }

                  t.e > B ? t.c = t.e = null : t.e < I && (t.c = [t.e = 0]);
                }

                return t;
              }

              function q(t) {
                var e,
                    r = t.e;
                return null === r ? t.toString() : (e = d(t.c), e = r <= T || r >= k ? b(e, r) : v(e, r, "0"), t.s < 0 ? "-" + e : e);
              }

              return j.clone = t, j.ROUND_UP = 0, j.ROUND_DOWN = 1, j.ROUND_CEIL = 2, j.ROUND_FLOOR = 3, j.ROUND_HALF_UP = 4, j.ROUND_HALF_DOWN = 5, j.ROUND_HALF_EVEN = 6, j.ROUND_HALF_CEIL = 7, j.ROUND_HALF_FLOOR = 8, j.EUCLID = 9, j.config = j.set = function (t) {
                var e, r;

                if (null != t) {
                  if ("object" != typeof t) throw Error(f + "Object expected: " + t);
                  if (t.hasOwnProperty(e = "DECIMAL_PLACES") && (g(r = t[e], 0, 1e9, e), x = r), t.hasOwnProperty(e = "ROUNDING_MODE") && (g(r = t[e], 0, 8, e), R = r), t.hasOwnProperty(e = "EXPONENTIAL_AT") && ((r = t[e]) && r.pop ? (g(r[0], -1e9, 0, e), g(r[1], 0, 1e9, e), T = r[0], k = r[1]) : (g(r, -1e9, 1e9, e), T = -(k = r < 0 ? -r : r))), t.hasOwnProperty(e = "RANGE")) if ((r = t[e]) && r.pop) g(r[0], -1e9, -1, e), g(r[1], 1, 1e9, e), I = r[0], B = r[1];else {
                    if (g(r, -1e9, 1e9, e), !r) throw Error(f + e + " cannot be zero: " + r);
                    I = -(B = r < 0 ? -r : r);
                  }

                  if (t.hasOwnProperty(e = "CRYPTO")) {
                    if ((r = t[e]) !== !!r) throw Error(f + e + " not true or false: " + r);

                    if (r) {
                      if ("undefined" == typeof crypto || !crypto || !crypto.getRandomValues && !crypto.randomBytes) throw O = !r, Error(f + "crypto unavailable");
                      O = r;
                    } else O = r;
                  }

                  if (t.hasOwnProperty(e = "MODULO_MODE") && (g(r = t[e], 0, 9, e), P = r), t.hasOwnProperty(e = "POW_PRECISION") && (g(r = t[e], 0, 1e9, e), N = r), t.hasOwnProperty(e = "FORMAT")) {
                    if ("object" != typeof (r = t[e])) throw Error(f + e + " not an object: " + r);
                    C = r;
                  }

                  if (t.hasOwnProperty(e = "ALPHABET")) {
                    if ("string" != typeof (r = t[e]) || /^.$|[+-.\s]|(.).*\1/.test(r)) throw Error(f + e + " invalid: " + r);
                    L = r;
                  }
                }

                return {
                  DECIMAL_PLACES: x,
                  ROUNDING_MODE: R,
                  EXPONENTIAL_AT: [T, k],
                  RANGE: [I, B],
                  CRYPTO: O,
                  MODULO_MODE: P,
                  POW_PRECISION: N,
                  FORMAT: C,
                  ALPHABET: L
                };
              }, j.isBigNumber = function (t) {
                if (!t || !0 !== t._isBigNumber) return !1;
                if (!j.DEBUG) return !0;
                var e,
                    r,
                    n = t.c,
                    i = t.e,
                    o = t.s;

                t: if ("[object Array]" == {}.toString.call(n)) {
                  if ((1 === o || -1 === o) && i >= -1e9 && i <= 1e9 && i === u(i)) {
                    if (0 === n[0]) {
                      if (0 === i && 1 === n.length) return !0;
                      break t;
                    }

                    if ((e = (i + 1) % 14) < 1 && (e += 14), String(n[0]).length == e) {
                      for (e = 0; e < n.length; e++) {
                        if ((r = n[e]) < 0 || r >= 1e14 || r !== u(r)) break t;
                      }

                      if (0 !== r) return !0;
                    }
                  }
                } else if (null === n && null === i && (null === o || 1 === o || -1 === o)) return !0;

                throw Error(f + "Invalid BigNumber: " + t);
              }, j.maximum = j.max = function () {
                return D(arguments, S.lt);
              }, j.minimum = j.min = function () {
                return D(arguments, S.gt);
              }, j.random = (o = 9007199254740992 * Math.random() & 2097151 ? function () {
                return u(9007199254740992 * Math.random());
              } : function () {
                return 8388608 * (1073741824 * Math.random() | 0) + (8388608 * Math.random() | 0);
              }, function (t) {
                var e,
                    r,
                    n,
                    i,
                    s,
                    c = 0,
                    l = [],
                    d = new j(A);
                if (null == t ? t = x : g(t, 0, 1e9), i = a(t / 14), O) if (crypto.getRandomValues) {
                  for (e = crypto.getRandomValues(new Uint32Array(i *= 2)); c < i;) {
                    (s = 131072 * e[c] + (e[c + 1] >>> 11)) >= 9e15 ? (r = crypto.getRandomValues(new Uint32Array(2)), e[c] = r[0], e[c + 1] = r[1]) : (l.push(s % 1e14), c += 2);
                  }

                  c = i / 2;
                } else {
                  if (!crypto.randomBytes) throw O = !1, Error(f + "crypto unavailable");

                  for (e = crypto.randomBytes(i *= 7); c < i;) {
                    (s = 281474976710656 * (31 & e[c]) + 1099511627776 * e[c + 1] + 4294967296 * e[c + 2] + 16777216 * e[c + 3] + (e[c + 4] << 16) + (e[c + 5] << 8) + e[c + 6]) >= 9e15 ? crypto.randomBytes(7).copy(e, c) : (l.push(s % 1e14), c += 7);
                  }

                  c = i / 7;
                }
                if (!O) for (; c < i;) {
                  (s = o()) < 9e15 && (l[c++] = s % 1e14);
                }

                for (t %= 14, (i = l[--c]) && t && (s = h[14 - t], l[c] = u(i / s) * s); 0 === l[c]; l.pop(), c--) {
                  ;
                }

                if (c < 0) l = [n = 0];else {
                  for (n = -1; 0 === l[0]; l.splice(0, 1), n -= 14) {
                    ;
                  }

                  for (c = 1, s = l[0]; s >= 10; s /= 10, c++) {
                    ;
                  }

                  c < 14 && (n -= 14 - c);
                }
                return d.e = n, d.c = l, d;
              }), j.sum = function () {
                for (var t = 1, e = arguments, r = new j(e[0]); t < e.length;) {
                  r = r.plus(e[t++]);
                }

                return r;
              }, n = function () {
                function t(t, e, r, n) {
                  for (var i, o, s = [0], a = 0, u = t.length; a < u;) {
                    for (o = s.length; o--; s[o] *= e) {
                      ;
                    }

                    for (s[0] += n.indexOf(t.charAt(a++)), i = 0; i < s.length; i++) {
                      s[i] > r - 1 && (null == s[i + 1] && (s[i + 1] = 0), s[i + 1] += s[i] / r | 0, s[i] %= r);
                    }
                  }

                  return s.reverse();
                }

                return function (e, n, i, o, s) {
                  var a,
                      u,
                      f,
                      c,
                      h,
                      l,
                      p,
                      g,
                      m = e.indexOf("."),
                      b = x,
                      y = R;

                  for (m >= 0 && (c = N, N = 0, e = e.replace(".", ""), l = (g = new j(n)).pow(e.length - m), N = c, g.c = t(v(d(l.c), l.e, "0"), 10, i, "0123456789"), g.e = g.c.length), f = c = (p = t(e, n, i, s ? (a = L, "0123456789") : (a = "0123456789", L))).length; 0 == p[--c]; p.pop()) {
                    ;
                  }

                  if (!p[0]) return a.charAt(0);
                  if (m < 0 ? --f : (l.c = p, l.e = f, l.s = o, p = (l = r(l, g, b, y, i)).c, h = l.r, f = l.e), m = p[u = f + b + 1], c = i / 2, h = h || u < 0 || null != p[u + 1], h = y < 4 ? (null != m || h) && (0 == y || y == (l.s < 0 ? 3 : 2)) : m > c || m == c && (4 == y || h || 6 == y && 1 & p[u - 1] || y == (l.s < 0 ? 8 : 7)), u < 1 || !p[0]) e = h ? v(a.charAt(1), -b, a.charAt(0)) : a.charAt(0);else {
                    if (p.length = u, h) for (--i; ++p[--u] > i;) {
                      p[u] = 0, u || (++f, p = [1].concat(p));
                    }

                    for (c = p.length; !p[--c];) {
                      ;
                    }

                    for (m = 0, e = ""; m <= c; e += a.charAt(p[m++])) {
                      ;
                    }

                    e = v(e, f, a.charAt(0));
                  }
                  return e;
                };
              }(), r = function () {
                function t(t, e, r) {
                  var n,
                      i,
                      o,
                      s,
                      a = 0,
                      u = t.length,
                      f = e % 1e7,
                      c = e / 1e7 | 0;

                  for (t = t.slice(); u--;) {
                    a = ((i = f * (o = t[u] % 1e7) + (n = c * o + (s = t[u] / 1e7 | 0) * f) % 1e7 * 1e7 + a) / r | 0) + (n / 1e7 | 0) + c * s, t[u] = i % r;
                  }

                  return a && (t = [a].concat(t)), t;
                }

                function e(t, e, r, n) {
                  var i, o;
                  if (r != n) o = r > n ? 1 : -1;else for (i = o = 0; i < r; i++) {
                    if (t[i] != e[i]) {
                      o = t[i] > e[i] ? 1 : -1;
                      break;
                    }
                  }
                  return o;
                }

                function r(t, e, r, n) {
                  for (var i = 0; r--;) {
                    t[r] -= i, i = t[r] < e[r] ? 1 : 0, t[r] = i * n + t[r] - e[r];
                  }

                  for (; !t[0] && t.length > 1; t.splice(0, 1)) {
                    ;
                  }
                }

                return function (n, i, o, s, a) {
                  var f,
                      c,
                      h,
                      d,
                      p,
                      g,
                      m,
                      b,
                      v,
                      y,
                      _,
                      w,
                      E,
                      M,
                      S,
                      A,
                      x,
                      R = n.s == i.s ? 1 : -1,
                      T = n.c,
                      k = i.c;

                  if (!(T && T[0] && k && k[0])) return new j(n.s && i.s && (T ? !k || T[0] != k[0] : k) ? T && 0 == T[0] || !k ? 0 * R : R / 0 : NaN);

                  for (v = (b = new j(R)).c = [], R = o + (c = n.e - i.e) + 1, a || (a = 1e14, c = l(n.e / 14) - l(i.e / 14), R = R / 14 | 0), h = 0; k[h] == (T[h] || 0); h++) {
                    ;
                  }

                  if (k[h] > (T[h] || 0) && c--, R < 0) v.push(1), d = !0;else {
                    for (M = T.length, A = k.length, h = 0, R += 2, (p = u(a / (k[0] + 1))) > 1 && (k = t(k, p, a), T = t(T, p, a), A = k.length, M = T.length), E = A, _ = (y = T.slice(0, A)).length; _ < A; y[_++] = 0) {
                      ;
                    }

                    x = k.slice(), x = [0].concat(x), S = k[0], k[1] >= a / 2 && S++;

                    do {
                      if (p = 0, (f = e(k, y, A, _)) < 0) {
                        if (w = y[0], A != _ && (w = w * a + (y[1] || 0)), (p = u(w / S)) > 1) for (p >= a && (p = a - 1), m = (g = t(k, p, a)).length, _ = y.length; 1 == e(g, y, m, _);) {
                          p--, r(g, A < m ? x : k, m, a), m = g.length, f = 1;
                        } else 0 == p && (f = p = 1), m = (g = k.slice()).length;
                        if (m < _ && (g = [0].concat(g)), r(y, g, _, a), _ = y.length, -1 == f) for (; e(k, y, A, _) < 1;) {
                          p++, r(y, A < _ ? x : k, _, a), _ = y.length;
                        }
                      } else 0 === f && (p++, y = [0]);

                      v[h++] = p, y[0] ? y[_++] = T[E] || 0 : (y = [T[E]], _ = 1);
                    } while ((E++ < M || null != y[0]) && R--);

                    d = null != y[0], v[0] || v.splice(0, 1);
                  }

                  if (1e14 == a) {
                    for (h = 1, R = v[0]; R >= 10; R /= 10, h++) {
                      ;
                    }

                    z(b, o + (b.e = h + 14 * c - 1) + 1, s, d);
                  } else b.e = c, b.r = +d;

                  return b;
                };
              }(), y = /^(-?)0([xbo])(?=\w[\w.]*$)/i, _ = /^([^.]+)\.$/, w = /^\.([^.]+)$/, E = /^-?(Infinity|NaN)$/, M = /^\s*\+(?=[\w.])|^\s+|\s+$/g, i = function i(t, e, r, n) {
                var i,
                    o = r ? e : e.replace(M, "");
                if (E.test(o)) t.s = isNaN(o) ? null : o < 0 ? -1 : 1;else {
                  if (!r && (o = o.replace(y, function (t, e, r) {
                    return i = "x" == (r = r.toLowerCase()) ? 16 : "b" == r ? 2 : 8, n && n != i ? t : e;
                  }), n && (i = n, o = o.replace(_, "$1").replace(w, "0.$1")), e != o)) return new j(o, i);
                  if (j.DEBUG) throw Error(f + "Not a" + (n ? " base " + n : "") + " number: " + e);
                  t.s = null;
                }
                t.c = t.e = null;
              }, S.absoluteValue = S.abs = function () {
                var t = new j(this);
                return t.s < 0 && (t.s = 1), t;
              }, S.comparedTo = function (t, e) {
                return p(this, new j(t, e));
              }, S.decimalPlaces = S.dp = function (t, e) {
                var r,
                    n,
                    i,
                    o = this;
                if (null != t) return g(t, 0, 1e9), null == e ? e = R : g(e, 0, 8), z(new j(o), t + o.e + 1, e);
                if (!(r = o.c)) return null;
                if (n = 14 * ((i = r.length - 1) - l(this.e / 14)), i = r[i]) for (; i % 10 == 0; i /= 10, n--) {
                  ;
                }
                return n < 0 && (n = 0), n;
              }, S.dividedBy = S.div = function (t, e) {
                return r(this, new j(t, e), x, R);
              }, S.dividedToIntegerBy = S.idiv = function (t, e) {
                return r(this, new j(t, e), 0, 1);
              }, S.exponentiatedBy = S.pow = function (t, e) {
                var r,
                    n,
                    i,
                    o,
                    s,
                    c,
                    h,
                    l,
                    d = this;
                if ((t = new j(t)).c && !t.isInteger()) throw Error(f + "Exponent not an integer: " + q(t));
                if (null != e && (e = new j(e)), s = t.e > 14, !d.c || !d.c[0] || 1 == d.c[0] && !d.e && 1 == d.c.length || !t.c || !t.c[0]) return l = new j(Math.pow(+q(d), s ? 2 - m(t) : +q(t))), e ? l.mod(e) : l;

                if (c = t.s < 0, e) {
                  if (e.c ? !e.c[0] : !e.s) return new j(NaN);
                  (n = !c && d.isInteger() && e.isInteger()) && (d = d.mod(e));
                } else {
                  if (t.e > 9 && (d.e > 0 || d.e < -1 || (0 == d.e ? d.c[0] > 1 || s && d.c[1] >= 24e7 : d.c[0] < 8e13 || s && d.c[0] <= 9999975e7))) return o = d.s < 0 && m(t) ? -0 : 0, d.e > -1 && (o = 1 / o), new j(c ? 1 / o : o);
                  N && (o = a(N / 14 + 2));
                }

                for (s ? (r = new j(.5), c && (t.s = 1), h = m(t)) : h = (i = Math.abs(+q(t))) % 2, l = new j(A);;) {
                  if (h) {
                    if (!(l = l.times(d)).c) break;
                    o ? l.c.length > o && (l.c.length = o) : n && (l = l.mod(e));
                  }

                  if (i) {
                    if (0 === (i = u(i / 2))) break;
                    h = i % 2;
                  } else if (z(t = t.times(r), t.e + 1, 1), t.e > 14) h = m(t);else {
                    if (0 == (i = +q(t))) break;
                    h = i % 2;
                  }

                  d = d.times(d), o ? d.c && d.c.length > o && (d.c.length = o) : n && (d = d.mod(e));
                }

                return n ? l : (c && (l = A.div(l)), e ? l.mod(e) : o ? z(l, N, R, void 0) : l);
              }, S.integerValue = function (t) {
                var e = new j(this);
                return null == t ? t = R : g(t, 0, 8), z(e, e.e + 1, t);
              }, S.isEqualTo = S.eq = function (t, e) {
                return 0 === p(this, new j(t, e));
              }, S.isFinite = function () {
                return !!this.c;
              }, S.isGreaterThan = S.gt = function (t, e) {
                return p(this, new j(t, e)) > 0;
              }, S.isGreaterThanOrEqualTo = S.gte = function (t, e) {
                return 1 === (e = p(this, new j(t, e))) || 0 === e;
              }, S.isInteger = function () {
                return !!this.c && l(this.e / 14) > this.c.length - 2;
              }, S.isLessThan = S.lt = function (t, e) {
                return p(this, new j(t, e)) < 0;
              }, S.isLessThanOrEqualTo = S.lte = function (t, e) {
                return -1 === (e = p(this, new j(t, e))) || 0 === e;
              }, S.isNaN = function () {
                return !this.s;
              }, S.isNegative = function () {
                return this.s < 0;
              }, S.isPositive = function () {
                return this.s > 0;
              }, S.isZero = function () {
                return !!this.c && 0 == this.c[0];
              }, S.minus = function (t, e) {
                var r,
                    n,
                    i,
                    o,
                    s = this,
                    a = s.s;
                if (e = (t = new j(t, e)).s, !a || !e) return new j(NaN);
                if (a != e) return t.s = -e, s.plus(t);
                var u = s.e / 14,
                    f = t.e / 14,
                    c = s.c,
                    h = t.c;

                if (!u || !f) {
                  if (!c || !h) return c ? (t.s = -e, t) : new j(h ? s : NaN);
                  if (!c[0] || !h[0]) return h[0] ? (t.s = -e, t) : new j(c[0] ? s : 3 == R ? -0 : 0);
                }

                if (u = l(u), f = l(f), c = c.slice(), a = u - f) {
                  for ((o = a < 0) ? (a = -a, i = c) : (f = u, i = h), i.reverse(), e = a; e--; i.push(0)) {
                    ;
                  }

                  i.reverse();
                } else for (n = (o = (a = c.length) < (e = h.length)) ? a : e, a = e = 0; e < n; e++) {
                  if (c[e] != h[e]) {
                    o = c[e] < h[e];
                    break;
                  }
                }

                if (o && (i = c, c = h, h = i, t.s = -t.s), (e = (n = h.length) - (r = c.length)) > 0) for (; e--; c[r++] = 0) {
                  ;
                }

                for (e = 1e14 - 1; n > a;) {
                  if (c[--n] < h[n]) {
                    for (r = n; r && !c[--r]; c[r] = e) {
                      ;
                    }

                    --c[r], c[n] += 1e14;
                  }

                  c[n] -= h[n];
                }

                for (; 0 == c[0]; c.splice(0, 1), --f) {
                  ;
                }

                return c[0] ? F(t, c, f) : (t.s = 3 == R ? -1 : 1, t.c = [t.e = 0], t);
              }, S.modulo = S.mod = function (t, e) {
                var n,
                    i,
                    o = this;
                return t = new j(t, e), !o.c || !t.s || t.c && !t.c[0] ? new j(NaN) : !t.c || o.c && !o.c[0] ? new j(o) : (9 == P ? (i = t.s, t.s = 1, n = r(o, t, 0, 3), t.s = i, n.s *= i) : n = r(o, t, 0, P), (t = o.minus(n.times(t))).c[0] || 1 != P || (t.s = o.s), t);
              }, S.multipliedBy = S.times = function (t, e) {
                var r,
                    n,
                    i,
                    o,
                    s,
                    a,
                    u,
                    f,
                    c,
                    h,
                    d,
                    p,
                    g,
                    m = this,
                    b = m.c,
                    v = (t = new j(t, e)).c;
                if (!(b && v && b[0] && v[0])) return !m.s || !t.s || b && !b[0] && !v || v && !v[0] && !b ? t.c = t.e = t.s = null : (t.s *= m.s, b && v ? (t.c = [0], t.e = 0) : t.c = t.e = null), t;

                for (n = l(m.e / 14) + l(t.e / 14), t.s *= m.s, (u = b.length) < (h = v.length) && (g = b, b = v, v = g, i = u, u = h, h = i), i = u + h, g = []; i--; g.push(0)) {
                  ;
                }

                for (i = h; --i >= 0;) {
                  for (r = 0, d = v[i] % 1e7, p = v[i] / 1e7 | 0, o = i + (s = u); o > i;) {
                    r = ((f = d * (f = b[--s] % 1e7) + (a = p * f + (c = b[s] / 1e7 | 0) * d) % 1e7 * 1e7 + g[o] + r) / 1e14 | 0) + (a / 1e7 | 0) + p * c, g[o--] = f % 1e14;
                  }

                  g[o] = r;
                }

                return r ? ++n : g.splice(0, 1), F(t, g, n);
              }, S.negated = function () {
                var t = new j(this);
                return t.s = -t.s || null, t;
              }, S.plus = function (t, e) {
                var r,
                    n = this,
                    i = n.s;
                if (e = (t = new j(t, e)).s, !i || !e) return new j(NaN);
                if (i != e) return t.s = -e, n.minus(t);
                var o = n.e / 14,
                    s = t.e / 14,
                    a = n.c,
                    u = t.c;

                if (!o || !s) {
                  if (!a || !u) return new j(i / 0);
                  if (!a[0] || !u[0]) return u[0] ? t : new j(a[0] ? n : 0 * i);
                }

                if (o = l(o), s = l(s), a = a.slice(), i = o - s) {
                  for (i > 0 ? (s = o, r = u) : (i = -i, r = a), r.reverse(); i--; r.push(0)) {
                    ;
                  }

                  r.reverse();
                }

                for ((i = a.length) - (e = u.length) < 0 && (r = u, u = a, a = r, e = i), i = 0; e;) {
                  i = (a[--e] = a[e] + u[e] + i) / 1e14 | 0, a[e] = 1e14 === a[e] ? 0 : a[e] % 1e14;
                }

                return i && (a = [i].concat(a), ++s), F(t, a, s);
              }, S.precision = S.sd = function (t, e) {
                var r,
                    n,
                    i,
                    o = this;
                if (null != t && t !== !!t) return g(t, 1, 1e9), null == e ? e = R : g(e, 0, 8), z(new j(o), t, e);
                if (!(r = o.c)) return null;

                if (n = 14 * (i = r.length - 1) + 1, i = r[i]) {
                  for (; i % 10 == 0; i /= 10, n--) {
                    ;
                  }

                  for (i = r[0]; i >= 10; i /= 10, n++) {
                    ;
                  }
                }

                return t && o.e + 1 > n && (n = o.e + 1), n;
              }, S.shiftedBy = function (t) {
                return g(t, -9007199254740991, 9007199254740991), this.times("1e" + t);
              }, S.squareRoot = S.sqrt = function () {
                var t,
                    e,
                    n,
                    i,
                    o,
                    s = this,
                    a = s.c,
                    u = s.s,
                    f = s.e,
                    c = x + 4,
                    h = new j("0.5");
                if (1 !== u || !a || !a[0]) return new j(!u || u < 0 && (!a || a[0]) ? NaN : a ? s : 1 / 0);
                if (0 == (u = Math.sqrt(+q(s))) || u == 1 / 0 ? (((e = d(a)).length + f) % 2 == 0 && (e += "0"), u = Math.sqrt(+e), f = l((f + 1) / 2) - (f < 0 || f % 2), n = new j(e = u == 1 / 0 ? "1e" + f : (e = u.toExponential()).slice(0, e.indexOf("e") + 1) + f)) : n = new j(u + ""), n.c[0]) for ((u = (f = n.e) + c) < 3 && (u = 0);;) {
                  if (o = n, n = h.times(o.plus(r(s, o, c, 1))), d(o.c).slice(0, u) === (e = d(n.c)).slice(0, u)) {
                    if (n.e < f && --u, "9999" != (e = e.slice(u - 3, u + 1)) && (i || "4999" != e)) {
                      +e && (+e.slice(1) || "5" != e.charAt(0)) || (z(n, n.e + x + 2, 1), t = !n.times(n).eq(s));
                      break;
                    }

                    if (!i && (z(o, o.e + x + 2, 0), o.times(o).eq(s))) {
                      n = o;
                      break;
                    }

                    c += 4, u += 4, i = 1;
                  }
                }
                return z(n, n.e + x + 1, R, t);
              }, S.toExponential = function (t, e) {
                return null != t && (g(t, 0, 1e9), t++), U(this, t, e, 1);
              }, S.toFixed = function (t, e) {
                return null != t && (g(t, 0, 1e9), t = t + this.e + 1), U(this, t, e);
              }, S.toFormat = function (t, e, r) {
                var n,
                    i = this;
                if (null == r) null != t && e && "object" == typeof e ? (r = e, e = null) : t && "object" == typeof t ? (r = t, t = e = null) : r = C;else if ("object" != typeof r) throw Error(f + "Argument not an object: " + r);

                if (n = i.toFixed(t, e), i.c) {
                  var o,
                      s = n.split("."),
                      a = +r.groupSize,
                      u = +r.secondaryGroupSize,
                      c = r.groupSeparator || "",
                      h = s[0],
                      l = s[1],
                      d = i.s < 0,
                      p = d ? h.slice(1) : h,
                      g = p.length;

                  if (u && (o = a, a = u, u = o, g -= o), a > 0 && g > 0) {
                    for (o = g % a || a, h = p.substr(0, o); o < g; o += a) {
                      h += c + p.substr(o, a);
                    }

                    u > 0 && (h += c + p.slice(o)), d && (h = "-" + h);
                  }

                  n = l ? h + (r.decimalSeparator || "") + ((u = +r.fractionGroupSize) ? l.replace(new RegExp("\\d{" + u + "}\\B", "g"), "$&" + (r.fractionGroupSeparator || "")) : l) : h;
                }

                return (r.prefix || "") + n + (r.suffix || "");
              }, S.toFraction = function (t) {
                var e,
                    n,
                    i,
                    o,
                    s,
                    a,
                    u,
                    c,
                    l,
                    p,
                    g,
                    m,
                    b = this,
                    v = b.c;
                if (null != t && (!(u = new j(t)).isInteger() && (u.c || 1 !== u.s) || u.lt(A))) throw Error(f + "Argument " + (u.isInteger() ? "out of range: " : "not an integer: ") + q(u));
                if (!v) return new j(b);

                for (e = new j(A), l = n = new j(A), i = c = new j(A), m = d(v), s = e.e = m.length - b.e - 1, e.c[0] = h[(a = s % 14) < 0 ? 14 + a : a], t = !t || u.comparedTo(e) > 0 ? s > 0 ? e : l : u, a = B, B = 1 / 0, u = new j(m), c.c[0] = 0; p = r(u, e, 0, 1), 1 != (o = n.plus(p.times(i))).comparedTo(t);) {
                  n = i, i = o, l = c.plus(p.times(o = l)), c = o, e = u.minus(p.times(o = e)), u = o;
                }

                return o = r(t.minus(n), i, 0, 1), c = c.plus(o.times(l)), n = n.plus(o.times(i)), c.s = l.s = b.s, g = r(l, i, s *= 2, R).minus(b).abs().comparedTo(r(c, n, s, R).minus(b).abs()) < 1 ? [l, i] : [c, n], B = a, g;
              }, S.toNumber = function () {
                return +q(this);
              }, S.toPrecision = function (t, e) {
                return null != t && g(t, 1, 1e9), U(this, t, e, 2);
              }, S.toString = function (t) {
                var e,
                    r = this,
                    i = r.s,
                    o = r.e;
                return null === o ? i ? (e = "Infinity", i < 0 && (e = "-" + e)) : e = "NaN" : (null == t ? e = o <= T || o >= k ? b(d(r.c), o) : v(d(r.c), o, "0") : 10 === t ? e = v(d((r = z(new j(r), x + o + 1, R)).c), r.e, "0") : (g(t, 2, L.length, "Base"), e = n(v(d(r.c), o, "0"), 10, t, i, !0)), i < 0 && r.c[0] && (e = "-" + e)), e;
              }, S.valueOf = S.toJSON = function () {
                return q(this);
              }, S._isBigNumber = !0, null != e && j.set(e), j;
            }()).default = o.BigNumber = o, void 0 === (n = function () {
              return o;
            }.call(e, r, e, t)) || (t.exports = n);
          }();
        }, function (t, e) {
          t.exports = function (t) {
            return t.webpackPolyfill || (t.deprecate = function () {}, t.paths = [], t.children || (t.children = []), Object.defineProperty(t, "loaded", {
              enumerable: !0,
              get: function get() {
                return t.l;
              }
            }), Object.defineProperty(t, "id", {
              enumerable: !0,
              get: function get() {
                return t.i;
              }
            }), t.webpackPolyfill = 1), t;
          };
        }, function (t, e) {}, function (t, e) {
          var r,
              n,
              i = t.exports = {};

          function o() {
            throw new Error("setTimeout has not been defined");
          }

          function s() {
            throw new Error("clearTimeout has not been defined");
          }

          function a(t) {
            if (r === setTimeout) return setTimeout(t, 0);
            if ((r === o || !r) && setTimeout) return r = setTimeout, setTimeout(t, 0);

            try {
              return r(t, 0);
            } catch (e) {
              try {
                return r.call(null, t, 0);
              } catch (e) {
                return r.call(this, t, 0);
              }
            }
          }

          !function () {
            try {
              r = "function" == typeof setTimeout ? setTimeout : o;
            } catch (t) {
              r = o;
            }

            try {
              n = "function" == typeof clearTimeout ? clearTimeout : s;
            } catch (t) {
              n = s;
            }
          }();
          var u,
              f = [],
              c = !1,
              h = -1;

          function l() {
            c && u && (c = !1, u.length ? f = u.concat(f) : h = -1, f.length && d());
          }

          function d() {
            if (!c) {
              var t = a(l);
              c = !0;

              for (var e = f.length; e;) {
                for (u = f, f = []; ++h < e;) {
                  u && u[h].run();
                }

                h = -1, e = f.length;
              }

              u = null, c = !1, function (t) {
                if (n === clearTimeout) return clearTimeout(t);
                if ((n === s || !n) && clearTimeout) return n = clearTimeout, clearTimeout(t);

                try {
                  n(t);
                } catch (e) {
                  try {
                    return n.call(null, t);
                  } catch (e) {
                    return n.call(this, t);
                  }
                }
              }(t);
            }
          }

          function p(t, e) {
            this.fun = t, this.array = e;
          }

          function g() {}

          i.nextTick = function (t) {
            var e = new Array(arguments.length - 1);
            if (arguments.length > 1) for (var r = 1; r < arguments.length; r++) {
              e[r - 1] = arguments[r];
            }
            f.push(new p(t, e)), 1 !== f.length || c || a(d);
          }, p.prototype.run = function () {
            this.fun.apply(null, this.array);
          }, i.title = "browser", i.browser = !0, i.env = {}, i.argv = [], i.version = "", i.versions = {}, i.on = g, i.addListener = g, i.once = g, i.off = g, i.removeListener = g, i.removeAllListeners = g, i.emit = g, i.prependListener = g, i.prependOnceListener = g, i.listeners = function (t) {
            return [];
          }, i.binding = function (t) {
            throw new Error("process.binding is not supported");
          }, i.cwd = function () {
            return "/";
          }, i.chdir = function (t) {
            throw new Error("process.chdir is not supported");
          }, i.umask = function () {
            return 0;
          };
        }, function (t, e, r) {
          "use strict";

          r.r(e);
          var n = r(2);
          n.a.from(-1), n.a.from(0), n.a.from(1), n.a.from(2), n.a.from("1000000000000000000"), n.a.from("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
          var i = r(0);
          var o = new (r(1).a)("strings/5.0.0-beta.136");
          var s, a;

          function u(t, e, r, n, i) {
            if (t === a.BAD_PREFIX || t === a.UNEXPECTED_CONTINUE) {
              var _t15 = 0;

              for (var _n20 = e + 1; _n20 < r.length && r[_n20] >> 6 == 2; _n20++) {
                _t15++;
              }

              return _t15;
            }

            return t === a.OVERRUN ? r.length - e - 1 : 0;
          }

          !function (t) {
            t.current = "", t.NFC = "NFC", t.NFD = "NFD", t.NFKC = "NFKC", t.NFKD = "NFKD";
          }(s || (s = {})), function (t) {
            t.UNEXPECTED_CONTINUE = "unexpected continuation byte", t.BAD_PREFIX = "bad codepoint prefix", t.OVERRUN = "string overrun", t.MISSING_CONTINUE = "missing continuation byte", t.OUT_OF_RANGE = "out of UTF-8 range", t.UTF16_SURROGATE = "UTF-16 surrogate", t.OVERLONG = "overlong representation";
          }(a || (a = {}));
          var f = Object.freeze({
            error: function error(t, e, r, n, i) {
              return o.throwArgumentError("invalid codepoint at offset ".concat(e, "; ").concat(t), "bytes", r);
            },
            ignore: u,
            replace: function replace(t, e, r, n, i) {
              return t === a.OVERLONG ? (n.push(i), 0) : (n.push(65533), u(t, e, r));
            }
          });

          function c(t, e) {
            null == e && (e = f.error), t = Object(i.arrayify)(t);
            var r = [];
            var n = 0;

            for (; n < t.length;) {
              var _i6 = t[n++];

              if (_i6 >> 7 == 0) {
                r.push(_i6);
                continue;
              }

              var _o10 = null,
                  _s2 = null;
              if (192 == (224 & _i6)) _o10 = 1, _s2 = 127;else if (224 == (240 & _i6)) _o10 = 2, _s2 = 2047;else {
                if (240 != (248 & _i6)) {
                  n += e(128 == (192 & _i6) ? a.UNEXPECTED_CONTINUE : a.BAD_PREFIX, n - 1, t, r);
                  continue;
                }

                _o10 = 3, _s2 = 65535;
              }

              if (n - 1 + _o10 >= t.length) {
                n += e(a.OVERRUN, n - 1, t, r);
                continue;
              }

              var _u2 = _i6 & (1 << 8 - _o10 - 1) - 1;

              for (var _i7 = 0; _i7 < _o10; _i7++) {
                var _i8 = t[n];

                if (128 != (192 & _i8)) {
                  n += e(a.MISSING_CONTINUE, n, t, r), _u2 = null;
                  break;
                }

                _u2 = _u2 << 6 | 63 & _i8, n++;
              }

              null !== _u2 && (_u2 > 1114111 ? n += e(a.OUT_OF_RANGE, n - 1 - _o10, t, r, _u2) : _u2 >= 55296 && _u2 <= 57343 ? n += e(a.UTF16_SURROGATE, n - 1 - _o10, t, r, _u2) : _u2 <= _s2 ? n += e(a.OVERLONG, n - 1 - _o10, t, r, _u2) : r.push(_u2));
            }

            return r;
          }

          function h(t) {
            var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : s.current;
            e != s.current && (o.checkNormalize(), t = t.normalize(e));
            var r = [];

            for (var _e13 = 0; _e13 < t.length; _e13++) {
              var _n21 = t.charCodeAt(_e13);

              if (_n21 < 128) r.push(_n21);else if (_n21 < 2048) r.push(_n21 >> 6 | 192), r.push(63 & _n21 | 128);else if (55296 == (64512 & _n21)) {
                _e13++;

                var _i9 = t.charCodeAt(_e13);

                if (_e13 >= t.length || 56320 != (64512 & _i9)) throw new Error("invalid utf-8 string");

                var _o11 = 65536 + ((1023 & _n21) << 10) + (1023 & _i9);

                r.push(_o11 >> 18 | 240), r.push(_o11 >> 12 & 63 | 128), r.push(_o11 >> 6 & 63 | 128), r.push(63 & _o11 | 128);
              } else r.push(_n21 >> 12 | 224), r.push(_n21 >> 6 & 63 | 128), r.push(63 & _n21 | 128);
            }

            return Object(i.arrayify)(r);
          }

          function l(t) {
            var e = "0000" + t.toString(16);
            return "\\u" + e.substring(e.length - 4);
          }

          function d(t, e) {
            return '"' + c(t, e).map(function (t) {
              if (t < 256) {
                switch (t) {
                  case 8:
                    return "\\b";

                  case 9:
                    return "\\t";

                  case 10:
                    return "\\n";

                  case 13:
                    return "\\r";

                  case 34:
                    return '\\"';

                  case 92:
                    return "\\\\";
                }

                if (t >= 32 && t < 127) return String.fromCharCode(t);
              }

              return t <= 65535 ? l(t) : l(55296 + ((t -= 65536) >> 10 & 1023)) + l(56320 + (1023 & t));
            }).join("") + '"';
          }

          function p(t) {
            return t.map(function (t) {
              return t <= 65535 ? String.fromCharCode(t) : (t -= 65536, String.fromCharCode(55296 + (t >> 10 & 1023), 56320 + (1023 & t)));
            }).join("");
          }

          function g(t, e) {
            return p(c(t, e));
          }

          function m(t) {
            var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : s.current;
            return c(h(t, e));
          }

          function b(t) {
            var e = h(t);
            if (e.length > 31) throw new Error("bytes32 string must be less than 32 bytes");
            return Object(i.hexlify)(Object(i.concat)([e, "0x0000000000000000000000000000000000000000000000000000000000000000"]).slice(0, 32));
          }

          function v(t) {
            var e = Object(i.arrayify)(t);
            if (32 !== e.length) throw new Error("invalid bytes32 - not 32 bytes long");
            if (0 !== e[31]) throw new Error("invalid bytes32 string - no null terminator");
            var r = 31;

            for (; 0 === e[r - 1];) {
              r--;
            }

            return g(e.slice(0, r));
          }

          function y(t, e) {
            e || (e = function e(t) {
              return [parseInt(t, 16)];
            });
            var r = 0,
                n = {};
            return t.split(",").forEach(function (t) {
              var i = t.split(":");
              r += parseInt(i[0], 16), n[r] = e(i[1]);
            }), n;
          }

          function _(t) {
            var e = 0;
            return t.split(",").map(function (t) {
              var r = t.split("-");
              1 === r.length ? r[1] = "0" : "" === r[1] && (r[1] = "1");
              var n = e + parseInt(r[0], 16);
              return e = parseInt(r[1], 16), {
                l: n,
                h: e
              };
            });
          }

          function w(t, e) {
            var r = 0;

            for (var _n22 = 0; _n22 < e.length; _n22++) {
              var _i10 = e[_n22];

              if (r += _i10.l, t >= r && t <= r + _i10.h && (t - r) % (_i10.d || 1) == 0) {
                if (_i10.e && -1 !== _i10.e.indexOf(t - r)) continue;
                return _i10;
              }
            }

            return null;
          }

          var E = _("221,13-1b,5f-,40-10,51-f,11-3,3-3,2-2,2-4,8,2,15,2d,28-8,88,48,27-,3-5,11-20,27-,8,28,3-5,12,18,b-a,1c-4,6-16,2-d,2-2,2,1b-4,17-9,8f-,10,f,1f-2,1c-34,33-14e,4,36-,13-,6-2,1a-f,4,9-,3-,17,8,2-2,5-,2,8-,3-,4-8,2-3,3,6-,16-6,2-,7-3,3-,17,8,3,3,3-,2,6-3,3-,4-a,5,2-6,10-b,4,8,2,4,17,8,3,6-,b,4,4-,2-e,2-4,b-10,4,9-,3-,17,8,3-,5-,9-2,3-,4-7,3-3,3,4-3,c-10,3,7-2,4,5-2,3,2,3-2,3-2,4-2,9,4-3,6-2,4,5-8,2-e,d-d,4,9,4,18,b,6-3,8,4,5-6,3-8,3-3,b-11,3,9,4,18,b,6-3,8,4,5-6,3-6,2,3-3,b-11,3,9,4,18,11-3,7-,4,5-8,2-7,3-3,b-11,3,13-2,19,a,2-,8-2,2-3,7,2,9-11,4-b,3b-3,1e-24,3,2-,3,2-,2-5,5,8,4,2,2-,3,e,4-,6,2,7-,b-,3-21,49,23-5,1c-3,9,25,10-,2-2f,23,6,3,8-2,5-5,1b-45,27-9,2a-,2-3,5b-4,45-4,53-5,8,40,2,5-,8,2,5-,28,2,5-,20,2,5-,8,2,5-,8,8,18,20,2,5-,8,28,14-5,1d-22,56-b,277-8,1e-2,52-e,e,8-a,18-8,15-b,e,4,3-b,5e-2,b-15,10,b-5,59-7,2b-555,9d-3,5b-5,17-,7-,27-,7-,9,2,2,2,20-,36,10,f-,7,14-,4,a,54-3,2-6,6-5,9-,1c-10,13-1d,1c-14,3c-,10-6,32-b,240-30,28-18,c-14,a0,115-,3,66-,b-76,5,5-,1d,24,2,5-2,2,8-,35-2,19,f-10,1d-3,311-37f,1b,5a-b,d7-19,d-3,41,57-,68-4,29-3,5f,29-37,2e-2,25-c,2c-2,4e-3,30,78-3,64-,20,19b7-49,51a7-59,48e-2,38-738,2ba5-5b,222f-,3c-94,8-b,6-4,1b,6,2,3,3,6d-20,16e-f,41-,37-7,2e-2,11-f,5-b,18-,b,14,5-3,6,88-,2,bf-2,7-,7-,7-,4-2,8,8-9,8-2ff,20,5-b,1c-b4,27-,27-cbb1,f7-9,28-2,b5-221,56,48,3-,2-,3-,5,d,2,5,3,42,5-,9,8,1d,5,6,2-2,8,153-3,123-3,33-27fd,a6da-5128,21f-5df,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3,2-1d,61-ff7d"),
              M = "ad,34f,1806,180b,180c,180d,200b,200c,200d,2060,feff".split(",").map(function (t) {
            return parseInt(t, 16);
          }),
              S = [{
            h: 25,
            s: 32,
            l: 65
          }, {
            h: 30,
            s: 32,
            e: [23],
            l: 127
          }, {
            h: 54,
            s: 1,
            e: [48],
            l: 64,
            d: 2
          }, {
            h: 14,
            s: 1,
            l: 57,
            d: 2
          }, {
            h: 44,
            s: 1,
            l: 17,
            d: 2
          }, {
            h: 10,
            s: 1,
            e: [2, 6, 8],
            l: 61,
            d: 2
          }, {
            h: 16,
            s: 1,
            l: 68,
            d: 2
          }, {
            h: 84,
            s: 1,
            e: [18, 24, 66],
            l: 19,
            d: 2
          }, {
            h: 26,
            s: 32,
            e: [17],
            l: 435
          }, {
            h: 22,
            s: 1,
            l: 71,
            d: 2
          }, {
            h: 15,
            s: 80,
            l: 40
          }, {
            h: 31,
            s: 32,
            l: 16
          }, {
            h: 32,
            s: 1,
            l: 80,
            d: 2
          }, {
            h: 52,
            s: 1,
            l: 42,
            d: 2
          }, {
            h: 12,
            s: 1,
            l: 55,
            d: 2
          }, {
            h: 40,
            s: 1,
            e: [38],
            l: 15,
            d: 2
          }, {
            h: 14,
            s: 1,
            l: 48,
            d: 2
          }, {
            h: 37,
            s: 48,
            l: 49
          }, {
            h: 148,
            s: 1,
            l: 6351,
            d: 2
          }, {
            h: 88,
            s: 1,
            l: 160,
            d: 2
          }, {
            h: 15,
            s: 16,
            l: 704
          }, {
            h: 25,
            s: 26,
            l: 854
          }, {
            h: 25,
            s: 32,
            l: 55915
          }, {
            h: 37,
            s: 40,
            l: 1247
          }, {
            h: 25,
            s: -119711,
            l: 53248
          }, {
            h: 25,
            s: -119763,
            l: 52
          }, {
            h: 25,
            s: -119815,
            l: 52
          }, {
            h: 25,
            s: -119867,
            e: [1, 4, 5, 7, 8, 11, 12, 17],
            l: 52
          }, {
            h: 25,
            s: -119919,
            l: 52
          }, {
            h: 24,
            s: -119971,
            e: [2, 7, 8, 17],
            l: 52
          }, {
            h: 24,
            s: -120023,
            e: [2, 7, 13, 15, 16, 17],
            l: 52
          }, {
            h: 25,
            s: -120075,
            l: 52
          }, {
            h: 25,
            s: -120127,
            l: 52
          }, {
            h: 25,
            s: -120179,
            l: 52
          }, {
            h: 25,
            s: -120231,
            l: 52
          }, {
            h: 25,
            s: -120283,
            l: 52
          }, {
            h: 25,
            s: -120335,
            l: 52
          }, {
            h: 24,
            s: -119543,
            e: [17],
            l: 56
          }, {
            h: 24,
            s: -119601,
            e: [17],
            l: 58
          }, {
            h: 24,
            s: -119659,
            e: [17],
            l: 58
          }, {
            h: 24,
            s: -119717,
            e: [17],
            l: 58
          }, {
            h: 24,
            s: -119775,
            e: [17],
            l: 58
          }],
              A = y("b5:3bc,c3:ff,7:73,2:253,5:254,3:256,1:257,5:259,1:25b,3:260,1:263,2:269,1:268,5:26f,1:272,2:275,7:280,3:283,5:288,3:28a,1:28b,5:292,3f:195,1:1bf,29:19e,125:3b9,8b:3b2,1:3b8,1:3c5,3:3c6,1:3c0,1a:3ba,1:3c1,1:3c3,2:3b8,1:3b5,1bc9:3b9,1c:1f76,1:1f77,f:1f7a,1:1f7b,d:1f78,1:1f79,1:1f7c,1:1f7d,107:63,5:25b,4:68,1:68,1:68,3:69,1:69,1:6c,3:6e,4:70,1:71,1:72,1:72,1:72,7:7a,2:3c9,2:7a,2:6b,1:e5,1:62,1:63,3:65,1:66,2:6d,b:3b3,1:3c0,6:64,1b574:3b8,1a:3c3,20:3b8,1a:3c3,20:3b8,1a:3c3,20:3b8,1a:3c3,20:3b8,1a:3c3"),
              x = y("179:1,2:1,2:1,5:1,2:1,a:4f,a:1,8:1,2:1,2:1,3:1,5:1,3:1,4:1,2:1,3:1,4:1,8:2,1:1,2:2,1:1,2:2,27:2,195:26,2:25,1:25,1:25,2:40,2:3f,1:3f,33:1,11:-6,1:-9,1ac7:-3a,6d:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,b:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,c:-8,2:-8,2:-8,2:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,49:-8,1:-8,1:-4a,1:-4a,d:-56,1:-56,1:-56,1:-56,d:-8,1:-8,f:-8,1:-8,3:-7"),
              R = y("df:00730073,51:00690307,19:02BC006E,a7:006A030C,18a:002003B9,16:03B903080301,20:03C503080301,1d7:05650582,190f:00680331,1:00740308,1:0077030A,1:0079030A,1:006102BE,b6:03C50313,2:03C503130300,2:03C503130301,2:03C503130342,2a:1F0003B9,1:1F0103B9,1:1F0203B9,1:1F0303B9,1:1F0403B9,1:1F0503B9,1:1F0603B9,1:1F0703B9,1:1F0003B9,1:1F0103B9,1:1F0203B9,1:1F0303B9,1:1F0403B9,1:1F0503B9,1:1F0603B9,1:1F0703B9,1:1F2003B9,1:1F2103B9,1:1F2203B9,1:1F2303B9,1:1F2403B9,1:1F2503B9,1:1F2603B9,1:1F2703B9,1:1F2003B9,1:1F2103B9,1:1F2203B9,1:1F2303B9,1:1F2403B9,1:1F2503B9,1:1F2603B9,1:1F2703B9,1:1F6003B9,1:1F6103B9,1:1F6203B9,1:1F6303B9,1:1F6403B9,1:1F6503B9,1:1F6603B9,1:1F6703B9,1:1F6003B9,1:1F6103B9,1:1F6203B9,1:1F6303B9,1:1F6403B9,1:1F6503B9,1:1F6603B9,1:1F6703B9,3:1F7003B9,1:03B103B9,1:03AC03B9,2:03B10342,1:03B1034203B9,5:03B103B9,6:1F7403B9,1:03B703B9,1:03AE03B9,2:03B70342,1:03B7034203B9,5:03B703B9,6:03B903080300,1:03B903080301,3:03B90342,1:03B903080342,b:03C503080300,1:03C503080301,1:03C10313,2:03C50342,1:03C503080342,b:1F7C03B9,1:03C903B9,1:03CE03B9,2:03C90342,1:03C9034203B9,5:03C903B9,ac:00720073,5b:00B00063,6:00B00066,d:006E006F,a:0073006D,1:00740065006C,1:0074006D,124f:006800700061,2:00610075,2:006F0076,b:00700061,1:006E0061,1:03BC0061,1:006D0061,1:006B0061,1:006B0062,1:006D0062,1:00670062,3:00700066,1:006E0066,1:03BC0066,4:0068007A,1:006B0068007A,1:006D0068007A,1:00670068007A,1:00740068007A,15:00700061,1:006B00700061,1:006D00700061,1:006700700061,8:00700076,1:006E0076,1:03BC0076,1:006D0076,1:006B0076,1:006D0076,1:00700077,1:006E0077,1:03BC0077,1:006D0077,1:006B0077,1:006D0077,1:006B03C9,1:006D03C9,2:00620071,3:00632215006B0067,1:0063006F002E,1:00640062,1:00670079,2:00680070,2:006B006B,1:006B006D,9:00700068,2:00700070006D,1:00700072,2:00730076,1:00770062,c723:00660066,1:00660069,1:0066006C,1:006600660069,1:00660066006C,1:00730074,1:00730074,d:05740576,1:05740565,1:0574056B,1:057E0576,1:0574056D", function (t) {
            if (t.length % 4 != 0) throw new Error("bad data");
            var e = [];

            for (var _r17 = 0; _r17 < t.length; _r17 += 4) {
              e.push(parseInt(t.substring(_r17, _r17 + 4), 16));
            }

            return e;
          }),
              T = _("80-20,2a0-,39c,32,f71,18e,7f2-f,19-7,30-4,7-5,f81-b,5,a800-20ff,4d1-1f,110,fa-6,d174-7,2e84-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,2,1f-5f,ff7f-20001");

          function k(t) {
            if (t.match(/^[a-z0-9-]*$/i) && t.length <= 59) return t.toLowerCase();
            var e = m(t);
            var r;
            r = e.map(function (t) {
              return M.indexOf(t) >= 0 ? [] : t >= 65024 && t <= 65039 ? [] : function (t) {
                var e = w(t, S);
                if (e) return [t + e.s];
                var r = A[t];
                if (r) return r;
                var n = x[t];
                return n ? [t + n[0]] : R[t] || null;
              }(t) || [t];
            }), e = r.reduce(function (t, e) {
              return e.forEach(function (e) {
                t.push(e);
              }), t;
            }, []), e = m(p(e), s.NFKC), e.forEach(function (t) {
              if (w(t, T)) throw new Error("STRINGPREP_CONTAINS_PROHIBITED");
            }), e.forEach(function (t) {
              if (w(t, E)) throw new Error("STRINGPREP_CONTAINS_UNASSIGNED");
            });
            var n = p(e);
            if ("-" === n.substring(0, 1) || "--" === n.substring(2, 4) || "-" === n.substring(n.length - 1)) throw new Error("invalid hyphen");
            if (n.length > 63) throw new Error("too long");
            return n;
          }

          r.d(e, "_toEscapedUtf8String", function () {
            return d;
          }), r.d(e, "toUtf8Bytes", function () {
            return h;
          }), r.d(e, "toUtf8CodePoints", function () {
            return m;
          }), r.d(e, "toUtf8String", function () {
            return g;
          }), r.d(e, "Utf8ErrorFuncs", function () {
            return f;
          }), r.d(e, "Utf8ErrorReason", function () {
            return a;
          }), r.d(e, "UnicodeNormalizationForm", function () {
            return s;
          }), r.d(e, "formatBytes32String", function () {
            return b;
          }), r.d(e, "parseBytes32String", function () {
            return v;
          }), r.d(e, "nameprep", function () {
            return k;
          });
        }, function (t, e, r) {
          "use strict";

          r.r(e);
          var n = r(3),
              i = r(0),
              o = r(2),
              s = r(5),
              a = r.n(s);

          function u(t) {
            return "0x" + a.a.keccak_256(Object(i.arrayify)(t));
          }

          function f(t) {
            var e = [];

            for (; t;) {
              e.unshift(255 & t), t >>= 8;
            }

            return e;
          }

          var c = r(1);
          r.d(e, "getAddress", function () {
            return b;
          }), r.d(e, "isAddress", function () {
            return v;
          }), r.d(e, "getIcapAddress", function () {
            return y;
          }), r.d(e, "getContractAddress", function () {
            return _;
          }), r.d(e, "getCreate2Address", function () {
            return w;
          });
          var h = new c.a("address/5.0.0-beta.134");

          function l(t) {
            Object(i.isHexString)(t, 20) || h.throwArgumentError("invalid address", "address", t);
            var e = (t = t.toLowerCase()).substring(2).split(""),
                r = new Uint8Array(40);

            for (var _t16 = 0; _t16 < 40; _t16++) {
              r[_t16] = e[_t16].charCodeAt(0);
            }

            var n = Object(i.arrayify)(u(r));

            for (var _t17 = 0; _t17 < 40; _t17 += 2) {
              n[_t17 >> 1] >> 4 >= 8 && (e[_t17] = e[_t17].toUpperCase()), (15 & n[_t17 >> 1]) >= 8 && (e[_t17 + 1] = e[_t17 + 1].toUpperCase());
            }

            return "0x" + e.join("");
          }

          var d = {};

          for (var _t18 = 0; _t18 < 10; _t18++) {
            d[String(_t18)] = String(_t18);
          }

          for (var _t19 = 0; _t19 < 26; _t19++) {
            d[String.fromCharCode(65 + _t19)] = String(10 + _t19);
          }

          var p = Math.floor((g = 9007199254740991, Math.log10 ? Math.log10(g) : Math.log(g) / Math.LN10));
          var g;

          function m(t) {
            var e = (t = (t = t.toUpperCase()).substring(4) + t.substring(0, 2) + "00").split("").map(function (t) {
              return d[t];
            }).join("");

            for (; e.length >= p;) {
              var _t20 = e.substring(0, p);

              e = parseInt(_t20, 10) % 97 + e.substring(_t20.length);
            }

            var r = String(98 - parseInt(e, 10) % 97);

            for (; r.length < 2;) {
              r = "0" + r;
            }

            return r;
          }

          function b(t) {
            var e = null;
            if ("string" != typeof t && h.throwArgumentError("invalid address", "address", t), t.match(/^(0x)?[0-9a-fA-F]{40}$/)) "0x" !== t.substring(0, 2) && (t = "0x" + t), e = l(t), t.match(/([A-F].*[a-f])|([a-f].*[A-F])/) && e !== t && h.throwArgumentError("bad address checksum", "address", t);else if (t.match(/^XE[0-9]{2}[0-9A-Za-z]{30,31}$/)) {
              for (t.substring(2, 4) !== m(t) && h.throwArgumentError("bad icap checksum", "address", t), e = new n.BN(t.substring(4), 36).toString(16); e.length < 40;) {
                e = "0" + e;
              }

              e = l("0x" + e);
            } else h.throwArgumentError("invalid address", "address", t);
            return e;
          }

          function v(t) {
            try {
              return b(t), !0;
            } catch (t) {}

            return !1;
          }

          function y(t) {
            var e = new n.BN(b(t).substring(2), 16).toString(36).toUpperCase();

            for (; e.length < 30;) {
              e = "0" + e;
            }

            return "XE" + m("XE00" + e) + e;
          }

          function _(t) {
            var e = null;

            try {
              e = b(t.from);
            } catch (e) {
              h.throwArgumentError("missing from address", "transaction", t);
            }

            var r = Object(i.stripZeros)(Object(i.arrayify)(o.a.from(t.nonce).toHexString()));
            return b(Object(i.hexDataSlice)(u(function (t) {
              return Object(i.hexlify)(function t(e) {
                if (Array.isArray(e)) {
                  var _r18 = [];
                  if (e.forEach(function (e) {
                    _r18 = _r18.concat(t(e));
                  }), _r18.length <= 55) return _r18.unshift(192 + _r18.length), _r18;

                  var _n23 = f(_r18.length);

                  return _n23.unshift(247 + _n23.length), _n23.concat(_r18);
                }

                var r = Array.prototype.slice.call(Object(i.arrayify)(e));
                if (1 === r.length && r[0] <= 127) return r;
                if (r.length <= 55) return r.unshift(128 + r.length), r;
                var n = f(r.length);
                return n.unshift(183 + n.length), n.concat(r);
              }(t));
            }([e, r])), 12));
          }

          function w(t, e, r) {
            return 32 !== Object(i.hexDataLength)(e) && h.throwArgumentError("salt must be 32 bytes", "salt", e), 32 !== Object(i.hexDataLength)(r) && h.throwArgumentError("initCodeHash must be 32 bytes", "initCodeHash", r), b(Object(i.hexDataSlice)(u(Object(i.concat)(["0xff", b(t), e, r])), 12));
          }
        }]);
      }, function (t, e, r) {
        "use strict";

        Object.defineProperty(e, "__esModule", {
          value: !0
        });

        var n = r(0),
            i = r(1),
            o = r(3),
            s = n.__importDefault(r(4)),
            a = n.__importDefault(r(5)),
            u = function () {
          function t(t, e, r, n, i) {
            if (this.cryptoLib = t, this.protocol = "wc", this.version = 1, this._bridge = "", this._key = null, this._nextKey = null, this._clientId = "", this._clientMeta = null, this._peerId = "", this._peerMeta = null, this._handshakeId = 0, this._handshakeTopic = "", this._accounts = [], this._chainId = 0, this._networkId = 0, this._rpcUrl = "", this._eventManager = new a.default(), this._connected = !1, this._storage = n || null, i && (this.clientMeta = i), !e.bridge && !e.uri && !e.session) throw new Error(o.ERROR_MISSING_REQUIRED);
            e.bridge && (this.bridge = e.bridge), e.uri && (this.uri = e.uri);
            var u = e.session || null;
            u || (u = this._getStorageSession()), u && (this.session = u), this.handshakeId && this._subscribeToSessionResponse(this.handshakeId, "Session request rejected"), this._transport = r || new s.default({
              bridge: this.bridge,
              clientId: this.clientId
            }), e.uri && this._subscribeToSessionRequest(), this._subscribeToInternalEvents(), this._transport.open();
          }

          return Object.defineProperty(t.prototype, "bridge", {
            get: function get() {
              return this._bridge;
            },
            set: function set(t) {
              t && (this._bridge = t);
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(t.prototype, "key", {
            get: function get() {
              return this._key ? i.convertArrayBufferToHex(this._key, !0) : "";
            },
            set: function set(t) {
              if (t) {
                var e = i.convertHexToArrayBuffer(t);
                this._key = e;
              }
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(t.prototype, "nextKey", {
            get: function get() {
              return this._nextKey ? i.convertArrayBufferToHex(this._nextKey) : "";
            },
            set: function set(t) {
              if (t) {
                var e = i.convertHexToArrayBuffer(t);
                this._nextKey = e;
              }
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(t.prototype, "clientId", {
            get: function get() {
              var t = this._clientId;
              return t || (t = this._clientId = i.uuid()), this._clientId;
            },
            set: function set(t) {
              t && (this._clientId = t);
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(t.prototype, "peerId", {
            get: function get() {
              return this._peerId;
            },
            set: function set(t) {
              t && (this._peerId = t);
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(t.prototype, "clientMeta", {
            get: function get() {
              var t = this._clientMeta;
              return t || (t = this._clientMeta = i.getMeta()), t;
            },
            set: function set(t) {},
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(t.prototype, "peerMeta", {
            get: function get() {
              return this._peerMeta;
            },
            set: function set(t) {
              this._peerMeta = t;
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(t.prototype, "handshakeTopic", {
            get: function get() {
              return this._handshakeTopic;
            },
            set: function set(t) {
              t && (this._handshakeTopic = t);
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(t.prototype, "handshakeId", {
            get: function get() {
              return this._handshakeId;
            },
            set: function set(t) {
              t && (this._handshakeId = t);
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(t.prototype, "uri", {
            get: function get() {
              return this._formatUri();
            },
            set: function set(t) {
              if (t) {
                var e = this._parseUri(t),
                    r = e.handshakeTopic,
                    n = e.bridge,
                    i = e.key;

                this.handshakeTopic = r, this.bridge = n, this.key = i;
              }
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(t.prototype, "chainId", {
            get: function get() {
              return this._chainId;
            },
            set: function set(t) {
              this._chainId = t;
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(t.prototype, "networkId", {
            get: function get() {
              return this._networkId;
            },
            set: function set(t) {
              this._networkId = t;
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(t.prototype, "accounts", {
            get: function get() {
              return this._accounts;
            },
            set: function set(t) {
              this._accounts = t;
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(t.prototype, "rpcUrl", {
            get: function get() {
              return this._rpcUrl;
            },
            set: function set(t) {
              this._rpcUrl = t;
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(t.prototype, "connected", {
            get: function get() {
              return this._connected;
            },
            set: function set(t) {},
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(t.prototype, "pending", {
            get: function get() {
              return !!this._handshakeTopic;
            },
            set: function set(t) {},
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(t.prototype, "session", {
            get: function get() {
              return {
                connected: this.connected,
                accounts: this.accounts,
                chainId: this.chainId,
                bridge: this.bridge,
                key: this.key,
                clientId: this.clientId,
                clientMeta: this.clientMeta,
                peerId: this.peerId,
                peerMeta: this.peerMeta,
                handshakeId: this.handshakeId,
                handshakeTopic: this.handshakeTopic
              };
            },
            set: function set(t) {
              t && (this._connected = t.connected, this.accounts = t.accounts, this.chainId = t.chainId, this.bridge = t.bridge, this.key = t.key, this.clientId = t.clientId, this.clientMeta = t.clientMeta, this.peerId = t.peerId, this.peerMeta = t.peerMeta, this.handshakeId = t.handshakeId, this.handshakeTopic = t.handshakeTopic);
            },
            enumerable: !0,
            configurable: !0
          }), t.prototype.on = function (t, e) {
            var r = {
              event: t,
              callback: e
            };

            this._eventManager.subscribe(r);
          }, t.prototype.createSession = function (t) {
            return n.__awaiter(this, void 0, void 0, function () {
              var e, r;
              return n.__generator(this, function (n) {
                switch (n.label) {
                  case 0:
                    if (this._connected) throw new Error(o.ERROR_SESSION_CONNECTED);
                    return this.pending ? [2] : (e = this, [4, this._generateKey()]);

                  case 1:
                    return e._key = n.sent(), r = this._formatRequest({
                      method: "wc_sessionRequest",
                      params: [{
                        peerId: this.clientId,
                        peerMeta: this.clientMeta,
                        chainId: t && t.chainId ? t.chainId : null
                      }]
                    }), this.handshakeId = r.id, this.handshakeTopic = i.uuid(), this._sendSessionRequest(r, "Session update rejected", {
                      topic: this.handshakeTopic
                    }), this._eventManager.trigger({
                      event: "display_uri",
                      params: [this.uri]
                    }), [2];
                }
              });
            });
          }, t.prototype.approveSession = function (t) {
            if (this._connected) throw new Error(o.ERROR_SESSION_CONNECTED);
            this.chainId = t.chainId, this.accounts = t.accounts, this.networkId = t.networkId || 0, this.rpcUrl = t.rpcUrl || "";
            var e = {
              approved: !0,
              chainId: this.chainId,
              networkId: this.networkId,
              accounts: this.accounts,
              rpcUrl: this.rpcUrl,
              peerId: this.clientId,
              peerMeta: this.clientMeta
            },
                r = {
              id: this.handshakeId,
              jsonrpc: "2.0",
              result: e
            };
            this._sendResponse(r), this._connected = !0, this._eventManager.trigger({
              event: "connect",
              params: [{
                peerId: this.peerId,
                peerMeta: this.peerMeta,
                chainId: this.chainId,
                accounts: this.accounts
              }]
            }), this._connected && this._setStorageSession();
          }, t.prototype.rejectSession = function (t) {
            if (this._connected) throw new Error(o.ERROR_SESSION_CONNECTED);

            var e = t && t.message ? t.message : o.ERROR_SESSION_REJECTED,
                r = this._formatResponse({
              id: this.handshakeId,
              error: {
                message: e
              }
            });

            this._sendResponse(r), this._connected = !1, this._eventManager.trigger({
              event: "disconnect",
              params: [{
                message: e
              }]
            }), this._removeStorageSession();
          }, t.prototype.updateSession = function (t) {
            if (!this._connected) throw new Error(o.ERROR_SESSION_DISCONNECTED);
            this.chainId = t.chainId, this.accounts = t.accounts, this.networkId = t.networkId || 0, this.rpcUrl = t.rpcUrl || "";

            var e = {
              approved: !0,
              chainId: this.chainId,
              networkId: this.networkId,
              accounts: this.accounts,
              rpcUrl: this.rpcUrl
            },
                r = this._formatRequest({
              method: "wc_sessionUpdate",
              params: [e]
            });

            this._sendSessionRequest(r, "Session update rejected"), this._eventManager.trigger({
              event: "session_update",
              params: [{
                chainId: this.chainId,
                accounts: this.accounts
              }]
            }), this._manageStorageSession();
          }, t.prototype.killSession = function (t) {
            return n.__awaiter(this, void 0, void 0, function () {
              var e, r, i;
              return n.__generator(this, function (n) {
                switch (n.label) {
                  case 0:
                    return e = t ? t.message : "Session Disconnected", r = {
                      approved: !1,
                      chainId: null,
                      networkId: null,
                      accounts: null
                    }, i = this._formatRequest({
                      method: "wc_sessionUpdate",
                      params: [r]
                    }), [4, this._sendRequest(i)];

                  case 1:
                    return n.sent(), this._handleSessionDisconnect(e), [2];
                }
              });
            });
          }, t.prototype.sendTransaction = function (t) {
            return n.__awaiter(this, void 0, void 0, function () {
              var e, r;
              return n.__generator(this, function (n) {
                switch (n.label) {
                  case 0:
                    if (!this._connected) throw new Error(o.ERROR_SESSION_DISCONNECTED);
                    e = i.parseTransactionData(t), r = this._formatRequest({
                      method: "eth_sendTransaction",
                      params: [e]
                    }), n.label = 1;

                  case 1:
                    return n.trys.push([1, 3,, 4]), [4, this._sendCallRequest(r)];

                  case 2:
                    return [2, n.sent()];

                  case 3:
                    throw n.sent();

                  case 4:
                    return [2];
                }
              });
            });
          }, t.prototype.signTransaction = function (t) {
            return n.__awaiter(this, void 0, void 0, function () {
              var e, r;
              return n.__generator(this, function (n) {
                switch (n.label) {
                  case 0:
                    if (!this._connected) throw new Error(o.ERROR_SESSION_DISCONNECTED);
                    e = i.parseTransactionData(t), r = this._formatRequest({
                      method: "eth_signTransaction",
                      params: [e]
                    }), n.label = 1;

                  case 1:
                    return n.trys.push([1, 3,, 4]), [4, this._sendCallRequest(r)];

                  case 2:
                    return [2, n.sent()];

                  case 3:
                    throw n.sent();

                  case 4:
                    return [2];
                }
              });
            });
          }, t.prototype.signMessage = function (t) {
            return n.__awaiter(this, void 0, void 0, function () {
              var e;
              return n.__generator(this, function (r) {
                switch (r.label) {
                  case 0:
                    if (!this._connected) throw new Error(o.ERROR_SESSION_DISCONNECTED);
                    e = this._formatRequest({
                      method: "eth_sign",
                      params: t
                    }), r.label = 1;

                  case 1:
                    return r.trys.push([1, 3,, 4]), [4, this._sendCallRequest(e)];

                  case 2:
                    return [2, r.sent()];

                  case 3:
                    throw r.sent();

                  case 4:
                    return [2];
                }
              });
            });
          }, t.prototype.signPersonalMessage = function (t) {
            return n.__awaiter(this, void 0, void 0, function () {
              var e;
              return n.__generator(this, function (r) {
                switch (r.label) {
                  case 0:
                    if (!this._connected) throw new Error(o.ERROR_SESSION_DISCONNECTED);
                    t = i.parsePersonalSign(t), e = this._formatRequest({
                      method: "personal_sign",
                      params: t
                    }), r.label = 1;

                  case 1:
                    return r.trys.push([1, 3,, 4]), [4, this._sendCallRequest(e)];

                  case 2:
                    return [2, r.sent()];

                  case 3:
                    throw r.sent();

                  case 4:
                    return [2];
                }
              });
            });
          }, t.prototype.signTypedData = function (t) {
            return n.__awaiter(this, void 0, void 0, function () {
              var e;
              return n.__generator(this, function (r) {
                switch (r.label) {
                  case 0:
                    if (!this._connected) throw new Error(o.ERROR_SESSION_DISCONNECTED);
                    e = this._formatRequest({
                      method: "eth_signTypedData",
                      params: t
                    }), r.label = 1;

                  case 1:
                    return r.trys.push([1, 3,, 4]), [4, this._sendCallRequest(e)];

                  case 2:
                    return [2, r.sent()];

                  case 3:
                    throw r.sent();

                  case 4:
                    return [2];
                }
              });
            });
          }, t.prototype.updateChain = function (t) {
            return n.__awaiter(this, void 0, void 0, function () {
              var e;
              return n.__generator(this, function (r) {
                switch (r.label) {
                  case 0:
                    if (!this._connected) throw new Error("Session currently disconnected");
                    e = this._formatRequest({
                      method: "wallet_updateChain",
                      params: [t]
                    }), r.label = 1;

                  case 1:
                    return r.trys.push([1, 3,, 4]), [4, this._sendCallRequest(e)];

                  case 2:
                    return [2, r.sent()];

                  case 3:
                    throw r.sent();

                  case 4:
                    return [2];
                }
              });
            });
          }, t.prototype.unsafeSend = function (t, e) {
            var r = this;
            return this._sendRequest(t, e), new Promise(function (e, n) {
              r._subscribeToResponse(t.id, function (t, r) {
                if (t) n(t);else {
                  if (!r) throw new Error(o.ERROR_MISSING_JSON_RPC);
                  e(r);
                }
              });
            });
          }, t.prototype.sendCustomRequest = function (t, e) {
            return n.__awaiter(this, void 0, void 0, function () {
              var r;
              return n.__generator(this, function (n) {
                switch (n.label) {
                  case 0:
                    if (!this._connected) throw new Error(o.ERROR_SESSION_DISCONNECTED);

                    switch (t.method) {
                      case "eth_accounts":
                        return [2, this.accounts];

                      case "eth_chainId":
                        return [2, i.convertNumberToHex(this.chainId)];

                      case "eth_sendTransaction":
                      case "eth_signTransaction":
                        t.params && (t.params[0] = i.parseTransactionData(t.params[0]));
                        break;

                      case "personal_sign":
                        t.params && (t.params = i.parsePersonalSign(t.params));
                    }

                    r = this._formatRequest(t), n.label = 1;

                  case 1:
                    return n.trys.push([1, 3,, 4]), [4, this._sendCallRequest(r, e)];

                  case 2:
                    return [2, n.sent()];

                  case 3:
                    throw n.sent();

                  case 4:
                    return [2];
                }
              });
            });
          }, t.prototype.approveRequest = function (t) {
            if (!i.isJsonRpcResponseSuccess(t)) throw new Error(o.ERROR_MISSING_RESULT);

            var e = this._formatResponse(t);

            this._sendResponse(e);
          }, t.prototype.rejectRequest = function (t) {
            if (!i.isJsonRpcResponseError(t)) throw new Error(o.ERROR_MISSING_ERROR);

            var e = this._formatResponse(t);

            this._sendResponse(e);
          }, t.prototype._sendRequest = function (t, e) {
            var r, o;
            return n.__awaiter(this, void 0, void 0, function () {
              var s, a, u, f, c, h;
              return n.__generator(this, function (n) {
                switch (n.label) {
                  case 0:
                    return s = this._formatRequest(t), [4, this._encrypt(s)];

                  case 1:
                    return a = n.sent(), u = void 0 !== (null === (r = e) || void 0 === r ? void 0 : r.topic) ? e.topic : this.peerId, f = JSON.stringify(a), c = void 0 !== (null === (o = e) || void 0 === o ? void 0 : o.forcePushNotification) ? !e.forcePushNotification : i.isSilentPayload(s), h = {
                      topic: u,
                      type: "pub",
                      payload: f,
                      silent: c
                    }, this._transport.send(h), [2];
                }
              });
            });
          }, t.prototype._sendResponse = function (t) {
            return n.__awaiter(this, void 0, void 0, function () {
              var e, r, i, o;
              return n.__generator(this, function (n) {
                switch (n.label) {
                  case 0:
                    return [4, this._encrypt(t)];

                  case 1:
                    return e = n.sent(), r = this.peerId, i = JSON.stringify(e), o = {
                      topic: r,
                      type: "pub",
                      payload: i,
                      silent: !0
                    }, this._transport.send(o), [2];
                }
              });
            });
          }, t.prototype._sendSessionRequest = function (t, e, r) {
            return n.__awaiter(this, void 0, void 0, function () {
              return n.__generator(this, function (n) {
                return this._sendRequest(t, r), this._subscribeToSessionResponse(t.id, e), [2];
              });
            });
          }, t.prototype._sendCallRequest = function (t, e) {
            return this._sendRequest(t, e), this._subscribeToCallResponse(t.id);
          }, t.prototype._formatRequest = function (t) {
            if (void 0 === t.method) throw new Error(o.ERROR_MISSING_METHOD);
            return {
              id: void 0 === t.id ? i.payloadId() : t.id,
              jsonrpc: "2.0",
              method: t.method,
              params: void 0 === t.params ? [] : t.params
            };
          }, t.prototype._formatResponse = function (t) {
            if (void 0 === t.id) throw new Error(o.ERROR_MISSING_ID);

            if (i.isJsonRpcResponseError(t)) {
              var e = i.formatRpcError(t.error);
              return n.__assign(n.__assign({
                id: t.id,
                jsonrpc: "2.0"
              }, t), {
                error: e
              });
            }

            if (i.isJsonRpcResponseSuccess(t)) return n.__assign({
              id: t.id,
              jsonrpc: "2.0"
            }, t);
            throw new Error(o.ERROR_INVALID_RESPONSE);
          }, t.prototype._handleSessionDisconnect = function (t) {
            var e = t || "Session Disconnected";
            this._connected && (this._connected = !1), this._eventManager.trigger({
              event: "disconnect",
              params: [{
                message: e
              }]
            }), this._removeStorageSession(), this._transport.close();
          }, t.prototype._handleSessionResponse = function (t, e) {
            e && e.approved ? (this._connected ? (e.chainId && (this.chainId = e.chainId), e.accounts && (this.accounts = e.accounts), this._eventManager.trigger({
              event: "session_update",
              params: [{
                chainId: this.chainId,
                accounts: this.accounts
              }]
            })) : (this._connected = !0, e.chainId && (this.chainId = e.chainId), e.accounts && (this.accounts = e.accounts), e.peerId && !this.peerId && (this.peerId = e.peerId), e.peerMeta && !this.peerMeta && (this.peerMeta = e.peerMeta), this._eventManager.trigger({
              event: "connect",
              params: [{
                peerId: this.peerId,
                peerMeta: this.peerMeta,
                chainId: this.chainId,
                accounts: this.accounts
              }]
            })), this._manageStorageSession()) : this._handleSessionDisconnect(t);
          }, t.prototype._handleIncomingMessages = function (t) {
            return n.__awaiter(this, void 0, void 0, function () {
              var e, r;
              return n.__generator(this, function (n) {
                switch (n.label) {
                  case 0:
                    if (![this.clientId, this.handshakeTopic].includes(t.topic)) return [2];

                    try {
                      e = JSON.parse(t.payload);
                    } catch (t) {
                      return [2];
                    }

                    return [4, this._decrypt(e)];

                  case 1:
                    return (r = n.sent()) && this._eventManager.trigger(r), [2];
                }
              });
            });
          }, t.prototype._subscribeToSessionRequest = function () {
            this._transport.send({
              topic: "" + this.handshakeTopic,
              type: "sub",
              payload: "",
              silent: !0
            });
          }, t.prototype._subscribeToResponse = function (t, e) {
            this.on("response:" + t, e);
          }, t.prototype._subscribeToSessionResponse = function (t, e) {
            var r = this;

            this._subscribeToResponse(t, function (t, n) {
              t ? r._handleSessionResponse(t.message) : n.result ? r._handleSessionResponse(e, n.result) : n.error && n.error.message ? r._handleSessionResponse(n.error.message) : r._handleSessionResponse(e);
            });
          }, t.prototype._subscribeToCallResponse = function (t) {
            var e = this;
            return new Promise(function (r, n) {
              e._subscribeToResponse(t, function (t, e) {
                t ? n(t) : e.result ? r(e.result) : e.error && e.error.message ? n(new Error(e.error.message)) : n(new Error(o.ERROR_INVALID_RESPONSE));
              });
            });
          }, t.prototype._subscribeToInternalEvents = function () {
            var t = this;
            this._transport.on("message", function (e) {
              return t._handleIncomingMessages(e);
            }), this._transport.on("open", function () {
              return t._eventManager.trigger({
                event: "transport_open",
                params: []
              });
            }), this._transport.on("close", function () {
              return t._eventManager.trigger({
                event: "transport_close",
                params: []
              });
            }), this.on("wc_sessionRequest", function (e, r) {
              e && t._eventManager.trigger({
                event: "error",
                params: [{
                  code: "SESSION_REQUEST_ERROR",
                  message: e.toString()
                }]
              }), t.handshakeId = r.id, t.peerId = r.params[0].peerId, t.peerMeta = r.params[0].peerMeta;

              var i = n.__assign(n.__assign({}, r), {
                method: "session_request"
              });

              t._eventManager.trigger(i);
            }), this.on("wc_sessionUpdate", function (e, r) {
              e && t._handleSessionResponse(e.message), t._handleSessionResponse("Session disconnected", r.params[0]);
            });
          }, t.prototype._formatUri = function () {
            return this.protocol + ":" + this.handshakeTopic + "@" + this.version + "?bridge=" + encodeURIComponent(this.bridge) + "&key=" + this.key;
          }, t.prototype._parseUri = function (t) {
            var e = i.parseWalletConnectUri(t);

            if (e.protocol === this.protocol) {
              if (!e.handshakeTopic) throw Error("Invalid or missing handshakeTopic parameter value");
              var r = e.handshakeTopic;
              if (!e.bridge) throw Error("Invalid or missing bridge url parameter value");
              var n = decodeURIComponent(e.bridge);
              if (!e.key) throw Error("Invalid or missing kkey parameter value");
              return {
                handshakeTopic: r,
                bridge: n,
                key: e.key
              };
            }

            throw new Error(o.ERROR_INVALID_URI);
          }, t.prototype._generateKey = function () {
            return n.__awaiter(this, void 0, void 0, function () {
              return n.__generator(this, function (t) {
                switch (t.label) {
                  case 0:
                    return this.cryptoLib ? [4, this.cryptoLib.generateKey()] : [3, 2];

                  case 1:
                    return [2, t.sent()];

                  case 2:
                    return [2, null];
                }
              });
            });
          }, t.prototype._encrypt = function (t) {
            return n.__awaiter(this, void 0, void 0, function () {
              var e;
              return n.__generator(this, function (r) {
                switch (r.label) {
                  case 0:
                    return e = this._key, this.cryptoLib && e ? [4, this.cryptoLib.encrypt(t, e)] : [3, 2];

                  case 1:
                    return [2, r.sent()];

                  case 2:
                    return [2, null];
                }
              });
            });
          }, t.prototype._decrypt = function (t) {
            return n.__awaiter(this, void 0, void 0, function () {
              var e;
              return n.__generator(this, function (r) {
                switch (r.label) {
                  case 0:
                    return e = this._key, this.cryptoLib && e ? [4, this.cryptoLib.decrypt(t, e)] : [3, 2];

                  case 1:
                    return [2, r.sent()];

                  case 2:
                    return [2, null];
                }
              });
            });
          }, t.prototype._getStorageSession = function () {
            var t = null;
            return this._storage && (t = this._storage.getSession()), t;
          }, t.prototype._setStorageSession = function () {
            this._storage && this._storage.setSession(this.session);
          }, t.prototype._removeStorageSession = function () {
            this._storage && this._storage.removeSession();
          }, t.prototype._manageStorageSession = function () {
            this._connected ? this._setStorageSession() : this._removeStorageSession();
          }, t;
        }();

        e.default = u;
      }, function (t, e, r) {
        "use strict";

        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ERROR_SESSION_CONNECTED = "Session currently connected", e.ERROR_SESSION_DISCONNECTED = "Session currently disconnected", e.ERROR_SESSION_REJECTED = "Session Rejected", e.ERROR_MISSING_JSON_RPC = "Missing JSON RPC response", e.ERROR_MISSING_RESULT = 'JSON-RPC success response must include "result" field', e.ERROR_MISSING_ERROR = 'JSON-RPC error response must include "error" field', e.ERROR_MISSING_METHOD = 'JSON RPC request must have valid "method" value', e.ERROR_MISSING_ID = 'JSON RPC request must have valid "id" value', e.ERROR_MISSING_REQUIRED = "Missing one of the required parameters: bridge / uri / session", e.ERROR_INVALID_RESPONSE = "JSON RPC response format is invalid", e.ERROR_INVALID_URI = "URI format is invalid";
      }, function (t, e, r) {
        "use strict";

        Object.defineProperty(e, "__esModule", {
          value: !0
        });

        var n = r(0),
            i = function () {
          function t(t) {
            if (this._events = [], this._initiating = !1, this._bridge = "", this._socket = null, this._queue = [], !t.bridge || "string" != typeof t.bridge) throw new Error("Missing or invalid bridge field");
            if (this._bridge = t.bridge, !t.clientId || "string" != typeof t.clientId) throw new Error("Missing or invalid clientId field");
            this._clientId = t.clientId;
          }

          return Object.defineProperty(t.prototype, "readyState", {
            get: function get() {
              return this._socket ? this._socket.readyState : -1;
            },
            set: function set(t) {},
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(t.prototype, "connecting", {
            get: function get() {
              return 0 === this.readyState;
            },
            set: function set(t) {},
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(t.prototype, "connected", {
            get: function get() {
              return 1 === this.readyState;
            },
            set: function set(t) {},
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(t.prototype, "closing", {
            get: function get() {
              return 2 === this.readyState;
            },
            set: function set(t) {},
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(t.prototype, "closed", {
            get: function get() {
              return 3 === this.readyState;
            },
            set: function set(t) {},
            enumerable: !0,
            configurable: !0
          }), t.prototype.open = function () {
            this._socketOpen();
          }, t.prototype.send = function (t) {
            this._socketSend(t);
          }, t.prototype.close = function () {
            this._socketClose();
          }, t.prototype.on = function (t, e) {
            this._events.push({
              event: t,
              callback: e
            });
          }, t.prototype._socketOpen = function (t) {
            var e = this;

            if ((void 0 === t || t) && !this._initiating) {
              this._initiating = !0;
              var r = this._bridge;

              this._setToQueue({
                topic: "" + this._clientId,
                type: "sub",
                payload: "",
                silent: !0
              });

              var n = r.startsWith("https") ? r.replace("https", "wss") : r.startsWith("http") ? r.replace("http", "ws") : r,
                  i = new WebSocket(n);
              i.onmessage = function (t) {
                return e._socketReceive(t);
              }, i.onopen = function () {
                e._trigger("open"), e._socketClose(), e._initiating = !1, e._socket = i, e._pushQueue();
              }, i.onclose = function () {
                e._trigger("close"), e._socketOpen(!0);
              };
            }
          }, t.prototype._socketClose = function () {
            this._socket && (this._socket.onclose = function () {}, this._socket.close());
          }, t.prototype._socketSend = function (t) {
            var e = JSON.stringify(t);
            this._socket && this.connected ? this._socket.send(e) : (this._setToQueue(t), this._socketOpen());
          }, t.prototype._socketReceive = function (t) {
            return n.__awaiter(this, void 0, void 0, function () {
              var e;
              return n.__generator(this, function (r) {
                try {
                  e = JSON.parse(t.data);
                } catch (t) {
                  return [2];
                }

                return this.connected && this._trigger("message", e), [2];
              });
            });
          }, t.prototype._setToQueue = function (t) {
            this._queue.push(t);
          }, t.prototype._pushQueue = function () {
            var t = this;
            this._queue.forEach(function (e) {
              return t._socketSend(e);
            }), this._queue = [];
          }, t.prototype._trigger = function (t, e) {
            var r = this._events.filter(function (e) {
              return e.event === t;
            });

            r && r.length && r.forEach(function (t) {
              return t.callback(e);
            });
          }, t;
        }();

        e.default = i;
      }, function (t, e, r) {
        "use strict";

        Object.defineProperty(e, "__esModule", {
          value: !0
        });

        var n = r(1),
            i = function () {
          function t() {
            this._eventEmitters = [];
          }

          return t.prototype.subscribe = function (t) {
            this._eventEmitters.push(t);
          }, t.prototype.trigger = function (t) {
            var e,
                r = [];
            (e = n.isJsonRpcRequest(t) ? t.method : n.isJsonRpcResponseSuccess(t) || n.isJsonRpcResponseError(t) ? "response:" + t.id : n.isInternalEvent(t) ? t.event : "") && (r = this._eventEmitters.filter(function (t) {
              return t.event === e;
            })), r && r.length || n.isReservedEvent(e) || n.isInternalEvent(e) || (r = this._eventEmitters.filter(function (t) {
              return "call_request" === t.event;
            })), r.forEach(function (e) {
              if (n.isJsonRpcResponseError(t)) {
                var r = new Error(t.error.message);
                e.callback(r, null);
              } else e.callback(null, t);
            });
          }, t;
        }();

        e.default = i;
      }]);
    }, function (t, e, r) {
      "use strict";

      Object.defineProperty(e, "__esModule", {
        value: !0
      });
      var n = r(0),
          i = r(1);

      function o(t) {
        return n.__awaiter(this, void 0, void 0, function () {
          return n.__generator(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, window.crypto.subtle.exportKey("raw", t)];

              case 1:
                return [2, e.sent()];
            }
          });
        });
      }

      function s(t, e) {
        return void 0 === e && (e = "AES-CBC"), n.__awaiter(this, void 0, void 0, function () {
          var r, i;
          return n.__generator(this, function (n) {
            switch (n.label) {
              case 0:
                return r = "AES-CBC" === e ? {
                  length: 256,
                  name: "AES-CBC"
                } : {
                  hash: {
                    name: "SHA-256"
                  },
                  name: "HMAC"
                }, i = "AES-CBC" === e ? ["encrypt", "decrypt"] : ["sign", "verify"], [4, window.crypto.subtle.importKey("raw", t, r, !0, i)];

              case 1:
                return [2, n.sent()];
            }
          });
        });
      }

      function a(t) {
        return n.__awaiter(this, void 0, void 0, function () {
          var e;
          return n.__generator(this, function (r) {
            switch (r.label) {
              case 0:
                return e = t || 256, [4, window.crypto.subtle.generateKey({
                  length: e,
                  name: "AES-CBC"
                }, !0, ["encrypt", "decrypt"])];

              case 1:
                return [4, o(r.sent())];

              case 2:
                return [2, r.sent()];
            }
          });
        });
      }

      function u(t, e) {
        return n.__awaiter(this, void 0, void 0, function () {
          var r;
          return n.__generator(this, function (n) {
            switch (n.label) {
              case 0:
                return [4, s(e, "HMAC")];

              case 1:
                return r = n.sent(), [4, window.crypto.subtle.sign({
                  length: 256,
                  name: "HMAC"
                }, r, t)];

              case 2:
                return [2, n.sent()];
            }
          });
        });
      }

      function f(t, e) {
        return n.__awaiter(this, void 0, void 0, function () {
          var r, o, s, a, f, c;
          return n.__generator(this, function (n) {
            switch (n.label) {
              case 0:
                return r = i.convertHexToArrayBuffer(t.data), o = i.convertHexToArrayBuffer(t.iv), s = i.convertHexToArrayBuffer(t.hmac), a = i.convertArrayBufferToHex(s, !0), [4, u(i.concatArrayBuffers(r, o), e)];

              case 1:
                return f = n.sent(), c = i.convertArrayBufferToHex(f, !0), i.removeHexPrefix(a) === i.removeHexPrefix(c) ? [2, !0] : [2, !1];
            }
          });
        });
      }

      function c(t, e, r) {
        return n.__awaiter(this, void 0, void 0, function () {
          var i;
          return n.__generator(this, function (n) {
            switch (n.label) {
              case 0:
                return [4, s(e, "AES-CBC")];

              case 1:
                return i = n.sent(), [4, window.crypto.subtle.encrypt({
                  iv: r,
                  name: "AES-CBC"
                }, i, t)];

              case 2:
                return [2, n.sent()];
            }
          });
        });
      }

      function h(t, e, r) {
        return n.__awaiter(this, void 0, void 0, function () {
          var i;
          return n.__generator(this, function (n) {
            switch (n.label) {
              case 0:
                return [4, s(e, "AES-CBC")];

              case 1:
                return i = n.sent(), [4, window.crypto.subtle.decrypt({
                  iv: r,
                  name: "AES-CBC"
                }, i, t)];

              case 2:
                return [2, n.sent()];
            }
          });
        });
      }

      e.exportKey = o, e.importKey = s, e.generateKey = a, e.createHmac = u, e.verifyHmac = f, e.aesCbcEncrypt = c, e.aesCbcDecrypt = h, e.encrypt = function (t, e) {
        return n.__awaiter(this, void 0, void 0, function () {
          var r, o, s, f, h, l, d;
          return n.__generator(this, function (n) {
            switch (n.label) {
              case 0:
                if (!e) throw new Error("Missing key: required for encryption");
                return [4, a(128)];

              case 1:
                return r = n.sent(), o = i.convertArrayBufferToHex(r, !0), s = JSON.stringify(t), [4, c(i.convertUtf8ToArrayBuffer(s), e, r)];

              case 2:
                return f = n.sent(), h = i.convertArrayBufferToHex(f, !0), [4, u(i.concatArrayBuffers(f, r), e)];

              case 3:
                return l = n.sent(), d = i.convertArrayBufferToHex(l, !0), [2, {
                  data: h,
                  hmac: d,
                  iv: o
                }];
            }
          });
        });
      }, e.decrypt = function (t, e) {
        return n.__awaiter(this, void 0, void 0, function () {
          var r, o, s, a, u;
          return n.__generator(this, function (n) {
            switch (n.label) {
              case 0:
                if (!e) throw new Error("Missing key: required for decryption");
                return [4, f(t, e)];

              case 1:
                return n.sent() ? (r = i.convertHexToArrayBuffer(t.data), o = i.convertHexToArrayBuffer(t.iv), [4, h(r, e, o)]) : [2, null];

              case 2:
                s = n.sent(), a = i.convertArrayBufferToUtf8(s);

                try {
                  u = JSON.parse(a);
                } catch (t) {
                  return [2, null];
                }

                return [2, u];
            }
          });
        });
      };
    }, function (t, e, r) {
      "use strict";

      Object.defineProperty(e, "__esModule", {
        value: !0
      });
      var n = r(1),
          i = null;
      "undefined" != typeof window && void 0 !== window.localStorage && (i = window.localStorage), e.default = {
        getSession: function getSession() {
          var t = null,
              e = null;
          if (i && (e = i.getItem("walletconnect")), e && "string" == typeof e) try {
            var r = JSON.parse(e);
            n.isWalletConnectSession(r) && (t = r);
          } catch (t) {
            return null;
          }
          return t;
        },
        setSession: function setSession(t) {
          var e = JSON.stringify(t);
          return i && i.setItem("walletconnect", e), t;
        },
        removeSession: function removeSession() {
          i && i.removeItem("walletconnect");
        }
      };
    }]);
  }, function (t, e, r) {
    var n = r(8).EventEmitter,
        i = r(9).inherits,
        o = r(16),
        s = r(155),
        a = r(158),
        u = r(186),
        f = r(189),
        c = (r(82), r(44)),
        h = function h() {};

    function l(t) {
      n.call(this), this.setMaxListeners(30), t = t || {};
      var e = {
        sendAsync: this._handleAsync.bind(this)
      },
          r = t.blockTrackerProvider || e;
      this._blockTracker = t.blockTracker || new s({
        provider: r,
        pollingInterval: t.pollingInterval || 4e3,
        setSkipCacheFlag: !0
      }), this._ready = new f(), this.currentBlock = null, this._providers = [];
    }

    t.exports = l, i(l, n), l.prototype.start = function () {
      var _this5 = this;

      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : h;
      var e = this;
      e._ready.go(), e._blockTracker.on("latest", function (t) {
        e._getBlockByNumber(t, function (t, r) {
          if (t) return void _this5.emit("error", t);
          if (!r) return void _this5.emit("error", new Error("Could not find block"));
          var n = (i = r, {
            number: o.toBuffer(i.number),
            hash: o.toBuffer(i.hash),
            parentHash: o.toBuffer(i.parentHash),
            nonce: o.toBuffer(i.nonce),
            mixHash: o.toBuffer(i.mixHash),
            sha3Uncles: o.toBuffer(i.sha3Uncles),
            logsBloom: o.toBuffer(i.logsBloom),
            transactionsRoot: o.toBuffer(i.transactionsRoot),
            stateRoot: o.toBuffer(i.stateRoot),
            receiptsRoot: o.toBuffer(i.receiptRoot || i.receiptsRoot),
            miner: o.toBuffer(i.miner),
            difficulty: o.toBuffer(i.difficulty),
            totalDifficulty: o.toBuffer(i.totalDifficulty),
            size: o.toBuffer(i.size),
            extraData: o.toBuffer(i.extraData),
            gasLimit: o.toBuffer(i.gasLimit),
            gasUsed: o.toBuffer(i.gasUsed),
            timestamp: o.toBuffer(i.timestamp),
            transactions: i.transactions
          });
          var i;
          e._setCurrentBlock(n), e.emit("rawBlock", r), e.emit("latest", r);
        });
      }), e._blockTracker.on("sync", e.emit.bind(e, "sync")), e._blockTracker.on("error", e.emit.bind(e, "error")), e._running = !0, e.emit("start");
    }, l.prototype.stop = function () {
      this._blockTracker.removeAllListeners(), this._running = !1, this.emit("stop");
    }, l.prototype.isRunning = function () {
      return this._running;
    }, l.prototype.addProvider = function (t, e) {
      var r = this;
      "number" == typeof e ? r._providers.splice(e, 0, t) : r._providers.push(t), t.setEngine(this);
    }, l.prototype.removeProvider = function (t) {
      var e = this._providers.indexOf(t);

      if (e < 0) throw new Error("Provider not found.");

      this._providers.splice(e, 1);
    }, l.prototype.send = function (t) {
      throw new Error("Web3ProviderEngine does not support synchronous requests.");
    }, l.prototype.sendAsync = function (t, e) {
      var r = this;

      r._ready.await(function () {
        Array.isArray(t) ? a(t, r._handleAsync.bind(r), e) : r._handleAsync(t, e);
      });
    }, l.prototype._getBlockByNumber = function (t, e) {
      var r = c({
        method: "eth_getBlockByNumber",
        params: [t, !1],
        skipCache: !0
      });

      this._handleAsync(r, function (t, r) {
        return t ? e(t) : e(null, r.result);
      });
    }, l.prototype._handleAsync = function (t, e) {
      var r = this,
          n = -1,
          i = null,
          o = null,
          s = [];

      function a(r, n) {
        o = r, i = n, u(s, function (t, e) {
          t ? t(o, i, e) : e();
        }, function () {
          var r = {
            id: t.id,
            jsonrpc: t.jsonrpc,
            result: i
          };
          null != o ? (r.error = {
            message: o.stack || o.message || o,
            code: -32e3
          }, e(o, r)) : e(null, r);
        });
      }

      !function e(i) {
        if (n += 1, s.unshift(i), n >= r._providers.length) a(new Error('Request for method "' + t.method + '" not handled by any subprovider. Please check your subprovider configuration to ensure this method is handled.'));else try {
          r._providers[n].handleRequest(t, e, a);
        } catch (t) {
          a(t);
        }
      }();
    }, l.prototype._setCurrentBlock = function (t) {
      this.currentBlock = t, this.emit("block", t);
    };
  }, function (t, e, r) {
    var n = r(45),
        i = r(194);

    t.exports =
    /*#__PURE__*/
    function (_n24) {
      "use strict";

      _inherits(_class3, _n24);

      function _class3(t) {
        _classCallCheck(this, _class3);

        return _possibleConstructorReturn(this, _getPrototypeOf(_class3).call(this, function (_ref15) {
          var e = _ref15.blockTracker;
          return i(Object.assign({
            blockTracker: e
          }, t));
        }));
      }

      return _class3;
    }(n);
  }, function (t, e, r) {
    var n = r(9).inherits,
        i = r(32);

    function o(t) {
      t = t || {}, this.staticResponses = t;
    }

    t.exports = o, n(o, i), o.prototype.handleRequest = function (t, e, r) {
      var n = this.staticResponses[t.method];
      "function" == typeof n ? n(t, e, r) : void 0 !== n ? setTimeout(function () {
        return r(null, n);
      }) : e();
    };
  }, function (t, e, r) {
    var n = r(45),
        i = r(84);

    t.exports =
    /*#__PURE__*/
    function (_n25) {
      "use strict";

      _inherits(_class4, _n25);

      function _class4() {
        _classCallCheck(this, _class4);

        return _possibleConstructorReturn(this, _getPrototypeOf(_class4).call(this, function (_ref16) {
          var t = _ref16.blockTracker,
              e = _ref16.provider,
              r = _ref16.engine;
          return i({
            blockTracker: t,
            provider: e
          });
        }));
      }

      return _class4;
    }(n);
  }, function (t, e, r) {
    var n = r(207),
        i = r(208),
        o = r(9).inherits,
        s = r(16),
        a = r(210),
        u = r(29),
        f = r(224),
        c = r(32),
        h = r(225),
        l = /^[0-9A-Fa-f]+$/g;

    function d(t) {
      this.nonceLock = f(1), t.getAccounts && (this.getAccounts = t.getAccounts), t.processTransaction && (this.processTransaction = t.processTransaction), t.processSignTransaction && (this.processSignTransaction = t.processSignTransaction), t.processMessage && (this.processMessage = t.processMessage), t.processPersonalMessage && (this.processPersonalMessage = t.processPersonalMessage), t.processTypedMessage && (this.processTypedMessage = t.processTypedMessage), this.approveTransaction = t.approveTransaction || this.autoApprove, this.approveMessage = t.approveMessage || this.autoApprove, this.approvePersonalMessage = t.approvePersonalMessage || this.autoApprove, this.approveTypedMessage = t.approveTypedMessage || this.autoApprove, this.signTransaction = t.signTransaction || m("signTransaction"), this.signMessage = t.signMessage || m("signMessage"), this.signPersonalMessage = t.signPersonalMessage || m("signPersonalMessage"), this.signTypedMessage = t.signTypedMessage || m("signTypedMessage"), t.recoverPersonalSignature && (this.recoverPersonalSignature = t.recoverPersonalSignature), t.publishTransaction && (this.publishTransaction = t.publishTransaction), this.estimateGas = t.estimateGas || this.estimateGas, this.getGasPrice = t.getGasPrice || this.getGasPrice;
    }

    function p(t) {
      return t.toLowerCase();
    }

    function g(t) {
      return "string" == typeof t && "0x" === t.slice(0, 2) && t.slice(2).match(l);
    }

    function m(t) {
      return function (e, r) {
        r(new Error('ProviderEngine - HookedWalletSubprovider - Must provide "' + t + '" fn in constructor options'));
      };
    }

    t.exports = d, o(d, c), d.prototype.handleRequest = function (t, e, r) {
      var i = this;
      var o, a, f, c, h;

      switch (i._parityRequests = {}, i._parityRequestCount = 0, t.method) {
        case "eth_coinbase":
          return void i.getAccounts(function (t, e) {
            if (t) return r(t);
            var n = e[0] || null;
            r(null, n);
          });

        case "eth_accounts":
          return void i.getAccounts(function (t, e) {
            if (t) return r(t);
            r(null, e);
          });

        case "eth_sendTransaction":
          return o = t.params[0], void n([function (t) {
            return i.validateTransaction(o, t);
          }, function (t) {
            return i.processTransaction(o, t);
          }], r);

        case "eth_signTransaction":
          return o = t.params[0], void n([function (t) {
            return i.validateTransaction(o, t);
          }, function (t) {
            return i.processSignTransaction(o, t);
          }], r);

        case "eth_sign":
          return h = t.params[0], c = t.params[1], f = t.params[2] || {}, a = u(f, {
            from: h,
            data: c
          }), void n([function (t) {
            return i.validateMessage(a, t);
          }, function (t) {
            return i.processMessage(a, t);
          }], r);

        case "personal_sign":
          return function () {
            var e = t.params[0];

            if (function (t) {
              var e = s.addHexPrefix(t);
              return !s.isValidAddress(e) && g(t);
            }(t.params[1]) && function (t) {
              var e = s.addHexPrefix(t);
              return s.isValidAddress(e);
            }(e)) {
              var _e14 = "The eth_personalSign method requires params ordered ";
              _e14 += "[message, address]. This was previously handled incorrectly, ", _e14 += "and has been corrected automatically. ", _e14 += "Please switch this param order for smooth behavior in the future.", console.warn(_e14), h = t.params[0], c = t.params[1];
            } else c = t.params[0], h = t.params[1];

            f = t.params[2] || {}, a = u(f, {
              from: h,
              data: c
            }), n([function (t) {
              return i.validatePersonalMessage(a, t);
            }, function (t) {
              return i.processPersonalMessage(a, t);
            }], r);
          }();

        case "personal_ecRecover":
          return function () {
            c = t.params[0];
            var e = t.params[1];
            f = t.params[2] || {}, a = u(f, {
              sig: e,
              data: c
            }), i.recoverPersonalSignature(a, r);
          }();

        case "eth_signTypedData":
          return c = t.params[0], h = t.params[1], f = t.params[2] || {}, a = u(f, {
            from: h,
            data: c
          }), void n([function (t) {
            return i.validateTypedMessage(a, t);
          }, function (t) {
            return i.processTypedMessage(a, t);
          }], r);

        case "parity_postTransaction":
          return o = t.params[0], void i.parityPostTransaction(o, r);

        case "parity_postSign":
          return h = t.params[0], c = t.params[1], void i.parityPostSign(h, c, r);

        case "parity_checkRequest":
          return function () {
            var e = t.params[0];
            i.parityCheckRequest(e, r);
          }();

        case "parity_defaultAccount":
          return void i.getAccounts(function (t, e) {
            if (t) return r(t);
            var n = e[0] || null;
            r(null, n);
          });

        default:
          return void e();
      }
    }, d.prototype.getAccounts = function (t) {
      t(null, []);
    }, d.prototype.processTransaction = function (t, e) {
      var r = this;
      n([function (e) {
        return r.approveTransaction(t, e);
      }, function (t, e) {
        return r.checkApproval("transaction", t, e);
      }, function (e) {
        return r.finalizeAndSubmitTx(t, e);
      }], e);
    }, d.prototype.processSignTransaction = function (t, e) {
      var r = this;
      n([function (e) {
        return r.approveTransaction(t, e);
      }, function (t, e) {
        return r.checkApproval("transaction", t, e);
      }, function (e) {
        return r.finalizeTx(t, e);
      }], e);
    }, d.prototype.processMessage = function (t, e) {
      var r = this;
      n([function (e) {
        return r.approveMessage(t, e);
      }, function (t, e) {
        return r.checkApproval("message", t, e);
      }, function (e) {
        return r.signMessage(t, e);
      }], e);
    }, d.prototype.processPersonalMessage = function (t, e) {
      var r = this;
      n([function (e) {
        return r.approvePersonalMessage(t, e);
      }, function (t, e) {
        return r.checkApproval("message", t, e);
      }, function (e) {
        return r.signPersonalMessage(t, e);
      }], e);
    }, d.prototype.processTypedMessage = function (t, e) {
      var r = this;
      n([function (e) {
        return r.approveTypedMessage(t, e);
      }, function (t, e) {
        return r.checkApproval("message", t, e);
      }, function (e) {
        return r.signTypedMessage(t, e);
      }], e);
    }, d.prototype.autoApprove = function (t, e) {
      e(null, !0);
    }, d.prototype.checkApproval = function (t, e, r) {
      r(e ? null : new Error("User denied " + t + " signature."));
    }, d.prototype.parityPostTransaction = function (t, e) {
      var r = this,
          n = "0x".concat(r._parityRequestCount.toString(16));
      r._parityRequestCount++, r.emitPayload({
        method: "eth_sendTransaction",
        params: [t]
      }, function (t, e) {
        if (t) return void (r._parityRequests[n] = {
          error: t
        });
        var i = e.result;
        r._parityRequests[n] = i;
      }), e(null, n);
    }, d.prototype.parityPostSign = function (t, e, r) {
      var n = this,
          i = "0x".concat(n._parityRequestCount.toString(16));
      n._parityRequestCount++, n.emitPayload({
        method: "eth_sign",
        params: [t, e]
      }, function (t, e) {
        if (t) return void (n._parityRequests[i] = {
          error: t
        });
        var r = e.result;
        n._parityRequests[i] = r;
      }), r(null, i);
    }, d.prototype.parityCheckRequest = function (t, e) {
      var r = this._parityRequests[t] || null;
      return r ? r.error ? e(r.error) : void e(null, r) : e(null, null);
    }, d.prototype.recoverPersonalSignature = function (t, e) {
      var r;

      try {
        r = a.recoverPersonalSignature(t);
      } catch (t) {
        return e(t);
      }

      e(null, r);
    }, d.prototype.validateTransaction = function (t, e) {
      if (void 0 === t.from) return e(new Error("Undefined address - from address required to sign transaction."));
      this.validateSender(t.from, function (r, n) {
        return r ? e(r) : n ? void e() : e(new Error("Unknown address - unable to sign transaction for this address: \"".concat(t.from, "\"")));
      });
    }, d.prototype.validateMessage = function (t, e) {
      if (void 0 === t.from) return e(new Error("Undefined address - from address required to sign message."));
      this.validateSender(t.from, function (r, n) {
        return r ? e(r) : n ? void e() : e(new Error("Unknown address - unable to sign message for this address: \"".concat(t.from, "\"")));
      });
    }, d.prototype.validatePersonalMessage = function (t, e) {
      return void 0 === t.from ? e(new Error("Undefined address - from address required to sign personal message.")) : void 0 === t.data ? e(new Error("Undefined message - message required to sign personal message.")) : g(t.data) ? void this.validateSender(t.from, function (r, n) {
        return r ? e(r) : n ? void e() : e(new Error("Unknown address - unable to sign message for this address: \"".concat(t.from, "\"")));
      }) : e(new Error("HookedWalletSubprovider - validateMessage - message was not encoded as hex."));
    }, d.prototype.validateTypedMessage = function (t, e) {
      return void 0 === t.from ? e(new Error("Undefined address - from address required to sign typed data.")) : void 0 === t.data ? e(new Error("Undefined data - message required to sign typed data.")) : void this.validateSender(t.from, function (r, n) {
        return r ? e(r) : n ? void e() : e(new Error("Unknown address - unable to sign message for this address: \"".concat(t.from, "\"")));
      });
    }, d.prototype.validateSender = function (t, e) {
      if (!t) return e(null, !1);
      this.getAccounts(function (r, n) {
        if (r) return e(r);
        var i = -1 !== n.map(p).indexOf(t.toLowerCase());
        e(null, i);
      });
    }, d.prototype.finalizeAndSubmitTx = function (t, e) {
      var r = this;
      r.nonceLock.take(function () {
        n([r.fillInTxExtras.bind(r, t), r.signTransaction.bind(r), r.publishTransaction.bind(r)], function (t, n) {
          if (r.nonceLock.leave(), t) return e(t);
          e(null, n);
        });
      });
    }, d.prototype.finalizeTx = function (t, e) {
      var r = this;
      r.nonceLock.take(function () {
        n([r.fillInTxExtras.bind(r, t), r.signTransaction.bind(r)], function (n, i) {
          if (r.nonceLock.leave(), n) return e(n);
          e(null, {
            raw: i,
            tx: t
          });
        });
      });
    }, d.prototype.publishTransaction = function (t, e) {
      this.emitPayload({
        method: "eth_sendRawTransaction",
        params: [t]
      }, function (t, r) {
        if (t) return e(t);
        e(null, r.result);
      });
    }, d.prototype.estimateGas = function (t, e) {
      h(this.engine, t, e);
    }, d.prototype.getGasPrice = function (t) {
      this.emitPayload({
        method: "eth_gasPrice",
        params: []
      }, function (e, r) {
        if (e) return t(e);
        t(null, r.result);
      });
    }, d.prototype.fillInTxExtras = function (t, e) {
      var r = this,
          n = t.from,
          o = {};
      void 0 === t.gasPrice && (o.gasPrice = r.getGasPrice.bind(r)), void 0 === t.nonce && (o.nonce = r.emitPayload.bind(r, {
        method: "eth_getTransactionCount",
        params: [n, "pending"]
      })), void 0 === t.gas && (o.gas = r.estimateGas.bind(r, function (t) {
        return {
          from: t.from,
          to: t.to,
          value: t.value,
          data: t.data,
          gas: t.gas,
          gasPrice: t.gasPrice,
          nonce: t.nonce
        };
      }(t))), i(o, function (r, n) {
        if (r) return e(r);
        var i = {};
        n.gasPrice && (i.gasPrice = n.gasPrice), n.nonce && (i.nonce = n.nonce.result), n.gas && (i.gas = n.gas), e(null, u(t, i));
      });
    };
  }, function (t, e, r) {
    (function (e) {
      var n = r(9).inherits,
          i = r(226),
          o = r(16),
          s = r(32),
          a = r(82).blockTagForPayload;

      function u(t) {
        this.nonceCache = {};
      }

      t.exports = u, n(u, s), u.prototype.handleRequest = function (t, r, n) {
        var s = this;

        switch (t.method) {
          case "eth_getTransactionCount":
            var u = a(t),
                f = t.params[0].toLowerCase(),
                c = s.nonceCache[f];
            return void ("pending" === u ? c ? n(null, c) : r(function (t, e, r) {
              if (t) return r();
              void 0 === s.nonceCache[f] && (s.nonceCache[f] = e), r();
            }) : r());

          case "eth_sendRawTransaction":
            return void r(function (r, n, a) {
              if (r) return a();
              var u = t.params[0],
                  f = (o.stripHexPrefix(u), e.from(o.stripHexPrefix(u), "hex"), new i(e.from(o.stripHexPrefix(u), "hex"))),
                  c = "0x" + f.getSenderAddress().toString("hex").toLowerCase(),
                  h = o.bufferToInt(f.nonce),
                  l = (++h).toString(16);
              l.length % 2 && (l = "0" + l), l = "0x" + l, s.nonceCache[c] = l, a();
            });

          case "evm_revert":
            return s.nonceCache = {}, void r();

          default:
            return void r();
        }
      };
    }).call(this, r(2).Buffer);
  }, function (t, e, r) {
    var n = r(45),
        i = r(228);

    t.exports =
    /*#__PURE__*/
    function (_n26) {
      "use strict";

      _inherits(_class5, _n26);

      function _class5() {
        _classCallCheck(this, _class5);

        return _possibleConstructorReturn(this, _getPrototypeOf(_class5).call(this, function (_ref17) {
          var t = _ref17.blockTracker,
              e = _ref17.provider,
              r = _ref17.engine;

          var _i11 = i({
            blockTracker: t,
            provider: e
          }),
              n = _i11.events,
              o = _i11.middleware;

          return n.on("notification", function (t) {
            return r.emit("data", null, t);
          }), o;
        }));
      }

      return _class5;
    }(n);
  }, function (t, e, r) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), function (t) {
      for (var r in t) {
        e.hasOwnProperty(r) || (e[r] = t[r]);
      }
    }(r(229));
    var n = r(52);
    e.XMLHttpRequestEventTarget = n.XMLHttpRequestEventTarget;
  }, function (t, e) {
    t.exports = function (t) {
      return t && "object" == typeof t && "function" == typeof t.copy && "function" == typeof t.fill && "function" == typeof t.readUInt8;
    };
  }, function (t, e, r) {
    "use strict";

    t.exports = r(102)(r(117));
  }, function (t, e, r) {
    "use strict";

    var n = r(103),
        i = r(116);

    t.exports = function (t) {
      var e = n(t),
          r = i(t);
      return function (t, n) {
        switch ("string" == typeof t ? t.toLowerCase() : t) {
          case "keccak224":
            return new e(1152, 448, null, 224, n);

          case "keccak256":
            return new e(1088, 512, null, 256, n);

          case "keccak384":
            return new e(832, 768, null, 384, n);

          case "keccak512":
            return new e(576, 1024, null, 512, n);

          case "sha3-224":
            return new e(1152, 448, 6, 224, n);

          case "sha3-256":
            return new e(1088, 512, 6, 256, n);

          case "sha3-384":
            return new e(832, 768, 6, 384, n);

          case "sha3-512":
            return new e(576, 1024, 6, 512, n);

          case "shake128":
            return new r(1344, 256, 31, n);

          case "shake256":
            return new r(1088, 512, 31, n);

          default:
            throw new Error("Invald algorithm: " + t);
        }
      };
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(1).Buffer,
        i = r(13).Transform,
        o = r(0);

    t.exports = function (t) {
      function e(e, r, n, o, s) {
        i.call(this, s), this._rate = e, this._capacity = r, this._delimitedSuffix = n, this._hashBitLength = o, this._options = s, this._state = new t(), this._state.initialize(e, r), this._finalized = !1;
      }

      return o(e, i), e.prototype._transform = function (t, e, r) {
        var n = null;

        try {
          this.update(t, e);
        } catch (t) {
          n = t;
        }

        r(n);
      }, e.prototype._flush = function (t) {
        var e = null;

        try {
          this.push(this.digest());
        } catch (t) {
          e = t;
        }

        t(e);
      }, e.prototype.update = function (t, e) {
        if (!n.isBuffer(t) && "string" != typeof t) throw new TypeError("Data must be a string or a buffer");
        if (this._finalized) throw new Error("Digest already called");
        return n.isBuffer(t) || (t = n.from(t, e)), this._state.absorb(t), this;
      }, e.prototype.digest = function (t) {
        if (this._finalized) throw new Error("Digest already called");
        this._finalized = !0, this._delimitedSuffix && this._state.absorbLastFewBits(this._delimitedSuffix);

        var e = this._state.squeeze(this._hashBitLength / 8);

        return void 0 !== t && (e = e.toString(t)), this._resetState(), e;
      }, e.prototype._resetState = function () {
        return this._state.initialize(this._rate, this._capacity), this;
      }, e.prototype._clone = function () {
        var t = new e(this._rate, this._capacity, this._delimitedSuffix, this._hashBitLength, this._options);
        return this._state.copy(t._state), t._finalized = this._finalized, t;
      }, e;
    };
  }, function (t, e, r) {
    "use strict";

    e.byteLength = function (t) {
      var e = f(t),
          r = e[0],
          n = e[1];
      return 3 * (r + n) / 4 - n;
    }, e.toByteArray = function (t) {
      var e,
          r,
          n = f(t),
          s = n[0],
          a = n[1],
          u = new o(function (t, e, r) {
        return 3 * (e + r) / 4 - r;
      }(0, s, a)),
          c = 0,
          h = a > 0 ? s - 4 : s;

      for (r = 0; r < h; r += 4) {
        e = i[t.charCodeAt(r)] << 18 | i[t.charCodeAt(r + 1)] << 12 | i[t.charCodeAt(r + 2)] << 6 | i[t.charCodeAt(r + 3)], u[c++] = e >> 16 & 255, u[c++] = e >> 8 & 255, u[c++] = 255 & e;
      }

      2 === a && (e = i[t.charCodeAt(r)] << 2 | i[t.charCodeAt(r + 1)] >> 4, u[c++] = 255 & e);
      1 === a && (e = i[t.charCodeAt(r)] << 10 | i[t.charCodeAt(r + 1)] << 4 | i[t.charCodeAt(r + 2)] >> 2, u[c++] = e >> 8 & 255, u[c++] = 255 & e);
      return u;
    }, e.fromByteArray = function (t) {
      for (var e, r = t.length, i = r % 3, o = [], s = 0, a = r - i; s < a; s += 16383) {
        o.push(c(t, s, s + 16383 > a ? a : s + 16383));
      }

      1 === i ? (e = t[r - 1], o.push(n[e >> 2] + n[e << 4 & 63] + "==")) : 2 === i && (e = (t[r - 2] << 8) + t[r - 1], o.push(n[e >> 10] + n[e >> 4 & 63] + n[e << 2 & 63] + "="));
      return o.join("");
    };

    for (var n = [], i = [], o = "undefined" != typeof Uint8Array ? Uint8Array : Array, s = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", a = 0, u = s.length; a < u; ++a) {
      n[a] = s[a], i[s.charCodeAt(a)] = a;
    }

    function f(t) {
      var e = t.length;
      if (e % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
      var r = t.indexOf("=");
      return -1 === r && (r = e), [r, r === e ? 0 : 4 - r % 4];
    }

    function c(t, e, r) {
      for (var i, o, s = [], a = e; a < r; a += 3) {
        i = (t[a] << 16 & 16711680) + (t[a + 1] << 8 & 65280) + (255 & t[a + 2]), s.push(n[(o = i) >> 18 & 63] + n[o >> 12 & 63] + n[o >> 6 & 63] + n[63 & o]);
      }

      return s.join("");
    }

    i["-".charCodeAt(0)] = 62, i["_".charCodeAt(0)] = 63;
  }, function (t, e) {
    e.read = function (t, e, r, n, i) {
      var o,
          s,
          a = 8 * i - n - 1,
          u = (1 << a) - 1,
          f = u >> 1,
          c = -7,
          h = r ? i - 1 : 0,
          l = r ? -1 : 1,
          d = t[e + h];

      for (h += l, o = d & (1 << -c) - 1, d >>= -c, c += a; c > 0; o = 256 * o + t[e + h], h += l, c -= 8) {
        ;
      }

      for (s = o & (1 << -c) - 1, o >>= -c, c += n; c > 0; s = 256 * s + t[e + h], h += l, c -= 8) {
        ;
      }

      if (0 === o) o = 1 - f;else {
        if (o === u) return s ? NaN : 1 / 0 * (d ? -1 : 1);
        s += Math.pow(2, n), o -= f;
      }
      return (d ? -1 : 1) * s * Math.pow(2, o - n);
    }, e.write = function (t, e, r, n, i, o) {
      var s,
          a,
          u,
          f = 8 * o - i - 1,
          c = (1 << f) - 1,
          h = c >> 1,
          l = 23 === i ? Math.pow(2, -24) - Math.pow(2, -77) : 0,
          d = n ? 0 : o - 1,
          p = n ? 1 : -1,
          g = e < 0 || 0 === e && 1 / e < 0 ? 1 : 0;

      for (e = Math.abs(e), isNaN(e) || e === 1 / 0 ? (a = isNaN(e) ? 1 : 0, s = c) : (s = Math.floor(Math.log(e) / Math.LN2), e * (u = Math.pow(2, -s)) < 1 && (s--, u *= 2), (e += s + h >= 1 ? l / u : l * Math.pow(2, 1 - h)) * u >= 2 && (s++, u /= 2), s + h >= c ? (a = 0, s = c) : s + h >= 1 ? (a = (e * u - 1) * Math.pow(2, i), s += h) : (a = e * Math.pow(2, h - 1) * Math.pow(2, i), s = 0)); i >= 8; t[r + d] = 255 & a, d += p, a /= 256, i -= 8) {
        ;
      }

      for (s = s << i | a, f += i; f > 0; t[r + d] = 255 & s, d += p, s /= 256, f -= 8) {
        ;
      }

      t[r + d - p] |= 128 * g;
    };
  }, function (t, e) {}, function (t, e, r) {
    "use strict";

    var n = r(1).Buffer,
        i = r(108);
    t.exports = function () {
      function t() {
        !function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, t), this.head = null, this.tail = null, this.length = 0;
      }

      return t.prototype.push = function (t) {
        var e = {
          data: t,
          next: null
        };
        this.length > 0 ? this.tail.next = e : this.head = e, this.tail = e, ++this.length;
      }, t.prototype.unshift = function (t) {
        var e = {
          data: t,
          next: this.head
        };
        0 === this.length && (this.tail = e), this.head = e, ++this.length;
      }, t.prototype.shift = function () {
        if (0 !== this.length) {
          var t = this.head.data;
          return 1 === this.length ? this.head = this.tail = null : this.head = this.head.next, --this.length, t;
        }
      }, t.prototype.clear = function () {
        this.head = this.tail = null, this.length = 0;
      }, t.prototype.join = function (t) {
        if (0 === this.length) return "";

        for (var e = this.head, r = "" + e.data; e = e.next;) {
          r += t + e.data;
        }

        return r;
      }, t.prototype.concat = function (t) {
        if (0 === this.length) return n.alloc(0);
        if (1 === this.length) return this.head.data;

        for (var e, r, i, o = n.allocUnsafe(t >>> 0), s = this.head, a = 0; s;) {
          e = s.data, r = o, i = a, e.copy(r, i), a += s.data.length, s = s.next;
        }

        return o;
      }, t;
    }(), i && i.inspect && i.inspect.custom && (t.exports.prototype[i.inspect.custom] = function () {
      var t = i.inspect({
        length: this.length
      });
      return this.constructor.name + " " + t;
    });
  }, function (t, e) {}, function (t, e, r) {
    (function (t, e) {
      !function (t, r) {
        "use strict";

        if (!t.setImmediate) {
          var n,
              i,
              o,
              s,
              a,
              u = 1,
              f = {},
              c = !1,
              h = t.document,
              l = Object.getPrototypeOf && Object.getPrototypeOf(t);
          l = l && l.setTimeout ? l : t, "[object process]" === {}.toString.call(t.process) ? n = function n() {
            var t = d(arguments);
            return e.nextTick(p(g, t)), t;
          } : !function () {
            if (t.postMessage && !t.importScripts) {
              var e = !0,
                  r = t.onmessage;
              return t.onmessage = function () {
                e = !1;
              }, t.postMessage("", "*"), t.onmessage = r, e;
            }
          }() ? t.MessageChannel ? ((o = new MessageChannel()).port1.onmessage = function (t) {
            g(t.data);
          }, n = function n() {
            var t = d(arguments);
            return o.port2.postMessage(t), t;
          }) : h && "onreadystatechange" in h.createElement("script") ? (i = h.documentElement, n = function n() {
            var t = d(arguments),
                e = h.createElement("script");
            return e.onreadystatechange = function () {
              g(t), e.onreadystatechange = null, i.removeChild(e), e = null;
            }, i.appendChild(e), t;
          }) : n = function n() {
            var t = d(arguments);
            return setTimeout(p(g, t), 0), t;
          } : (s = "setImmediate$" + Math.random() + "$", a = function a(e) {
            e.source === t && "string" == typeof e.data && 0 === e.data.indexOf(s) && g(+e.data.slice(s.length));
          }, t.addEventListener ? t.addEventListener("message", a, !1) : t.attachEvent("onmessage", a), n = function n() {
            var e = d(arguments);
            return t.postMessage(s + e, "*"), e;
          }), l.setImmediate = n, l.clearImmediate = m;
        }

        function d(t) {
          return f[u] = p.apply(void 0, t), u++;
        }

        function p(t) {
          var e = [].slice.call(arguments, 1);
          return function () {
            "function" == typeof t ? t.apply(void 0, e) : new Function("" + t)();
          };
        }

        function g(t) {
          if (c) setTimeout(p(g, t), 0);else {
            var e = f[t];

            if (e) {
              c = !0;

              try {
                e();
              } finally {
                m(t), c = !1;
              }
            }
          }
        }

        function m(t) {
          delete f[t];
        }
      }("undefined" == typeof self ? void 0 === t ? this : t : self);
    }).call(this, r(4), r(6));
  }, function (t, e, r) {
    (function (e) {
      function r(t) {
        try {
          if (!e.localStorage) return !1;
        } catch (t) {
          return !1;
        }

        var r = e.localStorage[t];
        return null != r && "true" === String(r).toLowerCase();
      }

      t.exports = function (t, e) {
        if (r("noDeprecation")) return t;
        var n = !1;
        return function () {
          if (!n) {
            if (r("throwDeprecation")) throw new Error(e);
            r("traceDeprecation") ? console.trace(e) : console.warn(e), n = !0;
          }

          return t.apply(this, arguments);
        };
      };
    }).call(this, r(4));
  }, function (t, e, r) {
    "use strict";

    t.exports = o;
    var n = r(58),
        i = r(18);

    function o(t) {
      if (!(this instanceof o)) return new o(t);
      n.call(this, t);
    }

    i.inherits = r(0), i.inherits(o, n), o.prototype._transform = function (t, e, r) {
      r(null, t);
    };
  }, function (t, e, r) {
    t.exports = r(33);
  }, function (t, e, r) {
    t.exports = r(10);
  }, function (t, e, r) {
    t.exports = r(17).Transform;
  }, function (t, e, r) {
    t.exports = r(17).PassThrough;
  }, function (t, e, r) {
    "use strict";

    var n = r(1).Buffer,
        i = r(13).Transform,
        o = r(0);

    t.exports = function (t) {
      function e(e, r, n, o) {
        i.call(this, o), this._rate = e, this._capacity = r, this._delimitedSuffix = n, this._options = o, this._state = new t(), this._state.initialize(e, r), this._finalized = !1;
      }

      return o(e, i), e.prototype._transform = function (t, e, r) {
        var n = null;

        try {
          this.update(t, e);
        } catch (t) {
          n = t;
        }

        r(n);
      }, e.prototype._flush = function () {}, e.prototype._read = function (t) {
        this.push(this.squeeze(t));
      }, e.prototype.update = function (t, e) {
        if (!n.isBuffer(t) && "string" != typeof t) throw new TypeError("Data must be a string or a buffer");
        if (this._finalized) throw new Error("Squeeze already called");
        return n.isBuffer(t) || (t = n.from(t, e)), this._state.absorb(t), this;
      }, e.prototype.squeeze = function (t, e) {
        this._finalized || (this._finalized = !0, this._state.absorbLastFewBits(this._delimitedSuffix));

        var r = this._state.squeeze(t);

        return void 0 !== e && (r = r.toString(e)), r;
      }, e.prototype._resetState = function () {
        return this._state.initialize(this._rate, this._capacity), this;
      }, e.prototype._clone = function () {
        var t = new e(this._rate, this._capacity, this._delimitedSuffix, this._options);
        return this._state.copy(t._state), t._finalized = this._finalized, t;
      }, e;
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(1).Buffer,
        i = r(118);

    function o() {
      this.state = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], this.blockSize = null, this.count = 0, this.squeezing = !1;
    }

    o.prototype.initialize = function (t, e) {
      for (var r = 0; r < 50; ++r) {
        this.state[r] = 0;
      }

      this.blockSize = t / 8, this.count = 0, this.squeezing = !1;
    }, o.prototype.absorb = function (t) {
      for (var e = 0; e < t.length; ++e) {
        this.state[~~(this.count / 4)] ^= t[e] << this.count % 4 * 8, this.count += 1, this.count === this.blockSize && (i.p1600(this.state), this.count = 0);
      }
    }, o.prototype.absorbLastFewBits = function (t) {
      this.state[~~(this.count / 4)] ^= t << this.count % 4 * 8, 0 != (128 & t) && this.count === this.blockSize - 1 && i.p1600(this.state), this.state[~~((this.blockSize - 1) / 4)] ^= 128 << (this.blockSize - 1) % 4 * 8, i.p1600(this.state), this.count = 0, this.squeezing = !0;
    }, o.prototype.squeeze = function (t) {
      this.squeezing || this.absorbLastFewBits(1);

      for (var e = n.alloc(t), r = 0; r < t; ++r) {
        e[r] = this.state[~~(this.count / 4)] >>> this.count % 4 * 8 & 255, this.count += 1, this.count === this.blockSize && (i.p1600(this.state), this.count = 0);
      }

      return e;
    }, o.prototype.copy = function (t) {
      for (var e = 0; e < 50; ++e) {
        t.state[e] = this.state[e];
      }

      t.blockSize = this.blockSize, t.count = this.count, t.squeezing = this.squeezing;
    }, t.exports = o;
  }, function (t, e, r) {
    "use strict";

    var n = [1, 0, 32898, 0, 32906, 2147483648, 2147516416, 2147483648, 32907, 0, 2147483649, 0, 2147516545, 2147483648, 32777, 2147483648, 138, 0, 136, 0, 2147516425, 0, 2147483658, 0, 2147516555, 0, 139, 2147483648, 32905, 2147483648, 32771, 2147483648, 32770, 2147483648, 128, 2147483648, 32778, 0, 2147483658, 2147483648, 2147516545, 2147483648, 32896, 2147483648, 2147483649, 0, 2147516424, 2147483648];

    e.p1600 = function (t) {
      for (var e = 0; e < 24; ++e) {
        var r = t[0] ^ t[10] ^ t[20] ^ t[30] ^ t[40],
            i = t[1] ^ t[11] ^ t[21] ^ t[31] ^ t[41],
            o = t[2] ^ t[12] ^ t[22] ^ t[32] ^ t[42],
            s = t[3] ^ t[13] ^ t[23] ^ t[33] ^ t[43],
            a = t[4] ^ t[14] ^ t[24] ^ t[34] ^ t[44],
            u = t[5] ^ t[15] ^ t[25] ^ t[35] ^ t[45],
            f = t[6] ^ t[16] ^ t[26] ^ t[36] ^ t[46],
            c = t[7] ^ t[17] ^ t[27] ^ t[37] ^ t[47],
            h = t[8] ^ t[18] ^ t[28] ^ t[38] ^ t[48],
            l = t[9] ^ t[19] ^ t[29] ^ t[39] ^ t[49],
            d = h ^ (o << 1 | s >>> 31),
            p = l ^ (s << 1 | o >>> 31),
            g = t[0] ^ d,
            m = t[1] ^ p,
            b = t[10] ^ d,
            v = t[11] ^ p,
            y = t[20] ^ d,
            _ = t[21] ^ p,
            w = t[30] ^ d,
            E = t[31] ^ p,
            M = t[40] ^ d,
            S = t[41] ^ p;

        d = r ^ (a << 1 | u >>> 31), p = i ^ (u << 1 | a >>> 31);
        var A = t[2] ^ d,
            x = t[3] ^ p,
            R = t[12] ^ d,
            T = t[13] ^ p,
            k = t[22] ^ d,
            I = t[23] ^ p,
            B = t[32] ^ d,
            O = t[33] ^ p,
            P = t[42] ^ d,
            N = t[43] ^ p;
        d = o ^ (f << 1 | c >>> 31), p = s ^ (c << 1 | f >>> 31);
        var C = t[4] ^ d,
            L = t[5] ^ p,
            j = t[14] ^ d,
            U = t[15] ^ p,
            D = t[24] ^ d,
            F = t[25] ^ p,
            z = t[34] ^ d,
            q = t[35] ^ p,
            H = t[44] ^ d,
            Y = t[45] ^ p;
        d = a ^ (h << 1 | l >>> 31), p = u ^ (l << 1 | h >>> 31);
        var G = t[6] ^ d,
            K = t[7] ^ p,
            Z = t[16] ^ d,
            V = t[17] ^ p,
            W = t[26] ^ d,
            J = t[27] ^ p,
            X = t[36] ^ d,
            $ = t[37] ^ p,
            Q = t[46] ^ d,
            tt = t[47] ^ p;
        d = f ^ (r << 1 | i >>> 31), p = c ^ (i << 1 | r >>> 31);

        var et = t[8] ^ d,
            rt = t[9] ^ p,
            nt = t[18] ^ d,
            it = t[19] ^ p,
            ot = t[28] ^ d,
            st = t[29] ^ p,
            at = t[38] ^ d,
            ut = t[39] ^ p,
            ft = t[48] ^ d,
            ct = t[49] ^ p,
            ht = g,
            lt = m,
            dt = v << 4 | b >>> 28,
            pt = b << 4 | v >>> 28,
            gt = y << 3 | _ >>> 29,
            mt = _ << 3 | y >>> 29,
            bt = E << 9 | w >>> 23,
            vt = w << 9 | E >>> 23,
            yt = M << 18 | S >>> 14,
            _t = S << 18 | M >>> 14,
            wt = A << 1 | x >>> 31,
            Et = x << 1 | A >>> 31,
            Mt = T << 12 | R >>> 20,
            St = R << 12 | T >>> 20,
            At = k << 10 | I >>> 22,
            xt = I << 10 | k >>> 22,
            Rt = O << 13 | B >>> 19,
            Tt = B << 13 | O >>> 19,
            kt = P << 2 | N >>> 30,
            It = N << 2 | P >>> 30,
            Bt = L << 30 | C >>> 2,
            Ot = C << 30 | L >>> 2,
            Pt = j << 6 | U >>> 26,
            Nt = U << 6 | j >>> 26,
            Ct = F << 11 | D >>> 21,
            Lt = D << 11 | F >>> 21,
            jt = z << 15 | q >>> 17,
            Ut = q << 15 | z >>> 17,
            Dt = Y << 29 | H >>> 3,
            Ft = H << 29 | Y >>> 3,
            zt = G << 28 | K >>> 4,
            qt = K << 28 | G >>> 4,
            Ht = V << 23 | Z >>> 9,
            Yt = Z << 23 | V >>> 9,
            Gt = W << 25 | J >>> 7,
            Kt = J << 25 | W >>> 7,
            Zt = X << 21 | $ >>> 11,
            Vt = $ << 21 | X >>> 11,
            Wt = tt << 24 | Q >>> 8,
            Jt = Q << 24 | tt >>> 8,
            Xt = et << 27 | rt >>> 5,
            $t = rt << 27 | et >>> 5,
            Qt = nt << 20 | it >>> 12,
            te = it << 20 | nt >>> 12,
            ee = st << 7 | ot >>> 25,
            re = ot << 7 | st >>> 25,
            ne = at << 8 | ut >>> 24,
            ie = ut << 8 | at >>> 24,
            oe = ft << 14 | ct >>> 18,
            se = ct << 14 | ft >>> 18;

        t[0] = ht ^ ~Mt & Ct, t[1] = lt ^ ~St & Lt, t[10] = zt ^ ~Qt & gt, t[11] = qt ^ ~te & mt, t[20] = wt ^ ~Pt & Gt, t[21] = Et ^ ~Nt & Kt, t[30] = Xt ^ ~dt & At, t[31] = $t ^ ~pt & xt, t[40] = Bt ^ ~Ht & ee, t[41] = Ot ^ ~Yt & re, t[2] = Mt ^ ~Ct & Zt, t[3] = St ^ ~Lt & Vt, t[12] = Qt ^ ~gt & Rt, t[13] = te ^ ~mt & Tt, t[22] = Pt ^ ~Gt & ne, t[23] = Nt ^ ~Kt & ie, t[32] = dt ^ ~At & jt, t[33] = pt ^ ~xt & Ut, t[42] = Ht ^ ~ee & bt, t[43] = Yt ^ ~re & vt, t[4] = Ct ^ ~Zt & oe, t[5] = Lt ^ ~Vt & se, t[14] = gt ^ ~Rt & Dt, t[15] = mt ^ ~Tt & Ft, t[24] = Gt ^ ~ne & yt, t[25] = Kt ^ ~ie & _t, t[34] = At ^ ~jt & Wt, t[35] = xt ^ ~Ut & Jt, t[44] = ee ^ ~bt & kt, t[45] = re ^ ~vt & It, t[6] = Zt ^ ~oe & ht, t[7] = Vt ^ ~se & lt, t[16] = Rt ^ ~Dt & zt, t[17] = Tt ^ ~Ft & qt, t[26] = ne ^ ~yt & wt, t[27] = ie ^ ~_t & Et, t[36] = jt ^ ~Wt & Xt, t[37] = Ut ^ ~Jt & $t, t[46] = bt ^ ~kt & Bt, t[47] = vt ^ ~It & Ot, t[8] = oe ^ ~ht & Mt, t[9] = se ^ ~lt & St, t[18] = Dt ^ ~zt & Qt, t[19] = Ft ^ ~qt & te, t[28] = yt ^ ~wt & Pt, t[29] = _t ^ ~Et & Nt, t[38] = Wt ^ ~Xt & dt, t[39] = Jt ^ ~$t & pt, t[48] = kt ^ ~Bt & Ht, t[49] = It ^ ~Ot & Yt, t[0] ^= n[2 * e], t[1] ^= n[2 * e + 1];
      }
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(120),
        i = r(121),
        o = r(59);

    function s(t, e) {
      return void 0 === t ? e : (n.isBoolean(t, o.COMPRESSED_TYPE_INVALID), t);
    }

    t.exports = function (t) {
      return {
        privateKeyVerify: function privateKeyVerify(e) {
          return n.isBuffer(e, o.EC_PRIVATE_KEY_TYPE_INVALID), 32 === e.length && t.privateKeyVerify(e);
        },
        privateKeyExport: function privateKeyExport(e, r) {
          n.isBuffer(e, o.EC_PRIVATE_KEY_TYPE_INVALID), n.isBufferLength(e, 32, o.EC_PRIVATE_KEY_LENGTH_INVALID), r = s(r, !0);
          var a = t.privateKeyExport(e, r);
          return i.privateKeyExport(e, a, r);
        },
        privateKeyImport: function privateKeyImport(e) {
          if (n.isBuffer(e, o.EC_PRIVATE_KEY_TYPE_INVALID), (e = i.privateKeyImport(e)) && 32 === e.length && t.privateKeyVerify(e)) return e;
          throw new Error(o.EC_PRIVATE_KEY_IMPORT_DER_FAIL);
        },
        privateKeyNegate: function privateKeyNegate(e) {
          return n.isBuffer(e, o.EC_PRIVATE_KEY_TYPE_INVALID), n.isBufferLength(e, 32, o.EC_PRIVATE_KEY_LENGTH_INVALID), t.privateKeyNegate(e);
        },
        privateKeyModInverse: function privateKeyModInverse(e) {
          return n.isBuffer(e, o.EC_PRIVATE_KEY_TYPE_INVALID), n.isBufferLength(e, 32, o.EC_PRIVATE_KEY_LENGTH_INVALID), t.privateKeyModInverse(e);
        },
        privateKeyTweakAdd: function privateKeyTweakAdd(e, r) {
          return n.isBuffer(e, o.EC_PRIVATE_KEY_TYPE_INVALID), n.isBufferLength(e, 32, o.EC_PRIVATE_KEY_LENGTH_INVALID), n.isBuffer(r, o.TWEAK_TYPE_INVALID), n.isBufferLength(r, 32, o.TWEAK_LENGTH_INVALID), t.privateKeyTweakAdd(e, r);
        },
        privateKeyTweakMul: function privateKeyTweakMul(e, r) {
          return n.isBuffer(e, o.EC_PRIVATE_KEY_TYPE_INVALID), n.isBufferLength(e, 32, o.EC_PRIVATE_KEY_LENGTH_INVALID), n.isBuffer(r, o.TWEAK_TYPE_INVALID), n.isBufferLength(r, 32, o.TWEAK_LENGTH_INVALID), t.privateKeyTweakMul(e, r);
        },
        publicKeyCreate: function publicKeyCreate(e, r) {
          return n.isBuffer(e, o.EC_PRIVATE_KEY_TYPE_INVALID), n.isBufferLength(e, 32, o.EC_PRIVATE_KEY_LENGTH_INVALID), r = s(r, !0), t.publicKeyCreate(e, r);
        },
        publicKeyConvert: function publicKeyConvert(e, r) {
          return n.isBuffer(e, o.EC_PUBLIC_KEY_TYPE_INVALID), n.isBufferLength2(e, 33, 65, o.EC_PUBLIC_KEY_LENGTH_INVALID), r = s(r, !0), t.publicKeyConvert(e, r);
        },
        publicKeyVerify: function publicKeyVerify(e) {
          return n.isBuffer(e, o.EC_PUBLIC_KEY_TYPE_INVALID), t.publicKeyVerify(e);
        },
        publicKeyTweakAdd: function publicKeyTweakAdd(e, r, i) {
          return n.isBuffer(e, o.EC_PUBLIC_KEY_TYPE_INVALID), n.isBufferLength2(e, 33, 65, o.EC_PUBLIC_KEY_LENGTH_INVALID), n.isBuffer(r, o.TWEAK_TYPE_INVALID), n.isBufferLength(r, 32, o.TWEAK_LENGTH_INVALID), i = s(i, !0), t.publicKeyTweakAdd(e, r, i);
        },
        publicKeyTweakMul: function publicKeyTweakMul(e, r, i) {
          return n.isBuffer(e, o.EC_PUBLIC_KEY_TYPE_INVALID), n.isBufferLength2(e, 33, 65, o.EC_PUBLIC_KEY_LENGTH_INVALID), n.isBuffer(r, o.TWEAK_TYPE_INVALID), n.isBufferLength(r, 32, o.TWEAK_LENGTH_INVALID), i = s(i, !0), t.publicKeyTweakMul(e, r, i);
        },
        publicKeyCombine: function publicKeyCombine(e, r) {
          n.isArray(e, o.EC_PUBLIC_KEYS_TYPE_INVALID), n.isLengthGTZero(e, o.EC_PUBLIC_KEYS_LENGTH_INVALID);

          for (var i = 0; i < e.length; ++i) {
            n.isBuffer(e[i], o.EC_PUBLIC_KEY_TYPE_INVALID), n.isBufferLength2(e[i], 33, 65, o.EC_PUBLIC_KEY_LENGTH_INVALID);
          }

          return r = s(r, !0), t.publicKeyCombine(e, r);
        },
        signatureNormalize: function signatureNormalize(e) {
          return n.isBuffer(e, o.ECDSA_SIGNATURE_TYPE_INVALID), n.isBufferLength(e, 64, o.ECDSA_SIGNATURE_LENGTH_INVALID), t.signatureNormalize(e);
        },
        signatureExport: function signatureExport(e) {
          n.isBuffer(e, o.ECDSA_SIGNATURE_TYPE_INVALID), n.isBufferLength(e, 64, o.ECDSA_SIGNATURE_LENGTH_INVALID);
          var r = t.signatureExport(e);
          return i.signatureExport(r);
        },
        signatureImport: function signatureImport(e) {
          n.isBuffer(e, o.ECDSA_SIGNATURE_TYPE_INVALID), n.isLengthGTZero(e, o.ECDSA_SIGNATURE_LENGTH_INVALID);
          var r = i.signatureImport(e);
          if (r) return t.signatureImport(r);
          throw new Error(o.ECDSA_SIGNATURE_PARSE_DER_FAIL);
        },
        signatureImportLax: function signatureImportLax(e) {
          n.isBuffer(e, o.ECDSA_SIGNATURE_TYPE_INVALID), n.isLengthGTZero(e, o.ECDSA_SIGNATURE_LENGTH_INVALID);
          var r = i.signatureImportLax(e);
          if (r) return t.signatureImport(r);
          throw new Error(o.ECDSA_SIGNATURE_PARSE_DER_FAIL);
        },
        sign: function sign(e, r, i) {
          n.isBuffer(e, o.MSG32_TYPE_INVALID), n.isBufferLength(e, 32, o.MSG32_LENGTH_INVALID), n.isBuffer(r, o.EC_PRIVATE_KEY_TYPE_INVALID), n.isBufferLength(r, 32, o.EC_PRIVATE_KEY_LENGTH_INVALID);
          var s = null,
              a = null;
          return void 0 !== i && (n.isObject(i, o.OPTIONS_TYPE_INVALID), void 0 !== i.data && (n.isBuffer(i.data, o.OPTIONS_DATA_TYPE_INVALID), n.isBufferLength(i.data, 32, o.OPTIONS_DATA_LENGTH_INVALID), s = i.data), void 0 !== i.noncefn && (n.isFunction(i.noncefn, o.OPTIONS_NONCEFN_TYPE_INVALID), a = i.noncefn)), t.sign(e, r, a, s);
        },
        verify: function verify(e, r, i) {
          return n.isBuffer(e, o.MSG32_TYPE_INVALID), n.isBufferLength(e, 32, o.MSG32_LENGTH_INVALID), n.isBuffer(r, o.ECDSA_SIGNATURE_TYPE_INVALID), n.isBufferLength(r, 64, o.ECDSA_SIGNATURE_LENGTH_INVALID), n.isBuffer(i, o.EC_PUBLIC_KEY_TYPE_INVALID), n.isBufferLength2(i, 33, 65, o.EC_PUBLIC_KEY_LENGTH_INVALID), t.verify(e, r, i);
        },
        recover: function recover(e, r, i, a) {
          return n.isBuffer(e, o.MSG32_TYPE_INVALID), n.isBufferLength(e, 32, o.MSG32_LENGTH_INVALID), n.isBuffer(r, o.ECDSA_SIGNATURE_TYPE_INVALID), n.isBufferLength(r, 64, o.ECDSA_SIGNATURE_LENGTH_INVALID), n.isNumber(i, o.RECOVERY_ID_TYPE_INVALID), n.isNumberInInterval(i, -1, 4, o.RECOVERY_ID_VALUE_INVALID), a = s(a, !0), t.recover(e, r, i, a);
        },
        ecdh: function ecdh(e, r) {
          return n.isBuffer(e, o.EC_PUBLIC_KEY_TYPE_INVALID), n.isBufferLength2(e, 33, 65, o.EC_PUBLIC_KEY_LENGTH_INVALID), n.isBuffer(r, o.EC_PRIVATE_KEY_TYPE_INVALID), n.isBufferLength(r, 32, o.EC_PRIVATE_KEY_LENGTH_INVALID), t.ecdh(e, r);
        },
        ecdhUnsafe: function ecdhUnsafe(e, r, i) {
          return n.isBuffer(e, o.EC_PUBLIC_KEY_TYPE_INVALID), n.isBufferLength2(e, 33, 65, o.EC_PUBLIC_KEY_LENGTH_INVALID), n.isBuffer(r, o.EC_PRIVATE_KEY_TYPE_INVALID), n.isBufferLength(r, 32, o.EC_PRIVATE_KEY_LENGTH_INVALID), i = s(i, !0), t.ecdhUnsafe(e, r, i);
        }
      };
    };
  }, function (t, e, r) {
    "use strict";

    (function (t) {
      var r = Object.prototype.toString;
      e.isArray = function (t, e) {
        if (!Array.isArray(t)) throw TypeError(e);
      }, e.isBoolean = function (t, e) {
        if ("[object Boolean]" !== r.call(t)) throw TypeError(e);
      }, e.isBuffer = function (e, r) {
        if (!t.isBuffer(e)) throw TypeError(r);
      }, e.isFunction = function (t, e) {
        if ("[object Function]" !== r.call(t)) throw TypeError(e);
      }, e.isNumber = function (t, e) {
        if ("[object Number]" !== r.call(t)) throw TypeError(e);
      }, e.isObject = function (t, e) {
        if ("[object Object]" !== r.call(t)) throw TypeError(e);
      }, e.isBufferLength = function (t, e, r) {
        if (t.length !== e) throw RangeError(r);
      }, e.isBufferLength2 = function (t, e, r, n) {
        if (t.length !== e && t.length !== r) throw RangeError(n);
      }, e.isLengthGTZero = function (t, e) {
        if (0 === t.length) throw RangeError(e);
      }, e.isNumberInInterval = function (t, e, r, n) {
        if (t <= e || t >= r) throw RangeError(n);
      };
    }).call(this, r(2).Buffer);
  }, function (t, e, r) {
    "use strict";

    var n = r(1).Buffer,
        i = r(122),
        o = n.from([48, 129, 211, 2, 1, 1, 4, 32, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 160, 129, 133, 48, 129, 130, 2, 1, 1, 48, 44, 6, 7, 42, 134, 72, 206, 61, 1, 1, 2, 33, 0, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 254, 255, 255, 252, 47, 48, 6, 4, 1, 0, 4, 1, 7, 4, 33, 2, 121, 190, 102, 126, 249, 220, 187, 172, 85, 160, 98, 149, 206, 135, 11, 7, 2, 155, 252, 219, 45, 206, 40, 217, 89, 242, 129, 91, 22, 248, 23, 152, 2, 33, 0, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 254, 186, 174, 220, 230, 175, 72, 160, 59, 191, 210, 94, 140, 208, 54, 65, 65, 2, 1, 1, 161, 36, 3, 34, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]),
        s = n.from([48, 130, 1, 19, 2, 1, 1, 4, 32, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 160, 129, 165, 48, 129, 162, 2, 1, 1, 48, 44, 6, 7, 42, 134, 72, 206, 61, 1, 1, 2, 33, 0, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 254, 255, 255, 252, 47, 48, 6, 4, 1, 0, 4, 1, 7, 4, 65, 4, 121, 190, 102, 126, 249, 220, 187, 172, 85, 160, 98, 149, 206, 135, 11, 7, 2, 155, 252, 219, 45, 206, 40, 217, 89, 242, 129, 91, 22, 248, 23, 152, 72, 58, 218, 119, 38, 163, 196, 101, 93, 164, 251, 252, 14, 17, 8, 168, 253, 23, 180, 72, 166, 133, 84, 25, 156, 71, 208, 143, 251, 16, 212, 184, 2, 33, 0, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 254, 186, 174, 220, 230, 175, 72, 160, 59, 191, 210, 94, 140, 208, 54, 65, 65, 2, 1, 1, 161, 68, 3, 66, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]);
    e.privateKeyExport = function (t, e, r) {
      var i = n.from(r ? o : s);
      return t.copy(i, r ? 8 : 9), e.copy(i, r ? 181 : 214), i;
    }, e.privateKeyImport = function (t) {
      var e = t.length,
          r = 0;

      if (!(e < r + 1 || 48 !== t[r]) && !(e < (r += 1) + 1) && 128 & t[r]) {
        var n = 127 & t[r];

        if (r += 1, !(n < 1 || n > 2 || e < r + n)) {
          var i = t[r + n - 1] | (n > 1 ? t[r + n - 2] << 8 : 0);
          if (!(e < (r += n) + i || e < r + 3 || 2 !== t[r] || 1 !== t[r + 1] || 1 !== t[r + 2] || e < (r += 3) + 2 || 4 !== t[r] || t[r + 1] > 32 || e < r + 2 + t[r + 1])) return t.slice(r + 2, r + 2 + t[r + 1]);
        }
      }
    }, e.signatureExport = function (t) {
      for (var e = n.concat([n.from([0]), t.r]), r = 33, o = 0; r > 1 && 0 === e[o] && !(128 & e[o + 1]); --r, ++o) {
        ;
      }

      for (var s = n.concat([n.from([0]), t.s]), a = 33, u = 0; a > 1 && 0 === s[u] && !(128 & s[u + 1]); --a, ++u) {
        ;
      }

      return i.encode(e.slice(o), s.slice(u));
    }, e.signatureImport = function (t) {
      var e = n.alloc(32, 0),
          r = n.alloc(32, 0);

      try {
        var o = i.decode(t);
        if (33 === o.r.length && 0 === o.r[0] && (o.r = o.r.slice(1)), o.r.length > 32) throw new Error("R length is too long");
        if (33 === o.s.length && 0 === o.s[0] && (o.s = o.s.slice(1)), o.s.length > 32) throw new Error("S length is too long");
      } catch (t) {
        return;
      }

      return o.r.copy(e, 32 - o.r.length), o.s.copy(r, 32 - o.s.length), {
        r: e,
        s: r
      };
    }, e.signatureImportLax = function (t) {
      var e = n.alloc(32, 0),
          r = n.alloc(32, 0),
          i = t.length,
          o = 0;

      if (48 === t[o++]) {
        var s = t[o++];

        if (!(128 & s && (o += s - 128) > i) && 2 === t[o++]) {
          var a = t[o++];

          if (128 & a) {
            if (o + (s = a - 128) > i) return;

            for (; s > 0 && 0 === t[o]; o += 1, s -= 1) {
              ;
            }

            for (a = 0; s > 0; o += 1, s -= 1) {
              a = (a << 8) + t[o];
            }
          }

          if (!(a > i - o)) {
            var u = o;

            if (o += a, 2 === t[o++]) {
              var f = t[o++];

              if (128 & f) {
                if (o + (s = f - 128) > i) return;

                for (; s > 0 && 0 === t[o]; o += 1, s -= 1) {
                  ;
                }

                for (f = 0; s > 0; o += 1, s -= 1) {
                  f = (f << 8) + t[o];
                }
              }

              if (!(f > i - o)) {
                var c = o;

                for (o += f; a > 0 && 0 === t[u]; a -= 1, u += 1) {
                  ;
                }

                if (!(a > 32)) {
                  var h = t.slice(u, u + a);

                  for (h.copy(e, 32 - h.length); f > 0 && 0 === t[c]; f -= 1, c += 1) {
                    ;
                  }

                  if (!(f > 32)) {
                    var l = t.slice(c, c + f);
                    return l.copy(r, 32 - l.length), {
                      r: e,
                      s: r
                    };
                  }
                }
              }
            }
          }
        }
      }
    };
  }, function (t, e, r) {
    var n = r(1).Buffer;
    t.exports = {
      check: function check(t) {
        if (t.length < 8) return !1;
        if (t.length > 72) return !1;
        if (48 !== t[0]) return !1;
        if (t[1] !== t.length - 2) return !1;
        if (2 !== t[2]) return !1;
        var e = t[3];
        if (0 === e) return !1;
        if (5 + e >= t.length) return !1;
        if (2 !== t[4 + e]) return !1;
        var r = t[5 + e];
        return 0 !== r && 6 + e + r === t.length && !(128 & t[4]) && !(e > 1 && 0 === t[4] && !(128 & t[5])) && !(128 & t[e + 6]) && !(r > 1 && 0 === t[e + 6] && !(128 & t[e + 7]));
      },
      decode: function decode(t) {
        if (t.length < 8) throw new Error("DER sequence length is too short");
        if (t.length > 72) throw new Error("DER sequence length is too long");
        if (48 !== t[0]) throw new Error("Expected DER sequence");
        if (t[1] !== t.length - 2) throw new Error("DER sequence length is invalid");
        if (2 !== t[2]) throw new Error("Expected DER integer");
        var e = t[3];
        if (0 === e) throw new Error("R length is zero");
        if (5 + e >= t.length) throw new Error("R length is too long");
        if (2 !== t[4 + e]) throw new Error("Expected DER integer (2)");
        var r = t[5 + e];
        if (0 === r) throw new Error("S length is zero");
        if (6 + e + r !== t.length) throw new Error("S length is invalid");
        if (128 & t[4]) throw new Error("R value is negative");
        if (e > 1 && 0 === t[4] && !(128 & t[5])) throw new Error("R value excessively padded");
        if (128 & t[e + 6]) throw new Error("S value is negative");
        if (r > 1 && 0 === t[e + 6] && !(128 & t[e + 7])) throw new Error("S value excessively padded");
        return {
          r: t.slice(4, 4 + e),
          s: t.slice(6 + e)
        };
      },
      encode: function encode(t, e) {
        var r = t.length,
            i = e.length;
        if (0 === r) throw new Error("R length is zero");
        if (0 === i) throw new Error("S length is zero");
        if (r > 33) throw new Error("R length is too long");
        if (i > 33) throw new Error("S length is too long");
        if (128 & t[0]) throw new Error("R value is negative");
        if (128 & e[0]) throw new Error("S value is negative");
        if (r > 1 && 0 === t[0] && !(128 & t[1])) throw new Error("R value excessively padded");
        if (i > 1 && 0 === e[0] && !(128 & e[1])) throw new Error("S value excessively padded");
        var o = n.allocUnsafe(6 + r + i);
        return o[0] = 48, o[1] = o.length - 2, o[2] = 2, o[3] = t.length, t.copy(o, 4), o[4 + r] = 2, o[5 + r] = e.length, e.copy(o, 6 + r), o;
      }
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(1).Buffer,
        i = r(35),
        o = r(3),
        s = r(133).ec,
        a = r(59),
        u = new s("secp256k1"),
        f = u.curve;

    function c(t) {
      var e = t[0];

      switch (e) {
        case 2:
        case 3:
          return 33 !== t.length ? null : function (t, e) {
            var r = new o(e);
            if (r.cmp(f.p) >= 0) return null;
            var n = (r = r.toRed(f.red)).redSqr().redIMul(r).redIAdd(f.b).redSqrt();
            return 3 === t !== n.isOdd() && (n = n.redNeg()), u.keyPair({
              pub: {
                x: r,
                y: n
              }
            });
          }(e, t.slice(1, 33));

        case 4:
        case 6:
        case 7:
          return 65 !== t.length ? null : function (t, e, r) {
            var n = new o(e),
                i = new o(r);
            if (n.cmp(f.p) >= 0 || i.cmp(f.p) >= 0) return null;
            if (n = n.toRed(f.red), i = i.toRed(f.red), (6 === t || 7 === t) && i.isOdd() !== (7 === t)) return null;
            var s = n.redSqr().redIMul(n);
            return i.redSqr().redISub(s.redIAdd(f.b)).isZero() ? u.keyPair({
              pub: {
                x: n,
                y: i
              }
            }) : null;
          }(e, t.slice(1, 33), t.slice(33, 65));

        default:
          return null;
      }
    }

    e.privateKeyVerify = function (t) {
      var e = new o(t);
      return e.cmp(f.n) < 0 && !e.isZero();
    }, e.privateKeyExport = function (t, e) {
      var r = new o(t);
      if (r.cmp(f.n) >= 0 || r.isZero()) throw new Error(a.EC_PRIVATE_KEY_EXPORT_DER_FAIL);
      return n.from(u.keyFromPrivate(t).getPublic(e, !0));
    }, e.privateKeyNegate = function (t) {
      var e = new o(t);
      return e.isZero() ? n.alloc(32) : f.n.sub(e).umod(f.n).toArrayLike(n, "be", 32);
    }, e.privateKeyModInverse = function (t) {
      var e = new o(t);
      if (e.cmp(f.n) >= 0 || e.isZero()) throw new Error(a.EC_PRIVATE_KEY_RANGE_INVALID);
      return e.invm(f.n).toArrayLike(n, "be", 32);
    }, e.privateKeyTweakAdd = function (t, e) {
      var r = new o(e);
      if (r.cmp(f.n) >= 0) throw new Error(a.EC_PRIVATE_KEY_TWEAK_ADD_FAIL);
      if (r.iadd(new o(t)), r.cmp(f.n) >= 0 && r.isub(f.n), r.isZero()) throw new Error(a.EC_PRIVATE_KEY_TWEAK_ADD_FAIL);
      return r.toArrayLike(n, "be", 32);
    }, e.privateKeyTweakMul = function (t, e) {
      var r = new o(e);
      if (r.cmp(f.n) >= 0 || r.isZero()) throw new Error(a.EC_PRIVATE_KEY_TWEAK_MUL_FAIL);
      return r.imul(new o(t)), r.cmp(f.n) && (r = r.umod(f.n)), r.toArrayLike(n, "be", 32);
    }, e.publicKeyCreate = function (t, e) {
      var r = new o(t);
      if (r.cmp(f.n) >= 0 || r.isZero()) throw new Error(a.EC_PUBLIC_KEY_CREATE_FAIL);
      return n.from(u.keyFromPrivate(t).getPublic(e, !0));
    }, e.publicKeyConvert = function (t, e) {
      var r = c(t);
      if (null === r) throw new Error(a.EC_PUBLIC_KEY_PARSE_FAIL);
      return n.from(r.getPublic(e, !0));
    }, e.publicKeyVerify = function (t) {
      return null !== c(t);
    }, e.publicKeyTweakAdd = function (t, e, r) {
      var i = c(t);
      if (null === i) throw new Error(a.EC_PUBLIC_KEY_PARSE_FAIL);
      if ((e = new o(e)).cmp(f.n) >= 0) throw new Error(a.EC_PUBLIC_KEY_TWEAK_ADD_FAIL);
      var s = f.g.mul(e).add(i.pub);
      if (s.isInfinity()) throw new Error(a.EC_PUBLIC_KEY_TWEAK_ADD_FAIL);
      return n.from(s.encode(!0, r));
    }, e.publicKeyTweakMul = function (t, e, r) {
      var i = c(t);
      if (null === i) throw new Error(a.EC_PUBLIC_KEY_PARSE_FAIL);
      if ((e = new o(e)).cmp(f.n) >= 0 || e.isZero()) throw new Error(a.EC_PUBLIC_KEY_TWEAK_MUL_FAIL);
      return n.from(i.pub.mul(e).encode(!0, r));
    }, e.publicKeyCombine = function (t, e) {
      for (var r = new Array(t.length), i = 0; i < t.length; ++i) {
        if (r[i] = c(t[i]), null === r[i]) throw new Error(a.EC_PUBLIC_KEY_PARSE_FAIL);
      }

      for (var o = r[0].pub, s = 1; s < r.length; ++s) {
        o = o.add(r[s].pub);
      }

      if (o.isInfinity()) throw new Error(a.EC_PUBLIC_KEY_COMBINE_FAIL);
      return n.from(o.encode(!0, e));
    }, e.signatureNormalize = function (t) {
      var e = new o(t.slice(0, 32)),
          r = new o(t.slice(32, 64));
      if (e.cmp(f.n) >= 0 || r.cmp(f.n) >= 0) throw new Error(a.ECDSA_SIGNATURE_PARSE_FAIL);
      var i = n.from(t);
      return 1 === r.cmp(u.nh) && f.n.sub(r).toArrayLike(n, "be", 32).copy(i, 32), i;
    }, e.signatureExport = function (t) {
      var e = t.slice(0, 32),
          r = t.slice(32, 64);
      if (new o(e).cmp(f.n) >= 0 || new o(r).cmp(f.n) >= 0) throw new Error(a.ECDSA_SIGNATURE_PARSE_FAIL);
      return {
        r: e,
        s: r
      };
    }, e.signatureImport = function (t) {
      var e = new o(t.r);
      e.cmp(f.n) >= 0 && (e = new o(0));
      var r = new o(t.s);
      return r.cmp(f.n) >= 0 && (r = new o(0)), n.concat([e.toArrayLike(n, "be", 32), r.toArrayLike(n, "be", 32)]);
    }, e.sign = function (t, e, r, i) {
      if ("function" == typeof r) {
        var s = r;

        r = function r(_r19) {
          var u = s(t, e, null, i, _r19);
          if (!n.isBuffer(u) || 32 !== u.length) throw new Error(a.ECDSA_SIGN_FAIL);
          return new o(u);
        };
      }

      var c = new o(e);
      if (c.cmp(f.n) >= 0 || c.isZero()) throw new Error(a.ECDSA_SIGN_FAIL);
      var h = u.sign(t, e, {
        canonical: !0,
        k: r,
        pers: i
      });
      return {
        signature: n.concat([h.r.toArrayLike(n, "be", 32), h.s.toArrayLike(n, "be", 32)]),
        recovery: h.recoveryParam
      };
    }, e.verify = function (t, e, r) {
      var n = {
        r: e.slice(0, 32),
        s: e.slice(32, 64)
      },
          i = new o(n.r),
          s = new o(n.s);
      if (i.cmp(f.n) >= 0 || s.cmp(f.n) >= 0) throw new Error(a.ECDSA_SIGNATURE_PARSE_FAIL);
      if (1 === s.cmp(u.nh) || i.isZero() || s.isZero()) return !1;
      var h = c(r);
      if (null === h) throw new Error(a.EC_PUBLIC_KEY_PARSE_FAIL);
      return u.verify(t, n, {
        x: h.pub.x,
        y: h.pub.y
      });
    }, e.recover = function (t, e, r, i) {
      var s = {
        r: e.slice(0, 32),
        s: e.slice(32, 64)
      },
          c = new o(s.r),
          h = new o(s.s);
      if (c.cmp(f.n) >= 0 || h.cmp(f.n) >= 0) throw new Error(a.ECDSA_SIGNATURE_PARSE_FAIL);

      try {
        if (c.isZero() || h.isZero()) throw new Error();
        var l = u.recoverPubKey(t, s, r);
        return n.from(l.encode(!0, i));
      } catch (t) {
        throw new Error(a.ECDSA_RECOVER_FAIL);
      }
    }, e.ecdh = function (t, r) {
      var n = e.ecdhUnsafe(t, r, !0);
      return i("sha256").update(n).digest();
    }, e.ecdhUnsafe = function (t, e, r) {
      var i = c(t);
      if (null === i) throw new Error(a.EC_PUBLIC_KEY_PARSE_FAIL);
      var s = new o(e);
      if (s.cmp(f.n) >= 0 || s.isZero()) throw new Error(a.ECDH_FAIL);
      return n.from(i.pub.mul(s).encode(!0, r));
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(0),
        i = r(60),
        o = r(1).Buffer,
        s = new Array(16);

    function a() {
      i.call(this, 64), this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878;
    }

    function u(t, e) {
      return t << e | t >>> 32 - e;
    }

    function f(t, e, r, n, i, o, s) {
      return u(t + (e & r | ~e & n) + i + o | 0, s) + e | 0;
    }

    function c(t, e, r, n, i, o, s) {
      return u(t + (e & n | r & ~n) + i + o | 0, s) + e | 0;
    }

    function h(t, e, r, n, i, o, s) {
      return u(t + (e ^ r ^ n) + i + o | 0, s) + e | 0;
    }

    function l(t, e, r, n, i, o, s) {
      return u(t + (r ^ (e | ~n)) + i + o | 0, s) + e | 0;
    }

    n(a, i), a.prototype._update = function () {
      for (var t = s, e = 0; e < 16; ++e) {
        t[e] = this._block.readInt32LE(4 * e);
      }

      var r = this._a,
          n = this._b,
          i = this._c,
          o = this._d;
      r = f(r, n, i, o, t[0], 3614090360, 7), o = f(o, r, n, i, t[1], 3905402710, 12), i = f(i, o, r, n, t[2], 606105819, 17), n = f(n, i, o, r, t[3], 3250441966, 22), r = f(r, n, i, o, t[4], 4118548399, 7), o = f(o, r, n, i, t[5], 1200080426, 12), i = f(i, o, r, n, t[6], 2821735955, 17), n = f(n, i, o, r, t[7], 4249261313, 22), r = f(r, n, i, o, t[8], 1770035416, 7), o = f(o, r, n, i, t[9], 2336552879, 12), i = f(i, o, r, n, t[10], 4294925233, 17), n = f(n, i, o, r, t[11], 2304563134, 22), r = f(r, n, i, o, t[12], 1804603682, 7), o = f(o, r, n, i, t[13], 4254626195, 12), i = f(i, o, r, n, t[14], 2792965006, 17), r = c(r, n = f(n, i, o, r, t[15], 1236535329, 22), i, o, t[1], 4129170786, 5), o = c(o, r, n, i, t[6], 3225465664, 9), i = c(i, o, r, n, t[11], 643717713, 14), n = c(n, i, o, r, t[0], 3921069994, 20), r = c(r, n, i, o, t[5], 3593408605, 5), o = c(o, r, n, i, t[10], 38016083, 9), i = c(i, o, r, n, t[15], 3634488961, 14), n = c(n, i, o, r, t[4], 3889429448, 20), r = c(r, n, i, o, t[9], 568446438, 5), o = c(o, r, n, i, t[14], 3275163606, 9), i = c(i, o, r, n, t[3], 4107603335, 14), n = c(n, i, o, r, t[8], 1163531501, 20), r = c(r, n, i, o, t[13], 2850285829, 5), o = c(o, r, n, i, t[2], 4243563512, 9), i = c(i, o, r, n, t[7], 1735328473, 14), r = h(r, n = c(n, i, o, r, t[12], 2368359562, 20), i, o, t[5], 4294588738, 4), o = h(o, r, n, i, t[8], 2272392833, 11), i = h(i, o, r, n, t[11], 1839030562, 16), n = h(n, i, o, r, t[14], 4259657740, 23), r = h(r, n, i, o, t[1], 2763975236, 4), o = h(o, r, n, i, t[4], 1272893353, 11), i = h(i, o, r, n, t[7], 4139469664, 16), n = h(n, i, o, r, t[10], 3200236656, 23), r = h(r, n, i, o, t[13], 681279174, 4), o = h(o, r, n, i, t[0], 3936430074, 11), i = h(i, o, r, n, t[3], 3572445317, 16), n = h(n, i, o, r, t[6], 76029189, 23), r = h(r, n, i, o, t[9], 3654602809, 4), o = h(o, r, n, i, t[12], 3873151461, 11), i = h(i, o, r, n, t[15], 530742520, 16), r = l(r, n = h(n, i, o, r, t[2], 3299628645, 23), i, o, t[0], 4096336452, 6), o = l(o, r, n, i, t[7], 1126891415, 10), i = l(i, o, r, n, t[14], 2878612391, 15), n = l(n, i, o, r, t[5], 4237533241, 21), r = l(r, n, i, o, t[12], 1700485571, 6), o = l(o, r, n, i, t[3], 2399980690, 10), i = l(i, o, r, n, t[10], 4293915773, 15), n = l(n, i, o, r, t[1], 2240044497, 21), r = l(r, n, i, o, t[8], 1873313359, 6), o = l(o, r, n, i, t[15], 4264355552, 10), i = l(i, o, r, n, t[6], 2734768916, 15), n = l(n, i, o, r, t[13], 1309151649, 21), r = l(r, n, i, o, t[4], 4149444226, 6), o = l(o, r, n, i, t[11], 3174756917, 10), i = l(i, o, r, n, t[2], 718787259, 15), n = l(n, i, o, r, t[9], 3951481745, 21), this._a = this._a + r | 0, this._b = this._b + n | 0, this._c = this._c + i | 0, this._d = this._d + o | 0;
    }, a.prototype._digest = function () {
      this._block[this._blockOffset++] = 128, this._blockOffset > 56 && (this._block.fill(0, this._blockOffset, 64), this._update(), this._blockOffset = 0), this._block.fill(0, this._blockOffset, 56), this._block.writeUInt32LE(this._length[0], 56), this._block.writeUInt32LE(this._length[1], 60), this._update();
      var t = o.allocUnsafe(16);
      return t.writeInt32LE(this._a, 0), t.writeInt32LE(this._b, 4), t.writeInt32LE(this._c, 8), t.writeInt32LE(this._d, 12), t;
    }, t.exports = a;
  }, function (t, e, r) {
    "use strict";

    var n = r(2).Buffer,
        i = r(0),
        o = r(60),
        s = new Array(16),
        a = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8, 3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12, 1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2, 4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13],
        u = [5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12, 6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2, 15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13, 8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14, 12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11],
        f = [11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8, 7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12, 11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5, 11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12, 9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6],
        c = [8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6, 9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11, 9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5, 15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8, 8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11],
        h = [0, 1518500249, 1859775393, 2400959708, 2840853838],
        l = [1352829926, 1548603684, 1836072691, 2053994217, 0];

    function d() {
      o.call(this, 64), this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520;
    }

    function p(t, e) {
      return t << e | t >>> 32 - e;
    }

    function g(t, e, r, n, i, o, s, a) {
      return p(t + (e ^ r ^ n) + o + s | 0, a) + i | 0;
    }

    function m(t, e, r, n, i, o, s, a) {
      return p(t + (e & r | ~e & n) + o + s | 0, a) + i | 0;
    }

    function b(t, e, r, n, i, o, s, a) {
      return p(t + ((e | ~r) ^ n) + o + s | 0, a) + i | 0;
    }

    function v(t, e, r, n, i, o, s, a) {
      return p(t + (e & n | r & ~n) + o + s | 0, a) + i | 0;
    }

    function y(t, e, r, n, i, o, s, a) {
      return p(t + (e ^ (r | ~n)) + o + s | 0, a) + i | 0;
    }

    i(d, o), d.prototype._update = function () {
      for (var t = s, e = 0; e < 16; ++e) {
        t[e] = this._block.readInt32LE(4 * e);
      }

      for (var r = 0 | this._a, n = 0 | this._b, i = 0 | this._c, o = 0 | this._d, d = 0 | this._e, _ = 0 | this._a, w = 0 | this._b, E = 0 | this._c, M = 0 | this._d, S = 0 | this._e, A = 0; A < 80; A += 1) {
        var x, R;
        A < 16 ? (x = g(r, n, i, o, d, t[a[A]], h[0], f[A]), R = y(_, w, E, M, S, t[u[A]], l[0], c[A])) : A < 32 ? (x = m(r, n, i, o, d, t[a[A]], h[1], f[A]), R = v(_, w, E, M, S, t[u[A]], l[1], c[A])) : A < 48 ? (x = b(r, n, i, o, d, t[a[A]], h[2], f[A]), R = b(_, w, E, M, S, t[u[A]], l[2], c[A])) : A < 64 ? (x = v(r, n, i, o, d, t[a[A]], h[3], f[A]), R = m(_, w, E, M, S, t[u[A]], l[3], c[A])) : (x = y(r, n, i, o, d, t[a[A]], h[4], f[A]), R = g(_, w, E, M, S, t[u[A]], l[4], c[A])), r = d, d = o, o = p(i, 10), i = n, n = x, _ = S, S = M, M = p(E, 10), E = w, w = R;
      }

      var T = this._b + i + M | 0;
      this._b = this._c + o + S | 0, this._c = this._d + d + _ | 0, this._d = this._e + r + w | 0, this._e = this._a + n + E | 0, this._a = T;
    }, d.prototype._digest = function () {
      this._block[this._blockOffset++] = 128, this._blockOffset > 56 && (this._block.fill(0, this._blockOffset, 64), this._update(), this._blockOffset = 0), this._block.fill(0, this._blockOffset, 56), this._block.writeUInt32LE(this._length[0], 56), this._block.writeUInt32LE(this._length[1], 60), this._update();
      var t = n.alloc ? n.alloc(20) : new n(20);
      return t.writeInt32LE(this._a, 0), t.writeInt32LE(this._b, 4), t.writeInt32LE(this._c, 8), t.writeInt32LE(this._d, 12), t.writeInt32LE(this._e, 16), t;
    }, t.exports = d;
  }, function (t, e, r) {
    (e = t.exports = function (t) {
      t = t.toLowerCase();
      var r = e[t];
      if (!r) throw new Error(t + " is not supported (we accept pull requests)");
      return new r();
    }).sha = r(127), e.sha1 = r(128), e.sha224 = r(129), e.sha256 = r(61), e.sha384 = r(130), e.sha512 = r(62);
  }, function (t, e, r) {
    var n = r(0),
        i = r(14),
        o = r(1).Buffer,
        s = [1518500249, 1859775393, -1894007588, -899497514],
        a = new Array(80);

    function u() {
      this.init(), this._w = a, i.call(this, 64, 56);
    }

    function f(t) {
      return t << 30 | t >>> 2;
    }

    function c(t, e, r, n) {
      return 0 === t ? e & r | ~e & n : 2 === t ? e & r | e & n | r & n : e ^ r ^ n;
    }

    n(u, i), u.prototype.init = function () {
      return this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520, this;
    }, u.prototype._update = function (t) {
      for (var e, r = this._w, n = 0 | this._a, i = 0 | this._b, o = 0 | this._c, a = 0 | this._d, u = 0 | this._e, h = 0; h < 16; ++h) {
        r[h] = t.readInt32BE(4 * h);
      }

      for (; h < 80; ++h) {
        r[h] = r[h - 3] ^ r[h - 8] ^ r[h - 14] ^ r[h - 16];
      }

      for (var l = 0; l < 80; ++l) {
        var d = ~~(l / 20),
            p = 0 | ((e = n) << 5 | e >>> 27) + c(d, i, o, a) + u + r[l] + s[d];
        u = a, a = o, o = f(i), i = n, n = p;
      }

      this._a = n + this._a | 0, this._b = i + this._b | 0, this._c = o + this._c | 0, this._d = a + this._d | 0, this._e = u + this._e | 0;
    }, u.prototype._hash = function () {
      var t = o.allocUnsafe(20);
      return t.writeInt32BE(0 | this._a, 0), t.writeInt32BE(0 | this._b, 4), t.writeInt32BE(0 | this._c, 8), t.writeInt32BE(0 | this._d, 12), t.writeInt32BE(0 | this._e, 16), t;
    }, t.exports = u;
  }, function (t, e, r) {
    var n = r(0),
        i = r(14),
        o = r(1).Buffer,
        s = [1518500249, 1859775393, -1894007588, -899497514],
        a = new Array(80);

    function u() {
      this.init(), this._w = a, i.call(this, 64, 56);
    }

    function f(t) {
      return t << 5 | t >>> 27;
    }

    function c(t) {
      return t << 30 | t >>> 2;
    }

    function h(t, e, r, n) {
      return 0 === t ? e & r | ~e & n : 2 === t ? e & r | e & n | r & n : e ^ r ^ n;
    }

    n(u, i), u.prototype.init = function () {
      return this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520, this;
    }, u.prototype._update = function (t) {
      for (var e, r = this._w, n = 0 | this._a, i = 0 | this._b, o = 0 | this._c, a = 0 | this._d, u = 0 | this._e, l = 0; l < 16; ++l) {
        r[l] = t.readInt32BE(4 * l);
      }

      for (; l < 80; ++l) {
        r[l] = (e = r[l - 3] ^ r[l - 8] ^ r[l - 14] ^ r[l - 16]) << 1 | e >>> 31;
      }

      for (var d = 0; d < 80; ++d) {
        var p = ~~(d / 20),
            g = f(n) + h(p, i, o, a) + u + r[d] + s[p] | 0;
        u = a, a = o, o = c(i), i = n, n = g;
      }

      this._a = n + this._a | 0, this._b = i + this._b | 0, this._c = o + this._c | 0, this._d = a + this._d | 0, this._e = u + this._e | 0;
    }, u.prototype._hash = function () {
      var t = o.allocUnsafe(20);
      return t.writeInt32BE(0 | this._a, 0), t.writeInt32BE(0 | this._b, 4), t.writeInt32BE(0 | this._c, 8), t.writeInt32BE(0 | this._d, 12), t.writeInt32BE(0 | this._e, 16), t;
    }, t.exports = u;
  }, function (t, e, r) {
    var n = r(0),
        i = r(61),
        o = r(14),
        s = r(1).Buffer,
        a = new Array(64);

    function u() {
      this.init(), this._w = a, o.call(this, 64, 56);
    }

    n(u, i), u.prototype.init = function () {
      return this._a = 3238371032, this._b = 914150663, this._c = 812702999, this._d = 4144912697, this._e = 4290775857, this._f = 1750603025, this._g = 1694076839, this._h = 3204075428, this;
    }, u.prototype._hash = function () {
      var t = s.allocUnsafe(28);
      return t.writeInt32BE(this._a, 0), t.writeInt32BE(this._b, 4), t.writeInt32BE(this._c, 8), t.writeInt32BE(this._d, 12), t.writeInt32BE(this._e, 16), t.writeInt32BE(this._f, 20), t.writeInt32BE(this._g, 24), t;
    }, t.exports = u;
  }, function (t, e, r) {
    var n = r(0),
        i = r(62),
        o = r(14),
        s = r(1).Buffer,
        a = new Array(160);

    function u() {
      this.init(), this._w = a, o.call(this, 128, 112);
    }

    n(u, i), u.prototype.init = function () {
      return this._ah = 3418070365, this._bh = 1654270250, this._ch = 2438529370, this._dh = 355462360, this._eh = 1731405415, this._fh = 2394180231, this._gh = 3675008525, this._hh = 1203062813, this._al = 3238371032, this._bl = 914150663, this._cl = 812702999, this._dl = 4144912697, this._el = 4290775857, this._fl = 1750603025, this._gl = 1694076839, this._hl = 3204075428, this;
    }, u.prototype._hash = function () {
      var t = s.allocUnsafe(48);

      function e(e, r, n) {
        t.writeInt32BE(e, n), t.writeInt32BE(r, n + 4);
      }

      return e(this._ah, this._al, 0), e(this._bh, this._bl, 8), e(this._ch, this._cl, 16), e(this._dh, this._dl, 24), e(this._eh, this._el, 32), e(this._fh, this._fl, 40), t;
    }, t.exports = u;
  }, function (t, e, r) {
    var n = r(1).Buffer,
        i = r(13).Transform,
        o = r(34).StringDecoder;

    function s(t) {
      i.call(this), this.hashMode = "string" == typeof t, this.hashMode ? this[t] = this._finalOrDigest : this.final = this._finalOrDigest, this._final && (this.__final = this._final, this._final = null), this._decoder = null, this._encoding = null;
    }

    r(0)(s, i), s.prototype.update = function (t, e, r) {
      "string" == typeof t && (t = n.from(t, e));

      var i = this._update(t);

      return this.hashMode ? this : (r && (i = this._toString(i, r)), i);
    }, s.prototype.setAutoPadding = function () {}, s.prototype.getAuthTag = function () {
      throw new Error("trying to get auth tag in unsupported state");
    }, s.prototype.setAuthTag = function () {
      throw new Error("trying to set auth tag in unsupported state");
    }, s.prototype.setAAD = function () {
      throw new Error("trying to set aad in unsupported state");
    }, s.prototype._transform = function (t, e, r) {
      var n;

      try {
        this.hashMode ? this._update(t) : this.push(this._update(t));
      } catch (t) {
        n = t;
      } finally {
        r(n);
      }
    }, s.prototype._flush = function (t) {
      var e;

      try {
        this.push(this.__final());
      } catch (t) {
        e = t;
      }

      t(e);
    }, s.prototype._finalOrDigest = function (t) {
      var e = this.__final() || n.alloc(0);
      return t && (e = this._toString(e, t, !0)), e;
    }, s.prototype._toString = function (t, e, r) {
      if (this._decoder || (this._decoder = new o(e), this._encoding = e), this._encoding !== e) throw new Error("can't switch encodings");

      var n = this._decoder.write(t);

      return r && (n += this._decoder.end()), n;
    }, t.exports = s;
  }, function (t, e) {}, function (t, e, r) {
    "use strict";

    var n = e;
    n.version = r(134).version, n.utils = r(5), n.rand = r(64), n.curve = r(65), n.curves = r(36), n.ec = r(146), n.eddsa = r(150);
  }, function (t) {
    t.exports = JSON.parse('{"_from":"elliptic@6.5.2","_id":"elliptic@6.5.2","_inBundle":false,"_integrity":"sha512-f4x70okzZbIQl/NSRLkI/+tteV/9WqL98zx+SQ69KbXxmVrmjwsNUPn/gYJJ0sHvEak24cZgHIPegRePAtA/xw==","_location":"/elliptic","_phantomChildren":{},"_requested":{"type":"version","registry":true,"raw":"elliptic@6.5.2","name":"elliptic","escapedName":"elliptic","rawSpec":"6.5.2","saveSpec":null,"fetchSpec":"6.5.2"},"_requiredBy":["/browserify-sign","/create-ecdh","/ethers","/secp256k1"],"_resolved":"https://registry.npmjs.org/elliptic/-/elliptic-6.5.2.tgz","_shasum":"05c5678d7173c049d8ca433552224a495d0e3762","_spec":"elliptic@6.5.2","_where":"/Users/pedrogomes/_walletconnect/walletconnect-monorepo/node_modules/ethers","author":{"name":"Fedor Indutny","email":"fedor@indutny.com"},"bugs":{"url":"https://github.com/indutny/elliptic/issues"},"bundleDependencies":false,"dependencies":{"bn.js":"^4.4.0","brorand":"^1.0.1","hash.js":"^1.0.0","hmac-drbg":"^1.0.0","inherits":"^2.0.1","minimalistic-assert":"^1.0.0","minimalistic-crypto-utils":"^1.0.0"},"deprecated":false,"description":"EC cryptography","devDependencies":{"brfs":"^1.4.3","coveralls":"^3.0.8","grunt":"^1.0.4","grunt-browserify":"^5.0.0","grunt-cli":"^1.2.0","grunt-contrib-connect":"^1.0.0","grunt-contrib-copy":"^1.0.0","grunt-contrib-uglify":"^1.0.1","grunt-mocha-istanbul":"^3.0.1","grunt-saucelabs":"^9.0.1","istanbul":"^0.4.2","jscs":"^3.0.7","jshint":"^2.10.3","mocha":"^6.2.2"},"files":["lib"],"homepage":"https://github.com/indutny/elliptic","keywords":["EC","Elliptic","curve","Cryptography"],"license":"MIT","main":"lib/elliptic.js","name":"elliptic","repository":{"type":"git","url":"git+ssh://git@github.com/indutny/elliptic.git"},"scripts":{"jscs":"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js","jshint":"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js","lint":"npm run jscs && npm run jshint","test":"npm run lint && npm run unit","unit":"istanbul test _mocha --reporter=spec test/index.js","version":"grunt dist && git add dist/"},"version":"6.5.2"}');
  }, function (t, e) {}, function (t, e, r) {
    "use strict";

    var n = r(5),
        i = r(3),
        o = r(0),
        s = r(27),
        a = n.assert;

    function u(t) {
      s.call(this, "short", t), this.a = new i(t.a, 16).toRed(this.red), this.b = new i(t.b, 16).toRed(this.red), this.tinv = this.two.redInvm(), this.zeroA = 0 === this.a.fromRed().cmpn(0), this.threeA = 0 === this.a.fromRed().sub(this.p).cmpn(-3), this.endo = this._getEndomorphism(t), this._endoWnafT1 = new Array(4), this._endoWnafT2 = new Array(4);
    }

    function f(t, e, r, n) {
      s.BasePoint.call(this, t, "affine"), null === e && null === r ? (this.x = null, this.y = null, this.inf = !0) : (this.x = new i(e, 16), this.y = new i(r, 16), n && (this.x.forceRed(this.curve.red), this.y.forceRed(this.curve.red)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.inf = !1);
    }

    function c(t, e, r, n) {
      s.BasePoint.call(this, t, "jacobian"), null === e && null === r && null === n ? (this.x = this.curve.one, this.y = this.curve.one, this.z = new i(0)) : (this.x = new i(e, 16), this.y = new i(r, 16), this.z = new i(n, 16)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)), this.zOne = this.z === this.curve.one;
    }

    o(u, s), t.exports = u, u.prototype._getEndomorphism = function (t) {
      if (this.zeroA && this.g && this.n && 1 === this.p.modn(3)) {
        var e, r;
        if (t.beta) e = new i(t.beta, 16).toRed(this.red);else {
          var n = this._getEndoRoots(this.p);

          e = (e = n[0].cmp(n[1]) < 0 ? n[0] : n[1]).toRed(this.red);
        }
        if (t.lambda) r = new i(t.lambda, 16);else {
          var o = this._getEndoRoots(this.n);

          0 === this.g.mul(o[0]).x.cmp(this.g.x.redMul(e)) ? r = o[0] : (r = o[1], a(0 === this.g.mul(r).x.cmp(this.g.x.redMul(e))));
        }
        return {
          beta: e,
          lambda: r,
          basis: t.basis ? t.basis.map(function (t) {
            return {
              a: new i(t.a, 16),
              b: new i(t.b, 16)
            };
          }) : this._getEndoBasis(r)
        };
      }
    }, u.prototype._getEndoRoots = function (t) {
      var e = t === this.p ? this.red : i.mont(t),
          r = new i(2).toRed(e).redInvm(),
          n = r.redNeg(),
          o = new i(3).toRed(e).redNeg().redSqrt().redMul(r);
      return [n.redAdd(o).fromRed(), n.redSub(o).fromRed()];
    }, u.prototype._getEndoBasis = function (t) {
      for (var e, r, n, o, s, a, u, f, c, h = this.n.ushrn(Math.floor(this.n.bitLength() / 2)), l = t, d = this.n.clone(), p = new i(1), g = new i(0), m = new i(0), b = new i(1), v = 0; 0 !== l.cmpn(0);) {
        var y = d.div(l);
        f = d.sub(y.mul(l)), c = m.sub(y.mul(p));

        var _ = b.sub(y.mul(g));

        if (!n && f.cmp(h) < 0) e = u.neg(), r = p, n = f.neg(), o = c;else if (n && 2 == ++v) break;
        u = f, d = l, l = f, m = p, p = c, b = g, g = _;
      }

      s = f.neg(), a = c;
      var w = n.sqr().add(o.sqr());
      return s.sqr().add(a.sqr()).cmp(w) >= 0 && (s = e, a = r), n.negative && (n = n.neg(), o = o.neg()), s.negative && (s = s.neg(), a = a.neg()), [{
        a: n,
        b: o
      }, {
        a: s,
        b: a
      }];
    }, u.prototype._endoSplit = function (t) {
      var e = this.endo.basis,
          r = e[0],
          n = e[1],
          i = n.b.mul(t).divRound(this.n),
          o = r.b.neg().mul(t).divRound(this.n),
          s = i.mul(r.a),
          a = o.mul(n.a),
          u = i.mul(r.b),
          f = o.mul(n.b);
      return {
        k1: t.sub(s).sub(a),
        k2: u.add(f).neg()
      };
    }, u.prototype.pointFromX = function (t, e) {
      (t = new i(t, 16)).red || (t = t.toRed(this.red));
      var r = t.redSqr().redMul(t).redIAdd(t.redMul(this.a)).redIAdd(this.b),
          n = r.redSqrt();
      if (0 !== n.redSqr().redSub(r).cmp(this.zero)) throw new Error("invalid point");
      var o = n.fromRed().isOdd();
      return (e && !o || !e && o) && (n = n.redNeg()), this.point(t, n);
    }, u.prototype.validate = function (t) {
      if (t.inf) return !0;
      var e = t.x,
          r = t.y,
          n = this.a.redMul(e),
          i = e.redSqr().redMul(e).redIAdd(n).redIAdd(this.b);
      return 0 === r.redSqr().redISub(i).cmpn(0);
    }, u.prototype._endoWnafMulAdd = function (t, e, r) {
      for (var n = this._endoWnafT1, i = this._endoWnafT2, o = 0; o < t.length; o++) {
        var s = this._endoSplit(e[o]),
            a = t[o],
            u = a._getBeta();

        s.k1.negative && (s.k1.ineg(), a = a.neg(!0)), s.k2.negative && (s.k2.ineg(), u = u.neg(!0)), n[2 * o] = a, n[2 * o + 1] = u, i[2 * o] = s.k1, i[2 * o + 1] = s.k2;
      }

      for (var f = this._wnafMulAdd(1, n, i, 2 * o, r), c = 0; c < 2 * o; c++) {
        n[c] = null, i[c] = null;
      }

      return f;
    }, o(f, s.BasePoint), u.prototype.point = function (t, e, r) {
      return new f(this, t, e, r);
    }, u.prototype.pointFromJSON = function (t, e) {
      return f.fromJSON(this, t, e);
    }, f.prototype._getBeta = function () {
      if (this.curve.endo) {
        var t = this.precomputed;
        if (t && t.beta) return t.beta;
        var e = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);

        if (t) {
          var r = this.curve,
              n = function n(t) {
            return r.point(t.x.redMul(r.endo.beta), t.y);
          };

          t.beta = e, e.precomputed = {
            beta: null,
            naf: t.naf && {
              wnd: t.naf.wnd,
              points: t.naf.points.map(n)
            },
            doubles: t.doubles && {
              step: t.doubles.step,
              points: t.doubles.points.map(n)
            }
          };
        }

        return e;
      }
    }, f.prototype.toJSON = function () {
      return this.precomputed ? [this.x, this.y, this.precomputed && {
        doubles: this.precomputed.doubles && {
          step: this.precomputed.doubles.step,
          points: this.precomputed.doubles.points.slice(1)
        },
        naf: this.precomputed.naf && {
          wnd: this.precomputed.naf.wnd,
          points: this.precomputed.naf.points.slice(1)
        }
      }] : [this.x, this.y];
    }, f.fromJSON = function (t, e, r) {
      "string" == typeof e && (e = JSON.parse(e));
      var n = t.point(e[0], e[1], r);
      if (!e[2]) return n;

      function i(e) {
        return t.point(e[0], e[1], r);
      }

      var o = e[2];
      return n.precomputed = {
        beta: null,
        doubles: o.doubles && {
          step: o.doubles.step,
          points: [n].concat(o.doubles.points.map(i))
        },
        naf: o.naf && {
          wnd: o.naf.wnd,
          points: [n].concat(o.naf.points.map(i))
        }
      }, n;
    }, f.prototype.inspect = function () {
      return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + ">";
    }, f.prototype.isInfinity = function () {
      return this.inf;
    }, f.prototype.add = function (t) {
      if (this.inf) return t;
      if (t.inf) return this;
      if (this.eq(t)) return this.dbl();
      if (this.neg().eq(t)) return this.curve.point(null, null);
      if (0 === this.x.cmp(t.x)) return this.curve.point(null, null);
      var e = this.y.redSub(t.y);
      0 !== e.cmpn(0) && (e = e.redMul(this.x.redSub(t.x).redInvm()));
      var r = e.redSqr().redISub(this.x).redISub(t.x),
          n = e.redMul(this.x.redSub(r)).redISub(this.y);
      return this.curve.point(r, n);
    }, f.prototype.dbl = function () {
      if (this.inf) return this;
      var t = this.y.redAdd(this.y);
      if (0 === t.cmpn(0)) return this.curve.point(null, null);
      var e = this.curve.a,
          r = this.x.redSqr(),
          n = t.redInvm(),
          i = r.redAdd(r).redIAdd(r).redIAdd(e).redMul(n),
          o = i.redSqr().redISub(this.x.redAdd(this.x)),
          s = i.redMul(this.x.redSub(o)).redISub(this.y);
      return this.curve.point(o, s);
    }, f.prototype.getX = function () {
      return this.x.fromRed();
    }, f.prototype.getY = function () {
      return this.y.fromRed();
    }, f.prototype.mul = function (t) {
      return t = new i(t, 16), this.isInfinity() ? this : this._hasDoubles(t) ? this.curve._fixedNafMul(this, t) : this.curve.endo ? this.curve._endoWnafMulAdd([this], [t]) : this.curve._wnafMul(this, t);
    }, f.prototype.mulAdd = function (t, e, r) {
      var n = [this, e],
          i = [t, r];
      return this.curve.endo ? this.curve._endoWnafMulAdd(n, i) : this.curve._wnafMulAdd(1, n, i, 2);
    }, f.prototype.jmulAdd = function (t, e, r) {
      var n = [this, e],
          i = [t, r];
      return this.curve.endo ? this.curve._endoWnafMulAdd(n, i, !0) : this.curve._wnafMulAdd(1, n, i, 2, !0);
    }, f.prototype.eq = function (t) {
      return this === t || this.inf === t.inf && (this.inf || 0 === this.x.cmp(t.x) && 0 === this.y.cmp(t.y));
    }, f.prototype.neg = function (t) {
      if (this.inf) return this;
      var e = this.curve.point(this.x, this.y.redNeg());

      if (t && this.precomputed) {
        var r = this.precomputed,
            n = function n(t) {
          return t.neg();
        };

        e.precomputed = {
          naf: r.naf && {
            wnd: r.naf.wnd,
            points: r.naf.points.map(n)
          },
          doubles: r.doubles && {
            step: r.doubles.step,
            points: r.doubles.points.map(n)
          }
        };
      }

      return e;
    }, f.prototype.toJ = function () {
      return this.inf ? this.curve.jpoint(null, null, null) : this.curve.jpoint(this.x, this.y, this.curve.one);
    }, o(c, s.BasePoint), u.prototype.jpoint = function (t, e, r) {
      return new c(this, t, e, r);
    }, c.prototype.toP = function () {
      if (this.isInfinity()) return this.curve.point(null, null);
      var t = this.z.redInvm(),
          e = t.redSqr(),
          r = this.x.redMul(e),
          n = this.y.redMul(e).redMul(t);
      return this.curve.point(r, n);
    }, c.prototype.neg = function () {
      return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
    }, c.prototype.add = function (t) {
      if (this.isInfinity()) return t;
      if (t.isInfinity()) return this;
      var e = t.z.redSqr(),
          r = this.z.redSqr(),
          n = this.x.redMul(e),
          i = t.x.redMul(r),
          o = this.y.redMul(e.redMul(t.z)),
          s = t.y.redMul(r.redMul(this.z)),
          a = n.redSub(i),
          u = o.redSub(s);
      if (0 === a.cmpn(0)) return 0 !== u.cmpn(0) ? this.curve.jpoint(null, null, null) : this.dbl();
      var f = a.redSqr(),
          c = f.redMul(a),
          h = n.redMul(f),
          l = u.redSqr().redIAdd(c).redISub(h).redISub(h),
          d = u.redMul(h.redISub(l)).redISub(o.redMul(c)),
          p = this.z.redMul(t.z).redMul(a);
      return this.curve.jpoint(l, d, p);
    }, c.prototype.mixedAdd = function (t) {
      if (this.isInfinity()) return t.toJ();
      if (t.isInfinity()) return this;
      var e = this.z.redSqr(),
          r = this.x,
          n = t.x.redMul(e),
          i = this.y,
          o = t.y.redMul(e).redMul(this.z),
          s = r.redSub(n),
          a = i.redSub(o);
      if (0 === s.cmpn(0)) return 0 !== a.cmpn(0) ? this.curve.jpoint(null, null, null) : this.dbl();
      var u = s.redSqr(),
          f = u.redMul(s),
          c = r.redMul(u),
          h = a.redSqr().redIAdd(f).redISub(c).redISub(c),
          l = a.redMul(c.redISub(h)).redISub(i.redMul(f)),
          d = this.z.redMul(s);
      return this.curve.jpoint(h, l, d);
    }, c.prototype.dblp = function (t) {
      if (0 === t) return this;
      if (this.isInfinity()) return this;
      if (!t) return this.dbl();

      if (this.curve.zeroA || this.curve.threeA) {
        for (var e = this, r = 0; r < t; r++) {
          e = e.dbl();
        }

        return e;
      }

      var n = this.curve.a,
          i = this.curve.tinv,
          o = this.x,
          s = this.y,
          a = this.z,
          u = a.redSqr().redSqr(),
          f = s.redAdd(s);

      for (r = 0; r < t; r++) {
        var c = o.redSqr(),
            h = f.redSqr(),
            l = h.redSqr(),
            d = c.redAdd(c).redIAdd(c).redIAdd(n.redMul(u)),
            p = o.redMul(h),
            g = d.redSqr().redISub(p.redAdd(p)),
            m = p.redISub(g),
            b = d.redMul(m);
        b = b.redIAdd(b).redISub(l);
        var v = f.redMul(a);
        r + 1 < t && (u = u.redMul(l)), o = g, a = v, f = b;
      }

      return this.curve.jpoint(o, f.redMul(i), a);
    }, c.prototype.dbl = function () {
      return this.isInfinity() ? this : this.curve.zeroA ? this._zeroDbl() : this.curve.threeA ? this._threeDbl() : this._dbl();
    }, c.prototype._zeroDbl = function () {
      var t, e, r;

      if (this.zOne) {
        var n = this.x.redSqr(),
            i = this.y.redSqr(),
            o = i.redSqr(),
            s = this.x.redAdd(i).redSqr().redISub(n).redISub(o);
        s = s.redIAdd(s);
        var a = n.redAdd(n).redIAdd(n),
            u = a.redSqr().redISub(s).redISub(s),
            f = o.redIAdd(o);
        f = (f = f.redIAdd(f)).redIAdd(f), t = u, e = a.redMul(s.redISub(u)).redISub(f), r = this.y.redAdd(this.y);
      } else {
        var c = this.x.redSqr(),
            h = this.y.redSqr(),
            l = h.redSqr(),
            d = this.x.redAdd(h).redSqr().redISub(c).redISub(l);
        d = d.redIAdd(d);
        var p = c.redAdd(c).redIAdd(c),
            g = p.redSqr(),
            m = l.redIAdd(l);
        m = (m = m.redIAdd(m)).redIAdd(m), t = g.redISub(d).redISub(d), e = p.redMul(d.redISub(t)).redISub(m), r = (r = this.y.redMul(this.z)).redIAdd(r);
      }

      return this.curve.jpoint(t, e, r);
    }, c.prototype._threeDbl = function () {
      var t, e, r;

      if (this.zOne) {
        var n = this.x.redSqr(),
            i = this.y.redSqr(),
            o = i.redSqr(),
            s = this.x.redAdd(i).redSqr().redISub(n).redISub(o);
        s = s.redIAdd(s);
        var a = n.redAdd(n).redIAdd(n).redIAdd(this.curve.a),
            u = a.redSqr().redISub(s).redISub(s);
        t = u;
        var f = o.redIAdd(o);
        f = (f = f.redIAdd(f)).redIAdd(f), e = a.redMul(s.redISub(u)).redISub(f), r = this.y.redAdd(this.y);
      } else {
        var c = this.z.redSqr(),
            h = this.y.redSqr(),
            l = this.x.redMul(h),
            d = this.x.redSub(c).redMul(this.x.redAdd(c));
        d = d.redAdd(d).redIAdd(d);
        var p = l.redIAdd(l),
            g = (p = p.redIAdd(p)).redAdd(p);
        t = d.redSqr().redISub(g), r = this.y.redAdd(this.z).redSqr().redISub(h).redISub(c);
        var m = h.redSqr();
        m = (m = (m = m.redIAdd(m)).redIAdd(m)).redIAdd(m), e = d.redMul(p.redISub(t)).redISub(m);
      }

      return this.curve.jpoint(t, e, r);
    }, c.prototype._dbl = function () {
      var t = this.curve.a,
          e = this.x,
          r = this.y,
          n = this.z,
          i = n.redSqr().redSqr(),
          o = e.redSqr(),
          s = r.redSqr(),
          a = o.redAdd(o).redIAdd(o).redIAdd(t.redMul(i)),
          u = e.redAdd(e),
          f = (u = u.redIAdd(u)).redMul(s),
          c = a.redSqr().redISub(f.redAdd(f)),
          h = f.redISub(c),
          l = s.redSqr();
      l = (l = (l = l.redIAdd(l)).redIAdd(l)).redIAdd(l);
      var d = a.redMul(h).redISub(l),
          p = r.redAdd(r).redMul(n);
      return this.curve.jpoint(c, d, p);
    }, c.prototype.trpl = function () {
      if (!this.curve.zeroA) return this.dbl().add(this);
      var t = this.x.redSqr(),
          e = this.y.redSqr(),
          r = this.z.redSqr(),
          n = e.redSqr(),
          i = t.redAdd(t).redIAdd(t),
          o = i.redSqr(),
          s = this.x.redAdd(e).redSqr().redISub(t).redISub(n),
          a = (s = (s = (s = s.redIAdd(s)).redAdd(s).redIAdd(s)).redISub(o)).redSqr(),
          u = n.redIAdd(n);
      u = (u = (u = u.redIAdd(u)).redIAdd(u)).redIAdd(u);
      var f = i.redIAdd(s).redSqr().redISub(o).redISub(a).redISub(u),
          c = e.redMul(f);
      c = (c = c.redIAdd(c)).redIAdd(c);
      var h = this.x.redMul(a).redISub(c);
      h = (h = h.redIAdd(h)).redIAdd(h);
      var l = this.y.redMul(f.redMul(u.redISub(f)).redISub(s.redMul(a)));
      l = (l = (l = l.redIAdd(l)).redIAdd(l)).redIAdd(l);
      var d = this.z.redAdd(s).redSqr().redISub(r).redISub(a);
      return this.curve.jpoint(h, l, d);
    }, c.prototype.mul = function (t, e) {
      return t = new i(t, e), this.curve._wnafMul(this, t);
    }, c.prototype.eq = function (t) {
      if ("affine" === t.type) return this.eq(t.toJ());
      if (this === t) return !0;
      var e = this.z.redSqr(),
          r = t.z.redSqr();
      if (0 !== this.x.redMul(r).redISub(t.x.redMul(e)).cmpn(0)) return !1;
      var n = e.redMul(this.z),
          i = r.redMul(t.z);
      return 0 === this.y.redMul(i).redISub(t.y.redMul(n)).cmpn(0);
    }, c.prototype.eqXToP = function (t) {
      var e = this.z.redSqr(),
          r = t.toRed(this.curve.red).redMul(e);
      if (0 === this.x.cmp(r)) return !0;

      for (var n = t.clone(), i = this.curve.redN.redMul(e);;) {
        if (n.iadd(this.curve.n), n.cmp(this.curve.p) >= 0) return !1;
        if (r.redIAdd(i), 0 === this.x.cmp(r)) return !0;
      }
    }, c.prototype.inspect = function () {
      return this.isInfinity() ? "<EC JPoint Infinity>" : "<EC JPoint x: " + this.x.toString(16, 2) + " y: " + this.y.toString(16, 2) + " z: " + this.z.toString(16, 2) + ">";
    }, c.prototype.isInfinity = function () {
      return 0 === this.z.cmpn(0);
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(3),
        i = r(0),
        o = r(27),
        s = r(5);

    function a(t) {
      o.call(this, "mont", t), this.a = new n(t.a, 16).toRed(this.red), this.b = new n(t.b, 16).toRed(this.red), this.i4 = new n(4).toRed(this.red).redInvm(), this.two = new n(2).toRed(this.red), this.a24 = this.i4.redMul(this.a.redAdd(this.two));
    }

    function u(t, e, r) {
      o.BasePoint.call(this, t, "projective"), null === e && null === r ? (this.x = this.curve.one, this.z = this.curve.zero) : (this.x = new n(e, 16), this.z = new n(r, 16), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)));
    }

    i(a, o), t.exports = a, a.prototype.validate = function (t) {
      var e = t.normalize().x,
          r = e.redSqr(),
          n = r.redMul(e).redAdd(r.redMul(this.a)).redAdd(e);
      return 0 === n.redSqrt().redSqr().cmp(n);
    }, i(u, o.BasePoint), a.prototype.decodePoint = function (t, e) {
      return this.point(s.toArray(t, e), 1);
    }, a.prototype.point = function (t, e) {
      return new u(this, t, e);
    }, a.prototype.pointFromJSON = function (t) {
      return u.fromJSON(this, t);
    }, u.prototype.precompute = function () {}, u.prototype._encode = function () {
      return this.getX().toArray("be", this.curve.p.byteLength());
    }, u.fromJSON = function (t, e) {
      return new u(t, e[0], e[1] || t.one);
    }, u.prototype.inspect = function () {
      return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
    }, u.prototype.isInfinity = function () {
      return 0 === this.z.cmpn(0);
    }, u.prototype.dbl = function () {
      var t = this.x.redAdd(this.z).redSqr(),
          e = this.x.redSub(this.z).redSqr(),
          r = t.redSub(e),
          n = t.redMul(e),
          i = r.redMul(e.redAdd(this.curve.a24.redMul(r)));
      return this.curve.point(n, i);
    }, u.prototype.add = function () {
      throw new Error("Not supported on Montgomery curve");
    }, u.prototype.diffAdd = function (t, e) {
      var r = this.x.redAdd(this.z),
          n = this.x.redSub(this.z),
          i = t.x.redAdd(t.z),
          o = t.x.redSub(t.z).redMul(r),
          s = i.redMul(n),
          a = e.z.redMul(o.redAdd(s).redSqr()),
          u = e.x.redMul(o.redISub(s).redSqr());
      return this.curve.point(a, u);
    }, u.prototype.mul = function (t) {
      for (var e = t.clone(), r = this, n = this.curve.point(null, null), i = []; 0 !== e.cmpn(0); e.iushrn(1)) {
        i.push(e.andln(1));
      }

      for (var o = i.length - 1; o >= 0; o--) {
        0 === i[o] ? (r = r.diffAdd(n, this), n = n.dbl()) : (n = r.diffAdd(n, this), r = r.dbl());
      }

      return n;
    }, u.prototype.mulAdd = function () {
      throw new Error("Not supported on Montgomery curve");
    }, u.prototype.jumlAdd = function () {
      throw new Error("Not supported on Montgomery curve");
    }, u.prototype.eq = function (t) {
      return 0 === this.getX().cmp(t.getX());
    }, u.prototype.normalize = function () {
      return this.x = this.x.redMul(this.z.redInvm()), this.z = this.curve.one, this;
    }, u.prototype.getX = function () {
      return this.normalize(), this.x.fromRed();
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(5),
        i = r(3),
        o = r(0),
        s = r(27),
        a = n.assert;

    function u(t) {
      this.twisted = 1 != (0 | t.a), this.mOneA = this.twisted && -1 == (0 | t.a), this.extended = this.mOneA, s.call(this, "edwards", t), this.a = new i(t.a, 16).umod(this.red.m), this.a = this.a.toRed(this.red), this.c = new i(t.c, 16).toRed(this.red), this.c2 = this.c.redSqr(), this.d = new i(t.d, 16).toRed(this.red), this.dd = this.d.redAdd(this.d), a(!this.twisted || 0 === this.c.fromRed().cmpn(1)), this.oneC = 1 == (0 | t.c);
    }

    function f(t, e, r, n, o) {
      s.BasePoint.call(this, t, "projective"), null === e && null === r && null === n ? (this.x = this.curve.zero, this.y = this.curve.one, this.z = this.curve.one, this.t = this.curve.zero, this.zOne = !0) : (this.x = new i(e, 16), this.y = new i(r, 16), this.z = n ? new i(n, 16) : this.curve.one, this.t = o && new i(o, 16), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)), this.t && !this.t.red && (this.t = this.t.toRed(this.curve.red)), this.zOne = this.z === this.curve.one, this.curve.extended && !this.t && (this.t = this.x.redMul(this.y), this.zOne || (this.t = this.t.redMul(this.z.redInvm()))));
    }

    o(u, s), t.exports = u, u.prototype._mulA = function (t) {
      return this.mOneA ? t.redNeg() : this.a.redMul(t);
    }, u.prototype._mulC = function (t) {
      return this.oneC ? t : this.c.redMul(t);
    }, u.prototype.jpoint = function (t, e, r, n) {
      return this.point(t, e, r, n);
    }, u.prototype.pointFromX = function (t, e) {
      (t = new i(t, 16)).red || (t = t.toRed(this.red));
      var r = t.redSqr(),
          n = this.c2.redSub(this.a.redMul(r)),
          o = this.one.redSub(this.c2.redMul(this.d).redMul(r)),
          s = n.redMul(o.redInvm()),
          a = s.redSqrt();
      if (0 !== a.redSqr().redSub(s).cmp(this.zero)) throw new Error("invalid point");
      var u = a.fromRed().isOdd();
      return (e && !u || !e && u) && (a = a.redNeg()), this.point(t, a);
    }, u.prototype.pointFromY = function (t, e) {
      (t = new i(t, 16)).red || (t = t.toRed(this.red));
      var r = t.redSqr(),
          n = r.redSub(this.c2),
          o = r.redMul(this.d).redMul(this.c2).redSub(this.a),
          s = n.redMul(o.redInvm());

      if (0 === s.cmp(this.zero)) {
        if (e) throw new Error("invalid point");
        return this.point(this.zero, t);
      }

      var a = s.redSqrt();
      if (0 !== a.redSqr().redSub(s).cmp(this.zero)) throw new Error("invalid point");
      return a.fromRed().isOdd() !== e && (a = a.redNeg()), this.point(a, t);
    }, u.prototype.validate = function (t) {
      if (t.isInfinity()) return !0;
      t.normalize();
      var e = t.x.redSqr(),
          r = t.y.redSqr(),
          n = e.redMul(this.a).redAdd(r),
          i = this.c2.redMul(this.one.redAdd(this.d.redMul(e).redMul(r)));
      return 0 === n.cmp(i);
    }, o(f, s.BasePoint), u.prototype.pointFromJSON = function (t) {
      return f.fromJSON(this, t);
    }, u.prototype.point = function (t, e, r, n) {
      return new f(this, t, e, r, n);
    }, f.fromJSON = function (t, e) {
      return new f(t, e[0], e[1], e[2]);
    }, f.prototype.inspect = function () {
      return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
    }, f.prototype.isInfinity = function () {
      return 0 === this.x.cmpn(0) && (0 === this.y.cmp(this.z) || this.zOne && 0 === this.y.cmp(this.curve.c));
    }, f.prototype._extDbl = function () {
      var t = this.x.redSqr(),
          e = this.y.redSqr(),
          r = this.z.redSqr();
      r = r.redIAdd(r);

      var n = this.curve._mulA(t),
          i = this.x.redAdd(this.y).redSqr().redISub(t).redISub(e),
          o = n.redAdd(e),
          s = o.redSub(r),
          a = n.redSub(e),
          u = i.redMul(s),
          f = o.redMul(a),
          c = i.redMul(a),
          h = s.redMul(o);

      return this.curve.point(u, f, h, c);
    }, f.prototype._projDbl = function () {
      var t,
          e,
          r,
          n = this.x.redAdd(this.y).redSqr(),
          i = this.x.redSqr(),
          o = this.y.redSqr();

      if (this.curve.twisted) {
        var s = (f = this.curve._mulA(i)).redAdd(o);

        if (this.zOne) t = n.redSub(i).redSub(o).redMul(s.redSub(this.curve.two)), e = s.redMul(f.redSub(o)), r = s.redSqr().redSub(s).redSub(s);else {
          var a = this.z.redSqr(),
              u = s.redSub(a).redISub(a);
          t = n.redSub(i).redISub(o).redMul(u), e = s.redMul(f.redSub(o)), r = s.redMul(u);
        }
      } else {
        var f = i.redAdd(o);
        a = this.curve._mulC(this.z).redSqr(), u = f.redSub(a).redSub(a);
        t = this.curve._mulC(n.redISub(f)).redMul(u), e = this.curve._mulC(f).redMul(i.redISub(o)), r = f.redMul(u);
      }

      return this.curve.point(t, e, r);
    }, f.prototype.dbl = function () {
      return this.isInfinity() ? this : this.curve.extended ? this._extDbl() : this._projDbl();
    }, f.prototype._extAdd = function (t) {
      var e = this.y.redSub(this.x).redMul(t.y.redSub(t.x)),
          r = this.y.redAdd(this.x).redMul(t.y.redAdd(t.x)),
          n = this.t.redMul(this.curve.dd).redMul(t.t),
          i = this.z.redMul(t.z.redAdd(t.z)),
          o = r.redSub(e),
          s = i.redSub(n),
          a = i.redAdd(n),
          u = r.redAdd(e),
          f = o.redMul(s),
          c = a.redMul(u),
          h = o.redMul(u),
          l = s.redMul(a);
      return this.curve.point(f, c, l, h);
    }, f.prototype._projAdd = function (t) {
      var e,
          r,
          n = this.z.redMul(t.z),
          i = n.redSqr(),
          o = this.x.redMul(t.x),
          s = this.y.redMul(t.y),
          a = this.curve.d.redMul(o).redMul(s),
          u = i.redSub(a),
          f = i.redAdd(a),
          c = this.x.redAdd(this.y).redMul(t.x.redAdd(t.y)).redISub(o).redISub(s),
          h = n.redMul(u).redMul(c);
      return this.curve.twisted ? (e = n.redMul(f).redMul(s.redSub(this.curve._mulA(o))), r = u.redMul(f)) : (e = n.redMul(f).redMul(s.redSub(o)), r = this.curve._mulC(u).redMul(f)), this.curve.point(h, e, r);
    }, f.prototype.add = function (t) {
      return this.isInfinity() ? t : t.isInfinity() ? this : this.curve.extended ? this._extAdd(t) : this._projAdd(t);
    }, f.prototype.mul = function (t) {
      return this._hasDoubles(t) ? this.curve._fixedNafMul(this, t) : this.curve._wnafMul(this, t);
    }, f.prototype.mulAdd = function (t, e, r) {
      return this.curve._wnafMulAdd(1, [this, e], [t, r], 2, !1);
    }, f.prototype.jmulAdd = function (t, e, r) {
      return this.curve._wnafMulAdd(1, [this, e], [t, r], 2, !0);
    }, f.prototype.normalize = function () {
      if (this.zOne) return this;
      var t = this.z.redInvm();
      return this.x = this.x.redMul(t), this.y = this.y.redMul(t), this.t && (this.t = this.t.redMul(t)), this.z = this.curve.one, this.zOne = !0, this;
    }, f.prototype.neg = function () {
      return this.curve.point(this.x.redNeg(), this.y, this.z, this.t && this.t.redNeg());
    }, f.prototype.getX = function () {
      return this.normalize(), this.x.fromRed();
    }, f.prototype.getY = function () {
      return this.normalize(), this.y.fromRed();
    }, f.prototype.eq = function (t) {
      return this === t || 0 === this.getX().cmp(t.getX()) && 0 === this.getY().cmp(t.getY());
    }, f.prototype.eqXToP = function (t) {
      var e = t.toRed(this.curve.red).redMul(this.z);
      if (0 === this.x.cmp(e)) return !0;

      for (var r = t.clone(), n = this.curve.redN.redMul(this.z);;) {
        if (r.iadd(this.curve.n), r.cmp(this.curve.p) >= 0) return !1;
        if (e.redIAdd(n), 0 === this.x.cmp(e)) return !0;
      }
    }, f.prototype.toP = f.prototype.normalize, f.prototype.mixedAdd = f.prototype.add;
  }, function (t, e, r) {
    "use strict";

    e.sha1 = r(140), e.sha224 = r(141), e.sha256 = r(67), e.sha384 = r(142), e.sha512 = r(68);
  }, function (t, e, r) {
    "use strict";

    var n = r(7),
        i = r(20),
        o = r(66),
        s = n.rotl32,
        a = n.sum32,
        u = n.sum32_5,
        f = o.ft_1,
        c = i.BlockHash,
        h = [1518500249, 1859775393, 2400959708, 3395469782];

    function l() {
      if (!(this instanceof l)) return new l();
      c.call(this), this.h = [1732584193, 4023233417, 2562383102, 271733878, 3285377520], this.W = new Array(80);
    }

    n.inherits(l, c), t.exports = l, l.blockSize = 512, l.outSize = 160, l.hmacStrength = 80, l.padLength = 64, l.prototype._update = function (t, e) {
      for (var r = this.W, n = 0; n < 16; n++) {
        r[n] = t[e + n];
      }

      for (; n < r.length; n++) {
        r[n] = s(r[n - 3] ^ r[n - 8] ^ r[n - 14] ^ r[n - 16], 1);
      }

      var i = this.h[0],
          o = this.h[1],
          c = this.h[2],
          l = this.h[3],
          d = this.h[4];

      for (n = 0; n < r.length; n++) {
        var p = ~~(n / 20),
            g = u(s(i, 5), f(p, o, c, l), d, r[n], h[p]);
        d = l, l = c, c = s(o, 30), o = i, i = g;
      }

      this.h[0] = a(this.h[0], i), this.h[1] = a(this.h[1], o), this.h[2] = a(this.h[2], c), this.h[3] = a(this.h[3], l), this.h[4] = a(this.h[4], d);
    }, l.prototype._digest = function (t) {
      return "hex" === t ? n.toHex32(this.h, "big") : n.split32(this.h, "big");
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(7),
        i = r(67);

    function o() {
      if (!(this instanceof o)) return new o();
      i.call(this), this.h = [3238371032, 914150663, 812702999, 4144912697, 4290775857, 1750603025, 1694076839, 3204075428];
    }

    n.inherits(o, i), t.exports = o, o.blockSize = 512, o.outSize = 224, o.hmacStrength = 192, o.padLength = 64, o.prototype._digest = function (t) {
      return "hex" === t ? n.toHex32(this.h.slice(0, 7), "big") : n.split32(this.h.slice(0, 7), "big");
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(7),
        i = r(68);

    function o() {
      if (!(this instanceof o)) return new o();
      i.call(this), this.h = [3418070365, 3238371032, 1654270250, 914150663, 2438529370, 812702999, 355462360, 4144912697, 1731405415, 4290775857, 2394180231, 1750603025, 3675008525, 1694076839, 1203062813, 3204075428];
    }

    n.inherits(o, i), t.exports = o, o.blockSize = 1024, o.outSize = 384, o.hmacStrength = 192, o.padLength = 128, o.prototype._digest = function (t) {
      return "hex" === t ? n.toHex32(this.h.slice(0, 12), "big") : n.split32(this.h.slice(0, 12), "big");
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(7),
        i = r(20),
        o = n.rotl32,
        s = n.sum32,
        a = n.sum32_3,
        u = n.sum32_4,
        f = i.BlockHash;

    function c() {
      if (!(this instanceof c)) return new c();
      f.call(this), this.h = [1732584193, 4023233417, 2562383102, 271733878, 3285377520], this.endian = "little";
    }

    function h(t, e, r, n) {
      return t <= 15 ? e ^ r ^ n : t <= 31 ? e & r | ~e & n : t <= 47 ? (e | ~r) ^ n : t <= 63 ? e & n | r & ~n : e ^ (r | ~n);
    }

    function l(t) {
      return t <= 15 ? 0 : t <= 31 ? 1518500249 : t <= 47 ? 1859775393 : t <= 63 ? 2400959708 : 2840853838;
    }

    function d(t) {
      return t <= 15 ? 1352829926 : t <= 31 ? 1548603684 : t <= 47 ? 1836072691 : t <= 63 ? 2053994217 : 0;
    }

    n.inherits(c, f), e.ripemd160 = c, c.blockSize = 512, c.outSize = 160, c.hmacStrength = 192, c.padLength = 64, c.prototype._update = function (t, e) {
      for (var r = this.h[0], n = this.h[1], i = this.h[2], f = this.h[3], c = this.h[4], v = r, y = n, _ = i, w = f, E = c, M = 0; M < 80; M++) {
        var S = s(o(u(r, h(M, n, i, f), t[p[M] + e], l(M)), m[M]), c);
        r = c, c = f, f = o(i, 10), i = n, n = S, S = s(o(u(v, h(79 - M, y, _, w), t[g[M] + e], d(M)), b[M]), E), v = E, E = w, w = o(_, 10), _ = y, y = S;
      }

      S = a(this.h[1], i, w), this.h[1] = a(this.h[2], f, E), this.h[2] = a(this.h[3], c, v), this.h[3] = a(this.h[4], r, y), this.h[4] = a(this.h[0], n, _), this.h[0] = S;
    }, c.prototype._digest = function (t) {
      return "hex" === t ? n.toHex32(this.h, "little") : n.split32(this.h, "little");
    };
    var p = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8, 3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12, 1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2, 4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13],
        g = [5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12, 6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2, 15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13, 8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14, 12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11],
        m = [11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8, 7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12, 11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5, 11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12, 9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6],
        b = [8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6, 9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11, 9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5, 15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8, 8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11];
  }, function (t, e, r) {
    "use strict";

    var n = r(7),
        i = r(11);

    function o(t, e, r) {
      if (!(this instanceof o)) return new o(t, e, r);
      this.Hash = t, this.blockSize = t.blockSize / 8, this.outSize = t.outSize / 8, this.inner = null, this.outer = null, this._init(n.toArray(e, r));
    }

    t.exports = o, o.prototype._init = function (t) {
      t.length > this.blockSize && (t = new this.Hash().update(t).digest()), i(t.length <= this.blockSize);

      for (var e = t.length; e < this.blockSize; e++) {
        t.push(0);
      }

      for (e = 0; e < t.length; e++) {
        t[e] ^= 54;
      }

      for (this.inner = new this.Hash().update(t), e = 0; e < t.length; e++) {
        t[e] ^= 106;
      }

      this.outer = new this.Hash().update(t);
    }, o.prototype.update = function (t, e) {
      return this.inner.update(t, e), this;
    }, o.prototype.digest = function (t) {
      return this.outer.update(this.inner.digest()), this.outer.digest(t);
    };
  }, function (t, e) {
    t.exports = {
      doubles: {
        step: 4,
        points: [["e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a", "f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821"], ["8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508", "11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf"], ["175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739", "d3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695"], ["363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640", "4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9"], ["8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c", "4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36"], ["723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda", "96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f"], ["eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa", "5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999"], ["100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0", "cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09"], ["e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d", "9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d"], ["feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d", "e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088"], ["da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1", "9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d"], ["53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0", "5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8"], ["8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047", "10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a"], ["385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862", "283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453"], ["6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7", "7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160"], ["3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd", "56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0"], ["85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83", "7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6"], ["948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a", "53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589"], ["6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8", "bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17"], ["e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d", "4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda"], ["e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725", "7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd"], ["213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754", "4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2"], ["4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c", "17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6"], ["fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6", "6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f"], ["76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39", "c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01"], ["c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891", "893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3"], ["d895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b", "febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f"], ["b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03", "2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7"], ["e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d", "eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78"], ["a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070", "7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1"], ["90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4", "e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150"], ["8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da", "662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82"], ["e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11", "1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc"], ["8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e", "efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b"], ["e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41", "2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51"], ["b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef", "67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45"], ["d68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8", "db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120"], ["324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d", "648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84"], ["4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96", "35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d"], ["9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd", "ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d"], ["6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5", "9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8"], ["a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266", "40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8"], ["7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71", "34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac"], ["928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac", "c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f"], ["85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751", "1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962"], ["ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e", "493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907"], ["827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241", "c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec"], ["eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3", "be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d"], ["e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f", "4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414"], ["1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19", "aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd"], ["146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be", "b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0"], ["fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9", "6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811"], ["da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2", "8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1"], ["a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13", "7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c"], ["174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c", "ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73"], ["959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba", "2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd"], ["d2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151", "e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405"], ["64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073", "d99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589"], ["8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458", "38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e"], ["13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b", "69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27"], ["bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366", "d3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1"], ["8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa", "40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482"], ["8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0", "620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945"], ["dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787", "7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573"], ["f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e", "ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82"]]
      },
      naf: {
        wnd: 7,
        points: [["f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9", "388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672"], ["2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4", "d8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6"], ["5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc", "6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da"], ["acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe", "cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37"], ["774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb", "d984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b"], ["f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8", "ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81"], ["d7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e", "581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58"], ["defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34", "4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77"], ["2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c", "85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a"], ["352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5", "321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c"], ["2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f", "2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67"], ["9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714", "73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402"], ["daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729", "a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55"], ["c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db", "2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482"], ["6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4", "e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82"], ["1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5", "b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396"], ["605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479", "2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49"], ["62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d", "80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf"], ["80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f", "1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a"], ["7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb", "d0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7"], ["d528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9", "eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933"], ["49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963", "758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a"], ["77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74", "958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6"], ["f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530", "e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37"], ["463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b", "5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e"], ["f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247", "cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6"], ["caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1", "cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476"], ["2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120", "4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40"], ["7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435", "91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61"], ["754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18", "673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683"], ["e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8", "59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5"], ["186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb", "3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b"], ["df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f", "55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417"], ["5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143", "efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868"], ["290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba", "e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a"], ["af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45", "f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6"], ["766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a", "744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996"], ["59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e", "c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e"], ["f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8", "e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d"], ["7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c", "30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2"], ["948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519", "e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e"], ["7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab", "100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437"], ["3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca", "ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311"], ["d3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf", "8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4"], ["1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610", "68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575"], ["733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4", "f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d"], ["15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c", "d56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d"], ["a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940", "edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629"], ["e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980", "a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06"], ["311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3", "66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374"], ["34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf", "9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee"], ["f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63", "4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1"], ["d7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448", "fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b"], ["32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf", "5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661"], ["7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5", "8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6"], ["ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6", "8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e"], ["16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5", "5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d"], ["eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99", "f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc"], ["78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51", "f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4"], ["494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5", "42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c"], ["a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5", "204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b"], ["c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997", "4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913"], ["841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881", "73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154"], ["5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5", "39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865"], ["36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66", "d2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc"], ["336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726", "ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224"], ["8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede", "6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e"], ["1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94", "60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6"], ["85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31", "3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511"], ["29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51", "b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b"], ["a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252", "ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2"], ["4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5", "cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c"], ["d24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b", "6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3"], ["ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4", "322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d"], ["af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f", "6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700"], ["e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889", "2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4"], ["591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246", "b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196"], ["11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984", "998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4"], ["3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a", "b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257"], ["cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030", "bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13"], ["c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197", "6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096"], ["c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593", "c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38"], ["a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef", "21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f"], ["347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38", "60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448"], ["da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a", "49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a"], ["c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111", "5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4"], ["4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502", "7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437"], ["3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea", "be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7"], ["cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26", "8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d"], ["b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986", "39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a"], ["d4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e", "62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54"], ["48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4", "25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77"], ["dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda", "ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517"], ["6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859", "cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10"], ["e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f", "f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125"], ["eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c", "6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e"], ["13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942", "fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1"], ["ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a", "1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2"], ["b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80", "5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423"], ["ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d", "438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8"], ["8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1", "cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758"], ["52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63", "c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375"], ["e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352", "6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d"], ["7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193", "ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec"], ["5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00", "9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0"], ["32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58", "ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c"], ["e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7", "d3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4"], ["8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8", "c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f"], ["4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e", "67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649"], ["3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d", "cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826"], ["674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b", "299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5"], ["d32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f", "f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87"], ["30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6", "462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b"], ["be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297", "62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc"], ["93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a", "7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c"], ["b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c", "ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f"], ["d5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52", "4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a"], ["d3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb", "bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46"], ["463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065", "bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f"], ["7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917", "603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03"], ["74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9", "cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08"], ["30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3", "553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8"], ["9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57", "712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373"], ["176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66", "ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3"], ["75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8", "9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8"], ["809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721", "9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1"], ["1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180", "4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9"]]
      }
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(3),
        i = r(147),
        o = r(5),
        s = r(36),
        a = r(64),
        u = o.assert,
        f = r(148),
        c = r(149);

    function h(t) {
      if (!(this instanceof h)) return new h(t);
      "string" == typeof t && (u(s.hasOwnProperty(t), "Unknown curve " + t), t = s[t]), t instanceof s.PresetCurve && (t = {
        curve: t
      }), this.curve = t.curve.curve, this.n = this.curve.n, this.nh = this.n.ushrn(1), this.g = this.curve.g, this.g = t.curve.g, this.g.precompute(t.curve.n.bitLength() + 1), this.hash = t.hash || t.curve.hash;
    }

    t.exports = h, h.prototype.keyPair = function (t) {
      return new f(this, t);
    }, h.prototype.keyFromPrivate = function (t, e) {
      return f.fromPrivate(this, t, e);
    }, h.prototype.keyFromPublic = function (t, e) {
      return f.fromPublic(this, t, e);
    }, h.prototype.genKeyPair = function (t) {
      t || (t = {});

      for (var e = new i({
        hash: this.hash,
        pers: t.pers,
        persEnc: t.persEnc || "utf8",
        entropy: t.entropy || a(this.hash.hmacStrength),
        entropyEnc: t.entropy && t.entropyEnc || "utf8",
        nonce: this.n.toArray()
      }), r = this.n.byteLength(), o = this.n.sub(new n(2));;) {
        var s = new n(e.generate(r));
        if (!(s.cmp(o) > 0)) return s.iaddn(1), this.keyFromPrivate(s);
      }
    }, h.prototype._truncateToN = function (t, e) {
      var r = 8 * t.byteLength() - this.n.bitLength();
      return r > 0 && (t = t.ushrn(r)), !e && t.cmp(this.n) >= 0 ? t.sub(this.n) : t;
    }, h.prototype.sign = function (t, e, r, o) {
      "object" == typeof r && (o = r, r = null), o || (o = {}), e = this.keyFromPrivate(e, r), t = this._truncateToN(new n(t, 16));

      for (var s = this.n.byteLength(), a = e.getPrivate().toArray("be", s), u = t.toArray("be", s), f = new i({
        hash: this.hash,
        entropy: a,
        nonce: u,
        pers: o.pers,
        persEnc: o.persEnc || "utf8"
      }), h = this.n.sub(new n(1)), l = 0;; l++) {
        var d = o.k ? o.k(l) : new n(f.generate(this.n.byteLength()));

        if (!((d = this._truncateToN(d, !0)).cmpn(1) <= 0 || d.cmp(h) >= 0)) {
          var p = this.g.mul(d);

          if (!p.isInfinity()) {
            var g = p.getX(),
                m = g.umod(this.n);

            if (0 !== m.cmpn(0)) {
              var b = d.invm(this.n).mul(m.mul(e.getPrivate()).iadd(t));

              if (0 !== (b = b.umod(this.n)).cmpn(0)) {
                var v = (p.getY().isOdd() ? 1 : 0) | (0 !== g.cmp(m) ? 2 : 0);
                return o.canonical && b.cmp(this.nh) > 0 && (b = this.n.sub(b), v ^= 1), new c({
                  r: m,
                  s: b,
                  recoveryParam: v
                });
              }
            }
          }
        }
      }
    }, h.prototype.verify = function (t, e, r, i) {
      t = this._truncateToN(new n(t, 16)), r = this.keyFromPublic(r, i);
      var o = (e = new c(e, "hex")).r,
          s = e.s;
      if (o.cmpn(1) < 0 || o.cmp(this.n) >= 0) return !1;
      if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0) return !1;
      var a,
          u = s.invm(this.n),
          f = u.mul(t).umod(this.n),
          h = u.mul(o).umod(this.n);
      return this.curve._maxwellTrick ? !(a = this.g.jmulAdd(f, r.getPublic(), h)).isInfinity() && a.eqXToP(o) : !(a = this.g.mulAdd(f, r.getPublic(), h)).isInfinity() && 0 === a.getX().umod(this.n).cmp(o);
    }, h.prototype.recoverPubKey = function (t, e, r, i) {
      u((3 & r) === r, "The recovery param is more than two bits"), e = new c(e, i);
      var o = this.n,
          s = new n(t),
          a = e.r,
          f = e.s,
          h = 1 & r,
          l = r >> 1;
      if (a.cmp(this.curve.p.umod(this.curve.n)) >= 0 && l) throw new Error("Unable to find sencond key candinate");
      a = l ? this.curve.pointFromX(a.add(this.curve.n), h) : this.curve.pointFromX(a, h);
      var d = e.r.invm(o),
          p = o.sub(s).mul(d).umod(o),
          g = f.mul(d).umod(o);
      return this.g.mulAdd(p, a, g);
    }, h.prototype.getKeyRecoveryParam = function (t, e, r, n) {
      if (null !== (e = new c(e, n)).recoveryParam) return e.recoveryParam;

      for (var i = 0; i < 4; i++) {
        var o;

        try {
          o = this.recoverPubKey(t, e, i);
        } catch (t) {
          continue;
        }

        if (o.eq(r)) return i;
      }

      throw new Error("Unable to find valid recovery factor");
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(37),
        i = r(63),
        o = r(11);

    function s(t) {
      if (!(this instanceof s)) return new s(t);
      this.hash = t.hash, this.predResist = !!t.predResist, this.outLen = this.hash.outSize, this.minEntropy = t.minEntropy || this.hash.hmacStrength, this._reseed = null, this.reseedInterval = null, this.K = null, this.V = null;
      var e = i.toArray(t.entropy, t.entropyEnc || "hex"),
          r = i.toArray(t.nonce, t.nonceEnc || "hex"),
          n = i.toArray(t.pers, t.persEnc || "hex");
      o(e.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits"), this._init(e, r, n);
    }

    t.exports = s, s.prototype._init = function (t, e, r) {
      var n = t.concat(e).concat(r);
      this.K = new Array(this.outLen / 8), this.V = new Array(this.outLen / 8);

      for (var i = 0; i < this.V.length; i++) {
        this.K[i] = 0, this.V[i] = 1;
      }

      this._update(n), this._reseed = 1, this.reseedInterval = 281474976710656;
    }, s.prototype._hmac = function () {
      return new n.hmac(this.hash, this.K);
    }, s.prototype._update = function (t) {
      var e = this._hmac().update(this.V).update([0]);

      t && (e = e.update(t)), this.K = e.digest(), this.V = this._hmac().update(this.V).digest(), t && (this.K = this._hmac().update(this.V).update([1]).update(t).digest(), this.V = this._hmac().update(this.V).digest());
    }, s.prototype.reseed = function (t, e, r, n) {
      "string" != typeof e && (n = r, r = e, e = null), t = i.toArray(t, e), r = i.toArray(r, n), o(t.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits"), this._update(t.concat(r || [])), this._reseed = 1;
    }, s.prototype.generate = function (t, e, r, n) {
      if (this._reseed > this.reseedInterval) throw new Error("Reseed is required");
      "string" != typeof e && (n = r, r = e, e = null), r && (r = i.toArray(r, n || "hex"), this._update(r));

      for (var o = []; o.length < t;) {
        this.V = this._hmac().update(this.V).digest(), o = o.concat(this.V);
      }

      var s = o.slice(0, t);
      return this._update(r), this._reseed++, i.encode(s, e);
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(3),
        i = r(5).assert;

    function o(t, e) {
      this.ec = t, this.priv = null, this.pub = null, e.priv && this._importPrivate(e.priv, e.privEnc), e.pub && this._importPublic(e.pub, e.pubEnc);
    }

    t.exports = o, o.fromPublic = function (t, e, r) {
      return e instanceof o ? e : new o(t, {
        pub: e,
        pubEnc: r
      });
    }, o.fromPrivate = function (t, e, r) {
      return e instanceof o ? e : new o(t, {
        priv: e,
        privEnc: r
      });
    }, o.prototype.validate = function () {
      var t = this.getPublic();
      return t.isInfinity() ? {
        result: !1,
        reason: "Invalid public key"
      } : t.validate() ? t.mul(this.ec.curve.n).isInfinity() ? {
        result: !0,
        reason: null
      } : {
        result: !1,
        reason: "Public key * N != O"
      } : {
        result: !1,
        reason: "Public key is not a point"
      };
    }, o.prototype.getPublic = function (t, e) {
      return "string" == typeof t && (e = t, t = null), this.pub || (this.pub = this.ec.g.mul(this.priv)), e ? this.pub.encode(e, t) : this.pub;
    }, o.prototype.getPrivate = function (t) {
      return "hex" === t ? this.priv.toString(16, 2) : this.priv;
    }, o.prototype._importPrivate = function (t, e) {
      this.priv = new n(t, e || 16), this.priv = this.priv.umod(this.ec.curve.n);
    }, o.prototype._importPublic = function (t, e) {
      if (t.x || t.y) return "mont" === this.ec.curve.type ? i(t.x, "Need x coordinate") : "short" !== this.ec.curve.type && "edwards" !== this.ec.curve.type || i(t.x && t.y, "Need both x and y coordinate"), void (this.pub = this.ec.curve.point(t.x, t.y));
      this.pub = this.ec.curve.decodePoint(t, e);
    }, o.prototype.derive = function (t) {
      return t.mul(this.priv).getX();
    }, o.prototype.sign = function (t, e, r) {
      return this.ec.sign(t, this, e, r);
    }, o.prototype.verify = function (t, e) {
      return this.ec.verify(t, e, this);
    }, o.prototype.inspect = function () {
      return "<Key priv: " + (this.priv && this.priv.toString(16, 2)) + " pub: " + (this.pub && this.pub.inspect()) + " >";
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(3),
        i = r(5),
        o = i.assert;

    function s(t, e) {
      if (t instanceof s) return t;
      this._importDER(t, e) || (o(t.r && t.s, "Signature without r or s"), this.r = new n(t.r, 16), this.s = new n(t.s, 16), void 0 === t.recoveryParam ? this.recoveryParam = null : this.recoveryParam = t.recoveryParam);
    }

    function a() {
      this.place = 0;
    }

    function u(t, e) {
      var r = t[e.place++];
      if (!(128 & r)) return r;

      for (var n = 15 & r, i = 0, o = 0, s = e.place; o < n; o++, s++) {
        i <<= 8, i |= t[s];
      }

      return e.place = s, i;
    }

    function f(t) {
      for (var e = 0, r = t.length - 1; !t[e] && !(128 & t[e + 1]) && e < r;) {
        e++;
      }

      return 0 === e ? t : t.slice(e);
    }

    function c(t, e) {
      if (e < 128) t.push(e);else {
        var r = 1 + (Math.log(e) / Math.LN2 >>> 3);

        for (t.push(128 | r); --r;) {
          t.push(e >>> (r << 3) & 255);
        }

        t.push(e);
      }
    }

    t.exports = s, s.prototype._importDER = function (t, e) {
      t = i.toArray(t, e);
      var r = new a();
      if (48 !== t[r.place++]) return !1;
      if (u(t, r) + r.place !== t.length) return !1;
      if (2 !== t[r.place++]) return !1;
      var o = u(t, r),
          s = t.slice(r.place, o + r.place);
      if (r.place += o, 2 !== t[r.place++]) return !1;
      var f = u(t, r);
      if (t.length !== f + r.place) return !1;
      var c = t.slice(r.place, f + r.place);
      return 0 === s[0] && 128 & s[1] && (s = s.slice(1)), 0 === c[0] && 128 & c[1] && (c = c.slice(1)), this.r = new n(s), this.s = new n(c), this.recoveryParam = null, !0;
    }, s.prototype.toDER = function (t) {
      var e = this.r.toArray(),
          r = this.s.toArray();

      for (128 & e[0] && (e = [0].concat(e)), 128 & r[0] && (r = [0].concat(r)), e = f(e), r = f(r); !(r[0] || 128 & r[1]);) {
        r = r.slice(1);
      }

      var n = [2];
      c(n, e.length), (n = n.concat(e)).push(2), c(n, r.length);
      var o = n.concat(r),
          s = [48];
      return c(s, o.length), s = s.concat(o), i.encode(s, t);
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(37),
        i = r(36),
        o = r(5),
        s = o.assert,
        a = o.parseBytes,
        u = r(151),
        f = r(152);

    function c(t) {
      if (s("ed25519" === t, "only tested with ed25519 so far"), !(this instanceof c)) return new c(t);
      t = i[t].curve;
      this.curve = t, this.g = t.g, this.g.precompute(t.n.bitLength() + 1), this.pointClass = t.point().constructor, this.encodingLength = Math.ceil(t.n.bitLength() / 8), this.hash = n.sha512;
    }

    t.exports = c, c.prototype.sign = function (t, e) {
      t = a(t);
      var r = this.keyFromSecret(e),
          n = this.hashInt(r.messagePrefix(), t),
          i = this.g.mul(n),
          o = this.encodePoint(i),
          s = this.hashInt(o, r.pubBytes(), t).mul(r.priv()),
          u = n.add(s).umod(this.curve.n);
      return this.makeSignature({
        R: i,
        S: u,
        Rencoded: o
      });
    }, c.prototype.verify = function (t, e, r) {
      t = a(t), e = this.makeSignature(e);
      var n = this.keyFromPublic(r),
          i = this.hashInt(e.Rencoded(), n.pubBytes(), t),
          o = this.g.mul(e.S());
      return e.R().add(n.pub().mul(i)).eq(o);
    }, c.prototype.hashInt = function () {
      for (var t = this.hash(), e = 0; e < arguments.length; e++) {
        t.update(arguments[e]);
      }

      return o.intFromLE(t.digest()).umod(this.curve.n);
    }, c.prototype.keyFromPublic = function (t) {
      return u.fromPublic(this, t);
    }, c.prototype.keyFromSecret = function (t) {
      return u.fromSecret(this, t);
    }, c.prototype.makeSignature = function (t) {
      return t instanceof f ? t : new f(this, t);
    }, c.prototype.encodePoint = function (t) {
      var e = t.getY().toArray("le", this.encodingLength);
      return e[this.encodingLength - 1] |= t.getX().isOdd() ? 128 : 0, e;
    }, c.prototype.decodePoint = function (t) {
      var e = (t = o.parseBytes(t)).length - 1,
          r = t.slice(0, e).concat(-129 & t[e]),
          n = 0 != (128 & t[e]),
          i = o.intFromLE(r);
      return this.curve.pointFromY(i, n);
    }, c.prototype.encodeInt = function (t) {
      return t.toArray("le", this.encodingLength);
    }, c.prototype.decodeInt = function (t) {
      return o.intFromLE(t);
    }, c.prototype.isPoint = function (t) {
      return t instanceof this.pointClass;
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(5),
        i = n.assert,
        o = n.parseBytes,
        s = n.cachedProperty;

    function a(t, e) {
      this.eddsa = t, this._secret = o(e.secret), t.isPoint(e.pub) ? this._pub = e.pub : this._pubBytes = o(e.pub);
    }

    a.fromPublic = function (t, e) {
      return e instanceof a ? e : new a(t, {
        pub: e
      });
    }, a.fromSecret = function (t, e) {
      return e instanceof a ? e : new a(t, {
        secret: e
      });
    }, a.prototype.secret = function () {
      return this._secret;
    }, s(a, "pubBytes", function () {
      return this.eddsa.encodePoint(this.pub());
    }), s(a, "pub", function () {
      return this._pubBytes ? this.eddsa.decodePoint(this._pubBytes) : this.eddsa.g.mul(this.priv());
    }), s(a, "privBytes", function () {
      var t = this.eddsa,
          e = this.hash(),
          r = t.encodingLength - 1,
          n = e.slice(0, t.encodingLength);
      return n[0] &= 248, n[r] &= 127, n[r] |= 64, n;
    }), s(a, "priv", function () {
      return this.eddsa.decodeInt(this.privBytes());
    }), s(a, "hash", function () {
      return this.eddsa.hash().update(this.secret()).digest();
    }), s(a, "messagePrefix", function () {
      return this.hash().slice(this.eddsa.encodingLength);
    }), a.prototype.sign = function (t) {
      return i(this._secret, "KeyPair can only verify"), this.eddsa.sign(t, this);
    }, a.prototype.verify = function (t, e) {
      return this.eddsa.verify(t, e, this);
    }, a.prototype.getSecret = function (t) {
      return i(this._secret, "KeyPair is public only"), n.encode(this.secret(), t);
    }, a.prototype.getPublic = function (t) {
      return n.encode(this.pubBytes(), t);
    }, t.exports = a;
  }, function (t, e, r) {
    "use strict";

    var n = r(3),
        i = r(5),
        o = i.assert,
        s = i.cachedProperty,
        a = i.parseBytes;

    function u(t, e) {
      this.eddsa = t, "object" != typeof e && (e = a(e)), Array.isArray(e) && (e = {
        R: e.slice(0, t.encodingLength),
        S: e.slice(t.encodingLength)
      }), o(e.R && e.S, "Signature without R or S"), t.isPoint(e.R) && (this._R = e.R), e.S instanceof n && (this._S = e.S), this._Rencoded = Array.isArray(e.R) ? e.R : e.Rencoded, this._Sencoded = Array.isArray(e.S) ? e.S : e.Sencoded;
    }

    s(u, "S", function () {
      return this.eddsa.decodeInt(this.Sencoded());
    }), s(u, "R", function () {
      return this.eddsa.decodePoint(this.Rencoded());
    }), s(u, "Rencoded", function () {
      return this.eddsa.encodePoint(this.R());
    }), s(u, "Sencoded", function () {
      return this.eddsa.encodeInt(this.S());
    }), u.prototype.toBytes = function () {
      return this.Rencoded().concat(this.Sencoded());
    }, u.prototype.toHex = function () {
      return i.encode(this.toBytes(), "hex").toUpperCase();
    }, t.exports = u;
  }, function (t, e, r) {
    "use strict";
    /*
    object-assign
    (c) Sindre Sorhus
    @license MIT
    */

    var n = Object.getOwnPropertySymbols,
        i = Object.prototype.hasOwnProperty,
        o = Object.prototype.propertyIsEnumerable;

    function s(t) {
      if (null == t) throw new TypeError("Object.assign cannot be called with null or undefined");
      return Object(t);
    }

    t.exports = function () {
      try {
        if (!Object.assign) return !1;
        var t = new String("abc");
        if (t[5] = "de", "5" === Object.getOwnPropertyNames(t)[0]) return !1;

        for (var e = {}, r = 0; r < 10; r++) {
          e["_" + String.fromCharCode(r)] = r;
        }

        if ("0123456789" !== Object.getOwnPropertyNames(e).map(function (t) {
          return e[t];
        }).join("")) return !1;
        var n = {};
        return "abcdefghijklmnopqrst".split("").forEach(function (t) {
          n[t] = t;
        }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, n)).join("");
      } catch (t) {
        return !1;
      }
    }() ? Object.assign : function (t, e) {
      for (var r, a, u = s(t), f = 1; f < arguments.length; f++) {
        for (var c in r = Object(arguments[f])) {
          i.call(r, c) && (u[c] = r[c]);
        }

        if (n) {
          a = n(r);

          for (var h = 0; h < a.length; h++) {
            o.call(r, a[h]) && (u[a[h]] = r[a[h]]);
          }
        }
      }

      return u;
    };
  }, function (t, e, r) {
    var n = r(69);

    t.exports = function (t) {
      return "string" != typeof t ? t : n(t) ? t.slice(2) : t;
    };
  }, function (t, e, r) {
    var n = r(70),
        i = r(156);

    function o(t, e) {
      return new Promise(function (r) {
        var n = setTimeout(r, t);
        n.unref && e && n.unref();
      });
    }

    t.exports =
    /*#__PURE__*/
    function (_i12) {
      "use strict";

      _inherits(_class6, _i12);

      function _class6() {
        var _this6;

        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        _classCallCheck(this, _class6);

        if (!t.provider) throw new Error("PollingBlockTracker - no provider specified.");
        var e = t.pollingInterval || 2e4,
            r = t.retryTimeout || e / 10,
            n = void 0 === t.keepEventLoopActive || t.keepEventLoopActive,
            i = t.setSkipCacheFlag || !1;
        _this6 = _possibleConstructorReturn(this, _getPrototypeOf(_class6).call(this, Object.assign({
          blockResetDuration: e
        }, t))), _this6._provider = t.provider, _this6._pollingInterval = e, _this6._retryTimeout = r, _this6._keepEventLoopActive = n, _this6._setSkipCacheFlag = i;
        return _this6;
      }

      _createClass(_class6, [{
        key: "checkForLatestBlock",
        value: function () {
          var _checkForLatestBlock = _asyncToGenerator(
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee19() {
            return _regeneratorRuntime.wrap(function _callee19$(_context19) {
              while (1) {
                switch (_context19.prev = _context19.next) {
                  case 0:
                    _context19.next = 2;
                    return this._updateLatestBlock();

                  case 2:
                    _context19.next = 4;
                    return this.getLatestBlock();

                  case 4:
                    return _context19.abrupt("return", _context19.sent);

                  case 5:
                  case "end":
                    return _context19.stop();
                }
              }
            }, _callee19, this);
          }));

          function checkForLatestBlock() {
            return _checkForLatestBlock.apply(this, arguments);
          }

          return checkForLatestBlock;
        }()
      }, {
        key: "_start",
        value: function _start() {
          var _this7 = this;

          this._performSync().catch(function (t) {
            return _this7.emit("error", t);
          });
        }
      }, {
        key: "_performSync",
        value: function () {
          var _performSync2 = _asyncToGenerator(
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee20() {
            var _e15;

            return _regeneratorRuntime.wrap(function _callee20$(_context20) {
              while (1) {
                switch (_context20.prev = _context20.next) {
                  case 0:
                    if (!this._isRunning) {
                      _context20.next = 16;
                      break;
                    }

                    _context20.prev = 1;
                    _context20.next = 4;
                    return this._updateLatestBlock();

                  case 4:
                    _context20.next = 6;
                    return o(this._pollingInterval, !this._keepEventLoopActive);

                  case 6:
                    _context20.next = 14;
                    break;

                  case 8:
                    _context20.prev = 8;
                    _context20.t0 = _context20["catch"](1);
                    _e15 = new Error("PollingBlockTracker - encountered an error while attempting to update latest block:\n".concat(_context20.t0.stack));

                    try {
                      this.emit("error", _e15);
                    } catch (t) {
                      console.error(_e15);
                    }

                    _context20.next = 14;
                    return o(this._retryTimeout, !this._keepEventLoopActive);

                  case 14:
                    _context20.next = 0;
                    break;

                  case 16:
                  case "end":
                    return _context20.stop();
                }
              }
            }, _callee20, this, [[1, 8]]);
          }));

          function _performSync() {
            return _performSync2.apply(this, arguments);
          }

          return _performSync;
        }()
      }, {
        key: "_updateLatestBlock",
        value: function () {
          var _updateLatestBlock2 = _asyncToGenerator(
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee21() {
            var t;
            return _regeneratorRuntime.wrap(function _callee21$(_context21) {
              while (1) {
                switch (_context21.prev = _context21.next) {
                  case 0:
                    _context21.next = 2;
                    return this._fetchLatestBlock();

                  case 2:
                    t = _context21.sent;

                    this._newPotentialLatest(t);

                  case 4:
                  case "end":
                    return _context21.stop();
                }
              }
            }, _callee21, this);
          }));

          function _updateLatestBlock() {
            return _updateLatestBlock2.apply(this, arguments);
          }

          return _updateLatestBlock;
        }()
      }, {
        key: "_fetchLatestBlock",
        value: function () {
          var _fetchLatestBlock2 = _asyncToGenerator(
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee22() {
            var _this8 = this;

            var t, e;
            return _regeneratorRuntime.wrap(function _callee22$(_context22) {
              while (1) {
                switch (_context22.prev = _context22.next) {
                  case 0:
                    t = {
                      jsonrpc: "2.0",
                      id: 1,
                      method: "eth_blockNumber",
                      params: []
                    };
                    this._setSkipCacheFlag && (t.skipCache = !0);
                    _context22.next = 4;
                    return n(function (e) {
                      return _this8._provider.sendAsync(t, e);
                    })();

                  case 4:
                    e = _context22.sent;

                    if (!e.error) {
                      _context22.next = 7;
                      break;
                    }

                    throw new Error("PollingBlockTracker - encountered error fetching block:\n".concat(e.error));

                  case 7:
                    return _context22.abrupt("return", e.result);

                  case 8:
                  case "end":
                    return _context22.stop();
                }
              }
            }, _callee22, this);
          }));

          function _fetchLatestBlock() {
            return _fetchLatestBlock2.apply(this, arguments);
          }

          return _fetchLatestBlock;
        }()
      }]);

      return _class6;
    }(i);
  }, function (t, e, r) {
    r(71), r(70);

    var n = r(39),
        i = function i(t, e) {
      return t + e;
    },
        o = ["sync", "latest"];

    function s(t) {
      return Number.parseInt(t, 16);
    }

    t.exports =
    /*#__PURE__*/
    function (_n27) {
      "use strict";

      _inherits(_class7, _n27);

      function _class7() {
        var _this9;

        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        _classCallCheck(this, _class7);

        _this9 = _possibleConstructorReturn(this, _getPrototypeOf(_class7).call(this)), _this9._blockResetDuration = t.blockResetDuration || 2e4, _this9._blockResetTimeout, _this9._currentBlock = null, _this9._isRunning = !1, _this9._onNewListener = _this9._onNewListener.bind(_assertThisInitialized(_assertThisInitialized(_this9))), _this9._onRemoveListener = _this9._onRemoveListener.bind(_assertThisInitialized(_assertThisInitialized(_this9))), _this9._resetCurrentBlock = _this9._resetCurrentBlock.bind(_assertThisInitialized(_assertThisInitialized(_this9))), _this9._setupInternalEvents();
        return _this9;
      }

      _createClass(_class7, [{
        key: "isRunning",
        value: function isRunning() {
          return this._isRunning;
        }
      }, {
        key: "getCurrentBlock",
        value: function getCurrentBlock() {
          return this._currentBlock;
        }
      }, {
        key: "getLatestBlock",
        value: function () {
          var _getLatestBlock = _asyncToGenerator(
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee23() {
            var _this10 = this;

            return _regeneratorRuntime.wrap(function _callee23$(_context23) {
              while (1) {
                switch (_context23.prev = _context23.next) {
                  case 0:
                    if (!this._currentBlock) {
                      _context23.next = 2;
                      break;
                    }

                    return _context23.abrupt("return", this._currentBlock);

                  case 2:
                    _context23.next = 4;
                    return new Promise(function (t) {
                      return _this10.once("latest", t);
                    });

                  case 4:
                    return _context23.abrupt("return", _context23.sent);

                  case 5:
                  case "end":
                    return _context23.stop();
                }
              }
            }, _callee23, this);
          }));

          function getLatestBlock() {
            return _getLatestBlock.apply(this, arguments);
          }

          return getLatestBlock;
        }()
      }, {
        key: "removeAllListeners",
        value: function removeAllListeners(t) {
          t ? _get(_getPrototypeOf(_class7.prototype), "removeAllListeners", this).call(this, t) : _get(_getPrototypeOf(_class7.prototype), "removeAllListeners", this).call(this), this._setupInternalEvents(), this._onRemoveListener();
        }
      }, {
        key: "_start",
        value: function _start() {}
      }, {
        key: "_end",
        value: function _end() {}
      }, {
        key: "_setupInternalEvents",
        value: function _setupInternalEvents() {
          this.removeListener("newListener", this._onNewListener), this.removeListener("removeListener", this._onRemoveListener), this.on("newListener", this._onNewListener), this.on("removeListener", this._onRemoveListener);
        }
      }, {
        key: "_onNewListener",
        value: function _onNewListener(t, e) {
          o.includes(t) && this._maybeStart();
        }
      }, {
        key: "_onRemoveListener",
        value: function _onRemoveListener(t, e) {
          this._getBlockTrackerEventCount() > 0 || this._maybeEnd();
        }
      }, {
        key: "_maybeStart",
        value: function _maybeStart() {
          this._isRunning || (this._isRunning = !0, this._cancelBlockResetTimeout(), this._start());
        }
      }, {
        key: "_maybeEnd",
        value: function _maybeEnd() {
          this._isRunning && (this._isRunning = !1, this._setupBlockResetTimeout(), this._end());
        }
      }, {
        key: "_getBlockTrackerEventCount",
        value: function _getBlockTrackerEventCount() {
          var _this11 = this;

          return o.map(function (t) {
            return _this11.listenerCount(t);
          }).reduce(i);
        }
      }, {
        key: "_newPotentialLatest",
        value: function _newPotentialLatest(t) {
          var e = this._currentBlock;
          e && s(t) <= s(e) || this._setCurrentBlock(t);
        }
      }, {
        key: "_setCurrentBlock",
        value: function _setCurrentBlock(t) {
          var e = this._currentBlock;
          this._currentBlock = t, this.emit("latest", t), this.emit("sync", {
            oldBlock: e,
            newBlock: t
          });
        }
      }, {
        key: "_setupBlockResetTimeout",
        value: function _setupBlockResetTimeout() {
          this._cancelBlockResetTimeout(), this._blockResetTimeout = setTimeout(this._resetCurrentBlock, this._blockResetDuration), this._blockResetTimeout.unref && this._blockResetTimeout.unref();
        }
      }, {
        key: "_cancelBlockResetTimeout",
        value: function _cancelBlockResetTimeout() {
          clearTimeout(this._blockResetTimeout);
        }
      }, {
        key: "_resetCurrentBlock",
        value: function _resetCurrentBlock() {
          this._currentBlock = null;
        }
      }]);

      return _class7;
    }(n);
  }, function (t, e) {
    t.exports = function (t) {
      var e = (t = t || {}).max || Number.MAX_SAFE_INTEGER,
          r = void 0 !== t.start ? t.start : Math.floor(Math.random() * e);
      return function () {
        return r %= e, r++;
      };
    };
  }, function (t, e, r) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var n = o(r(159)),
        i = o(r(185));

    function o(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }

    e.default = (0, n.default)(i.default), t.exports = e.default;
  }, function (t, e, r) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = function (t) {
      return function (e, r, o) {
        return t(n.default, e, (0, i.default)(r), o);
      };
    };
    var n = o(r(72)),
        i = o(r(12));

    function o(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }

    t.exports = e.default;
  }, function (t, e, r) {
    var n = r(40),
        i = r(76);

    t.exports = function (t) {
      if (!i(t)) return !1;
      var e = n(t);
      return "[object Function]" == e || "[object GeneratorFunction]" == e || "[object AsyncFunction]" == e || "[object Proxy]" == e;
    };
  }, function (t, e, r) {
    var n = r(73),
        i = Object.prototype,
        o = i.hasOwnProperty,
        s = i.toString,
        a = n ? n.toStringTag : void 0;

    t.exports = function (t) {
      var e = o.call(t, a),
          r = t[a];

      try {
        t[a] = void 0;
        var n = !0;
      } catch (t) {}

      var i = s.call(t);
      return n && (e ? t[a] = r : delete t[a]), i;
    };
  }, function (t, e) {
    var r = Object.prototype.toString;

    t.exports = function (t) {
      return r.call(t);
    };
  }, function (t, e, r) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = function (t, e, r, o) {
      (0, n.default)(e)(t, (0, i.default)(r), o);
    };
    var n = o(r(79)),
        i = o(r(12));

    function o(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }

    t.exports = e.default;
  }, function (t, e, r) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = function (t) {
      if ((0, n.default)(t)) return function (t) {
        var e = -1,
            r = t.length;
        return function () {
          return ++e < r ? {
            value: t[e],
            key: e
          } : null;
        };
      }(t);
      var e = (0, i.default)(t);
      return e ? function (t) {
        var e = -1;
        return function () {
          var r = t.next();
          return r.done ? null : (e++, {
            value: r.value,
            key: e
          });
        };
      }(e) : (r = t, s = (0, o.default)(r), a = -1, u = s.length, function () {
        var t = s[++a];
        return a < u ? {
          value: r[t],
          key: t
        } : null;
      });
      var r, s, a, u;
    };
    var n = s(r(30)),
        i = s(r(165)),
        o = s(r(166));

    function s(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }

    t.exports = e.default;
  }, function (t, e, r) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = function (t) {
      return n && t[n] && t[n]();
    };
    var n = "function" == typeof Symbol && Symbol.iterator;
    t.exports = e.default;
  }, function (t, e, r) {
    var n = r(167),
        i = r(178),
        o = r(30);

    t.exports = function (t) {
      return o(t) ? n(t) : i(t);
    };
  }, function (t, e, r) {
    var n = r(168),
        i = r(169),
        o = r(80),
        s = r(171),
        a = r(173),
        u = r(174),
        f = Object.prototype.hasOwnProperty;

    t.exports = function (t, e) {
      var r = o(t),
          c = !r && i(t),
          h = !r && !c && s(t),
          l = !r && !c && !h && u(t),
          d = r || c || h || l,
          p = d ? n(t.length, String) : [],
          g = p.length;

      for (var m in t) {
        !e && !f.call(t, m) || d && ("length" == m || h && ("offset" == m || "parent" == m) || l && ("buffer" == m || "byteLength" == m || "byteOffset" == m) || a(m, g)) || p.push(m);
      }

      return p;
    };
  }, function (t, e) {
    t.exports = function (t, e) {
      for (var r = -1, n = Array(t); ++r < t;) {
        n[r] = e(r);
      }

      return n;
    };
  }, function (t, e, r) {
    var n = r(170),
        i = r(42),
        o = Object.prototype,
        s = o.hasOwnProperty,
        a = o.propertyIsEnumerable,
        u = n(function () {
      return arguments;
    }()) ? n : function (t) {
      return i(t) && s.call(t, "callee") && !a.call(t, "callee");
    };
    t.exports = u;
  }, function (t, e, r) {
    var n = r(40),
        i = r(42);

    t.exports = function (t) {
      return i(t) && "[object Arguments]" == n(t);
    };
  }, function (t, e, r) {
    (function (t) {
      var n = r(74),
          i = r(172),
          o = e && !e.nodeType && e,
          s = o && "object" == typeof t && t && !t.nodeType && t,
          a = s && s.exports === o ? n.Buffer : void 0,
          u = (a ? a.isBuffer : void 0) || i;
      t.exports = u;
    }).call(this, r(19)(t));
  }, function (t, e) {
    t.exports = function () {
      return !1;
    };
  }, function (t, e) {
    var r = /^(?:0|[1-9]\d*)$/;

    t.exports = function (t, e) {
      var n = typeof t;
      return !!(e = null == e ? 9007199254740991 : e) && ("number" == n || "symbol" != n && r.test(t)) && t > -1 && t % 1 == 0 && t < e;
    };
  }, function (t, e, r) {
    var n = r(175),
        i = r(176),
        o = r(177),
        s = o && o.isTypedArray,
        a = s ? i(s) : n;
    t.exports = a;
  }, function (t, e, r) {
    var n = r(40),
        i = r(77),
        o = r(42),
        s = {};
    s["[object Float32Array]"] = s["[object Float64Array]"] = s["[object Int8Array]"] = s["[object Int16Array]"] = s["[object Int32Array]"] = s["[object Uint8Array]"] = s["[object Uint8ClampedArray]"] = s["[object Uint16Array]"] = s["[object Uint32Array]"] = !0, s["[object Arguments]"] = s["[object Array]"] = s["[object ArrayBuffer]"] = s["[object Boolean]"] = s["[object DataView]"] = s["[object Date]"] = s["[object Error]"] = s["[object Function]"] = s["[object Map]"] = s["[object Number]"] = s["[object Object]"] = s["[object RegExp]"] = s["[object Set]"] = s["[object String]"] = s["[object WeakMap]"] = !1, t.exports = function (t) {
      return o(t) && i(t.length) && !!s[n(t)];
    };
  }, function (t, e) {
    t.exports = function (t) {
      return function (e) {
        return t(e);
      };
    };
  }, function (t, e, r) {
    (function (t) {
      var n = r(75),
          i = e && !e.nodeType && e,
          o = i && "object" == typeof t && t && !t.nodeType && t,
          s = o && o.exports === i && n.process,
          a = function () {
        try {
          var t = o && o.require && o.require("util").types;

          return t || s && s.binding && s.binding("util");
        } catch (t) {}
      }();

      t.exports = a;
    }).call(this, r(19)(t));
  }, function (t, e, r) {
    var n = r(179),
        i = r(180),
        o = Object.prototype.hasOwnProperty;

    t.exports = function (t) {
      if (!n(t)) return i(t);
      var e = [];

      for (var r in Object(t)) {
        o.call(t, r) && "constructor" != r && e.push(r);
      }

      return e;
    };
  }, function (t, e) {
    var r = Object.prototype;

    t.exports = function (t) {
      var e = t && t.constructor;
      return t === ("function" == typeof e && e.prototype || r);
    };
  }, function (t, e, r) {
    var n = r(181)(Object.keys, Object);
    t.exports = n;
  }, function (t, e) {
    t.exports = function (t, e) {
      return function (r) {
        return t(e(r));
      };
    };
  }, function (t, e, r) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = function (t) {
      return (0, i.default)(function (e, r) {
        var i;

        try {
          i = t.apply(this, e);
        } catch (t) {
          return r(t);
        }

        (0, n.default)(i) && "function" == typeof i.then ? i.then(function (t) {
          a(r, null, t);
        }, function (t) {
          a(r, t.message ? t : new Error(t));
        }) : r(null, i);
      });
    };
    var n = s(r(76)),
        i = s(r(183)),
        o = s(r(184));

    function s(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }

    function a(t, e, r) {
      try {
        t(e, r);
      } catch (t) {
        (0, o.default)(u, t);
      }
    }

    function u(t) {
      throw t;
    }

    t.exports = e.default;
  }, function (t, e, r) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = function (t) {
      return function () {
        var e = (0, o.default)(arguments),
            r = e.pop();
        t.call(this, e, r);
      };
    };
    var n,
        i = r(31),
        o = (n = i) && n.__esModule ? n : {
      default: n
    };
    t.exports = e.default;
  }, function (t, e, r) {
    "use strict";

    (function (t, n) {
      Object.defineProperty(e, "__esModule", {
        value: !0
      }), e.hasNextTick = e.hasSetImmediate = void 0, e.fallback = c, e.wrap = h;
      var i,
          o = r(31),
          s = (i = o) && i.__esModule ? i : {
        default: i
      };
      var a,
          u = e.hasSetImmediate = "function" == typeof t && t,
          f = e.hasNextTick = "object" == typeof n && "function" == typeof n.nextTick;

      function c(t) {
        setTimeout(t, 0);
      }

      function h(t) {
        return function (e) {
          var r = (0, s.default)(arguments, 1);
          t(function () {
            e.apply(null, r);
          });
        };
      }

      a = u ? t : f ? n.nextTick : c, e.default = h(a);
    }).call(this, r(25).setImmediate, r(6));
  }, function (t, e, r) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = function (t, e, r, o) {
      o = o || n.default, e = e || [];
      var s = [],
          a = 0,
          u = (0, i.default)(r);
      t(e, function (t, e, r) {
        var n = a++;
        u(t, function (t, e) {
          s[n] = e, r(t);
        });
      }, function (t) {
        o(t, s);
      });
    };
    var n = o(r(21)),
        i = o(r(12));

    function o(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }

    t.exports = e.default;
  }, function (t, e, r) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var n = o(r(187)),
        i = o(r(81));

    function o(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }

    e.default = (0, i.default)(n.default, 1), t.exports = e.default;
  }, function (t, e, r) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = function (t, e, r, s) {
      (0, n.default)(e)(t, (0, i.default)((0, o.default)(r)), s);
    };
    var n = s(r(79)),
        i = s(r(188)),
        o = s(r(12));

    function s(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }

    t.exports = e.default;
  }, function (t, e, r) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = function (t) {
      return function (e, r, n) {
        return t(e, n);
      };
    }, t.exports = e.default;
  }, function (t, e, r) {
    var n = r(8).EventEmitter,
        i = r(9).inherits;

    function o() {
      n.call(this), this.isLocked = !0;
    }

    t.exports = o, i(o, n), o.prototype.go = function () {
      this.isLocked = !1, this.emit("unlock");
    }, o.prototype.stop = function () {
      this.isLocked = !0, this.emit("lock");
    }, o.prototype.await = function (t) {
      var e = this;
      e.isLocked ? e.once("unlock", t) : setTimeout(t);
    };
  }, function (t, e, r) {
    e.parse = r(191), e.stringify = r(192);
  }, function (t, e) {
    var r,
        n,
        i,
        _o12,
        s = {
      '"': '"',
      "\\": "\\",
      "/": "/",
      b: "\b",
      f: "\f",
      n: "\n",
      r: "\r",
      t: "\t"
    },
        a = function a(t) {
      throw {
        name: "SyntaxError",
        message: t,
        at: r,
        text: i
      };
    },
        u = function u(t) {
      return t && t !== n && a("Expected '" + t + "' instead of '" + n + "'"), n = i.charAt(r), r += 1, n;
    },
        f = function f() {
      var t,
          e = "";

      for ("-" === n && (e = "-", u("-")); n >= "0" && n <= "9";) {
        e += n, u();
      }

      if ("." === n) for (e += "."; u() && n >= "0" && n <= "9";) {
        e += n;
      }
      if ("e" === n || "E" === n) for (e += n, u(), "-" !== n && "+" !== n || (e += n, u()); n >= "0" && n <= "9";) {
        e += n, u();
      }
      if (t = +e, isFinite(t)) return t;
      a("Bad number");
    },
        c = function c() {
      var t,
          e,
          r,
          i = "";
      if ('"' === n) for (; u();) {
        if ('"' === n) return u(), i;
        if ("\\" === n) {
          if (u(), "u" === n) {
            for (r = 0, e = 0; e < 4 && (t = parseInt(u(), 16), isFinite(t)); e += 1) {
              r = 16 * r + t;
            }

            i += String.fromCharCode(r);
          } else {
            if ("string" != typeof s[n]) break;
            i += s[n];
          }
        } else i += n;
      }
      a("Bad string");
    },
        h = function h() {
      for (; n && n <= " ";) {
        u();
      }
    };

    _o12 = function o() {
      switch (h(), n) {
        case "{":
          return function () {
            var t,
                e = {};

            if ("{" === n) {
              if (u("{"), h(), "}" === n) return u("}"), e;

              for (; n;) {
                if (t = c(), h(), u(":"), Object.hasOwnProperty.call(e, t) && a('Duplicate key "' + t + '"'), e[t] = _o12(), h(), "}" === n) return u("}"), e;
                u(","), h();
              }
            }

            a("Bad object");
          }();

        case "[":
          return function () {
            var t = [];

            if ("[" === n) {
              if (u("["), h(), "]" === n) return u("]"), t;

              for (; n;) {
                if (t.push(_o12()), h(), "]" === n) return u("]"), t;
                u(","), h();
              }
            }

            a("Bad array");
          }();

        case '"':
          return c();

        case "-":
          return f();

        default:
          return n >= "0" && n <= "9" ? f() : function () {
            switch (n) {
              case "t":
                return u("t"), u("r"), u("u"), u("e"), !0;

              case "f":
                return u("f"), u("a"), u("l"), u("s"), u("e"), !1;

              case "n":
                return u("n"), u("u"), u("l"), u("l"), null;
            }

            a("Unexpected '" + n + "'");
          }();
      }
    }, t.exports = function (t, e) {
      var s;
      return i = t, r = 0, n = " ", s = _o12(), h(), n && a("Syntax error"), "function" == typeof e ? function t(r, n) {
        var i,
            o,
            s = r[n];
        if (s && "object" == typeof s) for (i in s) {
          Object.prototype.hasOwnProperty.call(s, i) && (void 0 !== (o = t(s, i)) ? s[i] = o : delete s[i]);
        }
        return e.call(r, n, s);
      }({
        "": s
      }, "") : s;
    };
  }, function (t, e) {
    var r,
        n,
        i,
        o = /[\\\"\x00-\x1f\x7f-\x9f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g,
        s = {
      "\b": "\\b",
      "\t": "\\t",
      "\n": "\\n",
      "\f": "\\f",
      "\r": "\\r",
      '"': '\\"',
      "\\": "\\\\"
    };

    function a(t) {
      return o.lastIndex = 0, o.test(t) ? '"' + t.replace(o, function (t) {
        var e = s[t];
        return "string" == typeof e ? e : "\\u" + ("0000" + t.charCodeAt(0).toString(16)).slice(-4);
      }) + '"' : '"' + t + '"';
    }

    t.exports = function (t, e, o) {
      var s;
      if (r = "", n = "", "number" == typeof o) for (s = 0; s < o; s += 1) {
        n += " ";
      } else "string" == typeof o && (n = o);
      if (i = e, e && "function" != typeof e && ("object" != typeof e || "number" != typeof e.length)) throw new Error("JSON.stringify");
      return function t(e, o) {
        var s,
            u,
            f,
            c,
            h,
            l = r,
            d = o[e];

        switch (d && "object" == typeof d && "function" == typeof d.toJSON && (d = d.toJSON(e)), "function" == typeof i && (d = i.call(o, e, d)), typeof d) {
          case "string":
            return a(d);

          case "number":
            return isFinite(d) ? String(d) : "null";

          case "boolean":
          case "null":
            return String(d);

          case "object":
            if (!d) return "null";

            if (r += n, h = [], "[object Array]" === Object.prototype.toString.apply(d)) {
              for (c = d.length, s = 0; s < c; s += 1) {
                h[s] = t(s, d) || "null";
              }

              return f = 0 === h.length ? "[]" : r ? "[\n" + r + h.join(",\n" + r) + "\n" + l + "]" : "[" + h.join(",") + "]", r = l, f;
            }

            if (i && "object" == typeof i) for (c = i.length, s = 0; s < c; s += 1) {
              "string" == typeof (u = i[s]) && (f = t(u, d)) && h.push(a(u) + (r ? ": " : ":") + f);
            } else for (u in d) {
              Object.prototype.hasOwnProperty.call(d, u) && (f = t(u, d)) && h.push(a(u) + (r ? ": " : ":") + f);
            }
            return f = 0 === h.length ? "{}" : r ? "{\n" + r + h.join(",\n" + r) + "\n" + l + "}" : "{" + h.join(",") + "}", r = l, f;
        }
      }("", {
        "": t
      });
    };
  }, function (t, e) {
    t.exports = function () {
      var t = new Date().getTime() * Math.pow(10, 3),
          e = Math.floor(Math.random() * Math.pow(10, 3));
      return t + e;
    };
  }, function (t, e, r) {
    var n = r(195),
        i = r(46),
        o = [void 0, null, "<nil>"];

    t.exports = function () {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var e = t.blockTracker;
      if (!e) throw new Error("createBlockCacheMiddleware - No BlockTracker specified");
      var r = new s(),
          o = {
        perma: r,
        block: r,
        fork: r
      };
      return i(
      /*#__PURE__*/
      function () {
        var _ref18 = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee24(t, i, s) {
          var a, u, f, c, _t21, h;

          return _regeneratorRuntime.wrap(function _callee24$(_context24) {
            while (1) {
              switch (_context24.prev = _context24.next) {
                case 0:
                  if (!t.skipCache) {
                    _context24.next = 2;
                    break;
                  }

                  return _context24.abrupt("return", s());

                case 2:
                  a = n.cacheTypeForPayload(t), u = o[a];

                  if (u) {
                    _context24.next = 5;
                    break;
                  }

                  return _context24.abrupt("return", s());

                case 5:
                  if (u.canCacheRequest(t)) {
                    _context24.next = 7;
                    break;
                  }

                  return _context24.abrupt("return", s());

                case 7:
                  c = n.blockTagForPayload(t);

                  if (!(c || (c = "latest"), "earliest" === c)) {
                    _context24.next = 12;
                    break;
                  }

                  f = "0x00";
                  _context24.next = 20;
                  break;

                case 12:
                  if (!("latest" === c)) {
                    _context24.next = 19;
                    break;
                  }

                  _context24.next = 15;
                  return e.getLatestBlock();

                case 15:
                  _t21 = _context24.sent;
                  r.clearBefore(_t21), f = _t21;
                  _context24.next = 20;
                  break;

                case 19:
                  f = c;

                case 20:
                  _context24.next = 22;
                  return u.get(t, f);

                case 22:
                  h = _context24.sent;

                  if (!(void 0 === h)) {
                    _context24.next = 30;
                    break;
                  }

                  _context24.next = 26;
                  return s();

                case 26:
                  _context24.next = 28;
                  return u.set(t, f, i.result);

                case 28:
                  _context24.next = 31;
                  break;

                case 30:
                  i.result = h;

                case 31:
                case "end":
                  return _context24.stop();
              }
            }
          }, _callee24);
        }));

        return function (_x16, _x17, _x18) {
          return _ref18.apply(this, arguments);
        };
      }());
    };

    var s =
    /*#__PURE__*/
    function () {
      "use strict";

      function s() {
        _classCallCheck(this, s);

        this.cache = {};
      }

      _createClass(s, [{
        key: "getBlockCacheForPayload",
        value: function getBlockCacheForPayload(t, e) {
          var r = Number.parseInt(e, 16);
          var n = this.cache[r];

          if (!n) {
            var _t22 = {};
            this.cache[r] = _t22, n = _t22;
          }

          return n;
        }
      }, {
        key: "get",
        value: function () {
          var _get2 = _asyncToGenerator(
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee25(t, e) {
            var r;
            return _regeneratorRuntime.wrap(function _callee25$(_context25) {
              while (1) {
                switch (_context25.prev = _context25.next) {
                  case 0:
                    r = this.getBlockCacheForPayload(t, e);

                    if (!r) {
                      _context25.next = 3;
                      break;
                    }

                    return _context25.abrupt("return", r[n.cacheIdentifierForPayload(t, !0)]);

                  case 3:
                  case "end":
                    return _context25.stop();
                }
              }
            }, _callee25, this);
          }));

          function get(_x19, _x20) {
            return _get2.apply(this, arguments);
          }

          return get;
        }()
      }, {
        key: "set",
        value: function () {
          var _set = _asyncToGenerator(
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee26(t, e, r) {
            return _regeneratorRuntime.wrap(function _callee26$(_context26) {
              while (1) {
                switch (_context26.prev = _context26.next) {
                  case 0:
                    this.canCacheResult(t, r) && (this.getBlockCacheForPayload(t, e)[n.cacheIdentifierForPayload(t, !0)] = r);

                  case 1:
                  case "end":
                    return _context26.stop();
                }
              }
            }, _callee26, this);
          }));

          function set(_x21, _x22, _x23) {
            return _set.apply(this, arguments);
          }

          return set;
        }()
      }, {
        key: "canCacheRequest",
        value: function canCacheRequest(t) {
          if (!n.canCache(t)) return !1;
          return "pending" !== n.blockTagForPayload(t);
        }
      }, {
        key: "canCacheResult",
        value: function canCacheResult(t, e) {
          if (!o.includes(e)) return !!(!["eth_getTransactionByHash", "eth_getTransactionReceipt"].includes(t.method) || e && e.blockHash && "0x0000000000000000000000000000000000000000000000000000000000000000" !== e.blockHash);
        }
      }, {
        key: "clearBefore",
        value: function clearBefore(t) {
          var e = this,
              r = Number.parseInt(t, 16);
          Object.keys(e.cache).map(Number).filter(function (t) {
            return t < r;
          }).forEach(function (t) {
            return delete e.cache[t];
          });
        }
      }]);

      return s;
    }();
  }, function (t, e, r) {
    var n = r(83);

    function i(t) {
      return "never" !== a(t);
    }

    function o(t) {
      var e = s(t);
      return e >= t.params.length ? t.params : "eth_getBlockByNumber" === t.method ? t.params.slice(1) : t.params.slice(0, e);
    }

    function s(t) {
      switch (t.method) {
        case "eth_getStorageAt":
          return 2;

        case "eth_getBalance":
        case "eth_getCode":
        case "eth_getTransactionCount":
        case "eth_call":
          return 1;

        case "eth_getBlockByNumber":
          return 0;

        default:
          return;
      }
    }

    function a(t) {
      switch (t.method) {
        case "web3_clientVersion":
        case "web3_sha3":
        case "eth_protocolVersion":
        case "eth_getBlockTransactionCountByHash":
        case "eth_getUncleCountByBlockHash":
        case "eth_getCode":
        case "eth_getBlockByHash":
        case "eth_getTransactionByHash":
        case "eth_getTransactionByBlockHashAndIndex":
        case "eth_getTransactionReceipt":
        case "eth_getUncleByBlockHashAndIndex":
        case "eth_getCompilers":
        case "eth_compileLLL":
        case "eth_compileSolidity":
        case "eth_compileSerpent":
        case "shh_version":
        case "test_permaCache":
          return "perma";

        case "eth_getBlockByNumber":
        case "eth_getBlockTransactionCountByNumber":
        case "eth_getUncleCountByBlockNumber":
        case "eth_getTransactionByBlockNumberAndIndex":
        case "eth_getUncleByBlockNumberAndIndex":
        case "test_forkCache":
          return "fork";

        case "eth_gasPrice":
        case "eth_blockNumber":
        case "eth_getBalance":
        case "eth_getStorageAt":
        case "eth_getTransactionCount":
        case "eth_call":
        case "eth_estimateGas":
        case "eth_getFilterLogs":
        case "eth_getLogs":
        case "test_blockCache":
          return "block";

        case "net_version":
        case "net_peerCount":
        case "net_listening":
        case "eth_syncing":
        case "eth_sign":
        case "eth_coinbase":
        case "eth_mining":
        case "eth_hashrate":
        case "eth_accounts":
        case "eth_sendTransaction":
        case "eth_sendRawTransaction":
        case "eth_newFilter":
        case "eth_newBlockFilter":
        case "eth_newPendingTransactionFilter":
        case "eth_uninstallFilter":
        case "eth_getFilterChanges":
        case "eth_getWork":
        case "eth_submitWork":
        case "eth_submitHashrate":
        case "db_putString":
        case "db_getString":
        case "db_putHex":
        case "db_getHex":
        case "shh_post":
        case "shh_newIdentity":
        case "shh_hasIdentity":
        case "shh_newGroup":
        case "shh_addToGroup":
        case "shh_newFilter":
        case "shh_uninstallFilter":
        case "shh_getFilterChanges":
        case "shh_getMessages":
        case "test_neverCache":
          return "never";
      }
    }

    t.exports = {
      cacheIdentifierForPayload: function cacheIdentifierForPayload(t, e) {
        var r = e ? o(t) : t.params;
        return i(t) ? t.method + ":" + n(r) : null;
      },
      canCache: i,
      blockTagForPayload: function blockTagForPayload(t) {
        var e = s(t);
        if (e >= t.params.length) return null;
        return t.params[e];
      },
      paramsWithoutBlockTag: o,
      blockTagParamIndex: s,
      cacheTypeForPayload: a
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(197),
        i = r(198);

    t.exports = function (t) {
      if (!n(t.then)) throw new TypeError("Expected a promise");
      return function (e) {
        t.then(function (t) {
          i(e, null, t);
        }, function (t) {
          i(e, t);
        });
      };
    };
  }, function (t, e, r) {
    "use strict";

    var n = Object.prototype.toString;

    t.exports = function (t) {
      return "[object Function]" === n.call(t);
    };
  }, function (t, e, r) {
    "use strict";

    (function (e) {
      t.exports = "function" == typeof e ? e : function () {
        var t = [].slice.apply(arguments);
        t.splice(1, 0, 0), setTimeout.apply(null, t);
      };
    }).call(this, r(25).setImmediate);
  }, function (t, e, r) {
    "use strict";

    (function (t, r) {
      var n =
      /*#__PURE__*/
      function () {
        function n(t) {
          _classCallCheck(this, n);

          this.tasks = [], this.count = t;
        }

        _createClass(n, [{
          key: "sched",
          value: function sched() {
            if (this.count > 0 && this.tasks.length > 0) {
              this.count--;

              var _t23 = this.tasks.shift();

              if (void 0 === _t23) throw "Unexpected undefined value in tasks list";

              _t23();
            }
          }
        }, {
          key: "acquire",
          value: function acquire() {
            var _this12 = this;

            return new Promise(function (e, n) {
              _this12.tasks.push(function () {
                var t = !1;
                e(function () {
                  t || (t = !0, _this12.count++, _this12.sched());
                });
              }), t && t.nextTick ? t.nextTick(_this12.sched.bind(_this12)) : r(_this12.sched.bind(_this12));
            });
          }
        }, {
          key: "use",
          value: function use(t) {
            return this.acquire().then(function (e) {
              return t().then(function (t) {
                return e(), t;
              }).catch(function (t) {
                throw e(), t;
              });
            });
          }
        }]);

        return n;
      }();

      e.Semaphore = n;

      e.Mutex =
      /*#__PURE__*/
      function (_n28) {
        _inherits(_class8, _n28);

        function _class8() {
          _classCallCheck(this, _class8);

          return _possibleConstructorReturn(this, _getPrototypeOf(_class8).call(this, 1));
        }

        return _class8;
      }(n);
    }).call(this, r(6), r(25).setImmediate);
  }, function (t, e) {
    t.exports = function (t) {
      return function (e, r, n, i) {
        var o = t[e.method];
        return void 0 === o ? n() : "function" == typeof o ? o(e, r, n, i) : (r.result = o, void i());
      };
    };
  }, function (t, e, r) {
    var n = r(71),
        i = r(202),
        o = r(203),
        _r20 = r(22),
        s = _r20.bnToHex,
        a = _r20.hexToInt,
        u = _r20.incrementHexInt,
        f = _r20.minBlockRef,
        c = _r20.blockRefIsNumber;

    t.exports =
    /*#__PURE__*/
    function (_o13) {
      "use strict";

      _inherits(_class9, _o13);

      function _class9(_ref19) {
        var _this13;

        var t = _ref19.provider,
            e = _ref19.params;

        _classCallCheck(this, _class9);

        _this13 = _possibleConstructorReturn(this, _getPrototypeOf(_class9).call(this)), _this13.type = "log", _this13.ethQuery = new n(t), _this13.params = Object.assign({
          fromBlock: "latest",
          toBlock: "latest",
          address: void 0,
          topics: []
        }, e), _this13.params.address && (Array.isArray(_this13.params.address) || (_this13.params.address = [_this13.params.address]), _this13.params.address = _this13.params.address.map(function (t) {
          return t.toLowerCase();
        }));
        return _this13;
      }

      _createClass(_class9, [{
        key: "initialize",
        value: function () {
          var _initialize2 = _asyncToGenerator(
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee27(_ref20) {
            var t, e, r, n, i;
            return _regeneratorRuntime.wrap(function _callee27$(_context27) {
              while (1) {
                switch (_context27.prev = _context27.next) {
                  case 0:
                    t = _ref20.currentBlock;
                    e = this.params.fromBlock;
                    ["latest", "pending"].includes(e) && (e = t), "earliest" === e && (e = "0x0"), this.params.fromBlock = e;
                    r = f(this.params.toBlock, t);
                    n = Object.assign({}, this.params, {
                      toBlock: r
                    });
                    _context27.next = 7;
                    return this._fetchLogs(n);

                  case 7:
                    i = _context27.sent;
                    this.addInitialResults(i);

                  case 9:
                  case "end":
                    return _context27.stop();
                }
              }
            }, _callee27, this);
          }));

          function initialize(_x24) {
            return _initialize2.apply(this, arguments);
          }

          return initialize;
        }()
      }, {
        key: "update",
        value: function () {
          var _update2 = _asyncToGenerator(
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee28(_ref21) {
            var _this14 = this;

            var t, e, r, n, i, o;
            return _regeneratorRuntime.wrap(function _callee28$(_context28) {
              while (1) {
                switch (_context28.prev = _context28.next) {
                  case 0:
                    t = _ref21.oldBlock, e = _ref21.newBlock;
                    r = e;
                    n = t ? u(t) : e;
                    i = Object.assign({}, this.params, {
                      fromBlock: n,
                      toBlock: r
                    });
                    _context28.next = 6;
                    return this._fetchLogs(i);

                  case 6:
                    _context28.t0 = function (t) {
                      return _this14.matchLog(t);
                    };

                    o = _context28.sent.filter(_context28.t0);
                    this.addResults(o);

                  case 9:
                  case "end":
                    return _context28.stop();
                }
              }
            }, _callee28, this);
          }));

          function update(_x25) {
            return _update2.apply(this, arguments);
          }

          return update;
        }()
      }, {
        key: "_fetchLogs",
        value: function () {
          var _fetchLogs2 = _asyncToGenerator(
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee29(t) {
            var _this15 = this;

            return _regeneratorRuntime.wrap(function _callee29$(_context29) {
              while (1) {
                switch (_context29.prev = _context29.next) {
                  case 0:
                    _context29.next = 2;
                    return i(function (e) {
                      return _this15.ethQuery.getLogs(t, e);
                    })();

                  case 2:
                    return _context29.abrupt("return", _context29.sent);

                  case 3:
                  case "end":
                    return _context29.stop();
                }
              }
            }, _callee29);
          }));

          function _fetchLogs(_x26) {
            return _fetchLogs2.apply(this, arguments);
          }

          return _fetchLogs;
        }()
      }, {
        key: "matchLog",
        value: function matchLog(t) {
          if (a(this.params.fromBlock) >= a(t.blockNumber)) return !1;
          if (c(this.params.toBlock) && a(this.params.toBlock) <= a(t.blockNumber)) return !1;
          var e = t.address && t.address.toLowerCase();
          return !(this.params.address && e && !this.params.address.includes(e)) && this.params.topics.every(function (e, r) {
            var n = t.topics[r];
            if (!n) return !1;
            n = n.toLowerCase();
            var i = Array.isArray(e) ? e : [e];
            return !!i.includes(null) || (i = i.map(function (t) {
              return t.toLowerCase();
            }), i.includes(n));
          });
        }
      }]);

      return _class9;
    }(o);
  }, function (t, e, r) {
    "use strict";

    var n = function n(t, e, r) {
      return function () {
        for (var n = this, i = new Array(arguments.length), o = 0; o < arguments.length; o++) {
          i[o] = arguments[o];
        }

        return new e(function (e, o) {
          i.push(function (t, n) {
            if (t) o(t);else if (r.multiArgs) {
              for (var i = new Array(arguments.length - 1), s = 1; s < arguments.length; s++) {
                i[s - 1] = arguments[s];
              }

              e(i);
            } else e(n);
          }), t.apply(n, i);
        });
      };
    },
        i = t.exports = function (t, e, r) {
      "function" != typeof e && (r = e, e = Promise), (r = r || {}).exclude = r.exclude || [/.+Sync$/];
      var i = "function" == typeof t ? function () {
        return r.excludeMain ? t.apply(this, arguments) : n(t, e, r).apply(this, arguments);
      } : {};
      return Object.keys(t).reduce(function (i, o) {
        var s = t[o];
        return i[o] = "function" == typeof s && function (t) {
          var e = function e(_e16) {
            return "string" == typeof _e16 ? t === _e16 : _e16.test(t);
          };

          return r.include ? r.include.some(e) : !r.exclude.some(e);
        }(o) ? n(s, e, r) : s, i;
      }, i);
    };

    i.all = i;
  }, function (t, e, r) {
    var n = r(47);

    t.exports =
    /*#__PURE__*/
    function (_n29) {
      "use strict";

      _inherits(_class10, _n29);

      function _class10() {
        var _this16;

        _classCallCheck(this, _class10);

        _this16 = _possibleConstructorReturn(this, _getPrototypeOf(_class10).call(this)), _this16.allResults = [];
        return _this16;
      }

      _createClass(_class10, [{
        key: "update",
        value: function () {
          var _update3 = _asyncToGenerator(
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee30() {
            return _regeneratorRuntime.wrap(function _callee30$(_context30) {
              while (1) {
                switch (_context30.prev = _context30.next) {
                  case 0:
                    throw new Error("BaseFilterWithHistory - no update method specified");

                  case 1:
                  case "end":
                    return _context30.stop();
                }
              }
            }, _callee30);
          }));

          function update() {
            return _update3.apply(this, arguments);
          }

          return update;
        }()
      }, {
        key: "addResults",
        value: function addResults(t) {
          this.allResults = this.allResults.concat(t), _get(_getPrototypeOf(_class10.prototype), "addResults", this).call(this, t);
        }
      }, {
        key: "addInitialResults",
        value: function addInitialResults(t) {
          this.allResults = this.allResults.concat(t), _get(_getPrototypeOf(_class10.prototype), "addInitialResults", this).call(this, t);
        }
      }, {
        key: "getAllResults",
        value: function getAllResults() {
          return this.allResults;
        }
      }]);

      return _class10;
    }(n);
  }, function (t, e, r) {
    var n = r(47),
        i = r(48),
        _r21 = r(22),
        o = _r21.incrementHexInt;

    t.exports =
    /*#__PURE__*/
    function (_n30) {
      "use strict";

      _inherits(_class11, _n30);

      function _class11(_ref22) {
        var _this17;

        var t = _ref22.provider,
            e = _ref22.params;

        _classCallCheck(this, _class11);

        _this17 = _possibleConstructorReturn(this, _getPrototypeOf(_class11).call(this)), _this17.type = "block", _this17.provider = t;
        return _this17;
      }

      _createClass(_class11, [{
        key: "update",
        value: function () {
          var _update4 = _asyncToGenerator(
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee31(_ref23) {
            var t, e, r, n, s;
            return _regeneratorRuntime.wrap(function _callee31$(_context31) {
              while (1) {
                switch (_context31.prev = _context31.next) {
                  case 0:
                    t = _ref23.oldBlock, e = _ref23.newBlock;
                    r = e;
                    n = o(t);
                    _context31.next = 5;
                    return i({
                      provider: this.provider,
                      fromBlock: n,
                      toBlock: r
                    });

                  case 5:
                    _context31.t0 = function (t) {
                      return t.hash;
                    };

                    s = _context31.sent.map(_context31.t0);
                    this.addResults(s);

                  case 8:
                  case "end":
                    return _context31.stop();
                }
              }
            }, _callee31, this);
          }));

          function update(_x27) {
            return _update4.apply(this, arguments);
          }

          return update;
        }()
      }]);

      return _class11;
    }(n);
  }, function (t, e, r) {
    var n = r(206),
        i = r(47),
        o = r(48),
        _r22 = r(22),
        s = _r22.incrementHexInt;

    t.exports =
    /*#__PURE__*/
    function (_i13) {
      "use strict";

      _inherits(_class12, _i13);

      function _class12(_ref24) {
        var _this18;

        var t = _ref24.provider;

        _classCallCheck(this, _class12);

        _this18 = _possibleConstructorReturn(this, _getPrototypeOf(_class12).call(this)), _this18.type = "tx", _this18.provider = t;
        return _this18;
      }

      _createClass(_class12, [{
        key: "update",
        value: function () {
          var _update5 = _asyncToGenerator(
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee32(_ref25) {
            var t, e, r, i, a;
            return _regeneratorRuntime.wrap(function _callee32$(_context32) {
              while (1) {
                switch (_context32.prev = _context32.next) {
                  case 0:
                    t = _ref25.oldBlock;
                    e = t;
                    r = s(t);
                    _context32.next = 5;
                    return o({
                      provider: this.provider,
                      fromBlock: r,
                      toBlock: e
                    });

                  case 5:
                    i = _context32.sent;
                    a = n(i, function (t) {
                      return t.transactions;
                    });
                    this.addResults(a);

                  case 8:
                  case "end":
                    return _context32.stop();
                }
              }
            }, _callee32, this);
          }));

          function update(_x28) {
            return _update5.apply(this, arguments);
          }

          return update;
        }()
      }]);

      return _class12;
    }(i);
  }, function (t, e, r) {
    (function (t, r) {
      var n = "[object Arguments]",
          i = "[object Map]",
          o = "[object Object]",
          s = "[object Set]",
          a = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
          u = /^\w*$/,
          f = /^\./,
          c = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,
          h = /\\(\\)?/g,
          l = /^\[object .+?Constructor\]$/,
          d = /^(?:0|[1-9]\d*)$/,
          p = {};
      p["[object Float32Array]"] = p["[object Float64Array]"] = p["[object Int8Array]"] = p["[object Int16Array]"] = p["[object Int32Array]"] = p["[object Uint8Array]"] = p["[object Uint8ClampedArray]"] = p["[object Uint16Array]"] = p["[object Uint32Array]"] = !0, p[n] = p["[object Array]"] = p["[object ArrayBuffer]"] = p["[object Boolean]"] = p["[object DataView]"] = p["[object Date]"] = p["[object Error]"] = p["[object Function]"] = p[i] = p["[object Number]"] = p[o] = p["[object RegExp]"] = p[s] = p["[object String]"] = p["[object WeakMap]"] = !1;

      var g = "object" == typeof t && t && t.Object === Object && t,
          m = "object" == typeof self && self && self.Object === Object && self,
          b = g || m || Function("return this")(),
          v = e && !e.nodeType && e,
          y = v && "object" == typeof r && r && !r.nodeType && r,
          _ = y && y.exports === v && g.process,
          w = function () {
        try {
          return _ && _.binding("util");
        } catch (t) {}
      }(),
          E = w && w.isTypedArray;

      function M(t, e) {
        for (var r = -1, n = t ? t.length : 0, i = Array(n); ++r < n;) {
          i[r] = e(t[r], r, t);
        }

        return i;
      }

      function S(t, e) {
        for (var r = -1, n = e.length, i = t.length; ++r < n;) {
          t[i + r] = e[r];
        }

        return t;
      }

      function A(t, e) {
        for (var r = -1, n = t ? t.length : 0; ++r < n;) {
          if (e(t[r], r, t)) return !0;
        }

        return !1;
      }

      function x(t) {
        var e = !1;
        if (null != t && "function" != typeof t.toString) try {
          e = !!(t + "");
        } catch (t) {}
        return e;
      }

      function R(t) {
        var e = -1,
            r = Array(t.size);
        return t.forEach(function (t, n) {
          r[++e] = [n, t];
        }), r;
      }

      function T(t) {
        var e = -1,
            r = Array(t.size);
        return t.forEach(function (t) {
          r[++e] = t;
        }), r;
      }

      var k,
          I,
          B,
          O = Array.prototype,
          P = Function.prototype,
          N = Object.prototype,
          C = b["__core-js_shared__"],
          L = (k = /[^.]+$/.exec(C && C.keys && C.keys.IE_PROTO || "")) ? "Symbol(src)_1." + k : "",
          j = P.toString,
          U = N.hasOwnProperty,
          D = N.toString,
          F = RegExp("^" + j.call(U).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"),
          z = b.Symbol,
          q = b.Uint8Array,
          H = N.propertyIsEnumerable,
          Y = O.splice,
          G = z ? z.isConcatSpreadable : void 0,
          K = (I = Object.keys, B = Object, function (t) {
        return I(B(t));
      }),
          Z = Tt(b, "DataView"),
          V = Tt(b, "Map"),
          W = Tt(b, "Promise"),
          J = Tt(b, "Set"),
          X = Tt(b, "WeakMap"),
          $ = Tt(Object, "create"),
          Q = jt(Z),
          tt = jt(V),
          et = jt(W),
          rt = jt(J),
          nt = jt(X),
          it = z ? z.prototype : void 0,
          ot = it ? it.valueOf : void 0,
          st = it ? it.toString : void 0;

      function at(t) {
        var e = -1,
            r = t ? t.length : 0;

        for (this.clear(); ++e < r;) {
          var n = t[e];
          this.set(n[0], n[1]);
        }
      }

      function ut(t) {
        var e = -1,
            r = t ? t.length : 0;

        for (this.clear(); ++e < r;) {
          var n = t[e];
          this.set(n[0], n[1]);
        }
      }

      function ft(t) {
        var e = -1,
            r = t ? t.length : 0;

        for (this.clear(); ++e < r;) {
          var n = t[e];
          this.set(n[0], n[1]);
        }
      }

      function ct(t) {
        var e = -1,
            r = t ? t.length : 0;

        for (this.__data__ = new ft(); ++e < r;) {
          this.add(t[e]);
        }
      }

      function ht(t) {
        this.__data__ = new ut(t);
      }

      function lt(t, e) {
        var r = zt(t) || Ft(t) ? function (t, e) {
          for (var r = -1, n = Array(t); ++r < t;) {
            n[r] = e(r);
          }

          return n;
        }(t.length, String) : [],
            n = r.length,
            i = !!n;

        for (var o in t) {
          !e && !U.call(t, o) || i && ("length" == o || Bt(o, n)) || r.push(o);
        }

        return r;
      }

      function dt(t, e) {
        for (var r = t.length; r--;) {
          if (Dt(t[r][0], e)) return r;
        }

        return -1;
      }

      at.prototype.clear = function () {
        this.__data__ = $ ? $(null) : {};
      }, at.prototype.delete = function (t) {
        return this.has(t) && delete this.__data__[t];
      }, at.prototype.get = function (t) {
        var e = this.__data__;

        if ($) {
          var r = e[t];
          return "__lodash_hash_undefined__" === r ? void 0 : r;
        }

        return U.call(e, t) ? e[t] : void 0;
      }, at.prototype.has = function (t) {
        var e = this.__data__;
        return $ ? void 0 !== e[t] : U.call(e, t);
      }, at.prototype.set = function (t, e) {
        return this.__data__[t] = $ && void 0 === e ? "__lodash_hash_undefined__" : e, this;
      }, ut.prototype.clear = function () {
        this.__data__ = [];
      }, ut.prototype.delete = function (t) {
        var e = this.__data__,
            r = dt(e, t);
        return !(r < 0) && (r == e.length - 1 ? e.pop() : Y.call(e, r, 1), !0);
      }, ut.prototype.get = function (t) {
        var e = this.__data__,
            r = dt(e, t);
        return r < 0 ? void 0 : e[r][1];
      }, ut.prototype.has = function (t) {
        return dt(this.__data__, t) > -1;
      }, ut.prototype.set = function (t, e) {
        var r = this.__data__,
            n = dt(r, t);
        return n < 0 ? r.push([t, e]) : r[n][1] = e, this;
      }, ft.prototype.clear = function () {
        this.__data__ = {
          hash: new at(),
          map: new (V || ut)(),
          string: new at()
        };
      }, ft.prototype.delete = function (t) {
        return Rt(this, t).delete(t);
      }, ft.prototype.get = function (t) {
        return Rt(this, t).get(t);
      }, ft.prototype.has = function (t) {
        return Rt(this, t).has(t);
      }, ft.prototype.set = function (t, e) {
        return Rt(this, t).set(t, e), this;
      }, ct.prototype.add = ct.prototype.push = function (t) {
        return this.__data__.set(t, "__lodash_hash_undefined__"), this;
      }, ct.prototype.has = function (t) {
        return this.__data__.has(t);
      }, ht.prototype.clear = function () {
        this.__data__ = new ut();
      }, ht.prototype.delete = function (t) {
        return this.__data__.delete(t);
      }, ht.prototype.get = function (t) {
        return this.__data__.get(t);
      }, ht.prototype.has = function (t) {
        return this.__data__.has(t);
      }, ht.prototype.set = function (t, e) {
        var r = this.__data__;

        if (r instanceof ut) {
          var n = r.__data__;
          if (!V || n.length < 199) return n.push([t, e]), this;
          r = this.__data__ = new ft(n);
        }

        return r.set(t, e), this;
      };
      var pt,
          gt,
          mt = (pt = function pt(t, e) {
        return t && bt(t, e, Wt);
      }, function (t, e) {
        if (null == t) return t;
        if (!qt(t)) return pt(t, e);

        for (var r = t.length, n = gt ? r : -1, i = Object(t); (gt ? n-- : ++n < r) && !1 !== e(i[n], n, i);) {
          ;
        }

        return t;
      });

      var bt = function (t) {
        return function (e, r, n) {
          for (var i = -1, o = Object(e), s = n(e), a = s.length; a--;) {
            var u = s[t ? a : ++i];
            if (!1 === r(o[u], u, o)) break;
          }

          return e;
        };
      }();

      function vt(t, e) {
        for (var r = 0, n = (e = Ot(e, t) ? [e] : At(e)).length; null != t && r < n;) {
          t = t[Lt(e[r++])];
        }

        return r && r == n ? t : void 0;
      }

      function yt(t, e) {
        return null != t && e in Object(t);
      }

      function _t(t, e, r, a, u) {
        return t === e || (null == t || null == e || !Gt(t) && !Kt(e) ? t != t && e != e : function (t, e, r, a, u, f) {
          var c = zt(t),
              h = zt(e),
              l = "[object Array]",
              d = "[object Array]";
          c || (l = (l = kt(t)) == n ? o : l);
          h || (d = (d = kt(e)) == n ? o : d);
          var p = l == o && !x(t),
              g = d == o && !x(e),
              m = l == d;
          if (m && !p) return f || (f = new ht()), c || Vt(t) ? xt(t, e, r, a, u, f) : function (t, e, r, n, o, a, u) {
            switch (r) {
              case "[object DataView]":
                if (t.byteLength != e.byteLength || t.byteOffset != e.byteOffset) return !1;
                t = t.buffer, e = e.buffer;

              case "[object ArrayBuffer]":
                return !(t.byteLength != e.byteLength || !n(new q(t), new q(e)));

              case "[object Boolean]":
              case "[object Date]":
              case "[object Number]":
                return Dt(+t, +e);

              case "[object Error]":
                return t.name == e.name && t.message == e.message;

              case "[object RegExp]":
              case "[object String]":
                return t == e + "";

              case i:
                var f = R;

              case s:
                var c = 2 & a;
                if (f || (f = T), t.size != e.size && !c) return !1;
                var h = u.get(t);
                if (h) return h == e;
                a |= 1, u.set(t, e);
                var l = xt(f(t), f(e), n, o, a, u);
                return u.delete(t), l;

              case "[object Symbol]":
                if (ot) return ot.call(t) == ot.call(e);
            }

            return !1;
          }(t, e, l, r, a, u, f);

          if (!(2 & u)) {
            var b = p && U.call(t, "__wrapped__"),
                v = g && U.call(e, "__wrapped__");

            if (b || v) {
              var y = b ? t.value() : t,
                  _ = v ? e.value() : e;

              return f || (f = new ht()), r(y, _, a, u, f);
            }
          }

          if (!m) return !1;
          return f || (f = new ht()), function (t, e, r, n, i, o) {
            var s = 2 & i,
                a = Wt(t),
                u = a.length,
                f = Wt(e).length;
            if (u != f && !s) return !1;
            var c = u;

            for (; c--;) {
              var h = a[c];
              if (!(s ? h in e : U.call(e, h))) return !1;
            }

            var l = o.get(t);
            if (l && o.get(e)) return l == e;
            var d = !0;
            o.set(t, e), o.set(e, t);
            var p = s;

            for (; ++c < u;) {
              h = a[c];
              var g = t[h],
                  m = e[h];
              if (n) var b = s ? n(m, g, h, e, t, o) : n(g, m, h, t, e, o);

              if (!(void 0 === b ? g === m || r(g, m, n, i, o) : b)) {
                d = !1;
                break;
              }

              p || (p = "constructor" == h);
            }

            if (d && !p) {
              var v = t.constructor,
                  y = e.constructor;
              v != y && "constructor" in t && "constructor" in e && !("function" == typeof v && v instanceof v && "function" == typeof y && y instanceof y) && (d = !1);
            }

            return o.delete(t), o.delete(e), d;
          }(t, e, r, a, u, f);
        }(t, e, _t, r, a, u));
      }

      function wt(t) {
        return !(!Gt(t) || function (t) {
          return !!L && L in t;
        }(t)) && (Ht(t) || x(t) ? F : l).test(jt(t));
      }

      function Et(t) {
        return "function" == typeof t ? t : null == t ? Jt : "object" == typeof t ? zt(t) ? function (t, e) {
          if (Ot(t) && Pt(e)) return Nt(Lt(t), e);
          return function (r) {
            var n = function (t, e, r) {
              var n = null == t ? void 0 : vt(t, e);
              return void 0 === n ? r : n;
            }(r, t);

            return void 0 === n && n === e ? function (t, e) {
              return null != t && function (t, e, r) {
                e = Ot(e, t) ? [e] : At(e);
                var n,
                    i = -1,
                    o = e.length;

                for (; ++i < o;) {
                  var s = Lt(e[i]);
                  if (!(n = null != t && r(t, s))) break;
                  t = t[s];
                }

                if (n) return n;
                return !!(o = t ? t.length : 0) && Yt(o) && Bt(s, o) && (zt(t) || Ft(t));
              }(t, e, yt);
            }(r, t) : _t(e, n, void 0, 3);
          };
        }(t[0], t[1]) : function (t) {
          var e = function (t) {
            var e = Wt(t),
                r = e.length;

            for (; r--;) {
              var n = e[r],
                  i = t[n];
              e[r] = [n, i, Pt(i)];
            }

            return e;
          }(t);

          if (1 == e.length && e[0][2]) return Nt(e[0][0], e[0][1]);
          return function (r) {
            return r === t || function (t, e, r, n) {
              var i = r.length,
                  o = i,
                  s = !n;
              if (null == t) return !o;

              for (t = Object(t); i--;) {
                var a = r[i];
                if (s && a[2] ? a[1] !== t[a[0]] : !(a[0] in t)) return !1;
              }

              for (; ++i < o;) {
                var u = (a = r[i])[0],
                    f = t[u],
                    c = a[1];

                if (s && a[2]) {
                  if (void 0 === f && !(u in t)) return !1;
                } else {
                  var h = new ht();
                  if (n) var l = n(f, c, u, t, e, h);
                  if (!(void 0 === l ? _t(c, f, n, 3, h) : l)) return !1;
                }
              }

              return !0;
            }(r, t, e);
          };
        }(t) : Ot(e = t) ? (r = Lt(e), function (t) {
          return null == t ? void 0 : t[r];
        }) : function (t) {
          return function (e) {
            return vt(e, t);
          };
        }(e);
        var e, r;
      }

      function Mt(t) {
        if (r = (e = t) && e.constructor, n = "function" == typeof r && r.prototype || N, e !== n) return K(t);
        var e,
            r,
            n,
            i = [];

        for (var o in Object(t)) {
          U.call(t, o) && "constructor" != o && i.push(o);
        }

        return i;
      }

      function St(t, e) {
        var r = -1,
            n = qt(t) ? Array(t.length) : [];
        return mt(t, function (t, i, o) {
          n[++r] = e(t, i, o);
        }), n;
      }

      function At(t) {
        return zt(t) ? t : Ct(t);
      }

      function xt(t, e, r, n, i, o) {
        var s = 2 & i,
            a = t.length,
            u = e.length;
        if (a != u && !(s && u > a)) return !1;
        var f = o.get(t);
        if (f && o.get(e)) return f == e;
        var c = -1,
            h = !0,
            l = 1 & i ? new ct() : void 0;

        for (o.set(t, e), o.set(e, t); ++c < a;) {
          var d = t[c],
              p = e[c];
          if (n) var g = s ? n(p, d, c, e, t, o) : n(d, p, c, t, e, o);

          if (void 0 !== g) {
            if (g) continue;
            h = !1;
            break;
          }

          if (l) {
            if (!A(e, function (t, e) {
              if (!l.has(e) && (d === t || r(d, t, n, i, o))) return l.add(e);
            })) {
              h = !1;
              break;
            }
          } else if (d !== p && !r(d, p, n, i, o)) {
            h = !1;
            break;
          }
        }

        return o.delete(t), o.delete(e), h;
      }

      function Rt(t, e) {
        var r,
            n,
            i = t.__data__;
        return ("string" == (n = typeof (r = e)) || "number" == n || "symbol" == n || "boolean" == n ? "__proto__" !== r : null === r) ? i["string" == typeof e ? "string" : "hash"] : i.map;
      }

      function Tt(t, e) {
        var r = function (t, e) {
          return null == t ? void 0 : t[e];
        }(t, e);

        return wt(r) ? r : void 0;
      }

      var kt = function kt(t) {
        return D.call(t);
      };

      function It(t) {
        return zt(t) || Ft(t) || !!(G && t && t[G]);
      }

      function Bt(t, e) {
        return !!(e = null == e ? 9007199254740991 : e) && ("number" == typeof t || d.test(t)) && t > -1 && t % 1 == 0 && t < e;
      }

      function Ot(t, e) {
        if (zt(t)) return !1;
        var r = typeof t;
        return !("number" != r && "symbol" != r && "boolean" != r && null != t && !Zt(t)) || u.test(t) || !a.test(t) || null != e && t in Object(e);
      }

      function Pt(t) {
        return t == t && !Gt(t);
      }

      function Nt(t, e) {
        return function (r) {
          return null != r && r[t] === e && (void 0 !== e || t in Object(r));
        };
      }

      (Z && "[object DataView]" != kt(new Z(new ArrayBuffer(1))) || V && kt(new V()) != i || W && "[object Promise]" != kt(W.resolve()) || J && kt(new J()) != s || X && "[object WeakMap]" != kt(new X())) && (kt = function kt(t) {
        var e = D.call(t),
            r = e == o ? t.constructor : void 0,
            n = r ? jt(r) : void 0;
        if (n) switch (n) {
          case Q:
            return "[object DataView]";

          case tt:
            return i;

          case et:
            return "[object Promise]";

          case rt:
            return s;

          case nt:
            return "[object WeakMap]";
        }
        return e;
      });
      var Ct = Ut(function (t) {
        var e;
        t = null == (e = t) ? "" : function (t) {
          if ("string" == typeof t) return t;
          if (Zt(t)) return st ? st.call(t) : "";
          var e = t + "";
          return "0" == e && 1 / t == -1 / 0 ? "-0" : e;
        }(e);
        var r = [];
        return f.test(t) && r.push(""), t.replace(c, function (t, e, n, i) {
          r.push(n ? i.replace(h, "$1") : e || t);
        }), r;
      });

      function Lt(t) {
        if ("string" == typeof t || Zt(t)) return t;
        var e = t + "";
        return "0" == e && 1 / t == -1 / 0 ? "-0" : e;
      }

      function jt(t) {
        if (null != t) {
          try {
            return j.call(t);
          } catch (t) {}

          try {
            return t + "";
          } catch (t) {}
        }

        return "";
      }

      function Ut(t, e) {
        if ("function" != typeof t || e && "function" != typeof e) throw new TypeError("Expected a function");

        var r = function r() {
          var n = arguments,
              i = e ? e.apply(this, n) : n[0],
              o = r.cache;
          if (o.has(i)) return o.get(i);
          var s = t.apply(this, n);
          return r.cache = o.set(i, s), s;
        };

        return r.cache = new (Ut.Cache || ft)(), r;
      }

      function Dt(t, e) {
        return t === e || t != t && e != e;
      }

      function Ft(t) {
        return function (t) {
          return Kt(t) && qt(t);
        }(t) && U.call(t, "callee") && (!H.call(t, "callee") || D.call(t) == n);
      }

      Ut.Cache = ft;
      var zt = Array.isArray;

      function qt(t) {
        return null != t && Yt(t.length) && !Ht(t);
      }

      function Ht(t) {
        var e = Gt(t) ? D.call(t) : "";
        return "[object Function]" == e || "[object GeneratorFunction]" == e;
      }

      function Yt(t) {
        return "number" == typeof t && t > -1 && t % 1 == 0 && t <= 9007199254740991;
      }

      function Gt(t) {
        var e = typeof t;
        return !!t && ("object" == e || "function" == e);
      }

      function Kt(t) {
        return !!t && "object" == typeof t;
      }

      function Zt(t) {
        return "symbol" == typeof t || Kt(t) && "[object Symbol]" == D.call(t);
      }

      var Vt = E ? function (t) {
        return function (e) {
          return t(e);
        };
      }(E) : function (t) {
        return Kt(t) && Yt(t.length) && !!p[D.call(t)];
      };

      function Wt(t) {
        return qt(t) ? lt(t) : Mt(t);
      }

      function Jt(t) {
        return t;
      }

      r.exports = function (t, e) {
        return function t(e, r, n, i, o) {
          var s = -1,
              a = e.length;

          for (n || (n = It), o || (o = []); ++s < a;) {
            var u = e[s];
            r > 0 && n(u) ? r > 1 ? t(u, r - 1, n, i, o) : S(o, u) : i || (o[o.length] = u);
          }

          return o;
        }(function (t, e) {
          return (zt(t) ? M : St)(t, Et(e));
        }(t, e), 1);
      };
    }).call(this, r(4), r(19)(t));
  }, function (t, e, r) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = function (t, e) {
      if (e = (0, o.default)(e || i.default), !(0, n.default)(t)) return e(new Error("First argument to waterfall must be an array of functions"));
      if (!t.length) return e();
      var r = 0;

      function f(e) {
        var n = (0, u.default)(t[r++]);
        e.push((0, a.default)(c)), n.apply(null, e);
      }

      function c(n) {
        if (n || r === t.length) return e.apply(null, arguments);
        f((0, s.default)(arguments, 1));
      }

      f([]);
    };
    var n = f(r(80)),
        i = f(r(21)),
        o = f(r(41)),
        s = f(r(31)),
        a = f(r(43)),
        u = f(r(12));

    function f(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }

    t.exports = e.default;
  }, function (t, e, r) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = function (t, e) {
      (0, i.default)(n.default, t, e);
    };
    var n = o(r(72)),
        i = o(r(209));

    function o(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }

    t.exports = e.default;
  }, function (t, e, r) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = function (t, e, r) {
      r = r || n.default;
      var a = (0, i.default)(e) ? [] : {};
      t(e, function (t, e, r) {
        (0, s.default)(t)(function (t, n) {
          arguments.length > 2 && (n = (0, o.default)(arguments, 1)), a[e] = n, r(t);
        });
      }, function (t) {
        r(t, a);
      });
    };
    var n = a(r(21)),
        i = a(r(30)),
        o = a(r(31)),
        s = a(r(12));

    function a(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }

    t.exports = e.default;
  }, function (t, e, r) {
    var n = r(16),
        i = r(211);

    function o(t) {
      var e = new Error("Expect argument to be non-empty array");
      if ("object" != typeof t || !t.length) throw e;
      var r = t.map(function (t) {
        return "bytes" === t.type ? n.toBuffer(t.value) : t.value;
      }),
          o = t.map(function (t) {
        return t.type;
      }),
          s = t.map(function (t) {
        if (!t.name) throw e;
        return t.type + " " + t.name;
      });
      return i.soliditySHA3(["bytes32", "bytes32"], [i.soliditySHA3(new Array(t.length).fill("string"), s), i.soliditySHA3(o, r)]);
    }

    function s(t, e) {
      var r = n.toBuffer(e),
          i = n.fromRpcSig(r);
      return n.ecrecover(t, i.v, i.r, i.s);
    }

    function a(t) {
      var e = n.toBuffer(t.data);
      return s(n.hashPersonalMessage(e), t.sig);
    }

    function u(t, e) {
      for (var r = "" + t; r.length < e;) {
        r = "0" + r;
      }

      return r;
    }

    t.exports = {
      concatSig: function concatSig(t, e, r) {
        var i = n.fromSigned(e),
            o = n.fromSigned(r),
            s = n.bufferToInt(t),
            a = u(n.toUnsigned(i).toString("hex"), 64),
            f = u(n.toUnsigned(o).toString("hex"), 64),
            c = n.stripHexPrefix(n.intToHex(s));
        return n.addHexPrefix(a.concat(f, c)).toString("hex");
      },
      normalize: function normalize(t) {
        if (t) {
          if ("number" == typeof t) {
            var _e17 = n.toBuffer(t);

            t = n.bufferToHex(_e17);
          }

          if ("string" != typeof t) {
            var e = "eth-sig-util.normalize() requires hex string or integer input.";
            throw new Error(e += " received " + typeof t + ": " + t);
          }

          return n.addHexPrefix(t.toLowerCase());
        }
      },
      personalSign: function personalSign(t, e) {
        var r = n.toBuffer(e.data),
            i = n.hashPersonalMessage(r),
            o = n.ecsign(i, t);
        return n.bufferToHex(this.concatSig(o.v, o.r, o.s));
      },
      recoverPersonalSignature: function recoverPersonalSignature(t) {
        var e = a(t),
            r = n.publicToAddress(e);
        return n.bufferToHex(r);
      },
      extractPublicKey: function extractPublicKey(t) {
        return "0x" + a(t).toString("hex");
      },
      typedSignatureHash: function typedSignatureHash(t) {
        var e = o(t);
        return n.bufferToHex(e);
      },
      signTypedData: function signTypedData(t, e) {
        var r = o(e.data),
            i = n.ecsign(r, t);
        return n.bufferToHex(this.concatSig(i.v, i.r, i.s));
      },
      recoverTypedSignature: function recoverTypedSignature(t) {
        var e = s(o(t.data), t.sig),
            r = n.publicToAddress(e);
        return n.bufferToHex(r);
      }
    };
  }, function (t, e, r) {
    t.exports = r(212);
  }, function (t, e, r) {
    (function (e) {
      var n = r(213),
          i = r(3);

      var o = function o() {};

      function s(t) {
        return t.startsWith("int[") ? "int256" + t.slice(3) : "int" === t ? "int256" : t.startsWith("uint[") ? "uint256" + t.slice(4) : "uint" === t ? "uint256" : t.startsWith("fixed[") ? "fixed128x128" + t.slice(5) : "fixed" === t ? "fixed128x128" : t.startsWith("ufixed[") ? "ufixed128x128" + t.slice(6) : "ufixed" === t ? "ufixed128x128" : t;
      }

      function a(t) {
        return parseInt(/^\D+(\d+)$/.exec(t)[1], 10);
      }

      function u(t) {
        var e = /^\D+(\d+)x(\d+)$/.exec(t);
        return [parseInt(e[1], 10), parseInt(e[2], 10)];
      }

      function f(t) {
        var e = t.match(/(.*)\[(.*?)\]$/);
        return e ? "" === e[2] ? "dynamic" : parseInt(e[2], 10) : null;
      }

      function c(t) {
        var e = typeof t;
        if ("string" === e) return n.isHexPrefixed(t) ? new i(n.stripHexPrefix(t), 16) : new i(t, 10);
        if ("number" === e) return new i(t);
        if (t.toArray) return t;
        throw new Error("Argument is not a number");
      }

      function h(t) {
        var e = /^(\w+)\((.*)\)$/.exec(t);
        if (3 !== e.length) throw new Error("Invalid method signature");
        var r = /^(.+)\):\((.+)$/.exec(e[2]);
        if (null !== r && 3 === r.length) return {
          method: e[1],
          args: r[1].split(","),
          retargs: r[2].split(",")
        };
        var n = e[2].split(",");
        return 1 === n.length && "" === n[0] && (n = []), {
          method: e[1],
          args: n
        };
      }

      function l(t, r) {
        var o, s, h, d;
        if ("address" === t) return l("uint160", c(r));
        if ("bool" === t) return l("uint8", r ? 1 : 0);
        if ("string" === t) return l("bytes", e.from(r, "utf8"));

        if (m(t)) {
          if (void 0 === r.length) throw new Error("Not an array?");
          if ("dynamic" !== (o = f(t)) && 0 !== o && r.length > o) throw new Error("Elements exceed array size: " + o);

          for (d in h = [], t = t.slice(0, t.lastIndexOf("[")), "string" == typeof r && (r = JSON.parse(r)), r) {
            h.push(l(t, r[d]));
          }

          if ("dynamic" === o) {
            var p = l("uint256", r.length);
            h.unshift(p);
          }

          return e.concat(h);
        }

        if ("bytes" === t) return r = e.from(r), h = e.concat([l("uint256", r.length), r]), r.length % 32 != 0 && (h = e.concat([h, n.zeros(32 - r.length % 32)])), h;

        if (t.startsWith("bytes")) {
          if ((o = a(t)) < 1 || o > 32) throw new Error("Invalid bytes<N> width: " + o);
          return n.setLengthRight(r, 32);
        }

        if (t.startsWith("uint")) {
          if ((o = a(t)) % 8 || o < 8 || o > 256) throw new Error("Invalid uint<N> width: " + o);
          if ((s = c(r)).bitLength() > o) throw new Error("Supplied uint exceeds width: " + o + " vs " + s.bitLength());
          if (s < 0) throw new Error("Supplied uint is negative");
          return s.toArrayLike(e, "be", 32);
        }

        if (t.startsWith("int")) {
          if ((o = a(t)) % 8 || o < 8 || o > 256) throw new Error("Invalid int<N> width: " + o);
          if ((s = c(r)).bitLength() > o) throw new Error("Supplied int exceeds width: " + o + " vs " + s.bitLength());
          return s.toTwos(256).toArrayLike(e, "be", 32);
        }

        if (t.startsWith("ufixed")) {
          if (o = u(t), (s = c(r)) < 0) throw new Error("Supplied ufixed is negative");
          return l("uint256", s.mul(new i(2).pow(new i(o[1]))));
        }

        if (t.startsWith("fixed")) return o = u(t), l("int256", c(r).mul(new i(2).pow(new i(o[1]))));
        throw new Error("Unsupported or invalid type: " + t);
      }

      function d(t, r, n) {
        var o, s, a, u;
        if ("string" == typeof t && (t = p(t)), "address" === t.name) return d(t.rawType, r, n).toArrayLike(e, "be", 20).toString("hex");
        if ("bool" === t.name) return d(t.rawType, r, n).toString() === new i(1).toString();

        if ("string" === t.name) {
          var f = d(t.rawType, r, n);
          return e.from(f, "utf8").toString();
        }

        if (t.isArray) {
          for (a = [], o = t.size, "dynamic" === t.size && (n = d("uint256", r, n).toNumber(), o = d("uint256", r, n).toNumber(), n += 32), u = 0; u < o; u++) {
            var c = d(t.subArray, r, n);
            a.push(c), n += t.subArray.memoryUsage;
          }

          return a;
        }

        if ("bytes" === t.name) return n = d("uint256", r, n).toNumber(), o = d("uint256", r, n).toNumber(), r.slice(n + 32, n + 32 + o);
        if (t.name.startsWith("bytes")) return r.slice(n, n + t.size);

        if (t.name.startsWith("uint")) {
          if ((s = new i(r.slice(n, n + 32), 16, "be")).bitLength() > t.size) throw new Error("Decoded int exceeds width: " + t.size + " vs " + s.bitLength());
          return s;
        }

        if (t.name.startsWith("int")) {
          if ((s = new i(r.slice(n, n + 32), 16, "be").fromTwos(256)).bitLength() > t.size) throw new Error("Decoded uint exceeds width: " + t.size + " vs " + s.bitLength());
          return s;
        }

        if (t.name.startsWith("ufixed")) {
          if (o = new i(2).pow(new i(t.size[1])), !(s = d("uint256", r, n)).mod(o).isZero()) throw new Error("Decimals not supported yet");
          return s.div(o);
        }

        if (t.name.startsWith("fixed")) {
          if (o = new i(2).pow(new i(t.size[1])), !(s = d("int256", r, n)).mod(o).isZero()) throw new Error("Decimals not supported yet");
          return s.div(o);
        }

        throw new Error("Unsupported or invalid type: " + t.name);
      }

      function p(t) {
        var e, r, n;

        if (m(t)) {
          e = f(t);
          var i = t.slice(0, t.lastIndexOf("["));
          return i = p(i), r = {
            isArray: !0,
            name: t,
            size: e,
            memoryUsage: "dynamic" === e ? 32 : i.memoryUsage * e,
            subArray: i
          };
        }

        switch (t) {
          case "address":
            n = "uint160";
            break;

          case "bool":
            n = "uint8";
            break;

          case "string":
            n = "bytes";
        }

        if (r = {
          rawType: n,
          name: t,
          memoryUsage: 32
        }, t.startsWith("bytes") && "bytes" !== t || t.startsWith("uint") || t.startsWith("int") ? r.size = a(t) : (t.startsWith("ufixed") || t.startsWith("fixed")) && (r.size = u(t)), t.startsWith("bytes") && "bytes" !== t && (r.size < 1 || r.size > 32)) throw new Error("Invalid bytes<N> width: " + r.size);
        if ((t.startsWith("uint") || t.startsWith("int")) && (r.size % 8 || r.size < 8 || r.size > 256)) throw new Error("Invalid int/uint<N> width: " + r.size);
        return r;
      }

      function g(t) {
        return "string" === t || "bytes" === t || "dynamic" === f(t);
      }

      function m(t) {
        return t.lastIndexOf("]") === t.length - 1;
      }

      function b(t, e) {
        return t.startsWith("address") || t.startsWith("bytes") ? "0x" + e.toString("hex") : e.toString();
      }

      o.eventID = function (t, r) {
        var i = t + "(" + r.map(s).join(",") + ")";
        return n.keccak256(e.from(i));
      }, o.methodID = function (t, e) {
        return o.eventID(t, e).slice(0, 4);
      }, o.rawEncode = function (t, r) {
        var n = [],
            i = [],
            o = 0;
        t.forEach(function (t) {
          if (m(t)) {
            var e = f(t);
            o += "dynamic" !== e ? 32 * e : 32;
          } else o += 32;
        });

        for (var a = 0; a < t.length; a++) {
          var u = s(t[a]),
              c = l(u, r[a]);
          g(u) ? (n.push(l("uint256", o)), i.push(c), o += c.length) : n.push(c);
        }

        return e.concat(n.concat(i));
      }, o.rawDecode = function (t, r) {
        var n = [];
        r = e.from(r);

        for (var i = 0, o = 0; o < t.length; o++) {
          var a = p(s(t[o])),
              u = d(a, r, i);
          i += a.memoryUsage, n.push(u);
        }

        return n;
      }, o.simpleEncode = function (t) {
        var r = Array.prototype.slice.call(arguments).slice(1),
            n = h(t);
        if (r.length !== n.args.length) throw new Error("Argument count mismatch");
        return e.concat([o.methodID(n.method, n.args), o.rawEncode(n.args, r)]);
      }, o.simpleDecode = function (t, e) {
        var r = h(t);
        if (!r.retargs) throw new Error("No return values in method");
        return o.rawDecode(r.retargs, e);
      }, o.stringify = function (t, e) {
        var r = [];

        for (var n in t) {
          var i = t[n],
              o = e[n];
          o = /^[^\[]+\[.*\]$/.test(i) ? o.map(function (t) {
            return b(i, t);
          }).join(", ") : b(i, o), r.push(o);
        }

        return r;
      }, o.solidityHexValue = function (t, r, i) {
        var s, u;

        if (m(t)) {
          var h = t.replace(/\[.*?\]/, "");

          if (!m(h)) {
            var l = f(t);
            if ("dynamic" !== l && 0 !== l && r.length > l) throw new Error("Elements exceed array size: " + l);
          }

          var d = r.map(function (t) {
            return o.solidityHexValue(h, t, 256);
          });
          return e.concat(d);
        }

        if ("bytes" === t) return r;
        if ("string" === t) return e.from(r, "utf8");

        if ("bool" === t) {
          i = i || 8;
          var p = Array(i / 4).join("0");
          return e.from(r ? p + "1" : p + "0", "hex");
        }

        if ("address" === t) {
          var g = 20;
          return i && (g = i / 8), n.setLengthLeft(r, g);
        }

        if (t.startsWith("bytes")) {
          if ((s = a(t)) < 1 || s > 32) throw new Error("Invalid bytes<N> width: " + s);
          return n.setLengthRight(r, s);
        }

        if (t.startsWith("uint")) {
          if ((s = a(t)) % 8 || s < 8 || s > 256) throw new Error("Invalid uint<N> width: " + s);
          if ((u = c(r)).bitLength() > s) throw new Error("Supplied uint exceeds width: " + s + " vs " + u.bitLength());
          return i = i || s, u.toArrayLike(e, "be", i / 8);
        }

        if (t.startsWith("int")) {
          if ((s = a(t)) % 8 || s < 8 || s > 256) throw new Error("Invalid int<N> width: " + s);
          if ((u = c(r)).bitLength() > s) throw new Error("Supplied int exceeds width: " + s + " vs " + u.bitLength());
          return i = i || s, u.toTwos(s).toArrayLike(e, "be", i / 8);
        }

        throw new Error("Unsupported or invalid type: " + t);
      }, o.solidityPack = function (t, r) {
        if (t.length !== r.length) throw new Error("Number of types are not matching the values");

        for (var n = [], i = 0; i < t.length; i++) {
          var a = s(t[i]),
              u = r[i];
          n.push(o.solidityHexValue(a, u, null));
        }

        return e.concat(n);
      }, o.soliditySHA3 = function (t, e) {
        return n.keccak256(o.solidityPack(t, e));
      }, o.soliditySHA256 = function (t, e) {
        return n.sha256(o.solidityPack(t, e));
      }, o.solidityRIPEMD160 = function (t, e) {
        return n.ripemd160(o.solidityPack(t, e), !0);
      }, o.fromSerpent = function (t) {
        for (var e, r = [], n = 0; n < t.length; n++) {
          var i = t[n];
          if ("s" === i) r.push("bytes");else if ("b" === i) {
            for (var o = "bytes", s = n + 1; s < t.length && (e = t[s]) >= "0" && e <= "9";) {
              o += t[s] - "0", s++;
            }

            n = s - 1, r.push(o);
          } else if ("i" === i) r.push("int256");else {
            if ("a" !== i) throw new Error("Unsupported or invalid type: " + i);
            r.push("int256[]");
          }
        }

        return r;
      }, o.toSerpent = function (t) {
        for (var e = [], r = 0; r < t.length; r++) {
          var n = t[r];
          if ("bytes" === n) e.push("s");else if (n.startsWith("bytes")) e.push("b" + a(n));else if ("int256" === n) e.push("i");else {
            if ("int256[]" !== n) throw new Error("Unsupported or invalid type: " + n);
            e.push("a");
          }
        }

        return e.join("");
      }, t.exports = o;
    }).call(this, r(2).Buffer);
  }, function (t, e, r) {
    "use strict";

    function n(t) {
      for (var r in t) {
        e.hasOwnProperty(r) || (e[r] = t[r]);
      }
    }

    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var i = r(26);
    e.secp256k1 = i;
    var o = r(15),
        s = r(3);
    e.BN = s;
    var a = r(28);
    e.rlp = a, Object.assign(e, o), n(r(214)), n(r(215)), n(r(49)), n(r(222)), n(r(23)), n(r(223));
  }, function (t, e, r) {
    "use strict";

    (function (t) {
      Object.defineProperty(e, "__esModule", {
        value: !0
      });
      var n = r(3);
      e.MAX_INTEGER = new n("ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff", 16), e.TWO_POW256 = new n("10000000000000000000000000000000000000000000000000000000000000000", 16), e.KECCAK256_NULL_S = "c5d2460186f7233c927e7db2dcc703c0e500b653ca82273b7bfad8045d85a470", e.KECCAK256_NULL = t.from(e.KECCAK256_NULL_S, "hex"), e.KECCAK256_RLP_ARRAY_S = "1dcc4de8dec75d7aab85b567b6ccd41ad312451b948a7413f0a142fd40d49347", e.KECCAK256_RLP_ARRAY = t.from(e.KECCAK256_RLP_ARRAY_S, "hex"), e.KECCAK256_RLP_S = "56e81f171bcc55a6ff8345e692c0f86e5b48e01b996cadc001622fb5e363b421", e.KECCAK256_RLP = t.from(e.KECCAK256_RLP_S, "hex");
    }).call(this, r(2).Buffer);
  }, function (t, e, r) {
    "use strict";

    (function (t) {
      Object.defineProperty(e, "__esModule", {
        value: !0
      });
      var n = r(38),
          i = r(15),
          o = r(26),
          s = r(3),
          a = r(23),
          u = r(49);
      e.zeroAddress = function () {
        var t = a.zeros(20);
        return a.bufferToHex(t);
      }, e.isValidAddress = function (t) {
        return /^0x[0-9a-fA-F]{40}$/.test(t);
      }, e.isZeroAddress = function (t) {
        return e.zeroAddress() === a.addHexPrefix(t);
      }, e.toChecksumAddress = function (t, e) {
        t = i.stripHexPrefix(t).toLowerCase();

        for (var r = void 0 !== e ? e.toString() + "0x" : "", n = u.keccak(r + t).toString("hex"), o = "0x", s = 0; s < t.length; s++) {
          parseInt(n[s], 16) >= 8 ? o += t[s].toUpperCase() : o += t[s];
        }

        return o;
      }, e.isValidChecksumAddress = function (t, r) {
        return e.isValidAddress(t) && e.toChecksumAddress(t, r) === t;
      }, e.generateAddress = function (e, r) {
        e = a.toBuffer(e);
        var n = new s(r);
        return n.isZero() ? u.rlphash([e, null]).slice(-20) : u.rlphash([e, t.from(n.toArray())]).slice(-20);
      }, e.generateAddress2 = function (e, r, i) {
        var o = a.toBuffer(e),
            s = a.toBuffer(r),
            f = a.toBuffer(i);
        return n(20 === o.length), n(32 === s.length), u.keccak256(t.concat([t.from("ff", "hex"), o, s, u.keccak256(f)])).slice(-20);
      }, e.isPrecompiled = function (t) {
        var e = a.unpad(t);
        return 1 === e.length && e[0] >= 1 && e[0] <= 8;
      }, e.isValidPrivate = function (t) {
        return o.privateKeyVerify(t);
      }, e.isValidPublic = function (e, r) {
        return void 0 === r && (r = !1), 64 === e.length ? o.publicKeyVerify(t.concat([t.from([4]), e])) : !!r && o.publicKeyVerify(e);
      }, e.pubToAddress = function (t, e) {
        return void 0 === e && (e = !1), t = a.toBuffer(t), e && 64 !== t.length && (t = o.publicKeyConvert(t, !1).slice(1)), n(64 === t.length), u.keccak(t).slice(-20);
      }, e.publicToAddress = e.pubToAddress, e.privateToAddress = function (t) {
        return e.publicToAddress(e.privateToPublic(t));
      }, e.privateToPublic = function (t) {
        return t = a.toBuffer(t), o.publicKeyCreate(t, !1).slice(1);
      }, e.importPublic = function (t) {
        return 64 !== (t = a.toBuffer(t)).length && (t = o.publicKeyConvert(t, !1).slice(1)), t;
      };
    }).call(this, r(2).Buffer);
  }, function (t, e, r) {
    "use strict";

    t.exports = r(217)(r(220));
  }, function (t, e, r) {
    "use strict";

    var n = r(218),
        i = r(219);

    t.exports = function (t) {
      var e = n(t),
          r = i(t);
      return function (t, n) {
        switch ("string" == typeof t ? t.toLowerCase() : t) {
          case "keccak224":
            return new e(1152, 448, null, 224, n);

          case "keccak256":
            return new e(1088, 512, null, 256, n);

          case "keccak384":
            return new e(832, 768, null, 384, n);

          case "keccak512":
            return new e(576, 1024, null, 512, n);

          case "sha3-224":
            return new e(1152, 448, 6, 224, n);

          case "sha3-256":
            return new e(1088, 512, 6, 256, n);

          case "sha3-384":
            return new e(832, 768, 6, 384, n);

          case "sha3-512":
            return new e(576, 1024, 6, 512, n);

          case "shake128":
            return new r(1344, 256, 31, n);

          case "shake256":
            return new r(1088, 512, 31, n);

          default:
            throw new Error("Invald algorithm: " + t);
        }
      };
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(50).Buffer,
        i = r(13).Transform,
        o = r(86);

    t.exports = function (t) {
      function e(e, r, n, o, s) {
        i.call(this, s), this._rate = e, this._capacity = r, this._delimitedSuffix = n, this._hashBitLength = o, this._options = s, this._state = new t(), this._state.initialize(e, r), this._finalized = !1;
      }

      return o(e, i), e.prototype._transform = function (t, e, r) {
        var n = null;

        try {
          this.update(t, e);
        } catch (t) {
          n = t;
        }

        r(n);
      }, e.prototype._flush = function (t) {
        var e = null;

        try {
          this.push(this.digest());
        } catch (t) {
          e = t;
        }

        t(e);
      }, e.prototype.update = function (t, e) {
        if (!n.isBuffer(t) && "string" != typeof t) throw new TypeError("Data must be a string or a buffer");
        if (this._finalized) throw new Error("Digest already called");
        return n.isBuffer(t) || (t = n.from(t, e)), this._state.absorb(t), this;
      }, e.prototype.digest = function (t) {
        if (this._finalized) throw new Error("Digest already called");
        this._finalized = !0, this._delimitedSuffix && this._state.absorbLastFewBits(this._delimitedSuffix);

        var e = this._state.squeeze(this._hashBitLength / 8);

        return void 0 !== t && (e = e.toString(t)), this._resetState(), e;
      }, e.prototype._resetState = function () {
        return this._state.initialize(this._rate, this._capacity), this;
      }, e.prototype._clone = function () {
        var t = new e(this._rate, this._capacity, this._delimitedSuffix, this._hashBitLength, this._options);
        return this._state.copy(t._state), t._finalized = this._finalized, t;
      }, e;
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(50).Buffer,
        i = r(13).Transform,
        o = r(86);

    t.exports = function (t) {
      function e(e, r, n, o) {
        i.call(this, o), this._rate = e, this._capacity = r, this._delimitedSuffix = n, this._options = o, this._state = new t(), this._state.initialize(e, r), this._finalized = !1;
      }

      return o(e, i), e.prototype._transform = function (t, e, r) {
        var n = null;

        try {
          this.update(t, e);
        } catch (t) {
          n = t;
        }

        r(n);
      }, e.prototype._flush = function () {}, e.prototype._read = function (t) {
        this.push(this.squeeze(t));
      }, e.prototype.update = function (t, e) {
        if (!n.isBuffer(t) && "string" != typeof t) throw new TypeError("Data must be a string or a buffer");
        if (this._finalized) throw new Error("Squeeze already called");
        return n.isBuffer(t) || (t = n.from(t, e)), this._state.absorb(t), this;
      }, e.prototype.squeeze = function (t, e) {
        this._finalized || (this._finalized = !0, this._state.absorbLastFewBits(this._delimitedSuffix));

        var r = this._state.squeeze(t);

        return void 0 !== e && (r = r.toString(e)), r;
      }, e.prototype._resetState = function () {
        return this._state.initialize(this._rate, this._capacity), this;
      }, e.prototype._clone = function () {
        var t = new e(this._rate, this._capacity, this._delimitedSuffix, this._options);
        return this._state.copy(t._state), t._finalized = this._finalized, t;
      }, e;
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(50).Buffer,
        i = r(221);

    function o() {
      this.state = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], this.blockSize = null, this.count = 0, this.squeezing = !1;
    }

    o.prototype.initialize = function (t, e) {
      for (var _t24 = 0; _t24 < 50; ++_t24) {
        this.state[_t24] = 0;
      }

      this.blockSize = t / 8, this.count = 0, this.squeezing = !1;
    }, o.prototype.absorb = function (t) {
      for (var _e18 = 0; _e18 < t.length; ++_e18) {
        this.state[~~(this.count / 4)] ^= t[_e18] << this.count % 4 * 8, this.count += 1, this.count === this.blockSize && (i.p1600(this.state), this.count = 0);
      }
    }, o.prototype.absorbLastFewBits = function (t) {
      this.state[~~(this.count / 4)] ^= t << this.count % 4 * 8, 0 != (128 & t) && this.count === this.blockSize - 1 && i.p1600(this.state), this.state[~~((this.blockSize - 1) / 4)] ^= 128 << (this.blockSize - 1) % 4 * 8, i.p1600(this.state), this.count = 0, this.squeezing = !0;
    }, o.prototype.squeeze = function (t) {
      this.squeezing || this.absorbLastFewBits(1);
      var e = n.alloc(t);

      for (var r = 0; r < t; ++r) {
        e[r] = this.state[~~(this.count / 4)] >>> this.count % 4 * 8 & 255, this.count += 1, this.count === this.blockSize && (i.p1600(this.state), this.count = 0);
      }

      return e;
    }, o.prototype.copy = function (t) {
      for (var _e19 = 0; _e19 < 50; ++_e19) {
        t.state[_e19] = this.state[_e19];
      }

      t.blockSize = this.blockSize, t.count = this.count, t.squeezing = this.squeezing;
    }, t.exports = o;
  }, function (t, e, r) {
    "use strict";

    var n = [1, 0, 32898, 0, 32906, 2147483648, 2147516416, 2147483648, 32907, 0, 2147483649, 0, 2147516545, 2147483648, 32777, 2147483648, 138, 0, 136, 0, 2147516425, 0, 2147483658, 0, 2147516555, 0, 139, 2147483648, 32905, 2147483648, 32771, 2147483648, 32770, 2147483648, 128, 2147483648, 32778, 0, 2147483658, 2147483648, 2147516545, 2147483648, 32896, 2147483648, 2147483649, 0, 2147516424, 2147483648];

    e.p1600 = function (t) {
      for (var _e20 = 0; _e20 < 24; ++_e20) {
        var _r23 = t[0] ^ t[10] ^ t[20] ^ t[30] ^ t[40],
            i = t[1] ^ t[11] ^ t[21] ^ t[31] ^ t[41],
            o = t[2] ^ t[12] ^ t[22] ^ t[32] ^ t[42],
            s = t[3] ^ t[13] ^ t[23] ^ t[33] ^ t[43],
            a = t[4] ^ t[14] ^ t[24] ^ t[34] ^ t[44],
            u = t[5] ^ t[15] ^ t[25] ^ t[35] ^ t[45],
            f = t[6] ^ t[16] ^ t[26] ^ t[36] ^ t[46],
            c = t[7] ^ t[17] ^ t[27] ^ t[37] ^ t[47],
            h = t[8] ^ t[18] ^ t[28] ^ t[38] ^ t[48],
            l = t[9] ^ t[19] ^ t[29] ^ t[39] ^ t[49];

        var d = h ^ (o << 1 | s >>> 31),
            p = l ^ (s << 1 | o >>> 31);

        var g = t[0] ^ d,
            m = t[1] ^ p,
            b = t[10] ^ d,
            v = t[11] ^ p,
            y = t[20] ^ d,
            _ = t[21] ^ p,
            w = t[30] ^ d,
            E = t[31] ^ p,
            M = t[40] ^ d,
            S = t[41] ^ p;

        d = _r23 ^ (a << 1 | u >>> 31), p = i ^ (u << 1 | a >>> 31);
        var A = t[2] ^ d,
            x = t[3] ^ p,
            R = t[12] ^ d,
            T = t[13] ^ p,
            k = t[22] ^ d,
            I = t[23] ^ p,
            B = t[32] ^ d,
            O = t[33] ^ p,
            P = t[42] ^ d,
            N = t[43] ^ p;
        d = o ^ (f << 1 | c >>> 31), p = s ^ (c << 1 | f >>> 31);
        var C = t[4] ^ d,
            L = t[5] ^ p,
            j = t[14] ^ d,
            U = t[15] ^ p,
            D = t[24] ^ d,
            F = t[25] ^ p,
            z = t[34] ^ d,
            q = t[35] ^ p,
            H = t[44] ^ d,
            Y = t[45] ^ p;
        d = a ^ (h << 1 | l >>> 31), p = u ^ (l << 1 | h >>> 31);
        var G = t[6] ^ d,
            K = t[7] ^ p,
            Z = t[16] ^ d,
            V = t[17] ^ p,
            W = t[26] ^ d,
            J = t[27] ^ p,
            X = t[36] ^ d,
            $ = t[37] ^ p,
            Q = t[46] ^ d,
            tt = t[47] ^ p;
        d = f ^ (_r23 << 1 | i >>> 31), p = c ^ (i << 1 | _r23 >>> 31);

        var et = t[8] ^ d,
            rt = t[9] ^ p,
            nt = t[18] ^ d,
            it = t[19] ^ p,
            ot = t[28] ^ d,
            st = t[29] ^ p,
            at = t[38] ^ d,
            ut = t[39] ^ p,
            ft = t[48] ^ d,
            ct = t[49] ^ p,
            ht = g,
            lt = m,
            dt = v << 4 | b >>> 28,
            pt = b << 4 | v >>> 28,
            gt = y << 3 | _ >>> 29,
            mt = _ << 3 | y >>> 29,
            bt = E << 9 | w >>> 23,
            vt = w << 9 | E >>> 23,
            yt = M << 18 | S >>> 14,
            _t = S << 18 | M >>> 14,
            wt = A << 1 | x >>> 31,
            Et = x << 1 | A >>> 31,
            Mt = T << 12 | R >>> 20,
            St = R << 12 | T >>> 20,
            At = k << 10 | I >>> 22,
            xt = I << 10 | k >>> 22,
            Rt = O << 13 | B >>> 19,
            Tt = B << 13 | O >>> 19,
            kt = P << 2 | N >>> 30,
            It = N << 2 | P >>> 30,
            Bt = L << 30 | C >>> 2,
            Ot = C << 30 | L >>> 2,
            Pt = j << 6 | U >>> 26,
            Nt = U << 6 | j >>> 26,
            Ct = F << 11 | D >>> 21,
            Lt = D << 11 | F >>> 21,
            jt = z << 15 | q >>> 17,
            Ut = q << 15 | z >>> 17,
            Dt = Y << 29 | H >>> 3,
            Ft = H << 29 | Y >>> 3,
            zt = G << 28 | K >>> 4,
            qt = K << 28 | G >>> 4,
            Ht = V << 23 | Z >>> 9,
            Yt = Z << 23 | V >>> 9,
            Gt = W << 25 | J >>> 7,
            Kt = J << 25 | W >>> 7,
            Zt = X << 21 | $ >>> 11,
            Vt = $ << 21 | X >>> 11,
            Wt = tt << 24 | Q >>> 8,
            Jt = Q << 24 | tt >>> 8,
            Xt = et << 27 | rt >>> 5,
            $t = rt << 27 | et >>> 5,
            Qt = nt << 20 | it >>> 12,
            te = it << 20 | nt >>> 12,
            ee = st << 7 | ot >>> 25,
            re = ot << 7 | st >>> 25,
            ne = at << 8 | ut >>> 24,
            ie = ut << 8 | at >>> 24,
            oe = ft << 14 | ct >>> 18,
            se = ct << 14 | ft >>> 18;

        t[0] = ht ^ ~Mt & Ct, t[1] = lt ^ ~St & Lt, t[10] = zt ^ ~Qt & gt, t[11] = qt ^ ~te & mt, t[20] = wt ^ ~Pt & Gt, t[21] = Et ^ ~Nt & Kt, t[30] = Xt ^ ~dt & At, t[31] = $t ^ ~pt & xt, t[40] = Bt ^ ~Ht & ee, t[41] = Ot ^ ~Yt & re, t[2] = Mt ^ ~Ct & Zt, t[3] = St ^ ~Lt & Vt, t[12] = Qt ^ ~gt & Rt, t[13] = te ^ ~mt & Tt, t[22] = Pt ^ ~Gt & ne, t[23] = Nt ^ ~Kt & ie, t[32] = dt ^ ~At & jt, t[33] = pt ^ ~xt & Ut, t[42] = Ht ^ ~ee & bt, t[43] = Yt ^ ~re & vt, t[4] = Ct ^ ~Zt & oe, t[5] = Lt ^ ~Vt & se, t[14] = gt ^ ~Rt & Dt, t[15] = mt ^ ~Tt & Ft, t[24] = Gt ^ ~ne & yt, t[25] = Kt ^ ~ie & _t, t[34] = At ^ ~jt & Wt, t[35] = xt ^ ~Ut & Jt, t[44] = ee ^ ~bt & kt, t[45] = re ^ ~vt & It, t[6] = Zt ^ ~oe & ht, t[7] = Vt ^ ~se & lt, t[16] = Rt ^ ~Dt & zt, t[17] = Tt ^ ~Ft & qt, t[26] = ne ^ ~yt & wt, t[27] = ie ^ ~_t & Et, t[36] = jt ^ ~Wt & Xt, t[37] = Ut ^ ~Jt & $t, t[46] = bt ^ ~kt & Bt, t[47] = vt ^ ~It & Ot, t[8] = oe ^ ~ht & Mt, t[9] = se ^ ~lt & St, t[18] = Dt ^ ~zt & Qt, t[19] = Ft ^ ~qt & te, t[28] = yt ^ ~wt & Pt, t[29] = _t ^ ~Et & Nt, t[38] = Wt ^ ~Xt & dt, t[39] = Jt ^ ~$t & pt, t[48] = kt ^ ~Bt & Ht, t[49] = It ^ ~Ot & Yt, t[0] ^= n[2 * _e20], t[1] ^= n[2 * _e20 + 1];
      }
    };
  }, function (t, e, r) {
    "use strict";

    (function (t) {
      Object.defineProperty(e, "__esModule", {
        value: !0
      });
      var n = r(26),
          i = r(3),
          o = r(23),
          s = r(49);

      function a(t, e) {
        return e ? t - (2 * e + 35) : t - 27;
      }

      function u(t) {
        return 0 === t || 1 === t;
      }

      e.ecsign = function (t, e, r) {
        var i = n.sign(t, e),
            o = i.recovery;
        return {
          r: i.signature.slice(0, 32),
          s: i.signature.slice(32, 64),
          v: r ? o + (2 * r + 35) : o + 27
        };
      }, e.ecrecover = function (e, r, i, s, f) {
        var c = t.concat([o.setLength(i, 32), o.setLength(s, 32)], 64),
            h = a(r, f);
        if (!u(h)) throw new Error("Invalid signature v value");
        var l = n.recover(e, c, h);
        return n.publicKeyConvert(l, !1).slice(1);
      }, e.toRpcSig = function (e, r, n, i) {
        if (!u(a(e, i))) throw new Error("Invalid signature v value");
        return o.bufferToHex(t.concat([o.setLengthLeft(r, 32), o.setLengthLeft(n, 32), o.toBuffer(e)]));
      }, e.fromRpcSig = function (t) {
        var e = o.toBuffer(t);
        if (65 !== e.length) throw new Error("Invalid signature length");
        var r = e[64];
        return r < 27 && (r += 27), {
          v: r,
          r: e.slice(0, 32),
          s: e.slice(32, 64)
        };
      }, e.isValidSignature = function (t, e, r, n, o) {
        void 0 === n && (n = !0);
        var s = new i("7fffffffffffffffffffffffffffffff5d576e7357a4501ddfe92f46681b20a0", 16),
            f = new i("fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141", 16);
        if (32 !== e.length || 32 !== r.length) return !1;
        if (!u(a(t, o))) return !1;
        var c = new i(e),
            h = new i(r);
        return !(c.isZero() || c.gt(f) || h.isZero() || h.gt(f)) && (!n || 1 !== h.cmp(s));
      }, e.hashPersonalMessage = function (e) {
        var r = t.from("Ethereum Signed Message:\n" + e.length.toString(), "utf-8");
        return s.keccak(t.concat([r, e]));
      };
    }).call(this, r(2).Buffer);
  }, function (t, e, r) {
    "use strict";

    (function (t) {
      Object.defineProperty(e, "__esModule", {
        value: !0
      });
      var n = r(38),
          i = r(15),
          o = r(28),
          s = r(23);

      e.defineProperties = function (e, r, a) {
        if (e.raw = [], e._fields = [], e.toJSON = function (t) {
          if (void 0 === t && (t = !1), t) {
            var r = {};
            return e._fields.forEach(function (t) {
              r[t] = "0x" + e[t].toString("hex");
            }), r;
          }

          return s.baToJSON(e.raw);
        }, e.serialize = function () {
          return o.encode(e.raw);
        }, r.forEach(function (r, i) {
          function o() {
            return e.raw[i];
          }

          function a(o) {
            "00" !== (o = s.toBuffer(o)).toString("hex") || r.allowZero || (o = t.allocUnsafe(0)), r.allowLess && r.length ? (o = s.stripZeros(o), n(r.length >= o.length, "The field " + r.name + " must not have more " + r.length + " bytes")) : r.allowZero && 0 === o.length || !r.length || n(r.length === o.length, "The field " + r.name + " must have byte length of " + r.length), e.raw[i] = o;
          }

          e._fields.push(r.name), Object.defineProperty(e, r.name, {
            enumerable: !0,
            configurable: !0,
            get: o,
            set: a
          }), r.default && (e[r.name] = r.default), r.alias && Object.defineProperty(e, r.alias, {
            enumerable: !1,
            configurable: !0,
            set: a,
            get: o
          });
        }), a) if ("string" == typeof a && (a = t.from(i.stripHexPrefix(a), "hex")), t.isBuffer(a) && (a = o.decode(a)), Array.isArray(a)) {
          if (a.length > e._fields.length) throw new Error("wrong number of fields in data");
          a.forEach(function (t, r) {
            e[e._fields[r]] = s.toBuffer(t);
          });
        } else {
          if ("object" != typeof a) throw new Error("invalid data");
          var u = Object.keys(a);
          r.forEach(function (t) {
            -1 !== u.indexOf(t.name) && (e[t.name] = a[t.name]), -1 !== u.indexOf(t.alias) && (e[t.alias] = a[t.alias]);
          });
        }
      };
    }).call(this, r(2).Buffer);
  }, function (t, e, r) {
    (function (e) {
      !function (r) {
        "use strict";

        var n = function n(t) {
          setTimeout(t, 0);
        };

        void 0 !== e && e && "function" == typeof e.nextTick && (n = e.nextTick), t.exports = function (t) {
          var e = {
            capacity: t || 1,
            current: 0,
            queue: [],
            firstHere: !1,
            take: function take() {
              if (!1 === e.firstHere) {
                e.current++, e.firstHere = !0;
                var t = 1;
              } else t = 0;

              var r = {
                n: 1
              };
              "function" == typeof arguments[0] ? r.task = arguments[0] : r.n = arguments[0], arguments.length >= 2 && ("function" == typeof arguments[1] ? r.task = arguments[1] : r.n = arguments[1]);
              var n = r.task;
              if (r.task = function () {
                n(e.leave);
              }, e.current + r.n - t > e.capacity) return 1 === t && (e.current--, e.firstHere = !1), e.queue.push(r);
              e.current += r.n - t, r.task(e.leave), 1 === t && (e.firstHere = !1);
            },
            leave: function leave(t) {
              if (t = t || 1, e.current -= t, e.queue.length) {
                var r = e.queue[0];
                r.n + e.current > e.capacity || (e.queue.shift(), e.current += r.n, n(r.task));
              } else if (e.current < 0) throw new Error("leave called too many times.");
            },
            available: function available(t) {
              return t = t || 1, e.current + t <= e.capacity;
            }
          };
          return e;
        };
      }();
    }).call(this, r(6));
  }, function (t, e, r) {
    var n = r(44);

    t.exports = function (t, e, r) {
      t.sendAsync(n({
        method: "eth_estimateGas",
        params: [e]
      }), function (t, e) {
        if (t) return "no contract code at given address" === t.message ? r(null, "0xcf08") : r(t);
        r(null, e.result);
      });
    };
  }, function (t, e, r) {
    "use strict";

    (function (e) {
      var n = r(16),
          i = r(227),
          o = n.BN,
          s = new o("7fffffffffffffffffffffffffffffff5d576e7357a4501ddfe92f46681b20a0", 16),
          a = function () {
        function t(r) {
          !function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, t), r = r || {};
          var i = [{
            name: "nonce",
            length: 32,
            allowLess: !0,
            default: new e([])
          }, {
            name: "gasPrice",
            length: 32,
            allowLess: !0,
            default: new e([])
          }, {
            name: "gasLimit",
            alias: "gas",
            length: 32,
            allowLess: !0,
            default: new e([])
          }, {
            name: "to",
            allowZero: !0,
            length: 20,
            default: new e([])
          }, {
            name: "value",
            length: 32,
            allowLess: !0,
            default: new e([])
          }, {
            name: "data",
            alias: "input",
            allowZero: !0,
            default: new e([])
          }, {
            name: "v",
            allowZero: !0,
            default: new e([28])
          }, {
            name: "r",
            length: 32,
            allowZero: !0,
            allowLess: !0,
            default: new e([])
          }, {
            name: "s",
            length: 32,
            allowZero: !0,
            allowLess: !0,
            default: new e([])
          }];
          n.defineProperties(this, i, r), Object.defineProperty(this, "from", {
            enumerable: !0,
            configurable: !0,
            get: this.getSenderAddress.bind(this)
          });
          var o = n.bufferToInt(this.v),
              s = Math.floor((o - 35) / 2);
          s < 0 && (s = 0), this._chainId = s || r.chainId || 0, this._homestead = !0;
        }

        return t.prototype.toCreationAddress = function () {
          return "" === this.to.toString("hex");
        }, t.prototype.hash = function (t) {
          void 0 === t && (t = !0);
          var e = void 0;
          if (t) e = this.raw;else if (this._chainId > 0) {
            var r = this.raw.slice();
            this.v = this._chainId, this.r = 0, this.s = 0, e = this.raw, this.raw = r;
          } else e = this.raw.slice(0, 6);
          return n.rlphash(e);
        }, t.prototype.getChainId = function () {
          return this._chainId;
        }, t.prototype.getSenderAddress = function () {
          if (this._from) return this._from;
          var t = this.getSenderPublicKey();
          return this._from = n.publicToAddress(t), this._from;
        }, t.prototype.getSenderPublicKey = function () {
          if (!(this._senderPubKey && this._senderPubKey.length || this.verifySignature())) throw new Error("Invalid Signature");
          return this._senderPubKey;
        }, t.prototype.verifySignature = function () {
          var t = this.hash(!1);
          if (this._homestead && 1 === new o(this.s).cmp(s)) return !1;

          try {
            var e = n.bufferToInt(this.v);
            this._chainId > 0 && (e -= 2 * this._chainId + 8), this._senderPubKey = n.ecrecover(t, e, this.r, this.s);
          } catch (t) {
            return !1;
          }

          return !!this._senderPubKey;
        }, t.prototype.sign = function (t) {
          var e = this.hash(!1),
              r = n.ecsign(e, t);
          this._chainId > 0 && (r.v += 2 * this._chainId + 8), Object.assign(this, r);
        }, t.prototype.getDataFee = function () {
          for (var t = this.raw[5], e = new o(0), r = 0; r < t.length; r++) {
            0 === t[r] ? e.iaddn(i.txDataZeroGas.v) : e.iaddn(i.txDataNonZeroGas.v);
          }

          return e;
        }, t.prototype.getBaseFee = function () {
          var t = this.getDataFee().iaddn(i.txGas.v);
          return this._homestead && this.toCreationAddress() && t.iaddn(i.txCreation.v), t;
        }, t.prototype.getUpfrontCost = function () {
          return new o(this.gasLimit).imul(new o(this.gasPrice)).iadd(new o(this.value));
        }, t.prototype.validate = function (t) {
          var e = [];
          return this.verifySignature() || e.push("Invalid Signature"), this.getBaseFee().cmp(new o(this.gasLimit)) > 0 && e.push(["gas limit is too low. Need at least " + this.getBaseFee()]), void 0 === t || !1 === t ? 0 === e.length : e.join(" ");
        }, t;
      }();

      t.exports = a;
    }).call(this, r(2).Buffer);
  }, function (t) {
    t.exports = JSON.parse('{"genesisGasLimit":{"v":5000,"d":"Gas limit of the Genesis block."},"genesisDifficulty":{"v":17179869184,"d":"Difficulty of the Genesis block."},"genesisNonce":{"v":"0x0000000000000042","d":"the geneis nonce"},"genesisExtraData":{"v":"0x11bbe8db4e347b4e8c937c1c8370e4b5ed33adb3db69cbdb7a38e1e50b1b82fa","d":"extra data "},"genesisHash":{"v":"0xd4e56740f876aef8c010b86a40d5f56745a118d0906a34e69aec8c0db1cb8fa3","d":"genesis hash"},"genesisStateRoot":{"v":"0xd7f8974fb5ac78d9ac099b9ad5018bedc2ce0a72dad1827a1709da30580f0544","d":"the genesis state root"},"minGasLimit":{"v":5000,"d":"Minimum the gas limit may ever be."},"gasLimitBoundDivisor":{"v":1024,"d":"The bound divisor of the gas limit, used in update calculations."},"minimumDifficulty":{"v":131072,"d":"The minimum that the difficulty may ever be."},"difficultyBoundDivisor":{"v":2048,"d":"The bound divisor of the difficulty, used in the update calculations."},"durationLimit":{"v":13,"d":"The decision boundary on the blocktime duration used to determine whether difficulty should go up or not."},"maximumExtraDataSize":{"v":32,"d":"Maximum size extra data may be after Genesis."},"epochDuration":{"v":30000,"d":"Duration between proof-of-work epochs."},"stackLimit":{"v":1024,"d":"Maximum size of VM stack allowed."},"callCreateDepth":{"v":1024,"d":"Maximum depth of call/create stack."},"tierStepGas":{"v":[0,2,3,5,8,10,20],"d":"Once per operation, for a selection of them."},"expGas":{"v":10,"d":"Once per EXP instuction."},"expByteGas":{"v":10,"d":"Times ceil(log256(exponent)) for the EXP instruction."},"sha3Gas":{"v":30,"d":"Once per SHA3 operation."},"sha3WordGas":{"v":6,"d":"Once per word of the SHA3 operation\'s data."},"sloadGas":{"v":50,"d":"Once per SLOAD operation."},"sstoreSetGas":{"v":20000,"d":"Once per SSTORE operation if the zeroness changes from zero."},"sstoreResetGas":{"v":5000,"d":"Once per SSTORE operation if the zeroness does not change from zero."},"sstoreRefundGas":{"v":15000,"d":"Once per SSTORE operation if the zeroness changes to zero."},"jumpdestGas":{"v":1,"d":"Refunded gas, once per SSTORE operation if the zeroness changes to zero."},"logGas":{"v":375,"d":"Per LOG* operation."},"logDataGas":{"v":8,"d":"Per byte in a LOG* operation\'s data."},"logTopicGas":{"v":375,"d":"Multiplied by the * of the LOG*, per LOG transaction. e.g. LOG0 incurs 0 * c_txLogTopicGas, LOG4 incurs 4 * c_txLogTopicGas."},"createGas":{"v":32000,"d":"Once per CREATE operation & contract-creation transaction."},"callGas":{"v":40,"d":"Once per CALL operation & message call transaction."},"callStipend":{"v":2300,"d":"Free gas given at beginning of call."},"callValueTransferGas":{"v":9000,"d":"Paid for CALL when the value transfor is non-zero."},"callNewAccountGas":{"v":25000,"d":"Paid for CALL when the destination address didn\'t exist prior."},"suicideRefundGas":{"v":24000,"d":"Refunded following a suicide operation."},"memoryGas":{"v":3,"d":"Times the address of the (highest referenced byte in memory + 1). NOTE: referencing happens on read, write and in instructions such as RETURN and CALL."},"quadCoeffDiv":{"v":512,"d":"Divisor for the quadratic particle of the memory cost equation."},"createDataGas":{"v":200,"d":""},"txGas":{"v":21000,"d":"Per transaction. NOTE: Not payable on data of calls between transactions."},"txCreation":{"v":32000,"d":"the cost of creating a contract via tx"},"txDataZeroGas":{"v":4,"d":"Per byte of data attached to a transaction that equals zero. NOTE: Not payable on data of calls between transactions."},"txDataNonZeroGas":{"v":68,"d":"Per byte of data attached to a transaction that is not equal to zero. NOTE: Not payable on data of calls between transactions."},"copyGas":{"v":3,"d":"Multiplied by the number of 32-byte words that are copied (round up) for any *COPY operation and added."},"ecrecoverGas":{"v":3000,"d":""},"sha256Gas":{"v":60,"d":""},"sha256WordGas":{"v":12,"d":""},"ripemd160Gas":{"v":600,"d":""},"ripemd160WordGas":{"v":120,"d":""},"identityGas":{"v":15,"d":""},"identityWordGas":{"v":3,"d":""},"minerReward":{"v":"5000000000000000000","d":"the amount a miner get rewarded for mining a block"},"ommerReward":{"v":"625000000000000000","d":"The amount of wei a miner of an uncle block gets for being inculded in the blockchain"},"niblingReward":{"v":"156250000000000000","d":"the amount a miner gets for inculding a uncle"},"homeSteadForkNumber":{"v":1150000,"d":"the block that the Homestead fork started at"},"homesteadRepriceForkNumber":{"v":2463000,"d":"the block that the Homestead Reprice (EIP150) fork started at"},"timebombPeriod":{"v":100000,"d":"Exponential difficulty timebomb period"},"freeBlockPeriod":{"v":2}}');
  }, function (t, e, r) {
    var n = r(39),
        i = r(85),
        o = r(46),
        s = r(84),
        _r24 = r(22),
        a = _r24.unsafeRandomBytes,
        u = _r24.incrementHexInt,
        f = r(48);

    function c(t) {
      return {
        hash: t.hash,
        parentHash: t.parentHash,
        sha3Uncles: t.sha3Uncles,
        miner: t.miner,
        stateRoot: t.stateRoot,
        transactionsRoot: t.transactionsRoot,
        receiptsRoot: t.receiptsRoot,
        logsBloom: t.logsBloom,
        difficulty: t.difficulty,
        number: t.number,
        gasLimit: t.gasLimit,
        gasUsed: t.gasUsed,
        nonce: t.nonce,
        mixHash: t.mixHash,
        timestamp: t.timestamp,
        extraData: t.extraData
      };
    }

    t.exports = function (_ref26) {
      var t = _ref26.blockTracker,
          e = _ref26.provider;
      var r = {},
          h = s({
        blockTracker: t,
        provider: e
      });
      var l = !1;
      var d = new n(),
          p = i({
        eth_subscribe: o(
        /*#__PURE__*/
        function () {
          var _ref27 = _asyncToGenerator(
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee36(n, i) {
            var o, s, d, _r25, _i14;

            return _regeneratorRuntime.wrap(function _callee36$(_context36) {
              while (1) {
                switch (_context36.prev = _context36.next) {
                  case 0:
                    if (!l) {
                      _context36.next = 2;
                      break;
                    }

                    throw new Error("SubscriptionManager - attempting to use after destroying");

                  case 2:
                    o = n.params[0], s = a(16);
                    _context36.t0 = o;
                    _context36.next = _context36.t0 === "newHeads" ? 6 : _context36.t0 === "logs" ? 8 : 14;
                    break;

                  case 6:
                    d = function (_ref28) {
                      var r = _ref28.subId;
                      var n = {
                        type: o,
                        destroy: function () {
                          var _destroy = _asyncToGenerator(
                          /*#__PURE__*/
                          _regeneratorRuntime.mark(function _callee33() {
                            return _regeneratorRuntime.wrap(function _callee33$(_context33) {
                              while (1) {
                                switch (_context33.prev = _context33.next) {
                                  case 0:
                                    t.removeListener("sync", n.update);

                                  case 1:
                                  case "end":
                                    return _context33.stop();
                                }
                              }
                            }, _callee33);
                          }));

                          function destroy() {
                            return _destroy.apply(this, arguments);
                          }

                          return destroy;
                        }(),
                        update: function () {
                          var _update6 = _asyncToGenerator(
                          /*#__PURE__*/
                          _regeneratorRuntime.mark(function _callee34(_ref29) {
                            var t, n, i, o;
                            return _regeneratorRuntime.wrap(function _callee34$(_context34) {
                              while (1) {
                                switch (_context34.prev = _context34.next) {
                                  case 0:
                                    t = _ref29.oldBlock, n = _ref29.newBlock;
                                    i = n, o = u(t);
                                    _context34.next = 4;
                                    return f({
                                      provider: e,
                                      fromBlock: o,
                                      toBlock: i
                                    });

                                  case 4:
                                    _context34.t0 = c;

                                    _context34.t1 = function (t) {
                                      g(r, t);
                                    };

                                    _context34.sent.map(_context34.t0).forEach(_context34.t1);

                                  case 7:
                                  case "end":
                                    return _context34.stop();
                                }
                              }
                            }, _callee34);
                          }));

                          function update(_x31) {
                            return _update6.apply(this, arguments);
                          }

                          return update;
                        }()
                      };
                      return t.on("sync", n.update), n;
                    }({
                      subId: s
                    });

                    return _context36.abrupt("break", 15);

                  case 8:
                    _r25 = n.params[1];
                    _context36.next = 11;
                    return h.newLogFilter(_r25);

                  case 11:
                    _i14 = _context36.sent;

                    d = function (_ref30) {
                      var t = _ref30.subId,
                          e = _ref30.filter;
                      return e.on("update", function (e) {
                        return g(t, e);
                      }), {
                        type: o,
                        destroy: function () {
                          var _destroy2 = _asyncToGenerator(
                          /*#__PURE__*/
                          _regeneratorRuntime.mark(function _callee35() {
                            return _regeneratorRuntime.wrap(function _callee35$(_context35) {
                              while (1) {
                                switch (_context35.prev = _context35.next) {
                                  case 0:
                                    _context35.next = 2;
                                    return h.uninstallFilter(e.idHex);

                                  case 2:
                                    return _context35.abrupt("return", _context35.sent);

                                  case 3:
                                  case "end":
                                    return _context35.stop();
                                }
                              }
                            }, _callee35);
                          }));

                          function destroy() {
                            return _destroy2.apply(this, arguments);
                          }

                          return destroy;
                        }()
                      };
                    }({
                      subId: s,
                      filter: _i14
                    });

                    return _context36.abrupt("break", 15);

                  case 14:
                    throw new Error("SubscriptionManager - unsupported subscription type \"".concat(o, "\""));

                  case 15:
                    return _context36.abrupt("return", (r[s] = d, void (i.result = s)));

                  case 16:
                  case "end":
                    return _context36.stop();
                }
              }
            }, _callee36);
          }));

          return function (_x29, _x30) {
            return _ref27.apply(this, arguments);
          };
        }()),
        eth_unsubscribe: o(
        /*#__PURE__*/
        function () {
          var _ref31 = _asyncToGenerator(
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee37(t, e) {
            var n, i;
            return _regeneratorRuntime.wrap(function _callee37$(_context37) {
              while (1) {
                switch (_context37.prev = _context37.next) {
                  case 0:
                    if (!l) {
                      _context37.next = 2;
                      break;
                    }

                    throw new Error("SubscriptionManager - attempting to use after destroying");

                  case 2:
                    n = t.params[0], i = r[n];

                    if (i) {
                      _context37.next = 5;
                      break;
                    }

                    return _context37.abrupt("return", void (e.result = !1));

                  case 5:
                    delete r[n];
                    _context37.next = 8;
                    return i.destroy();

                  case 8:
                    e.result = !0;

                  case 9:
                  case "end":
                    return _context37.stop();
                }
              }
            }, _callee37);
          }));

          return function (_x32, _x33) {
            return _ref31.apply(this, arguments);
          };
        }())
      });
      return p.destroy = function () {
        d.removeAllListeners();

        for (var _t25 in r) {
          r[_t25].destroy(), delete r[_t25];
        }

        l = !0;
      }, {
        events: d,
        middleware: p
      };

      function g(t, e) {
        d.emit("notification", {
          jsonrpc: "2.0",
          method: "eth_subscription",
          params: {
            subscription: t,
            result: e
          }
        });
      }
    };
  }, function (t, e, r) {
    "use strict";

    (function (t, n) {
      var i,
          o = this && this.__extends || (i = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (t, e) {
        t.__proto__ = e;
      } || function (t, e) {
        for (var r in e) {
          e.hasOwnProperty(r) && (t[r] = e[r]);
        }
      }, function (t, e) {
        function r() {
          this.constructor = t;
        }

        i(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
      }),
          s = this && this.__assign || Object.assign || function (t) {
        for (var e, r = 1, n = arguments.length; r < n; r++) {
          for (var i in e = arguments[r]) {
            Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
          }
        }

        return t;
      };

      Object.defineProperty(e, "__esModule", {
        value: !0
      });

      var a = r(87),
          u = r(238),
          f = r(239),
          c = r(51),
          h = r(240),
          l = r(241),
          d = r(52),
          p = r(242),
          g = r(243),
          m = function (e) {
        function r(n) {
          void 0 === n && (n = {});
          var i = e.call(this) || this;
          return i.UNSENT = r.UNSENT, i.OPENED = r.OPENED, i.HEADERS_RECEIVED = r.HEADERS_RECEIVED, i.LOADING = r.LOADING, i.DONE = r.DONE, i.onreadystatechange = null, i.readyState = r.UNSENT, i.response = null, i.responseText = "", i.responseType = "", i.status = 0, i.statusText = "", i.timeout = 0, i.upload = new p.XMLHttpRequestUpload(), i.responseUrl = "", i.withCredentials = !1, i._method = null, i._url = null, i._sync = !1, i._headers = {}, i._loweredHeaders = {}, i._mimeOverride = null, i._request = null, i._response = null, i._responseParts = null, i._responseHeaders = null, i._aborting = null, i._error = null, i._loadedBytes = 0, i._totalBytes = 0, i._lengthComputable = !1, i._restrictedMethods = {
            CONNECT: !0,
            TRACE: !0,
            TRACK: !0
          }, i._restrictedHeaders = {
            "accept-charset": !0,
            "accept-encoding": !0,
            "access-control-request-headers": !0,
            "access-control-request-method": !0,
            connection: !0,
            "content-length": !0,
            cookie: !0,
            cookie2: !0,
            date: !0,
            dnt: !0,
            expect: !0,
            host: !0,
            "keep-alive": !0,
            origin: !0,
            referer: !0,
            te: !0,
            trailer: !0,
            "transfer-encoding": !0,
            upgrade: !0,
            "user-agent": !0,
            via: !0
          }, i._privateHeaders = {
            "set-cookie": !0,
            "set-cookie2": !0
          }, i._userAgent = "Mozilla/5.0 (" + f.type() + " " + f.arch() + ") node.js/" + t.versions.node + " v8/" + t.versions.v8, i._anonymous = n.anon || !1, i;
        }

        return o(r, e), r.prototype.open = function (t, e, n, i, o) {
          if (void 0 === n && (n = !0), t = t.toUpperCase(), this._restrictedMethods[t]) throw new r.SecurityError("HTTP method " + t + " is not allowed in XHR");

          var s = this._parseUrl(e, i, o);

          this.readyState === r.HEADERS_RECEIVED || (this.readyState, r.LOADING), this._method = t, this._url = s, this._sync = !n, this._headers = {}, this._loweredHeaders = {}, this._mimeOverride = null, this._setReadyState(r.OPENED), this._request = null, this._response = null, this.status = 0, this.statusText = "", this._responseParts = [], this._responseHeaders = null, this._loadedBytes = 0, this._totalBytes = 0, this._lengthComputable = !1;
        }, r.prototype.setRequestHeader = function (t, e) {
          if (this.readyState !== r.OPENED) throw new r.InvalidStateError("XHR readyState must be OPENED");
          var n = t.toLowerCase();
          this._restrictedHeaders[n] || /^sec-/.test(n) || /^proxy-/.test(n) ? console.warn('Refused to set unsafe header "' + t + '"') : (e = e.toString(), null != this._loweredHeaders[n] ? (t = this._loweredHeaders[n], this._headers[t] = this._headers[t] + ", " + e) : (this._loweredHeaders[n] = t, this._headers[t] = e));
        }, r.prototype.send = function (t) {
          if (this.readyState !== r.OPENED) throw new r.InvalidStateError("XHR readyState must be OPENED");
          if (this._request) throw new r.InvalidStateError("send() already called");

          switch (this._url.protocol) {
            case "file:":
              return this._sendFile(t);

            case "http:":
            case "https:":
              return this._sendHttp(t);

            default:
              throw new r.NetworkError("Unsupported protocol " + this._url.protocol);
          }
        }, r.prototype.abort = function () {
          null != this._request && (this._request.abort(), this._setError(), this._dispatchProgress("abort"), this._dispatchProgress("loadend"));
        }, r.prototype.getResponseHeader = function (t) {
          if (null == this._responseHeaders || null == t) return null;
          var e = t.toLowerCase();
          return this._responseHeaders.hasOwnProperty(e) ? this._responseHeaders[t.toLowerCase()] : null;
        }, r.prototype.getAllResponseHeaders = function () {
          var t = this;
          return null == this._responseHeaders ? "" : Object.keys(this._responseHeaders).map(function (e) {
            return e + ": " + t._responseHeaders[e];
          }).join("\r\n");
        }, r.prototype.overrideMimeType = function (t) {
          if (this.readyState === r.LOADING || this.readyState === r.DONE) throw new r.InvalidStateError("overrideMimeType() not allowed in LOADING or DONE");
          this._mimeOverride = t.toLowerCase();
        }, r.prototype.nodejsSet = function (t) {
          if (this.nodejsHttpAgent = t.httpAgent || this.nodejsHttpAgent, this.nodejsHttpsAgent = t.httpsAgent || this.nodejsHttpsAgent, t.hasOwnProperty("baseUrl")) {
            if (null != t.baseUrl) if (!c.parse(t.baseUrl, !1, !0).protocol) throw new r.SyntaxError("baseUrl must be an absolute URL");
            this.nodejsBaseUrl = t.baseUrl;
          }
        }, r.nodejsSet = function (t) {
          r.prototype.nodejsSet(t);
        }, r.prototype._setReadyState = function (t) {
          this.readyState = t, this.dispatchEvent(new h.ProgressEvent("readystatechange"));
        }, r.prototype._sendFile = function (t) {
          throw new Error("Protocol file: not implemented");
        }, r.prototype._sendHttp = function (t) {
          if (this._sync) throw new Error("Synchronous XHR processing not implemented");
          !t || "GET" !== this._method && "HEAD" !== this._method ? t = t || "" : (console.warn("Discarding entity body for " + this._method + " requests"), t = null), this.upload._setData(t), this._finalizeHeaders(), this._sendHxxpRequest();
        }, r.prototype._sendHxxpRequest = function () {
          var t = this;

          if (this.withCredentials) {
            var e = r.cookieJar.getCookies(g.CookieAccessInfo(this._url.hostname, this._url.pathname, "https:" === this._url.protocol)).toValueString();
            this._headers.cookie = this._headers.cookie2 = e;
          }

          var n = "http:" === this._url.protocol ? [a, this.nodejsHttpAgent] : [u, this.nodejsHttpsAgent],
              i = n[0],
              o = n[1],
              s = i.request.bind(i)({
            hostname: this._url.hostname,
            port: +this._url.port,
            path: this._url.path,
            auth: this._url.auth,
            method: this._method,
            headers: this._headers,
            agent: o
          });
          this._request = s, this.timeout && s.setTimeout(this.timeout, function () {
            return t._onHttpTimeout(s);
          }), s.on("response", function (e) {
            return t._onHttpResponse(s, e);
          }), s.on("error", function (e) {
            return t._onHttpRequestError(s, e);
          }), this.upload._startUpload(s), this._request === s && this._dispatchProgress("loadstart");
        }, r.prototype._finalizeHeaders = function () {
          this._headers = s({}, this._headers, {
            Connection: "keep-alive",
            Host: this._url.host,
            "User-Agent": this._userAgent
          }, this._anonymous ? {
            Referer: "about:blank"
          } : {}), this.upload._finalizeHeaders(this._headers, this._loweredHeaders);
        }, r.prototype._onHttpResponse = function (t, e) {
          var n = this;

          if (this._request === t) {
            if (this.withCredentials && (e.headers["set-cookie"] || e.headers["set-cookie2"]) && r.cookieJar.setCookies(e.headers["set-cookie"] || e.headers["set-cookie2"]), [301, 302, 303, 307, 308].indexOf(e.statusCode) >= 0) return this._url = this._parseUrl(e.headers.location), this._method = "GET", this._loweredHeaders["content-type"] && (delete this._headers[this._loweredHeaders["content-type"]], delete this._loweredHeaders["content-type"]), null != this._headers["Content-Type"] && delete this._headers["Content-Type"], delete this._headers["Content-Length"], this.upload._reset(), this._finalizeHeaders(), void this._sendHxxpRequest();
            this._response = e, this._response.on("data", function (t) {
              return n._onHttpResponseData(e, t);
            }), this._response.on("end", function () {
              return n._onHttpResponseEnd(e);
            }), this._response.on("close", function () {
              return n._onHttpResponseClose(e);
            }), this.responseUrl = this._url.href.split("#")[0], this.status = e.statusCode, this.statusText = a.STATUS_CODES[this.status], this._parseResponseHeaders(e);
            var i = this._responseHeaders["content-length"] || "";
            this._totalBytes = +i, this._lengthComputable = !!i, this._setReadyState(r.HEADERS_RECEIVED);
          }
        }, r.prototype._onHttpResponseData = function (t, e) {
          this._response === t && (this._responseParts.push(new n(e)), this._loadedBytes += e.length, this.readyState !== r.LOADING && this._setReadyState(r.LOADING), this._dispatchProgress("progress"));
        }, r.prototype._onHttpResponseEnd = function (t) {
          this._response === t && (this._parseResponse(), this._request = null, this._response = null, this._setReadyState(r.DONE), this._dispatchProgress("load"), this._dispatchProgress("loadend"));
        }, r.prototype._onHttpResponseClose = function (t) {
          if (this._response === t) {
            var e = this._request;
            this._setError(), e.abort(), this._setReadyState(r.DONE), this._dispatchProgress("error"), this._dispatchProgress("loadend");
          }
        }, r.prototype._onHttpTimeout = function (t) {
          this._request === t && (this._setError(), t.abort(), this._setReadyState(r.DONE), this._dispatchProgress("timeout"), this._dispatchProgress("loadend"));
        }, r.prototype._onHttpRequestError = function (t, e) {
          this._request === t && (this._setError(), t.abort(), this._setReadyState(r.DONE), this._dispatchProgress("error"), this._dispatchProgress("loadend"));
        }, r.prototype._dispatchProgress = function (t) {
          var e = new r.ProgressEvent(t);
          e.lengthComputable = this._lengthComputable, e.loaded = this._loadedBytes, e.total = this._totalBytes, this.dispatchEvent(e);
        }, r.prototype._setError = function () {
          this._request = null, this._response = null, this._responseHeaders = null, this._responseParts = null;
        }, r.prototype._parseUrl = function (t, e, r) {
          var n = null == this.nodejsBaseUrl ? t : c.resolve(this.nodejsBaseUrl, t),
              i = c.parse(n, !1, !0);
          i.hash = null;
          var o = (i.auth || "").split(":"),
              s = o[0],
              a = o[1];
          return (s || a || e || r) && (i.auth = (e || s || "") + ":" + (r || a || "")), i;
        }, r.prototype._parseResponseHeaders = function (t) {
          for (var e in this._responseHeaders = {}, t.headers) {
            var r = e.toLowerCase();
            this._privateHeaders[r] || (this._responseHeaders[r] = t.headers[e]);
          }

          null != this._mimeOverride && (this._responseHeaders["content-type"] = this._mimeOverride);
        }, r.prototype._parseResponse = function () {
          var t = n.concat(this._responseParts);

          switch (this._responseParts = null, this.responseType) {
            case "json":
              this.responseText = null;

              try {
                this.response = JSON.parse(t.toString("utf-8"));
              } catch (t) {
                this.response = null;
              }

              return;

            case "buffer":
              return this.responseText = null, void (this.response = t);

            case "arraybuffer":
              this.responseText = null;

              for (var e = new ArrayBuffer(t.length), r = new Uint8Array(e), i = 0; i < t.length; i++) {
                r[i] = t[i];
              }

              return void (this.response = e);

            case "text":
            default:
              try {
                this.responseText = t.toString(this._parseResponseEncoding());
              } catch (e) {
                this.responseText = t.toString("binary");
              }

              this.response = this.responseText;
          }
        }, r.prototype._parseResponseEncoding = function () {
          return /;\s*charset=(.*)$/.exec(this._responseHeaders["content-type"] || "")[1] || "utf-8";
        }, r.ProgressEvent = h.ProgressEvent, r.InvalidStateError = l.InvalidStateError, r.NetworkError = l.NetworkError, r.SecurityError = l.SecurityError, r.SyntaxError = l.SyntaxError, r.XMLHttpRequestUpload = p.XMLHttpRequestUpload, r.UNSENT = 0, r.OPENED = 1, r.HEADERS_RECEIVED = 2, r.LOADING = 3, r.DONE = 4, r.cookieJar = g.CookieJar(), r;
      }(d.XMLHttpRequestEventTarget);

      e.XMLHttpRequest = m, m.prototype.nodejsHttpAgent = a.globalAgent, m.prototype.nodejsHttpsAgent = u.globalAgent, m.prototype.nodejsBaseUrl = null;
    }).call(this, r(6), r(2).Buffer);
  }, function (t, e, r) {
    (function (e, n, i) {
      var o = r(88),
          s = r(0),
          a = r(89),
          u = r(17),
          f = r(231),
          c = a.IncomingMessage,
          h = a.readyStates;

      var l = t.exports = function (t) {
        var r,
            n = this;
        u.Writable.call(n), n._opts = t, n._body = [], n._headers = {}, t.auth && n.setHeader("Authorization", "Basic " + new e(t.auth).toString("base64")), Object.keys(t.headers).forEach(function (e) {
          n.setHeader(e, t.headers[e]);
        });
        var i = !0;
        if ("disable-fetch" === t.mode || "requestTimeout" in t && !o.abortController) i = !1, r = !0;else if ("prefer-streaming" === t.mode) r = !1;else if ("allow-wrong-content-type" === t.mode) r = !o.overrideMimeType;else {
          if (t.mode && "default" !== t.mode && "prefer-fast" !== t.mode) throw new Error("Invalid value for opts.mode");
          r = !0;
        }
        n._mode = function (t, e) {
          return o.fetch && e ? "fetch" : o.mozchunkedarraybuffer ? "moz-chunked-arraybuffer" : o.msstream ? "ms-stream" : o.arraybuffer && t ? "arraybuffer" : o.vbArray && t ? "text:vbarray" : "text";
        }(r, i), n._fetchTimer = null, n.on("finish", function () {
          n._onFinish();
        });
      };

      s(l, u.Writable), l.prototype.setHeader = function (t, e) {
        var r = t.toLowerCase();
        -1 === d.indexOf(r) && (this._headers[r] = {
          name: t,
          value: e
        });
      }, l.prototype.getHeader = function (t) {
        var e = this._headers[t.toLowerCase()];

        return e ? e.value : null;
      }, l.prototype.removeHeader = function (t) {
        delete this._headers[t.toLowerCase()];
      }, l.prototype._onFinish = function () {
        var t = this;

        if (!t._destroyed) {
          var r = t._opts,
              s = t._headers,
              a = null;
          "GET" !== r.method && "HEAD" !== r.method && (a = o.arraybuffer ? f(e.concat(t._body)) : o.blobConstructor ? new n.Blob(t._body.map(function (t) {
            return f(t);
          }), {
            type: (s["content-type"] || {}).value || ""
          }) : e.concat(t._body).toString());
          var u = [];

          if (Object.keys(s).forEach(function (t) {
            var e = s[t].name,
                r = s[t].value;
            Array.isArray(r) ? r.forEach(function (t) {
              u.push([e, t]);
            }) : u.push([e, r]);
          }), "fetch" === t._mode) {
            var c = null;

            if (o.abortController) {
              var l = new AbortController();
              c = l.signal, t._fetchAbortController = l, "requestTimeout" in r && 0 !== r.requestTimeout && (t._fetchTimer = n.setTimeout(function () {
                t.emit("requestTimeout"), t._fetchAbortController && t._fetchAbortController.abort();
              }, r.requestTimeout));
            }

            n.fetch(t._opts.url, {
              method: t._opts.method,
              headers: u,
              body: a || void 0,
              mode: "cors",
              credentials: r.withCredentials ? "include" : "same-origin",
              signal: c
            }).then(function (e) {
              t._fetchResponse = e, t._connect();
            }, function (e) {
              n.clearTimeout(t._fetchTimer), t._destroyed || t.emit("error", e);
            });
          } else {
            var d = t._xhr = new n.XMLHttpRequest();

            try {
              d.open(t._opts.method, t._opts.url, !0);
            } catch (e) {
              return void i.nextTick(function () {
                t.emit("error", e);
              });
            }

            "responseType" in d && (d.responseType = t._mode.split(":")[0]), "withCredentials" in d && (d.withCredentials = !!r.withCredentials), "text" === t._mode && "overrideMimeType" in d && d.overrideMimeType("text/plain; charset=x-user-defined"), "requestTimeout" in r && (d.timeout = r.requestTimeout, d.ontimeout = function () {
              t.emit("requestTimeout");
            }), u.forEach(function (t) {
              d.setRequestHeader(t[0], t[1]);
            }), t._response = null, d.onreadystatechange = function () {
              switch (d.readyState) {
                case h.LOADING:
                case h.DONE:
                  t._onXHRProgress();

              }
            }, "moz-chunked-arraybuffer" === t._mode && (d.onprogress = function () {
              t._onXHRProgress();
            }), d.onerror = function () {
              t._destroyed || t.emit("error", new Error("XHR error"));
            };

            try {
              d.send(a);
            } catch (e) {
              return void i.nextTick(function () {
                t.emit("error", e);
              });
            }
          }
        }
      }, l.prototype._onXHRProgress = function () {
        (function (t) {
          try {
            var e = t.status;
            return null !== e && 0 !== e;
          } catch (t) {
            return !1;
          }
        })(this._xhr) && !this._destroyed && (this._response || this._connect(), this._response._onXHRProgress());
      }, l.prototype._connect = function () {
        var t = this;
        t._destroyed || (t._response = new c(t._xhr, t._fetchResponse, t._mode, t._fetchTimer), t._response.on("error", function (e) {
          t.emit("error", e);
        }), t.emit("response", t._response));
      }, l.prototype._write = function (t, e, r) {
        this._body.push(t), r();
      }, l.prototype.abort = l.prototype.destroy = function () {
        this._destroyed = !0, n.clearTimeout(this._fetchTimer), this._response && (this._response._destroyed = !0), this._xhr ? this._xhr.abort() : this._fetchAbortController && this._fetchAbortController.abort();
      }, l.prototype.end = function (t, e, r) {
        "function" == typeof t && (r = t, t = void 0), u.Writable.prototype.end.call(this, t, e, r);
      }, l.prototype.flushHeaders = function () {}, l.prototype.setTimeout = function () {}, l.prototype.setNoDelay = function () {}, l.prototype.setSocketKeepAlive = function () {};
      var d = ["accept-charset", "accept-encoding", "access-control-request-headers", "access-control-request-method", "connection", "content-length", "cookie", "cookie2", "date", "dnt", "expect", "host", "keep-alive", "origin", "referer", "te", "trailer", "transfer-encoding", "upgrade", "via"];
    }).call(this, r(2).Buffer, r(4), r(6));
  }, function (t, e, r) {
    var n = r(2).Buffer;

    t.exports = function (t) {
      if (t instanceof Uint8Array) {
        if (0 === t.byteOffset && t.byteLength === t.buffer.byteLength) return t.buffer;
        if ("function" == typeof t.buffer.slice) return t.buffer.slice(t.byteOffset, t.byteOffset + t.byteLength);
      }

      if (n.isBuffer(t)) {
        for (var e = new Uint8Array(t.length), r = t.length, i = 0; i < r; i++) {
          e[i] = t[i];
        }

        return e.buffer;
      }

      throw new Error("Argument must be a Buffer");
    };
  }, function (t, e) {
    t.exports = {
      100: "Continue",
      101: "Switching Protocols",
      102: "Processing",
      200: "OK",
      201: "Created",
      202: "Accepted",
      203: "Non-Authoritative Information",
      204: "No Content",
      205: "Reset Content",
      206: "Partial Content",
      207: "Multi-Status",
      208: "Already Reported",
      226: "IM Used",
      300: "Multiple Choices",
      301: "Moved Permanently",
      302: "Found",
      303: "See Other",
      304: "Not Modified",
      305: "Use Proxy",
      307: "Temporary Redirect",
      308: "Permanent Redirect",
      400: "Bad Request",
      401: "Unauthorized",
      402: "Payment Required",
      403: "Forbidden",
      404: "Not Found",
      405: "Method Not Allowed",
      406: "Not Acceptable",
      407: "Proxy Authentication Required",
      408: "Request Timeout",
      409: "Conflict",
      410: "Gone",
      411: "Length Required",
      412: "Precondition Failed",
      413: "Payload Too Large",
      414: "URI Too Long",
      415: "Unsupported Media Type",
      416: "Range Not Satisfiable",
      417: "Expectation Failed",
      418: "I'm a teapot",
      421: "Misdirected Request",
      422: "Unprocessable Entity",
      423: "Locked",
      424: "Failed Dependency",
      425: "Unordered Collection",
      426: "Upgrade Required",
      428: "Precondition Required",
      429: "Too Many Requests",
      431: "Request Header Fields Too Large",
      451: "Unavailable For Legal Reasons",
      500: "Internal Server Error",
      501: "Not Implemented",
      502: "Bad Gateway",
      503: "Service Unavailable",
      504: "Gateway Timeout",
      505: "HTTP Version Not Supported",
      506: "Variant Also Negotiates",
      507: "Insufficient Storage",
      508: "Loop Detected",
      509: "Bandwidth Limit Exceeded",
      510: "Not Extended",
      511: "Network Authentication Required"
    };
  }, function (t, e, r) {
    (function (t, n) {
      var i;
      /*! https://mths.be/punycode v1.4.1 by @mathias */

      !function (o) {
        e && e.nodeType, t && t.nodeType;
        var s = "object" == typeof n && n;
        s.global !== s && s.window !== s && s.self;
        var a,
            u = 2147483647,
            f = /^xn--/,
            c = /[^\x20-\x7E]/,
            h = /[\x2E\u3002\uFF0E\uFF61]/g,
            l = {
          overflow: "Overflow: input needs wider integers to process",
          "not-basic": "Illegal input >= 0x80 (not a basic code point)",
          "invalid-input": "Invalid input"
        },
            d = Math.floor,
            p = String.fromCharCode;

        function g(t) {
          throw new RangeError(l[t]);
        }

        function m(t, e) {
          for (var r = t.length, n = []; r--;) {
            n[r] = e(t[r]);
          }

          return n;
        }

        function b(t, e) {
          var r = t.split("@"),
              n = "";
          return r.length > 1 && (n = r[0] + "@", t = r[1]), n + m((t = t.replace(h, ".")).split("."), e).join(".");
        }

        function v(t) {
          for (var e, r, n = [], i = 0, o = t.length; i < o;) {
            (e = t.charCodeAt(i++)) >= 55296 && e <= 56319 && i < o ? 56320 == (64512 & (r = t.charCodeAt(i++))) ? n.push(((1023 & e) << 10) + (1023 & r) + 65536) : (n.push(e), i--) : n.push(e);
          }

          return n;
        }

        function y(t) {
          return m(t, function (t) {
            var e = "";
            return t > 65535 && (e += p((t -= 65536) >>> 10 & 1023 | 55296), t = 56320 | 1023 & t), e += p(t);
          }).join("");
        }

        function _(t, e) {
          return t + 22 + 75 * (t < 26) - ((0 != e) << 5);
        }

        function w(t, e, r) {
          var n = 0;

          for (t = r ? d(t / 700) : t >> 1, t += d(t / e); t > 455; n += 36) {
            t = d(t / 35);
          }

          return d(n + 36 * t / (t + 38));
        }

        function E(t) {
          var e,
              r,
              n,
              i,
              o,
              s,
              a,
              f,
              c,
              h,
              l,
              p = [],
              m = t.length,
              b = 0,
              v = 128,
              _ = 72;

          for ((r = t.lastIndexOf("-")) < 0 && (r = 0), n = 0; n < r; ++n) {
            t.charCodeAt(n) >= 128 && g("not-basic"), p.push(t.charCodeAt(n));
          }

          for (i = r > 0 ? r + 1 : 0; i < m;) {
            for (o = b, s = 1, a = 36; i >= m && g("invalid-input"), ((f = (l = t.charCodeAt(i++)) - 48 < 10 ? l - 22 : l - 65 < 26 ? l - 65 : l - 97 < 26 ? l - 97 : 36) >= 36 || f > d((u - b) / s)) && g("overflow"), b += f * s, !(f < (c = a <= _ ? 1 : a >= _ + 26 ? 26 : a - _)); a += 36) {
              s > d(u / (h = 36 - c)) && g("overflow"), s *= h;
            }

            _ = w(b - o, e = p.length + 1, 0 == o), d(b / e) > u - v && g("overflow"), v += d(b / e), b %= e, p.splice(b++, 0, v);
          }

          return y(p);
        }

        function M(t) {
          var e,
              r,
              n,
              i,
              o,
              s,
              a,
              f,
              c,
              h,
              l,
              m,
              b,
              y,
              E,
              M = [];

          for (m = (t = v(t)).length, e = 128, r = 0, o = 72, s = 0; s < m; ++s) {
            (l = t[s]) < 128 && M.push(p(l));
          }

          for (n = i = M.length, i && M.push("-"); n < m;) {
            for (a = u, s = 0; s < m; ++s) {
              (l = t[s]) >= e && l < a && (a = l);
            }

            for (a - e > d((u - r) / (b = n + 1)) && g("overflow"), r += (a - e) * b, e = a, s = 0; s < m; ++s) {
              if ((l = t[s]) < e && ++r > u && g("overflow"), l == e) {
                for (f = r, c = 36; !(f < (h = c <= o ? 1 : c >= o + 26 ? 26 : c - o)); c += 36) {
                  E = f - h, y = 36 - h, M.push(p(_(h + E % y, 0))), f = d(E / y);
                }

                M.push(p(_(f, 0))), o = w(r, b, n == i), r = 0, ++n;
              }
            }

            ++r, ++e;
          }

          return M.join("");
        }

        a = {
          version: "1.4.1",
          ucs2: {
            decode: v,
            encode: y
          },
          decode: E,
          encode: M,
          toASCII: function toASCII(t) {
            return b(t, function (t) {
              return c.test(t) ? "xn--" + M(t) : t;
            });
          },
          toUnicode: function toUnicode(t) {
            return b(t, function (t) {
              return f.test(t) ? E(t.slice(4).toLowerCase()) : t;
            });
          }
        }, void 0 === (i = function () {
          return a;
        }.call(e, r, e, t)) || (t.exports = i);
      }();
    }).call(this, r(19)(t), r(4));
  }, function (t, e, r) {
    "use strict";

    t.exports = {
      isString: function isString(t) {
        return "string" == typeof t;
      },
      isObject: function isObject(t) {
        return "object" == typeof t && null !== t;
      },
      isNull: function isNull(t) {
        return null === t;
      },
      isNullOrUndefined: function isNullOrUndefined(t) {
        return null == t;
      }
    };
  }, function (t, e, r) {
    "use strict";

    e.decode = e.parse = r(236), e.encode = e.stringify = r(237);
  }, function (t, e, r) {
    "use strict";

    function n(t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }

    t.exports = function (t, e, r, o) {
      e = e || "&", r = r || "=";
      var s = {};
      if ("string" != typeof t || 0 === t.length) return s;
      var a = /\+/g;
      t = t.split(e);
      var u = 1e3;
      o && "number" == typeof o.maxKeys && (u = o.maxKeys);
      var f = t.length;
      u > 0 && f > u && (f = u);

      for (var c = 0; c < f; ++c) {
        var h,
            l,
            d,
            p,
            g = t[c].replace(a, "%20"),
            m = g.indexOf(r);
        m >= 0 ? (h = g.substr(0, m), l = g.substr(m + 1)) : (h = g, l = ""), d = decodeURIComponent(h), p = decodeURIComponent(l), n(s, d) ? i(s[d]) ? s[d].push(p) : s[d] = [s[d], p] : s[d] = p;
      }

      return s;
    };

    var i = Array.isArray || function (t) {
      return "[object Array]" === Object.prototype.toString.call(t);
    };
  }, function (t, e, r) {
    "use strict";

    var n = function n(t) {
      switch (typeof t) {
        case "string":
          return t;

        case "boolean":
          return t ? "true" : "false";

        case "number":
          return isFinite(t) ? t : "";

        default:
          return "";
      }
    };

    t.exports = function (t, e, r, a) {
      return e = e || "&", r = r || "=", null === t && (t = void 0), "object" == typeof t ? o(s(t), function (s) {
        var a = encodeURIComponent(n(s)) + r;
        return i(t[s]) ? o(t[s], function (t) {
          return a + encodeURIComponent(n(t));
        }).join(e) : a + encodeURIComponent(n(t[s]));
      }).join(e) : a ? encodeURIComponent(n(a)) + r + encodeURIComponent(n(t)) : "";
    };

    var i = Array.isArray || function (t) {
      return "[object Array]" === Object.prototype.toString.call(t);
    };

    function o(t, e) {
      if (t.map) return t.map(e);

      for (var r = [], n = 0; n < t.length; n++) {
        r.push(e(t[n], n));
      }

      return r;
    }

    var s = Object.keys || function (t) {
      var e = [];

      for (var r in t) {
        Object.prototype.hasOwnProperty.call(t, r) && e.push(r);
      }

      return e;
    };
  }, function (t, e, r) {
    var n = r(87),
        i = r(51),
        o = t.exports;

    for (var s in n) {
      n.hasOwnProperty(s) && (o[s] = n[s]);
    }

    function a(t) {
      if ("string" == typeof t && (t = i.parse(t)), t.protocol || (t.protocol = "https:"), "https:" !== t.protocol) throw new Error('Protocol "' + t.protocol + '" not supported. Expected "https:"');
      return t;
    }

    o.request = function (t, e) {
      return t = a(t), n.request.call(this, t, e);
    }, o.get = function (t, e) {
      return t = a(t), n.get.call(this, t, e);
    };
  }, function (t, e) {
    e.endianness = function () {
      return "LE";
    }, e.hostname = function () {
      return "undefined" != typeof location ? location.hostname : "";
    }, e.loadavg = function () {
      return [];
    }, e.uptime = function () {
      return 0;
    }, e.freemem = function () {
      return Number.MAX_VALUE;
    }, e.totalmem = function () {
      return Number.MAX_VALUE;
    }, e.cpus = function () {
      return [];
    }, e.type = function () {
      return "Browser";
    }, e.release = function () {
      return "undefined" != typeof navigator ? navigator.appVersion : "";
    }, e.networkInterfaces = e.getNetworkInterfaces = function () {
      return {};
    }, e.arch = function () {
      return "javascript";
    }, e.platform = function () {
      return "browser";
    }, e.tmpdir = e.tmpDir = function () {
      return "/tmp";
    }, e.EOL = "\n", e.homedir = function () {
      return "/";
    };
  }, function (t, e, r) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });

    var n = function n(t) {
      this.type = t, this.bubbles = !1, this.cancelable = !1, this.loaded = 0, this.lengthComputable = !1, this.total = 0;
    };

    e.ProgressEvent = n;
  }, function (t, e, r) {
    "use strict";

    var n,
        i = this && this.__extends || (n = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (t, e) {
      t.__proto__ = e;
    } || function (t, e) {
      for (var r in e) {
        e.hasOwnProperty(r) && (t[r] = e[r]);
      }
    }, function (t, e) {
      function r() {
        this.constructor = t;
      }

      n(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
    });
    Object.defineProperty(e, "__esModule", {
      value: !0
    });

    var o = function (t) {
      function e() {
        return null !== t && t.apply(this, arguments) || this;
      }

      return i(e, t), e;
    }(Error);

    e.SecurityError = o;

    var s = function (t) {
      function e() {
        return null !== t && t.apply(this, arguments) || this;
      }

      return i(e, t), e;
    }(Error);

    e.InvalidStateError = s;

    var a = function (t) {
      function e() {
        return null !== t && t.apply(this, arguments) || this;
      }

      return i(e, t), e;
    }(Error);

    e.NetworkError = a;

    var u = function (t) {
      function e() {
        return null !== t && t.apply(this, arguments) || this;
      }

      return i(e, t), e;
    }(Error);

    e.SyntaxError = u;
  }, function (t, e, r) {
    "use strict";

    (function (t) {
      var n,
          i = this && this.__extends || (n = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (t, e) {
        t.__proto__ = e;
      } || function (t, e) {
        for (var r in e) {
          e.hasOwnProperty(r) && (t[r] = e[r]);
        }
      }, function (t, e) {
        function r() {
          this.constructor = t;
        }

        n(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
      });
      Object.defineProperty(e, "__esModule", {
        value: !0
      });

      var o = function (e) {
        function r() {
          var t = e.call(this) || this;
          return t._contentType = null, t._body = null, t._reset(), t;
        }

        return i(r, e), r.prototype._reset = function () {
          this._contentType = null, this._body = null;
        }, r.prototype._setData = function (e) {
          if (null != e) if ("string" == typeof e) 0 !== e.length && (this._contentType = "text/plain;charset=UTF-8"), this._body = new t(e, "utf-8");else if (t.isBuffer(e)) this._body = e;else if (e instanceof ArrayBuffer) {
            for (var r = new t(e.byteLength), n = new Uint8Array(e), i = 0; i < e.byteLength; i++) {
              r[i] = n[i];
            }

            this._body = r;
          } else {
            if (!(e.buffer && e.buffer instanceof ArrayBuffer)) throw new Error("Unsupported send() data " + e);
            r = new t(e.byteLength);
            var o = e.byteOffset;

            for (n = new Uint8Array(e.buffer), i = 0; i < e.byteLength; i++) {
              r[i] = n[i + o];
            }

            this._body = r;
          }
        }, r.prototype._finalizeHeaders = function (t, e) {
          this._contentType && !e["content-type"] && (t["Content-Type"] = this._contentType), this._body && (t["Content-Length"] = this._body.length.toString());
        }, r.prototype._startUpload = function (t) {
          this._body && t.write(this._body), t.end();
        }, r;
      }(r(52).XMLHttpRequestEventTarget);

      e.XMLHttpRequestUpload = o;
    }).call(this, r(2).Buffer);
  }, function (t, e) {
    !function () {
      "use strict";

      function t(e, r, n, i) {
        return this instanceof t ? (this.domain = e || void 0, this.path = r || "/", this.secure = !!n, this.script = !!i, this) : new t(e, r, n, i);
      }

      function r(t, e, n) {
        return t instanceof r ? t : this instanceof r ? (this.name = null, this.value = null, this.expiration_date = 1 / 0, this.path = String(n || "/"), this.explicit_path = !1, this.domain = e || null, this.explicit_domain = !1, this.secure = !1, this.noscript = !1, t && this.parse(t, e, n), this) : new r(t, e, n);
      }

      t.All = Object.freeze(Object.create(null)), e.CookieAccessInfo = t, e.Cookie = r, r.prototype.toString = function () {
        var t = [this.name + "=" + this.value];
        return this.expiration_date !== 1 / 0 && t.push("expires=" + new Date(this.expiration_date).toGMTString()), this.domain && t.push("domain=" + this.domain), this.path && t.push("path=" + this.path), this.secure && t.push("secure"), this.noscript && t.push("httponly"), t.join("; ");
      }, r.prototype.toValueString = function () {
        return this.name + "=" + this.value;
      };
      var n = /[:](?=\s*[a-zA-Z0-9_\-]+\s*[=])/g;

      function i() {
        var t, e;
        return this instanceof i ? (t = Object.create(null), this.setCookie = function (n, i, o) {
          var s, a;

          if (s = (n = new r(n, i, o)).expiration_date <= Date.now(), void 0 !== t[n.name]) {
            for (e = t[n.name], a = 0; a < e.length; a += 1) {
              if (e[a].collidesWith(n)) return s ? (e.splice(a, 1), 0 === e.length && delete t[n.name], !1) : (e[a] = n, n);
            }

            return !s && (e.push(n), n);
          }

          return !s && (t[n.name] = [n], t[n.name]);
        }, this.getCookie = function (r, n) {
          var i, o;
          if (e = t[r]) for (o = 0; o < e.length; o += 1) {
            if ((i = e[o]).expiration_date <= Date.now()) 0 === e.length && delete t[i.name];else if (i.matches(n)) return i;
          }
        }, this.getCookies = function (e) {
          var r,
              n,
              i = [];

          for (r in t) {
            (n = this.getCookie(r, e)) && i.push(n);
          }

          return i.toString = function () {
            return i.join(":");
          }, i.toValueString = function () {
            return i.map(function (t) {
              return t.toValueString();
            }).join(";");
          }, i;
        }, this) : new i();
      }

      r.prototype.parse = function (t, e, n) {
        if (this instanceof r) {
          var i,
              o = t.split(";").filter(function (t) {
            return !!t;
          }),
              s = o[0].match(/([^=]+)=([\s\S]*)/);
          if (!s) return void console.warn("Invalid cookie header encountered. Header: '" + t + "'");
          var a = s[1],
              u = s[2];
          if ("string" != typeof a || 0 === a.length || "string" != typeof u) return void console.warn("Unable to extract values from cookie header. Cookie: '" + t + "'");

          for (this.name = a, this.value = u, i = 1; i < o.length; i += 1) {
            switch (a = (s = o[i].match(/([^=]+)(?:=([\s\S]*))?/))[1].trim().toLowerCase(), u = s[2], a) {
              case "httponly":
                this.noscript = !0;
                break;

              case "expires":
                this.expiration_date = u ? Number(Date.parse(u)) : 1 / 0;
                break;

              case "path":
                this.path = u ? u.trim() : "", this.explicit_path = !0;
                break;

              case "domain":
                this.domain = u ? u.trim() : "", this.explicit_domain = !!this.domain;
                break;

              case "secure":
                this.secure = !0;
            }
          }

          return this.explicit_path || (this.path = n || "/"), this.explicit_domain || (this.domain = e), this;
        }

        return new r().parse(t, e, n);
      }, r.prototype.matches = function (e) {
        return e === t.All || !(this.noscript && e.script || this.secure && !e.secure || !this.collidesWith(e));
      }, r.prototype.collidesWith = function (t) {
        if (this.path && !t.path || this.domain && !t.domain) return !1;
        if (this.path && 0 !== t.path.indexOf(this.path)) return !1;
        if (this.explicit_path && 0 !== t.path.indexOf(this.path)) return !1;
        var e = t.domain && t.domain.replace(/^[\.]/, ""),
            r = this.domain && this.domain.replace(/^[\.]/, "");
        if (r === e) return !0;

        if (r) {
          if (!this.explicit_domain) return !1;
          var n = e.indexOf(r);
          return -1 !== n && n === e.length - r.length;
        }

        return !0;
      }, e.CookieJar = i, i.prototype.setCookies = function (t, e, i) {
        var o,
            s,
            a = [];

        for (t = (t = Array.isArray(t) ? t : t.split(n)).map(function (t) {
          return new r(t, e, i);
        }), o = 0; o < t.length; o += 1) {
          s = t[o], this.setCookie(s, e, i) && a.push(s);
        }

        return a;
      };
    }();
  }, function (t, e, r) {
    "use strict";

    r.r(e);

    var n = r(90),
        i = r(91),
        o = r.n(i),
        s = r(53),
        a = r.n(s),
        u = r(92),
        f = r.n(u),
        c = r(93),
        h = r.n(c),
        l = r(94),
        d = r.n(l),
        p = r(95),
        g = r.n(p),
        m = r(96),
        b = r.n(m),
        v = r(97),
        y = r.n(v),
        _ = r(98),
        w = r.n(_),
        E = r(8),
        M = r.n(E),
        S = r(99);

    var A = window,
        x = void 0 !== A && void 0 !== A.XMLHttpRequest ? A.XMLHttpRequest : S.XMLHttpRequest;

    var R =
    /*#__PURE__*/
    function (_M$a) {
      _inherits(R, _M$a);

      function R(t) {
        var _this19;

        _classCallCheck(this, R);

        _this19 = _possibleConstructorReturn(this, _getPrototypeOf(R).call(this)), _this19.url = t, _this19.post = {
          body: null,
          headers: {
            "Content-Type": "application/json"
          },
          method: "POST"
        };
        return _this19;
      }

      _createClass(R, [{
        key: "formatError",
        value: function formatError(t, e) {
          var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : -1;
          return {
            error: {
              message: e,
              code: r
            },
            id: t.id,
            jsonrpc: t.jsonrpc
          };
        }
      }, {
        key: "send",
        value: function send(t, e) {
          var _this20 = this;

          return new Promise(function (r) {
            if ("eth_subscribe" === t.method) {
              var _e21 = _this20.formatError(t, "Subscriptions are not supported by this HTTP endpoint");

              return r(_e21);
            }

            var n = new x();
            var i = !1;

            var o = function o(_o14, s) {
              if (!i) if (n.abort(), i = !0, e) e(_o14, s);else {
                var _e22 = t.id,
                    _n31 = t.jsonrpc,
                    _i15 = _o14 ? {
                  id: _e22,
                  jsonrpc: _n31,
                  error: {
                    message: _o14.message,
                    code: _o14.code
                  }
                } : {
                  id: _e22,
                  jsonrpc: _n31,
                  result: s
                };

                r(_i15);
              }
            };

            try {
              _this20.post.body = JSON.stringify(t);
            } catch (t) {
              return o(t);
            }

            n.open("POST", _this20.url, !0), n.timeout = 6e4, n.onerror = o, n.ontimeout = o, n.onreadystatechange = function () {
              if (4 === n.readyState) try {
                var _t26 = JSON.parse(n.responseText);

                o(_t26.error, _t26.result);
              } catch (t) {
                o(t);
              }
            }, n.send(JSON.stringify(t));
          });
        }
      }]);

      return R;
    }(M.a);

    var T = R;

    var k =
    /*#__PURE__*/
    function (_f$a) {
      _inherits(k, _f$a);

      function k(t) {
        var _this21;

        _classCallCheck(this, k);

        if (_this21 = _possibleConstructorReturn(this, _getPrototypeOf(k).call(this, {
          pollingInterval: t.pollingInterval || 4e3
        })), _this21.bridge = t.bridge || "https://bridge.walletconnect.org", _this21.qrcode = void 0 === t.qrcode || !1 !== t.qrcode, _this21.rpc = t.rpc || null, !(_this21.rpc || t.infuraId && "string" == typeof t.infuraId && t.infuraId.trim())) throw new Error("Missing one of the required parameters: rpc or infuraId");
        _this21.infuraId = t.infuraId || "", _this21.wc = new o.a({
          bridge: _this21.bridge
        }), _this21.isConnecting = !1, _this21.connected = !1, _this21.isWalletConnect = !0, _this21.connectCallbacks = [], _this21.accounts = [], _this21.chainId = void 0 !== t.chainId ? t.chainId : 1, _this21.networkId = _this21.chainId, _this21.rpcUrl = "", _this21.updateRpcUrl(_this21.chainId), _this21.addProvider(new d.a({
          eth_hashrate: "0x00",
          eth_mining: !1,
          eth_syncing: !0,
          net_listening: !0,
          web3_clientVersion: "WalletConnect/v".concat(n.version, "/javascript")
        })), _this21.addProvider(new h.a()), _this21.addProvider(new w.a()), _this21.addProvider(new g.a()), _this21.addProvider(new y.a()), _this21.addProvider(new b.a({
          getAccounts: function () {
            var _getAccounts = _asyncToGenerator(
            /*#__PURE__*/
            _regeneratorRuntime.mark(function _callee38(t) {
              var _e23;

              return _regeneratorRuntime.wrap(function _callee38$(_context38) {
                while (1) {
                  switch (_context38.prev = _context38.next) {
                    case 0:
                      _context38.prev = 0;
                      _context38.next = 3;
                      return _this21.getWalletConnector();

                    case 3:
                      _e23 = _context38.sent.accounts;
                      _e23 && _e23.length ? t(null, _e23) : t(new Error("Failed to get accounts"));
                      _context38.next = 10;
                      break;

                    case 7:
                      _context38.prev = 7;
                      _context38.t0 = _context38["catch"](0);
                      t(_context38.t0);

                    case 10:
                    case "end":
                      return _context38.stop();
                  }
                }
              }, _callee38, null, [[0, 7]]);
            }));

            function getAccounts(_x34) {
              return _getAccounts.apply(this, arguments);
            }

            return getAccounts;
          }(),
          processMessage: function () {
            var _processMessage = _asyncToGenerator(
            /*#__PURE__*/
            _regeneratorRuntime.mark(function _callee39(t, e) {
              var _r26;

              return _regeneratorRuntime.wrap(function _callee39$(_context39) {
                while (1) {
                  switch (_context39.prev = _context39.next) {
                    case 0:
                      _context39.prev = 0;
                      _context39.next = 3;
                      return _this21.getWalletConnector();

                    case 3:
                      _r26 = _context39.sent;
                      _context39.t0 = e;
                      _context39.next = 7;
                      return _r26.signMessage([t.from, t.data]);

                    case 7:
                      _context39.t1 = _context39.sent;
                      (0, _context39.t0)(null, _context39.t1);
                      _context39.next = 14;
                      break;

                    case 11:
                      _context39.prev = 11;
                      _context39.t2 = _context39["catch"](0);
                      e(_context39.t2);

                    case 14:
                    case "end":
                      return _context39.stop();
                  }
                }
              }, _callee39, null, [[0, 11]]);
            }));

            function processMessage(_x35, _x36) {
              return _processMessage.apply(this, arguments);
            }

            return processMessage;
          }(),
          processPersonalMessage: function () {
            var _processPersonalMessage = _asyncToGenerator(
            /*#__PURE__*/
            _regeneratorRuntime.mark(function _callee40(t, e) {
              var _r27;

              return _regeneratorRuntime.wrap(function _callee40$(_context40) {
                while (1) {
                  switch (_context40.prev = _context40.next) {
                    case 0:
                      _context40.prev = 0;
                      _context40.next = 3;
                      return _this21.getWalletConnector();

                    case 3:
                      _r27 = _context40.sent;
                      _context40.t0 = e;
                      _context40.next = 7;
                      return _r27.signPersonalMessage([t.data, t.from]);

                    case 7:
                      _context40.t1 = _context40.sent;
                      (0, _context40.t0)(null, _context40.t1);
                      _context40.next = 14;
                      break;

                    case 11:
                      _context40.prev = 11;
                      _context40.t2 = _context40["catch"](0);
                      e(_context40.t2);

                    case 14:
                    case "end":
                      return _context40.stop();
                  }
                }
              }, _callee40, null, [[0, 11]]);
            }));

            function processPersonalMessage(_x37, _x38) {
              return _processPersonalMessage.apply(this, arguments);
            }

            return processPersonalMessage;
          }(),
          processSignTransaction: function () {
            var _processSignTransaction = _asyncToGenerator(
            /*#__PURE__*/
            _regeneratorRuntime.mark(function _callee41(t, e) {
              var _r28;

              return _regeneratorRuntime.wrap(function _callee41$(_context41) {
                while (1) {
                  switch (_context41.prev = _context41.next) {
                    case 0:
                      _context41.prev = 0;
                      _context41.next = 3;
                      return _this21.getWalletConnector();

                    case 3:
                      _r28 = _context41.sent;
                      _context41.t0 = e;
                      _context41.next = 7;
                      return _r28.signTransaction(t);

                    case 7:
                      _context41.t1 = _context41.sent;
                      (0, _context41.t0)(null, _context41.t1);
                      _context41.next = 14;
                      break;

                    case 11:
                      _context41.prev = 11;
                      _context41.t2 = _context41["catch"](0);
                      e(_context41.t2);

                    case 14:
                    case "end":
                      return _context41.stop();
                  }
                }
              }, _callee41, null, [[0, 11]]);
            }));

            function processSignTransaction(_x39, _x40) {
              return _processSignTransaction.apply(this, arguments);
            }

            return processSignTransaction;
          }(),
          processTransaction: function () {
            var _processTransaction = _asyncToGenerator(
            /*#__PURE__*/
            _regeneratorRuntime.mark(function _callee42(t, e) {
              var _r29;

              return _regeneratorRuntime.wrap(function _callee42$(_context42) {
                while (1) {
                  switch (_context42.prev = _context42.next) {
                    case 0:
                      _context42.prev = 0;
                      _context42.next = 3;
                      return _this21.getWalletConnector();

                    case 3:
                      _r29 = _context42.sent;
                      _context42.t0 = e;
                      _context42.next = 7;
                      return _r29.sendTransaction(t);

                    case 7:
                      _context42.t1 = _context42.sent;
                      (0, _context42.t0)(null, _context42.t1);
                      _context42.next = 14;
                      break;

                    case 11:
                      _context42.prev = 11;
                      _context42.t2 = _context42["catch"](0);
                      e(_context42.t2);

                    case 14:
                    case "end":
                      return _context42.stop();
                  }
                }
              }, _callee42, null, [[0, 11]]);
            }));

            function processTransaction(_x41, _x42) {
              return _processTransaction.apply(this, arguments);
            }

            return processTransaction;
          }(),
          processTypedMessage: function () {
            var _processTypedMessage = _asyncToGenerator(
            /*#__PURE__*/
            _regeneratorRuntime.mark(function _callee43(t, e) {
              var _r30;

              return _regeneratorRuntime.wrap(function _callee43$(_context43) {
                while (1) {
                  switch (_context43.prev = _context43.next) {
                    case 0:
                      _context43.prev = 0;
                      _context43.next = 3;
                      return _this21.getWalletConnector();

                    case 3:
                      _r30 = _context43.sent;
                      _context43.t0 = e;
                      _context43.next = 7;
                      return _r30.signTypedData([t.from, t.data]);

                    case 7:
                      _context43.t1 = _context43.sent;
                      (0, _context43.t0)(null, _context43.t1);
                      _context43.next = 14;
                      break;

                    case 11:
                      _context43.prev = 11;
                      _context43.t2 = _context43["catch"](0);
                      e(_context43.t2);

                    case 14:
                    case "end":
                      return _context43.stop();
                  }
                }
              }, _callee43, null, [[0, 11]]);
            }));

            function processTypedMessage(_x43, _x44) {
              return _processTypedMessage.apply(this, arguments);
            }

            return processTypedMessage;
          }()
        })), _this21.addProvider({
          handleRequest: function () {
            var _handleRequest = _asyncToGenerator(
            /*#__PURE__*/
            _regeneratorRuntime.mark(function _callee44(t, e, r) {
              var _ref32, _e24;

              return _regeneratorRuntime.wrap(function _callee44$(_context44) {
                while (1) {
                  switch (_context44.prev = _context44.next) {
                    case 0:
                      _context44.prev = 0;
                      _context44.next = 3;
                      return _this21.handleRequest(t);

                    case 3:
                      _ref32 = _context44.sent;
                      _e24 = _ref32.result;
                      r(null, _e24);
                      _context44.next = 11;
                      break;

                    case 8:
                      _context44.prev = 8;
                      _context44.t0 = _context44["catch"](0);
                      r(_context44.t0);

                    case 11:
                    case "end":
                      return _context44.stop();
                  }
                }
              }, _callee44, null, [[0, 8]]);
            }));

            function handleRequest(_x45, _x46, _x47) {
              return _handleRequest.apply(this, arguments);
            }

            return handleRequest;
          }(),
          setEngine: function setEngine(t) {
            return t;
          }
        });
        return _possibleConstructorReturn(_this21);
      }

      _createClass(k, [{
        key: "enable",
        value: function enable() {
          var _this22 = this;

          return new Promise(
          /*#__PURE__*/
          function () {
            var _ref33 = _asyncToGenerator(
            /*#__PURE__*/
            _regeneratorRuntime.mark(function _callee45(t, e) {
              var _r31;

              return _regeneratorRuntime.wrap(function _callee45$(_context45) {
                while (1) {
                  switch (_context45.prev = _context45.next) {
                    case 0:
                      _context45.prev = 0;
                      _context45.next = 3;
                      return _this22.getWalletConnector();

                    case 3:
                      _r31 = _context45.sent;

                      if (_r31) {
                        _context45.next = 6;
                        break;
                      }

                      return _context45.abrupt("return", e(new Error("Failed to connect to WalleConnect")));

                    case 6:
                      _this22.start(), _this22.subscribeWalletConnector(), t(_r31.accounts);
                      _context45.next = 12;
                      break;

                    case 9:
                      _context45.prev = 9;
                      _context45.t0 = _context45["catch"](0);
                      return _context45.abrupt("return", e(_context45.t0));

                    case 12:
                    case "end":
                      return _context45.stop();
                  }
                }
              }, _callee45, null, [[0, 9]]);
            }));

            return function (_x48, _x49) {
              return _ref33.apply(this, arguments);
            };
          }());
        }
      }, {
        key: "send",
        value: function () {
          var _send = _asyncToGenerator(
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee46(t, e) {
            var _this23 = this;

            return _regeneratorRuntime.wrap(function _callee46$(_context46) {
              while (1) {
                switch (_context46.prev = _context46.next) {
                  case 0:
                    if (!("string" == typeof t)) {
                      _context46.next = 2;
                      break;
                    }

                    return _context46.abrupt("return", new Promise(function (r, n) {
                      _this23.sendAsync({
                        id: 42,
                        jsonrpc: "2.0",
                        method: t,
                        params: e || []
                      }, function (t, e) {
                        t ? n(t) : r(e.result);
                      });
                    }));

                  case 2:
                    if (!e) {
                      _context46.next = 4;
                      break;
                    }

                    return _context46.abrupt("return", void this.sendAsync(t, e));

                  case 4:
                    _context46.next = 6;
                    return this.handleRequest(t, e);

                  case 6:
                    return _context46.abrupt("return", _context46.sent);

                  case 7:
                  case "end":
                    return _context46.stop();
                }
              }
            }, _callee46, this);
          }));

          function send(_x50, _x51) {
            return _send.apply(this, arguments);
          }

          return send;
        }()
      }, {
        key: "onConnect",
        value: function onConnect(t) {
          this.connectCallbacks.push(t);
        }
      }, {
        key: "triggerConnect",
        value: function triggerConnect(t) {
          this.connectCallbacks && this.connectCallbacks.length && this.connectCallbacks.forEach(function (e) {
            return e(t);
          });
        }
      }, {
        key: "close",
        value: function () {
          var _close = _asyncToGenerator(
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee47() {
            var t;
            return _regeneratorRuntime.wrap(function _callee47$(_context47) {
              while (1) {
                switch (_context47.prev = _context47.next) {
                  case 0:
                    _context47.next = 2;
                    return this.getWalletConnector({
                      disableSessionCreation: !0
                    });

                  case 2:
                    t = _context47.sent;
                    _context47.next = 5;
                    return t.killSession();

                  case 5:
                    _context47.next = 7;
                    return this.stop();

                  case 7:
                    this.emit("close", 1e3, "Connection closed");

                  case 8:
                  case "end":
                    return _context47.stop();
                }
              }
            }, _callee47, this);
          }));

          function close() {
            return _close.apply(this, arguments);
          }

          return close;
        }()
      }, {
        key: "handleRequest",
        value: function () {
          var _handleRequest2 = _asyncToGenerator(
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee48(t) {
            var e, _r32;

            return _regeneratorRuntime.wrap(function _callee48$(_context48) {
              while (1) {
                switch (_context48.prev = _context48.next) {
                  case 0:
                    e = null;
                    _context48.prev = 1;
                    _context48.next = 4;
                    return this.getWalletConnector();

                  case 4:
                    _r32 = _context48.sent;
                    _context48.t0 = t.method;
                    _context48.next = _context48.t0 === "wc_killSession" ? 8 : _context48.t0 === "eth_accounts" ? 12 : _context48.t0 === "eth_coinbase" ? 14 : _context48.t0 === "eth_chainId" ? 16 : _context48.t0 === "net_version" ? 18 : _context48.t0 === "eth_uninstallFilter" ? 20 : 22;
                    break;

                  case 8:
                    _context48.next = 10;
                    return this.close();

                  case 10:
                    e = null;
                    return _context48.abrupt("break", 23);

                  case 12:
                    e = _r32.accounts;
                    return _context48.abrupt("break", 23);

                  case 14:
                    e = _r32.accounts[0];
                    return _context48.abrupt("break", 23);

                  case 16:
                    e = _r32.chainId;
                    return _context48.abrupt("break", 23);

                  case 18:
                    e = _r32.networkId || _r32.chainId;
                    return _context48.abrupt("break", 23);

                  case 20:
                    this.sendAsync(t, function (t) {
                      return t;
                    }), e = !0;
                    return _context48.abrupt("break", 23);

                  case 22:
                    return _context48.abrupt("return", this.handleOtherRequests(t));

                  case 23:
                    _context48.next = 28;
                    break;

                  case 25:
                    _context48.prev = 25;
                    _context48.t1 = _context48["catch"](1);
                    return _context48.abrupt("return", void this.emit("error", _context48.t1));

                  case 28:
                    return _context48.abrupt("return", this.formatResponse(t, e));

                  case 29:
                  case "end":
                    return _context48.stop();
                }
              }
            }, _callee48, this, [[1, 25]]);
          }));

          function handleRequest(_x52) {
            return _handleRequest2.apply(this, arguments);
          }

          return handleRequest;
        }()
      }, {
        key: "formatResponse",
        value: function formatResponse(t, e) {
          return {
            id: t.id,
            jsonrpc: t.jsonrpc,
            result: e
          };
        }
      }, {
        key: "handleOtherRequests",
        value: function () {
          var _handleOtherRequests = _asyncToGenerator(
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee49(t) {
            var e, r;
            return _regeneratorRuntime.wrap(function _callee49$(_context49) {
              while (1) {
                switch (_context49.prev = _context49.next) {
                  case 0:
                    if (!t.method.startsWith("eth_")) {
                      _context49.next = 2;
                      break;
                    }

                    return _context49.abrupt("return", this.handleReadRequests(t));

                  case 2:
                    _context49.next = 4;
                    return this.getWalletConnector();

                  case 4:
                    e = _context49.sent;
                    _context49.next = 7;
                    return e.sendCustomRequest(t);

                  case 7:
                    r = _context49.sent;
                    return _context49.abrupt("return", this.formatResponse(t, r));

                  case 9:
                  case "end":
                    return _context49.stop();
                }
              }
            }, _callee49, this);
          }));

          function handleOtherRequests(_x53) {
            return _handleOtherRequests.apply(this, arguments);
          }

          return handleOtherRequests;
        }()
      }, {
        key: "handleReadRequests",
        value: function () {
          var _handleReadRequests = _asyncToGenerator(
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee50(t) {
            return _regeneratorRuntime.wrap(function _callee50$(_context50) {
              while (1) {
                switch (_context50.prev = _context50.next) {
                  case 0:
                    if (!this.http) {
                      _context50.next = 2;
                      break;
                    }

                    return _context50.abrupt("return", this.http.send(t));

                  case 2:
                    this.emit("error", new Error("HTTP Connection not available"));

                  case 3:
                  case "end":
                    return _context50.stop();
                }
              }
            }, _callee50, this);
          }));

          function handleReadRequests(_x54) {
            return _handleReadRequests.apply(this, arguments);
          }

          return handleReadRequests;
        }()
      }, {
        key: "getWalletConnector",
        value: function getWalletConnector() {
          var _this24 = this;

          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          var _t$disableSessionCrea = t.disableSessionCreation,
              e = _t$disableSessionCrea === void 0 ? !1 : _t$disableSessionCrea;
          return new Promise(function (t, r) {
            var n = _this24.wc;
            if (_this24.isConnecting) _this24.onConnect(function (e) {
              return t(e);
            });else if (n.connected || e) _this24.connected || (_this24.connected = !0, _this24.updateState(n.session)), t(n);else {
              _this24.isConnecting = !0;

              var _e25 = _this24.chainId ? {
                chainId: _this24.chainId
              } : void 0;

              n.createSession(_e25).then(function () {
                _this24.qrcode && a.a.open(n.uri, function () {
                  r(new Error("User closed WalletConnect modal"));
                }), n.on("connect", function (e, i) {
                  if (_this24.qrcode && a.a.close(), e) return _this24.isConnecting = !1, r(e);
                  _this24.isConnecting = !1, _this24.connected = !0, i && _this24.updateState(i.params[0]), _this24.emit("connect"), _this24.triggerConnect(n), t(n);
                });
              }).catch(function (t) {
                _this24.isConnecting = !1, r(t);
              });
            }
          });
        }
      }, {
        key: "subscribeWalletConnector",
        value: function () {
          var _subscribeWalletConnector = _asyncToGenerator(
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee51() {
            var _this25 = this;

            var t;
            return _regeneratorRuntime.wrap(function _callee51$(_context51) {
              while (1) {
                switch (_context51.prev = _context51.next) {
                  case 0:
                    _context51.next = 2;
                    return this.getWalletConnector();

                  case 2:
                    t = _context51.sent;
                    t.on("disconnect", function (t, e) {
                      t ? _this25.emit("error", t) : _this25.stop();
                    }), t.on("session_update", function (t, e) {
                      t ? _this25.emit("error", t) : _this25.updateState(e.params[0]);
                    });

                  case 4:
                  case "end":
                    return _context51.stop();
                }
              }
            }, _callee51, this);
          }));

          function subscribeWalletConnector() {
            return _subscribeWalletConnector.apply(this, arguments);
          }

          return subscribeWalletConnector;
        }()
      }, {
        key: "updateState",
        value: function () {
          var _updateState = _asyncToGenerator(
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee52(t) {
            var e, r, n, i;
            return _regeneratorRuntime.wrap(function _callee52$(_context52) {
              while (1) {
                switch (_context52.prev = _context52.next) {
                  case 0:
                    e = t.accounts, r = t.chainId, n = t.networkId, i = t.rpcUrl;
                    (!this.accounts || e && this.accounts !== e) && (this.accounts = e, this.emit("accountsChanged", e)), (!this.chainId || r && this.chainId !== r) && (this.chainId = r, this.emit("chainChanged", r)), (!this.networkId || n && this.networkId !== n) && (this.networkId = n, this.emit("networkChanged", n)), this.updateRpcUrl(this.chainId, i || "");

                  case 2:
                  case "end":
                    return _context52.stop();
                }
              }
            }, _callee52, this);
          }));

          function updateState(_x55) {
            return _updateState.apply(this, arguments);
          }

          return updateState;
        }()
      }, {
        key: "updateRpcUrl",
        value: function updateRpcUrl(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
          var r = {
            1: "mainnet",
            3: "ropsten",
            4: "rinkeby",
            5: "goerli",
            42: "kovan"
          }[t];
          e || (this.rpc && this.rpc[t] ? e = this.rpc[t] : r && (e = "https://".concat(r, ".infura.io/v3/").concat(this.infuraId))), e ? (this.rpcUrl = e, this.updateHttpConnection()) : this.emit("error", new Error("No RPC Url available for chainId: ".concat(t)));
        }
      }, {
        key: "updateHttpConnection",
        value: function updateHttpConnection() {
          var _this26 = this;

          this.rpcUrl && (this.http = new T(this.rpcUrl), this.http.on("payload", function (t) {
            return _this26.emit("payload", t);
          }), this.http.on("error", function (t) {
            return _this26.emit("error", t);
          }));
        }
      }]);

      return k;
    }(f.a);

    e.default = k;
  }]);
});